var Nu = Object.defineProperty;
var Bu = (r, e, t) => e in r ? Nu(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var j = (r, e, t) => (Bu(r, typeof e != "symbol" ? e + "" : e, t), t), Sa = (r, e, t) => {
  if (!e.has(r))
    throw TypeError("Cannot " + t);
};
var xa = (r, e, t) => (Sa(r, e, "read from private field"), t ? t.call(r) : e.get(r)), ba = (r, e, t) => {
  if (e.has(r))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(r) : e.set(r, t);
}, Aa = (r, e, t, i) => (Sa(r, e, "write to private field"), i ? i.call(r, t) : e.set(r, t), t);
import { defineComponent as ut, openBlock as fe, createElementBlock as Se, normalizeStyle as Pt, pushScopeId as gr, popScopeId as pr, createElementVNode as me, watch as er, ref as ke, createBlock as Fe, resolveDynamicComponent as yn, normalizeClass as Ct, withCtx as xe, renderSlot as Ur, toDisplayString as jt, inject as it, computed as we, onMounted as mi, unref as de, Fragment as nn, renderList as Ps, withModifiers as Uu, createVNode as De, createTextVNode as No, createCommentVNode as _t, watchEffect as Ku, shallowRef as Vu, provide as _r, getCurrentInstance as Wu, onBeforeUnmount as Gu, withDirectives as Di, vShow as Ii, Transition as La } from "vue";
import "@2501world/lightplayer-external-api";
const Kt = {
  FreeView: "FreeView",
  MultiSelect: "MultiSelect"
}, Hu = {
  None: "None",
  Seek: "Seek"
}, wa = 1;
class $u {
  constructor() {
    j(this, "_events");
    j(this, "_requestId", 0);
    j(this, "_lastUpdateTime", 0);
    j(this, "_updateFunction");
    this._events = [], this._updateFunction = this._update.bind(this);
  }
  add(e, t) {
    let i = e, n = t;
    if (!n) {
      if (!(i instanceof Function))
        throw new Error("Ticker.add requires Function or Object and Function");
      n = i, i = null;
    }
    this._events.push({
      target: i,
      fn: n
    }), this._events.length === 1 && (this._lastUpdateTime = Date.now()), this._requestUpdate();
  }
  remove(e, t) {
    let i = e, n = t;
    if (!n) {
      if (!(i instanceof Function))
        throw new Error("Ticker.remove requires Function or Object and Function");
      n = i, i = null;
    }
    for (let s = 0; s < this._events.length; s++) {
      const o = this._events[s];
      (o.target === i && o.fn === n || !i && o.fn === n) && (this._events.splice(s, 1), s--);
    }
  }
  _requestUpdate() {
    this._requestId === 0 && (this._requestId = window.requestAnimationFrame(this._updateFunction));
  }
  _update() {
    const e = Date.now();
    let t = (e - this._lastUpdateTime) / 1e3;
    this._lastUpdateTime = e, this._requestId = 0, t > wa && (t = wa), t === 0 && (t = Number.EPSILON || 2220446049250313e-31);
    for (let i = 0; i < this._events.length; i++) {
      const n = this._events[i];
      n.target ? n.fn.call(n.target, t) : n.fn(t);
    }
    this._events.length > 0 && this._requestUpdate();
  }
}
const Da = new $u();
function Ia(r, e) {
  if (!r)
    throw new Error("math.gl assertion ".concat(e));
}
const qe = {
  EPSILON: 1e-12,
  debug: !1,
  precision: 4,
  printTypes: !1,
  printDegrees: !1,
  printRowMajor: !0
};
function ju(r, {
  precision: e = qe.precision
} = {}) {
  return r = Yu(r), "".concat(parseFloat(r.toPrecision(e)));
}
function hr(r) {
  return Array.isArray(r) || ArrayBuffer.isView(r) && !(r instanceof DataView);
}
function We(r, e, t) {
  return Xu(r, (i) => Math.max(e, Math.min(t, i)));
}
function Bo(r, e, t) {
  const i = qe.EPSILON;
  t && (qe.EPSILON = t);
  try {
    if (r === e)
      return !0;
    if (hr(r) && hr(e)) {
      if (r.length !== e.length)
        return !1;
      for (let n = 0; n < r.length; ++n)
        if (!Bo(r[n], e[n]))
          return !1;
      return !0;
    }
    return r && r.equals ? r.equals(e) : e && e.equals ? e.equals(r) : typeof r == "number" && typeof e == "number" ? Math.abs(r - e) <= qe.EPSILON * Math.max(1, Math.abs(r), Math.abs(e)) : !1;
  } finally {
    qe.EPSILON = i;
  }
}
function Yu(r) {
  return Math.round(r / qe.EPSILON) * qe.EPSILON;
}
function zu(r) {
  return r.clone ? r.clone() : new Array(r.length);
}
function Xu(r, e, t) {
  if (hr(r)) {
    const i = r;
    t = t || zu(i);
    for (let n = 0; n < t.length && n < i.length; ++n)
      t[n] = e(r[n], n, t);
    return t;
  }
  return e(r);
}
function Qu(r) {
  function e() {
    var t = Reflect.construct(r, Array.from(arguments));
    return Object.setPrototypeOf(t, Object.getPrototypeOf(this)), t;
  }
  return e.prototype = Object.create(r.prototype, {
    constructor: {
      value: r,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : e.__proto__ = r, e;
}
class En extends Qu(Array) {
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(e, t = 0) {
    for (let i = 0; i < this.ELEMENTS; ++i)
      this[i] = e[i + t];
    return this.check();
  }
  toArray(e = [], t = 0) {
    for (let i = 0; i < this.ELEMENTS; ++i)
      e[t + i] = this[i];
    return e;
  }
  from(e) {
    return Array.isArray(e) ? this.copy(e) : this.fromObject(e);
  }
  to(e) {
    return e === this ? this : hr(e) ? this.toArray(e) : this.toObject(e);
  }
  toTarget(e) {
    return e ? this.to(e) : this;
  }
  toFloat32Array() {
    return new Float32Array(this);
  }
  toString() {
    return this.formatString(qe);
  }
  formatString(e) {
    let t = "";
    for (let i = 0; i < this.ELEMENTS; ++i)
      t += (i > 0 ? ", " : "") + ju(this[i], e);
    return "".concat(e.printTypes ? this.constructor.name : "", "[").concat(t, "]");
  }
  equals(e) {
    if (!e || this.length !== e.length)
      return !1;
    for (let t = 0; t < this.ELEMENTS; ++t)
      if (!Bo(this[t], e[t]))
        return !1;
    return !0;
  }
  exactEquals(e) {
    if (!e || this.length !== e.length)
      return !1;
    for (let t = 0; t < this.ELEMENTS; ++t)
      if (this[t] !== e[t])
        return !1;
    return !0;
  }
  negate() {
    for (let e = 0; e < this.ELEMENTS; ++e)
      this[e] = -this[e];
    return this.check();
  }
  lerp(e, t, i) {
    if (i === void 0)
      return this.lerp(this, e, t);
    for (let n = 0; n < this.ELEMENTS; ++n) {
      const s = e[n];
      this[n] = s + i * (t[n] - s);
    }
    return this.check();
  }
  min(e) {
    for (let t = 0; t < this.ELEMENTS; ++t)
      this[t] = Math.min(e[t], this[t]);
    return this.check();
  }
  max(e) {
    for (let t = 0; t < this.ELEMENTS; ++t)
      this[t] = Math.max(e[t], this[t]);
    return this.check();
  }
  clamp(e, t) {
    for (let i = 0; i < this.ELEMENTS; ++i)
      this[i] = Math.min(Math.max(this[i], e[i]), t[i]);
    return this.check();
  }
  add(...e) {
    for (const t of e)
      for (let i = 0; i < this.ELEMENTS; ++i)
        this[i] += t[i];
    return this.check();
  }
  subtract(...e) {
    for (const t of e)
      for (let i = 0; i < this.ELEMENTS; ++i)
        this[i] -= t[i];
    return this.check();
  }
  scale(e) {
    if (typeof e == "number")
      for (let t = 0; t < this.ELEMENTS; ++t)
        this[t] *= e;
    else
      for (let t = 0; t < this.ELEMENTS && t < e.length; ++t)
        this[t] *= e[t];
    return this.check();
  }
  multiplyByScalar(e) {
    for (let t = 0; t < this.ELEMENTS; ++t)
      this[t] *= e;
    return this.check();
  }
  check() {
    if (qe.debug && !this.validate())
      throw new Error("math.gl: ".concat(this.constructor.name, " some fields set to invalid numbers'"));
    return this;
  }
  validate() {
    let e = this.length === this.ELEMENTS;
    for (let t = 0; t < this.ELEMENTS; ++t)
      e = e && Number.isFinite(this[t]);
    return e;
  }
  sub(e) {
    return this.subtract(e);
  }
  setScalar(e) {
    for (let t = 0; t < this.ELEMENTS; ++t)
      this[t] = e;
    return this.check();
  }
  addScalar(e) {
    for (let t = 0; t < this.ELEMENTS; ++t)
      this[t] += e;
    return this.check();
  }
  subScalar(e) {
    return this.addScalar(-e);
  }
  multiplyScalar(e) {
    for (let t = 0; t < this.ELEMENTS; ++t)
      this[t] *= e;
    return this.check();
  }
  divideScalar(e) {
    return this.multiplyByScalar(1 / e);
  }
  clampScalar(e, t) {
    for (let i = 0; i < this.ELEMENTS; ++i)
      this[i] = Math.min(Math.max(this[i], e), t);
    return this.check();
  }
  get elements() {
    return this;
  }
}
function Zu(r, e) {
  if (r.length !== e)
    return !1;
  for (let t = 0; t < r.length; ++t)
    if (!Number.isFinite(r[t]))
      return !1;
  return !0;
}
function ve(r) {
  if (!Number.isFinite(r))
    throw new Error("Invalid number ".concat(r));
  return r;
}
function Vi(r, e, t = "") {
  if (qe.debug && !Zu(r, e))
    throw new Error("math.gl: ".concat(t, " some fields set to invalid numbers'"));
  return r;
}
class Rs extends En {
  get x() {
    return this[0];
  }
  set x(e) {
    this[0] = ve(e);
  }
  get y() {
    return this[1];
  }
  set y(e) {
    this[1] = ve(e);
  }
  len() {
    return Math.sqrt(this.lengthSquared());
  }
  magnitude() {
    return this.len();
  }
  lengthSquared() {
    let e = 0;
    for (let t = 0; t < this.ELEMENTS; ++t)
      e += this[t] * this[t];
    return e;
  }
  magnitudeSquared() {
    return this.lengthSquared();
  }
  distance(e) {
    return Math.sqrt(this.distanceSquared(e));
  }
  distanceSquared(e) {
    let t = 0;
    for (let i = 0; i < this.ELEMENTS; ++i) {
      const n = this[i] - e[i];
      t += n * n;
    }
    return ve(t);
  }
  dot(e) {
    let t = 0;
    for (let i = 0; i < this.ELEMENTS; ++i)
      t += this[i] * e[i];
    return ve(t);
  }
  normalize() {
    const e = this.magnitude();
    if (e !== 0)
      for (let t = 0; t < this.ELEMENTS; ++t)
        this[t] /= e;
    return this.check();
  }
  multiply(...e) {
    for (const t of e)
      for (let i = 0; i < this.ELEMENTS; ++i)
        this[i] *= t[i];
    return this.check();
  }
  divide(...e) {
    for (const t of e)
      for (let i = 0; i < this.ELEMENTS; ++i)
        this[i] /= t[i];
    return this.check();
  }
  lengthSq() {
    return this.lengthSquared();
  }
  distanceTo(e) {
    return this.distance(e);
  }
  distanceToSquared(e) {
    return this.distanceSquared(e);
  }
  getComponent(e) {
    return Ia(e >= 0 && e < this.ELEMENTS, "index is out of range"), ve(this[e]);
  }
  setComponent(e, t) {
    return Ia(e >= 0 && e < this.ELEMENTS, "index is out of range"), this[e] = t, this.check();
  }
  addVectors(e, t) {
    return this.copy(e).add(t);
  }
  subVectors(e, t) {
    return this.copy(e).subtract(t);
  }
  multiplyVectors(e, t) {
    return this.copy(e).multiply(t);
  }
  addScaledVector(e, t) {
    return this.add(new this.constructor(e).multiplyScalar(t));
  }
}
var Jr = 1e-6, kt = typeof Float32Array < "u" ? Float32Array : Array;
Math.hypot || (Math.hypot = function() {
  for (var r = 0, e = arguments.length; e--; )
    r += arguments[e] * arguments[e];
  return Math.sqrt(r);
});
function Ju() {
  var r = new kt(2);
  return kt != Float32Array && (r[0] = 0, r[1] = 0), r;
}
function qu(r, e, t) {
  var i = e[0], n = e[1];
  return r[0] = t[0] * i + t[2] * n, r[1] = t[1] * i + t[3] * n, r;
}
function ec(r, e, t) {
  var i = e[0], n = e[1];
  return r[0] = t[0] * i + t[2] * n + t[4], r[1] = t[1] * i + t[3] * n + t[5], r;
}
function tc(r, e, t) {
  var i = e[0], n = e[1];
  return r[0] = t[0] * i + t[3] * n + t[6], r[1] = t[1] * i + t[4] * n + t[7], r;
}
function Uo(r, e, t) {
  var i = e[0], n = e[1];
  return r[0] = t[0] * i + t[4] * n + t[12], r[1] = t[1] * i + t[5] * n + t[13], r;
}
(function() {
  var r = Ju();
  return function(e, t, i, n, s, o) {
    var l, a;
    for (t || (t = 2), i || (i = 0), n ? a = Math.min(n * t + i, e.length) : a = e.length, l = i; l < a; l += t)
      r[0] = e[l], r[1] = e[l + 1], s(r, r, o), e[l] = r[0], e[l + 1] = r[1];
    return e;
  };
})();
function Ko(r, e, t) {
  const i = e[0], n = e[1], s = t[3] * i + t[7] * n || 1;
  return r[0] = (t[0] * i + t[4] * n) / s, r[1] = (t[1] * i + t[5] * n) / s, r;
}
function Vo(r, e, t) {
  const i = e[0], n = e[1], s = e[2], o = t[3] * i + t[7] * n + t[11] * s || 1;
  return r[0] = (t[0] * i + t[4] * n + t[8] * s) / o, r[1] = (t[1] * i + t[5] * n + t[9] * s) / o, r[2] = (t[2] * i + t[6] * n + t[10] * s) / o, r;
}
function rc(r, e, t) {
  const i = e[0], n = e[1];
  return r[0] = t[0] * i + t[2] * n, r[1] = t[1] * i + t[3] * n, r[2] = e[2], r;
}
function ic(r, e, t) {
  const i = e[0], n = e[1];
  return r[0] = t[0] * i + t[2] * n, r[1] = t[1] * i + t[3] * n, r[2] = e[2], r[3] = e[3], r;
}
function nc(r, e, t) {
  const i = e[0], n = e[1], s = e[2];
  return r[0] = t[0] * i + t[3] * n + t[6] * s, r[1] = t[1] * i + t[4] * n + t[7] * s, r[2] = t[2] * i + t[5] * n + t[8] * s, r[3] = e[3], r;
}
class Rt extends Rs {
  constructor(e = 0, t = 0) {
    super(2), hr(e) && arguments.length === 1 ? this.copy(e) : (qe.debug && (ve(e), ve(t)), this[0] = e, this[1] = t);
  }
  set(e, t) {
    return this[0] = e, this[1] = t, this.check();
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this.check();
  }
  fromObject(e) {
    return qe.debug && (ve(e.x), ve(e.y)), this[0] = e.x, this[1] = e.y, this.check();
  }
  toObject(e) {
    return e.x = this[0], e.y = this[1], e;
  }
  get ELEMENTS() {
    return 2;
  }
  horizontalAngle() {
    return Math.atan2(this.y, this.x);
  }
  verticalAngle() {
    return Math.atan2(this.x, this.y);
  }
  transform(e) {
    return this.transformAsPoint(e);
  }
  transformAsPoint(e) {
    return Uo(this, this, e), this.check();
  }
  transformAsVector(e) {
    return Ko(this, this, e), this.check();
  }
  transformByMatrix3(e) {
    return tc(this, this, e), this.check();
  }
  transformByMatrix2x3(e) {
    return ec(this, this, e), this.check();
  }
  transformByMatrix2(e) {
    return qu(this, this, e), this.check();
  }
}
function Wo() {
  var r = new kt(3);
  return kt != Float32Array && (r[0] = 0, r[1] = 0, r[2] = 0), r;
}
function sc(r) {
  var e = r[0], t = r[1], i = r[2];
  return Math.hypot(e, t, i);
}
function Oa(r, e, t) {
  var i = new kt(3);
  return i[0] = r, i[1] = e, i[2] = t, i;
}
function ac(r, e) {
  var t = e[0], i = e[1], n = e[2], s = t * t + i * i + n * n;
  return s > 0 && (s = 1 / Math.sqrt(s)), r[0] = e[0] * s, r[1] = e[1] * s, r[2] = e[2] * s, r;
}
function Go(r, e) {
  return r[0] * e[0] + r[1] * e[1] + r[2] * e[2];
}
function Wi(r, e, t) {
  var i = e[0], n = e[1], s = e[2], o = t[0], l = t[1], a = t[2];
  return r[0] = n * a - s * l, r[1] = s * o - i * a, r[2] = i * l - n * o, r;
}
function Ms(r, e, t) {
  var i = e[0], n = e[1], s = e[2], o = t[3] * i + t[7] * n + t[11] * s + t[15];
  return o = o || 1, r[0] = (t[0] * i + t[4] * n + t[8] * s + t[12]) / o, r[1] = (t[1] * i + t[5] * n + t[9] * s + t[13]) / o, r[2] = (t[2] * i + t[6] * n + t[10] * s + t[14]) / o, r;
}
function oc(r, e, t) {
  var i = e[0], n = e[1], s = e[2];
  return r[0] = i * t[0] + n * t[3] + s * t[6], r[1] = i * t[1] + n * t[4] + s * t[7], r[2] = i * t[2] + n * t[5] + s * t[8], r;
}
function Ho(r, e, t) {
  var i = t[0], n = t[1], s = t[2], o = t[3], l = e[0], a = e[1], b = e[2], y = n * b - s * a, N = s * l - i * b, E = i * a - n * l, B = n * E - s * N, I = s * y - i * E, T = i * N - n * y, A = o * 2;
  return y *= A, N *= A, E *= A, B *= 2, I *= 2, T *= 2, r[0] = l + y + B, r[1] = a + N + I, r[2] = b + E + T, r;
}
function lc(r, e, t, i) {
  var n = [], s = [];
  return n[0] = e[0] - t[0], n[1] = e[1] - t[1], n[2] = e[2] - t[2], s[0] = n[0], s[1] = n[1] * Math.cos(i) - n[2] * Math.sin(i), s[2] = n[1] * Math.sin(i) + n[2] * Math.cos(i), r[0] = s[0] + t[0], r[1] = s[1] + t[1], r[2] = s[2] + t[2], r;
}
function uc(r, e, t, i) {
  var n = [], s = [];
  return n[0] = e[0] - t[0], n[1] = e[1] - t[1], n[2] = e[2] - t[2], s[0] = n[2] * Math.sin(i) + n[0] * Math.cos(i), s[1] = n[1], s[2] = n[2] * Math.cos(i) - n[0] * Math.sin(i), r[0] = s[0] + t[0], r[1] = s[1] + t[1], r[2] = s[2] + t[2], r;
}
function cc(r, e, t, i) {
  var n = [], s = [];
  return n[0] = e[0] - t[0], n[1] = e[1] - t[1], n[2] = e[2] - t[2], s[0] = n[0] * Math.cos(i) - n[1] * Math.sin(i), s[1] = n[0] * Math.sin(i) + n[1] * Math.cos(i), s[2] = n[2], r[0] = s[0] + t[0], r[1] = s[1] + t[1], r[2] = s[2] + t[2], r;
}
function fc(r, e) {
  var t = r[0], i = r[1], n = r[2], s = e[0], o = e[1], l = e[2], a = Math.sqrt(t * t + i * i + n * n), b = Math.sqrt(s * s + o * o + l * l), y = a * b, N = y && Go(r, e) / y;
  return Math.acos(Math.min(Math.max(N, -1), 1));
}
var hc = sc;
(function() {
  var r = Wo();
  return function(e, t, i, n, s, o) {
    var l, a;
    for (t || (t = 3), i || (i = 0), n ? a = Math.min(n * t + i, e.length) : a = e.length, l = i; l < a; l += t)
      r[0] = e[l], r[1] = e[l + 1], r[2] = e[l + 2], s(r, r, o), e[l] = r[0], e[l + 1] = r[1], e[l + 2] = r[2];
    return e;
  };
})();
const Vn = [0, 0, 0];
let Oi;
class Ie extends Rs {
  static get ZERO() {
    return Oi || (Oi = new Ie(0, 0, 0), Object.freeze(Oi)), Oi;
  }
  constructor(e = 0, t = 0, i = 0) {
    super(-0, -0, -0), arguments.length === 1 && hr(e) ? this.copy(e) : (qe.debug && (ve(e), ve(t), ve(i)), this[0] = e, this[1] = t, this[2] = i);
  }
  set(e, t, i) {
    return this[0] = e, this[1] = t, this[2] = i, this.check();
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this.check();
  }
  fromObject(e) {
    return qe.debug && (ve(e.x), ve(e.y), ve(e.z)), this[0] = e.x, this[1] = e.y, this[2] = e.z, this.check();
  }
  toObject(e) {
    return e.x = this[0], e.y = this[1], e.z = this[2], e;
  }
  get ELEMENTS() {
    return 3;
  }
  get z() {
    return this[2];
  }
  set z(e) {
    this[2] = ve(e);
  }
  angle(e) {
    return fc(this, e);
  }
  cross(e) {
    return Wi(this, this, e), this.check();
  }
  rotateX({
    radians: e,
    origin: t = Vn
  }) {
    return lc(this, this, t, e), this.check();
  }
  rotateY({
    radians: e,
    origin: t = Vn
  }) {
    return uc(this, this, t, e), this.check();
  }
  rotateZ({
    radians: e,
    origin: t = Vn
  }) {
    return cc(this, this, t, e), this.check();
  }
  transform(e) {
    return this.transformAsPoint(e);
  }
  transformAsPoint(e) {
    return Ms(this, this, e), this.check();
  }
  transformAsVector(e) {
    return Vo(this, this, e), this.check();
  }
  transformByMatrix3(e) {
    return oc(this, this, e), this.check();
  }
  transformByMatrix2(e) {
    return rc(this, this, e), this.check();
  }
  transformByQuaternion(e) {
    return Ho(this, this, e), this.check();
  }
}
let Ci;
class tr extends Rs {
  static get ZERO() {
    return Ci || (Ci = new tr(0, 0, 0, 0), Object.freeze(Ci)), Ci;
  }
  constructor(e = 0, t = 0, i = 0, n = 0) {
    super(-0, -0, -0, -0), hr(e) && arguments.length === 1 ? this.copy(e) : (qe.debug && (ve(e), ve(t), ve(i), ve(n)), this[0] = e, this[1] = t, this[2] = i, this[3] = n);
  }
  set(e, t, i, n) {
    return this[0] = e, this[1] = t, this[2] = i, this[3] = n, this.check();
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this[3] = e[3], this.check();
  }
  fromObject(e) {
    return qe.debug && (ve(e.x), ve(e.y), ve(e.z), ve(e.w)), this[0] = e.x, this[1] = e.y, this[2] = e.z, this[3] = e.w, this;
  }
  toObject(e) {
    return e.x = this[0], e.y = this[1], e.z = this[2], e.w = this[3], e;
  }
  get ELEMENTS() {
    return 4;
  }
  get z() {
    return this[2];
  }
  set z(e) {
    this[2] = ve(e);
  }
  get w() {
    return this[3];
  }
  set w(e) {
    this[3] = ve(e);
  }
  transform(e) {
    return Ms(this, this, e), this.check();
  }
  transformByMatrix3(e) {
    return nc(this, this, e), this.check();
  }
  transformByMatrix2(e) {
    return ic(this, this, e), this.check();
  }
  transformByQuaternion(e) {
    return Ho(this, this, e), this.check();
  }
  applyMatrix4(e) {
    return e.transform(this, this), this;
  }
}
class dc extends En {
  toString() {
    let e = "[";
    if (qe.printRowMajor) {
      e += "row-major:";
      for (let t = 0; t < this.RANK; ++t)
        for (let i = 0; i < this.RANK; ++i)
          e += " ".concat(this[i * this.RANK + t]);
    } else {
      e += "column-major:";
      for (let t = 0; t < this.ELEMENTS; ++t)
        e += " ".concat(this[t]);
    }
    return e += "]", e;
  }
  getElementIndex(e, t) {
    return t * this.RANK + e;
  }
  getElement(e, t) {
    return this[t * this.RANK + e];
  }
  setElement(e, t, i) {
    return this[t * this.RANK + e] = ve(i), this;
  }
  getColumn(e, t = new Array(this.RANK).fill(-0)) {
    const i = e * this.RANK;
    for (let n = 0; n < this.RANK; ++n)
      t[n] = this[i + n];
    return t;
  }
  setColumn(e, t) {
    const i = e * this.RANK;
    for (let n = 0; n < this.RANK; ++n)
      this[i + n] = t[n];
    return this;
  }
}
function vc() {
  var r = new kt(9);
  return kt != Float32Array && (r[1] = 0, r[2] = 0, r[3] = 0, r[5] = 0, r[6] = 0, r[7] = 0), r[0] = 1, r[4] = 1, r[8] = 1, r;
}
function mc(r) {
  return r[0] = 1, r[1] = 0, r[2] = 0, r[3] = 0, r[4] = 0, r[5] = 1, r[6] = 0, r[7] = 0, r[8] = 0, r[9] = 0, r[10] = 1, r[11] = 0, r[12] = 0, r[13] = 0, r[14] = 0, r[15] = 1, r;
}
function gc(r, e) {
  if (r === e) {
    var t = e[1], i = e[2], n = e[3], s = e[6], o = e[7], l = e[11];
    r[1] = e[4], r[2] = e[8], r[3] = e[12], r[4] = t, r[6] = e[9], r[7] = e[13], r[8] = i, r[9] = s, r[11] = e[14], r[12] = n, r[13] = o, r[14] = l;
  } else
    r[0] = e[0], r[1] = e[4], r[2] = e[8], r[3] = e[12], r[4] = e[1], r[5] = e[5], r[6] = e[9], r[7] = e[13], r[8] = e[2], r[9] = e[6], r[10] = e[10], r[11] = e[14], r[12] = e[3], r[13] = e[7], r[14] = e[11], r[15] = e[15];
  return r;
}
function pc(r, e) {
  var t = e[0], i = e[1], n = e[2], s = e[3], o = e[4], l = e[5], a = e[6], b = e[7], y = e[8], N = e[9], E = e[10], B = e[11], I = e[12], T = e[13], A = e[14], w = e[15], O = t * l - i * o, u = t * a - n * o, M = t * b - s * o, d = i * a - n * l, c = i * b - s * l, v = n * b - s * a, g = y * T - N * I, m = y * A - E * I, D = y * w - B * I, L = N * A - E * T, p = N * w - B * T, x = E * w - B * A, k = O * x - u * p + M * L + d * D - c * m + v * g;
  return k ? (k = 1 / k, r[0] = (l * x - a * p + b * L) * k, r[1] = (n * p - i * x - s * L) * k, r[2] = (T * v - A * c + w * d) * k, r[3] = (E * c - N * v - B * d) * k, r[4] = (a * D - o * x - b * m) * k, r[5] = (t * x - n * D + s * m) * k, r[6] = (A * M - I * v - w * u) * k, r[7] = (y * v - E * M + B * u) * k, r[8] = (o * p - l * D + b * g) * k, r[9] = (i * D - t * p - s * g) * k, r[10] = (I * c - T * M + w * O) * k, r[11] = (N * M - y * c - B * O) * k, r[12] = (l * m - o * L - a * g) * k, r[13] = (t * L - i * m + n * g) * k, r[14] = (T * u - I * d - A * O) * k, r[15] = (y * d - N * u + E * O) * k, r) : null;
}
function yc(r) {
  var e = r[0], t = r[1], i = r[2], n = r[3], s = r[4], o = r[5], l = r[6], a = r[7], b = r[8], y = r[9], N = r[10], E = r[11], B = r[12], I = r[13], T = r[14], A = r[15], w = e * o - t * s, O = e * l - i * s, u = e * a - n * s, M = t * l - i * o, d = t * a - n * o, c = i * a - n * l, v = b * I - y * B, g = b * T - N * B, m = b * A - E * B, D = y * T - N * I, L = y * A - E * I, p = N * A - E * T;
  return w * p - O * L + u * D + M * m - d * g + c * v;
}
function Ca(r, e, t) {
  var i = e[0], n = e[1], s = e[2], o = e[3], l = e[4], a = e[5], b = e[6], y = e[7], N = e[8], E = e[9], B = e[10], I = e[11], T = e[12], A = e[13], w = e[14], O = e[15], u = t[0], M = t[1], d = t[2], c = t[3];
  return r[0] = u * i + M * l + d * N + c * T, r[1] = u * n + M * a + d * E + c * A, r[2] = u * s + M * b + d * B + c * w, r[3] = u * o + M * y + d * I + c * O, u = t[4], M = t[5], d = t[6], c = t[7], r[4] = u * i + M * l + d * N + c * T, r[5] = u * n + M * a + d * E + c * A, r[6] = u * s + M * b + d * B + c * w, r[7] = u * o + M * y + d * I + c * O, u = t[8], M = t[9], d = t[10], c = t[11], r[8] = u * i + M * l + d * N + c * T, r[9] = u * n + M * a + d * E + c * A, r[10] = u * s + M * b + d * B + c * w, r[11] = u * o + M * y + d * I + c * O, u = t[12], M = t[13], d = t[14], c = t[15], r[12] = u * i + M * l + d * N + c * T, r[13] = u * n + M * a + d * E + c * A, r[14] = u * s + M * b + d * B + c * w, r[15] = u * o + M * y + d * I + c * O, r;
}
function Ec(r, e, t) {
  var i = t[0], n = t[1], s = t[2], o, l, a, b, y, N, E, B, I, T, A, w;
  return e === r ? (r[12] = e[0] * i + e[4] * n + e[8] * s + e[12], r[13] = e[1] * i + e[5] * n + e[9] * s + e[13], r[14] = e[2] * i + e[6] * n + e[10] * s + e[14], r[15] = e[3] * i + e[7] * n + e[11] * s + e[15]) : (o = e[0], l = e[1], a = e[2], b = e[3], y = e[4], N = e[5], E = e[6], B = e[7], I = e[8], T = e[9], A = e[10], w = e[11], r[0] = o, r[1] = l, r[2] = a, r[3] = b, r[4] = y, r[5] = N, r[6] = E, r[7] = B, r[8] = I, r[9] = T, r[10] = A, r[11] = w, r[12] = o * i + y * n + I * s + e[12], r[13] = l * i + N * n + T * s + e[13], r[14] = a * i + E * n + A * s + e[14], r[15] = b * i + B * n + w * s + e[15]), r;
}
function _c(r, e, t) {
  var i = t[0], n = t[1], s = t[2];
  return r[0] = e[0] * i, r[1] = e[1] * i, r[2] = e[2] * i, r[3] = e[3] * i, r[4] = e[4] * n, r[5] = e[5] * n, r[6] = e[6] * n, r[7] = e[7] * n, r[8] = e[8] * s, r[9] = e[9] * s, r[10] = e[10] * s, r[11] = e[11] * s, r[12] = e[12], r[13] = e[13], r[14] = e[14], r[15] = e[15], r;
}
function Tc(r, e, t, i) {
  var n = i[0], s = i[1], o = i[2], l = Math.hypot(n, s, o), a, b, y, N, E, B, I, T, A, w, O, u, M, d, c, v, g, m, D, L, p, x, k, _;
  return l < Jr ? null : (l = 1 / l, n *= l, s *= l, o *= l, a = Math.sin(t), b = Math.cos(t), y = 1 - b, N = e[0], E = e[1], B = e[2], I = e[3], T = e[4], A = e[5], w = e[6], O = e[7], u = e[8], M = e[9], d = e[10], c = e[11], v = n * n * y + b, g = s * n * y + o * a, m = o * n * y - s * a, D = n * s * y - o * a, L = s * s * y + b, p = o * s * y + n * a, x = n * o * y + s * a, k = s * o * y - n * a, _ = o * o * y + b, r[0] = N * v + T * g + u * m, r[1] = E * v + A * g + M * m, r[2] = B * v + w * g + d * m, r[3] = I * v + O * g + c * m, r[4] = N * D + T * L + u * p, r[5] = E * D + A * L + M * p, r[6] = B * D + w * L + d * p, r[7] = I * D + O * L + c * p, r[8] = N * x + T * k + u * _, r[9] = E * x + A * k + M * _, r[10] = B * x + w * k + d * _, r[11] = I * x + O * k + c * _, e !== r && (r[12] = e[12], r[13] = e[13], r[14] = e[14], r[15] = e[15]), r);
}
function Sc(r, e, t) {
  var i = Math.sin(t), n = Math.cos(t), s = e[4], o = e[5], l = e[6], a = e[7], b = e[8], y = e[9], N = e[10], E = e[11];
  return e !== r && (r[0] = e[0], r[1] = e[1], r[2] = e[2], r[3] = e[3], r[12] = e[12], r[13] = e[13], r[14] = e[14], r[15] = e[15]), r[4] = s * n + b * i, r[5] = o * n + y * i, r[6] = l * n + N * i, r[7] = a * n + E * i, r[8] = b * n - s * i, r[9] = y * n - o * i, r[10] = N * n - l * i, r[11] = E * n - a * i, r;
}
function xc(r, e, t) {
  var i = Math.sin(t), n = Math.cos(t), s = e[0], o = e[1], l = e[2], a = e[3], b = e[8], y = e[9], N = e[10], E = e[11];
  return e !== r && (r[4] = e[4], r[5] = e[5], r[6] = e[6], r[7] = e[7], r[12] = e[12], r[13] = e[13], r[14] = e[14], r[15] = e[15]), r[0] = s * n - b * i, r[1] = o * n - y * i, r[2] = l * n - N * i, r[3] = a * n - E * i, r[8] = s * i + b * n, r[9] = o * i + y * n, r[10] = l * i + N * n, r[11] = a * i + E * n, r;
}
function bc(r, e, t) {
  var i = Math.sin(t), n = Math.cos(t), s = e[0], o = e[1], l = e[2], a = e[3], b = e[4], y = e[5], N = e[6], E = e[7];
  return e !== r && (r[8] = e[8], r[9] = e[9], r[10] = e[10], r[11] = e[11], r[12] = e[12], r[13] = e[13], r[14] = e[14], r[15] = e[15]), r[0] = s * n + b * i, r[1] = o * n + y * i, r[2] = l * n + N * i, r[3] = a * n + E * i, r[4] = b * n - s * i, r[5] = y * n - o * i, r[6] = N * n - l * i, r[7] = E * n - a * i, r;
}
function Ac(r, e) {
  var t = e[0], i = e[1], n = e[2], s = e[3], o = t + t, l = i + i, a = n + n, b = t * o, y = i * o, N = i * l, E = n * o, B = n * l, I = n * a, T = s * o, A = s * l, w = s * a;
  return r[0] = 1 - N - I, r[1] = y + w, r[2] = E - A, r[3] = 0, r[4] = y - w, r[5] = 1 - b - I, r[6] = B + T, r[7] = 0, r[8] = E + A, r[9] = B - T, r[10] = 1 - b - N, r[11] = 0, r[12] = 0, r[13] = 0, r[14] = 0, r[15] = 1, r;
}
function Lc(r, e, t, i, n, s, o) {
  var l = 1 / (t - e), a = 1 / (n - i), b = 1 / (s - o);
  return r[0] = s * 2 * l, r[1] = 0, r[2] = 0, r[3] = 0, r[4] = 0, r[5] = s * 2 * a, r[6] = 0, r[7] = 0, r[8] = (t + e) * l, r[9] = (n + i) * a, r[10] = (o + s) * b, r[11] = -1, r[12] = 0, r[13] = 0, r[14] = o * s * 2 * b, r[15] = 0, r;
}
function wc(r, e, t, i, n) {
  var s = 1 / Math.tan(e / 2), o;
  return r[0] = s / t, r[1] = 0, r[2] = 0, r[3] = 0, r[4] = 0, r[5] = s, r[6] = 0, r[7] = 0, r[8] = 0, r[9] = 0, r[11] = -1, r[12] = 0, r[13] = 0, r[15] = 0, n != null && n !== 1 / 0 ? (o = 1 / (i - n), r[10] = (n + i) * o, r[14] = 2 * n * i * o) : (r[10] = -1, r[14] = -2 * i), r;
}
var Dc = wc;
function Ic(r, e, t, i, n, s, o) {
  var l = 1 / (e - t), a = 1 / (i - n), b = 1 / (s - o);
  return r[0] = -2 * l, r[1] = 0, r[2] = 0, r[3] = 0, r[4] = 0, r[5] = -2 * a, r[6] = 0, r[7] = 0, r[8] = 0, r[9] = 0, r[10] = 2 * b, r[11] = 0, r[12] = (e + t) * l, r[13] = (n + i) * a, r[14] = (o + s) * b, r[15] = 1, r;
}
var Oc = Ic;
function Cc(r, e, t, i) {
  var n, s, o, l, a, b, y, N, E, B, I = e[0], T = e[1], A = e[2], w = i[0], O = i[1], u = i[2], M = t[0], d = t[1], c = t[2];
  return Math.abs(I - M) < Jr && Math.abs(T - d) < Jr && Math.abs(A - c) < Jr ? mc(r) : (y = I - M, N = T - d, E = A - c, B = 1 / Math.hypot(y, N, E), y *= B, N *= B, E *= B, n = O * E - u * N, s = u * y - w * E, o = w * N - O * y, B = Math.hypot(n, s, o), B ? (B = 1 / B, n *= B, s *= B, o *= B) : (n = 0, s = 0, o = 0), l = N * o - E * s, a = E * n - y * o, b = y * s - N * n, B = Math.hypot(l, a, b), B ? (B = 1 / B, l *= B, a *= B, b *= B) : (l = 0, a = 0, b = 0), r[0] = n, r[1] = l, r[2] = y, r[3] = 0, r[4] = s, r[5] = a, r[6] = N, r[7] = 0, r[8] = o, r[9] = b, r[10] = E, r[11] = 0, r[12] = -(n * I + s * T + o * A), r[13] = -(l * I + a * T + b * A), r[14] = -(y * I + N * T + E * A), r[15] = 1, r);
}
function Pc() {
  var r = new kt(4);
  return kt != Float32Array && (r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 0), r;
}
function Rc(r, e, t) {
  return r[0] = e[0] + t[0], r[1] = e[1] + t[1], r[2] = e[2] + t[2], r[3] = e[3] + t[3], r;
}
function Mc(r, e, t) {
  return r[0] = e[0] * t, r[1] = e[1] * t, r[2] = e[2] * t, r[3] = e[3] * t, r;
}
function kc(r) {
  var e = r[0], t = r[1], i = r[2], n = r[3];
  return Math.hypot(e, t, i, n);
}
function Fc(r) {
  var e = r[0], t = r[1], i = r[2], n = r[3];
  return e * e + t * t + i * i + n * n;
}
function Nc(r, e) {
  var t = e[0], i = e[1], n = e[2], s = e[3], o = t * t + i * i + n * n + s * s;
  return o > 0 && (o = 1 / Math.sqrt(o)), r[0] = t * o, r[1] = i * o, r[2] = n * o, r[3] = s * o, r;
}
function Bc(r, e) {
  return r[0] * e[0] + r[1] * e[1] + r[2] * e[2] + r[3] * e[3];
}
function Uc(r, e, t, i) {
  var n = e[0], s = e[1], o = e[2], l = e[3];
  return r[0] = n + i * (t[0] - n), r[1] = s + i * (t[1] - s), r[2] = o + i * (t[2] - o), r[3] = l + i * (t[3] - l), r;
}
function Kc(r, e, t) {
  var i = e[0], n = e[1], s = e[2], o = e[3];
  return r[0] = t[0] * i + t[4] * n + t[8] * s + t[12] * o, r[1] = t[1] * i + t[5] * n + t[9] * s + t[13] * o, r[2] = t[2] * i + t[6] * n + t[10] * s + t[14] * o, r[3] = t[3] * i + t[7] * n + t[11] * s + t[15] * o, r;
}
function Vc(r, e, t) {
  var i = e[0], n = e[1], s = e[2], o = t[0], l = t[1], a = t[2], b = t[3], y = b * i + l * s - a * n, N = b * n + a * i - o * s, E = b * s + o * n - l * i, B = -o * i - l * n - a * s;
  return r[0] = y * b + B * -o + N * -a - E * -l, r[1] = N * b + B * -l + E * -o - y * -a, r[2] = E * b + B * -a + y * -l - N * -o, r[3] = e[3], r;
}
(function() {
  var r = Pc();
  return function(e, t, i, n, s, o) {
    var l, a;
    for (t || (t = 4), i || (i = 0), n ? a = Math.min(n * t + i, e.length) : a = e.length, l = i; l < a; l += t)
      r[0] = e[l], r[1] = e[l + 1], r[2] = e[l + 2], r[3] = e[l + 3], s(r, r, o), e[l] = r[0], e[l + 1] = r[1], e[l + 2] = r[2], e[l + 3] = r[3];
    return e;
  };
})();
var ps;
(function(r) {
  r[r.COL0ROW0 = 0] = "COL0ROW0", r[r.COL0ROW1 = 1] = "COL0ROW1", r[r.COL0ROW2 = 2] = "COL0ROW2", r[r.COL0ROW3 = 3] = "COL0ROW3", r[r.COL1ROW0 = 4] = "COL1ROW0", r[r.COL1ROW1 = 5] = "COL1ROW1", r[r.COL1ROW2 = 6] = "COL1ROW2", r[r.COL1ROW3 = 7] = "COL1ROW3", r[r.COL2ROW0 = 8] = "COL2ROW0", r[r.COL2ROW1 = 9] = "COL2ROW1", r[r.COL2ROW2 = 10] = "COL2ROW2", r[r.COL2ROW3 = 11] = "COL2ROW3", r[r.COL3ROW0 = 12] = "COL3ROW0", r[r.COL3ROW1 = 13] = "COL3ROW1", r[r.COL3ROW2 = 14] = "COL3ROW2", r[r.COL3ROW3 = 15] = "COL3ROW3";
})(ps || (ps = {}));
const Wc = 45 * Math.PI / 180, Gc = 1, Wn = 0.1, Gn = 500, Hc = Object.freeze([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
class lr extends dc {
  static get IDENTITY() {
    return jc();
  }
  static get ZERO() {
    return $c();
  }
  get ELEMENTS() {
    return 16;
  }
  get RANK() {
    return 4;
  }
  get INDICES() {
    return ps;
  }
  constructor(e) {
    super(-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0), arguments.length === 1 && Array.isArray(e) ? this.copy(e) : this.identity();
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this[3] = e[3], this[4] = e[4], this[5] = e[5], this[6] = e[6], this[7] = e[7], this[8] = e[8], this[9] = e[9], this[10] = e[10], this[11] = e[11], this[12] = e[12], this[13] = e[13], this[14] = e[14], this[15] = e[15], this.check();
  }
  set(e, t, i, n, s, o, l, a, b, y, N, E, B, I, T, A) {
    return this[0] = e, this[1] = t, this[2] = i, this[3] = n, this[4] = s, this[5] = o, this[6] = l, this[7] = a, this[8] = b, this[9] = y, this[10] = N, this[11] = E, this[12] = B, this[13] = I, this[14] = T, this[15] = A, this.check();
  }
  setRowMajor(e, t, i, n, s, o, l, a, b, y, N, E, B, I, T, A) {
    return this[0] = e, this[1] = s, this[2] = b, this[3] = B, this[4] = t, this[5] = o, this[6] = y, this[7] = I, this[8] = i, this[9] = l, this[10] = N, this[11] = T, this[12] = n, this[13] = a, this[14] = E, this[15] = A, this.check();
  }
  toRowMajor(e) {
    return e[0] = this[0], e[1] = this[4], e[2] = this[8], e[3] = this[12], e[4] = this[1], e[5] = this[5], e[6] = this[9], e[7] = this[13], e[8] = this[2], e[9] = this[6], e[10] = this[10], e[11] = this[14], e[12] = this[3], e[13] = this[7], e[14] = this[11], e[15] = this[15], e;
  }
  identity() {
    return this.copy(Hc);
  }
  fromObject(e) {
    return this.check();
  }
  fromQuaternion(e) {
    return Ac(this, e), this.check();
  }
  frustum(e) {
    const {
      left: t,
      right: i,
      bottom: n,
      top: s,
      near: o = Wn,
      far: l = Gn
    } = e;
    return l === 1 / 0 ? Yc(this, t, i, n, s, o) : Lc(this, t, i, n, s, o, l), this.check();
  }
  lookAt(e) {
    const {
      eye: t,
      center: i = [0, 0, 0],
      up: n = [0, 1, 0]
    } = e;
    return Cc(this, t, i, n), this.check();
  }
  ortho(e) {
    const {
      left: t,
      right: i,
      bottom: n,
      top: s,
      near: o = Wn,
      far: l = Gn
    } = e;
    return Oc(this, t, i, n, s, o, l), this.check();
  }
  orthographic(e) {
    const {
      fovy: t = Wc,
      aspect: i = Gc,
      focalDistance: n = 1,
      near: s = Wn,
      far: o = Gn
    } = e;
    Pa(t);
    const l = t / 2, a = n * Math.tan(l), b = a * i;
    return this.ortho({
      left: -b,
      right: b,
      bottom: -a,
      top: a,
      near: s,
      far: o
    });
  }
  perspective(e) {
    const {
      fovy: t = 45 * Math.PI / 180,
      aspect: i = 1,
      near: n = 0.1,
      far: s = 500
    } = e;
    return Pa(t), Dc(this, t, i, n, s), this.check();
  }
  determinant() {
    return yc(this);
  }
  getScale(e = [-0, -0, -0]) {
    return e[0] = Math.sqrt(this[0] * this[0] + this[1] * this[1] + this[2] * this[2]), e[1] = Math.sqrt(this[4] * this[4] + this[5] * this[5] + this[6] * this[6]), e[2] = Math.sqrt(this[8] * this[8] + this[9] * this[9] + this[10] * this[10]), e;
  }
  getTranslation(e = [-0, -0, -0]) {
    return e[0] = this[12], e[1] = this[13], e[2] = this[14], e;
  }
  getRotation(e, t) {
    e = e || [-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0], t = t || [-0, -0, -0];
    const i = this.getScale(t), n = 1 / i[0], s = 1 / i[1], o = 1 / i[2];
    return e[0] = this[0] * n, e[1] = this[1] * s, e[2] = this[2] * o, e[3] = 0, e[4] = this[4] * n, e[5] = this[5] * s, e[6] = this[6] * o, e[7] = 0, e[8] = this[8] * n, e[9] = this[9] * s, e[10] = this[10] * o, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
  }
  getRotationMatrix3(e, t) {
    e = e || [-0, -0, -0, -0, -0, -0, -0, -0, -0], t = t || [-0, -0, -0];
    const i = this.getScale(t), n = 1 / i[0], s = 1 / i[1], o = 1 / i[2];
    return e[0] = this[0] * n, e[1] = this[1] * s, e[2] = this[2] * o, e[3] = this[4] * n, e[4] = this[5] * s, e[5] = this[6] * o, e[6] = this[8] * n, e[7] = this[9] * s, e[8] = this[10] * o, e;
  }
  transpose() {
    return gc(this, this), this.check();
  }
  invert() {
    return pc(this, this), this.check();
  }
  multiplyLeft(e) {
    return Ca(this, e, this), this.check();
  }
  multiplyRight(e) {
    return Ca(this, this, e), this.check();
  }
  rotateX(e) {
    return Sc(this, this, e), this.check();
  }
  rotateY(e) {
    return xc(this, this, e), this.check();
  }
  rotateZ(e) {
    return bc(this, this, e), this.check();
  }
  rotateXYZ(e) {
    return this.rotateX(e[0]).rotateY(e[1]).rotateZ(e[2]);
  }
  rotateAxis(e, t) {
    return Tc(this, this, e, t), this.check();
  }
  scale(e) {
    return _c(this, this, Array.isArray(e) ? e : [e, e, e]), this.check();
  }
  translate(e) {
    return Ec(this, this, e), this.check();
  }
  transform(e, t) {
    return e.length === 4 ? (t = Kc(t || [-0, -0, -0, -0], e, this), Vi(t, 4), t) : this.transformAsPoint(e, t);
  }
  transformAsPoint(e, t) {
    const {
      length: i
    } = e;
    let n;
    switch (i) {
      case 2:
        n = Uo(t || [-0, -0], e, this);
        break;
      case 3:
        n = Ms(t || [-0, -0, -0], e, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    return Vi(n, e.length), n;
  }
  transformAsVector(e, t) {
    let i;
    switch (e.length) {
      case 2:
        i = Ko(t || [-0, -0], e, this);
        break;
      case 3:
        i = Vo(t || [-0, -0, -0], e, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    return Vi(i, e.length), i;
  }
  transformPoint(e, t) {
    return this.transformAsPoint(e, t);
  }
  transformVector(e, t) {
    return this.transformAsPoint(e, t);
  }
  transformDirection(e, t) {
    return this.transformAsVector(e, t);
  }
  makeRotationX(e) {
    return this.identity().rotateX(e);
  }
  makeTranslation(e, t, i) {
    return this.identity().translate([e, t, i]);
  }
}
let Pi, Ri;
function $c() {
  return Pi || (Pi = new lr([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), Object.freeze(Pi)), Pi;
}
function jc() {
  return Ri || (Ri = new lr(), Object.freeze(Ri)), Ri;
}
function Pa(r) {
  if (r > Math.PI * 2)
    throw Error("expected radians");
}
function Yc(r, e, t, i, n, s) {
  const o = 2 * s / (t - e), l = 2 * s / (n - i), a = (t + e) / (t - e), b = (n + i) / (n - i), y = -1, N = -1, E = -2 * s;
  return r[0] = o, r[1] = 0, r[2] = 0, r[3] = 0, r[4] = 0, r[5] = l, r[6] = 0, r[7] = 0, r[8] = a, r[9] = b, r[10] = y, r[11] = N, r[12] = 0, r[13] = 0, r[14] = E, r[15] = 0, r;
}
function Ra() {
  var r = new kt(4);
  return kt != Float32Array && (r[0] = 0, r[1] = 0, r[2] = 0), r[3] = 1, r;
}
function zc(r) {
  return r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 1, r;
}
function $o(r, e, t) {
  t = t * 0.5;
  var i = Math.sin(t);
  return r[0] = i * e[0], r[1] = i * e[1], r[2] = i * e[2], r[3] = Math.cos(t), r;
}
function Ma(r, e, t) {
  var i = e[0], n = e[1], s = e[2], o = e[3], l = t[0], a = t[1], b = t[2], y = t[3];
  return r[0] = i * y + o * l + n * b - s * a, r[1] = n * y + o * a + s * l - i * b, r[2] = s * y + o * b + i * a - n * l, r[3] = o * y - i * l - n * a - s * b, r;
}
function Xc(r, e, t) {
  t *= 0.5;
  var i = e[0], n = e[1], s = e[2], o = e[3], l = Math.sin(t), a = Math.cos(t);
  return r[0] = i * a + o * l, r[1] = n * a + s * l, r[2] = s * a - n * l, r[3] = o * a - i * l, r;
}
function Qc(r, e, t) {
  t *= 0.5;
  var i = e[0], n = e[1], s = e[2], o = e[3], l = Math.sin(t), a = Math.cos(t);
  return r[0] = i * a - s * l, r[1] = n * a + o * l, r[2] = s * a + i * l, r[3] = o * a - n * l, r;
}
function Zc(r, e, t) {
  t *= 0.5;
  var i = e[0], n = e[1], s = e[2], o = e[3], l = Math.sin(t), a = Math.cos(t);
  return r[0] = i * a + n * l, r[1] = n * a - i * l, r[2] = s * a + o * l, r[3] = o * a - s * l, r;
}
function Jc(r, e) {
  var t = e[0], i = e[1], n = e[2];
  return r[0] = t, r[1] = i, r[2] = n, r[3] = Math.sqrt(Math.abs(1 - t * t - i * i - n * n)), r;
}
function Gi(r, e, t, i) {
  var n = e[0], s = e[1], o = e[2], l = e[3], a = t[0], b = t[1], y = t[2], N = t[3], E, B, I, T, A;
  return B = n * a + s * b + o * y + l * N, B < 0 && (B = -B, a = -a, b = -b, y = -y, N = -N), 1 - B > Jr ? (E = Math.acos(B), I = Math.sin(E), T = Math.sin((1 - i) * E) / I, A = Math.sin(i * E) / I) : (T = 1 - i, A = i), r[0] = T * n + A * a, r[1] = T * s + A * b, r[2] = T * o + A * y, r[3] = T * l + A * N, r;
}
function qc(r, e) {
  var t = e[0], i = e[1], n = e[2], s = e[3], o = t * t + i * i + n * n + s * s, l = o ? 1 / o : 0;
  return r[0] = -t * l, r[1] = -i * l, r[2] = -n * l, r[3] = s * l, r;
}
function ef(r, e) {
  return r[0] = -e[0], r[1] = -e[1], r[2] = -e[2], r[3] = e[3], r;
}
function jo(r, e) {
  var t = e[0] + e[4] + e[8], i;
  if (t > 0)
    i = Math.sqrt(t + 1), r[3] = 0.5 * i, i = 0.5 / i, r[0] = (e[5] - e[7]) * i, r[1] = (e[6] - e[2]) * i, r[2] = (e[1] - e[3]) * i;
  else {
    var n = 0;
    e[4] > e[0] && (n = 1), e[8] > e[n * 3 + n] && (n = 2);
    var s = (n + 1) % 3, o = (n + 2) % 3;
    i = Math.sqrt(e[n * 3 + n] - e[s * 3 + s] - e[o * 3 + o] + 1), r[n] = 0.5 * i, i = 0.5 / i, r[3] = (e[s * 3 + o] - e[o * 3 + s]) * i, r[s] = (e[s * 3 + n] + e[n * 3 + s]) * i, r[o] = (e[o * 3 + n] + e[n * 3 + o]) * i;
  }
  return r;
}
var tf = Rc, rf = Mc, nf = Bc, sf = Uc, af = kc, of = Fc, Yo = Nc, lf = function() {
  var r = Wo(), e = Oa(1, 0, 0), t = Oa(0, 1, 0);
  return function(i, n, s) {
    var o = Go(n, s);
    return o < -0.999999 ? (Wi(r, e, n), hc(r) < 1e-6 && Wi(r, t, n), ac(r, r), $o(i, r, Math.PI), i) : o > 0.999999 ? (i[0] = 0, i[1] = 0, i[2] = 0, i[3] = 1, i) : (Wi(r, n, s), i[0] = r[0], i[1] = r[1], i[2] = r[2], i[3] = 1 + o, Yo(i, i));
  };
}();
(function() {
  var r = Ra(), e = Ra();
  return function(t, i, n, s, o, l) {
    return Gi(r, i, o, l), Gi(e, n, s, l), Gi(t, r, e, 2 * l * (1 - l)), t;
  };
})();
(function() {
  var r = vc();
  return function(e, t, i, n) {
    return r[0] = i[0], r[3] = i[1], r[6] = i[2], r[1] = n[0], r[4] = n[1], r[7] = n[2], r[2] = -t[0], r[5] = -t[1], r[8] = -t[2], Yo(e, jo(e, r));
  };
})();
const uf = [0, 0, 0, 1];
class ka extends En {
  constructor(e = 0, t = 0, i = 0, n = 1) {
    super(-0, -0, -0, -0), Array.isArray(e) && arguments.length === 1 ? this.copy(e) : this.set(e, t, i, n);
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this[3] = e[3], this.check();
  }
  set(e, t, i, n) {
    return this[0] = e, this[1] = t, this[2] = i, this[3] = n, this.check();
  }
  fromObject(e) {
    return this[0] = e.x, this[1] = e.y, this[2] = e.z, this[3] = e.w, this.check();
  }
  fromMatrix3(e) {
    return jo(this, e), this.check();
  }
  fromAxisRotation(e, t) {
    return $o(this, e, t), this.check();
  }
  identity() {
    return zc(this), this.check();
  }
  setAxisAngle(e, t) {
    return this.fromAxisRotation(e, t);
  }
  get ELEMENTS() {
    return 4;
  }
  get x() {
    return this[0];
  }
  set x(e) {
    this[0] = ve(e);
  }
  get y() {
    return this[1];
  }
  set y(e) {
    this[1] = ve(e);
  }
  get z() {
    return this[2];
  }
  set z(e) {
    this[2] = ve(e);
  }
  get w() {
    return this[3];
  }
  set w(e) {
    this[3] = ve(e);
  }
  len() {
    return af(this);
  }
  lengthSquared() {
    return of(this);
  }
  dot(e) {
    return nf(this, e);
  }
  rotationTo(e, t) {
    return lf(this, e, t), this.check();
  }
  add(e) {
    return tf(this, this, e), this.check();
  }
  calculateW() {
    return Jc(this, this), this.check();
  }
  conjugate() {
    return ef(this, this), this.check();
  }
  invert() {
    return qc(this, this), this.check();
  }
  lerp(e, t, i) {
    return i === void 0 ? this.lerp(this, e, t) : (sf(this, e, t, i), this.check());
  }
  multiplyRight(e) {
    return Ma(this, this, e), this.check();
  }
  multiplyLeft(e) {
    return Ma(this, e, this), this.check();
  }
  normalize() {
    const e = this.len(), t = e > 0 ? 1 / e : 0;
    return this[0] = this[0] * t, this[1] = this[1] * t, this[2] = this[2] * t, this[3] = this[3] * t, e === 0 && (this[3] = 1), this.check();
  }
  rotateX(e) {
    return Xc(this, this, e), this.check();
  }
  rotateY(e) {
    return Qc(this, this, e), this.check();
  }
  rotateZ(e) {
    return Zc(this, this, e), this.check();
  }
  scale(e) {
    return rf(this, this, e), this.check();
  }
  slerp(e, t, i) {
    let n, s, o;
    switch (arguments.length) {
      case 1:
        ({
          start: n = uf,
          target: s,
          ratio: o
        } = e);
        break;
      case 2:
        n = this, s = e, o = t;
        break;
      default:
        n = e, s = t, o = i;
    }
    return Gi(this, n, s, o), this.check();
  }
  transformVector4(e, t = new tr()) {
    return Vc(t, e, this), Vi(t, 4);
  }
  lengthSq() {
    return this.lengthSquared();
  }
  setFromAxisAngle(e, t) {
    return this.setAxisAngle(e, t);
  }
  premultiply(e) {
    return this.multiplyLeft(e);
  }
  multiply(e) {
    return this.multiplyRight(e);
  }
}
const Hi = "Unknown Euler angle order", Tr = 0.99999;
var $e;
(function(r) {
  r[r.ZYX = 0] = "ZYX", r[r.YXZ = 1] = "YXZ", r[r.XZY = 2] = "XZY", r[r.ZXY = 3] = "ZXY", r[r.YZX = 4] = "YZX", r[r.XYZ = 5] = "XYZ";
})($e || ($e = {}));
class Ce extends En {
  static get ZYX() {
    return $e.ZYX;
  }
  static get YXZ() {
    return $e.YXZ;
  }
  static get XZY() {
    return $e.XZY;
  }
  static get ZXY() {
    return $e.ZXY;
  }
  static get YZX() {
    return $e.YZX;
  }
  static get XYZ() {
    return $e.XYZ;
  }
  static get RollPitchYaw() {
    return $e.ZYX;
  }
  static get DefaultOrder() {
    return $e.ZYX;
  }
  static get RotationOrders() {
    return $e;
  }
  static rotationOrder(e) {
    return $e[e];
  }
  get ELEMENTS() {
    return 4;
  }
  constructor(e = 0, t = 0, i = 0, n = Ce.DefaultOrder) {
    super(-0, -0, -0, -0), arguments.length > 0 && Array.isArray(arguments[0]) ? this.fromVector3(...arguments) : this.set(e, t, i, n);
  }
  fromQuaternion(e) {
    const [t, i, n, s] = e, o = i * i, l = -2 * (o + n * n) + 1, a = 2 * (t * i + s * n);
    let b = -2 * (t * n - s * i);
    const y = 2 * (i * n + s * t), N = -2 * (t * t + o) + 1;
    b = b > 1 ? 1 : b, b = b < -1 ? -1 : b;
    const E = Math.atan2(y, N), B = Math.asin(b), I = Math.atan2(a, l);
    return this.set(E, B, I, Ce.RollPitchYaw);
  }
  fromObject(e) {
    throw new Error("not implemented");
  }
  copy(e) {
    return this[0] = e[0], this[1] = e[1], this[2] = e[2], this[3] = Number.isFinite(e[3]) || this.order, this.check();
  }
  set(e = 0, t = 0, i = 0, n) {
    return this[0] = e, this[1] = t, this[2] = i, this[3] = Number.isFinite(n) ? n : this[3], this.check();
  }
  validate() {
    return cf(this[3]) && Number.isFinite(this[0]) && Number.isFinite(this[1]) && Number.isFinite(this[2]);
  }
  toArray(e = [], t = 0) {
    return e[t] = this[0], e[t + 1] = this[1], e[t + 2] = this[2], e;
  }
  toArray4(e = [], t = 0) {
    return e[t] = this[0], e[t + 1] = this[1], e[t + 2] = this[2], e[t + 3] = this[3], e;
  }
  toVector3(e = [-0, -0, -0]) {
    return e[0] = this[0], e[1] = this[1], e[2] = this[2], e;
  }
  get x() {
    return this[0];
  }
  set x(e) {
    this[0] = ve(e);
  }
  get y() {
    return this[1];
  }
  set y(e) {
    this[1] = ve(e);
  }
  get z() {
    return this[2];
  }
  set z(e) {
    this[2] = ve(e);
  }
  get alpha() {
    return this[0];
  }
  set alpha(e) {
    this[0] = ve(e);
  }
  get beta() {
    return this[1];
  }
  set beta(e) {
    this[1] = ve(e);
  }
  get gamma() {
    return this[2];
  }
  set gamma(e) {
    this[2] = ve(e);
  }
  get phi() {
    return this[0];
  }
  set phi(e) {
    this[0] = ve(e);
  }
  get theta() {
    return this[1];
  }
  set theta(e) {
    this[1] = ve(e);
  }
  get psi() {
    return this[2];
  }
  set psi(e) {
    this[2] = ve(e);
  }
  get roll() {
    return this[0];
  }
  set roll(e) {
    this[0] = ve(e);
  }
  get pitch() {
    return this[1];
  }
  set pitch(e) {
    this[1] = ve(e);
  }
  get yaw() {
    return this[2];
  }
  set yaw(e) {
    this[2] = ve(e);
  }
  get order() {
    return this[3];
  }
  set order(e) {
    this[3] = ff(e);
  }
  fromVector3(e, t) {
    return this.set(e[0], e[1], e[2], Number.isFinite(t) ? t : this[3]);
  }
  fromArray(e, t = 0) {
    return this[0] = e[0 + t], this[1] = e[1 + t], this[2] = e[2 + t], e[3] !== void 0 && (this[3] = e[3]), this.check();
  }
  fromRollPitchYaw(e, t, i) {
    return this.set(e, t, i, $e.ZYX);
  }
  fromRotationMatrix(e, t = Ce.DefaultOrder) {
    return this._fromRotationMatrix(e, t), this.check();
  }
  getRotationMatrix(e) {
    return this._getRotationMatrix(e);
  }
  getQuaternion() {
    const e = new ka();
    switch (this[4]) {
      case $e.XYZ:
        return e.rotateX(this[0]).rotateY(this[1]).rotateZ(this[2]);
      case $e.YXZ:
        return e.rotateY(this[0]).rotateX(this[1]).rotateZ(this[2]);
      case $e.ZXY:
        return e.rotateZ(this[0]).rotateX(this[1]).rotateY(this[2]);
      case $e.ZYX:
        return e.rotateZ(this[0]).rotateY(this[1]).rotateX(this[2]);
      case $e.YZX:
        return e.rotateY(this[0]).rotateZ(this[1]).rotateX(this[2]);
      case $e.XZY:
        return e.rotateX(this[0]).rotateZ(this[1]).rotateY(this[2]);
      default:
        throw new Error(Hi);
    }
  }
  _fromRotationMatrix(e, t = Ce.DefaultOrder) {
    const i = e[0], n = e[4], s = e[8], o = e[1], l = e[5], a = e[9], b = e[2], y = e[6], N = e[10];
    switch (t = t || this[3], t) {
      case Ce.XYZ:
        this[1] = Math.asin(We(s, -1, 1)), Math.abs(s) < Tr ? (this[0] = Math.atan2(-a, N), this[2] = Math.atan2(-n, i)) : (this[0] = Math.atan2(y, l), this[2] = 0);
        break;
      case Ce.YXZ:
        this[0] = Math.asin(-We(a, -1, 1)), Math.abs(a) < Tr ? (this[1] = Math.atan2(s, N), this[2] = Math.atan2(o, l)) : (this[1] = Math.atan2(-b, i), this[2] = 0);
        break;
      case Ce.ZXY:
        this[0] = Math.asin(We(y, -1, 1)), Math.abs(y) < Tr ? (this[1] = Math.atan2(-b, N), this[2] = Math.atan2(-n, l)) : (this[1] = 0, this[2] = Math.atan2(o, i));
        break;
      case Ce.ZYX:
        this[1] = Math.asin(-We(b, -1, 1)), Math.abs(b) < Tr ? (this[0] = Math.atan2(y, N), this[2] = Math.atan2(o, i)) : (this[0] = 0, this[2] = Math.atan2(-n, l));
        break;
      case Ce.YZX:
        this[2] = Math.asin(We(o, -1, 1)), Math.abs(o) < Tr ? (this[0] = Math.atan2(-a, l), this[1] = Math.atan2(-b, i)) : (this[0] = 0, this[1] = Math.atan2(s, N));
        break;
      case Ce.XZY:
        this[2] = Math.asin(-We(n, -1, 1)), Math.abs(n) < Tr ? (this[0] = Math.atan2(y, l), this[1] = Math.atan2(s, i)) : (this[0] = Math.atan2(-a, N), this[1] = 0);
        break;
      default:
        throw new Error(Hi);
    }
    return this[3] = t, this;
  }
  _getRotationMatrix(e) {
    const t = e || [-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0], i = this.x, n = this.y, s = this.z, o = Math.cos(i), l = Math.cos(n), a = Math.cos(s), b = Math.sin(i), y = Math.sin(n), N = Math.sin(s);
    switch (this[3]) {
      case Ce.XYZ: {
        const E = o * a, B = o * N, I = b * a, T = b * N;
        t[0] = l * a, t[4] = -l * N, t[8] = y, t[1] = B + I * y, t[5] = E - T * y, t[9] = -b * l, t[2] = T - E * y, t[6] = I + B * y, t[10] = o * l;
        break;
      }
      case Ce.YXZ: {
        const E = l * a, B = l * N, I = y * a, T = y * N;
        t[0] = E + T * b, t[4] = I * b - B, t[8] = o * y, t[1] = o * N, t[5] = o * a, t[9] = -b, t[2] = B * b - I, t[6] = T + E * b, t[10] = o * l;
        break;
      }
      case Ce.ZXY: {
        const E = l * a, B = l * N, I = y * a, T = y * N;
        t[0] = E - T * b, t[4] = -o * N, t[8] = I + B * b, t[1] = B + I * b, t[5] = o * a, t[9] = T - E * b, t[2] = -o * y, t[6] = b, t[10] = o * l;
        break;
      }
      case Ce.ZYX: {
        const E = o * a, B = o * N, I = b * a, T = b * N;
        t[0] = l * a, t[4] = I * y - B, t[8] = E * y + T, t[1] = l * N, t[5] = T * y + E, t[9] = B * y - I, t[2] = -y, t[6] = b * l, t[10] = o * l;
        break;
      }
      case Ce.YZX: {
        const E = o * l, B = o * y, I = b * l, T = b * y;
        t[0] = l * a, t[4] = T - E * N, t[8] = I * N + B, t[1] = N, t[5] = o * a, t[9] = -b * a, t[2] = -y * a, t[6] = B * N + I, t[10] = E - T * N;
        break;
      }
      case Ce.XZY: {
        const E = o * l, B = o * y, I = b * l, T = b * y;
        t[0] = l * a, t[4] = -N, t[8] = y * a, t[1] = E * N + T, t[5] = o * a, t[9] = B * N - I, t[2] = I * N - B, t[6] = b * a, t[10] = T * N + E;
        break;
      }
      default:
        throw new Error(Hi);
    }
    return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
  }
  toQuaternion() {
    const e = Math.cos(this.yaw * 0.5), t = Math.sin(this.yaw * 0.5), i = Math.cos(this.roll * 0.5), n = Math.sin(this.roll * 0.5), s = Math.cos(this.pitch * 0.5), o = Math.sin(this.pitch * 0.5), l = e * i * s + t * n * o, a = e * n * s - t * i * o, b = e * i * o + t * n * s, y = t * i * s - e * n * o;
    return new ka(a, b, y, l);
  }
}
function cf(r) {
  return r >= 0 && r < 6;
}
function ff(r) {
  if (r < 0 && r >= 6)
    throw new Error(Hi);
  return r;
}
var Mi, hf = new Uint8Array(16);
function df() {
  if (!Mi && (Mi = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Mi))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Mi(hf);
}
const vf = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function mf(r) {
  return typeof r == "string" && vf.test(r);
}
var Qe = [];
for (var Hn = 0; Hn < 256; ++Hn)
  Qe.push((Hn + 256).toString(16).substr(1));
function gf(r) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = (Qe[r[e + 0]] + Qe[r[e + 1]] + Qe[r[e + 2]] + Qe[r[e + 3]] + "-" + Qe[r[e + 4]] + Qe[r[e + 5]] + "-" + Qe[r[e + 6]] + Qe[r[e + 7]] + "-" + Qe[r[e + 8]] + Qe[r[e + 9]] + "-" + Qe[r[e + 10]] + Qe[r[e + 11]] + Qe[r[e + 12]] + Qe[r[e + 13]] + Qe[r[e + 14]] + Qe[r[e + 15]]).toLowerCase();
  if (!mf(t))
    throw TypeError("Stringified UUID is invalid");
  return t;
}
function ks(r, e, t) {
  r = r || {};
  var i = r.random || (r.rng || df)();
  if (i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, e) {
    t = t || 0;
    for (var n = 0; n < 16; ++n)
      e[t + n] = i[n];
    return e;
  }
  return gf(i);
}
class gi {
  constructor(e) {
    j(this, "node");
    j(this, "enabled", !0);
    this.node = e;
  }
  get scene() {
    if (!this.node.parent)
      return this.node;
    let e = this.node.parent;
    for (; e.parent; )
      e = e.parent;
    return e;
  }
  dispose() {
  }
  sendMessage(e, ...t) {
    this.node.sendMessage(this, e, ...t);
  }
}
class zo extends gi {
  test(e) {
    return null;
  }
}
var Pe;
(function(r) {
  r[r.KEEP = 0] = "KEEP", r[r.ZERO = 1] = "ZERO", r[r.REPLACE = 2] = "REPLACE", r[r.INCR = 3] = "INCR", r[r.INCR_WRAP = 4] = "INCR_WRAP", r[r.DECR_WRAP = 5] = "DECR_WRAP", r[r.INVERT = 6] = "INVERT";
})(Pe || (Pe = {}));
var Ze;
(function(r) {
  r[r.NEVER = 0] = "NEVER", r[r.LESS = 1] = "LESS", r[r.GREATER = 2] = "GREATER", r[r.EQUAL = 3] = "EQUAL", r[r.ALWAYS = 4] = "ALWAYS", r[r.LEQUAL = 5] = "LEQUAL", r[r.GEQUAL = 6] = "GEQUAL", r[r.NOTEQUAL = 7] = "NOTEQUAL";
})(Ze || (Ze = {}));
class Mt {
  constructor(e, t = "Node") {
    j(this, "position", new Ie(0, 0, 0));
    j(this, "rotation", new Ce(0, 0, 0));
    j(this, "scale", new Ie(1, 1, 1));
    j(this, "matrixWorld", new lr(lr.IDENTITY));
    j(this, "components", []);
    j(this, "parent", null);
    j(this, "children", []);
    j(this, "visible", !0);
    j(this, "drawOrder", 0);
    j(this, "stencilWrite", !1);
    j(this, "stencilOp", {
      fail: Pe.KEEP,
      zFail: Pe.KEEP,
      zPass: Pe.REPLACE
    });
    j(this, "stencilFunc", {
      func: Ze.ALWAYS,
      ref: 0,
      mask: 0
    });
    j(this, "stencilTest", !1);
    j(this, "uid", ks());
    j(this, "name", "Node");
    j(this, "_lastPosition", new Ie(0, 0, 0));
    j(this, "_lastRotation", new Ce(0, 0, 0));
    j(this, "_lastScale", new Ie(1, 1, 1));
    j(this, "_willUpdateMatrix", !0);
    j(this, "_collider", null);
    this.name = t, e && e.add(this);
  }
  get collider() {
    return this._collider || (this._collider = this.getComponent(zo)), this._collider;
  }
  dispose() {
    var e;
    (e = this.parent) == null || e.remove(this);
  }
  updateMatrix(e = !1) {
    if (e || this._willUpdateMatrix || !this.position.equals(this._lastPosition) || !this.rotation.equals(this._lastRotation) || !this.scale.equals(this._lastScale)) {
      const t = new lr(lr.IDENTITY);
      t.translate([this.position.x, this.position.y, this.position.z]), t.rotateXYZ([this.rotation.x, this.rotation.y, this.rotation.z]), t.scale([this.scale.x, this.scale.y, this.scale.z]), this.parent && t.multiplyLeft(this.parent.matrixWorld), this.matrixWorld = t, this._willUpdateMatrix = !1, this._lastPosition.copy(this.position), this._lastRotation.copy(this.rotation), this._lastScale.copy(this.scale);
    }
  }
  traverse(e) {
    const t = [this];
    for (; t.length > 0; ) {
      const i = t.pop();
      e(i);
      for (let n = i.children.length - 1; n > -1; n--)
        t.push(i.children[n]);
    }
  }
  add(e) {
    e.parent && e.parent.remove(e);
    let t = this.parent;
    for (; t; ) {
      if (t === e)
        throw new Error("Node cannot add ancestor node as its child");
      t = t.parent;
    }
    this.children.push(e), e.parent = this;
  }
  remove(e) {
    for (let t = 0; t < this.children.length; t++)
      if (this.children[t] === e) {
        this.children.splice(t, 1), e.parent = null;
        return;
      }
  }
  draw(e, t) {
    this.sendMessage(null, "onDraw", e, t);
  }
  update(e) {
  }
  addComponent(e) {
    const t = new e(this);
    return this.components.push(t), t;
  }
  getComponent(e) {
    for (let t = 0; t < this.components.length; t++)
      if (this.components[t] instanceof e)
        return this.components[t];
    return null;
  }
  getComponents(e) {
    const t = [];
    for (let i = 0; i < this.components.length; i++)
      this.components[i] instanceof e && t.push(this.components[i]);
    return t;
  }
  getComponentInChildren(e) {
    let t = this.getComponent(e);
    if (t)
      return t;
    for (let i = 0; i < this.children.length; i++)
      if (t = this.children[i].getComponentInChildren(e), t)
        return t;
    return null;
  }
  getComponentsInChildren(e) {
    let t = this.getComponents(e);
    return this.traverse((i) => {
      t = t.concat(this.getComponents(e));
    }), t;
  }
  sendMessage(e, t, ...i) {
    for (let n = 0; n < this.components.length; n++) {
      const s = this.components[n];
      s.enabled && s[t] && s !== e && s[t](...i);
    }
  }
  _sendMessage(e, ...t) {
    for (let i = 0; i < this.components.length; i++) {
      const n = this.components[i];
      n[e] && n[e](...t);
    }
  }
}
class pf {
  constructor(e, t) {
    j(this, "origin");
    j(this, "direction");
    this.origin = e, this.direction = t.normalize();
  }
}
class yf extends Mt {
  constructor(t = 1, i) {
    super(i, "Camera");
    j(this, "aspect");
    j(this, "projectionMatrix", new lr());
    this.aspect = t;
  }
  updateProjectionMatrix() {
    this.projectionMatrix.set(1 / this.aspect, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  viewPointToRay(t, i) {
    let n = i;
    return n || (n = new pf(new Ie(), new Ie(0, 0, 1))), n.origin.set((t.x - 0.5) * 2 * (1 / this.projectionMatrix[0]), -(t.y - 0.5) * 2 * (1 / this.projectionMatrix[5]), -1), n;
  }
}
class Ef extends Mt {
}
class _f {
  constructor(e) {
    j(this, "indices", null);
    j(this, "attributes", {});
    j(this, "_gl");
    j(this, "_count");
    j(this, "_vertCount");
    this._gl = e, this._count = 0, this._vertCount = 0;
  }
  get vertCount() {
    return this._vertCount;
  }
  dispose() {
    Object.keys(this.attributes).forEach((e) => {
      this.attributes[e].dispose(), delete this.attributes[e];
    });
  }
  setAttribute(e, t) {
    this.attributes[e] && (this.attributes[e].dispose(), delete this.attributes[e]), t && (this.attributes[e] = t);
  }
  update() {
    var t;
    const e = this._gl;
    ["POSITION", "TEXCOORD"].forEach((i) => {
      this.attributes[i] && this.attributes[i].update(e.ARRAY_BUFFER, !0);
    }), this.indices && this.indices.update(e.ELEMENT_ARRAY_BUFFER, !0), this._count = ((t = this.indices) == null ? void 0 : t.array.length) || 0, this._vertCount = this.attributes.POSITION ? this.attributes.POSITION.array.length / 3 : 0;
  }
  draw(e) {
    const t = this._gl;
    ["POSITION", "TEXCOORD", "TEXCOORD2", "NORMAL", "COLOR"].forEach((i) => {
      const n = e.getAttribute(i);
      if (n > -1 && this.attributes[i]) {
        const s = this.attributes[i];
        t.enableVertexAttribArray(n), t.bindBuffer(t.ARRAY_BUFFER, s.buffer), t.vertexAttribPointer(n, s.size, t.FLOAT, !1, 0, 0);
      }
    }), this.indices && (t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, this.indices.buffer), t.drawElements(t.TRIANGLES, this._count, t.UNSIGNED_SHORT, 0));
  }
}
var Fa;
(function(r) {
  r[r.ArrayBuffer = 0] = "ArrayBuffer", r[r.ElementArrayBuffer = 1] = "ElementArrayBuffer";
})(Fa || (Fa = {}));
class $n {
  constructor(e, t, i) {
    j(this, "array");
    j(this, "buffer");
    j(this, "size");
    j(this, "gl");
    this.array = t, this.buffer = e.createBuffer(), this.gl = e, this.size = i;
  }
  dispose() {
    !this.buffer || (this.gl.deleteBuffer(this.buffer), this.buffer = null);
  }
  update(e, t = !0) {
    this.gl.bindBuffer(e, this.buffer), this.gl.bufferData(e, this.array, t ? this.gl.STATIC_DRAW : this.gl.DYNAMIC_DRAW);
  }
}
const Gt = class extends _f {
  constructor(e, t = 1, i = 1) {
    super(e), this.setAttribute("POSITION", new $n(e, Gt.createPositions(t, i), 3)), this.setAttribute("TEXCOORD", new $n(e, new Float32Array([0, 1, 1, 1, 1, 0, 0, 0]), 2)), this.indices = new $n(e, new Uint16Array([0, 1, 2, 2, 3, 0]), 3), this.update();
  }
  static createPositions(e = 1, t = 1) {
    const i = e / 2, n = t / 2;
    return new Float32Array([-i, n, 0, i, n, 0, i, -n, 0, -i, -n, 0]);
  }
  static sharedPlane(e) {
    return Gt._sharedPlaneMesh || (Gt._sharedPlaneMesh = new Gt(e, 1, 1)), Gt._sharedPlaneMesh;
  }
  static dispose() {
    var e;
    (e = Gt._sharedPlaneMesh) == null || e.dispose(), Gt._sharedPlaneMesh = void 0;
  }
};
let Zt = Gt;
j(Zt, "_sharedPlaneMesh");
const Tf = ["POSITION", "TEXCOORD"], Sf = ["MATRIX_MVP", "MainTex", "MainTex_ST"];
var qr;
(function(r) {
  r[r.VERTEX = 0] = "VERTEX", r[r.FRAGMENT = 1] = "FRAGMENT";
})(qr || (qr = {}));
const si = class {
  constructor(e, t) {
    j(this, "_name");
    j(this, "_gl");
    j(this, "_program");
    j(this, "_uniforms", {});
    j(this, "_attributes", {});
    this._name = t, this._gl = e;
  }
  get name() {
    return this._name;
  }
  static dispose() {
    this.sharedShaders = {};
  }
  static _createProgram(e, t, i) {
    const n = e.createProgram();
    if (!n)
      throw new Error("Failed to create Program");
    if (e.attachShader(n, t), e.attachShader(n, i), e.linkProgram(n), !e.getProgramParameter(n, e.LINK_STATUS))
      throw new Error(e.getProgramInfoLog(n) || "");
    return n;
  }
  static _createShader(e, t, i) {
    const n = e.createShader(t === qr.VERTEX ? e.VERTEX_SHADER : e.FRAGMENT_SHADER);
    if (!n)
      throw new Error("Failed to create Shader");
    if (e.shaderSource(n, i), e.compileShader(n), !e.getShaderParameter(n, e.COMPILE_STATUS))
      throw new Error(e.getShaderInfoLog(n) || "");
    return n;
  }
  compile(e, t) {
    const i = this._gl, n = si._createShader(i, qr.VERTEX, e), s = si._createShader(i, qr.FRAGMENT, t);
    this._program = si._createProgram(i, n, s), Tf.forEach((o) => {
      this.getAttribute(o);
    }), Sf.forEach((o) => {
      this.getUniform(o);
    });
  }
  activate() {
    this._gl.useProgram(this._program);
  }
  deactivate() {
    this._gl.useProgram(null);
  }
  getUniform(e) {
    if (!(e in this._uniforms)) {
      const i = this._gl.getUniformLocation(this._program, e);
      i !== null && (this._uniforms[e] = i);
    }
    return this._uniforms[e];
  }
  getAttribute(e) {
    if (!(e in this._attributes)) {
      const t = this._gl;
      this._attributes[e] = t.getAttribLocation(this._program, e);
    }
    return this._attributes[e];
  }
};
let ot = si;
j(ot, "sharedShaders", {});
class Fs {
  constructor(e) {
    j(this, "scene", new Ef(void 0, "Scene"));
    j(this, "clearColor", new tr(0, 0, 0, 1));
    j(this, "_canvas");
    j(this, "_gl");
    j(this, "_camera");
    j(this, "stencilFuncs", {});
    j(this, "stencilOps", {});
    j(this, "forceUpdateMatrix", !0);
    this._canvas = e;
    const t = Fs.getContext(this._canvas, { stencil: !0 });
    if (!t)
      throw new Error("WebGL is not supported");
    this._gl = t, this._camera = new yf(), this.resetView();
    const i = this._gl;
    this.stencilFuncs = {
      [Ze.NEVER]: i.NEVER,
      [Ze.LESS]: i.LESS,
      [Ze.GREATER]: i.GREATER,
      [Ze.EQUAL]: i.EQUAL,
      [Ze.ALWAYS]: i.ALWAYS,
      [Ze.LEQUAL]: i.LEQUAL,
      [Ze.GEQUAL]: i.GEQUAL,
      [Ze.NOTEQUAL]: i.NOTEQUAL
    }, this.stencilOps = {
      [Pe.KEEP]: i.KEEP,
      [Pe.ZERO]: i.ZERO,
      [Pe.REPLACE]: i.REPLACE,
      [Pe.INCR]: i.INCR,
      [Pe.INCR_WRAP]: i.INCR_WRAP,
      [Pe.DECR_WRAP]: i.DECR_WRAP,
      [Pe.INVERT]: i.INVERT
    };
  }
  get camera() {
    return this._camera;
  }
  get context() {
    return this._gl;
  }
  static getContext(e, t) {
    return e.getContext("webgl2", t) || e.getContext("webgl", t) || e.getContext("experimental-webgl", t);
  }
  static test(e) {
    return !!(e.getContext("webgl") || e.getContext("experimental-webgl"));
  }
  dispose() {
    Zt.dispose(), ot.dispose();
  }
  resetView() {
    const e = this._canvas.width, t = this._canvas.height;
    this._camera.aspect = e / t, isNaN(this._camera.aspect) && (this._camera.aspect = 1), this._camera.updateProjectionMatrix();
    const i = this._gl;
    i.viewport(0, 0, e, t), i.clear(i.DEPTH_BUFFER_BIT | i.COLOR_BUFFER_BIT | i.STENCIL_BUFFER_BIT), this.forceUpdateMatrix = !0;
  }
  draw(e) {
    const t = this._gl;
    t.clearColor(this.clearColor.x, this.clearColor.y, this.clearColor.z, this.clearColor.w), t.clearStencil(0), t.clear(t.COLOR_BUFFER_BIT | t.STENCIL_BUFFER_BIT);
    const i = [];
    this.scene.traverse((s) => {
      let o = s.parent;
      for (; o; ) {
        if (!o.visible)
          return;
        o = o.parent;
      }
      s.update(e), s.visible && i.push(s);
    }), i.sort((s, o) => s.drawOrder - o.drawOrder);
    let n = !1;
    for (let s = 0; s < i.length; s++) {
      const o = i[s];
      o.stencilTest || o.stencilWrite ? (n || (t.enable(t.STENCIL_TEST), n = !0), t.stencilFunc(o.stencilTest ? this.stencilFuncs[o.stencilFunc.func] : t.ALWAYS, o.stencilFunc.ref, o.stencilFunc.mask), o.stencilWrite ? t.stencilOp(this.stencilOps[o.stencilOp.fail], this.stencilOps[o.stencilOp.zFail], this.stencilOps[o.stencilOp.zPass]) : t.stencilOp(t.KEEP, t.KEEP, t.KEEP)) : (t.disable(t.STENCIL_TEST), n = !1), o.updateMatrix(this.forceUpdateMatrix), o.draw(t, this._camera.projectionMatrix);
    }
    this.forceUpdateMatrix = !1;
  }
}
var Xo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Qo(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var ys = { exports: {} };
(function(r, e) {
  (function(t, i) {
    var n = "1.0.33", s = "", o = "?", l = "function", a = "undefined", b = "object", y = "string", N = "major", E = "model", B = "name", I = "type", T = "vendor", A = "version", w = "architecture", O = "console", u = "mobile", M = "tablet", d = "smarttv", c = "wearable", v = "embedded", g = 350, m = "Amazon", D = "Apple", L = "ASUS", p = "BlackBerry", x = "Browser", k = "Chrome", _ = "Edge", S = "Firefox", h = "Google", C = "Huawei", f = "LG", P = "Microsoft", F = "Motorola", R = "Opera", U = "Samsung", K = "Sharp", V = "Sony", W = "Xiaomi", G = "Zebra", H = "Facebook", $ = function(ie, ce) {
      var se = {};
      for (var he in ie)
        ce[he] && ce[he].length % 2 === 0 ? se[he] = ce[he].concat(ie[he]) : se[he] = ie[he];
      return se;
    }, Y = function(ie) {
      for (var ce = {}, se = 0; se < ie.length; se++)
        ce[ie[se].toUpperCase()] = ie[se];
      return ce;
    }, z = function(ie, ce) {
      return typeof ie === y ? X(ce).indexOf(X(ie)) !== -1 : !1;
    }, X = function(ie) {
      return ie.toLowerCase();
    }, Q = function(ie) {
      return typeof ie === y ? ie.replace(/[^\d\.]/g, s).split(".")[0] : i;
    }, q = function(ie, ce) {
      if (typeof ie === y)
        return ie = ie.replace(/^\s\s*/, s), typeof ce === a ? ie : ie.substring(0, g);
    }, Z = function(ie, ce) {
      for (var se = 0, he, ae, Ee, ue, Le, Ae; se < ce.length && !Le; ) {
        var Re = ce[se], Ke = ce[se + 1];
        for (he = ae = 0; he < Re.length && !Le; )
          if (Le = Re[he++].exec(ie), Le)
            for (Ee = 0; Ee < Ke.length; Ee++)
              Ae = Le[++ae], ue = Ke[Ee], typeof ue === b && ue.length > 0 ? ue.length === 2 ? typeof ue[1] == l ? this[ue[0]] = ue[1].call(this, Ae) : this[ue[0]] = ue[1] : ue.length === 3 ? typeof ue[1] === l && !(ue[1].exec && ue[1].test) ? this[ue[0]] = Ae ? ue[1].call(this, Ae, ue[2]) : i : this[ue[0]] = Ae ? Ae.replace(ue[1], ue[2]) : i : ue.length === 4 && (this[ue[0]] = Ae ? ue[3].call(this, Ae.replace(ue[1], ue[2])) : i) : this[ue] = Ae || i;
        se += 2;
      }
    }, J = function(ie, ce) {
      for (var se in ce)
        if (typeof ce[se] === b && ce[se].length > 0) {
          for (var he = 0; he < ce[se].length; he++)
            if (z(ce[se][he], ie))
              return se === o ? i : se;
        } else if (z(ce[se], ie))
          return se === o ? i : se;
      return ie;
    }, te = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, ne = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, re = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
        ],
        [A, [B, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
        ],
        [A, [B, "Edge"]],
        [
          /(opera mini)\/([-\w\.]+)/i,
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
        ],
        [B, A],
        [
          /opios[\/ ]+([\w\.]+)/i
        ],
        [A, [B, R + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
        ],
        [A, [B, R]],
        [
          /(kindle)\/([\w\.]+)/i,
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
          /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
          /(?:ms|\()(ie) ([\w\.]+)/i,
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          /(weibo)__([\d\.]+)/i
        ],
        [B, A],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
        ],
        [A, [B, "UC" + x]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          /\bqbcore\/([\w\.]+).+microm/i
        ],
        [A, [B, "WeChat(Win) Desktop"]],
        [
          /micromessenger\/([\w\.]+)/i
        ],
        [A, [B, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
        ],
        [A, [B, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
        ],
        [A, [B, "IE"]],
        [
          /yabrowser\/([\w\.]+)/i
        ],
        [A, [B, "Yandex"]],
        [
          /(avast|avg)\/([\w\.]+)/i
        ],
        [[B, /(.+)/, "$1 Secure " + x], A],
        [
          /\bfocus\/([\w\.]+)/i
        ],
        [A, [B, S + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
        ],
        [A, [B, R + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
        ],
        [A, [B, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
        ],
        [A, [B, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
        ],
        [A, [B, R + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
        ],
        [A, [B, "MIUI " + x]],
        [
          /fxios\/([-\w\.]+)/i
        ],
        [A, [B, S]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
        ],
        [[B, "360 " + x]],
        [
          /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
        ],
        [[B, /(.+)/, "$1 " + x], A],
        [
          /(comodo_dragon)\/([\w\.]+)/i
        ],
        [[B, /_/g, " "], A],
        [
          /(electron)\/([\w\.]+) safari/i,
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
        ],
        [B, A],
        [
          /(metasr)[\/ ]?([\w\.]+)/i,
          /(lbbrowser)/i,
          /\[(linkedin)app\]/i
        ],
        [B],
        [
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
        ],
        [[B, H], A],
        [
          /safari (line)\/([\w\.]+)/i,
          /\b(line)\/([\w\.]+)\/iab/i,
          /(chromium|instagram)[\/ ]([-\w\.]+)/i
        ],
        [B, A],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
        ],
        [A, [B, "GSA"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
        ],
        [A, [B, k + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
        ],
        [[B, k + " WebView"], A],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
        ],
        [A, [B, "Android " + x]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
        ],
        [B, A],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
        ],
        [A, [B, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
        ],
        [A, B],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
        ],
        [B, [A, J, te]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [B, A],
        [
          /(navigator|netscape\d?)\/([-\w\.]+)/i
        ],
        [[B, "Netscape"], A],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
        ],
        [A, [B, S + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          /(swiftfox)/i,
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          /(firefox)\/([\w\.]+)/i,
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          /(links) \(([\w\.]+)/i
        ],
        [B, A],
        [
          /(cobalt)\/([\w\.]+)/i
        ],
        [B, [A, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
        ],
        [[w, "amd64"]],
        [
          /(ia32(?=;))/i
        ],
        [[w, X]],
        [
          /((?:i[346]|x)86)[;\)]/i
        ],
        [[w, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
        ],
        [[w, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
        ],
        [[w, "armhf"]],
        [
          /windows (ce|mobile); ppc;/i
        ],
        [[w, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
        ],
        [[w, /ower/, s, X]],
        [
          /(sun4\w)[;\)]/i
        ],
        [[w, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        ],
        [[w, X]]
      ],
      device: [
        [
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [E, [T, U], [I, M]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [E, [T, U], [I, u]],
        [
          /\((ip(?:hone|od)[\w ]*);/i
        ],
        [E, [T, D], [I, u]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [E, [T, D], [I, M]],
        [
          /(macintosh);/i
        ],
        [E, [T, D]],
        [
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [E, [T, C], [I, M]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [E, [T, C], [I, u]],
        [
          /\b(poco[\w ]+)(?: bui|\))/i,
          /\b; (\w+) build\/hm\1/i,
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
        ],
        [[E, /_/g, " "], [T, W], [I, u]],
        [
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
        ],
        [[E, /_/g, " "], [T, W], [I, M]],
        [
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [E, [T, "OPPO"], [I, u]],
        [
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [E, [T, "Vivo"], [I, u]],
        [
          /\b(rmx[12]\d{3})(?: bui|;|\))/i
        ],
        [E, [T, "Realme"], [I, u]],
        [
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [E, [T, F], [I, u]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [E, [T, F], [I, M]],
        [
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [E, [T, f], [I, M]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [E, [T, f], [I, u]],
        [
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [E, [T, "Lenovo"], [I, M]],
        [
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[E, /_/g, " "], [T, "Nokia"], [I, u]],
        [
          /(pixel c)\b/i
        ],
        [E, [T, h], [I, M]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
        ],
        [E, [T, h], [I, u]],
        [
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [E, [T, V], [I, u]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[E, "Xperia Tablet"], [T, V], [I, M]],
        [
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [E, [T, "OnePlus"], [I, u]],
        [
          /(alexa)webm/i,
          /(kf[a-z]{2}wi)( bui|\))/i,
          /(kf[a-z]+)( bui|\)).+silk\//i
        ],
        [E, [T, m], [I, M]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
        ],
        [[E, /(.+)/g, "Fire Phone $1"], [T, m], [I, u]],
        [
          /(playbook);[-\w\),; ]+(rim)/i
        ],
        [E, T, [I, M]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
        ],
        [E, [T, p], [I, u]],
        [
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [E, [T, L], [I, M]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [E, [T, L], [I, u]],
        [
          /(nexus 9)/i
        ],
        [E, [T, "HTC"], [I, M]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i
        ],
        [T, [E, /_/g, " "], [I, u]],
        [
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [E, [T, "Acer"], [I, M]],
        [
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [E, [T, "Meizu"], [I, u]],
        [
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [E, [T, K], [I, u]],
        [
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
          /(hp) ([\w ]+\w)/i,
          /(asus)-?(\w+)/i,
          /(microsoft); (lumia[\w ]+)/i,
          /(lenovo)[-_ ]?([-\w]+)/i,
          /(jolla)/i,
          /(oppo) ?([\w ]+) bui/i
        ],
        [T, E, [I, u]],
        [
          /(archos) (gamepad2?)/i,
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          /(kindle)\/([\w\.]+)/i,
          /(nook)[\w ]+build\/(\w+)/i,
          /(dell) (strea[kpr\d ]*[\dko])/i,
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          /(trinity)[- ]*(t\d{3}) bui/i,
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          /(vodafone) ([\w ]+)(?:\)| bui)/i
        ],
        [T, E, [I, M]],
        [
          /(surface duo)/i
        ],
        [E, [T, P], [I, M]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
        ],
        [E, [T, "Fairphone"], [I, u]],
        [
          /(u304aa)/i
        ],
        [E, [T, "AT&T"], [I, u]],
        [
          /\bsie-(\w*)/i
        ],
        [E, [T, "Siemens"], [I, u]],
        [
          /\b(rct\w+) b/i
        ],
        [E, [T, "RCA"], [I, M]],
        [
          /\b(venue[\d ]{2,7}) b/i
        ],
        [E, [T, "Dell"], [I, M]],
        [
          /\b(q(?:mv|ta)\w+) b/i
        ],
        [E, [T, "Verizon"], [I, M]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
        ],
        [E, [T, "Barnes & Noble"], [I, M]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [E, [T, "NuVision"], [I, M]],
        [
          /\b(k88) b/i
        ],
        [E, [T, "ZTE"], [I, M]],
        [
          /\b(nx\d{3}j) b/i
        ],
        [E, [T, "ZTE"], [I, u]],
        [
          /\b(gen\d{3}) b.+49h/i
        ],
        [E, [T, "Swiss"], [I, u]],
        [
          /\b(zur\d{3}) b/i
        ],
        [E, [T, "Swiss"], [I, M]],
        [
          /\b((zeki)?tb.*\b) b/i
        ],
        [E, [T, "Zeki"], [I, M]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
        ],
        [[T, "Dragon Touch"], E, [I, M]],
        [
          /\b(ns-?\w{0,9}) b/i
        ],
        [E, [T, "Insignia"], [I, M]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
        ],
        [E, [T, "NextBook"], [I, M]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
        ],
        [[T, "Voice"], E, [I, u]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
        ],
        [[T, "LvTel"], E, [I, u]],
        [
          /\b(ph-1) /i
        ],
        [E, [T, "Essential"], [I, u]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
        ],
        [E, [T, "Envizen"], [I, M]],
        [
          /\b(trio[-\w\. ]+) b/i
        ],
        [E, [T, "MachSpeed"], [I, M]],
        [
          /\btu_(1491) b/i
        ],
        [E, [T, "Rotor"], [I, M]],
        [
          /(shield[\w ]+) b/i
        ],
        [E, [T, "Nvidia"], [I, M]],
        [
          /(sprint) (\w+)/i
        ],
        [T, E, [I, u]],
        [
          /(kin\.[onetw]{3})/i
        ],
        [[E, /\./g, " "], [T, P], [I, u]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
        ],
        [E, [T, G], [I, M]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [E, [T, G], [I, u]],
        [
          /(ouya)/i,
          /(nintendo) ([wids3utch]+)/i
        ],
        [T, E, [I, O]],
        [
          /droid.+; (shield) bui/i
        ],
        [E, [T, "Nvidia"], [I, O]],
        [
          /(playstation [345portablevi]+)/i
        ],
        [E, [T, V], [I, O]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
        ],
        [E, [T, P], [I, O]],
        [
          /smart-tv.+(samsung)/i
        ],
        [T, [I, d]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[E, /^/, "SmartTV"], [T, U], [I, d]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
        ],
        [[T, f], [I, d]],
        [
          /(apple) ?tv/i
        ],
        [T, [E, D + " TV"], [I, d]],
        [
          /crkey/i
        ],
        [[E, k + "cast"], [T, h], [I, d]],
        [
          /droid.+aft(\w)( bui|\))/i
        ],
        [E, [T, m], [I, d]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
        ],
        [E, [T, K], [I, d]],
        [
          /(bravia[\w ]+)( bui|\))/i
        ],
        [E, [T, V], [I, d]],
        [
          /(mitv-\w{5}) bui/i
        ],
        [E, [T, W], [I, d]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
        ],
        [[T, q], [E, q], [I, d]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
        ],
        [[I, d]],
        [
          /((pebble))app/i
        ],
        [T, E, [I, c]],
        [
          /droid.+; (glass) \d/i
        ],
        [E, [T, h], [I, c]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [E, [T, G], [I, c]],
        [
          /(quest( 2)?)/i
        ],
        [E, [T, H], [I, c]],
        [
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
        ],
        [T, [I, v]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
        ],
        [E, [I, u]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
        ],
        [E, [I, M]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
        ],
        [[I, M]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
        ],
        [[I, u]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
        ],
        [E, [T, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
        ],
        [A, [B, _ + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
        ],
        [A, [B, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          /ekioh(flow)\/([\w\.]+)/i,
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          /(icab)[\/ ]([23]\.[\d\.]+)/i
        ],
        [B, A],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
        ],
        [A, B]
      ],
      os: [
        [
          /microsoft (windows) (vista|xp)/i
        ],
        [B, A],
        [
          /(windows) nt 6\.2; (arm)/i,
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
          /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [B, [A, J, ne]],
        [
          /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[B, "Windows"], [A, J, ne]],
        [
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[A, /_/g, "."], [B, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
        ],
        [[B, "Mac OS"], [A, /_/g, "."]],
        [
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
        ],
        [A, B],
        [
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          /\((series40);/i
        ],
        [B, A],
        [
          /\(bb(10);/i
        ],
        [A, [B, p]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
        ],
        [A, [B, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
        ],
        [A, [B, S + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
        ],
        [A, [B, "webOS"]],
        [
          /crkey\/([\d\.]+)/i
        ],
        [A, [B, k + "cast"]],
        [
          /(cros) [\w]+ ([\w\.]+\w)/i
        ],
        [[B, "Chromium OS"], A],
        [
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          /(xbox); +xbox ([^\);]+)/i,
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          /(mint)[\/\(\) ]?(\w*)/i,
          /(mageia|vectorlinux)[; ]/i,
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          /(hurd|linux) ?([\w\.]*)/i,
          /(gnu) ?([\w\.]*)/i,
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          /(haiku) (\w+)/i
        ],
        [B, A],
        [
          /(sunos) ?([\w\.\d]*)/i
        ],
        [[B, "Solaris"], A],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
          /(unix) ?([\w\.]*)/i
        ],
        [B, A]
      ]
    }, ee = function(ie, ce) {
      if (typeof ie === b && (ce = ie, ie = i), !(this instanceof ee))
        return new ee(ie, ce).getResult();
      var se = ie || (typeof t !== a && t.navigator && t.navigator.userAgent ? t.navigator.userAgent : s), he = ce ? $(re, ce) : re;
      return this.getBrowser = function() {
        var ae = {};
        return ae[B] = i, ae[A] = i, Z.call(ae, se, he.browser), ae.major = Q(ae.version), ae;
      }, this.getCPU = function() {
        var ae = {};
        return ae[w] = i, Z.call(ae, se, he.cpu), ae;
      }, this.getDevice = function() {
        var ae = {};
        return ae[T] = i, ae[E] = i, ae[I] = i, Z.call(ae, se, he.device), ae;
      }, this.getEngine = function() {
        var ae = {};
        return ae[B] = i, ae[A] = i, Z.call(ae, se, he.engine), ae;
      }, this.getOS = function() {
        var ae = {};
        return ae[B] = i, ae[A] = i, Z.call(ae, se, he.os), ae;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return se;
      }, this.setUA = function(ae) {
        return se = typeof ae === y && ae.length > g ? q(ae, g) : ae, this;
      }, this.setUA(se), this;
    };
    ee.VERSION = n, ee.BROWSER = Y([B, A, N]), ee.CPU = Y([w]), ee.DEVICE = Y([E, T, I, O, u, d, M, c, v]), ee.ENGINE = ee.OS = Y([B, A]), r.exports && (e = r.exports = ee), e.UAParser = ee;
    var le = typeof t !== a && (t.jQuery || t.Zepto);
    if (le && !le.ua) {
      var pe = new ee();
      le.ua = pe.getResult(), le.ua.get = function() {
        return pe.getUA();
      }, le.ua.set = function(ie) {
        pe.setUA(ie);
        var ce = pe.getResult();
        for (var se in ce)
          le.ua[se] = ce[se];
      };
    }
  })(typeof window == "object" ? window : Xo);
})(ys, ys.exports);
const Zo = ys.exports, xf = `
precision mediump float;
attribute highp vec3 POSITION;
attribute highp vec2 TEXCOORD;

uniform highp mat4 MATRIX_MVP;
uniform highp vec4 MainTex_ST;
varying highp vec2 vTextureCoord;

uniform highp vec4 FillColor;
varying highp vec4 vColor;

vec2 TEX_TRANSFORM(vec2 texCoord, vec4 texST){
    return texCoord.xy * texST.zw + texST.xy;
}

void main(void){
    vColor = FillColor;
    vTextureCoord = TEX_TRANSFORM(TEXCOORD, MainTex_ST);
    vTextureCoord.y = 1.0 - vTextureCoord.y;
    gl_Position = MATRIX_MVP * vec4(POSITION, 1.0);
}
`, bf = `
precision mediump float;

varying highp vec2 vTextureCoord;
uniform sampler2D MainTex;
varying highp vec4 vColor;

void main(void){
    gl_FragColor = vec4(texture2D(MainTex, vec2(vTextureCoord.s, vTextureCoord.t)).rgb, 1) * vColor;
}
`;
class sn extends Mt {
  constructor(t, i, n) {
    super(i, n);
    j(this, "fillColor", new tr(0, 0, 0, 1));
    j(this, "textureTransform", new tr(0, 0, 1, 1));
    j(this, "transparent", !1);
    j(this, "opacity", 1);
    j(this, "_mesh");
    j(this, "_shader");
    j(this, "_texture");
    this._mesh = Zt.sharedPlane(t), ot.sharedShaders.sprite || (ot.sharedShaders.sprite = new ot(t, "sprite"), ot.sharedShaders.sprite.compile(xf, bf)), this._shader = ot.sharedShaders.sprite;
  }
  get texture() {
    return this._texture;
  }
  set texture(t) {
    this._texture = t;
  }
  dispose() {
    super.dispose(), this._texture = void 0;
  }
  update(t) {
  }
  draw(t, i) {
    this._shader.activate();
    const n = i.clone().multiplyRight(this.matrixWorld);
    this.transparent ? (t.enable(t.BLEND), t.blendFunc(t.SRC_ALPHA, t.ONE)) : t.disable(t.BLEND), t.uniformMatrix4fv(this._shader.getUniform("MATRIX_MVP"), !1, n), t.uniform4fv(this._shader.getUniform("MainTex_ST"), this.textureTransform), t.uniform4fv(this._shader.getUniform("FillColor"), [this.fillColor.x, this.fillColor.y, this.fillColor.z, this.fillColor.w * this.opacity]), this._texture ? (t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, this._texture.texture), t.uniform1i(this._shader.getUniform("MainTex"), 0)) : (t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, null), t.uniform1i(this._shader.getUniform("MainTex"), 0)), this._mesh.draw(this._shader), super.draw(t, i);
  }
}
class $i {
  constructor(e, t) {
    j(this, "_gl");
    j(this, "_cacheKey", "");
    j(this, "_uploadCount", 0);
    j(this, "_texture");
    j(this, "_el");
    const i = e.createTexture();
    if (!i)
      throw new Error("Failed to create Texture");
    this._texture = e.createTexture() || i, this._el = t, this._gl = e, e.bindTexture(e.TEXTURE_2D, this._texture), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.LINEAR);
  }
  get cacheKey() {
    return this._cacheKey;
  }
  set cacheKey(e) {
    this._cacheKey = e;
  }
  get uploadCount() {
    return this._uploadCount;
  }
  get texture() {
    return this._texture;
  }
  get el() {
    return this._el;
  }
  set el(e) {
    this._el = e;
  }
  dispose() {
    if (!this._texture)
      return;
    this._gl.deleteTexture(this._texture), this._texture = null;
  }
  update() {
    const e = this._gl;
    !this._el || (e.bindTexture(e.TEXTURE_2D, this._texture), e.texImage2D(e.TEXTURE_2D, 0, e.RGB, e.RGB, e.UNSIGNED_BYTE, this._el), this._uploadCount++);
  }
}
class Jo extends gi {
}
class ai {
}
j(ai, "Deg2Rad", Math.PI * 2 / 360), j(ai, "Rad2Deg", 360 / (Math.PI * 2));
function Na() {
  return globalThis.gtag;
}
const ji = {
  PlayerGlobal: "PlayerGlobal",
  PlayerControls: "PlayerControls"
}, Yi = {
  ViewEvent: "ViewEvent"
}, zi = {
  PlayStart: "PlayStart",
  Play: "Play",
  Pause: "Pause",
  Toggle: "Toggle",
  Seek: "Seek",
  DragCamera: "DragCamera",
  DragFrame: "DragFrame",
  ResetFrame: "ResetFrame"
};
class Xt {
  static startIntervals() {
    this._bufferInterval && clearInterval(this._bufferInterval), window.setInterval(() => {
      this._sendEventBuffers();
    }, 5e3);
  }
  static sendEvent(e, t, i, n) {
    const s = Na();
    if (!s || !this.enabled)
      return;
    const o = {};
    t && (o.event_category = t), i && (o.event_label = i), typeof n < "u" && (o.value = n), s("event", e, o);
  }
  static sendEventBuffer(e, t, i, n, s) {
    for (let o = 0; o < this._eventBuffers.length; o++) {
      const l = this._eventBuffers[o];
      if (l.action === e && l.category === t && l.label === i) {
        l.value = s ? l.value + n : n;
        return;
      }
    }
    this._eventBuffers.push({
      action: e,
      category: t,
      label: i,
      value: n
    });
  }
  static _sendEventBuffers() {
    if (!(!Na() || !this.enabled))
      for (; this._eventBuffers.length > 0; ) {
        const t = this._eventBuffers.shift();
        if (t == null)
          break;
        this.sendEvent(t.action, t.category, t.label, t.value);
      }
  }
}
j(Xt, "_bufferInterval", 0), j(Xt, "_eventBuffers", []), j(Xt, "enabled", !1);
class dr {
  constructor(e, t) {
    j(this, "min", new Ie(0, 0, 0));
    j(this, "max", new Ie(0, 0, 0));
    e && (this.min.x = Math.min(e.x, this.min.x), this.min.y = Math.min(e.y, this.min.y), this.min.z = Math.min(e.z, this.min.z)), t && (this.max.x = Math.max(t.x, this.max.x), this.max.y = Math.max(t.y, this.max.y), this.max.z = Math.max(t.z, this.max.z));
  }
  get aspectXY() {
    return this.width / this.height || 1;
  }
  get width() {
    return Math.abs(this.max.x - this.min.x);
  }
  get height() {
    return Math.abs(this.max.y - this.min.y);
  }
  getCenter() {
    return new Ie((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, (this.min.z + this.max.z) / 2);
  }
}
function Af(r, e) {
  const t = Zt.createPositions(e, 1), i = Array.from({ length: 4 }).map((o, l) => [t[l * 3], t[1 + l * 3], t[2 + l * 3]]), n = new Mt(), s = new dr();
  s.min.x = s.min.y = -0.5, s.max.x = s.max.y = 0.5;
  for (const o of r) {
    n.scale.set(o.scale[0], o.scale[1], 1), n.rotation.set(0, 0, o.rotation * ai.Deg2Rad, Ce.ZYX), n.position.set(o.offset[0] * e, o.offset[1], 0), n.updateMatrix();
    for (const l of i) {
      const a = [0, 0, 0];
      n.matrixWorld.transformAsPoint(l, a), s.min.x = Math.min(s.min.x, a[0]), s.min.y = Math.min(s.min.y, a[1]), s.min.z = Math.min(s.min.z, a[2]), s.max.x = Math.max(s.max.x, a[0]), s.max.y = Math.max(s.max.y, a[1]), s.max.z = Math.max(s.max.z, a[2]);
    }
  }
  return s;
}
function an(r, e) {
  const t = r.getCenter();
  return {
    scale: Math.min(e[0] / r.width, e[1] / r.height),
    translate: [-t.x, -t.y]
  };
}
function qo(r, e, t) {
  const i = Math.max(e / 2, 0.5), n = Math.min(e / 2, 1 / 2);
  return r === "landscape" ? new dr(new Ie(-i, -n, 0), new Ie(i, n, 0)) : r === "portrait" ? new dr(new Ie(-n, -i, 0), new Ie(n, i, 0)) : Af(t, e);
}
const el = `
precision mediump float;

varying highp vec4 vColor;

void main(void){
    gl_FragColor = vColor;
}
`, tl = `
precision mediump float;
attribute highp vec3 POSITION;
attribute highp vec2 TEXCOORD;

uniform highp mat4 MATRIX_MVP;
uniform highp vec4 MainTex_ST;

uniform highp vec4 FillColor;
varying highp vec4 vColor;

void main(void){
    vColor = FillColor;
    gl_Position = MATRIX_MVP * vec4(POSITION, 1.0);
}
`;
class on extends Mt {
  constructor(t, i, n) {
    super(i, n);
    j(this, "color", new Ie());
    j(this, "opacity", 1);
    j(this, "_mesh");
    j(this, "_shader");
    this._mesh = Zt.sharedPlane(t), ot.sharedShaders.fill || (ot.sharedShaders.fill = new ot(t, "fill"), ot.sharedShaders.fill.compile(tl, el)), this._shader = ot.sharedShaders.fill;
  }
  draw(t, i) {
    this._shader.activate();
    const n = i.clone().multiplyRight(this.matrixWorld);
    this.opacity < 1 ? (t.enable(t.BLEND), t.blendFunc(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA)) : t.disable(t.BLEND), t.uniformMatrix4fv(this._shader.getUniform("MATRIX_MVP"), !1, n), t.uniform4fv(this._shader.getUniform("FillColor"), [this.color.x, this.color.y, this.color.z, this.opacity]), this._mesh.draw(this._shader), super.draw(t, i);
  }
}
class ln {
  constructor(e) {
    j(this, "_mainSprite");
    j(this, "_clippingVideo");
    j(this, "_textures", {});
    j(this, "_player");
    j(this, "_mainViewGroup");
    j(this, "_locator");
    j(this, "_transformer");
    j(this, "_scale", 1);
    j(this, "_translate", new Rt());
    j(this, "_globalScale", 1);
    j(this, "_dummySprites", []);
    j(this, "_videoFrameBounding", new dr());
    j(this, "_transformCacheId", "");
    j(this, "_activeStreamIdOfLastGroup", "");
    j(this, "_lastRenderTime", -1);
    j(this, "_lastRenderVideoId", -1);
    j(this, "_drawRequired", !1);
    this._player = e;
  }
  get drawRequired() {
    return this._drawRequired;
  }
  static getTransformCacheId(e, t) {
    return `${e}:${t}`;
  }
  dispose() {
    Object.keys(this._textures).forEach((e) => this._textures[e].dispose()), this._mainSprite.dispose(), this._player.eventController.onTranslate.remove(this), this._player.eventController.onScale.remove(this), this._player.eventController.onScaleBy.remove(this), this._player.eventController.onTransformReset.remove(this);
  }
  onSetup(e, t) {
    var l, a, b;
    this._globalScale = (b = (a = (l = e.content) == null ? void 0 : l.playerOptions) == null ? void 0 : a.globalScale) != null ? b : 1, this._mainViewGroup = new Mt(t.scene, "mainView"), this._mainViewGroup.addComponent(Jo), this._mainViewGroup.visible = !0, this._locator = new Mt(this._mainViewGroup, "locator"), this._clippingVideo = new on(t.context, this._locator, "clippingArea"), this._transformer = new Mt(this._locator, "transformer"), this._mainSprite = new sn(t.context, this._transformer, "mainSprite"), this._mainSprite.stencilTest = !0, this._mainSprite.stencilFunc = {
      func: Ze.EQUAL,
      ref: 2,
      mask: 255
    }, this._clippingVideo.drawOrder = -1, this._clippingVideo.color.set(0, 0, 1), this._clippingVideo.opacity = 0, this._clippingVideo.stencilWrite = !0, this._clippingVideo.stencilOp = {
      fail: Pe.KEEP,
      zFail: Pe.KEEP,
      zPass: Pe.REPLACE
    }, this._clippingVideo.stencilFunc = {
      func: Ze.ALWAYS,
      ref: 2,
      mask: 255
    }, t.resetView();
    const i = this._mainSprite, n = this._globalScale;
    i.fillColor.set(1, 1, 1, 1), i.position.set(0, 0, 0), this.updateBounding(e, t), this.updateSize(e, t), e.eventController.node.scale.set(16 / 9 * n * 2, n * 2, 1), e.eventController.node.position.copy(i.position), e.eventController.isEnableRotationCamera = !0;
    const s = e.eventController;
    s.onTranslate.add(this, (y) => {
      const N = t.camera.aspect;
      this.setTranslate(this._translate.x + y.rx * 2 * N, this._translate.y + y.ry * 2);
    });
    const o = (y, N, E) => {
      const B = t.camera.aspect, I = { x: (N * B - B / 2) * 2, y: -(E - 0.5) * 2 }, T = { x: this._translate.x, y: this._translate.y }, A = { x: T.x - I.x, y: T.y - I.y }, w = this._scale;
      this._scale = We(y, 1, 4);
      const O = this._scale / w;
      this.setTranslate(this._translate.x + A.x * (O - 1), this._translate.y + A.y * (O - 1));
    };
    s.onScale.add(this, (y) => {
      o(y.value, y.origin.rx, y.origin.ry);
    }), s.onScaleBy.add(this, (y) => {
      o(this._scale + y.value, y.origin.rx, y.origin.ry);
    }), s.onTransformReset.add(this, () => {
      this.setScale(1), this.setTranslate(0, 0), Xt.sendEvent(zi.ResetFrame, ji.PlayerControls, Yi.ViewEvent, 1);
    }), this._drawRequired = !0;
  }
  onChangeGroup(e) {
    var t, i;
    this._transformCacheId = "", this._activeStreamIdOfLastGroup = (i = (t = e.activeVideoStream) == null ? void 0 : t.uuid) != null ? i : "";
  }
  update(e, t) {
    var B, I, T, A, w, O;
    this._dummySprites.length > 0 && (this._dummySprites.forEach((u) => u.dispose()), this._dummySprites = []), this.updateBounding(e, t);
    const i = e.streamingManager.videoStreams;
    for (let u = 0; u < i.length; u++) {
      const M = i[u];
      let d = this._textures[M.uuid];
      if (d || (d = new $i(t.context), this._textures[M.uuid] = d, d.el = M.el), M.isReadable)
        if (d.uploadCount === 0) {
          d.update();
          const c = new sn(t.context);
          c.texture = d, c.fillColor = new tr(1, 0, 0, 1), c.visible = !1, this._dummySprites.push(c);
        } else
          (e.updateEveryTexture || e.activeVideoStream === M) && d.update();
    }
    const n = Object.keys(this._textures), s = e.streamingManager.streams.map((u) => u.uuid);
    if (n.forEach((u) => {
      s.indexOf(u) === -1 && (this._textures[u].dispose(), delete this._textures[u]);
    }), this._mainSprite.visible = !1, !e.activeVideoStream || !e.activeVideoStream.isReadable)
      return;
    const o = this._textures[e.activeVideoStream.uuid];
    if (!o)
      return;
    if (this._mainSprite.visible = !0, this.updateSize(e, t), this._mainSprite.texture = o, ((B = e.activeVideoSource) == null ? void 0 : B.type) === "tiled") {
      const u = e.activeVideoSource, M = u.tileX, d = u.tileY, c = (T = (I = e.activeVideoTarget) == null ? void 0 : I.tilePosition) != null ? T : 0;
      this._mainSprite.textureTransform.set(c % M / M, (d - 1 - Math.floor(c / M)) / d, 1 / M, 1 / d);
    } else
      this._mainSprite.textureTransform.set(0, 0, 1, 1);
    const l = (w = (A = e.currentTransforms) == null ? void 0 : A.transforms) != null ? w : [], a = (O = e.getVideoGroupManager().activeTransformId) != null ? O : -1, b = [t.camera.aspect * 2, 2], y = this._videoFrameBounding, N = an(y, b), E = this._globalScale * N.scale;
    if (a > -1 && l[a]) {
      const u = l[a], M = [u.scale[0] * E, u.scale[1] * E], d = [
        (u.offset[0] * this._mainSprite.scale.x + N.translate[0]) * E,
        (u.offset[1] * this._mainSprite.scale.y + N.translate[1]) * E
      ];
      this._transformer.scale.set(M[0], M[1], 1), this._transformer.position.set(d[0], d[1], 0), this._transformer.rotation.set(0, 0, u.rotation * ai.Deg2Rad, Ce.ZYX);
    } else
      this._transformer.scale.set(E, E, 1), this._transformer.position.set(0, 0, 0), this._transformer.rotation.set(0, 0, 0, Ce.ZYX);
    this._locator.position.set(this._translate.x, this._translate.y, 0), this._locator.scale.set(this._scale, this._scale, 1), this._drawRequired = !0, (e.currentTime !== this._lastRenderTime || e.getVideoGroupManager().currentVideoId !== this._lastRenderVideoId) && (this._drawRequired = !0), this._lastRenderTime = e.currentTime, this._lastRenderVideoId = e.getVideoGroupManager().currentVideoId;
  }
  updateSize(e, t) {
    var a;
    const i = [t.camera.aspect * 2, 2], n = this._videoFrameBounding, o = an(n, i).scale * this._globalScale;
    this._clippingVideo.scale.set(n.width * o, n.height * o, 1), this._clippingVideo.position.set(0, 0, 1);
    const l = ((a = e.activeVideoStream) == null ? void 0 : a.aspect) || 1;
    this._mainSprite.scale.set(l, 1, 1), e.eventController.node.scale.set(i[0], i[1], 1), e.eventController.node.position.copy(this._mainSprite.position);
  }
  updateBounding(e, t) {
    var l, a, b, y, N, E, B, I, T, A, w;
    const i = ((l = e.activeVideoStream) == null ? void 0 : l.aspect) || 1;
    if (!e.currentTransforms) {
      this._videoFrameBounding = new dr(new Ie(-i / 2, -1 / 2, 0), new Ie(i / 2, 1 / 2, 0));
      return;
    }
    const n = this._activeStreamIdOfLastGroup !== ((b = (a = e.activeVideoStream) == null ? void 0 : a.uuid) != null ? b : ""), s = this._activeStreamIdOfLastGroup !== "";
    if (ln.getTransformCacheId((N = (y = e.currentTransforms) == null ? void 0 : y.uuid) != null ? N : "", i) !== this._transformCacheId && (s ? n : !0)) {
      this._activeStreamIdOfLastGroup = "";
      const O = (B = (E = e.activeGroup) == null ? void 0 : E.videoTracks.map((u) => {
        var M, d;
        return u.data.transformId && (d = (M = e.currentTransforms) == null ? void 0 : M.transforms[u.data.transformId]) != null ? d : void 0;
      }).filter((u) => !!u)) != null ? B : [];
      this._videoFrameBounding = qo((T = (I = e.currentTransforms) == null ? void 0 : I.contentsView) != null ? T : "bounding_area", i, O), this._transformCacheId = ln.getTransformCacheId((w = (A = e.currentTransforms) == null ? void 0 : A.uuid) != null ? w : "", i);
    }
  }
  setTranslate(e, t, i = !1) {
    const n = (this._clippingVideo.scale.x * this._scale - this._clippingVideo.scale.x) / 2, s = (this._clippingVideo.scale.y * this._scale - this._clippingVideo.scale.y) / 2;
    this._translate.x = We(e, -n, n), this._translate.y = We(t, -s, s);
  }
  setScale(e, t = !1) {
    this._scale = e < 0 ? 0 : e;
  }
}
class Lf {
  static rayTriangleIntersect(e, t = Number.MAX_SAFE_INTEGER, i, n, s, o = 1) {
    const l = e.origin, a = e.direction.clone().normalize().multiplyScalar(t), b = Number.MAX_SAFE_INTEGER, y = n.clone().sub(i), N = s.clone().sub(n), E = y.clone().cross(N), B = E.clone().dot(a);
    if (!(B < 0))
      return b;
    let T = E.dot(i) - E.dot(l);
    if (!(T <= 0) || !(T >= B * o))
      return b;
    T /= B;
    const A = l.clone().add(a.clone().multiplyScalar(T));
    let w, O, u, M, d, c;
    Math.abs(E.x) > Math.abs(E.y) ? Math.abs(E.x) > Math.abs(E.z) ? (w = A.y - i.y, O = n.y - i.y, u = s.y - i.y, M = A.z - i.z, d = n.z - i.z, c = s.z - i.z) : (w = A.x - i.x, O = n.x - i.x, u = s.x - i.x, M = A.y - i.y, d = n.y - i.y, c = s.y - i.y) : Math.abs(E.y) > Math.abs(E.z) ? (w = A.x - i.x, O = n.x - i.x, u = s.x - i.x, M = A.z - i.z, d = n.z - i.z, c = s.z - i.z) : (w = A.x - i.x, O = n.x - i.x, u = s.x - i.x, M = A.y - i.y, d = n.y - i.y, c = s.y - i.y);
    let v = O * c - d * u;
    if (v === 0)
      return b;
    v = 1 / v;
    const g = (w * c - M * u) * v;
    if (!(g >= 0))
      return b;
    const m = (O * M - d * w) * v;
    return !(m >= 0) || !(1 - g - m >= 0) ? b : T;
  }
}
const ga = class extends zo {
  constructor() {
    super(...arguments);
    j(this, "width", 1);
    j(this, "height", 1);
    j(this, "showHitRect", !1);
    j(this, "showHitRectColor", new tr(1, 0, 0, 0.5));
    j(this, "_shader");
  }
  test(t) {
    const i = this.node.matrixWorld.clone().scale([this.width, this.height, 1]), n = ga.Rect.map((l) => {
      const a = new Ie();
      return i.transform(l, a), a;
    }), s = [
      [n[2], n[0], n[1]],
      [n[1], n[3], n[2]]
    ];
    let o = Number.MAX_SAFE_INTEGER;
    for (let l = 0; l < s.length; l++) {
      const a = s[l];
      o = Math.min(o, Lf.rayTriangleIntersect(t, 10, a[0], a[1], a[2]));
    }
    return o <= 10 ? {
      collider: this,
      distance: o,
      point: t.origin.clone().add(t.direction.clone().multiplyScalar(o)),
      node: this.node
    } : null;
  }
  onDraw(t, i) {
    if (!this.showHitRect)
      return;
    this._shader || (this._shader = new ot(t, "fill"), this._shader.compile(tl, el)), this._shader.activate();
    const n = i.clone().multiplyRight(this.node.matrixWorld.clone().scale([this.width, this.height, 1]));
    t.enable(t.BLEND), t.blendFunc(t.SRC_ALPHA, t.ONE_MINUS_SRC_ALPHA), t.uniformMatrix4fv(this._shader.getUniform("MATRIX_MVP"), !1, n), t.uniform4fv(this._shader.getUniform("FillColor"), this.showHitRectColor), Zt.sharedPlane(t).draw(this._shader);
  }
};
let ei = ga;
j(ei, "Rect", [
  new Ie(-0.5, 0.5, 0),
  new Ie(0.5, 0.5, 0),
  new Ie(-0.5, -0.5, 0),
  new Ie(0.5, -0.5, 0)
]);
class ge {
  constructor() {
    j(this, "listeners", []);
  }
  add(e, t) {
    e && t ? this.listeners.push({
      target: e,
      listener: t
    }) : this.listeners.push({
      target: null,
      listener: e
    });
  }
  remove(e, t) {
    for (let i = 0; i < this.listeners.length; i++)
      t ? this.listeners[i].target === e && this.listeners[i].listener === t && (this.listeners.splice(i, 1), i--) : this.listeners[i].listener === t && (this.listeners.splice(i, 1), i--);
  }
  emit(e) {
    for (let t = 0; t < this.listeners.length; t++) {
      const i = this.listeners[t];
      i.target ? i.listener.call(i.target, e) : i.listener(e);
    }
  }
}
class wf extends gi {
  constructor() {
    super(...arguments);
    j(this, "onClickEvent", new ge());
    j(this, "onDelayedClickEvent", new ge());
  }
  onClick(t) {
    this.onClickEvent.emit(t);
  }
  onDelayedClick(t) {
    this.onDelayedClickEvent.emit(t);
  }
}
class un {
  constructor(e) {
    j(this, "_player");
    j(this, "_mainSprite");
    j(this, "_clippingVideo");
    j(this, "_clippingView");
    j(this, "_textures", {});
    j(this, "_thumbnailSprites", []);
    j(this, "_thumbnailOffset", 0);
    j(this, "_mainViewGroup");
    j(this, "_locator");
    j(this, "_transformer");
    j(this, "_splitCount", 5);
    j(this, "_globalScale", 1);
    j(this, "_scale", 1);
    j(this, "_translate", new Rt());
    j(this, "_videoFrameBounding", new dr());
    j(this, "_viewSize", [0, 0]);
    j(this, "_activeStreamIdOfLastGroup", "");
    j(this, "_transformCorrection", {
      scale: 1,
      translate: [0, 0]
    });
    j(this, "_transformCacheId", "");
    j(this, "_drawRequired", !0);
    this._player = e;
  }
  get drawRequired() {
    return this._drawRequired;
  }
  static getTransformCacheId(e, t) {
    return `${e}:${t}`;
  }
  dispose() {
    this._mainSprite.dispose();
    for (let e = 0; e < this._thumbnailSprites.length; e++)
      this._thumbnailSprites[e].dispose();
    this._player.eventController.onTranslate.remove(this), this._player.eventController.onScale.remove(this), this._player.eventController.onScaleBy.remove(this), this._player.eventController.onTransformReset.remove(this);
  }
  onSetup(e, t) {
    var N, E, B, I, T, A, w, O, u;
    this._mainViewGroup = new Mt(t.scene, "mainView"), this._mainViewGroup.addComponent(Jo), this._clippingView = new on(t.context, t.scene, "clippingView"), this._locator = new Mt(this._mainViewGroup, "locator"), this._clippingVideo = new on(t.context, this._locator, "clippingArea"), this._clippingVideo.color = new Ie(1, 1, 1), this._transformer = new Mt(this._locator, "transformer"), this._mainSprite = new sn(t.context, this._transformer, "mainSprite"), t.resetView(), this._splitCount = (B = (E = (N = e.content) == null ? void 0 : N.playerOptions) == null ? void 0 : E.thumbnailCount) != null ? B : 5, this._globalScale = (A = (T = (I = e.content) == null ? void 0 : I.playerOptions) == null ? void 0 : T.globalScale) != null ? A : 1, e.eventController.isEnableRotationCamera = (u = (O = (w = e.content) == null ? void 0 : w.playerOptions) == null ? void 0 : O.allowRotation) != null ? u : !1;
    const i = this._mainSprite;
    i.stencilTest = !0, i.stencilFunc = {
      func: Ze.EQUAL,
      ref: 2,
      mask: 255
    }, i.fillColor.set(1, 1, 1, 1), i.visible = !0, this._clippingView.drawOrder = -2, this._clippingView.color.set(0, 0, 1), this._clippingView.opacity = 0, this._clippingView.stencilWrite = !0, this._clippingView.stencilOp = {
      fail: Pe.KEEP,
      zFail: Pe.KEEP,
      zPass: Pe.INCR
    }, this._clippingView.stencilFunc = {
      func: Ze.ALWAYS,
      ref: 1,
      mask: 255
    }, this._clippingVideo.drawOrder = -1, this._clippingVideo.color.set(0, 1, 0), this._clippingVideo.opacity = 0, this._clippingVideo.stencilTest = !0, this._clippingVideo.stencilWrite = !0, this._clippingVideo.stencilFunc = {
      func: Ze.EQUAL,
      ref: 1,
      mask: 255
    }, this._clippingVideo.stencilOp = {
      fail: Pe.KEEP,
      zFail: Pe.KEEP,
      zPass: Pe.INCR
    };
    const n = 16 / 9, s = [], o = this._splitCount, l = 1 / o, a = 1 - l;
    for (let M = 0; M < o; M++) {
      const d = new sn(t.context, t.scene, "subSprite" + (M + 1));
      d.addComponent(ei), d.addComponent(wf).onClickEvent.add(() => {
        var v, g;
        this.selectVideo((g = (v = this._player.activeGroup) == null ? void 0 : v.videoIds[M + this._thumbnailOffset]) != null ? g : 0);
      }), d.fillColor.set(1, 1, 1, 1), d.scale.set(l * n * 2, l * 2, 1), d.position.set(-a * n + M * (l + l) * n, -a, 0), d.visible = !1, s.push(d);
    }
    this._thumbnailSprites = s, i.fillColor.set(1, 1, 1, 1);
    const b = e.eventController;
    b.onTranslate.add(this, (M) => {
      this.setTranslate(this._translate.x + M.rx * this._mainSprite.scale.x, this._translate.y + M.ry * this._mainSprite.scale.y);
    });
    const y = (M, d, c) => {
      const v = t.camera.aspect, g = { x: (d * v - v / 2) * 2, y: -(c - 0.5) * 2 }, m = { x: this._translate.x, y: this._translate.y }, D = { x: m.x - g.x, y: m.y - g.y }, L = this._scale;
      this._scale = We(M, 1, 4);
      const p = this._scale / L;
      this.setTranslate(this._translate.x + D.x * (p - 1), this._translate.y + D.y * (p - 1));
    };
    b.onScale.add(this, (M) => {
      y(M.value, M.origin.rx, M.origin.ry);
    }), b.onScaleBy.add(this, (M) => {
      y(this._scale + M.value, M.origin.rx, M.origin.ry);
    }), b.onTransformReset.add(this, () => {
      this.setScale(1), this.setTranslate(0, 0);
    }), this.updateBounding(e, t);
  }
  selectVideo(e) {
    const t = this._player;
    t.activeGroup && t.selectByVideoId(e);
  }
  update(e, t) {
    var N, E, B, I, T, A;
    if (!e.activeVideoStream)
      return;
    this.updateBounding(e, t);
    const i = [], n = e.getVideoGroupManager().getGroup().getSourceIds("tiled").map((w) => e.streamingManager.getStream(w)).filter((w) => !!w);
    for (let w = 0; w < n.length; w++) {
      const O = n[w];
      let u = this._textures[O.uuid];
      u || (u = new $i(t.context), this._textures[O.uuid] = u, u.el = O.el, u.update());
    }
    for (let w = 0; w < this._thumbnailSprites.length; w++)
      this._thumbnailSprites[w].visible = !1, this._thumbnailSprites[w].fillColor.set(1, 1, 1, 1);
    if (e.activeGroup) {
      const w = e.activeGroup, O = w.videoIds.indexOf(e.getVideoGroupManager().currentVideoId);
      O < this._thumbnailOffset && (this._thumbnailOffset = O), O > this._thumbnailOffset + this._thumbnailSprites.length - 1 && (this._thumbnailOffset = O - (this._thumbnailSprites.length - 1));
      for (let u = 0; u < w.videoIds.length && u < this._thumbnailSprites.length; u++) {
        const M = this._thumbnailOffset + u, d = w.videoIds[M], c = e.getVideoTrack(d).getRegionAt(e.currentTime);
        if (!c || !c.tiled)
          continue;
        const v = e.getContent().getSource(c.tiled.sourceId), g = e.streamingManager.getStream(c.tiled.sourceId);
        if (!v || !g)
          continue;
        let m = this._textures[g.uuid];
        m || (m = new $i(t.context), this._textures[g.uuid] = m), i.indexOf(m) === -1 && (m.el = g.el, i.push(m));
        const D = this._getTileTransform(v, c.tiled.tilePosition);
        this._thumbnailSprites[u].textureTransform.set(D[0], D[1], D[2], D[3]), this._thumbnailSprites[u].visible = !0, this._thumbnailSprites[u].texture = m, e.getVideoGroupManager().currentVideoId === d && this._thumbnailSprites[u].fillColor.set(0.5, 0.5, 0.5, 1);
      }
      this._splitCount = Math.min(w.videoIds.length, this._thumbnailSprites.length);
    }
    if (((N = e.activeVideoSource) == null ? void 0 : N.type) === "tiled") {
      const w = e.activeVideoSource, O = w.tileX, u = w.tileY, M = (B = (E = e.activeVideoTarget) == null ? void 0 : E.tilePosition) != null ? B : 0;
      this._mainSprite.texture = this._textures[e.activeVideoStream.uuid], this._mainSprite.textureTransform.set(M % O / O, (u - 1 - Math.floor(M / O)) / u, 1 / O, 1 / u);
      const d = this._textures[e.activeVideoStream.uuid];
      i.push(d);
    } else {
      let w = this._textures[e.activeVideoStream.uuid];
      w || (w = new $i(t.context), this._textures[e.activeVideoStream.uuid] = w), w.el = e.activeVideoStream.el, w.update(), this._mainSprite.texture = w, this._mainSprite.textureTransform.set(0, 0, 1, 1);
    }
    this.updateSize(e, t);
    for (let w = 0; w < i.length; w++)
      i[w].update();
    const s = (T = (I = e.currentTransforms) == null ? void 0 : I.transforms) != null ? T : [], o = (A = e.getContent().getVideoTrack(e.getVideoGroupManager().currentVideoId).data.transformId) != null ? A : -1, l = this._viewSize, a = this._videoFrameBounding, b = an(a, l), y = this._globalScale * b.scale;
    if (o > -1 && s[o]) {
      const w = s[o], O = [w.scale[0] * y, w.scale[1] * y], u = [
        (w.offset[0] * this._mainSprite.scale.x + b.translate[0]) * y,
        (w.offset[1] * this._mainSprite.scale.y + b.translate[1]) * y
      ];
      this._transformer.scale.set(O[0], O[1], 1), this._transformer.position.set(u[0], u[1], 0), this._transformer.rotation.set(0, 0, w.rotation * ai.Deg2Rad, Ce.ZYX);
    } else
      this._transformer.scale.set(y, y, 1), this._transformer.position.set(0, 0, 0), this._transformer.rotation.set(0, 0, 0, Ce.ZYX);
    this._locator.position.set(this._translate.x, this._translate.y, 0), this._locator.scale.set(this._scale, this._scale, 1);
  }
  updateSize(e, t) {
    var A;
    const i = ((A = e.activeVideoStream) == null ? void 0 : A.aspect) || 1, n = t.camera.aspect, s = 0.5, o = 2 * n, l = 2, a = this._splitCount;
    let b = o / a, y = b / i;
    y > s && (b = b / (y / s), y = s);
    for (let w = 0; w < a; w++) {
      const O = this._thumbnailSprites[w];
      O.scale.set(b, y, 1), O.position.set(b * (w - (a - 1) / 2), -l / 2 + y / 2, 0);
    }
    const N = l - y;
    this._viewSize = [2 * n, l - y];
    const E = this._videoFrameBounding, I = an(E, this._viewSize).scale * this._globalScale, T = l / 2 - N / 2;
    this._clippingView.position.set(0, l / 2 - N / 2, 1), this._clippingView.scale.set(n * 2, N, 1), this._clippingVideo.position.set(0, 0, 1), this._clippingVideo.scale.set(E.width * I, E.height * I, 1), this._mainSprite.scale.set(i, 1, 1), this._mainViewGroup.position.y = T, this._player.eventController.node.scale.set(this._viewSize[0], this._viewSize[1], 1), this._player.eventController.node.position.set(0, 0, 0);
  }
  _getTileTransform(e, t) {
    if (e.type === "tiled") {
      const i = e.tileX, n = e.tileY;
      return [t % i / i, (n - 1 - Math.floor(t / i)) / n, 1 / i, 1 / n];
    } else
      return [0, 0, 1, 1];
  }
  updateBounding(e, t) {
    var l, a, b, y, N, E, B, I, T, A, w;
    const i = ((l = e.activeVideoStream) == null ? void 0 : l.aspect) || 1;
    if (!e.currentTransforms) {
      this._videoFrameBounding = new dr(new Ie(-i / 2, -1 / 2, 0), new Ie(i / 2, 1 / 2, 0));
      return;
    }
    const n = this._activeStreamIdOfLastGroup !== ((b = (a = e.activeVideoStream) == null ? void 0 : a.uuid) != null ? b : ""), s = this._activeStreamIdOfLastGroup !== "";
    if (un.getTransformCacheId((N = (y = e.currentTransforms) == null ? void 0 : y.uuid) != null ? N : "", i) !== this._transformCacheId && (s ? n : !0)) {
      this._activeStreamIdOfLastGroup = "";
      const O = (B = (E = e.activeGroup) == null ? void 0 : E.videoTracks.map((u) => {
        var M, d;
        return u.data.transformId && (d = (M = e.currentTransforms) == null ? void 0 : M.transforms[u.data.transformId]) != null ? d : void 0;
      }).filter((u) => !!u)) != null ? B : [];
      this._videoFrameBounding = qo((T = (I = e.currentTransforms) == null ? void 0 : I.contentsView) != null ? T : "bounding_area", i, O), this._transformCacheId = un.getTransformCacheId((w = (A = e.currentTransforms) == null ? void 0 : A.uuid) != null ? w : "", i);
    }
  }
  setTranslate(e, t, i = !1) {
    const n = (this._mainSprite.scale.x * this._scale - this._mainSprite.scale.x) / 2, s = (this._mainSprite.scale.y * this._scale - this._mainSprite.scale.y) / 2;
    this._translate.x = We(e, -n, n), this._translate.y = We(t, -s, s);
  }
  setScale(e, t = !1) {
    this._scale = e < 0 ? 0 : e;
  }
}
var oi;
(function(r) {
  r[r.None = 0] = "None", r[r.Left = 1] = "Left", r[r.Right = 2] = "Right", r[r.Middle = 4] = "Middle";
})(oi || (oi = {}));
class Ns {
  constructor(e) {
    j(this, "onKeyDown", new ge());
    j(this, "onKeyUp", new ge());
    j(this, "onPointerDown", new ge());
    j(this, "onPointerMove", new ge());
    j(this, "onPointerLocalMove", new ge());
    j(this, "onPointerUp", new ge());
    j(this, "onMouseDown", new ge());
    j(this, "onMouseMove", new ge());
    j(this, "onMouseLocalMove", new ge());
    j(this, "onMouseUp", new ge());
    j(this, "onTouchStart", new ge());
    j(this, "onTouchMove", new ge());
    j(this, "onTouchLocalMove", new ge());
    j(this, "onTouchEnd", new ge());
    j(this, "onInputStart", new ge());
    j(this, "onInputMove", new ge());
    j(this, "onInputLocalMove", new ge());
    j(this, "onInputEnd", new ge());
    j(this, "onWheel", new ge());
    j(this, "onClick", new ge());
    j(this, "onDelayedClick", new ge());
    j(this, "onDblClick", new ge());
    j(this, "_events", {});
    j(this, "isTouchDown", !1);
    j(this, "isMouseDown", !1);
    j(this, "isPointerDown", !1);
    j(this, "isMoved", !1);
    j(this, "isPrimary", !1);
    j(this, "isDown", !1);
    j(this, "startPosition", { x: 0, y: 0 });
    j(this, "lastClickTime", 0);
    j(this, "clickTimer", 0);
    j(this, "_el");
    j(this, "_eventPosition", new Rt());
    j(this, "_mouseScrollDelta", new Rt());
    this._events["key-down"] = this.keyDown.bind(this), this._events["key-up"] = this.keyUp.bind(this), this._events["mouse-down"] = this.mouseDown.bind(this), this._events["mouse-move"] = this.mouseMove.bind(this), this._events["mouse-local-move"] = this.mouseLocalMove.bind(this), this._events["mouse-up"] = this.mouseUp.bind(this), this._events["pointer-down"] = this.pointerDown.bind(this), this._events["pointer-move"] = this.pointerMove.bind(this), this._events["pointer-local-move"] = this.pointerLocalMove.bind(this), this._events["pointer-up"] = this.pointerUp.bind(this), this._events["touch-start"] = this.touchStart.bind(this), this._events["touch-move"] = this.touchMove.bind(this), this._events["touch-local-move"] = this.touchLocalMove.bind(this), this._events["touch-end"] = this.touchEnd.bind(this), this._events.wheel = this.wheel.bind(this), this._events.prevent = this.prevent.bind(this), e && (this.el = e);
  }
  get el() {
    return this._el;
  }
  set el(e) {
    this._el && this.removeHandlers(), this._el = e, this._el && this.addHandlers();
  }
  get eventPosition() {
    return this._eventPosition;
  }
  get mouseScrollDelta() {
    return this._mouseScrollDelta;
  }
  dispose() {
    this.removeHandlers();
  }
  onEndOfFrame() {
    this._mouseScrollDelta.set(0, 0);
  }
  removeHandlers() {
    const e = this._el;
    !e || ("onpointerdown" in window ? (e.removeEventListener("pointerdown", this._events["pointer-down"], !0), e.removeEventListener("pointermove", this._events["pointer-local-move"], !0), window.removeEventListener("pointermove", this._events["pointer-move"], !0), window.removeEventListener("pointerup", this._events["pointer-up"], !0)) : (e.removeEventListener("mousedown", this._events["mouse-down"], !0), e.removeEventListener("mousemove", this._events["mouse-local-move"], !0), window.removeEventListener("mousemove", this._events["mouse-move"], !0), window.removeEventListener("mouseup", this._events["mouse-up"], !0)), e.removeEventListener("contextmenu", this._events.prevent), e.removeEventListener("touchstart", this._events["touch-start"], !0), window.removeEventListener("touchmove", this._events["touch-move"], !0), e.removeEventListener("touchmove", this._events["touch-local-move"], !0), window.removeEventListener("touchend", this._events["touch-end"], !0), e.removeEventListener("wheel", this._events.wheel));
  }
  addHandlers() {
    const e = this._el;
    !e || ("onpointerdown" in window ? (e.addEventListener("pointerdown", this._events["pointer-down"], { passive: !1 }), e.addEventListener("pointermove", this._events["pointer-local-move"], { passive: !1 }), window.addEventListener("pointermove", this._events["pointer-move"], { passive: !1 }), window.addEventListener("pointerup", this._events["pointer-up"], { passive: !1 })) : (e.addEventListener("mousedown", this._events["mouse-down"], { passive: !1 }), e.addEventListener("mousemove", this._events["mouse-local-move"], { passive: !1 }), window.addEventListener("mousemove", this._events["mouse-move"], { passive: !1 }), window.addEventListener("mouseup", this._events["mouse-up"], { passive: !1 })), e.addEventListener("contextmenu", this._events.prevent), e.addEventListener("touchstart", this._events["touch-start"], { passive: !1 }), window.addEventListener("touchmove", this._events["touch-move"], { passive: !1 }), e.addEventListener("touchmove", this._events["touch-local-move"], { passive: !1 }), window.addEventListener("touchend", this._events["touch-end"], { passive: !1 }), e.addEventListener("wheel", this._events.wheel));
  }
  prevent(e) {
    e.preventDefault();
  }
  keyDown(e) {
    this.onKeyDown.emit(e);
  }
  keyUp(e) {
    this.onKeyUp.emit(e);
  }
  mouseDown(e) {
    this.isMouseDown = !0, this.onMouseDown.emit(e);
    const t = this.toInputItems(e);
    this.inputStart({
      isTouch: !1,
      isDown: this.isMouseDown,
      buttons: e.buttons,
      main: t[0],
      inputs: t,
      originalEvent: e
    }), e.preventDefault();
  }
  mouseLocalMove(e) {
    this.onMouseLocalMove.emit(e);
    const t = this.toInputItems(e);
    this.inputLocalMove({
      isTouch: !1,
      isDown: this.isMouseDown,
      buttons: e.buttons,
      main: t[0],
      inputs: t,
      originalEvent: e
    });
  }
  mouseMove(e) {
    this.onMouseMove.emit(e);
    const t = this.toInputItems(e);
    this.inputMove({
      isTouch: !1,
      isDown: this.isMouseDown,
      buttons: e.buttons,
      main: t[0],
      inputs: t,
      originalEvent: e
    });
  }
  mouseUp(e) {
    this.onMouseUp.emit(e);
    const t = this.toInputItems(e);
    this.inputEnd({
      isTouch: !1,
      isDown: this.isMouseDown,
      buttons: e.buttons,
      main: t[0],
      inputs: t,
      originalEvent: e
    }), this.isMouseDown = !1;
  }
  pointerDown(e) {
    if (!e.isPrimary || e.type === "touch")
      return;
    this.isPointerDown = !0, this.onPointerDown.emit(e);
    const t = this.toInputItems(e);
    this.inputStart({
      isTouch: !1,
      isDown: this.isPointerDown,
      buttons: e.buttons,
      main: t[0],
      inputs: t,
      originalEvent: e
    }), e.preventDefault();
  }
  pointerLocalMove(e) {
    if (e.pointerType === "touch")
      return;
    this.onPointerLocalMove.emit(e);
    const t = this.toInputItems(e);
    this.inputLocalMove({
      isTouch: !1,
      isDown: this.isPointerDown,
      buttons: e.buttons,
      main: t[0],
      inputs: t,
      originalEvent: e
    });
  }
  pointerMove(e) {
    if (e.pointerType === "touch")
      return;
    this.onPointerMove.emit(e);
    const t = this.toInputItems(e);
    this.inputMove({
      isTouch: !1,
      isDown: this.isPointerDown,
      buttons: e.buttons,
      main: t[0],
      inputs: t,
      originalEvent: e
    });
  }
  pointerUp(e) {
    if (e.pointerType === "touch")
      return;
    this.onPointerUp.emit(e);
    const t = this.toInputItems(e);
    this.inputEnd({
      isTouch: !1,
      isDown: this.isPointerDown,
      buttons: e.buttons,
      main: t[0],
      inputs: t,
      originalEvent: e
    }), this.isPointerDown = !1;
  }
  touchStart(e) {
    e.preventDefault(), this.isTouchDown = !0, this.onTouchStart.emit(e);
    const t = this.toInputItems(e);
    this.inputStart({
      isTouch: !0,
      isDown: this.isTouchDown,
      buttons: 0,
      main: this.getMainInput(t),
      inputs: t,
      originalEvent: e
    });
  }
  touchMove(e) {
    this.onTouchMove.emit(e);
    const t = this.toInputItems(e);
    this.inputMove({
      isTouch: !0,
      isDown: this.isTouchDown,
      buttons: 0,
      main: this.getMainInput(t),
      inputs: t,
      originalEvent: e
    });
  }
  touchLocalMove(e) {
    e.preventDefault(), this.onTouchLocalMove.emit(e);
    const t = this.toInputItems(e);
    this.inputLocalMove({
      isTouch: !0,
      isDown: this.isTouchDown,
      buttons: 0,
      main: this.getMainInput(t),
      inputs: t,
      originalEvent: e
    });
  }
  touchEnd(e) {
    this.onTouchEnd.emit(e);
    const t = [{ x: this.eventPosition.x, y: this.eventPosition.y }];
    this.inputEnd({
      isTouch: !0,
      isDown: this.isTouchDown,
      buttons: 0,
      main: t[0],
      inputs: t,
      originalEvent: e
    }), this.isTouchDown = !1;
  }
  inputStart(e) {
    this.startPosition.x = e.main.x, this.startPosition.y = e.main.y, this.isMoved = !1, this.isDown = !0, e.isTouch ? this.isPrimary = e.inputs.length === 1 : this.isPrimary = !!(e.buttons & oi.Left), this._eventPosition.set(e.main.x, e.main.y), this.onInputStart.emit(e);
  }
  inputLocalMove(e) {
    this.onInputLocalMove.emit(e);
  }
  inputMove(e) {
    const t = this.startPosition.x - e.main.x, i = this.startPosition.y - e.main.y;
    t * t + i * i > 15 * 15 && (this.isMoved = !0), this._eventPosition.set(e.main.x, e.main.y), this.onInputMove.emit(e);
  }
  inputEnd(e) {
    this.onInputEnd.emit(e), this.isDown && (this.isDown = !1, !this.isMoved && this.isPrimary && (Date.now() - this.lastClickTime < 250 ? (window.clearTimeout(this.clickTimer), this.onDblClick.emit(e), this.lastClickTime = 0) : (this.clickTimer = window.setTimeout(() => {
      this.onDelayedClick.emit(e), this.clickTimer = 0;
    }, 250), this.onClick.emit(e), this.lastClickTime = Date.now())));
  }
  wheel(e) {
    e.preventDefault(), this._mouseScrollDelta.set(e.deltaX, e.deltaY), this.onWheel.emit(e);
  }
  toInputItems(e) {
    return e instanceof MouseEvent || window.PointerEvent && e instanceof PointerEvent ? [{
      x: e.pageX,
      y: e.pageY
    }] : Array.prototype.map.call(e.touches, (t) => ({
      x: t.pageX,
      y: t.pageY
    }));
  }
  getMainInput(e) {
    const t = { x: 0, y: 0 };
    if (e.length > 0) {
      for (let i = 0; i < e.length; i++)
        t.x += e[i].x, t.y += e[i].y;
      t.x /= e.length, t.y /= e.length;
    }
    return t;
  }
}
class cr extends gi {
  constructor(t) {
    super(t);
    j(this, "onKeyDownEvent", new ge());
    j(this, "camera");
    j(this, "_handler");
    j(this, "_el");
    this._handler = new Ns(), this._handler.onClick.add(this, this.onClick), this._handler.onDelayedClick.add(this, this.onDelayedClick), this._handler.onInputStart.add(this, this.onInputStart), this._handler.onKeyDown.add(this, this._onKeyDown);
  }
  get inputHandler() {
    var t;
    return (t = this._handler) != null ? t : null;
  }
  get el() {
    var t;
    return (t = this._el) != null ? t : void 0;
  }
  set el(t) {
    this._handler.el = t, this._el = t;
  }
  static getElementBounds(t) {
    return t.getBoundingClientRect();
  }
  static getViewPortPosition(t, i) {
    return new Rt((i.x - (t.x + window.scrollX)) / t.width, (i.y - (t.y + window.scrollY)) / t.height);
  }
  onClick(t) {
    this.emitEvent(t, "onClick");
  }
  onDelayedClick(t) {
    this.emitEvent(t, "onDelayedClick");
  }
  onInputStart(t) {
    this.emitEvent(t, "onInputStart");
  }
  _onKeyDown(t) {
    const i = this.scene;
    !i || (i.traverse((n) => {
      n.sendMessage(null, "onKeyDown", t);
    }), this.onKeyDownEvent.emit(t));
  }
  emitEvent(t, i) {
    if (!this.camera || !this.el)
      return;
    const n = this.camera.viewPointToRay(cr.getViewPortPosition(cr.getElementBounds(this.el), t.main)), s = this.raycast(n, !0);
    s[0] && s[0].node.sendMessage(null, i, t, s[0]);
  }
  raycast(t, i = !1) {
    var l;
    const n = this.scene;
    if (!n)
      return [];
    const s = [], o = [];
    n.traverse((a) => {
      a.visible && a.collider && o.push(a);
    }), o.sort((a, b) => b.drawOrder - a.drawOrder);
    for (let a = 0; a < o.length; a++) {
      const y = (l = o[a].collider) == null ? void 0 : l.test(t);
      if (y && (s.push(y), i))
        break;
    }
    return s.sort((a, b) => a.distance - b.distance), s;
  }
}
class Bs extends gi {
  constructor(t) {
    var n, s, o, l, a, b, y;
    super(t);
    j(this, "isEnableRotationCamera", !0);
    j(this, "isEnableStepFrame", !0);
    j(this, "isEnableTransform", !0);
    j(this, "horizontalOffsetAmount", 5);
    j(this, "onOffsetHorizontal", new ge());
    j(this, "onOffsetHorizontalRest", new ge());
    j(this, "onOffsetVertical", new ge());
    j(this, "onOffsetVerticalRest", new ge());
    j(this, "onPauseOrPlay", new ge());
    j(this, "onStartAction", new ge());
    j(this, "onEndAction", new ge());
    j(this, "onTranslate", new ge());
    j(this, "onScale", new ge());
    j(this, "onScaleBy", new ge());
    j(this, "onTransformReset", new ge());
    j(this, "startPosition", new Rt());
    j(this, "lastPosition", new Rt());
    j(this, "lastDistance", 0);
    j(this, "isStartScale", !1);
    j(this, "_lastOffsetPositionX", 0);
    j(this, "_lastOffsetPositionY", 0);
    j(this, "_eventSystem");
    j(this, "_resetStartTimer", 0);
    j(this, "_rotationEnabled", !1);
    j(this, "_stepsEnabled", !1);
    const i = t.addComponent(ei);
    i.showHitRect = !1, this.node.drawOrder = -1, this.node.updateMatrix(), this._eventSystem = (s = (n = this.scene) == null ? void 0 : n.getComponent(cr)) != null ? s : void 0, (o = this._eventSystem) == null || o.inputHandler.onInputStart.add(this, this.onInputStart), (l = this._eventSystem) == null || l.inputHandler.onInputMove.add(this, this.onInputMove), (a = this._eventSystem) == null || a.inputHandler.onInputEnd.add(this, this.onInputEnd), (b = this._eventSystem) == null || b.inputHandler.onDblClick.add(this, this.onDblClick), (y = this._eventSystem) == null || y.inputHandler.onWheel.add(this, this.onWheel);
  }
  get el() {
    var t;
    return (t = this._eventSystem) == null ? void 0 : t.inputHandler.el;
  }
  static positive(t) {
    return t < 0 ? 0 : t;
  }
  dispose() {
    var t, i, n;
    (t = this._eventSystem) == null || t.inputHandler.onInputStart.remove(this, this.onInputStart), (i = this._eventSystem) == null || i.inputHandler.onInputMove.remove(this, this.onInputMove), (n = this._eventSystem) == null || n.inputHandler.onInputEnd.remove(this, this.onInputEnd), this._eventSystem = void 0;
  }
  onDelayedClick(t, i) {
    this.onPauseOrPlay.emit();
  }
  onInputStart(t) {
    if (!this.el)
      return;
    const i = this.el.getBoundingClientRect();
    new Rt((t.main.x - i.x) / i.width, (t.main.y - i.y) / i.height), this.startPosition.set(t.main.x, t.main.y), this.lastPosition.set(t.main.x, t.main.y), this._rotationEnabled = !1, this._stepsEnabled = !1, t.inputs.length === 2 && (this.lastDistance = this.getDistance(t)), this.isStartScale = !1, this._lastOffsetPositionX = 0, this._lastOffsetPositionY = 0, this.onStartAction.emit(t);
  }
  onInputMove(t) {
    if (!t.isDown || !this.el)
      return;
    const i = this.el.getBoundingClientRect();
    new Rt((t.main.x - i.x) / i.width, (t.main.y - i.y) / i.height);
    const n = this.startPosition.x - t.main.x, s = this.startPosition.y - t.main.y, o = this.lastPosition.x - t.main.x, l = this.lastPosition.y - t.main.y, a = Math.trunc(-n / (i.width / this.horizontalOffsetAmount)), b = Math.trunc(Math.sign(s) * Bs.positive(Math.abs(s) - 50) / 50), y = -(this._lastOffsetPositionX - a), N = -(this._lastOffsetPositionY - b), E = t.isTouch && t.inputs.length === 1 || t.buttons & oi.Left;
    if (this.isEnableRotationCamera && E && Math.abs(n) > 25 && !this._stepsEnabled && (this._lastOffsetPositionX !== a && this.onOffsetHorizontal.emit(y), this._rotationEnabled = !0), this.isEnableStepFrame && E && Math.abs(s) > 25 && !this._rotationEnabled && (this._lastOffsetPositionY !== b && this.onOffsetVertical.emit(-N), this._stepsEnabled = !0), this.isEnableTransform && (t.isTouch && t.inputs.length === 2 || t.buttons & oi.Right) && this.onTranslate.emit({ x: -o, y: l, rx: -o / i.width, ry: l / i.height }), this.isEnableTransform && t.inputs.length === 2) {
      const B = this.getDistance(t);
      if (Math.abs(B - this.lastDistance) > 0.25 && (this.isStartScale = !0), this.isStartScale) {
        const I = B / this.lastDistance - 1;
        this.lastDistance = B;
        const T = (t.inputs[0].x + t.inputs[1].x) / 2, A = (t.inputs[0].y + t.inputs[1].y) / 2;
        this.onScaleBy.emit({
          value: I,
          origin: { x: -o, y: l, rx: T / i.width, ry: A / i.height }
        });
      }
    }
    this._lastOffsetPositionX = a, this._lastOffsetPositionY = b, this.lastPosition.set(t.main.x, t.main.y), this._resetStartTimer > 0 && clearTimeout(this._resetStartTimer), this._resetStartTimer = window.setTimeout(() => {
      this.startPosition.x = t.main.x, this.startPosition.y = t.main.y, this._rotationEnabled = !1, this._stepsEnabled = !1;
    }, 300);
  }
  onInputEnd(t) {
    !t.isDown || !this.el || this.onEndAction.emit(t);
  }
  onDblClick(t) {
    !this.isEnableTransform || this.onTransformReset.emit();
  }
  onWheel(t) {
    if (!this.el || !this.isEnableTransform)
      return;
    const i = this.el.getBoundingClientRect();
    this.onScaleBy.emit({
      value: -We(t.deltaY / 200, -0.1, 0.1),
      origin: {
        x: t.pageX - i.x,
        y: t.pageY - i.y,
        rx: (t.pageX - i.x) / i.width,
        ry: (t.pageY - i.y) / i.height
      }
    });
  }
  getDistance(t) {
    const i = t.inputs[1].x - t.inputs[0].x, n = t.inputs[1].y - t.inputs[0].y;
    return Math.sqrt(i * i + n * n);
  }
}
const ir = {
  Alt: "Alt",
  AltGraph: "AltGraph",
  CapsLock: "CapsLock",
  Control: "Control",
  Fn: "Fn",
  FnLock: "FnLock",
  Hyper: "Hyper",
  Meta: "Meta",
  NumLock: "NumLock",
  ScrollLock: "ScrollLock",
  Shift: "Shift",
  Super: "Super",
  Symbol: "Symbol",
  SymbolLock: "SymbolLock",
  Enter: "Enter",
  Tab: "Tab",
  Space: " ",
  ArrowDown: "ArrowDown",
  ArrowLeft: "ArrowLeft",
  ArrowRight: "ArrowRight",
  ArrowUp: "ArrowUp",
  End: "End",
  Home: "Home",
  PageDown: "PageDown",
  PageUp: "PageUp",
  Backspace: "Backspace",
  Clear: "Clear",
  Copy: "Copy",
  CrSel: "CrSel",
  Cut: "Cut",
  Delete: "Delete",
  EraseEof: "EraseEof",
  ExSel: "ExSel",
  Insert: "Insert",
  Paste: "Paste",
  Redo: "Redo",
  Undo: "Undo",
  Accept: "Accept",
  Again: "Again",
  Attn: "Attn",
  Cancel: "Cancel",
  ContextMenu: "ContextMenu",
  Escape: "Escape",
  Execute: "Execute",
  Find: "Find",
  Finish: "Finish",
  Help: "Help",
  Pause: "Pause",
  Play: "Play",
  Props: "Props",
  Select: "Select",
  ZoomIn: "ZoomIn",
  ZoomOut: "ZoomOut"
}, pn = class {
  constructor(e) {
    j(this, "onKeyDown", new ge());
    j(this, "_items", []);
    j(this, "_target");
    j(this, "_events");
    j(this, "_enabled", !1);
    this._target = e, this._events = {
      down: this._down.bind(this),
      up: this._up.bind(this)
    }, e.addEventListener("keydown", this._events.down), e.addEventListener("keyup", this._events.up);
  }
  static createRegion() {
    const e = new pn(window);
    return this._regions.push(e), e;
  }
  static disposeRegion(e) {
    e.dispose();
    const t = this._regions.indexOf(e);
    t > -1 && this._regions.splice(t, 1);
  }
  add(e) {
    this._items.push(e);
  }
  remove(e) {
    for (let t = 0; t < this._items.length; t++)
      this._items[t].group === e && (this._items.splice(t, 1), t--);
  }
  enable() {
    for (const e of pn._regions)
      e._enabled = !1;
    this._enabled = !0;
  }
  disable() {
    this._enabled = !1;
  }
  dispose() {
    this._target.removeEventListener("keydown", this._events.down), this._target.removeEventListener("keyup", this._events.up);
  }
  _down(e) {
    !this._enabled || document.activeElement && (document.activeElement.tagName === "INPUT" || document.activeElement.tagName === "TEXTAREA") || (this._evaluate(e, "down"), this.onKeyDown.emit(e));
  }
  _up(e) {
    !this._enabled || document.activeElement && (document.activeElement.tagName === "INPUT" || document.activeElement.tagName === "TEXTAREA") || this._evaluate(e, "up");
  }
  _evaluate(e, t) {
    for (let i = 0; i < this._items.length; i++) {
      const n = this._items[i];
      n.options.type === t && (!this._test(e, n) || n.action.call(null, e));
    }
  }
  _test(e, t) {
    return t.key === e.key;
  }
};
let ti = pn;
j(ti, "_regions", []);
class Us {
  constructor(e) {
    j(this, "_onChange", new ge());
    j(this, "_data");
    this._data = e;
  }
  get onChange() {
    return this._onChange;
  }
  get data() {
    return this._data;
  }
  update(e) {
    this._data = e, this._onChange.emit(e);
  }
}
class Df extends Us {
  constructor(t, i) {
    super(t.data.groups[i]);
    j(this, "groupId");
    j(this, "content");
    this.groupId = i, this.content = t, this.content.onChange.add(this, (n) => {
      this.update(n.groups[i]);
    });
  }
  get videoIds() {
    return this.data.videoIds;
  }
  get videoTracks() {
    return this.videoIds.map((t) => this.content.getVideoTrack(t));
  }
  getSources(t) {
    return this.getSourceIds(t).map((i) => ({ sourceId: i, source: this.content.getSource(i) }));
  }
  getSourceIds(t) {
    const i = [], n = this.videoTracks.map((s) => s.data);
    return (t === "tiled" || t === "both") && i.push(...n.map((s) => s.regions.map((o) => o.tiled)).flat().flat().filter((s) => !!s)), (t === "single" || t === "both") && i.push(...n.map((s) => s.regions.map((o) => o.single)).flat().flat().filter((s) => !!s)), Array.from(new Set(i.map((s) => s.sourceId)));
  }
}
class If extends Us {
  constructor(t, i) {
    super(t.data.videos[i]);
    j(this, "trackId");
    j(this, "content");
    this.trackId = i, this.content = t, this.data.regions.forEach((n) => {
      n.startTime || (n.startTime = 0), n.duration || (n.duration = -1);
    }), this.content.onChange.add(this, (n) => {
      this.update(n.videos[i]);
    });
  }
  getRegionAt(t) {
    var i;
    return (i = this.data.regions.find((n) => n.startTime <= t && (t < n.startTime + n.duration || n.duration === -1))) != null ? i : null;
  }
  getAllRegions() {
    return [...this.data.regions];
  }
}
class Of extends Us {
  constructor(t) {
    super(t);
    j(this, "tracks", {});
    for (const i of this.data.transforms)
      i.uuid || (i.uuid = ks());
  }
  get groupCount() {
    return this.data.groups.length;
  }
  get defaultGroupId() {
    var t;
    return (t = this.data.groups.findIndex((i) => i.isDefault)) != null ? t : 0;
  }
  get sources() {
    var t;
    return (t = this.data.sources) != null ? t : [];
  }
  get videoTracks() {
    var t;
    return (t = this.data.videos) != null ? t : [];
  }
  get audioTracks() {
    var t;
    return (t = this.data.audios) != null ? t : [];
  }
  updateCaptions(t) {
    this.data.closedCaptions = t, this.update(this.data);
  }
  getGroup(t) {
    if (!this.data.groups[t])
      throw new Error(`Group: ${t} is not exists.`);
    return new Df(this, t);
  }
  hasGroup(t) {
    return !!this.data.groups[t];
  }
  getSource(t) {
    if (!this.data.sources[t])
      throw new Error(`Source: ${t} is not exists.`);
    return this.data.sources[t];
  }
  getVideoTrack(t) {
    if (!this.data.videos[t])
      throw new Error(`VideoTrack: ${t} is not exists.`);
    return t in this.tracks || (this.tracks[t] = new If(this, t)), this.tracks[t];
  }
  getAudioTrack(t) {
    if (!this.data.audios[t])
      throw new Error(`AudioTrack: ${t} is not exists.`);
    return this.data.audios[t];
  }
  getTransform(t) {
    if (!this.data.transforms[t])
      throw new Error(`TransformSet: ${t} is not exists.`);
    return this.data.transforms[t];
  }
}
var rl = { exports: {} };
(function(r, e) {
  typeof window < "u" && function(i, n) {
    r.exports = n();
  }(Xo, () => (() => {
    var t = {
      "./src/config.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          enableStreamingMode: () => C,
          hlsDefaultConfig: () => _,
          mergeConfig: () => h
        });
        var b = a("./src/controller/abr-controller.ts"), y = a("./src/controller/audio-stream-controller.ts"), N = a("./src/controller/audio-track-controller.ts"), E = a("./src/controller/subtitle-stream-controller.ts"), B = a("./src/controller/subtitle-track-controller.ts"), I = a("./src/controller/buffer-controller.ts"), T = a("./src/controller/timeline-controller.ts"), A = a("./src/controller/cap-level-controller.ts"), w = a("./src/controller/fps-controller.ts"), O = a("./src/controller/eme-controller.ts"), u = a("./src/controller/cmcd-controller.ts"), M = a("./src/utils/xhr-loader.ts"), d = a("./src/utils/fetch-loader.ts"), c = a("./src/utils/cues.ts"), v = a("./src/utils/mediakeys-helper.ts"), g = a("./src/utils/logger.ts");
        function m() {
          return m = Object.assign ? Object.assign.bind() : function(f) {
            for (var P = 1; P < arguments.length; P++) {
              var F = arguments[P];
              for (var R in F)
                Object.prototype.hasOwnProperty.call(F, R) && (f[R] = F[R]);
            }
            return f;
          }, m.apply(this, arguments);
        }
        function D(f, P) {
          var F = Object.keys(f);
          if (Object.getOwnPropertySymbols) {
            var R = Object.getOwnPropertySymbols(f);
            P && (R = R.filter(function(U) {
              return Object.getOwnPropertyDescriptor(f, U).enumerable;
            })), F.push.apply(F, R);
          }
          return F;
        }
        function L(f) {
          for (var P = 1; P < arguments.length; P++) {
            var F = arguments[P] != null ? arguments[P] : {};
            P % 2 ? D(Object(F), !0).forEach(function(R) {
              p(f, R, F[R]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(f, Object.getOwnPropertyDescriptors(F)) : D(Object(F)).forEach(function(R) {
              Object.defineProperty(f, R, Object.getOwnPropertyDescriptor(F, R));
            });
          }
          return f;
        }
        function p(f, P, F) {
          return P = x(P), P in f ? Object.defineProperty(f, P, { value: F, enumerable: !0, configurable: !0, writable: !0 }) : f[P] = F, f;
        }
        function x(f) {
          var P = k(f, "string");
          return typeof P == "symbol" ? P : String(P);
        }
        function k(f, P) {
          if (typeof f != "object" || f === null)
            return f;
          var F = f[Symbol.toPrimitive];
          if (F !== void 0) {
            var R = F.call(f, P || "default");
            if (typeof R != "object")
              return R;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (P === "string" ? String : Number)(f);
        }
        var _ = L(L({
          autoStartLoad: !0,
          startPosition: -1,
          defaultAudioCodec: void 0,
          debug: !1,
          capLevelOnFPSDrop: !1,
          capLevelToPlayerSize: !1,
          ignoreDevicePixelRatio: !1,
          initialLiveManifestSize: 1,
          maxBufferLength: 30,
          backBufferLength: 1 / 0,
          maxBufferSize: 60 * 1e3 * 1e3,
          maxBufferHole: 0.1,
          highBufferWatchdogPeriod: 2,
          nudgeOffset: 0.1,
          nudgeMaxRetry: 3,
          maxFragLookUpTolerance: 0.25,
          liveSyncDurationCount: 3,
          liveMaxLatencyDurationCount: 1 / 0,
          liveSyncDuration: void 0,
          liveMaxLatencyDuration: void 0,
          maxLiveSyncPlaybackRate: 1,
          liveDurationInfinity: !1,
          liveBackBufferLength: null,
          maxMaxBufferLength: 600,
          enableWorker: !0,
          enableSoftwareAES: !0,
          manifestLoadingTimeOut: 1e4,
          manifestLoadingMaxRetry: 1,
          manifestLoadingRetryDelay: 1e3,
          manifestLoadingMaxRetryTimeout: 64e3,
          startLevel: void 0,
          levelLoadingTimeOut: 1e4,
          levelLoadingMaxRetry: 4,
          levelLoadingRetryDelay: 1e3,
          levelLoadingMaxRetryTimeout: 64e3,
          fragLoadingTimeOut: 2e4,
          fragLoadingMaxRetry: 6,
          fragLoadingRetryDelay: 1e3,
          fragLoadingMaxRetryTimeout: 64e3,
          startFragPrefetch: !1,
          fpsDroppedMonitoringPeriod: 5e3,
          fpsDroppedMonitoringThreshold: 0.2,
          appendErrorMaxRetry: 3,
          loader: M.default,
          fLoader: void 0,
          pLoader: void 0,
          xhrSetup: void 0,
          licenseXhrSetup: void 0,
          licenseResponseCallback: void 0,
          abrController: b.default,
          bufferController: I.default,
          capLevelController: A.default,
          fpsController: w.default,
          stretchShortVideoTrack: !1,
          maxAudioFramesDrift: 1,
          forceKeyFrameOnDiscontinuity: !0,
          abrEwmaFastLive: 3,
          abrEwmaSlowLive: 9,
          abrEwmaFastVoD: 3,
          abrEwmaSlowVoD: 9,
          abrEwmaDefaultEstimate: 5e5,
          abrBandWidthFactor: 0.95,
          abrBandWidthUpFactor: 0.7,
          abrMaxWithRealBitrate: !1,
          maxStarvationDelay: 4,
          maxLoadingDelay: 4,
          minAutoBitrate: 0,
          emeEnabled: !1,
          widevineLicenseUrl: void 0,
          drmSystems: {},
          drmSystemOptions: {},
          requestMediaKeySystemAccessFunc: v.requestMediaKeySystemAccess,
          testBandwidth: !0,
          progressive: !1,
          lowLatencyMode: !0,
          cmcd: void 0,
          enableDateRangeMetadataCues: !0,
          enableEmsgMetadataCues: !0,
          enableID3MetadataCues: !0
        }, S()), {}, {
          subtitleStreamController: E.SubtitleStreamController,
          subtitleTrackController: B.default,
          timelineController: T.TimelineController,
          audioStreamController: y.default,
          audioTrackController: N.default,
          emeController: O.default,
          cmcdController: u.default
        });
        function S() {
          return {
            cueHandler: c.default,
            enableWebVTT: !0,
            enableIMSC1: !0,
            enableCEA708Captions: !0,
            captionsTextTrack1Label: "English",
            captionsTextTrack1LanguageCode: "en",
            captionsTextTrack2Label: "Spanish",
            captionsTextTrack2LanguageCode: "es",
            captionsTextTrack3Label: "Unknown CC",
            captionsTextTrack3LanguageCode: "",
            captionsTextTrack4Label: "Unknown CC",
            captionsTextTrack4LanguageCode: "",
            renderTextTracksNatively: !0
          };
        }
        function h(f, P) {
          if ((P.liveSyncDurationCount || P.liveMaxLatencyDurationCount) && (P.liveSyncDuration || P.liveMaxLatencyDuration))
            throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
          if (P.liveMaxLatencyDurationCount !== void 0 && (P.liveSyncDurationCount === void 0 || P.liveMaxLatencyDurationCount <= P.liveSyncDurationCount))
            throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
          if (P.liveMaxLatencyDuration !== void 0 && (P.liveSyncDuration === void 0 || P.liveMaxLatencyDuration <= P.liveSyncDuration))
            throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
          return m({}, f, P);
        }
        function C(f) {
          var P = f.loader;
          if (P !== d.default && P !== M.default)
            g.logger.log("[config]: Custom loader detected, cannot enable progressive streaming"), f.progressive = !1;
          else {
            var F = (0, d.fetchSupported)();
            F && (f.loader = d.default, f.progressive = !0, f.enableSoftwareAES = !0, g.logger.log("[config]: Progressive streaming enabled, using FetchLoader"));
          }
        }
      },
      "./src/controller/abr-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => M
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/utils/ewma-bandwidth-estimator.ts"), N = a("./src/events.ts"), E = a("./src/errors.ts"), B = a("./src/types/loader.ts"), I = a("./src/utils/logger.ts");
        function T(d, c) {
          for (var v = 0; v < c.length; v++) {
            var g = c[v];
            g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(d, w(g.key), g);
          }
        }
        function A(d, c, v) {
          return c && T(d.prototype, c), v && T(d, v), Object.defineProperty(d, "prototype", { writable: !1 }), d;
        }
        function w(d) {
          var c = O(d, "string");
          return typeof c == "symbol" ? c : String(c);
        }
        function O(d, c) {
          if (typeof d != "object" || d === null)
            return d;
          var v = d[Symbol.toPrimitive];
          if (v !== void 0) {
            var g = v.call(d, c || "default");
            if (typeof g != "object")
              return g;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (c === "string" ? String : Number)(d);
        }
        var u = /* @__PURE__ */ function() {
          function d(v) {
            this.hls = void 0, this.lastLoadedFragLevel = 0, this._nextAutoLevel = -1, this.timer = void 0, this.onCheck = this._abandonRulesCheck.bind(this), this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.bwEstimator = void 0, this.hls = v;
            var g = v.config;
            this.bwEstimator = new y.default(g.abrEwmaSlowVoD, g.abrEwmaFastVoD, g.abrEwmaDefaultEstimate), this.registerListeners();
          }
          var c = d.prototype;
          return c.registerListeners = function() {
            var g = this.hls;
            g.on(N.Events.FRAG_LOADING, this.onFragLoading, this), g.on(N.Events.FRAG_LOADED, this.onFragLoaded, this), g.on(N.Events.FRAG_BUFFERED, this.onFragBuffered, this), g.on(N.Events.LEVEL_LOADED, this.onLevelLoaded, this), g.on(N.Events.ERROR, this.onError, this);
          }, c.unregisterListeners = function() {
            var g = this.hls;
            g.off(N.Events.FRAG_LOADING, this.onFragLoading, this), g.off(N.Events.FRAG_LOADED, this.onFragLoaded, this), g.off(N.Events.FRAG_BUFFERED, this.onFragBuffered, this), g.off(N.Events.LEVEL_LOADED, this.onLevelLoaded, this), g.off(N.Events.ERROR, this.onError, this);
          }, c.destroy = function() {
            this.unregisterListeners(), this.clearTimer(), this.hls = this.onCheck = null, this.fragCurrent = this.partCurrent = null;
          }, c.onFragLoading = function(g, m) {
            var D = m.frag;
            if (D.type === B.PlaylistLevelType.MAIN && !this.timer) {
              var L;
              this.fragCurrent = D, this.partCurrent = (L = m.part) != null ? L : null, this.timer = self.setInterval(this.onCheck, 100);
            }
          }, c.onLevelLoaded = function(g, m) {
            var D = this.hls.config;
            m.details.live ? this.bwEstimator.update(D.abrEwmaSlowLive, D.abrEwmaFastLive) : this.bwEstimator.update(D.abrEwmaSlowVoD, D.abrEwmaFastVoD);
          }, c._abandonRulesCheck = function() {
            var g = this.fragCurrent, m = this.partCurrent, D = this.hls, L = D.autoLevelEnabled, p = D.media;
            if (!(!g || !p)) {
              var x = m ? m.stats : g.stats, k = m ? m.duration : g.duration;
              if (x.aborted || x.loaded && x.loaded === x.total || g.level === 0) {
                this.clearTimer(), this._nextAutoLevel = -1;
                return;
              }
              if (!(!L || p.paused || !p.playbackRate || !p.readyState)) {
                var _ = D.mainForwardBufferInfo;
                if (_ !== null) {
                  var S = performance.now() - x.loading.start, h = Math.abs(p.playbackRate);
                  if (!(S <= 500 * k / h)) {
                    var C = x.loaded && x.loading.first, f = this.bwEstimator.getEstimate(), P = D.levels, F = D.minAutoLevel, R = P[g.level], U = x.total || Math.max(x.loaded, Math.round(k * R.maxBitrate / 8)), K = C ? x.loaded * 1e3 / S : 0, V = K ? (U - x.loaded) / K : U * 8 / f, W = _.len / h;
                    if (!(V <= W)) {
                      var G = Number.POSITIVE_INFINITY, H;
                      for (H = g.level - 1; H > F; H--) {
                        var $ = P[H].maxBitrate;
                        if (G = K ? k * $ / (8 * 0.8 * K) : k * $ / f, G < W)
                          break;
                      }
                      G >= V || (I.logger.warn("Fragment " + g.sn + (m ? " part " + m.index : "") + " of level " + g.level + " is loading too slowly and will cause an underbuffer; aborting and switching to level " + H + `
      Current BW estimate: ` + ((0, b.isFiniteNumber)(f) ? (f / 1024).toFixed(3) : "Unknown") + ` Kb/s
      Estimated load time for current fragment: ` + V.toFixed(3) + ` s
      Estimated load time for the next fragment: ` + G.toFixed(3) + ` s
      Time to underbuffer: ` + W.toFixed(3) + " s"), D.nextLoadLevel = H, C && this.bwEstimator.sample(S, x.loaded), this.clearTimer(), (g.loader || g.keyLoader) && (this.fragCurrent = this.partCurrent = null, g.abortRequests()), D.trigger(N.Events.FRAG_LOAD_EMERGENCY_ABORTED, {
                        frag: g,
                        part: m,
                        stats: x
                      }));
                    }
                  }
                }
              }
            }
          }, c.onFragLoaded = function(g, m) {
            var D = m.frag, L = m.part;
            if (D.type === B.PlaylistLevelType.MAIN && (0, b.isFiniteNumber)(D.sn)) {
              var p = L ? L.stats : D.stats, x = L ? L.duration : D.duration;
              if (this.clearTimer(), this.lastLoadedFragLevel = D.level, this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
                var k = this.hls.levels[D.level], _ = (k.loaded ? k.loaded.bytes : 0) + p.loaded, S = (k.loaded ? k.loaded.duration : 0) + x;
                k.loaded = {
                  bytes: _,
                  duration: S
                }, k.realBitrate = Math.round(8 * _ / S);
              }
              if (D.bitrateTest) {
                var h = {
                  stats: p,
                  frag: D,
                  part: L,
                  id: D.type
                };
                this.onFragBuffered(N.Events.FRAG_BUFFERED, h);
              }
            }
          }, c.onFragBuffered = function(g, m) {
            var D = m.frag, L = m.part, p = L ? L.stats : D.stats;
            if (!p.aborted && !(D.type !== B.PlaylistLevelType.MAIN || D.sn === "initSegment")) {
              var x = p.parsing.end - p.loading.start;
              this.bwEstimator.sample(x, p.loaded), p.bwEstimate = this.bwEstimator.getEstimate(), D.bitrateTest ? this.bitrateTestDelay = x / 1e3 : this.bitrateTestDelay = 0;
            }
          }, c.onError = function(g, m) {
            var D;
            if (((D = m.frag) === null || D === void 0 ? void 0 : D.type) === B.PlaylistLevelType.MAIN) {
              if (m.type === E.ErrorTypes.KEY_SYSTEM_ERROR) {
                this.clearTimer();
                return;
              }
              switch (m.details) {
                case E.ErrorDetails.FRAG_LOAD_ERROR:
                case E.ErrorDetails.FRAG_LOAD_TIMEOUT:
                case E.ErrorDetails.KEY_LOAD_ERROR:
                case E.ErrorDetails.KEY_LOAD_TIMEOUT:
                  this.clearTimer();
                  break;
              }
            }
          }, c.clearTimer = function() {
            self.clearInterval(this.timer), this.timer = void 0;
          }, c.getNextABRAutoLevel = function() {
            var g = this.fragCurrent, m = this.partCurrent, D = this.hls, L = D.maxAutoLevel, p = D.config, x = D.minAutoLevel, k = D.media, _ = m ? m.duration : g ? g.duration : 0, S = k && k.playbackRate !== 0 ? Math.abs(k.playbackRate) : 1, h = this.bwEstimator ? this.bwEstimator.getEstimate() : p.abrEwmaDefaultEstimate, C = D.mainForwardBufferInfo, f = (C ? C.len : 0) / S, P = this.findBestLevel(h, x, L, f, p.abrBandWidthFactor, p.abrBandWidthUpFactor);
            if (P >= 0)
              return P;
            I.logger.trace((f ? "rebuffering expected" : "buffer is empty") + ", finding optimal quality level");
            var F = _ ? Math.min(_, p.maxStarvationDelay) : p.maxStarvationDelay, R = p.abrBandWidthFactor, U = p.abrBandWidthUpFactor;
            if (!f) {
              var K = this.bitrateTestDelay;
              if (K) {
                var V = _ ? Math.min(_, p.maxLoadingDelay) : p.maxLoadingDelay;
                F = V - K, I.logger.trace("bitrate test took " + Math.round(1e3 * K) + "ms, set first fragment max fetchDuration to " + Math.round(1e3 * F) + " ms"), R = U = 1;
              }
            }
            return P = this.findBestLevel(h, x, L, f + F, R, U), Math.max(P, 0);
          }, c.findBestLevel = function(g, m, D, L, p, x) {
            for (var k, _ = this.fragCurrent, S = this.partCurrent, h = this.lastLoadedFragLevel, C = this.hls.levels, f = C[h], P = !!(f != null && (k = f.details) !== null && k !== void 0 && k.live), F = f == null ? void 0 : f.codecSet, R = S ? S.duration : _ ? _.duration : 0, U = D; U >= m; U--) {
              var K = C[U];
              if (!(!K || F && K.codecSet !== F)) {
                var V = K.details, W = (S ? V == null ? void 0 : V.partTarget : V == null ? void 0 : V.averagetargetduration) || R, G = void 0;
                U <= h ? G = p * g : G = x * g;
                var H = C[U].maxBitrate, $ = H * W / G;
                if (I.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + U + "/" + Math.round(G) + "/" + H + "/" + W + "/" + L + "/" + $), G > H && ($ === 0 || !(0, b.isFiniteNumber)($) || P && !this.bitrateTestDelay || $ < L))
                  return U;
              }
            }
            return -1;
          }, A(d, [{
            key: "nextAutoLevel",
            get: function() {
              var g = this._nextAutoLevel, m = this.bwEstimator;
              if (g !== -1 && !m.canEstimate())
                return g;
              var D = this.getNextABRAutoLevel();
              return g !== -1 && this.hls.levels[D].loadError ? g : (g !== -1 && (D = Math.min(g, D)), D);
            },
            set: function(g) {
              this._nextAutoLevel = g;
            }
          }]), d;
        }();
        const M = u;
      },
      "./src/controller/audio-stream-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => p
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/controller/base-stream-controller.ts"), N = a("./src/events.ts"), E = a("./src/utils/buffer-helper.ts"), B = a("./src/controller/fragment-tracker.ts"), I = a("./src/types/level.ts"), T = a("./src/types/loader.ts"), A = a("./src/loader/fragment.ts"), w = a("./src/demux/chunk-cache.ts"), O = a("./src/demux/transmuxer-interface.ts"), u = a("./src/types/transmuxer.ts"), M = a("./src/controller/fragment-finders.ts"), d = a("./src/utils/discontinuities.ts"), c = a("./src/errors.ts");
        function v() {
          return v = Object.assign ? Object.assign.bind() : function(x) {
            for (var k = 1; k < arguments.length; k++) {
              var _ = arguments[k];
              for (var S in _)
                Object.prototype.hasOwnProperty.call(_, S) && (x[S] = _[S]);
            }
            return x;
          }, v.apply(this, arguments);
        }
        function g(x, k) {
          x.prototype = Object.create(k.prototype), x.prototype.constructor = x, m(x, k);
        }
        function m(x, k) {
          return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(S, h) {
            return S.__proto__ = h, S;
          }, m(x, k);
        }
        var D = 100, L = /* @__PURE__ */ function(x) {
          g(k, x);
          function k(S, h, C) {
            var f;
            return f = x.call(this, S, h, C, "[audio-stream-controller]") || this, f.videoBuffer = null, f.videoTrackCC = -1, f.waitingVideoCC = -1, f.audioSwitch = !1, f.trackId = -1, f.waitingData = null, f.mainDetails = null, f.bufferFlushed = !1, f.cachedTrackLoadedData = null, f._registerListeners(), f;
          }
          var _ = k.prototype;
          return _.onHandlerDestroying = function() {
            this._unregisterListeners(), this.mainDetails = null;
          }, _._registerListeners = function() {
            var h = this.hls;
            h.on(N.Events.MEDIA_ATTACHED, this.onMediaAttached, this), h.on(N.Events.MEDIA_DETACHING, this.onMediaDetaching, this), h.on(N.Events.MANIFEST_LOADING, this.onManifestLoading, this), h.on(N.Events.LEVEL_LOADED, this.onLevelLoaded, this), h.on(N.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), h.on(N.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), h.on(N.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), h.on(N.Events.ERROR, this.onError, this), h.on(N.Events.BUFFER_RESET, this.onBufferReset, this), h.on(N.Events.BUFFER_CREATED, this.onBufferCreated, this), h.on(N.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), h.on(N.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), h.on(N.Events.FRAG_BUFFERED, this.onFragBuffered, this);
          }, _._unregisterListeners = function() {
            var h = this.hls;
            h.off(N.Events.MEDIA_ATTACHED, this.onMediaAttached, this), h.off(N.Events.MEDIA_DETACHING, this.onMediaDetaching, this), h.off(N.Events.MANIFEST_LOADING, this.onManifestLoading, this), h.off(N.Events.LEVEL_LOADED, this.onLevelLoaded, this), h.off(N.Events.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), h.off(N.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), h.off(N.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), h.off(N.Events.ERROR, this.onError, this), h.off(N.Events.BUFFER_RESET, this.onBufferReset, this), h.off(N.Events.BUFFER_CREATED, this.onBufferCreated, this), h.off(N.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), h.off(N.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), h.off(N.Events.FRAG_BUFFERED, this.onFragBuffered, this);
          }, _.onInitPtsFound = function(h, C) {
            var f = C.frag, P = C.id, F = C.initPTS;
            if (P === "main") {
              var R = f.cc;
              this.initPTS[f.cc] = F, this.log("InitPTS for cc: " + R + " found from main: " + F), this.videoTrackCC = R, this.state === y.State.WAITING_INIT_PTS && this.tick();
            }
          }, _.startLoad = function(h) {
            if (!this.levels) {
              this.startPosition = h, this.state = y.State.STOPPED;
              return;
            }
            var C = this.lastCurrentTime;
            this.stopLoad(), this.setInterval(D), this.fragLoadError = 0, C > 0 && h === -1 ? (this.log("Override startPosition with lastCurrentTime @" + C.toFixed(3)), h = C, this.state = y.State.IDLE) : (this.loadedmetadata = !1, this.state = y.State.WAITING_TRACK), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = h, this.tick();
          }, _.doTick = function() {
            switch (this.state) {
              case y.State.IDLE:
                this.doTickIdle();
                break;
              case y.State.WAITING_TRACK: {
                var h, C = this.levels, f = this.trackId, P = C == null || (h = C[f]) === null || h === void 0 ? void 0 : h.details;
                if (P) {
                  if (this.waitForCdnTuneIn(P))
                    break;
                  this.state = y.State.WAITING_INIT_PTS;
                }
                break;
              }
              case y.State.FRAG_LOADING_WAITING_RETRY: {
                var F, R = performance.now(), U = this.retryDate;
                (!U || R >= U || (F = this.media) !== null && F !== void 0 && F.seeking) && (this.log("RetryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded(this.trackId), this.state = y.State.IDLE);
                break;
              }
              case y.State.WAITING_INIT_PTS: {
                var K = this.waitingData;
                if (K) {
                  var V = K.frag, W = K.part, G = K.cache, H = K.complete;
                  if (this.initPTS[V.cc] !== void 0) {
                    this.waitingData = null, this.waitingVideoCC = -1, this.state = y.State.FRAG_LOADING;
                    var $ = G.flush(), Y = {
                      frag: V,
                      part: W,
                      payload: $,
                      networkDetails: null
                    };
                    this._handleFragmentLoadProgress(Y), H && x.prototype._handleFragmentLoadComplete.call(this, Y);
                  } else if (this.videoTrackCC !== this.waitingVideoCC)
                    this.log("Waiting fragment cc (" + V.cc + ") cancelled because video is at cc " + this.videoTrackCC), this.clearWaitingFragment();
                  else {
                    var z = this.getLoadPosition(), X = E.BufferHelper.bufferInfo(this.mediaBuffer, z, this.config.maxBufferHole), Q = (0, M.fragmentWithinToleranceTest)(X.end, this.config.maxFragLookUpTolerance, V);
                    Q < 0 && (this.log("Waiting fragment cc (" + V.cc + ") @ " + V.start + " cancelled because another fragment at " + X.end + " is needed"), this.clearWaitingFragment());
                  }
                } else
                  this.state = y.State.IDLE;
              }
            }
            this.onTickEnd();
          }, _.clearWaitingFragment = function() {
            var h = this.waitingData;
            h && (this.fragmentTracker.removeFragment(h.frag), this.waitingData = null, this.waitingVideoCC = -1, this.state = y.State.IDLE);
          }, _.resetLoadingState = function() {
            this.clearWaitingFragment(), x.prototype.resetLoadingState.call(this);
          }, _.onTickEnd = function() {
            var h = this.media;
            !h || !h.readyState || (this.lastCurrentTime = h.currentTime);
          }, _.doTickIdle = function() {
            var h = this.hls, C = this.levels, f = this.media, P = this.trackId, F = h.config;
            if (!(!C || !C[P]) && !(!f && (this.startFragRequested || !F.startFragPrefetch))) {
              var R = C[P], U = R.details;
              if (!U || U.live && this.levelLastLoaded !== P || this.waitForCdnTuneIn(U)) {
                this.state = y.State.WAITING_TRACK;
                return;
              }
              var K = this.mediaBuffer ? this.mediaBuffer : this.media;
              this.bufferFlushed && K && (this.bufferFlushed = !1, this.afterBufferFlushed(K, A.ElementaryStreamTypes.AUDIO, T.PlaylistLevelType.AUDIO));
              var V = this.getFwdBufferInfo(K, T.PlaylistLevelType.AUDIO);
              if (V !== null) {
                var W = this.audioSwitch;
                if (!W && this._streamEnded(V, U)) {
                  h.trigger(N.Events.BUFFER_EOS, {
                    type: "audio"
                  }), this.state = y.State.ENDED;
                  return;
                }
                var G = this.getFwdBufferInfo(this.videoBuffer ? this.videoBuffer : this.media, T.PlaylistLevelType.MAIN), H = V.len, $ = this.getMaxBufferLength(G == null ? void 0 : G.len);
                if (!(H >= $ && !W)) {
                  var Y = U.fragments, z = Y[0].start, X = V.end;
                  if (W && f) {
                    var Q = this.getLoadPosition();
                    X = Q, U.PTSKnown && Q < z && (V.end > z || V.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), f.currentTime = z + 0.05);
                  }
                  if (!(G && X > G.end + U.targetduration) && !((!G || !G.len) && V.len)) {
                    var q = this.getNextFragment(X, U);
                    if (!q) {
                      this.bufferFlushed = !0;
                      return;
                    }
                    this.loadFragment(q, U, X);
                  }
                }
              }
            }
          }, _.getMaxBufferLength = function(h) {
            var C = x.prototype.getMaxBufferLength.call(this);
            return h ? Math.max(C, h) : C;
          }, _.onMediaDetaching = function() {
            this.videoBuffer = null, x.prototype.onMediaDetaching.call(this);
          }, _.onAudioTracksUpdated = function(h, C) {
            var f = C.audioTracks;
            this.resetTransmuxer(), this.levels = f.map(function(P) {
              return new I.Level(P);
            });
          }, _.onAudioTrackSwitching = function(h, C) {
            var f = !!C.url;
            this.trackId = C.id;
            var P = this.fragCurrent;
            P && P.abortRequests(), this.fragCurrent = null, this.clearWaitingFragment(), f ? this.setInterval(D) : this.resetTransmuxer(), f ? (this.audioSwitch = !0, this.state = y.State.IDLE) : this.state = y.State.STOPPED, this.tick();
          }, _.onManifestLoading = function() {
            this.mainDetails = null, this.fragmentTracker.removeAllFragments(), this.startPosition = this.lastCurrentTime = 0, this.bufferFlushed = !1;
          }, _.onLevelLoaded = function(h, C) {
            this.mainDetails = C.details, this.cachedTrackLoadedData !== null && (this.hls.trigger(N.Events.AUDIO_TRACK_LOADED, this.cachedTrackLoadedData), this.cachedTrackLoadedData = null);
          }, _.onAudioTrackLoaded = function(h, C) {
            var f;
            if (this.mainDetails == null) {
              this.cachedTrackLoadedData = C;
              return;
            }
            var P = this.levels, F = C.details, R = C.id;
            if (!P) {
              this.warn("Audio tracks were reset while loading level " + R);
              return;
            }
            this.log("Track " + R + " loaded [" + F.startSN + "," + F.endSN + "],duration:" + F.totalduration);
            var U = P[R], K = 0;
            if (F.live || (f = U.details) !== null && f !== void 0 && f.live) {
              var V = this.mainDetails;
              if (F.fragments[0] || (F.deltaUpdateFailed = !0), F.deltaUpdateFailed || !V)
                return;
              !U.details && F.hasProgramDateTime && V.hasProgramDateTime ? ((0, d.alignMediaPlaylistByPDT)(F, V), K = F.fragments[0].start) : K = this.alignPlaylists(F, U.details);
            }
            U.details = F, this.levelLastLoaded = R, !this.startFragRequested && (this.mainDetails || !F.live) && this.setStartPosition(U.details, K), this.state === y.State.WAITING_TRACK && !this.waitForCdnTuneIn(F) && (this.state = y.State.IDLE), this.tick();
          }, _._handleFragmentLoadProgress = function(h) {
            var C, f = h.frag, P = h.part, F = h.payload, R = this.config, U = this.trackId, K = this.levels;
            if (!K) {
              this.warn("Audio tracks were reset while fragment load was in progress. Fragment " + f.sn + " of level " + f.level + " will not be buffered");
              return;
            }
            var V = K[U];
            console.assert(V, "Audio track is defined on fragment load progress");
            var W = V.details;
            console.assert(W, "Audio track details are defined on fragment load progress");
            var G = R.defaultAudioCodec || V.audioCodec || "mp4a.40.2", H = this.transmuxer;
            H || (H = this.transmuxer = new O.default(this.hls, T.PlaylistLevelType.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
            var $ = this.initPTS[f.cc], Y = (C = f.initSegment) === null || C === void 0 ? void 0 : C.data;
            if ($ !== void 0) {
              var z = !1, X = P ? P.index : -1, Q = X !== -1, q = new u.ChunkMetadata(f.level, f.sn, f.stats.chunkCount, F.byteLength, X, Q);
              H.push(F, Y, G, "", f, P, W.totalduration, z, q, $);
            } else {
              this.log("Unknown video PTS for cc " + f.cc + ", waiting for video PTS before demuxing audio frag " + f.sn + " of [" + W.startSN + " ," + W.endSN + "],track " + U);
              var Z = this.waitingData = this.waitingData || {
                frag: f,
                part: P,
                cache: new w.default(),
                complete: !1
              }, J = Z.cache;
              J.push(new Uint8Array(F)), this.waitingVideoCC = this.videoTrackCC, this.state = y.State.WAITING_INIT_PTS;
            }
          }, _._handleFragmentLoadComplete = function(h) {
            if (this.waitingData) {
              this.waitingData.complete = !0;
              return;
            }
            x.prototype._handleFragmentLoadComplete.call(this, h);
          }, _.onBufferReset = function() {
            this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
          }, _.onBufferCreated = function(h, C) {
            var f = C.tracks.audio;
            f && (this.mediaBuffer = f.buffer || null), C.tracks.video && (this.videoBuffer = C.tracks.video.buffer || null);
          }, _.onFragBuffered = function(h, C) {
            var f = C.frag, P = C.part;
            if (f.type !== T.PlaylistLevelType.AUDIO) {
              if (!this.loadedmetadata && f.type === T.PlaylistLevelType.MAIN) {
                var F;
                (F = this.videoBuffer || this.media) !== null && F !== void 0 && F.buffered.length && (this.loadedmetadata = !0);
              }
              return;
            }
            if (this.fragContextChanged(f)) {
              this.warn("Fragment " + f.sn + (P ? " p: " + P.index : "") + " of level " + f.level + " finished buffering, but was aborted. state: " + this.state + ", audioSwitch: " + this.audioSwitch);
              return;
            }
            f.sn !== "initSegment" && (this.fragPrevious = f, this.audioSwitch && (this.audioSwitch = !1, this.hls.trigger(N.Events.AUDIO_TRACK_SWITCHED, {
              id: this.trackId
            }))), this.fragBufferedComplete(f, P);
          }, _.onError = function(h, C) {
            if (C.type === c.ErrorTypes.KEY_SYSTEM_ERROR) {
              this.onFragmentOrKeyLoadError(T.PlaylistLevelType.AUDIO, C);
              return;
            }
            switch (C.details) {
              case c.ErrorDetails.FRAG_LOAD_ERROR:
              case c.ErrorDetails.FRAG_LOAD_TIMEOUT:
              case c.ErrorDetails.FRAG_PARSING_ERROR:
              case c.ErrorDetails.KEY_LOAD_ERROR:
              case c.ErrorDetails.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError(T.PlaylistLevelType.AUDIO, C);
                break;
              case c.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
              case c.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                this.state !== y.State.ERROR && this.state !== y.State.STOPPED && (this.state = C.fatal ? y.State.ERROR : y.State.IDLE, this.warn(C.details + " while loading frag, switching to " + this.state + " state"));
                break;
              case c.ErrorDetails.BUFFER_FULL_ERROR:
                if (C.parent === "audio" && (this.state === y.State.PARSING || this.state === y.State.PARSED)) {
                  var f = !0, P = this.getFwdBufferInfo(this.mediaBuffer, T.PlaylistLevelType.AUDIO);
                  P && P.len > 0.5 && (f = !this.reduceMaxBufferLength(P.len)), f && (this.warn("Buffer full error also media.currentTime is not buffered, flush audio buffer"), this.fragCurrent = null, x.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, "audio")), this.resetLoadingState();
                }
                break;
            }
          }, _.onBufferFlushed = function(h, C) {
            var f = C.type;
            f === A.ElementaryStreamTypes.AUDIO && (this.bufferFlushed = !0, this.state === y.State.ENDED && (this.state = y.State.IDLE));
          }, _._handleTransmuxComplete = function(h) {
            var C, f = "audio", P = this.hls, F = h.remuxResult, R = h.chunkMeta, U = this.getCurrentContext(R);
            if (!U) {
              this.warn("The loading context changed while buffering fragment " + R.sn + " of level " + R.level + ". This chunk will not be buffered."), this.resetStartWhenNotLoaded(R.level);
              return;
            }
            var K = U.frag, V = U.part, W = U.level.details, G = F.audio, H = F.text, $ = F.id3, Y = F.initSegment;
            if (!(this.fragContextChanged(K) || !W)) {
              if (this.state = y.State.PARSING, this.audioSwitch && G && this.completeAudioSwitch(), Y != null && Y.tracks && (this._bufferInitSegment(Y.tracks, K, R), P.trigger(N.Events.FRAG_PARSING_INIT_SEGMENT, {
                frag: K,
                id: f,
                tracks: Y.tracks
              })), G) {
                var z = G.startPTS, X = G.endPTS, Q = G.startDTS, q = G.endDTS;
                V && (V.elementaryStreams[A.ElementaryStreamTypes.AUDIO] = {
                  startPTS: z,
                  endPTS: X,
                  startDTS: Q,
                  endDTS: q
                }), K.setElementaryStreamInfo(A.ElementaryStreamTypes.AUDIO, z, X, Q, q), this.bufferFragmentData(G, K, V, R);
              }
              if ($ != null && (C = $.samples) !== null && C !== void 0 && C.length) {
                var Z = v({
                  id: f,
                  frag: K,
                  details: W
                }, $);
                P.trigger(N.Events.FRAG_PARSING_METADATA, Z);
              }
              if (H) {
                var J = v({
                  id: f,
                  frag: K,
                  details: W
                }, H);
                P.trigger(N.Events.FRAG_PARSING_USERDATA, J);
              }
            }
          }, _._bufferInitSegment = function(h, C, f) {
            if (this.state === y.State.PARSING) {
              h.video && delete h.video;
              var P = h.audio;
              if (!!P) {
                P.levelCodec = P.codec, P.id = "audio", this.log("Init audio buffer, container:" + P.container + ", codecs[parsed]=[" + P.codec + "]"), this.hls.trigger(N.Events.BUFFER_CODECS, h);
                var F = P.initSegment;
                if (F != null && F.byteLength) {
                  var R = {
                    type: "audio",
                    frag: C,
                    part: null,
                    chunkMeta: f,
                    parent: C.type,
                    data: F
                  };
                  this.hls.trigger(N.Events.BUFFER_APPENDING, R);
                }
                this.tick();
              }
            }
          }, _.loadFragment = function(h, C, f) {
            var P = this.fragmentTracker.getState(h);
            this.fragCurrent = h, (this.audioSwitch || P === B.FragmentState.NOT_LOADED || P === B.FragmentState.PARTIAL) && (h.sn === "initSegment" ? this._loadInitSegment(h, C) : C.live && !(0, b.isFiniteNumber)(this.initPTS[h.cc]) ? (this.log("Waiting for video PTS in continuity counter " + h.cc + " of live stream before loading audio fragment " + h.sn + " of level " + this.trackId), this.state = y.State.WAITING_INIT_PTS) : (this.startFragRequested = !0, x.prototype.loadFragment.call(this, h, C, f)));
          }, _.completeAudioSwitch = function() {
            var h = this.hls, C = this.media, f = this.trackId;
            C && (this.log("Switching audio track : flushing all audio"), x.prototype.flushMainBuffer.call(this, 0, Number.POSITIVE_INFINITY, "audio")), this.audioSwitch = !1, h.trigger(N.Events.AUDIO_TRACK_SWITCHED, {
              id: f
            });
          }, k;
        }(y.default);
        const p = L;
      },
      "./src/controller/audio-track-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => M
        });
        var b = a("./src/events.ts"), y = a("./src/errors.ts"), N = a("./src/controller/base-playlist-controller.ts"), E = a("./src/types/loader.ts");
        function B(d, c) {
          for (var v = 0; v < c.length; v++) {
            var g = c[v];
            g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(d, T(g.key), g);
          }
        }
        function I(d, c, v) {
          return c && B(d.prototype, c), v && B(d, v), Object.defineProperty(d, "prototype", { writable: !1 }), d;
        }
        function T(d) {
          var c = A(d, "string");
          return typeof c == "symbol" ? c : String(c);
        }
        function A(d, c) {
          if (typeof d != "object" || d === null)
            return d;
          var v = d[Symbol.toPrimitive];
          if (v !== void 0) {
            var g = v.call(d, c || "default");
            if (typeof g != "object")
              return g;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (c === "string" ? String : Number)(d);
        }
        function w(d, c) {
          d.prototype = Object.create(c.prototype), d.prototype.constructor = d, O(d, c);
        }
        function O(d, c) {
          return O = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, m) {
            return g.__proto__ = m, g;
          }, O(d, c);
        }
        var u = /* @__PURE__ */ function(d) {
          w(c, d);
          function c(g) {
            var m;
            return m = d.call(this, g, "[audio-track-controller]") || this, m.tracks = [], m.groupId = null, m.tracksInGroup = [], m.trackId = -1, m.trackName = "", m.selectDefaultTrack = !0, m.registerListeners(), m;
          }
          var v = c.prototype;
          return v.registerListeners = function() {
            var m = this.hls;
            m.on(b.Events.MANIFEST_LOADING, this.onManifestLoading, this), m.on(b.Events.MANIFEST_PARSED, this.onManifestParsed, this), m.on(b.Events.LEVEL_LOADING, this.onLevelLoading, this), m.on(b.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), m.on(b.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), m.on(b.Events.ERROR, this.onError, this);
          }, v.unregisterListeners = function() {
            var m = this.hls;
            m.off(b.Events.MANIFEST_LOADING, this.onManifestLoading, this), m.off(b.Events.MANIFEST_PARSED, this.onManifestParsed, this), m.off(b.Events.LEVEL_LOADING, this.onLevelLoading, this), m.off(b.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), m.off(b.Events.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), m.off(b.Events.ERROR, this.onError, this);
          }, v.destroy = function() {
            this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, d.prototype.destroy.call(this);
          }, v.onManifestLoading = function() {
            this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.trackName = "", this.selectDefaultTrack = !0;
          }, v.onManifestParsed = function(m, D) {
            this.tracks = D.audioTracks || [];
          }, v.onAudioTrackLoaded = function(m, D) {
            var L = D.id, p = D.details, x = this.tracksInGroup[L];
            if (!x) {
              this.warn("Invalid audio track id " + L);
              return;
            }
            var k = x.details;
            x.details = D.details, this.log("audioTrack " + L + " loaded [" + p.startSN + "-" + p.endSN + "]"), L === this.trackId && (this.retryCount = 0, this.playlistLoaded(L, D, k));
          }, v.onLevelLoading = function(m, D) {
            this.switchLevel(D.level);
          }, v.onLevelSwitching = function(m, D) {
            this.switchLevel(D.level);
          }, v.switchLevel = function(m) {
            var D = this.hls.levels[m];
            if (!!(D != null && D.audioGroupIds)) {
              var L = D.audioGroupIds[D.urlId];
              if (this.groupId !== L) {
                this.groupId = L;
                var p = this.tracks.filter(function(k) {
                  return !L || k.groupId === L;
                });
                this.selectDefaultTrack && !p.some(function(k) {
                  return k.default;
                }) && (this.selectDefaultTrack = !1), this.tracksInGroup = p;
                var x = {
                  audioTracks: p
                };
                this.log("Updating audio tracks, " + p.length + ' track(s) found in "' + L + '" group-id'), this.hls.trigger(b.Events.AUDIO_TRACKS_UPDATED, x), this.selectInitialTrack();
              }
            }
          }, v.onError = function(m, D) {
            d.prototype.onError.call(this, m, D), !(D.fatal || !D.context) && D.context.type === E.PlaylistContextType.AUDIO_TRACK && D.context.id === this.trackId && D.context.groupId === this.groupId && this.retryLoadingOrFail(D);
          }, v.setAudioTrack = function(m) {
            var D = this.tracksInGroup;
            if (m < 0 || m >= D.length) {
              this.warn("Invalid id passed to audio-track controller");
              return;
            }
            this.clearTimer();
            var L = D[this.trackId];
            this.log("Now switching to audio-track index " + m);
            var p = D[m], x = p.id, k = p.groupId, _ = k === void 0 ? "" : k, S = p.name, h = p.type, C = p.url;
            if (this.trackId = m, this.trackName = S, this.selectDefaultTrack = !1, this.hls.trigger(b.Events.AUDIO_TRACK_SWITCHING, {
              id: x,
              groupId: _,
              name: S,
              type: h,
              url: C
            }), !(p.details && !p.details.live)) {
              var f = this.switchParams(p.url, L == null ? void 0 : L.details);
              this.loadPlaylist(f);
            }
          }, v.selectInitialTrack = function() {
            var m = this.tracksInGroup;
            console.assert(m.length, "Initial audio track should be selected when tracks are known");
            var D = this.trackName, L = this.findTrackId(D) || this.findTrackId();
            L !== -1 ? this.setAudioTrack(L) : (this.warn("No track found for running audio group-ID: " + this.groupId), this.hls.trigger(b.Events.ERROR, {
              type: y.ErrorTypes.MEDIA_ERROR,
              details: y.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
              fatal: !0
            }));
          }, v.findTrackId = function(m) {
            for (var D = this.tracksInGroup, L = 0; L < D.length; L++) {
              var p = D[L];
              if ((!this.selectDefaultTrack || p.default) && (!m || m === p.name))
                return p.id;
            }
            return -1;
          }, v.loadPlaylist = function(m) {
            d.prototype.loadPlaylist.call(this);
            var D = this.tracksInGroup[this.trackId];
            if (this.shouldLoadTrack(D)) {
              var L = D.id, p = D.groupId, x = D.url;
              if (m)
                try {
                  x = m.addDirectives(x);
                } catch (k) {
                  this.warn("Could not construct new URL with HLS Delivery Directives: " + k);
                }
              this.log("loading audio-track playlist for id: " + L), this.clearTimer(), this.hls.trigger(b.Events.AUDIO_TRACK_LOADING, {
                url: x,
                id: L,
                groupId: p,
                deliveryDirectives: m || null
              });
            }
          }, I(c, [{
            key: "audioTracks",
            get: function() {
              return this.tracksInGroup;
            }
          }, {
            key: "audioTrack",
            get: function() {
              return this.trackId;
            },
            set: function(m) {
              this.selectDefaultTrack = !1, this.setAudioTrack(m);
            }
          }]), c;
        }(N.default);
        const M = u;
      },
      "./src/controller/base-playlist-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => B
        });
        var b = a("./src/types/level.ts"), y = a("./src/controller/level-helper.ts"), N = a("./src/utils/logger.ts"), E = a("./src/errors.ts"), B = /* @__PURE__ */ function() {
          function I(A, w) {
            this.hls = void 0, this.timer = -1, this.requestScheduled = -1, this.canLoad = !1, this.retryCount = 0, this.log = void 0, this.warn = void 0, this.log = N.logger.log.bind(N.logger, w + ":"), this.warn = N.logger.warn.bind(N.logger, w + ":"), this.hls = A;
          }
          var T = I.prototype;
          return T.destroy = function() {
            this.clearTimer(), this.hls = this.log = this.warn = null;
          }, T.onError = function(w, O) {
            O.fatal && (O.type === E.ErrorTypes.NETWORK_ERROR || O.type === E.ErrorTypes.KEY_SYSTEM_ERROR) && this.stopLoad();
          }, T.clearTimer = function() {
            clearTimeout(this.timer), this.timer = -1;
          }, T.startLoad = function() {
            this.canLoad = !0, this.retryCount = 0, this.requestScheduled = -1, this.loadPlaylist();
          }, T.stopLoad = function() {
            this.canLoad = !1, this.clearTimer();
          }, T.switchParams = function(w, O) {
            var u = O == null ? void 0 : O.renditionReports;
            if (u)
              for (var M = 0; M < u.length; M++) {
                var d = u[M], c = void 0;
                try {
                  c = new self.URL(d.URI, O.url).href;
                } catch (D) {
                  N.logger.warn("Could not construct new URL for Rendition Report: " + D), c = d.URI || "";
                }
                if (c === w.slice(-c.length)) {
                  var v = parseInt(d["LAST-MSN"]) || (O == null ? void 0 : O.lastPartSn), g = parseInt(d["LAST-PART"]) || (O == null ? void 0 : O.lastPartIndex);
                  if (this.hls.config.lowLatencyMode) {
                    var m = Math.min(O.age - O.partTarget, O.targetduration);
                    g >= 0 && m > O.partTarget && (g += 1);
                  }
                  return new b.HlsUrlParameters(v, g >= 0 ? g : void 0, b.HlsSkip.No);
                }
              }
          }, T.loadPlaylist = function(w) {
            this.requestScheduled === -1 && (this.requestScheduled = self.performance.now());
          }, T.shouldLoadTrack = function(w) {
            return this.canLoad && w && !!w.url && (!w.details || w.details.live);
          }, T.playlistLoaded = function(w, O, u) {
            var M = this, d = O.details, c = O.stats, v = self.performance.now(), g = c.loading.first ? Math.max(0, v - c.loading.first) : 0;
            if (d.advancedDateTime = Date.now() - g, d.live || u != null && u.live) {
              if (d.reloaded(u), u && this.log("live playlist " + w + " " + (d.advanced ? "REFRESHED " + d.lastPartSn + "-" + d.lastPartIndex : "MISSED")), u && d.fragments.length > 0 && (0, y.mergeDetails)(u, d), !this.canLoad || !d.live)
                return;
              var m, D = void 0, L = void 0;
              if (d.canBlockReload && d.endSN && d.advanced) {
                var p = this.hls.config.lowLatencyMode, x = d.lastPartSn, k = d.endSN, _ = d.lastPartIndex, S = _ !== -1, h = x === k, C = p ? 0 : _;
                S ? (D = h ? k + 1 : x, L = h ? C : _ + 1) : D = k + 1;
                var f = d.age, P = f + d.ageHeader, F = Math.min(P - d.partTarget, d.targetduration * 1.5);
                if (F > 0) {
                  if (u && F > u.tuneInGoal)
                    this.warn("CDN Tune-in goal increased from: " + u.tuneInGoal + " to: " + F + " with playlist age: " + d.age), F = 0;
                  else {
                    var R = Math.floor(F / d.targetduration);
                    if (D += R, L !== void 0) {
                      var U = Math.round(F % d.targetduration / d.partTarget);
                      L += U;
                    }
                    this.log("CDN Tune-in age: " + d.ageHeader + "s last advanced " + f.toFixed(2) + "s goal: " + F + " skip sn " + R + " to part " + L);
                  }
                  d.tuneInGoal = F;
                }
                if (m = this.getDeliveryDirectives(d, O.deliveryDirectives, D, L), p || !h) {
                  this.loadPlaylist(m);
                  return;
                }
              } else
                m = this.getDeliveryDirectives(d, O.deliveryDirectives, D, L);
              var K = this.hls.mainForwardBufferInfo, V = K ? K.end - K.len : 0, W = (d.edge - V) * 1e3, G = (0, y.computeReloadInterval)(d, W);
              d.updated ? v > this.requestScheduled + G && (this.requestScheduled = c.loading.start) : this.requestScheduled = -1, D !== void 0 && d.canBlockReload ? this.requestScheduled = c.loading.first + G - (d.partTarget * 1e3 || 1e3) : this.requestScheduled = (this.requestScheduled === -1 ? v : this.requestScheduled) + G;
              var H = this.requestScheduled - v;
              H = Math.max(0, H), this.log("reload live playlist " + w + " in " + Math.round(H) + " ms"), this.timer = self.setTimeout(function() {
                return M.loadPlaylist(m);
              }, H);
            } else
              this.clearTimer();
          }, T.getDeliveryDirectives = function(w, O, u, M) {
            var d = (0, b.getSkipValue)(w, u);
            return O != null && O.skip && w.deltaUpdateFailed && (u = O.msn, M = O.part, d = b.HlsSkip.No), new b.HlsUrlParameters(u, M, d);
          }, T.retryLoadingOrFail = function(w) {
            var O = this, u = this.hls.config, M = this.retryCount < u.levelLoadingMaxRetry;
            if (M) {
              var d;
              if (this.requestScheduled = -1, this.retryCount++, w.details.indexOf("LoadTimeOut") > -1 && (d = w.context) !== null && d !== void 0 && d.deliveryDirectives)
                this.warn("retry playlist loading #" + this.retryCount + ' after "' + w.details + '"'), this.loadPlaylist();
              else {
                var c = Math.min(Math.pow(2, this.retryCount) * u.levelLoadingRetryDelay, u.levelLoadingMaxRetryTimeout);
                this.timer = self.setTimeout(function() {
                  return O.loadPlaylist();
                }, c), this.warn("retry playlist loading #" + this.retryCount + " in " + c + ' ms after "' + w.details + '"');
              }
            } else
              this.warn('cannot recover from error "' + w.details + '"'), this.clearTimer(), w.fatal = !0;
            return M;
          }, I;
        }();
      },
      "./src/controller/base-stream-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          State: () => S,
          default: () => h
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/task-loop.ts"), N = a("./src/controller/fragment-tracker.ts"), E = a("./src/utils/buffer-helper.ts"), B = a("./src/utils/logger.ts"), I = a("./src/events.ts"), T = a("./src/errors.ts"), A = a("./src/types/transmuxer.ts"), w = a("./src/utils/mp4-tools.ts"), O = a("./src/utils/discontinuities.ts"), u = a("./src/controller/fragment-finders.ts"), M = a("./src/controller/level-helper.ts"), d = a("./src/loader/fragment-loader.ts"), c = a("./src/crypt/decrypter.ts"), v = a("./src/utils/time-ranges.ts"), g = a("./src/types/loader.ts");
        function m(C, f) {
          for (var P = 0; P < f.length; P++) {
            var F = f[P];
            F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(C, L(F.key), F);
          }
        }
        function D(C, f, P) {
          return f && m(C.prototype, f), P && m(C, P), Object.defineProperty(C, "prototype", { writable: !1 }), C;
        }
        function L(C) {
          var f = p(C, "string");
          return typeof f == "symbol" ? f : String(f);
        }
        function p(C, f) {
          if (typeof C != "object" || C === null)
            return C;
          var P = C[Symbol.toPrimitive];
          if (P !== void 0) {
            var F = P.call(C, f || "default");
            if (typeof F != "object")
              return F;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (f === "string" ? String : Number)(C);
        }
        function x(C) {
          if (C === void 0)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return C;
        }
        function k(C, f) {
          C.prototype = Object.create(f.prototype), C.prototype.constructor = C, _(C, f);
        }
        function _(C, f) {
          return _ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(F, R) {
            return F.__proto__ = R, F;
          }, _(C, f);
        }
        var S = {
          STOPPED: "STOPPED",
          IDLE: "IDLE",
          KEY_LOADING: "KEY_LOADING",
          FRAG_LOADING: "FRAG_LOADING",
          FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
          WAITING_TRACK: "WAITING_TRACK",
          PARSING: "PARSING",
          PARSED: "PARSED",
          ENDED: "ENDED",
          ERROR: "ERROR",
          WAITING_INIT_PTS: "WAITING_INIT_PTS",
          WAITING_LEVEL: "WAITING_LEVEL"
        }, h = /* @__PURE__ */ function(C) {
          k(f, C);
          function f(F, R, U, K) {
            var V;
            return V = C.call(this) || this, V.hls = void 0, V.fragPrevious = null, V.fragCurrent = null, V.fragmentTracker = void 0, V.transmuxer = null, V._state = S.STOPPED, V.media = null, V.mediaBuffer = null, V.config = void 0, V.bitrateTest = !1, V.lastCurrentTime = 0, V.nextLoadPosition = 0, V.startPosition = 0, V.loadedmetadata = !1, V.fragLoadError = 0, V.retryDate = 0, V.levels = null, V.fragmentLoader = void 0, V.keyLoader = void 0, V.levelLastLoaded = null, V.startFragRequested = !1, V.decrypter = void 0, V.initPTS = [], V.onvseeking = null, V.onvended = null, V.logPrefix = "", V.log = void 0, V.warn = void 0, V.logPrefix = K, V.log = B.logger.log.bind(B.logger, K + ":"), V.warn = B.logger.warn.bind(B.logger, K + ":"), V.hls = F, V.fragmentLoader = new d.default(F.config), V.keyLoader = U, V.fragmentTracker = R, V.config = F.config, V.decrypter = new c.default(F.config), F.on(I.Events.LEVEL_SWITCHING, V.onLevelSwitching, x(V)), V;
          }
          var P = f.prototype;
          return P.doTick = function() {
            this.onTickEnd();
          }, P.onTickEnd = function() {
          }, P.startLoad = function(R) {
          }, P.stopLoad = function() {
            this.fragmentLoader.abort(), this.keyLoader.abort();
            var R = this.fragCurrent;
            R && (R.abortRequests(), this.fragmentTracker.removeFragment(R)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = S.STOPPED;
          }, P._streamEnded = function(R, U) {
            if (U.live || R.nextStart || !R.end || !this.media)
              return !1;
            var K = U.partList;
            if (K != null && K.length) {
              var V = K[K.length - 1], W = E.BufferHelper.isBuffered(this.media, V.start + V.duration / 2);
              return W;
            }
            var G = U.fragments[U.fragments.length - 1].type;
            return this.fragmentTracker.isEndListAppended(G);
          }, P.getLevelDetails = function() {
            if (this.levels && this.levelLastLoaded !== null) {
              var R;
              return (R = this.levels[this.levelLastLoaded]) === null || R === void 0 ? void 0 : R.details;
            }
          }, P.onMediaAttached = function(R, U) {
            var K = this.media = this.mediaBuffer = U.media;
            this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), K.addEventListener("seeking", this.onvseeking), K.addEventListener("ended", this.onvended);
            var V = this.config;
            this.levels && V.autoStartLoad && this.state === S.STOPPED && this.startLoad(V.startPosition);
          }, P.onMediaDetaching = function() {
            var R = this.media;
            R != null && R.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), R && this.onvseeking && this.onvended && (R.removeEventListener("seeking", this.onvseeking), R.removeEventListener("ended", this.onvended), this.onvseeking = this.onvended = null), this.keyLoader && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
          }, P.onMediaSeeking = function() {
            var R = this.config, U = this.fragCurrent, K = this.media, V = this.mediaBuffer, W = this.state, G = K ? K.currentTime : 0, H = E.BufferHelper.bufferInfo(V || K, G, R.maxBufferHole);
            if (this.log("media seeking to " + ((0, b.isFiniteNumber)(G) ? G.toFixed(3) : G) + ", state: " + W), this.state === S.ENDED)
              this.resetLoadingState();
            else if (U) {
              var $ = R.maxFragLookUpTolerance, Y = U.start - $, z = U.start + U.duration + $;
              if (!H.len || z < H.start || Y > H.end) {
                var X = G > z;
                (G < Y || X) && (X && U.loader && (this.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), U.abortRequests()), this.resetLoadingState());
              }
            }
            K && (this.lastCurrentTime = G), !this.loadedmetadata && !H.len && (this.nextLoadPosition = this.startPosition = G), this.tickImmediate();
          }, P.onMediaEnded = function() {
            this.startPosition = this.lastCurrentTime = 0;
          }, P.onLevelSwitching = function(R, U) {
            this.fragLoadError = 0;
          }, P.onHandlerDestroying = function() {
            this.stopLoad(), C.prototype.onHandlerDestroying.call(this);
          }, P.onHandlerDestroyed = function() {
            this.state = S.STOPPED, this.hls.off(I.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, C.prototype.onHandlerDestroyed.call(this);
          }, P.loadFragment = function(R, U, K) {
            this._loadFragForPlayback(R, U, K);
          }, P._loadFragForPlayback = function(R, U, K) {
            var V = this, W = function(H) {
              if (V.fragContextChanged(R)) {
                V.warn("Fragment " + R.sn + (H.part ? " p: " + H.part.index : "") + " of level " + R.level + " was dropped during download."), V.fragmentTracker.removeFragment(R);
                return;
              }
              R.stats.chunkCount++, V._handleFragmentLoadProgress(H);
            };
            this._doFragLoad(R, U, K, W).then(function(G) {
              if (!!G) {
                V.fragLoadError = 0;
                var H = V.state;
                if (V.fragContextChanged(R)) {
                  (H === S.FRAG_LOADING || !V.fragCurrent && H === S.PARSING) && (V.fragmentTracker.removeFragment(R), V.state = S.IDLE);
                  return;
                }
                "payload" in G && (V.log("Loaded fragment " + R.sn + " of level " + R.level), V.hls.trigger(I.Events.FRAG_LOADED, G)), V._handleFragmentLoadComplete(G);
              }
            }).catch(function(G) {
              V.state === S.STOPPED || V.state === S.ERROR || (V.warn(G), V.resetFragmentLoading(R));
            });
          }, P.flushMainBuffer = function(R, U, K) {
            if (K === void 0 && (K = null), !!(R - U)) {
              var V = {
                startOffset: R,
                endOffset: U,
                type: K
              };
              this.fragLoadError = 0, this.hls.trigger(I.Events.BUFFER_FLUSHING, V);
            }
          }, P._loadInitSegment = function(R, U) {
            var K = this;
            this._doFragLoad(R, U).then(function(V) {
              if (!V || K.fragContextChanged(R) || !K.levels)
                throw new Error("init load aborted");
              return V;
            }).then(function(V) {
              var W = K.hls, G = V.payload, H = R.decryptdata;
              if (G && G.byteLength > 0 && H && H.key && H.iv && H.method === "AES-128") {
                var $ = self.performance.now();
                return K.decrypter.decrypt(new Uint8Array(G), H.key.buffer, H.iv.buffer).then(function(Y) {
                  var z = self.performance.now();
                  return W.trigger(I.Events.FRAG_DECRYPTED, {
                    frag: R,
                    payload: Y,
                    stats: {
                      tstart: $,
                      tdecrypt: z
                    }
                  }), V.payload = Y, V;
                });
              }
              return V;
            }).then(function(V) {
              var W = K.fragCurrent, G = K.hls, H = K.levels;
              if (!H)
                throw new Error("init load aborted, missing levels");
              var $ = H[R.level].details;
              console.assert($, "Level details are defined when init segment is loaded");
              var Y = R.stats;
              K.state = S.IDLE, K.fragLoadError = 0, R.data = new Uint8Array(V.payload), Y.parsing.start = Y.buffering.start = self.performance.now(), Y.parsing.end = Y.buffering.end = self.performance.now(), V.frag === W && G.trigger(I.Events.FRAG_BUFFERED, {
                stats: Y,
                frag: W,
                part: null,
                id: R.type
              }), K.tick();
            }).catch(function(V) {
              K.state === S.STOPPED || K.state === S.ERROR || (K.warn(V), K.resetFragmentLoading(R));
            });
          }, P.fragContextChanged = function(R) {
            var U = this.fragCurrent;
            return !R || !U || R.level !== U.level || R.sn !== U.sn || R.urlId !== U.urlId;
          }, P.fragBufferedComplete = function(R, U) {
            var K, V, W, G, H = this.mediaBuffer ? this.mediaBuffer : this.media;
            this.log("Buffered " + R.type + " sn: " + R.sn + (U ? " part: " + U.index : "") + " of " + (this.logPrefix === "[stream-controller]" ? "level" : "track") + " " + R.level + " (frag:[" + ((K = R.startPTS) != null ? K : NaN).toFixed(3) + "-" + ((V = R.endPTS) != null ? V : NaN).toFixed(3) + "] > buffer:" + (H ? v.default.toString(E.BufferHelper.getBuffered(H)) : "(detached)") + ")"), this.state = S.IDLE, H && (!this.loadedmetadata && R.type == g.PlaylistLevelType.MAIN && H.buffered.length && ((W = this.fragCurrent) === null || W === void 0 ? void 0 : W.sn) === ((G = this.fragPrevious) === null || G === void 0 ? void 0 : G.sn) && (this.loadedmetadata = !0, this.seekToStartPos()), this.tick());
          }, P.seekToStartPos = function() {
          }, P._handleFragmentLoadComplete = function(R) {
            var U = this.transmuxer;
            if (!!U) {
              var K = R.frag, V = R.part, W = R.partsLoaded, G = !W || W.length === 0 || W.some(function($) {
                return !$;
              }), H = new A.ChunkMetadata(K.level, K.sn, K.stats.chunkCount + 1, 0, V ? V.index : -1, !G);
              U.flush(H);
            }
          }, P._handleFragmentLoadProgress = function(R) {
          }, P._doFragLoad = function(R, U, K, V) {
            var W, G = this;
            if (K === void 0 && (K = null), !this.levels)
              throw new Error("frag load aborted, missing levels");
            var H = null;
            if (R.encrypted && !((W = R.decryptdata) !== null && W !== void 0 && W.key) ? (this.log("Loading key for " + R.sn + " of [" + U.startSN + "-" + U.endSN + "], " + (this.logPrefix === "[stream-controller]" ? "level" : "track") + " " + R.level), this.state = S.KEY_LOADING, this.fragCurrent = R, H = this.keyLoader.load(R).then(function(Q) {
              if (!G.fragContextChanged(Q.frag))
                return G.hls.trigger(I.Events.KEY_LOADED, Q), G.state === S.KEY_LOADING && (G.state = S.IDLE), Q;
            }), this.hls.trigger(I.Events.KEY_LOADING, {
              frag: R
            }), this.throwIfFragContextChanged("KEY_LOADING")) : !R.encrypted && U.encryptedFragments.length && this.keyLoader.loadClear(R, U.encryptedFragments), K = Math.max(R.start, K || 0), this.config.lowLatencyMode && U) {
              var $ = U.partList;
              if ($ && V) {
                K > R.end && U.fragmentHint && (R = U.fragmentHint);
                var Y = this.getNextPart($, R, K);
                if (Y > -1) {
                  var z = $[Y];
                  return this.log("Loading part sn: " + R.sn + " p: " + z.index + " cc: " + R.cc + " of playlist [" + U.startSN + "-" + U.endSN + "] parts [0-" + Y + "-" + ($.length - 1) + "] " + (this.logPrefix === "[stream-controller]" ? "level" : "track") + ": " + R.level + ", target: " + parseFloat(K.toFixed(3))), this.nextLoadPosition = z.start + z.duration, this.state = S.FRAG_LOADING, this.hls.trigger(I.Events.FRAG_LOADING, {
                    frag: R,
                    part: $[Y],
                    targetBufferTime: K
                  }), this.throwIfFragContextChanged("FRAG_LOADING parts"), H ? H.then(function(Q) {
                    return !Q || G.fragContextChanged(Q.frag) ? null : G.doFragPartsLoad(R, $, Y, V);
                  }).catch(function(Q) {
                    return G.handleFragLoadError(Q);
                  }) : this.doFragPartsLoad(R, $, Y, V).catch(function(Q) {
                    return G.handleFragLoadError(Q);
                  });
                } else if (!R.url || this.loadedEndOfParts($, K))
                  return Promise.resolve(null);
              }
            }
            this.log("Loading fragment " + R.sn + " cc: " + R.cc + " " + (U ? "of [" + U.startSN + "-" + U.endSN + "] " : "") + (this.logPrefix === "[stream-controller]" ? "level" : "track") + ": " + R.level + ", target: " + parseFloat(K.toFixed(3))), (0, b.isFiniteNumber)(R.sn) && !this.bitrateTest && (this.nextLoadPosition = R.start + R.duration), this.state = S.FRAG_LOADING, this.hls.trigger(I.Events.FRAG_LOADING, {
              frag: R,
              targetBufferTime: K
            }), this.throwIfFragContextChanged("FRAG_LOADING");
            var X = this.config.progressive;
            return X && H ? H.then(function(Q) {
              return !Q || G.fragContextChanged(Q == null ? void 0 : Q.frag) ? null : G.fragmentLoader.load(R, V);
            }).catch(function(Q) {
              return G.handleFragLoadError(Q);
            }) : Promise.all([this.fragmentLoader.load(R, X ? V : void 0), H]).then(function(Q) {
              var q = Q[0];
              return !X && q && V && V(q), q;
            }).catch(function(Q) {
              return G.handleFragLoadError(Q);
            });
          }, P.throwIfFragContextChanged = function(R) {
            if (this.fragCurrent === null)
              throw new Error("frag load aborted, context changed in " + R);
          }, P.doFragPartsLoad = function(R, U, K, V) {
            var W = this;
            return new Promise(function(G, H) {
              var $ = [], Y = function z(X) {
                var Q = U[X];
                W.fragmentLoader.loadPart(R, Q, V).then(function(q) {
                  $[Q.index] = q;
                  var Z = q.part;
                  W.hls.trigger(I.Events.FRAG_LOADED, q);
                  var J = U[X + 1];
                  if (J && J.fragment === R)
                    z(X + 1);
                  else
                    return G({
                      frag: R,
                      part: Z,
                      partsLoaded: $
                    });
                }).catch(H);
              };
              Y(K);
            });
          }, P.handleFragLoadError = function(R) {
            if ("data" in R) {
              var U = R.data;
              R.data && U.details === T.ErrorDetails.INTERNAL_ABORTED ? this.handleFragLoadAborted(U.frag, U.part) : this.hls.trigger(I.Events.ERROR, U);
            } else
              this.hls.trigger(I.Events.ERROR, {
                type: T.ErrorTypes.OTHER_ERROR,
                details: T.ErrorDetails.INTERNAL_EXCEPTION,
                err: R,
                fatal: !0
              });
            return null;
          }, P._handleTransmuxerFlush = function(R) {
            var U = this.getCurrentContext(R);
            if (!U || this.state !== S.PARSING) {
              !this.fragCurrent && this.state !== S.STOPPED && this.state !== S.ERROR && (this.state = S.IDLE);
              return;
            }
            var K = U.frag, V = U.part, W = U.level, G = self.performance.now();
            K.stats.parsing.end = G, V && (V.stats.parsing.end = G), this.updateLevelTiming(K, V, W, R.partial);
          }, P.getCurrentContext = function(R) {
            var U = this.levels, K = R.level, V = R.sn, W = R.part;
            if (!U || !U[K])
              return this.warn("Levels object was unset while buffering fragment " + V + " of level " + K + ". The current chunk will not be buffered."), null;
            var G = U[K], H = W > -1 ? (0, M.getPartWith)(G, V, W) : null, $ = H ? H.fragment : (0, M.getFragmentWithSN)(G, V, this.fragCurrent);
            return $ ? {
              frag: $,
              part: H,
              level: G
            } : null;
          }, P.bufferFragmentData = function(R, U, K, V) {
            if (!(!R || this.state !== S.PARSING)) {
              var W = R.data1, G = R.data2, H = W;
              if (W && G && (H = (0, w.appendUint8Array)(W, G)), !(!H || !H.length)) {
                var $ = {
                  type: R.type,
                  frag: U,
                  part: K,
                  chunkMeta: V,
                  parent: U.type,
                  data: H
                };
                this.hls.trigger(I.Events.BUFFER_APPENDING, $), R.dropped && R.independent && !K && this.flushBufferGap(U);
              }
            }
          }, P.flushBufferGap = function(R) {
            var U = this.media;
            if (!!U) {
              if (!E.BufferHelper.isBuffered(U, U.currentTime)) {
                this.flushMainBuffer(0, R.start);
                return;
              }
              var K = U.currentTime, V = E.BufferHelper.bufferInfo(U, K, 0), W = R.duration, G = Math.min(this.config.maxFragLookUpTolerance * 2, W * 0.25), H = Math.max(Math.min(R.start - G, V.end - G), K + G);
              R.start - H > G && this.flushMainBuffer(H, R.start);
            }
          }, P.getFwdBufferInfo = function(R, U) {
            var K = this.config, V = this.getLoadPosition();
            if (!(0, b.isFiniteNumber)(V))
              return null;
            var W = E.BufferHelper.bufferInfo(R, V, K.maxBufferHole);
            if (W.len === 0 && W.nextStart !== void 0) {
              var G = this.fragmentTracker.getBufferedFrag(V, U);
              if (G && W.nextStart < G.end)
                return E.BufferHelper.bufferInfo(R, V, Math.max(W.nextStart, K.maxBufferHole));
            }
            return W;
          }, P.getMaxBufferLength = function(R) {
            var U = this.config, K;
            return R ? K = Math.max(8 * U.maxBufferSize / R, U.maxBufferLength) : K = U.maxBufferLength, Math.min(K, U.maxMaxBufferLength);
          }, P.reduceMaxBufferLength = function(R) {
            var U = this.config, K = R || U.maxBufferLength;
            return U.maxMaxBufferLength >= K ? (U.maxMaxBufferLength /= 2, this.warn("Reduce max buffer length to " + U.maxMaxBufferLength + "s"), !0) : !1;
          }, P.getNextFragment = function(R, U) {
            var K = U.fragments, V = K.length;
            if (!V)
              return null;
            var W = this.config, G = K[0].start, H;
            if (U.live) {
              var $ = W.initialLiveManifestSize;
              if (V < $)
                return this.warn("Not enough fragments to start playback (have: " + V + ", need: " + $ + ")"), null;
              !U.PTSKnown && !this.startFragRequested && this.startPosition === -1 && (H = this.getInitialLiveFragment(U, K), this.startPosition = H ? this.hls.liveSyncPosition || H.start : R);
            } else
              R <= G && (H = K[0]);
            if (!H) {
              var Y = W.lowLatencyMode ? U.partEnd : U.fragmentEnd;
              H = this.getFragmentAtPosition(R, Y, U);
            }
            return this.mapToInitFragWhenRequired(H);
          }, P.mapToInitFragWhenRequired = function(R) {
            return R != null && R.initSegment && !(R != null && R.initSegment.data) && !this.bitrateTest ? R.initSegment : R;
          }, P.getNextPart = function(R, U, K) {
            for (var V = -1, W = !1, G = !0, H = 0, $ = R.length; H < $; H++) {
              var Y = R[H];
              if (G = G && !Y.independent, V > -1 && K < Y.start)
                break;
              var z = Y.loaded;
              z ? V = -1 : (W || Y.independent || G) && Y.fragment === U && (V = H), W = z;
            }
            return V;
          }, P.loadedEndOfParts = function(R, U) {
            var K = R[R.length - 1];
            return K && U > K.start && K.loaded;
          }, P.getInitialLiveFragment = function(R, U) {
            var K = this.fragPrevious, V = null;
            if (K) {
              if (R.hasProgramDateTime && (this.log("Live playlist, switching playlist, load frag with same PDT: " + K.programDateTime), V = (0, u.findFragmentByPDT)(U, K.endProgramDateTime, this.config.maxFragLookUpTolerance)), !V) {
                var W = K.sn + 1;
                if (W >= R.startSN && W <= R.endSN) {
                  var G = U[W - R.startSN];
                  K.cc === G.cc && (V = G, this.log("Live playlist, switching playlist, load frag with next SN: " + V.sn));
                }
                V || (V = (0, u.findFragWithCC)(U, K.cc), V && this.log("Live playlist, switching playlist, load frag with same CC: " + V.sn));
              }
            } else {
              var H = this.hls.liveSyncPosition;
              H !== null && (V = this.getFragmentAtPosition(H, this.bitrateTest ? R.fragmentEnd : R.edge, R));
            }
            return V;
          }, P.getFragmentAtPosition = function(R, U, K) {
            var V = this.config, W = this.fragPrevious, G = K.fragments, H = K.endSN, $ = K.fragmentHint, Y = V.maxFragLookUpTolerance, z = !!(V.lowLatencyMode && K.partList && $);
            z && $ && !this.bitrateTest && (G = G.concat($), H = $.sn);
            var X;
            if (R < U) {
              var Q = R > U - Y ? 0 : Y;
              X = (0, u.findFragmentByPTS)(W, G, R, Q);
            } else
              X = G[G.length - 1];
            if (X) {
              var q = X.sn - K.startSN;
              if (this.fragmentTracker.getState(X) === N.FragmentState.OK && (W = X), W && X.sn === W.sn && !z) {
                var Z = W && X.level === W.level;
                if (Z) {
                  var J = G[q + 1];
                  X.sn < H && this.fragmentTracker.getState(J) !== N.FragmentState.OK ? (this.log("SN " + X.sn + " just loaded, load next one: " + J.sn), X = J) : X = null;
                }
              }
            }
            return X;
          }, P.synchronizeToLiveEdge = function(R) {
            var U = this.config, K = this.media;
            if (!!K) {
              var V = this.hls.liveSyncPosition, W = K.currentTime, G = R.fragments[0].start, H = R.edge, $ = W >= G - U.maxFragLookUpTolerance && W <= H;
              if (V !== null && K.duration > V && (W < V || !$)) {
                var Y = U.liveMaxLatencyDuration !== void 0 ? U.liveMaxLatencyDuration : U.liveMaxLatencyDurationCount * R.targetduration;
                (!$ && K.readyState < 4 || W < H - Y) && (this.loadedmetadata || (this.nextLoadPosition = V), K.readyState && (this.warn("Playback: " + W.toFixed(3) + " is located too far from the end of live sliding playlist: " + H + ", reset currentTime to : " + V.toFixed(3)), K.currentTime = V));
              }
            }
          }, P.alignPlaylists = function(R, U) {
            var K = this.levels, V = this.levelLastLoaded, W = this.fragPrevious, G = V !== null ? K[V] : null, H = R.fragments.length;
            if (!H)
              return this.warn("No fragments in live playlist"), 0;
            var $ = R.fragments[0].start, Y = !U, z = R.alignedSliding && (0, b.isFiniteNumber)($);
            if (Y || !z && !$) {
              (0, O.alignStream)(W, G, R);
              var X = R.fragments[0].start;
              return this.log("Live playlist sliding: " + X.toFixed(2) + " start-sn: " + (U ? U.startSN : "na") + "->" + R.startSN + " prev-sn: " + (W ? W.sn : "na") + " fragments: " + H), X;
            }
            return $;
          }, P.waitForCdnTuneIn = function(R) {
            var U = 3;
            return R.live && R.canBlockReload && R.partTarget && R.tuneInGoal > Math.max(R.partHoldBack, R.partTarget * U);
          }, P.setStartPosition = function(R, U) {
            var K = this.startPosition;
            if (K < U && (K = -1), K === -1 || this.lastCurrentTime === -1) {
              var V = R.startTimeOffset;
              (0, b.isFiniteNumber)(V) ? (K = U + V, V < 0 && (K += R.totalduration), K = Math.min(Math.max(U, K), U + R.totalduration), this.log("Start time offset " + V + " found in playlist, adjust startPosition to " + K), this.startPosition = K) : R.live ? K = this.hls.liveSyncPosition || U : this.startPosition = K = 0, this.lastCurrentTime = K;
            }
            this.nextLoadPosition = K;
          }, P.getLoadPosition = function() {
            var R = this.media, U = 0;
            return this.loadedmetadata && R ? U = R.currentTime : this.nextLoadPosition && (U = this.nextLoadPosition), U;
          }, P.handleFragLoadAborted = function(R, U) {
            this.transmuxer && R.sn !== "initSegment" && R.stats.aborted && (this.warn("Fragment " + R.sn + (U ? " part" + U.index : "") + " of level " + R.level + " was aborted"), this.resetFragmentLoading(R));
          }, P.resetFragmentLoading = function(R) {
            (!this.fragCurrent || !this.fragContextChanged(R) && this.state !== S.FRAG_LOADING_WAITING_RETRY) && (this.state = S.IDLE);
          }, P.onFragmentOrKeyLoadError = function(R, U) {
            if (U.fatal) {
              this.stopLoad(), this.state = S.ERROR;
              return;
            }
            var K = this.config;
            if (U.chunkMeta) {
              var V = this.getCurrentContext(U.chunkMeta);
              V && (U.frag = V.frag, U.levelRetry = !0, this.fragLoadError = K.fragLoadingMaxRetry);
            }
            var W = U.frag;
            if (!(!W || W.type !== R)) {
              var G = this.fragCurrent;
              if (console.assert(G && W.sn === G.sn && W.level === G.level && W.urlId === G.urlId, "Frag load error must match current frag to retry"), this.fragLoadError + 1 <= K.fragLoadingMaxRetry) {
                this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition);
                var H = Math.min(Math.pow(2, this.fragLoadError) * K.fragLoadingRetryDelay, K.fragLoadingMaxRetryTimeout);
                this.warn("Fragment " + W.sn + " of " + R + " " + W.level + " failed to load, retrying in " + H + "ms"), this.retryDate = self.performance.now() + H, this.fragLoadError++, this.state = S.FRAG_LOADING_WAITING_RETRY;
              } else
                U.levelRetry ? (R === g.PlaylistLevelType.AUDIO && (this.fragCurrent = null), this.fragLoadError = 0, this.state = S.IDLE) : (B.logger.error(U.details + " reaches max retry, redispatch as fatal ..."), U.fatal = !0, this.hls.stopLoad(), this.state = S.ERROR);
            }
          }, P.afterBufferFlushed = function(R, U, K) {
            if (!!R) {
              var V = E.BufferHelper.getBuffered(R);
              this.fragmentTracker.detectEvictedFragments(U, V, K), this.state === S.ENDED && this.resetLoadingState();
            }
          }, P.resetLoadingState = function() {
            this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state = S.IDLE;
          }, P.resetStartWhenNotLoaded = function(R) {
            if (!this.loadedmetadata) {
              this.startFragRequested = !1;
              var U = this.levels ? this.levels[R].details : null;
              U != null && U.live ? (this.startPosition = -1, this.setStartPosition(U, 0), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
            }
          }, P.updateLevelTiming = function(R, U, K, V) {
            var W = this, G = K.details;
            console.assert(!!G, "level.details must be defined");
            var H = Object.keys(R.elementaryStreams).reduce(function($, Y) {
              var z = R.elementaryStreams[Y];
              if (z) {
                var X = z.endPTS - z.startPTS;
                if (X <= 0)
                  return W.warn("Could not parse fragment " + R.sn + " " + Y + " duration reliably (" + X + ")"), $ || !1;
                var Q = V ? 0 : (0, M.updateFragPTSDTS)(G, R, z.startPTS, z.endPTS, z.startDTS, z.endDTS);
                return W.hls.trigger(I.Events.LEVEL_PTS_UPDATED, {
                  details: G,
                  level: K,
                  drift: Q,
                  type: Y,
                  frag: R,
                  start: z.startPTS,
                  end: z.endPTS
                }), !0;
              }
              return $;
            }, !1);
            H || (this.warn("Found no media in fragment " + R.sn + " of level " + K.id + " resetting transmuxer to fallback to playlist timing"), this.resetTransmuxer()), this.state = S.PARSED, this.hls.trigger(I.Events.FRAG_PARSED, {
              frag: R,
              part: U
            });
          }, P.resetTransmuxer = function() {
            this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null);
          }, D(f, [{
            key: "state",
            get: function() {
              return this._state;
            },
            set: function(R) {
              var U = this._state;
              U !== R && (this._state = R, this.log(U + "->" + R));
            }
          }]), f;
        }(y.default);
      },
      "./src/controller/buffer-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => u
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/events.ts"), N = a("./src/utils/logger.ts"), E = a("./src/errors.ts"), B = a("./src/utils/buffer-helper.ts"), I = a("./src/utils/mediasource-helper.ts"), T = a("./src/loader/fragment.ts"), A = a("./src/controller/buffer-operation-queue.ts"), w = (0, I.getMediaSource)(), O = /([ha]vc.)(?:\.[^.,]+)+/, u = /* @__PURE__ */ function() {
          function M(c) {
            var v = this;
            this.details = null, this._objectUrl = null, this.operationQueue = void 0, this.listeners = void 0, this.hls = void 0, this.bufferCodecEventsExpected = 0, this._bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.appendError = 0, this.tracks = {}, this.pendingTracks = {}, this.sourceBuffer = void 0, this._onMediaSourceOpen = function() {
              var g = v.media, m = v.mediaSource;
              N.logger.log("[buffer-controller]: Media source opened"), g && (g.removeEventListener("emptied", v._onMediaEmptied), v.updateMediaElementDuration(), v.hls.trigger(y.Events.MEDIA_ATTACHED, {
                media: g
              })), m && m.removeEventListener("sourceopen", v._onMediaSourceOpen), v.checkPendingTracks();
            }, this._onMediaSourceClose = function() {
              N.logger.log("[buffer-controller]: Media source closed");
            }, this._onMediaSourceEnded = function() {
              N.logger.log("[buffer-controller]: Media source ended");
            }, this._onMediaEmptied = function() {
              var g = v.media, m = v._objectUrl;
              g && g.src !== m && N.logger.error("Media element src was set while attaching MediaSource (" + m + " > " + g.src + ")");
            }, this.hls = c, this._initSourceBuffer(), this.registerListeners();
          }
          var d = M.prototype;
          return d.hasSourceTypes = function() {
            return this.getSourceBufferTypes().length > 0 || Object.keys(this.pendingTracks).length > 0;
          }, d.destroy = function() {
            this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = null;
          }, d.registerListeners = function() {
            var v = this.hls;
            v.on(y.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), v.on(y.Events.MEDIA_DETACHING, this.onMediaDetaching, this), v.on(y.Events.MANIFEST_PARSED, this.onManifestParsed, this), v.on(y.Events.BUFFER_RESET, this.onBufferReset, this), v.on(y.Events.BUFFER_APPENDING, this.onBufferAppending, this), v.on(y.Events.BUFFER_CODECS, this.onBufferCodecs, this), v.on(y.Events.BUFFER_EOS, this.onBufferEos, this), v.on(y.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), v.on(y.Events.LEVEL_UPDATED, this.onLevelUpdated, this), v.on(y.Events.FRAG_PARSED, this.onFragParsed, this), v.on(y.Events.FRAG_CHANGED, this.onFragChanged, this);
          }, d.unregisterListeners = function() {
            var v = this.hls;
            v.off(y.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), v.off(y.Events.MEDIA_DETACHING, this.onMediaDetaching, this), v.off(y.Events.MANIFEST_PARSED, this.onManifestParsed, this), v.off(y.Events.BUFFER_RESET, this.onBufferReset, this), v.off(y.Events.BUFFER_APPENDING, this.onBufferAppending, this), v.off(y.Events.BUFFER_CODECS, this.onBufferCodecs, this), v.off(y.Events.BUFFER_EOS, this.onBufferEos, this), v.off(y.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), v.off(y.Events.LEVEL_UPDATED, this.onLevelUpdated, this), v.off(y.Events.FRAG_PARSED, this.onFragParsed, this), v.off(y.Events.FRAG_CHANGED, this.onFragChanged, this);
          }, d._initSourceBuffer = function() {
            this.sourceBuffer = {}, this.operationQueue = new A.default(this.sourceBuffer), this.listeners = {
              audio: [],
              video: [],
              audiovideo: []
            }, this.lastMpegAudioChunk = null;
          }, d.onManifestParsed = function(v, g) {
            var m = 2;
            (g.audio && !g.video || !g.altAudio) && (m = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = m, this.details = null, N.logger.log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
          }, d.onMediaAttaching = function(v, g) {
            var m = this.media = g.media;
            if (m && w) {
              var D = this.mediaSource = new w();
              D.addEventListener("sourceopen", this._onMediaSourceOpen), D.addEventListener("sourceended", this._onMediaSourceEnded), D.addEventListener("sourceclose", this._onMediaSourceClose), m.src = self.URL.createObjectURL(D), this._objectUrl = m.src, m.addEventListener("emptied", this._onMediaEmptied);
            }
          }, d.onMediaDetaching = function() {
            var v = this.media, g = this.mediaSource, m = this._objectUrl;
            if (g) {
              if (N.logger.log("[buffer-controller]: media source detaching"), g.readyState === "open")
                try {
                  g.endOfStream();
                } catch (D) {
                  N.logger.warn("[buffer-controller]: onMediaDetaching: " + D.message + " while calling endOfStream");
                }
              this.onBufferReset(), g.removeEventListener("sourceopen", this._onMediaSourceOpen), g.removeEventListener("sourceended", this._onMediaSourceEnded), g.removeEventListener("sourceclose", this._onMediaSourceClose), v && (v.removeEventListener("emptied", this._onMediaEmptied), m && self.URL.revokeObjectURL(m), v.src === m ? (v.removeAttribute("src"), v.load()) : N.logger.warn("[buffer-controller]: media.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {};
            }
            this.hls.trigger(y.Events.MEDIA_DETACHED, void 0);
          }, d.onBufferReset = function() {
            var v = this;
            this.getSourceBufferTypes().forEach(function(g) {
              var m = v.sourceBuffer[g];
              try {
                m && (v.removeBufferListeners(g), v.mediaSource && v.mediaSource.removeSourceBuffer(m), v.sourceBuffer[g] = void 0);
              } catch (D) {
                N.logger.warn("[buffer-controller]: Failed to reset the " + g + " buffer", D);
              }
            }), this._initSourceBuffer();
          }, d.onBufferCodecs = function(v, g) {
            var m = this, D = this.getSourceBufferTypes().length;
            Object.keys(g).forEach(function(L) {
              if (D) {
                var p = m.tracks[L];
                if (p && typeof p.buffer.changeType == "function") {
                  var x = g[L], k = x.id, _ = x.codec, S = x.levelCodec, h = x.container, C = x.metadata, f = (p.levelCodec || p.codec).replace(O, "$1"), P = (S || _).replace(O, "$1");
                  if (f !== P) {
                    var F = h + ";codecs=" + (S || _);
                    m.appendChangeType(L, F), N.logger.log("[buffer-controller]: switching codec " + f + " to " + P), m.tracks[L] = {
                      buffer: p.buffer,
                      codec: _,
                      container: h,
                      levelCodec: S,
                      metadata: C,
                      id: k
                    };
                  }
                }
              } else
                m.pendingTracks[L] = g[L];
            }), !D && (this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks());
          }, d.appendChangeType = function(v, g) {
            var m = this, D = this.operationQueue, L = {
              execute: function() {
                var x = m.sourceBuffer[v];
                x && (N.logger.log("[buffer-controller]: changing " + v + " sourceBuffer type to " + g), x.changeType(g)), D.shiftAndExecuteNext(v);
              },
              onStart: function() {
              },
              onComplete: function() {
              },
              onError: function(x) {
                N.logger.warn("[buffer-controller]: Failed to change " + v + " SourceBuffer type", x);
              }
            };
            D.append(L, v);
          }, d.onBufferAppending = function(v, g) {
            var m = this, D = this.hls, L = this.operationQueue, p = this.tracks, x = g.data, k = g.type, _ = g.frag, S = g.part, h = g.chunkMeta, C = h.buffering[k], f = self.performance.now();
            C.start = f;
            var P = _.stats.buffering, F = S ? S.stats.buffering : null;
            P.start === 0 && (P.start = f), F && F.start === 0 && (F.start = f);
            var R = p.audio, U = !1;
            k === "audio" && (R == null ? void 0 : R.container) === "audio/mpeg" && (U = !this.lastMpegAudioChunk || h.id === 1 || this.lastMpegAudioChunk.sn !== h.sn, this.lastMpegAudioChunk = h);
            var K = _.start, V = {
              execute: function() {
                if (C.executeStart = self.performance.now(), U) {
                  var G = m.sourceBuffer[k];
                  if (G) {
                    var H = K - G.timestampOffset;
                    Math.abs(H) >= 0.1 && (N.logger.log("[buffer-controller]: Updating audio SourceBuffer timestampOffset to " + K + " (delta: " + H + ") sn: " + _.sn + ")"), G.timestampOffset = K);
                  }
                }
                m.appendExecutor(x, k);
              },
              onStart: function() {
              },
              onComplete: function() {
                var G = self.performance.now();
                C.executeEnd = C.end = G, P.first === 0 && (P.first = G), F && F.first === 0 && (F.first = G);
                var H = m.sourceBuffer, $ = {};
                for (var Y in H)
                  $[Y] = B.BufferHelper.getBuffered(H[Y]);
                m.appendError = 0, m.hls.trigger(y.Events.BUFFER_APPENDED, {
                  type: k,
                  frag: _,
                  part: S,
                  chunkMeta: h,
                  parent: _.type,
                  timeRanges: $
                });
              },
              onError: function(G) {
                N.logger.error("[buffer-controller]: Error encountered while trying to append to the " + k + " SourceBuffer", G);
                var H = {
                  type: E.ErrorTypes.MEDIA_ERROR,
                  parent: _.type,
                  details: E.ErrorDetails.BUFFER_APPEND_ERROR,
                  err: G,
                  fatal: !1
                };
                G.code === DOMException.QUOTA_EXCEEDED_ERR ? H.details = E.ErrorDetails.BUFFER_FULL_ERROR : (m.appendError++, H.details = E.ErrorDetails.BUFFER_APPEND_ERROR, m.appendError > D.config.appendErrorMaxRetry && (N.logger.error("[buffer-controller]: Failed " + D.config.appendErrorMaxRetry + " times to append segment in sourceBuffer"), H.fatal = !0, D.stopLoad())), D.trigger(y.Events.ERROR, H);
              }
            };
            L.append(V, k);
          }, d.onBufferFlushing = function(v, g) {
            var m = this, D = this.operationQueue, L = function(x) {
              return {
                execute: m.removeExecutor.bind(m, x, g.startOffset, g.endOffset),
                onStart: function() {
                },
                onComplete: function() {
                  m.hls.trigger(y.Events.BUFFER_FLUSHED, {
                    type: x
                  });
                },
                onError: function(_) {
                  N.logger.warn("[buffer-controller]: Failed to remove from " + x + " SourceBuffer", _);
                }
              };
            };
            g.type ? D.append(L(g.type), g.type) : this.getSourceBufferTypes().forEach(function(p) {
              D.append(L(p), p);
            });
          }, d.onFragParsed = function(v, g) {
            var m = this, D = g.frag, L = g.part, p = [], x = L ? L.elementaryStreams : D.elementaryStreams;
            x[T.ElementaryStreamTypes.AUDIOVIDEO] ? p.push("audiovideo") : (x[T.ElementaryStreamTypes.AUDIO] && p.push("audio"), x[T.ElementaryStreamTypes.VIDEO] && p.push("video"));
            var k = function() {
              var S = self.performance.now();
              D.stats.buffering.end = S, L && (L.stats.buffering.end = S);
              var h = L ? L.stats : D.stats;
              m.hls.trigger(y.Events.FRAG_BUFFERED, {
                frag: D,
                part: L,
                stats: h,
                id: D.type
              });
            };
            p.length === 0 && N.logger.warn("Fragments must have at least one ElementaryStreamType set. type: " + D.type + " level: " + D.level + " sn: " + D.sn), this.blockBuffers(k, p);
          }, d.onFragChanged = function(v, g) {
            this.flushBackBuffer();
          }, d.onBufferEos = function(v, g) {
            var m = this, D = this.getSourceBufferTypes().reduce(function(L, p) {
              var x = m.sourceBuffer[p];
              return x && (!g.type || g.type === p) && (x.ending = !0, x.ended || (x.ended = !0, N.logger.log("[buffer-controller]: " + p + " sourceBuffer now EOS"))), L && !!(!x || x.ended);
            }, !0);
            D && (N.logger.log("[buffer-controller]: Queueing mediaSource.endOfStream()"), this.blockBuffers(function() {
              m.getSourceBufferTypes().forEach(function(p) {
                var x = m.sourceBuffer[p];
                x && (x.ending = !1);
              });
              var L = m.mediaSource;
              if (!L || L.readyState !== "open") {
                L && N.logger.info("[buffer-controller]: Could not call mediaSource.endOfStream(). mediaSource.readyState: " + L.readyState);
                return;
              }
              N.logger.log("[buffer-controller]: Calling mediaSource.endOfStream()"), L.endOfStream();
            }));
          }, d.onLevelUpdated = function(v, g) {
            var m = g.details;
            !m.fragments.length || (this.details = m, this.getSourceBufferTypes().length ? this.blockBuffers(this.updateMediaElementDuration.bind(this)) : this.updateMediaElementDuration());
          }, d.flushBackBuffer = function() {
            var v = this.hls, g = this.details, m = this.media, D = this.sourceBuffer;
            if (!(!m || g === null)) {
              var L = this.getSourceBufferTypes();
              if (!!L.length) {
                var p = g.live && v.config.liveBackBufferLength !== null ? v.config.liveBackBufferLength : v.config.backBufferLength;
                if (!(!(0, b.isFiniteNumber)(p) || p < 0)) {
                  var x = m.currentTime, k = g.levelTargetDuration, _ = Math.max(p, k), S = Math.floor(x / k) * k - _;
                  L.forEach(function(h) {
                    var C = D[h];
                    if (C) {
                      var f = B.BufferHelper.getBuffered(C);
                      if (f.length > 0 && S > f.start(0)) {
                        if (v.trigger(y.Events.BACK_BUFFER_REACHED, {
                          bufferEnd: S
                        }), g.live)
                          v.trigger(y.Events.LIVE_BACK_BUFFER_REACHED, {
                            bufferEnd: S
                          });
                        else if (C.ended && f.end(f.length - 1) - x < k * 2) {
                          N.logger.info("[buffer-controller]: Cannot flush " + h + " back buffer while SourceBuffer is in ended state");
                          return;
                        }
                        v.trigger(y.Events.BUFFER_FLUSHING, {
                          startOffset: 0,
                          endOffset: S,
                          type: h
                        });
                      }
                    }
                  });
                }
              }
            }
          }, d.updateMediaElementDuration = function() {
            if (!(!this.details || !this.media || !this.mediaSource || this.mediaSource.readyState !== "open")) {
              var v = this.details, g = this.hls, m = this.media, D = this.mediaSource, L = v.fragments[0].start + v.totalduration, p = m.duration, x = (0, b.isFiniteNumber)(D.duration) ? D.duration : 0;
              v.live && g.config.liveDurationInfinity ? (N.logger.log("[buffer-controller]: Media Source duration is set to Infinity"), D.duration = 1 / 0, this.updateSeekableRange(v)) : (L > x && L > p || !(0, b.isFiniteNumber)(p)) && (N.logger.log("[buffer-controller]: Updating Media Source duration to " + L.toFixed(3)), D.duration = L);
            }
          }, d.updateSeekableRange = function(v) {
            var g = this.mediaSource, m = v.fragments, D = m.length;
            if (D && v.live && g !== null && g !== void 0 && g.setLiveSeekableRange) {
              var L = Math.max(0, m[0].start), p = Math.max(L, L + v.totalduration);
              g.setLiveSeekableRange(L, p);
            }
          }, d.checkPendingTracks = function() {
            var v = this.bufferCodecEventsExpected, g = this.operationQueue, m = this.pendingTracks, D = Object.keys(m).length;
            if (D && !v || D === 2) {
              this.createSourceBuffers(m), this.pendingTracks = {};
              var L = this.getSourceBufferTypes();
              if (L.length === 0) {
                this.hls.trigger(y.Events.ERROR, {
                  type: E.ErrorTypes.MEDIA_ERROR,
                  details: E.ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                  fatal: !0,
                  reason: "could not create source buffer for media codec(s)"
                });
                return;
              }
              L.forEach(function(p) {
                g.executeNext(p);
              });
            }
          }, d.createSourceBuffers = function(v) {
            var g = this.sourceBuffer, m = this.mediaSource;
            if (!m)
              throw Error("createSourceBuffers called when mediaSource was null");
            var D = 0;
            for (var L in v)
              if (!g[L]) {
                var p = v[L];
                if (!p)
                  throw Error("source buffer exists for track " + L + ", however track does not");
                var x = p.levelCodec || p.codec, k = p.container + ";codecs=" + x;
                N.logger.log("[buffer-controller]: creating sourceBuffer(" + k + ")");
                try {
                  var _ = g[L] = m.addSourceBuffer(k), S = L;
                  this.addBufferListener(S, "updatestart", this._onSBUpdateStart), this.addBufferListener(S, "updateend", this._onSBUpdateEnd), this.addBufferListener(S, "error", this._onSBUpdateError), this.tracks[L] = {
                    buffer: _,
                    codec: x,
                    container: p.container,
                    levelCodec: p.levelCodec,
                    metadata: p.metadata,
                    id: p.id
                  }, D++;
                } catch (h) {
                  N.logger.error("[buffer-controller]: error while trying to add sourceBuffer: " + h.message), this.hls.trigger(y.Events.ERROR, {
                    type: E.ErrorTypes.MEDIA_ERROR,
                    details: E.ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                    fatal: !1,
                    error: h,
                    mimeType: k
                  });
                }
              }
            D && this.hls.trigger(y.Events.BUFFER_CREATED, {
              tracks: this.tracks
            });
          }, d._onSBUpdateStart = function(v) {
            var g = this.operationQueue, m = g.current(v);
            m.onStart();
          }, d._onSBUpdateEnd = function(v) {
            var g = this.operationQueue, m = g.current(v);
            m.onComplete(), g.shiftAndExecuteNext(v);
          }, d._onSBUpdateError = function(v, g) {
            N.logger.error("[buffer-controller]: " + v + " SourceBuffer error", g), this.hls.trigger(y.Events.ERROR, {
              type: E.ErrorTypes.MEDIA_ERROR,
              details: E.ErrorDetails.BUFFER_APPENDING_ERROR,
              fatal: !1
            });
            var m = this.operationQueue.current(v);
            m && m.onError(g);
          }, d.removeExecutor = function(v, g, m) {
            var D = this.media, L = this.mediaSource, p = this.operationQueue, x = this.sourceBuffer, k = x[v];
            if (!D || !L || !k) {
              N.logger.warn("[buffer-controller]: Attempting to remove from the " + v + " SourceBuffer, but it does not exist"), p.shiftAndExecuteNext(v);
              return;
            }
            var _ = (0, b.isFiniteNumber)(D.duration) ? D.duration : 1 / 0, S = (0, b.isFiniteNumber)(L.duration) ? L.duration : 1 / 0, h = Math.max(0, g), C = Math.min(m, _, S);
            C > h && !k.ending ? (k.ended = !1, N.logger.log("[buffer-controller]: Removing [" + h + "," + C + "] from the " + v + " SourceBuffer"), console.assert(!k.updating, v + " sourceBuffer must not be updating"), k.remove(h, C)) : p.shiftAndExecuteNext(v);
          }, d.appendExecutor = function(v, g) {
            var m = this.operationQueue, D = this.sourceBuffer, L = D[g];
            if (!L) {
              N.logger.warn("[buffer-controller]: Attempting to append to the " + g + " SourceBuffer, but it does not exist"), m.shiftAndExecuteNext(g);
              return;
            }
            L.ended = !1, console.assert(!L.updating, g + " sourceBuffer must not be updating"), L.appendBuffer(v);
          }, d.blockBuffers = function(v, g) {
            var m = this;
            if (g === void 0 && (g = this.getSourceBufferTypes()), !g.length) {
              N.logger.log("[buffer-controller]: Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(v);
              return;
            }
            var D = this.operationQueue, L = g.map(function(p) {
              return D.appendBlocker(p);
            });
            Promise.all(L).then(function() {
              v(), g.forEach(function(p) {
                var x = m.sourceBuffer[p];
                (!x || !x.updating) && D.shiftAndExecuteNext(p);
              });
            });
          }, d.getSourceBufferTypes = function() {
            return Object.keys(this.sourceBuffer);
          }, d.addBufferListener = function(v, g, m) {
            var D = this.sourceBuffer[v];
            if (!!D) {
              var L = m.bind(this, v);
              this.listeners[v].push({
                event: g,
                listener: L
              }), D.addEventListener(g, L);
            }
          }, d.removeBufferListeners = function(v) {
            var g = this.sourceBuffer[v];
            !g || this.listeners[v].forEach(function(m) {
              g.removeEventListener(m.event, m.listener);
            });
          }, M;
        }();
      },
      "./src/controller/buffer-operation-queue.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => y
        });
        var b = a("./src/utils/logger.ts"), y = /* @__PURE__ */ function() {
          function N(B) {
            this.buffers = void 0, this.queues = {
              video: [],
              audio: [],
              audiovideo: []
            }, this.buffers = B;
          }
          var E = N.prototype;
          return E.append = function(I, T) {
            var A = this.queues[T];
            A.push(I), A.length === 1 && this.buffers[T] && this.executeNext(T);
          }, E.insertAbort = function(I, T) {
            var A = this.queues[T];
            A.unshift(I), this.executeNext(T);
          }, E.appendBlocker = function(I) {
            var T, A = new Promise(function(O) {
              T = O;
            }), w = {
              execute: T,
              onStart: function() {
              },
              onComplete: function() {
              },
              onError: function() {
              }
            };
            return this.append(w, I), A;
          }, E.executeNext = function(I) {
            var T = this.buffers, A = this.queues, w = T[I], O = A[I];
            if (O.length) {
              var u = O[0];
              try {
                u.execute();
              } catch (M) {
                b.logger.warn("[buffer-operation-queue]: Unhandled exception executing the current operation"), u.onError(M), (!w || !w.updating) && (O.shift(), this.executeNext(I));
              }
            }
          }, E.shiftAndExecuteNext = function(I) {
            this.queues[I].shift(), this.executeNext(I);
          }, E.current = function(I) {
            return this.queues[I][0];
          }, N;
        }();
      },
      "./src/controller/cap-level-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => T
        });
        var b = a("./src/events.ts");
        function y(A, w) {
          for (var O = 0; O < w.length; O++) {
            var u = w[O];
            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(A, E(u.key), u);
          }
        }
        function N(A, w, O) {
          return w && y(A.prototype, w), O && y(A, O), Object.defineProperty(A, "prototype", { writable: !1 }), A;
        }
        function E(A) {
          var w = B(A, "string");
          return typeof w == "symbol" ? w : String(w);
        }
        function B(A, w) {
          if (typeof A != "object" || A === null)
            return A;
          var O = A[Symbol.toPrimitive];
          if (O !== void 0) {
            var u = O.call(A, w || "default");
            if (typeof u != "object")
              return u;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (w === "string" ? String : Number)(A);
        }
        var I = /* @__PURE__ */ function() {
          function A(O) {
            this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.hls = void 0, this.streamController = void 0, this.clientRect = void 0, this.hls = O, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
          }
          var w = A.prototype;
          return w.setStreamController = function(u) {
            this.streamController = u;
          }, w.destroy = function() {
            this.unregisterListener(), this.hls.config.capLevelToPlayerSize && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
          }, w.registerListeners = function() {
            var u = this.hls;
            u.on(b.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), u.on(b.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), u.on(b.Events.MANIFEST_PARSED, this.onManifestParsed, this), u.on(b.Events.BUFFER_CODECS, this.onBufferCodecs, this), u.on(b.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
          }, w.unregisterListener = function() {
            var u = this.hls;
            u.off(b.Events.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), u.off(b.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), u.off(b.Events.MANIFEST_PARSED, this.onManifestParsed, this), u.off(b.Events.BUFFER_CODECS, this.onBufferCodecs, this), u.off(b.Events.MEDIA_DETACHING, this.onMediaDetaching, this);
          }, w.onFpsDropLevelCapping = function(u, M) {
            A.isLevelAllowed(M.droppedLevel, this.restrictedLevels) && this.restrictedLevels.push(M.droppedLevel);
          }, w.onMediaAttaching = function(u, M) {
            this.media = M.media instanceof HTMLVideoElement ? M.media : null, this.clientRect = null;
          }, w.onManifestParsed = function(u, M) {
            var d = this.hls;
            this.restrictedLevels = [], this.firstLevel = M.firstLevel, d.config.capLevelToPlayerSize && M.video && this.startCapping();
          }, w.onBufferCodecs = function(u, M) {
            var d = this.hls;
            d.config.capLevelToPlayerSize && M.video && this.startCapping();
          }, w.onMediaDetaching = function() {
            this.stopCapping();
          }, w.detectPlayerSize = function() {
            if (this.media && this.mediaHeight > 0 && this.mediaWidth > 0) {
              var u = this.hls.levels;
              if (u.length) {
                var M = this.hls;
                M.autoLevelCapping = this.getMaxLevel(u.length - 1), M.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = M.autoLevelCapping;
              }
            }
          }, w.getMaxLevel = function(u) {
            var M = this, d = this.hls.levels;
            if (!d.length)
              return -1;
            var c = d.filter(function(v, g) {
              return A.isLevelAllowed(g, M.restrictedLevels) && g <= u;
            });
            return this.clientRect = null, A.getMaxLevelByMediaSize(c, this.mediaWidth, this.mediaHeight);
          }, w.startCapping = function() {
            this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, this.hls.firstLevel = this.getMaxLevel(this.firstLevel), self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
          }, w.stopCapping = function() {
            this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
          }, w.getDimensions = function() {
            if (this.clientRect)
              return this.clientRect;
            var u = this.media, M = {
              width: 0,
              height: 0
            };
            if (u) {
              var d = u.getBoundingClientRect();
              M.width = d.width, M.height = d.height, !M.width && !M.height && (M.width = d.right - d.left || u.width || 0, M.height = d.bottom - d.top || u.height || 0);
            }
            return this.clientRect = M, M;
          }, A.isLevelAllowed = function(u, M) {
            return M === void 0 && (M = []), M.indexOf(u) === -1;
          }, A.getMaxLevelByMediaSize = function(u, M, d) {
            if (!u || !u.length)
              return -1;
            for (var c = function(L, p) {
              return p ? L.width !== p.width || L.height !== p.height : !0;
            }, v = u.length - 1, g = 0; g < u.length; g += 1) {
              var m = u[g];
              if ((m.width >= M || m.height >= d) && c(m, u[g + 1])) {
                v = g;
                break;
              }
            }
            return v;
          }, N(A, [{
            key: "mediaWidth",
            get: function() {
              return this.getDimensions().width * this.contentScaleFactor;
            }
          }, {
            key: "mediaHeight",
            get: function() {
              return this.getDimensions().height * this.contentScaleFactor;
            }
          }, {
            key: "contentScaleFactor",
            get: function() {
              var u = 1;
              if (!this.hls.config.ignoreDevicePixelRatio)
                try {
                  u = self.devicePixelRatio;
                } catch {
                }
              return u;
            }
          }]), A;
        }();
        const T = I;
      },
      "./src/controller/cmcd-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => d
        });
        var b = a("./src/events.ts"), y = a("./src/types/cmcd.ts"), N = a("./src/utils/buffer-helper.ts"), E = a("./src/utils/logger.ts");
        function B(c, v) {
          for (var g = 0; g < v.length; g++) {
            var m = v[g];
            m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(c, T(m.key), m);
          }
        }
        function I(c, v, g) {
          return v && B(c.prototype, v), g && B(c, g), Object.defineProperty(c, "prototype", { writable: !1 }), c;
        }
        function T(c) {
          var v = A(c, "string");
          return typeof v == "symbol" ? v : String(v);
        }
        function A(c, v) {
          if (typeof c != "object" || c === null)
            return c;
          var g = c[Symbol.toPrimitive];
          if (g !== void 0) {
            var m = g.call(c, v || "default");
            if (typeof m != "object")
              return m;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (v === "string" ? String : Number)(c);
        }
        function w(c, v) {
          var g = typeof Symbol < "u" && c[Symbol.iterator] || c["@@iterator"];
          if (g)
            return (g = g.call(c)).next.bind(g);
          if (Array.isArray(c) || (g = O(c)) || v && c && typeof c.length == "number") {
            g && (c = g);
            var m = 0;
            return function() {
              return m >= c.length ? { done: !0 } : { done: !1, value: c[m++] };
            };
          }
          throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        }
        function O(c, v) {
          if (!!c) {
            if (typeof c == "string")
              return u(c, v);
            var g = Object.prototype.toString.call(c).slice(8, -1);
            if (g === "Object" && c.constructor && (g = c.constructor.name), g === "Map" || g === "Set")
              return Array.from(c);
            if (g === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(g))
              return u(c, v);
          }
        }
        function u(c, v) {
          (v == null || v > c.length) && (v = c.length);
          for (var g = 0, m = new Array(v); g < v; g++)
            m[g] = c[g];
          return m;
        }
        function M() {
          return M = Object.assign ? Object.assign.bind() : function(c) {
            for (var v = 1; v < arguments.length; v++) {
              var g = arguments[v];
              for (var m in g)
                Object.prototype.hasOwnProperty.call(g, m) && (c[m] = g[m]);
            }
            return c;
          }, M.apply(this, arguments);
        }
        var d = /* @__PURE__ */ function() {
          function c(g) {
            var m = this;
            this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = function() {
              m.initialized && (m.starved = !0), m.buffering = !0;
            }, this.onPlaying = function() {
              m.initialized || (m.initialized = !0), m.buffering = !1;
            }, this.applyPlaylistData = function(p) {
              try {
                m.apply(p, {
                  ot: y.CMCDObjectType.MANIFEST,
                  su: !m.initialized
                });
              } catch (x) {
                E.logger.warn("Could not generate manifest CMCD data.", x);
              }
            }, this.applyFragmentData = function(p) {
              try {
                var x = p.frag, k = m.hls.levels[x.level], _ = m.getObjectType(x), S = {
                  d: x.duration * 1e3,
                  ot: _
                };
                (_ === y.CMCDObjectType.VIDEO || _ === y.CMCDObjectType.AUDIO || _ == y.CMCDObjectType.MUXED) && (S.br = k.bitrate / 1e3, S.tb = m.getTopBandwidth(_) / 1e3, S.bl = m.getBufferLength(_)), m.apply(p, S);
              } catch (h) {
                E.logger.warn("Could not generate segment CMCD data.", h);
              }
            }, this.hls = g;
            var D = this.config = g.config, L = D.cmcd;
            L != null && (D.pLoader = this.createPlaylistLoader(), D.fLoader = this.createFragmentLoader(), this.sid = L.sessionId || c.uuid(), this.cid = L.contentId, this.useHeaders = L.useHeaders === !0, this.registerListeners());
          }
          var v = c.prototype;
          return v.registerListeners = function() {
            var m = this.hls;
            m.on(b.Events.MEDIA_ATTACHED, this.onMediaAttached, this), m.on(b.Events.MEDIA_DETACHED, this.onMediaDetached, this), m.on(b.Events.BUFFER_CREATED, this.onBufferCreated, this);
          }, v.unregisterListeners = function() {
            var m = this.hls;
            m.off(b.Events.MEDIA_ATTACHED, this.onMediaAttached, this), m.off(b.Events.MEDIA_DETACHED, this.onMediaDetached, this), m.off(b.Events.BUFFER_CREATED, this.onBufferCreated, this), this.onMediaDetached();
          }, v.destroy = function() {
            this.unregisterListeners(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
          }, v.onMediaAttached = function(m, D) {
            this.media = D.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
          }, v.onMediaDetached = function() {
            !this.media || (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
          }, v.onBufferCreated = function(m, D) {
            var L, p;
            this.audioBuffer = (L = D.tracks.audio) === null || L === void 0 ? void 0 : L.buffer, this.videoBuffer = (p = D.tracks.video) === null || p === void 0 ? void 0 : p.buffer;
          }, v.createData = function() {
            var m;
            return {
              v: y.CMCDVersion,
              sf: y.CMCDStreamingFormat.HLS,
              sid: this.sid,
              cid: this.cid,
              pr: (m = this.media) === null || m === void 0 ? void 0 : m.playbackRate,
              mtp: this.hls.bandwidthEstimate / 1e3
            };
          }, v.apply = function(m, D) {
            D === void 0 && (D = {}), M(D, this.createData());
            var L = D.ot === y.CMCDObjectType.INIT || D.ot === y.CMCDObjectType.VIDEO || D.ot === y.CMCDObjectType.MUXED;
            if (this.starved && L && (D.bs = !0, D.su = !0, this.starved = !1), D.su == null && (D.su = this.buffering), this.useHeaders) {
              var p = c.toHeaders(D);
              if (!Object.keys(p).length)
                return;
              m.headers || (m.headers = {}), M(m.headers, p);
            } else {
              var x = c.toQuery(D);
              if (!x)
                return;
              m.url = c.appendQueryToUri(m.url, x);
            }
          }, v.getObjectType = function(m) {
            var D = m.type;
            if (D === "subtitle")
              return y.CMCDObjectType.TIMED_TEXT;
            if (m.sn === "initSegment")
              return y.CMCDObjectType.INIT;
            if (D === "audio")
              return y.CMCDObjectType.AUDIO;
            if (D === "main")
              return this.hls.audioTracks.length ? y.CMCDObjectType.VIDEO : y.CMCDObjectType.MUXED;
          }, v.getTopBandwidth = function(m) {
            var D = 0, L, p = this.hls;
            if (m === y.CMCDObjectType.AUDIO)
              L = p.audioTracks;
            else {
              var x = p.maxAutoLevel, k = x > -1 ? x + 1 : p.levels.length;
              L = p.levels.slice(0, k);
            }
            for (var _ = w(L), S; !(S = _()).done; ) {
              var h = S.value;
              h.bitrate > D && (D = h.bitrate);
            }
            return D > 0 ? D : NaN;
          }, v.getBufferLength = function(m) {
            var D = this.hls.media, L = m === y.CMCDObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
            if (!L || !D)
              return NaN;
            var p = N.BufferHelper.bufferInfo(L, D.currentTime, this.config.maxBufferHole);
            return p.len * 1e3;
          }, v.createPlaylistLoader = function() {
            var m = this.config.pLoader, D = this.applyPlaylistData, L = m || this.config.loader;
            return /* @__PURE__ */ function() {
              function p(k) {
                this.loader = void 0, this.loader = new L(k);
              }
              var x = p.prototype;
              return x.destroy = function() {
                this.loader.destroy();
              }, x.abort = function() {
                this.loader.abort();
              }, x.load = function(_, S, h) {
                D(_), this.loader.load(_, S, h);
              }, I(p, [{
                key: "stats",
                get: function() {
                  return this.loader.stats;
                }
              }, {
                key: "context",
                get: function() {
                  return this.loader.context;
                }
              }]), p;
            }();
          }, v.createFragmentLoader = function() {
            var m = this.config.fLoader, D = this.applyFragmentData, L = m || this.config.loader;
            return /* @__PURE__ */ function() {
              function p(k) {
                this.loader = void 0, this.loader = new L(k);
              }
              var x = p.prototype;
              return x.destroy = function() {
                this.loader.destroy();
              }, x.abort = function() {
                this.loader.abort();
              }, x.load = function(_, S, h) {
                D(_), this.loader.load(_, S, h);
              }, I(p, [{
                key: "stats",
                get: function() {
                  return this.loader.stats;
                }
              }, {
                key: "context",
                get: function() {
                  return this.loader.context;
                }
              }]), p;
            }();
          }, c.uuid = function() {
            var m = URL.createObjectURL(new Blob()), D = m.toString();
            return URL.revokeObjectURL(m), D.slice(D.lastIndexOf("/") + 1);
          }, c.serialize = function(m) {
            for (var D = [], L = function(V) {
              return !Number.isNaN(V) && V != null && V !== "" && V !== !1;
            }, p = function(V) {
              return Math.round(V);
            }, x = function(V) {
              return p(V / 100) * 100;
            }, k = function(V) {
              return encodeURIComponent(V);
            }, _ = {
              br: p,
              d: p,
              bl: x,
              dl: x,
              mtp: x,
              nor: k,
              rtp: x,
              tb: p
            }, S = Object.keys(m || {}).sort(), h = w(S), C; !(C = h()).done; ) {
              var f = C.value, P = m[f];
              if (!!L(P) && !(f === "v" && P === 1) && !(f == "pr" && P === 1)) {
                var F = _[f];
                F && (P = F(P));
                var R = typeof P, U = void 0;
                f === "ot" || f === "sf" || f === "st" ? U = f + "=" + P : R === "boolean" ? U = f : R === "number" ? U = f + "=" + P : U = f + "=" + JSON.stringify(P), D.push(U);
              }
            }
            return D.join(",");
          }, c.toHeaders = function(m) {
            for (var D = Object.keys(m), L = {}, p = ["Object", "Request", "Session", "Status"], x = [{}, {}, {}, {}], k = {
              br: 0,
              d: 0,
              ot: 0,
              tb: 0,
              bl: 1,
              dl: 1,
              mtp: 1,
              nor: 1,
              nrr: 1,
              su: 1,
              cid: 2,
              pr: 2,
              sf: 2,
              sid: 2,
              st: 2,
              v: 2,
              bs: 3,
              rtp: 3
            }, _ = 0, S = D; _ < S.length; _++) {
              var h = S[_], C = k[h] != null ? k[h] : 1;
              x[C][h] = m[h];
            }
            for (var f = 0; f < x.length; f++) {
              var P = c.serialize(x[f]);
              P && (L["CMCD-" + p[f]] = P);
            }
            return L;
          }, c.toQuery = function(m) {
            return "CMCD=" + encodeURIComponent(c.serialize(m));
          }, c.appendQueryToUri = function(m, D) {
            if (!D)
              return m;
            var L = m.includes("?") ? "&" : "?";
            return "" + m + L + D;
          }, c;
        }();
      },
      "./src/controller/eme-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => _
        });
        var b = a("./src/events.ts"), y = a("./src/errors.ts"), N = a("./src/utils/logger.ts"), E = a("./src/utils/mediakeys-helper.ts"), B = a("./src/utils/keysystem-util.ts"), I = a("./src/utils/numeric-encoding-utils.ts"), T = a("./src/loader/level-key.ts"), A = a("./src/utils/hex.ts"), w = a("./src/utils/mp4-tools.ts"), O = a("./node_modules/eventemitter3/index.js"), u = /* @__PURE__ */ a.n(O);
        function M(S, h) {
          S.prototype = Object.create(h.prototype), S.prototype.constructor = S, m(S, h);
        }
        function d(S) {
          var h = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
          return d = function(f) {
            if (f === null || !g(f))
              return f;
            if (typeof f != "function")
              throw new TypeError("Super expression must either be null or a function");
            if (typeof h < "u") {
              if (h.has(f))
                return h.get(f);
              h.set(f, P);
            }
            function P() {
              return c(f, arguments, D(this).constructor);
            }
            return P.prototype = Object.create(f.prototype, { constructor: { value: P, enumerable: !1, writable: !0, configurable: !0 } }), m(P, f);
          }, d(S);
        }
        function c(S, h, C) {
          return v() ? c = Reflect.construct.bind() : c = function(P, F, R) {
            var U = [null];
            U.push.apply(U, F);
            var K = Function.bind.apply(P, U), V = new K();
            return R && m(V, R.prototype), V;
          }, c.apply(null, arguments);
        }
        function v() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return !1;
          if (typeof Proxy == "function")
            return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }
        function g(S) {
          return Function.toString.call(S).indexOf("[native code]") !== -1;
        }
        function m(S, h) {
          return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(f, P) {
            return f.__proto__ = P, f;
          }, m(S, h);
        }
        function D(S) {
          return D = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(C) {
            return C.__proto__ || Object.getPrototypeOf(C);
          }, D(S);
        }
        var L = 3, p = "[eme]", x = /* @__PURE__ */ function() {
          function S(C) {
            this.hls = void 0, this.config = void 0, this.media = null, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.setMediaKeysQueue = S.CDMCleanupPromise ? [S.CDMCleanupPromise] : [], this.onMediaEncrypted = this._onMediaEncrypted.bind(this), this.onWaitingForKey = this._onWaitingForKey.bind(this), this.debug = N.logger.debug.bind(N.logger, p), this.log = N.logger.log.bind(N.logger, p), this.warn = N.logger.warn.bind(N.logger, p), this.error = N.logger.error.bind(N.logger, p), this.hls = C, this.config = C.config, this.registerListeners();
          }
          var h = S.prototype;
          return h.destroy = function() {
            this.unregisterListeners(), this.onMediaDetached(), this.hls = this.onMediaEncrypted = this.onWaitingForKey = this.keyIdToKeySessionPromise = null;
          }, h.registerListeners = function() {
            this.hls.on(b.Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(b.Events.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(b.Events.MANIFEST_LOADED, this.onManifestLoaded, this);
          }, h.unregisterListeners = function() {
            this.hls.off(b.Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(b.Events.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(b.Events.MANIFEST_LOADED, this.onManifestLoaded, this);
          }, h.getLicenseServerUrl = function(f) {
            var P = this.config, F = P.drmSystems, R = P.widevineLicenseUrl, U = F[f];
            if (U)
              return U.licenseUrl;
            if (f === E.KeySystems.WIDEVINE && R)
              return R;
            throw new Error('no license server URL configured for key-system "' + f + '"');
          }, h.getServerCertificateUrl = function(f) {
            var P = this.config.drmSystems, F = P[f];
            if (F)
              return F.serverCertificateUrl;
            this.log('No Server Certificate in config.drmSystems["' + f + '"]');
          }, h.attemptKeySystemAccess = function(f) {
            var P = this, F = this.hls.levels, R = function(W, G, H) {
              return !!W && H.indexOf(W) === G;
            }, U = F.map(function(V) {
              return V.audioCodec;
            }).filter(R), K = F.map(function(V) {
              return V.videoCodec;
            }).filter(R);
            return U.length + K.length === 0 && K.push("avc1.42e01e"), new Promise(function(V, W) {
              var G = function H($) {
                var Y = $.shift();
                P.getMediaKeysPromise(Y, U, K).then(function(z) {
                  return V({
                    keySystem: Y,
                    mediaKeys: z
                  });
                }).catch(function(z) {
                  $.length ? H($) : z instanceof k ? W(z) : W(new k({
                    type: y.ErrorTypes.KEY_SYSTEM_ERROR,
                    details: y.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                    error: z,
                    fatal: !0
                  }, z.message));
                });
              };
              G(f);
            });
          }, h.requestMediaKeySystemAccess = function(f, P) {
            var F = this.config.requestMediaKeySystemAccessFunc;
            if (typeof F != "function") {
              var R = "Configured requestMediaKeySystemAccess is not a function " + F;
              return E.requestMediaKeySystemAccess === null && self.location.protocol === "http:" && (R = "navigator.requestMediaKeySystemAccess is not available over insecure protocol " + location.protocol), Promise.reject(new Error(R));
            }
            return F(f, P);
          }, h.getMediaKeysPromise = function(f, P, F) {
            var R = this, U = (0, E.getSupportedMediaKeySystemConfigurations)(f, P, F, this.config.drmSystemOptions), K = this.keySystemAccessPromises[f], V = K == null ? void 0 : K.keySystemAccess;
            if (!V) {
              this.log('Requesting encrypted media "' + f + '" key-system access with config: ' + JSON.stringify(U)), V = this.requestMediaKeySystemAccess(f, U);
              var W = this.keySystemAccessPromises[f] = {
                keySystemAccess: V
              };
              return V.catch(function(G) {
                R.log('Failed to obtain access to key-system "' + f + '": ' + G);
              }), V.then(function(G) {
                R.log('Access for key-system "' + G.keySystem + '" obtained');
                var H = R.fetchServerCertificate(f);
                return R.log('Create media-keys for "' + f + '"'), W.mediaKeys = G.createMediaKeys().then(function($) {
                  return R.log('Media-keys created for "' + f + '"'), H.then(function(Y) {
                    return Y ? R.setMediaKeysServerCertificate($, f, Y) : $;
                  });
                }), W.mediaKeys.catch(function($) {
                  R.error('Failed to create media-keys for "' + f + '"}: ' + $);
                }), W.mediaKeys;
              });
            }
            return V.then(function() {
              return K.mediaKeys;
            });
          }, h.createMediaKeySessionContext = function(f) {
            var P = f.decryptdata, F = f.keySystem, R = f.mediaKeys;
            console.assert(!!R, "mediaKeys is defined"), this.log('Creating key-system session "' + F + '" keyId: ' + A.default.hexDump(P.keyId || []));
            var U = R.createSession(), K = {
              decryptdata: P,
              keySystem: F,
              mediaKeys: R,
              mediaKeysSession: U,
              keyStatus: "status-pending"
            };
            return this.mediaKeySessions.push(K), K;
          }, h.renewKeySession = function(f) {
            var P = f.decryptdata;
            if (P.pssh) {
              var F = this.createMediaKeySessionContext(f), R = this.getKeyIdString(P), U = "cenc";
              this.keyIdToKeySessionPromise[R] = this.generateRequestWithPreferredKeySession(F, U, P.pssh, "expired");
            } else
              this.warn("Could not renew expired session. Missing pssh initData.");
            this.removeSession(f);
          }, h.getKeyIdString = function(f) {
            if (!f)
              throw new Error("Could not read keyId of undefined decryptdata");
            if (f.keyId === null)
              throw new Error("keyId is null");
            return A.default.hexDump(f.keyId);
          }, h.updateKeySession = function(f, P) {
            var F, R = f.mediaKeysSession;
            return this.log('Updating key-session "' + R.sessionId + '" for keyID ' + A.default.hexDump(((F = f.decryptdata) === null || F === void 0 ? void 0 : F.keyId) || []) + `
      } (data length: ` + (P && P.byteLength) + ")"), R.update(P);
          }, h.selectKeySystemFormat = function(f) {
            var P = Object.keys(f.levelkeys || {});
            return this.keyFormatPromise || (this.log("Selecting key-system from fragment (sn: " + f.sn + " " + f.type + ": " + f.level + ") key formats " + P.join(", ")), this.keyFormatPromise = this.getKeyFormatPromise(P)), this.keyFormatPromise;
          }, h.getKeyFormatPromise = function(f) {
            var P = this;
            return new Promise(function(F, R) {
              var U = (0, E.getKeySystemsForConfig)(P.config), K = f.map(E.keySystemFormatToKeySystemDomain).filter(function(V) {
                return !!V && U.indexOf(V) !== -1;
              });
              return P.getKeySystemSelectionPromise(K).then(function(V) {
                var W = V.keySystem, G = (0, E.keySystemDomainToKeySystemFormat)(W);
                G ? F(G) : R(new Error('Unable to find format for key-system "' + W + '"'));
              }).catch(R);
            });
          }, h.loadKey = function(f) {
            var P = this, F = f.keyInfo.decryptdata, R = this.getKeyIdString(F), U = "(keyId: " + R + ' format: "' + F.keyFormat + '" method: ' + F.method + " uri: " + F.uri + ")";
            this.log("Starting session for key " + U);
            var K = this.keyIdToKeySessionPromise[R];
            return K || (K = this.keyIdToKeySessionPromise[R] = this.getKeySystemForKeyPromise(F).then(function(V) {
              var W = V.keySystem, G = V.mediaKeys;
              return P.throwIfDestroyed(), P.log("Handle encrypted media sn: " + f.frag.sn + " " + f.frag.type + ": " + f.frag.level + " using key " + U), P.attemptSetMediaKeys(W, G).then(function() {
                P.throwIfDestroyed();
                var H = P.createMediaKeySessionContext({
                  keySystem: W,
                  mediaKeys: G,
                  decryptdata: F
                }), $ = "cenc";
                return P.generateRequestWithPreferredKeySession(H, $, F.pssh, "playlist-key");
              });
            }), K.catch(function(V) {
              return P.handleError(V);
            })), K;
          }, h.throwIfDestroyed = function(f) {
            if (!this.hls)
              throw new Error("invalid state");
          }, h.handleError = function(f) {
            !this.hls || (this.error(f.message), f instanceof k ? this.hls.trigger(b.Events.ERROR, f.data) : this.hls.trigger(b.Events.ERROR, {
              type: y.ErrorTypes.KEY_SYSTEM_ERROR,
              details: y.ErrorDetails.KEY_SYSTEM_NO_KEYS,
              error: f,
              fatal: !0
            }));
          }, h.getKeySystemForKeyPromise = function(f) {
            var P = this.getKeyIdString(f), F = this.keyIdToKeySessionPromise[P];
            if (!F) {
              var R = (0, E.keySystemFormatToKeySystemDomain)(f.keyFormat), U = R ? [R] : (0, E.getKeySystemsForConfig)(this.config);
              return this.attemptKeySystemAccess(U);
            }
            return F;
          }, h.getKeySystemSelectionPromise = function(f) {
            if (f.length || (f = (0, E.getKeySystemsForConfig)(this.config)), f.length === 0)
              throw new k({
                type: y.ErrorTypes.KEY_SYSTEM_ERROR,
                details: y.ErrorDetails.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
                fatal: !0
              }, "Missing key-system license configuration options " + JSON.stringify({
                drmSystems: this.config.drmSystems
              }));
            return this.attemptKeySystemAccess(f);
          }, h._onMediaEncrypted = function(f) {
            var P = this, F = f.initDataType, R = f.initData;
            if (this.debug('"' + f.type + '" event: init data type: "' + F + '"'), R !== null) {
              var U, K;
              if (F === "sinf" && this.config.drmSystems[E.KeySystems.FAIRPLAY]) {
                var V = (0, w.bin2str)(new Uint8Array(R));
                try {
                  var W = (0, I.base64Decode)(JSON.parse(V).sinf), G = (0, w.parseSinf)(new Uint8Array(W));
                  if (!G)
                    return;
                  U = G.subarray(8, 24), K = E.KeySystems.FAIRPLAY;
                } catch {
                  this.warn('Failed to parse sinf "encrypted" event message initData');
                  return;
                }
              } else {
                var H = (0, w.parsePssh)(R);
                if (H === null)
                  return;
                H.version === 0 && H.systemId === E.KeySystemIds.WIDEVINE && H.data && (U = H.data.subarray(8, 24)), K = (0, E.keySystemIdToKeySystemDomain)(H.systemId);
              }
              if (!(!K || !U)) {
                for (var $ = A.default.hexDump(U), Y = this.keyIdToKeySessionPromise, z = this.mediaKeySessions, X = Y[$], Q = function(te) {
                  var ne = z[te], re = ne.decryptdata;
                  if (re.pssh || !re.keyId)
                    return "continue";
                  var ee = A.default.hexDump(re.keyId);
                  if ($ === ee || re.uri.replace(/-/g, "").indexOf($) !== -1)
                    return X = Y[ee], delete Y[ee], re.pssh = new Uint8Array(R), re.keyId = U, X = Y[$] = X.then(function() {
                      return P.generateRequestWithPreferredKeySession(ne, F, R, "encrypted-event-key-match");
                    }), "break";
                }, q = 0; q < z.length; q++) {
                  var Z = Q(q);
                  if (Z !== "continue" && Z === "break")
                    break;
                }
                X || (X = Y[$] = this.getKeySystemSelectionPromise([K]).then(function(J) {
                  var te, ne = J.keySystem, re = J.mediaKeys;
                  P.throwIfDestroyed();
                  var ee = new T.LevelKey("ISO-23001-7", $, (te = (0, E.keySystemDomainToKeySystemFormat)(ne)) != null ? te : "");
                  return ee.pssh = new Uint8Array(R), ee.keyId = U, P.attemptSetMediaKeys(ne, re).then(function() {
                    P.throwIfDestroyed();
                    var le = P.createMediaKeySessionContext({
                      decryptdata: ee,
                      keySystem: ne,
                      mediaKeys: re
                    });
                    return P.generateRequestWithPreferredKeySession(le, F, R, "encrypted-event-no-match");
                  });
                })), X.catch(function(J) {
                  return P.handleError(J);
                });
              }
            }
          }, h._onWaitingForKey = function(f) {
            this.log('"' + f.type + '" event');
          }, h.attemptSetMediaKeys = function(f, P) {
            var F = this, R = this.setMediaKeysQueue.slice();
            this.log('Setting media-keys for "' + f + '"');
            var U = Promise.all(R).then(function() {
              if (!F.media)
                throw new Error("Attempted to set mediaKeys without media element attached");
              return F.media.setMediaKeys(P);
            });
            return this.setMediaKeysQueue.push(U), U.then(function() {
              F.log('Media-keys set for "' + f + '"'), R.push(U), F.setMediaKeysQueue = F.setMediaKeysQueue.filter(function(K) {
                return R.indexOf(K) === -1;
              });
            });
          }, h.generateRequestWithPreferredKeySession = function(f, P, F, R) {
            var U, K, V = this, W = (U = this.config.drmSystems) === null || U === void 0 || (K = U[f.keySystem]) === null || K === void 0 ? void 0 : K.generateRequest;
            if (W)
              try {
                var G = W.call(this.hls, P, F, f);
                if (!G)
                  throw new Error("Invalid response from configured generateRequest filter");
                P = G.initDataType, F = f.decryptdata.pssh = G.initData ? new Uint8Array(G.initData) : null;
              } catch (X) {
                var H;
                if (this.warn(X.message), (H = this.hls) !== null && H !== void 0 && H.config.debug)
                  throw X;
              }
            if (F === null)
              return this.log('Skipping key-session request for "' + R + '" (no initData)'), Promise.resolve(f);
            var $ = this.getKeyIdString(f.decryptdata);
            this.log('Generating key-session request for "' + R + '": ' + $ + " (init data type: " + P + " length: " + (F ? F.byteLength : null) + ")");
            var Y = new (u())();
            f.mediaKeysSession.onmessage = function(X) {
              var Q = f.mediaKeysSession;
              if (!Q) {
                Y.emit("error", new Error("invalid state"));
                return;
              }
              var q = X.messageType, Z = X.message;
              V.log('"' + q + '" message event for session "' + Q.sessionId + '" message size: ' + Z.byteLength), q === "license-request" || q === "license-renewal" ? V.renewLicense(f, Z).catch(function(J) {
                V.handleError(J), Y.emit("error", J);
              }) : q === "license-release" ? f.keySystem === E.KeySystems.FAIRPLAY && (V.updateKeySession(f, (0, B.strToUtf8array)("acknowledged")), V.removeSession(f)) : V.warn('unhandled media key message type "' + q + '"');
            }, f.mediaKeysSession.onkeystatuseschange = function(X) {
              var Q = f.mediaKeysSession;
              if (!Q) {
                Y.emit("error", new Error("invalid state"));
                return;
              }
              V.onKeyStatusChange(f);
              var q = f.keyStatus;
              Y.emit("keyStatus", q), q === "expired" && (V.warn(f.keySystem + " expired for key " + $), V.renewKeySession(f));
            };
            var z = new Promise(function(X, Q) {
              Y.on("error", Q), Y.on("keyStatus", function(q) {
                q.startsWith("usable") ? X() : q === "output-restricted" ? Q(new k({
                  type: y.ErrorTypes.KEY_SYSTEM_ERROR,
                  details: y.ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED,
                  fatal: !1
                }, "HDCP level output restricted")) : q === "internal-error" ? Q(new k({
                  type: y.ErrorTypes.KEY_SYSTEM_ERROR,
                  details: y.ErrorDetails.KEY_SYSTEM_STATUS_INTERNAL_ERROR,
                  fatal: !0
                }, 'key status changed to "' + q + '"')) : q === "expired" ? Q(new Error("key expired while generating request")) : V.warn('unhandled key status change "' + q + '"');
              });
            });
            return f.mediaKeysSession.generateRequest(P, F).then(function() {
              var X;
              V.log('Request generated for key-session "' + ((X = f.mediaKeysSession) === null || X === void 0 ? void 0 : X.sessionId) + '" keyId: ' + $);
            }).catch(function(X) {
              throw new k({
                type: y.ErrorTypes.KEY_SYSTEM_ERROR,
                details: y.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                error: X,
                fatal: !1
              }, "Error generating key-session request: " + X);
            }).then(function() {
              return z;
            }).catch(function(X) {
              throw Y.removeAllListeners(), V.removeSession(f), X;
            }).then(function() {
              return Y.removeAllListeners(), f;
            });
          }, h.onKeyStatusChange = function(f) {
            var P = this;
            f.mediaKeysSession.keyStatuses.forEach(function(F, R) {
              P.log('key status change "' + F + '" for keyStatuses keyId: ' + A.default.hexDump("buffer" in R ? new Uint8Array(R.buffer, R.byteOffset, R.byteLength) : new Uint8Array(R)) + " session keyId: " + A.default.hexDump(new Uint8Array(f.decryptdata.keyId || [])) + " uri: " + f.decryptdata.uri), f.keyStatus = F;
            });
          }, h.fetchServerCertificate = function(f) {
            var P = this;
            return new Promise(function(F, R) {
              var U = P.getServerCertificateUrl(f);
              if (!U)
                return F();
              P.log('Fetching serverCertificate for "' + f + '"');
              var K = new XMLHttpRequest();
              K.open("GET", U, !0), K.responseType = "arraybuffer", K.onreadystatechange = function() {
                K.readyState === XMLHttpRequest.DONE && (K.status === 200 ? F(K.response) : R(new k({
                  type: y.ErrorTypes.KEY_SYSTEM_ERROR,
                  details: y.ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
                  fatal: !0,
                  networkDetails: K
                }, '"' + f + '" certificate request XHR failed (' + U + "). Status: " + K.status + " (" + K.statusText + ")")));
              }, K.send();
            });
          }, h.setMediaKeysServerCertificate = function(f, P, F) {
            var R = this;
            return new Promise(function(U, K) {
              f.setServerCertificate(F).then(function(V) {
                R.log("setServerCertificate " + (V ? "success" : "not supported by CDM") + " (" + (F == null ? void 0 : F.byteLength) + ') on "' + P + '"'), U(f);
              }).catch(function(V) {
                K(new k({
                  type: y.ErrorTypes.KEY_SYSTEM_ERROR,
                  details: y.ErrorDetails.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
                  error: V,
                  fatal: !0
                }, V.message));
              });
            });
          }, h.renewLicense = function(f, P) {
            var F = this;
            return this.requestLicense(f, new Uint8Array(P)).then(function(R) {
              return F.updateKeySession(f, new Uint8Array(R)).catch(function(U) {
                throw new k({
                  type: y.ErrorTypes.KEY_SYSTEM_ERROR,
                  details: y.ErrorDetails.KEY_SYSTEM_SESSION_UPDATE_FAILED,
                  error: U,
                  fatal: !0
                }, U.message);
              });
            });
          }, h.setupLicenseXHR = function(f, P, F, R) {
            var U = this, K = this.config.licenseXhrSetup;
            return K ? Promise.resolve().then(function() {
              if (!F.decryptdata)
                throw new Error("Key removed");
              return K.call(U.hls, f, P, F, R);
            }).catch(function(V) {
              if (!F.decryptdata)
                throw V;
              return f.open("POST", P, !0), K.call(U.hls, f, P, F, R);
            }).then(function(V) {
              f.readyState || f.open("POST", P, !0);
              var W = V || R;
              return {
                xhr: f,
                licenseChallenge: W
              };
            }) : (f.open("POST", P, !0), Promise.resolve({
              xhr: f,
              licenseChallenge: R
            }));
          }, h.requestLicense = function(f, P) {
            var F = this;
            return new Promise(function(R, U) {
              var K = F.getLicenseServerUrl(f.keySystem);
              F.log("Sending license request to URL: " + K);
              var V = new XMLHttpRequest();
              V.responseType = "arraybuffer", V.onreadystatechange = function() {
                if (!F.hls || !f.mediaKeysSession)
                  return U(new Error("invalid state"));
                if (V.readyState === 4)
                  if (V.status === 200) {
                    F._requestLicenseFailureCount = 0;
                    var W = V.response;
                    F.log("License received " + (W instanceof ArrayBuffer ? W.byteLength : W));
                    var G = F.config.licenseResponseCallback;
                    if (G)
                      try {
                        W = G.call(F.hls, V, K, f);
                      } catch ($) {
                        F.error($);
                      }
                    R(W);
                  } else if (F._requestLicenseFailureCount++, F._requestLicenseFailureCount > L || V.status >= 400 && V.status < 500)
                    U(new k({
                      type: y.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: y.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                      fatal: !0,
                      networkDetails: V
                    }, "License Request XHR failed (" + K + "). Status: " + V.status + " (" + V.statusText + ")"));
                  else {
                    var H = L - F._requestLicenseFailureCount + 1;
                    F.warn("Retrying license request, " + H + " attempts left"), F.requestLicense(f, P).then(R, U);
                  }
              }, f.licenseXhr && f.licenseXhr.readyState !== XMLHttpRequest.DONE && f.licenseXhr.abort(), f.licenseXhr = V, F.setupLicenseXHR(V, K, f, P).then(function(W) {
                var G = W.xhr, H = W.licenseChallenge;
                G.send(H);
              });
            });
          }, h.onMediaAttached = function(f, P) {
            if (!!this.config.emeEnabled) {
              var F = P.media;
              this.media = F, F.addEventListener("encrypted", this.onMediaEncrypted), F.addEventListener("waitingforkey", this.onWaitingForKey);
            }
          }, h.onMediaDetached = function() {
            var f = this, P = this.media, F = this.mediaKeySessions;
            P && (P.removeEventListener("encrypted", this.onMediaEncrypted), P.removeEventListener("waitingforkey", this.onWaitingForKey), this.media = null), this._requestLicenseFailureCount = 0, this.setMediaKeysQueue = [], this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, T.LevelKey.clearKeyUriToKeyIdMap();
            var R = F.length;
            S.CDMCleanupPromise = Promise.all(F.map(function(U) {
              return f.removeSession(U);
            }).concat(P == null ? void 0 : P.setMediaKeys(null).catch(function(U) {
              f.log("Could not clear media keys: " + U + ". media.src: " + (P == null ? void 0 : P.src));
            }))).then(function() {
              R && (f.log("finished closing key sessions and clearing media keys"), F.length = 0);
            }).catch(function(U) {
              f.log("Could not close sessions and clear media keys: " + U + ". media.src: " + (P == null ? void 0 : P.src));
            });
          }, h.onManifestLoaded = function(f, P) {
            var F = P.sessionKeys;
            if (!(!F || !this.config.emeEnabled) && !this.keyFormatPromise) {
              var R = F.reduce(function(U, K) {
                return U.indexOf(K.keyFormat) === -1 && U.push(K.keyFormat), U;
              }, []);
              this.log("Selecting key-system from session-keys " + R.join(", ")), this.keyFormatPromise = this.getKeyFormatPromise(R);
            }
          }, h.removeSession = function(f) {
            var P = this, F = f.mediaKeysSession, R = f.licenseXhr;
            if (F) {
              this.log("Remove licenses and keys and close session " + F.sessionId), F.onmessage = null, F.onkeystatuseschange = null, R && R.readyState !== XMLHttpRequest.DONE && R.abort(), f.mediaKeysSession = f.decryptdata = f.licenseXhr = void 0;
              var U = this.mediaKeySessions.indexOf(f);
              return U > -1 && this.mediaKeySessions.splice(U, 1), F.remove().catch(function(K) {
                P.log("Could not remove session: " + K);
              }).then(function() {
                return F.close();
              }).catch(function(K) {
                P.log("Could not close session: " + K);
              });
            }
          }, S;
        }();
        x.CDMCleanupPromise = void 0;
        var k = /* @__PURE__ */ function(S) {
          M(h, S);
          function h(C, f) {
            var P;
            return P = S.call(this, f) || this, P.data = void 0, P.data = C, C.err = C.error, P;
          }
          return h;
        }(/* @__PURE__ */ d(Error));
        const _ = x;
      },
      "./src/controller/fps-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => E
        });
        var b = a("./src/events.ts"), y = a("./src/utils/logger.ts"), N = /* @__PURE__ */ function() {
          function B(T) {
            this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = T, this.registerListeners();
          }
          var I = B.prototype;
          return I.setStreamController = function(A) {
            this.streamController = A;
          }, I.registerListeners = function() {
            this.hls.on(b.Events.MEDIA_ATTACHING, this.onMediaAttaching, this);
          }, I.unregisterListeners = function() {
            this.hls.off(b.Events.MEDIA_ATTACHING, this.onMediaAttaching);
          }, I.destroy = function() {
            this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
          }, I.onMediaAttaching = function(A, w) {
            var O = this.hls.config;
            if (O.capLevelOnFPSDrop) {
              var u = w.media instanceof self.HTMLVideoElement ? w.media : null;
              this.media = u, u && typeof u.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), O.fpsDroppedMonitoringPeriod);
            }
          }, I.checkFPS = function(A, w, O) {
            var u = performance.now();
            if (w) {
              if (this.lastTime) {
                var M = u - this.lastTime, d = O - this.lastDroppedFrames, c = w - this.lastDecodedFrames, v = 1e3 * d / M, g = this.hls;
                if (g.trigger(b.Events.FPS_DROP, {
                  currentDropped: d,
                  currentDecoded: c,
                  totalDroppedFrames: O
                }), v > 0 && d > g.config.fpsDroppedMonitoringThreshold * c) {
                  var m = g.currentLevel;
                  y.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + m), m > 0 && (g.autoLevelCapping === -1 || g.autoLevelCapping >= m) && (m = m - 1, g.trigger(b.Events.FPS_DROP_LEVEL_CAPPING, {
                    level: m,
                    droppedLevel: g.currentLevel
                  }), g.autoLevelCapping = m, this.streamController.nextLevelSwitch());
                }
              }
              this.lastTime = u, this.lastDroppedFrames = O, this.lastDecodedFrames = w;
            }
          }, I.checkFPSInterval = function() {
            var A = this.media;
            if (A)
              if (this.isVideoPlaybackQualityAvailable) {
                var w = A.getVideoPlaybackQuality();
                this.checkFPS(A, w.totalVideoFrames, w.droppedVideoFrames);
              } else
                this.checkFPS(A, A.webkitDecodedFrameCount, A.webkitDroppedFrameCount);
          }, B;
        }();
        const E = N;
      },
      "./src/controller/fragment-finders.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          findFragWithCC: () => T,
          findFragmentByPDT: () => N,
          findFragmentByPTS: () => E,
          fragmentWithinToleranceTest: () => B,
          pdtWithinToleranceTest: () => I
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/utils/binary-search.ts");
        function N(A, w, O) {
          if (w === null || !Array.isArray(A) || !A.length || !(0, b.isFiniteNumber)(w))
            return null;
          var u = A[0].programDateTime;
          if (w < (u || 0))
            return null;
          var M = A[A.length - 1].endProgramDateTime;
          if (w >= (M || 0))
            return null;
          O = O || 0;
          for (var d = 0; d < A.length; ++d) {
            var c = A[d];
            if (I(w, O, c))
              return c;
          }
          return null;
        }
        function E(A, w, O, u) {
          O === void 0 && (O = 0), u === void 0 && (u = 0);
          var M = null;
          if (A ? M = w[A.sn - w[0].sn + 1] || null : O === 0 && w[0].start === 0 && (M = w[0]), M && B(O, u, M) === 0)
            return M;
          var d = y.default.search(w, B.bind(null, O, u));
          return d && (d !== A || !M) ? d : M;
        }
        function B(A, w, O) {
          if (A === void 0 && (A = 0), w === void 0 && (w = 0), O.start <= A && O.start + O.duration > A)
            return 0;
          var u = Math.min(w, O.duration + (O.deltaPTS ? O.deltaPTS : 0));
          return O.start + O.duration - u <= A ? 1 : O.start - u > A && O.start ? -1 : 0;
        }
        function I(A, w, O) {
          var u = Math.min(w, O.duration + (O.deltaPTS ? O.deltaPTS : 0)) * 1e3, M = O.endProgramDateTime || 0;
          return M - u > A;
        }
        function T(A, w) {
          return y.default.search(A, function(O) {
            return O.cc < w ? 1 : O.cc > w ? -1 : 0;
          });
        }
      },
      "./src/controller/fragment-tracker.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          FragmentState: () => N,
          FragmentTracker: () => E
        });
        var b = a("./src/events.ts"), y = a("./src/types/loader.ts"), N;
        (function(T) {
          T.NOT_LOADED = "NOT_LOADED", T.APPENDING = "APPENDING", T.PARTIAL = "PARTIAL", T.OK = "OK";
        })(N || (N = {}));
        var E = /* @__PURE__ */ function() {
          function T(w) {
            this.activeFragment = null, this.activeParts = null, this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hls = w, this._registerListeners();
          }
          var A = T.prototype;
          return A._registerListeners = function() {
            var O = this.hls;
            O.on(b.Events.BUFFER_APPENDED, this.onBufferAppended, this), O.on(b.Events.FRAG_BUFFERED, this.onFragBuffered, this), O.on(b.Events.FRAG_LOADED, this.onFragLoaded, this);
          }, A._unregisterListeners = function() {
            var O = this.hls;
            O.off(b.Events.BUFFER_APPENDED, this.onBufferAppended, this), O.off(b.Events.FRAG_BUFFERED, this.onFragBuffered, this), O.off(b.Events.FRAG_LOADED, this.onFragLoaded, this);
          }, A.destroy = function() {
            this._unregisterListeners(), this.fragments = this.endListFragments = this.timeRanges = this.activeFragment = this.activeParts = null;
          }, A.getAppendedFrag = function(O, u) {
            if (u === y.PlaylistLevelType.MAIN) {
              var M = this.activeFragment, d = this.activeParts;
              if (!M)
                return null;
              if (d)
                for (var c = d.length; c--; ) {
                  var v = d[c], g = v ? v.end : M.appendedPTS;
                  if (v.start <= O && g !== void 0 && O <= g)
                    return c > 9 && (this.activeParts = d.slice(c - 9)), v;
                }
              else if (M.start <= O && M.appendedPTS !== void 0 && O <= M.appendedPTS)
                return M;
            }
            return this.getBufferedFrag(O, u);
          }, A.getBufferedFrag = function(O, u) {
            for (var M = this.fragments, d = Object.keys(M), c = d.length; c--; ) {
              var v = M[d[c]];
              if ((v == null ? void 0 : v.body.type) === u && v.buffered) {
                var g = v.body;
                if (g.start <= O && O <= g.end)
                  return g;
              }
            }
            return null;
          }, A.detectEvictedFragments = function(O, u, M) {
            var d = this;
            this.timeRanges && (this.timeRanges[O] = u), Object.keys(this.fragments).forEach(function(c) {
              var v = d.fragments[c];
              if (!!v) {
                if (!v.buffered && !v.loaded) {
                  v.body.type === M && d.removeFragment(v.body);
                  return;
                }
                var g = v.range[O];
                !g || g.time.some(function(m) {
                  var D = !d.isTimeBuffered(m.startPTS, m.endPTS, u);
                  return D && d.removeFragment(v.body), D;
                });
              }
            });
          }, A.detectPartialFragments = function(O) {
            var u = this, M = this.timeRanges, d = O.frag, c = O.part;
            if (!(!M || d.sn === "initSegment")) {
              var v = I(d), g = this.fragments[v];
              !g || (Object.keys(M).forEach(function(m) {
                var D = d.elementaryStreams[m];
                if (!!D) {
                  var L = M[m], p = c !== null || D.partial === !0;
                  g.range[m] = u.getBufferedTimes(d, c, p, L);
                }
              }), g.loaded = null, Object.keys(g.range).length ? (g.buffered = !0, g.body.endList && (this.endListFragments[g.body.type] = g)) : this.removeFragment(g.body));
            }
          }, A.fragBuffered = function(O) {
            var u = I(O), M = this.fragments[u];
            M && (M.loaded = null, M.buffered = !0);
          }, A.getBufferedTimes = function(O, u, M, d) {
            for (var c = {
              time: [],
              partial: M
            }, v = u ? u.start : O.start, g = u ? u.end : O.end, m = O.minEndPTS || g, D = O.maxStartPTS || v, L = 0; L < d.length; L++) {
              var p = d.start(L) - this.bufferPadding, x = d.end(L) + this.bufferPadding;
              if (D >= p && m <= x) {
                c.time.push({
                  startPTS: Math.max(v, d.start(L)),
                  endPTS: Math.min(g, d.end(L))
                });
                break;
              } else if (v < x && g > p)
                c.partial = !0, c.time.push({
                  startPTS: Math.max(v, d.start(L)),
                  endPTS: Math.min(g, d.end(L))
                });
              else if (g <= p)
                break;
            }
            return c;
          }, A.getPartialFragment = function(O) {
            var u = null, M, d, c, v = 0, g = this.bufferPadding, m = this.fragments;
            return Object.keys(m).forEach(function(D) {
              var L = m[D];
              !L || B(L) && (d = L.body.start - g, c = L.body.end + g, O >= d && O <= c && (M = Math.min(O - d, c - O), v <= M && (u = L.body, v = M)));
            }), u;
          }, A.isEndListAppended = function(O) {
            var u = this.endListFragments[O];
            return u !== void 0 && (u.buffered || B(u));
          }, A.getState = function(O) {
            var u = I(O), M = this.fragments[u];
            return M ? M.buffered ? B(M) ? N.PARTIAL : N.OK : N.APPENDING : N.NOT_LOADED;
          }, A.isTimeBuffered = function(O, u, M) {
            for (var d, c, v = 0; v < M.length; v++) {
              if (d = M.start(v) - this.bufferPadding, c = M.end(v) + this.bufferPadding, O >= d && u <= c)
                return !0;
              if (u <= d)
                return !1;
            }
            return !1;
          }, A.onFragLoaded = function(O, u) {
            var M = u.frag, d = u.part;
            if (!(M.sn === "initSegment" || M.bitrateTest || d)) {
              var c = I(M);
              this.fragments[c] = {
                body: M,
                loaded: u,
                buffered: !1,
                range: /* @__PURE__ */ Object.create(null)
              };
            }
          }, A.onBufferAppended = function(O, u) {
            var M = this, d = u.frag, c = u.part, v = u.timeRanges;
            if (d.type === y.PlaylistLevelType.MAIN)
              if (this.activeFragment !== d && (this.activeFragment = d, d.appendedPTS = void 0), c) {
                var g = this.activeParts;
                g || (this.activeParts = g = []), g.push(c);
              } else
                this.activeParts = null;
            this.timeRanges = v, Object.keys(v).forEach(function(m) {
              var D = v[m];
              if (M.detectEvictedFragments(m, D), !c && d.type === y.PlaylistLevelType.MAIN) {
                var L = d.elementaryStreams[m];
                if (!L)
                  return;
                for (var p = 0; p < D.length; p++) {
                  var x = D.end(p);
                  x <= L.endPTS && x > L.startPTS ? d.appendedPTS = Math.max(x, d.appendedPTS || 0) : d.appendedPTS = L.endPTS;
                }
              }
            });
          }, A.onFragBuffered = function(O, u) {
            this.detectPartialFragments(u);
          }, A.hasFragment = function(O) {
            var u = I(O);
            return !!this.fragments[u];
          }, A.removeFragmentsInRange = function(O, u, M) {
            var d = this;
            Object.keys(this.fragments).forEach(function(c) {
              var v = d.fragments[c];
              if (!!v && v.buffered) {
                var g = v.body;
                g.type === M && g.start < u && g.end > O && d.removeFragment(g);
              }
            });
          }, A.removeFragment = function(O) {
            var u = I(O);
            O.stats.loaded = 0, O.clearElementaryStreamInfo(), O.appendedPTS = void 0, delete this.fragments[u], O.endList && delete this.endListFragments[O.type];
          }, A.removeAllFragments = function() {
            this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activeFragment = null, this.activeParts = null;
          }, T;
        }();
        function B(T) {
          var A, w;
          return T.buffered && (((A = T.range.video) === null || A === void 0 ? void 0 : A.partial) || ((w = T.range.audio) === null || w === void 0 ? void 0 : w.partial));
        }
        function I(T) {
          return T.type + "_" + T.level + "_" + T.urlId + "_" + T.sn;
        }
      },
      "./src/controller/gap-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          MAX_START_GAP_JUMP: () => I,
          SKIP_BUFFER_HOLE_STEP_SECONDS: () => T,
          SKIP_BUFFER_RANGE_START: () => A,
          STALL_MINIMUM_DURATION_MS: () => B,
          default: () => w
        });
        var b = a("./src/utils/buffer-helper.ts"), y = a("./src/errors.ts"), N = a("./src/events.ts"), E = a("./src/utils/logger.ts"), B = 250, I = 2, T = 0.1, A = 0.05, w = /* @__PURE__ */ function() {
          function O(M, d, c, v) {
            this.config = void 0, this.media = null, this.fragmentTracker = void 0, this.hls = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.config = M, this.media = d, this.fragmentTracker = c, this.hls = v;
          }
          var u = O.prototype;
          return u.destroy = function() {
            this.media = null, this.hls = this.fragmentTracker = null;
          }, u.poll = function(d, c) {
            var v = this.config, g = this.media, m = this.stalled;
            if (g !== null) {
              var D = g.currentTime, L = g.seeking, p = this.seeking && !L, x = !this.seeking && L;
              if (this.seeking = L, D !== d) {
                if (this.moved = !0, m !== null) {
                  if (this.stallReported) {
                    var k = self.performance.now() - m;
                    E.logger.warn("playback not stuck anymore @" + D + ", after " + Math.round(k) + "ms"), this.stallReported = !1;
                  }
                  this.stalled = null, this.nudgeRetry = 0;
                }
                return;
              }
              if ((x || p) && (this.stalled = null), !(g.paused && !L || g.ended || g.playbackRate === 0 || !b.BufferHelper.getBuffered(g).length)) {
                var _ = b.BufferHelper.bufferInfo(g, D, 0), S = _.len > 0, h = _.nextStart || 0;
                if (!(!S && !h)) {
                  if (L) {
                    var C = _.len > I, f = !h || c && c.start <= D || h - D > I && !this.fragmentTracker.getPartialFragment(D);
                    if (C || f)
                      return;
                    this.moved = !1;
                  }
                  if (!this.moved && this.stalled !== null) {
                    var P, F = Math.max(h, _.start || 0) - D, R = this.hls.levels ? this.hls.levels[this.hls.currentLevel] : null, U = R == null || (P = R.details) === null || P === void 0 ? void 0 : P.live, K = U ? R.details.targetduration * 2 : I;
                    if (F > 0 && F <= K) {
                      this._trySkipBufferHole(null);
                      return;
                    }
                  }
                  var V = self.performance.now();
                  if (m === null) {
                    this.stalled = V;
                    return;
                  }
                  var W = V - m;
                  if (!(!L && W >= B && (this._reportStall(_), !this.media))) {
                    var G = b.BufferHelper.bufferInfo(g, D, v.maxBufferHole);
                    this._tryFixBufferStall(G, W);
                  }
                }
              }
            }
          }, u._tryFixBufferStall = function(d, c) {
            var v = this.config, g = this.fragmentTracker, m = this.media;
            if (m !== null) {
              var D = m.currentTime, L = g.getPartialFragment(D);
              if (L) {
                var p = this._trySkipBufferHole(L);
                if (p || !this.media)
                  return;
              }
              d.len > v.maxBufferHole && c > v.highBufferWatchdogPeriod * 1e3 && (E.logger.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
            }
          }, u._reportStall = function(d) {
            var c = this.hls, v = this.media, g = this.stallReported;
            !g && v && (this.stallReported = !0, E.logger.warn("Playback stalling at @" + v.currentTime + " due to low buffer (" + JSON.stringify(d) + ")"), c.trigger(N.Events.ERROR, {
              type: y.ErrorTypes.MEDIA_ERROR,
              details: y.ErrorDetails.BUFFER_STALLED_ERROR,
              fatal: !1,
              buffer: d.len
            }));
          }, u._trySkipBufferHole = function(d) {
            var c = this.config, v = this.hls, g = this.media;
            if (g === null)
              return 0;
            for (var m = g.currentTime, D = 0, L = b.BufferHelper.getBuffered(g), p = 0; p < L.length; p++) {
              var x = L.start(p);
              if (m + c.maxBufferHole >= D && m < x) {
                var k = Math.max(x + A, g.currentTime + T);
                return E.logger.warn("skipping hole, adjusting currentTime from " + m + " to " + k), this.moved = !0, this.stalled = null, g.currentTime = k, d && v.trigger(N.Events.ERROR, {
                  type: y.ErrorTypes.MEDIA_ERROR,
                  details: y.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                  fatal: !1,
                  reason: "fragment loaded with buffer holes, seeking from " + m + " to " + k,
                  frag: d
                }), k;
              }
              D = L.end(p);
            }
            return 0;
          }, u._tryNudgeBuffer = function() {
            var d = this.config, c = this.hls, v = this.media, g = this.nudgeRetry;
            if (v !== null) {
              var m = v.currentTime;
              if (this.nudgeRetry++, g < d.nudgeMaxRetry) {
                var D = m + (g + 1) * d.nudgeOffset;
                E.logger.warn("Nudging 'currentTime' from " + m + " to " + D), v.currentTime = D, c.trigger(N.Events.ERROR, {
                  type: y.ErrorTypes.MEDIA_ERROR,
                  details: y.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                  fatal: !1
                });
              } else
                E.logger.error("Playhead still not moving while enough data buffered @" + m + " after " + d.nudgeMaxRetry + " nudges"), c.trigger(N.Events.ERROR, {
                  type: y.ErrorTypes.MEDIA_ERROR,
                  details: y.ErrorDetails.BUFFER_STALLED_ERROR,
                  fatal: !0
                });
            }
          }, O;
        }();
      },
      "./src/controller/id3-track-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => d
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/events.ts"), N = a("./src/utils/texttrack-utils.ts"), E = a("./src/demux/id3.ts"), B = a("./src/loader/date-range.ts"), I = a("./src/types/demuxer.ts"), T = 0.25;
        function A() {
          return self.WebKitDataCue || self.VTTCue || self.TextTrackCue;
        }
        var w = function() {
          var c = A();
          try {
            new c(0, Number.POSITIVE_INFINITY, "");
          } catch {
            return Number.MAX_VALUE;
          }
          return Number.POSITIVE_INFINITY;
        }();
        function O(c, v) {
          return c.getTime() / 1e3 - v;
        }
        function u(c) {
          return Uint8Array.from(c.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
        }
        var M = /* @__PURE__ */ function() {
          function c(g) {
            this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = g, this._registerListeners();
          }
          var v = c.prototype;
          return v.destroy = function() {
            this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = null;
          }, v._registerListeners = function() {
            var m = this.hls;
            m.on(y.Events.MEDIA_ATTACHED, this.onMediaAttached, this), m.on(y.Events.MEDIA_DETACHING, this.onMediaDetaching, this), m.on(y.Events.MANIFEST_LOADING, this.onManifestLoading, this), m.on(y.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), m.on(y.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), m.on(y.Events.LEVEL_UPDATED, this.onLevelUpdated, this);
          }, v._unregisterListeners = function() {
            var m = this.hls;
            m.off(y.Events.MEDIA_ATTACHED, this.onMediaAttached, this), m.off(y.Events.MEDIA_DETACHING, this.onMediaDetaching, this), m.off(y.Events.MANIFEST_LOADING, this.onManifestLoading, this), m.off(y.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), m.off(y.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), m.off(y.Events.LEVEL_UPDATED, this.onLevelUpdated, this);
          }, v.onMediaAttached = function(m, D) {
            this.media = D.media;
          }, v.onMediaDetaching = function() {
            !this.id3Track || ((0, N.clearCurrentCues)(this.id3Track), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {});
          }, v.onManifestLoading = function() {
            this.dateRangeCuesAppended = {};
          }, v.createTrack = function(m) {
            var D = this.getID3Track(m.textTracks);
            return D.mode = "hidden", D;
          }, v.getID3Track = function(m) {
            if (!!this.media) {
              for (var D = 0; D < m.length; D++) {
                var L = m[D];
                if (L.kind === "metadata" && L.label === "id3")
                  return (0, N.sendAddTrackEvent)(L, this.media), L;
              }
              return this.media.addTextTrack("metadata", "id3");
            }
          }, v.onFragParsingMetadata = function(m, D) {
            if (!!this.media) {
              var L = this.hls.config, p = L.enableEmsgMetadataCues, x = L.enableID3MetadataCues;
              if (!(!p && !x)) {
                var k = D.samples;
                this.id3Track || (this.id3Track = this.createTrack(this.media));
                for (var _ = A(), S = 0; S < k.length; S++) {
                  var h = k[S].type;
                  if (!(h === I.MetadataSchema.emsg && !p || !x)) {
                    var C = E.getID3Frames(k[S].data);
                    if (C) {
                      var f = k[S].pts, P = f + k[S].duration;
                      P > w && (P = w);
                      var F = P - f;
                      F <= 0 && (P = f + T);
                      for (var R = 0; R < C.length; R++) {
                        var U = C[R];
                        if (!E.isTimeStampFrame(U)) {
                          this.updateId3CueEnds(f);
                          var K = new _(f, P, "");
                          K.value = U, h && (K.type = h), this.id3Track.addCue(K);
                        }
                      }
                    }
                  }
                }
              }
            }
          }, v.updateId3CueEnds = function(m) {
            var D, L = (D = this.id3Track) === null || D === void 0 ? void 0 : D.cues;
            if (L)
              for (var p = L.length; p--; ) {
                var x = L[p];
                x.startTime < m && x.endTime === w && (x.endTime = m);
              }
          }, v.onBufferFlushing = function(m, D) {
            var L = D.startOffset, p = D.endOffset, x = D.type, k = this.id3Track, _ = this.hls;
            if (!!_) {
              var S = _.config, h = S.enableEmsgMetadataCues, C = S.enableID3MetadataCues;
              if (k && (h || C)) {
                var f;
                x === "audio" ? f = function(F) {
                  return F.type === I.MetadataSchema.audioId3 && C;
                } : x === "video" ? f = function(F) {
                  return F.type === I.MetadataSchema.emsg && h;
                } : f = function(F) {
                  return F.type === I.MetadataSchema.audioId3 && C || F.type === I.MetadataSchema.emsg && h;
                }, (0, N.removeCuesInRange)(k, L, p, f);
              }
            }
          }, v.onLevelUpdated = function(m, D) {
            var L = this, p = D.details;
            if (!(!this.media || !p.hasProgramDateTime || !this.hls.config.enableDateRangeMetadataCues)) {
              var x = this.dateRangeCuesAppended, k = this.id3Track, _ = p.dateRanges, S = Object.keys(_);
              if (k)
                for (var h = Object.keys(x).filter(function(V) {
                  return !S.includes(V);
                }), C = function(W) {
                  var G = h[W];
                  Object.keys(x[G].cues).forEach(function(H) {
                    k.removeCue(x[G].cues[H]);
                  }), delete x[G];
                }, f = h.length; f--; )
                  C(f);
              var P = p.fragments[p.fragments.length - 1];
              if (!(S.length === 0 || !(0, b.isFiniteNumber)(P == null ? void 0 : P.programDateTime))) {
                this.id3Track || (this.id3Track = this.createTrack(this.media));
                for (var F = P.programDateTime / 1e3 - P.start, R = A(), U = function(W) {
                  var G = S[W], H = _[G], $ = x[G], Y = ($ == null ? void 0 : $.cues) || {}, z = ($ == null ? void 0 : $.durationKnown) || !1, X = O(H.startDate, F), Q = w, q = H.endDate;
                  if (q)
                    Q = O(q, F), z = !0;
                  else if (H.endOnNext && !z) {
                    var Z = S.reduce(function(le, pe) {
                      var ie = _[pe];
                      return ie.class === H.class && ie.id !== pe && ie.startDate > H.startDate && le.push(ie), le;
                    }, []).sort(function(le, pe) {
                      return le.startDate.getTime() - pe.startDate.getTime();
                    })[0];
                    Z && (Q = O(Z.startDate, F), z = !0);
                  }
                  for (var J = Object.keys(H.attr), te = 0; te < J.length; te++) {
                    var ne = J[te];
                    if (!(ne === B.DateRangeAttribute.ID || ne === B.DateRangeAttribute.CLASS || ne === B.DateRangeAttribute.START_DATE || ne === B.DateRangeAttribute.DURATION || ne === B.DateRangeAttribute.END_DATE || ne === B.DateRangeAttribute.END_ON_NEXT)) {
                      var re = Y[ne];
                      if (re)
                        z && !$.durationKnown && (re.endTime = Q);
                      else {
                        var ee = H.attr[ne];
                        re = new R(X, Q, ""), (ne === B.DateRangeAttribute.SCTE35_OUT || ne === B.DateRangeAttribute.SCTE35_IN) && (ee = u(ee)), re.value = {
                          key: ne,
                          data: ee
                        }, re.type = I.MetadataSchema.dateRange, L.id3Track.addCue(re), Y[ne] = re;
                      }
                    }
                  }
                  x[G] = {
                    cues: Y,
                    dateRange: H,
                    durationKnown: z
                  };
                }, K = 0; K < S.length; K++)
                  U(K);
              }
            }
          }, c;
        }();
        const d = M;
      },
      "./src/controller/latency-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => A
        });
        var b = a("./src/errors.ts"), y = a("./src/events.ts"), N = a("./src/utils/logger.ts");
        function E(w, O) {
          for (var u = 0; u < O.length; u++) {
            var M = O[u];
            M.enumerable = M.enumerable || !1, M.configurable = !0, "value" in M && (M.writable = !0), Object.defineProperty(w, I(M.key), M);
          }
        }
        function B(w, O, u) {
          return O && E(w.prototype, O), u && E(w, u), Object.defineProperty(w, "prototype", { writable: !1 }), w;
        }
        function I(w) {
          var O = T(w, "string");
          return typeof O == "symbol" ? O : String(O);
        }
        function T(w, O) {
          if (typeof w != "object" || w === null)
            return w;
          var u = w[Symbol.toPrimitive];
          if (u !== void 0) {
            var M = u.call(w, O || "default");
            if (typeof M != "object")
              return M;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (O === "string" ? String : Number)(w);
        }
        var A = /* @__PURE__ */ function() {
          function w(u) {
            var M = this;
            this.hls = void 0, this.config = void 0, this.media = null, this.levelDetails = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this.timeupdateHandler = function() {
              return M.timeupdate();
            }, this.hls = u, this.config = u.config, this.registerListeners();
          }
          var O = w.prototype;
          return O.destroy = function() {
            this.unregisterListeners(), this.onMediaDetaching(), this.levelDetails = null, this.hls = this.timeupdateHandler = null;
          }, O.registerListeners = function() {
            this.hls.on(y.Events.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(y.Events.MEDIA_DETACHING, this.onMediaDetaching, this), this.hls.on(y.Events.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(y.Events.LEVEL_UPDATED, this.onLevelUpdated, this), this.hls.on(y.Events.ERROR, this.onError, this);
          }, O.unregisterListeners = function() {
            this.hls.off(y.Events.MEDIA_ATTACHED, this.onMediaAttached), this.hls.off(y.Events.MEDIA_DETACHING, this.onMediaDetaching), this.hls.off(y.Events.MANIFEST_LOADING, this.onManifestLoading), this.hls.off(y.Events.LEVEL_UPDATED, this.onLevelUpdated), this.hls.off(y.Events.ERROR, this.onError);
          }, O.onMediaAttached = function(M, d) {
            this.media = d.media, this.media.addEventListener("timeupdate", this.timeupdateHandler);
          }, O.onMediaDetaching = function() {
            this.media && (this.media.removeEventListener("timeupdate", this.timeupdateHandler), this.media = null);
          }, O.onManifestLoading = function() {
            this.levelDetails = null, this._latency = null, this.stallCount = 0;
          }, O.onLevelUpdated = function(M, d) {
            var c = d.details;
            this.levelDetails = c, c.advanced && this.timeupdate(), !c.live && this.media && this.media.removeEventListener("timeupdate", this.timeupdateHandler);
          }, O.onError = function(M, d) {
            d.details === b.ErrorDetails.BUFFER_STALLED_ERROR && (this.stallCount++, N.logger.warn("[playback-rate-controller]: Stall detected, adjusting target latency"));
          }, O.timeupdate = function() {
            var M = this.media, d = this.levelDetails;
            if (!(!M || !d)) {
              this.currentTime = M.currentTime;
              var c = this.computeLatency();
              if (c !== null) {
                this._latency = c;
                var v = this.config, g = v.lowLatencyMode, m = v.maxLiveSyncPlaybackRate;
                if (!(!g || m === 1)) {
                  var D = this.targetLatency;
                  if (D !== null) {
                    var L = c - D, p = Math.min(this.maxLatency, D + d.targetduration), x = L < p;
                    if (d.live && x && L > 0.05 && this.forwardBufferLength > 1) {
                      var k = Math.min(2, Math.max(1, m)), _ = Math.round(2 / (1 + Math.exp(-0.75 * L - this.edgeStalled)) * 20) / 20;
                      M.playbackRate = Math.min(k, Math.max(1, _));
                    } else
                      M.playbackRate !== 1 && M.playbackRate !== 0 && (M.playbackRate = 1);
                  }
                }
              }
            }
          }, O.estimateLiveEdge = function() {
            var M = this.levelDetails;
            return M === null ? null : M.edge + M.age;
          }, O.computeLatency = function() {
            var M = this.estimateLiveEdge();
            return M === null ? null : M - this.currentTime;
          }, B(w, [{
            key: "latency",
            get: function() {
              return this._latency || 0;
            }
          }, {
            key: "maxLatency",
            get: function() {
              var M = this.config, d = this.levelDetails;
              return M.liveMaxLatencyDuration !== void 0 ? M.liveMaxLatencyDuration : d ? M.liveMaxLatencyDurationCount * d.targetduration : 0;
            }
          }, {
            key: "targetLatency",
            get: function() {
              var M = this.levelDetails;
              if (M === null)
                return null;
              var d = M.holdBack, c = M.partHoldBack, v = M.targetduration, g = this.config, m = g.liveSyncDuration, D = g.liveSyncDurationCount, L = g.lowLatencyMode, p = this.hls.userConfig, x = L && c || d;
              (p.liveSyncDuration || p.liveSyncDurationCount || x === 0) && (x = m !== void 0 ? m : D * v);
              var k = v, _ = 1;
              return x + Math.min(this.stallCount * _, k);
            }
          }, {
            key: "liveSyncPosition",
            get: function() {
              var M = this.estimateLiveEdge(), d = this.targetLatency, c = this.levelDetails;
              if (M === null || d === null || c === null)
                return null;
              var v = c.edge, g = M - d - this.edgeStalled, m = v - c.totalduration, D = v - (this.config.lowLatencyMode && c.partTarget || c.targetduration);
              return Math.min(Math.max(m, g), D);
            }
          }, {
            key: "drift",
            get: function() {
              var M = this.levelDetails;
              return M === null ? 1 : M.drift;
            }
          }, {
            key: "edgeStalled",
            get: function() {
              var M = this.levelDetails;
              if (M === null)
                return 0;
              var d = (this.config.lowLatencyMode && M.partTarget || M.targetduration) * 3;
              return Math.max(M.age - d, 0);
            }
          }, {
            key: "forwardBufferLength",
            get: function() {
              var M = this.media, d = this.levelDetails;
              if (!M || !d)
                return 0;
              var c = M.buffered.length;
              return (c ? M.buffered.end(c - 1) : d.edge) - this.currentTime;
            }
          }]), w;
        }();
      },
      "./src/controller/level-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => g
        });
        var b = a("./src/types/level.ts"), y = a("./src/events.ts"), N = a("./src/errors.ts"), E = a("./src/utils/codecs.ts"), B = a("./src/controller/level-helper.ts"), I = a("./src/controller/base-playlist-controller.ts"), T = a("./src/types/loader.ts");
        function A() {
          return A = Object.assign ? Object.assign.bind() : function(m) {
            for (var D = 1; D < arguments.length; D++) {
              var L = arguments[D];
              for (var p in L)
                Object.prototype.hasOwnProperty.call(L, p) && (m[p] = L[p]);
            }
            return m;
          }, A.apply(this, arguments);
        }
        function w(m, D) {
          for (var L = 0; L < D.length; L++) {
            var p = D[L];
            p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(m, u(p.key), p);
          }
        }
        function O(m, D, L) {
          return D && w(m.prototype, D), L && w(m, L), Object.defineProperty(m, "prototype", { writable: !1 }), m;
        }
        function u(m) {
          var D = M(m, "string");
          return typeof D == "symbol" ? D : String(D);
        }
        function M(m, D) {
          if (typeof m != "object" || m === null)
            return m;
          var L = m[Symbol.toPrimitive];
          if (L !== void 0) {
            var p = L.call(m, D || "default");
            if (typeof p != "object")
              return p;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (D === "string" ? String : Number)(m);
        }
        function d(m, D) {
          m.prototype = Object.create(D.prototype), m.prototype.constructor = m, c(m, D);
        }
        function c(m, D) {
          return c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(p, x) {
            return p.__proto__ = x, p;
          }, c(m, D);
        }
        var v = /chrome|firefox/.test(navigator.userAgent.toLowerCase()), g = /* @__PURE__ */ function(m) {
          d(D, m);
          function D(p) {
            var x;
            return x = m.call(this, p, "[level-controller]") || this, x._levels = [], x._firstLevel = -1, x._startLevel = void 0, x.currentLevelIndex = -1, x.manualLevelIndex = -1, x.onParsedComplete = void 0, x._registerListeners(), x;
          }
          var L = D.prototype;
          return L._registerListeners = function() {
            var x = this.hls;
            x.on(y.Events.MANIFEST_LOADED, this.onManifestLoaded, this), x.on(y.Events.LEVEL_LOADED, this.onLevelLoaded, this), x.on(y.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), x.on(y.Events.FRAG_LOADED, this.onFragLoaded, this), x.on(y.Events.ERROR, this.onError, this);
          }, L._unregisterListeners = function() {
            var x = this.hls;
            x.off(y.Events.MANIFEST_LOADED, this.onManifestLoaded, this), x.off(y.Events.LEVEL_LOADED, this.onLevelLoaded, this), x.off(y.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), x.off(y.Events.FRAG_LOADED, this.onFragLoaded, this), x.off(y.Events.ERROR, this.onError, this);
          }, L.destroy = function() {
            this._unregisterListeners(), this.manualLevelIndex = -1, this._levels.length = 0, m.prototype.destroy.call(this);
          }, L.startLoad = function() {
            var x = this._levels;
            x.forEach(function(k) {
              k.loadError = 0;
            }), m.prototype.startLoad.call(this);
          }, L.onManifestLoaded = function(x, k) {
            var _ = [], S = [], h = [], C, f = {}, P, F = !1, R = !1, U = !1;
            if (k.levels.forEach(function(G) {
              var H = G.attrs;
              F = F || !!(G.width && G.height), R = R || !!G.videoCodec, U = U || !!G.audioCodec, v && G.audioCodec && G.audioCodec.indexOf("mp4a.40.34") !== -1 && (G.audioCodec = void 0);
              var $ = G.bitrate + "-" + G.attrs.RESOLUTION + "-" + G.attrs.CODECS;
              P = f[$], P ? P.url.push(G.url) : (P = new b.Level(G), f[$] = P, _.push(P)), H && (H.AUDIO && (0, B.addGroupId)(P, "audio", H.AUDIO), H.SUBTITLES && (0, B.addGroupId)(P, "text", H.SUBTITLES));
            }), (F || R) && U && (_ = _.filter(function(G) {
              var H = G.videoCodec, $ = G.width, Y = G.height;
              return !!H || !!($ && Y);
            })), _ = _.filter(function(G) {
              var H = G.audioCodec, $ = G.videoCodec;
              return (!H || (0, E.isCodecSupportedInMp4)(H, "audio")) && (!$ || (0, E.isCodecSupportedInMp4)($, "video"));
            }), k.audioTracks && (S = k.audioTracks.filter(function(G) {
              return !G.audioCodec || (0, E.isCodecSupportedInMp4)(G.audioCodec, "audio");
            }), (0, B.assignTrackIdsByGroup)(S)), k.subtitles && (h = k.subtitles, (0, B.assignTrackIdsByGroup)(h)), _.length > 0) {
              C = _[0].bitrate, _.sort(function(G, H) {
                return G.attrs["HDCP-LEVEL"] !== H.attrs["HDCP-LEVEL"] ? (G.attrs["HDCP-LEVEL"] || "") > (H.attrs["HDCP-LEVEL"] || "") ? 1 : -1 : G.bitrate !== H.bitrate ? G.bitrate - H.bitrate : G.attrs.SCORE !== H.attrs.SCORE ? G.attrs.decimalFloatingPoint("SCORE") - H.attrs.decimalFloatingPoint("SCORE") : F && G.height !== H.height ? G.height - H.height : 0;
              }), this._levels = _;
              for (var K = 0; K < _.length; K++)
                if (_[K].bitrate === C) {
                  this._firstLevel = K, this.log("manifest loaded, " + _.length + " level(s) found, first bitrate: " + C);
                  break;
                }
              var V = U && !R, W = {
                levels: _,
                audioTracks: S,
                subtitleTracks: h,
                sessionData: k.sessionData,
                sessionKeys: k.sessionKeys,
                firstLevel: this._firstLevel,
                stats: k.stats,
                audio: U,
                video: R,
                altAudio: !V && S.some(function(G) {
                  return !!G.url;
                })
              };
              this.hls.trigger(y.Events.MANIFEST_PARSED, W), (this.hls.config.autoStartLoad || this.hls.forceStartLoad) && this.hls.startLoad(this.hls.config.startPosition);
            } else
              this.hls.trigger(y.Events.ERROR, {
                type: N.ErrorTypes.MEDIA_ERROR,
                details: N.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                fatal: !0,
                url: k.url,
                reason: "no level with compatible codecs found in manifest"
              });
          }, L.onError = function(x, k) {
            var _, S;
            if (m.prototype.onError.call(this, x, k), !k.fatal) {
              var h = k.context, C = this._levels[this.currentLevelIndex];
              if (h && (h.type === T.PlaylistContextType.AUDIO_TRACK && C.audioGroupIds && h.groupId === C.audioGroupIds[C.urlId] || h.type === T.PlaylistContextType.SUBTITLE_TRACK && C.textGroupIds && h.groupId === C.textGroupIds[C.urlId])) {
                this.redundantFailover(this.currentLevelIndex);
                return;
              }
              var f = !1, P = !0, F;
              switch (k.details) {
                case N.ErrorDetails.FRAG_LOAD_ERROR:
                case N.ErrorDetails.FRAG_LOAD_TIMEOUT:
                case N.ErrorDetails.KEY_LOAD_ERROR:
                case N.ErrorDetails.KEY_LOAD_TIMEOUT:
                  if (k.frag) {
                    var R = k.frag.type === T.PlaylistLevelType.MAIN ? k.frag.level : this.currentLevelIndex, U = this._levels[R];
                    U ? (U.fragmentError++, U.fragmentError > this.hls.config.fragLoadingMaxRetry && (F = R)) : F = R;
                  }
                  break;
                case N.ErrorDetails.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED: {
                  var K = C.attrs["HDCP-LEVEL"];
                  K && (this.hls.maxHdcpLevel = b.HdcpLevels[b.HdcpLevels.indexOf(K) - 1], this.warn('Restricting playback to HDCP-LEVEL of "' + this.hls.maxHdcpLevel + '" or lower'));
                }
                case N.ErrorDetails.FRAG_PARSING_ERROR:
                case N.ErrorDetails.KEY_SYSTEM_NO_SESSION:
                  F = ((_ = k.frag) === null || _ === void 0 ? void 0 : _.type) === T.PlaylistLevelType.MAIN ? k.frag.level : this.currentLevelIndex, k.levelRetry = !1;
                  break;
                case N.ErrorDetails.LEVEL_LOAD_ERROR:
                case N.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                  h && (h.deliveryDirectives && (P = !1), F = h.level), f = !0;
                  break;
                case N.ErrorDetails.REMUX_ALLOC_ERROR:
                  F = (S = k.level) != null ? S : this.currentLevelIndex, f = !0;
                  break;
              }
              F !== void 0 && this.recoverLevel(k, F, f, P);
            }
          }, L.recoverLevel = function(x, k, _, S) {
            var h = x.details, C = this._levels[k];
            if (C.loadError++, _) {
              var f = this.retryLoadingOrFail(x);
              if (f)
                x.levelRetry = !0;
              else {
                this.currentLevelIndex = -1;
                return;
              }
            }
            if (S) {
              var P = C.url.length;
              if (P > 1 && C.loadError < P)
                x.levelRetry = !0, this.redundantFailover(k);
              else if (this.manualLevelIndex === -1) {
                for (var F = -1, R = this._levels, U = R.length; U--; ) {
                  var K = (U + this.currentLevelIndex) % R.length;
                  if (K !== this.currentLevelIndex && R[K].loadError === 0) {
                    F = K;
                    break;
                  }
                }
                F > -1 && this.currentLevelIndex !== F ? (this.warn(h + ": switch to " + F), x.levelRetry = !0, this.hls.nextAutoLevel = F) : x.levelRetry === !1 && (x.fatal = !0);
              }
            }
          }, L.redundantFailover = function(x) {
            var k = this._levels[x], _ = k.url.length;
            if (_ > 1) {
              var S = (k.urlId + 1) % _;
              this.warn("Switching to redundant URL-id " + S), this._levels.forEach(function(h) {
                h.urlId = S;
              }), this.level = x;
            }
          }, L.onFragLoaded = function(x, k) {
            var _ = k.frag;
            if (_ !== void 0 && _.type === T.PlaylistLevelType.MAIN) {
              var S = this._levels[_.level];
              S !== void 0 && (S.fragmentError = 0, S.loadError = 0);
            }
          }, L.onLevelLoaded = function(x, k) {
            var _, S = k.level, h = k.details, C = this._levels[S];
            if (!C) {
              var f;
              this.warn("Invalid level index " + S), (f = k.deliveryDirectives) !== null && f !== void 0 && f.skip && (h.deltaUpdateFailed = !0);
              return;
            }
            S === this.currentLevelIndex ? (C.fragmentError === 0 && (C.loadError = 0, this.retryCount = 0), this.playlistLoaded(S, k, C.details)) : (_ = k.deliveryDirectives) !== null && _ !== void 0 && _.skip && (h.deltaUpdateFailed = !0);
          }, L.onAudioTrackSwitched = function(x, k) {
            var _ = this.hls.levels[this.currentLevelIndex];
            if (!!_ && _.audioGroupIds) {
              for (var S = -1, h = this.hls.audioTracks[k.id].groupId, C = 0; C < _.audioGroupIds.length; C++)
                if (_.audioGroupIds[C] === h) {
                  S = C;
                  break;
                }
              S !== _.urlId && (_.urlId = S, this.startLoad());
            }
          }, L.loadPlaylist = function(x) {
            m.prototype.loadPlaylist.call(this);
            var k = this.currentLevelIndex, _ = this._levels[k];
            if (this.canLoad && _ && _.url.length > 0) {
              var S = _.urlId, h = _.url[S];
              if (x)
                try {
                  h = x.addDirectives(h);
                } catch (C) {
                  this.warn("Could not construct new URL with HLS Delivery Directives: " + C);
                }
              this.log("Attempt loading level index " + k + ((x == null ? void 0 : x.msn) !== void 0 ? " at sn " + x.msn + " part " + x.part : "") + " with URL-id " + S + " " + h), this.clearTimer(), this.hls.trigger(y.Events.LEVEL_LOADING, {
                url: h,
                level: k,
                id: S,
                deliveryDirectives: x || null
              });
            }
          }, L.removeLevel = function(x, k) {
            var _ = function(C, f) {
              return f !== k;
            }, S = this._levels.filter(function(h, C) {
              return C !== x ? !0 : h.url.length > 1 && k !== void 0 ? (h.url = h.url.filter(_), h.audioGroupIds && (h.audioGroupIds = h.audioGroupIds.filter(_)), h.textGroupIds && (h.textGroupIds = h.textGroupIds.filter(_)), h.urlId = 0, !0) : !1;
            }).map(function(h, C) {
              var f = h.details;
              return f != null && f.fragments && f.fragments.forEach(function(P) {
                P.level = C;
              }), h;
            });
            this._levels = S, this.hls.trigger(y.Events.LEVELS_UPDATED, {
              levels: S
            });
          }, O(D, [{
            key: "levels",
            get: function() {
              return this._levels.length === 0 ? null : this._levels;
            }
          }, {
            key: "level",
            get: function() {
              return this.currentLevelIndex;
            },
            set: function(x) {
              var k, _ = this._levels;
              if (_.length !== 0 && !(this.currentLevelIndex === x && (k = _[x]) !== null && k !== void 0 && k.details)) {
                if (x < 0 || x >= _.length) {
                  var S = x < 0;
                  if (this.hls.trigger(y.Events.ERROR, {
                    type: N.ErrorTypes.OTHER_ERROR,
                    details: N.ErrorDetails.LEVEL_SWITCH_ERROR,
                    level: x,
                    fatal: S,
                    reason: "invalid level idx"
                  }), S)
                    return;
                  x = Math.min(x, _.length - 1);
                }
                this.clearTimer();
                var h = this.currentLevelIndex, C = _[h], f = _[x];
                this.log("switching to level " + x + " from " + h), this.currentLevelIndex = x;
                var P = A({}, f, {
                  level: x,
                  maxBitrate: f.maxBitrate,
                  uri: f.uri,
                  urlId: f.urlId
                });
                delete P._urlId, this.hls.trigger(y.Events.LEVEL_SWITCHING, P);
                var F = f.details;
                if (!F || F.live) {
                  var R = this.switchParams(f.uri, C == null ? void 0 : C.details);
                  this.loadPlaylist(R);
                }
              }
            }
          }, {
            key: "manualLevel",
            get: function() {
              return this.manualLevelIndex;
            },
            set: function(x) {
              this.manualLevelIndex = x, this._startLevel === void 0 && (this._startLevel = x), x !== -1 && (this.level = x);
            }
          }, {
            key: "firstLevel",
            get: function() {
              return this._firstLevel;
            },
            set: function(x) {
              this._firstLevel = x;
            }
          }, {
            key: "startLevel",
            get: function() {
              if (this._startLevel === void 0) {
                var x = this.hls.config.startLevel;
                return x !== void 0 ? x : this._firstLevel;
              } else
                return this._startLevel;
            },
            set: function(x) {
              this._startLevel = x;
            }
          }, {
            key: "nextLoadLevel",
            get: function() {
              return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
            },
            set: function(x) {
              this.level = x, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = x);
            }
          }]), D;
        }(I.default);
      },
      "./src/controller/level-helper.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          addGroupId: () => B,
          addSliding: () => v,
          adjustSliding: () => c,
          assignTrackIdsByGroup: () => I,
          computeReloadInterval: () => g,
          getFragmentWithSN: () => m,
          getPartWith: () => D,
          mapFragmentIntersection: () => d,
          mapPartIntersection: () => M,
          mergeDetails: () => O,
          updateFragPTSDTS: () => w,
          updatePTS: () => T
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/utils/logger.ts"), N = a("./src/loader/date-range.ts");
        function E() {
          return E = Object.assign ? Object.assign.bind() : function(L) {
            for (var p = 1; p < arguments.length; p++) {
              var x = arguments[p];
              for (var k in x)
                Object.prototype.hasOwnProperty.call(x, k) && (L[k] = x[k]);
            }
            return L;
          }, E.apply(this, arguments);
        }
        function B(L, p, x) {
          switch (p) {
            case "audio":
              L.audioGroupIds || (L.audioGroupIds = []), L.audioGroupIds.push(x);
              break;
            case "text":
              L.textGroupIds || (L.textGroupIds = []), L.textGroupIds.push(x);
              break;
          }
        }
        function I(L) {
          var p = {};
          L.forEach(function(x) {
            var k = x.groupId || "";
            x.id = p[k] = p[k] || 0, p[k]++;
          });
        }
        function T(L, p, x) {
          var k = L[p], _ = L[x];
          A(k, _);
        }
        function A(L, p) {
          var x = p.startPTS;
          if ((0, b.isFiniteNumber)(x)) {
            var k = 0, _;
            p.sn > L.sn ? (k = x - L.start, _ = L) : (k = L.start - x, _ = p), _.duration !== k && (_.duration = k);
          } else if (p.sn > L.sn) {
            var S = L.cc === p.cc;
            S && L.minEndPTS ? p.start = L.start + (L.minEndPTS - L.start) : p.start = L.start + L.duration;
          } else
            p.start = Math.max(L.start - p.duration, 0);
        }
        function w(L, p, x, k, _, S) {
          var h = k - x;
          h <= 0 && (y.logger.warn("Fragment should have a positive duration", p), k = x + p.duration, S = _ + p.duration);
          var C = x, f = k, P = p.startPTS, F = p.endPTS;
          if ((0, b.isFiniteNumber)(P)) {
            var R = Math.abs(P - x);
            (0, b.isFiniteNumber)(p.deltaPTS) ? p.deltaPTS = Math.max(R, p.deltaPTS) : p.deltaPTS = R, C = Math.max(x, P), x = Math.min(x, P), _ = Math.min(_, p.startDTS), f = Math.min(k, F), k = Math.max(k, F), S = Math.max(S, p.endDTS);
          }
          p.duration = k - x;
          var U = x - p.start;
          p.start = p.startPTS = x, p.maxStartPTS = C, p.startDTS = _, p.endPTS = k, p.minEndPTS = f, p.endDTS = S;
          var K = p.sn;
          if (!L || K < L.startSN || K > L.endSN)
            return 0;
          var V, W = K - L.startSN, G = L.fragments;
          for (G[W] = p, V = W; V > 0; V--)
            A(G[V], G[V - 1]);
          for (V = W; V < G.length - 1; V++)
            A(G[V], G[V + 1]);
          return L.fragmentHint && A(G[G.length - 1], L.fragmentHint), L.PTSKnown = L.alignedSliding = !0, U;
        }
        function O(L, p) {
          for (var x = null, k = L.fragments, _ = k.length - 1; _ >= 0; _--) {
            var S = k[_].initSegment;
            if (S) {
              x = S;
              break;
            }
          }
          L.fragmentHint && delete L.fragmentHint.endPTS;
          var h = 0, C;
          if (d(L, p, function(V, W) {
            V.relurl && (h = V.cc - W.cc), (0, b.isFiniteNumber)(V.startPTS) && (0, b.isFiniteNumber)(V.endPTS) && (W.start = W.startPTS = V.startPTS, W.startDTS = V.startDTS, W.appendedPTS = V.appendedPTS, W.maxStartPTS = V.maxStartPTS, W.endPTS = V.endPTS, W.endDTS = V.endDTS, W.minEndPTS = V.minEndPTS, W.duration = V.endPTS - V.startPTS, W.duration && (C = W), p.PTSKnown = p.alignedSliding = !0), W.elementaryStreams = V.elementaryStreams, W.loader = V.loader, W.stats = V.stats, W.urlId = V.urlId, V.initSegment && (W.initSegment = V.initSegment, x = V.initSegment);
          }), x) {
            var f = p.fragmentHint ? p.fragments.concat(p.fragmentHint) : p.fragments;
            f.forEach(function(V) {
              var W;
              (!V.initSegment || V.initSegment.relurl === ((W = x) === null || W === void 0 ? void 0 : W.relurl)) && (V.initSegment = x);
            });
          }
          if (p.skippedSegments)
            if (p.deltaUpdateFailed = p.fragments.some(function(V) {
              return !V;
            }), p.deltaUpdateFailed) {
              y.logger.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
              for (var P = p.skippedSegments; P--; )
                p.fragments.shift();
              p.startSN = p.fragments[0].sn, p.startCC = p.fragments[0].cc;
            } else
              p.canSkipDateRanges && (p.dateRanges = u(L.dateRanges, p.dateRanges, p.recentlyRemovedDateranges));
          var F = p.fragments;
          if (h) {
            y.logger.warn("discontinuity sliding from playlist, take drift into account");
            for (var R = 0; R < F.length; R++)
              F[R].cc += h;
          }
          p.skippedSegments && (p.startCC = p.fragments[0].cc), M(L.partList, p.partList, function(V, W) {
            W.elementaryStreams = V.elementaryStreams, W.stats = V.stats;
          }), C ? w(p, C, C.startPTS, C.endPTS, C.startDTS, C.endDTS) : c(L, p), F.length && (p.totalduration = p.edge - F[0].start), p.driftStartTime = L.driftStartTime, p.driftStart = L.driftStart;
          var U = p.advancedDateTime;
          if (p.advanced && U) {
            var K = p.edge;
            p.driftStart || (p.driftStartTime = U, p.driftStart = K), p.driftEndTime = U, p.driftEnd = K;
          } else
            p.driftEndTime = L.driftEndTime, p.driftEnd = L.driftEnd, p.advancedDateTime = L.advancedDateTime;
        }
        function u(L, p, x) {
          var k = E({}, L);
          return x && x.forEach(function(_) {
            delete k[_];
          }), Object.keys(p).forEach(function(_) {
            var S = new N.DateRange(p[_].attr, k[_]);
            S.isValid ? k[_] = S : y.logger.warn('Ignoring invalid Playlist Delta Update DATERANGE tag: "' + JSON.stringify(p[_].attr) + '"');
          }), k;
        }
        function M(L, p, x) {
          if (L && p)
            for (var k = 0, _ = 0, S = L.length; _ <= S; _++) {
              var h = L[_], C = p[_ + k];
              h && C && h.index === C.index && h.fragment.sn === C.fragment.sn ? x(h, C) : k--;
            }
        }
        function d(L, p, x) {
          for (var k = p.skippedSegments, _ = Math.max(L.startSN, p.startSN) - p.startSN, S = (L.fragmentHint ? 1 : 0) + (k ? p.endSN : Math.min(L.endSN, p.endSN)) - p.startSN, h = p.startSN - L.startSN, C = p.fragmentHint ? p.fragments.concat(p.fragmentHint) : p.fragments, f = L.fragmentHint ? L.fragments.concat(L.fragmentHint) : L.fragments, P = _; P <= S; P++) {
            var F = f[h + P], R = C[P];
            k && !R && P < k && (R = p.fragments[P] = F), F && R && x(F, R);
          }
        }
        function c(L, p) {
          var x = p.startSN + p.skippedSegments - L.startSN, k = L.fragments;
          x < 0 || x >= k.length || v(p, k[x].start);
        }
        function v(L, p) {
          if (p) {
            for (var x = L.fragments, k = L.skippedSegments; k < x.length; k++)
              x[k].start += p;
            L.fragmentHint && (L.fragmentHint.start += p);
          }
        }
        function g(L, p) {
          p === void 0 && (p = 1 / 0);
          var x = 1e3 * L.targetduration;
          if (L.updated) {
            var k = L.fragments, _ = 4;
            if (k.length && x * _ > p) {
              var S = k[k.length - 1].duration * 1e3;
              S < x && (x = S);
            }
          } else
            x /= 2;
          return Math.round(x);
        }
        function m(L, p, x) {
          if (!L || !L.details)
            return null;
          var k = L.details, _ = k.fragments[p - k.startSN];
          return _ || (_ = k.fragmentHint, _ && _.sn === p) ? _ : p < k.startSN && x && x.sn === p ? x : null;
        }
        function D(L, p, x) {
          if (!L || !L.details)
            return null;
          var k = L.details.partList;
          if (k)
            for (var _ = k.length; _--; ) {
              var S = k[_];
              if (S.index === x && S.fragment.sn === p)
                return S;
            }
          return null;
        }
      },
      "./src/controller/stream-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => p
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/controller/base-stream-controller.ts"), N = a("./src/is-supported.ts"), E = a("./src/events.ts"), B = a("./src/utils/buffer-helper.ts"), I = a("./src/controller/fragment-tracker.ts"), T = a("./src/types/loader.ts"), A = a("./src/loader/fragment.ts"), w = a("./src/demux/transmuxer-interface.ts"), O = a("./src/types/transmuxer.ts"), u = a("./src/controller/gap-controller.ts"), M = a("./src/errors.ts");
        function d(x, k) {
          for (var _ = 0; _ < k.length; _++) {
            var S = k[_];
            S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(x, v(S.key), S);
          }
        }
        function c(x, k, _) {
          return k && d(x.prototype, k), _ && d(x, _), Object.defineProperty(x, "prototype", { writable: !1 }), x;
        }
        function v(x) {
          var k = g(x, "string");
          return typeof k == "symbol" ? k : String(k);
        }
        function g(x, k) {
          if (typeof x != "object" || x === null)
            return x;
          var _ = x[Symbol.toPrimitive];
          if (_ !== void 0) {
            var S = _.call(x, k || "default");
            if (typeof S != "object")
              return S;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (k === "string" ? String : Number)(x);
        }
        function m(x, k) {
          x.prototype = Object.create(k.prototype), x.prototype.constructor = x, D(x, k);
        }
        function D(x, k) {
          return D = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(S, h) {
            return S.__proto__ = h, S;
          }, D(x, k);
        }
        var L = 100, p = /* @__PURE__ */ function(x) {
          m(k, x);
          function k(S, h, C) {
            var f;
            return f = x.call(this, S, h, C, "[stream-controller]") || this, f.audioCodecSwap = !1, f.gapController = null, f.level = -1, f._forceStartLoad = !1, f.altAudio = !1, f.audioOnly = !1, f.fragPlaying = null, f.onvplaying = null, f.onvseeked = null, f.fragLastKbps = 0, f.couldBacktrack = !1, f.backtrackFragment = null, f.audioCodecSwitch = !1, f.videoBuffer = null, f._registerListeners(), f;
          }
          var _ = k.prototype;
          return _._registerListeners = function() {
            var h = this.hls;
            h.on(E.Events.MEDIA_ATTACHED, this.onMediaAttached, this), h.on(E.Events.MEDIA_DETACHING, this.onMediaDetaching, this), h.on(E.Events.MANIFEST_LOADING, this.onManifestLoading, this), h.on(E.Events.MANIFEST_PARSED, this.onManifestParsed, this), h.on(E.Events.LEVEL_LOADING, this.onLevelLoading, this), h.on(E.Events.LEVEL_LOADED, this.onLevelLoaded, this), h.on(E.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), h.on(E.Events.ERROR, this.onError, this), h.on(E.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), h.on(E.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), h.on(E.Events.BUFFER_CREATED, this.onBufferCreated, this), h.on(E.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), h.on(E.Events.LEVELS_UPDATED, this.onLevelsUpdated, this), h.on(E.Events.FRAG_BUFFERED, this.onFragBuffered, this);
          }, _._unregisterListeners = function() {
            var h = this.hls;
            h.off(E.Events.MEDIA_ATTACHED, this.onMediaAttached, this), h.off(E.Events.MEDIA_DETACHING, this.onMediaDetaching, this), h.off(E.Events.MANIFEST_LOADING, this.onManifestLoading, this), h.off(E.Events.MANIFEST_PARSED, this.onManifestParsed, this), h.off(E.Events.LEVEL_LOADED, this.onLevelLoaded, this), h.off(E.Events.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), h.off(E.Events.ERROR, this.onError, this), h.off(E.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), h.off(E.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), h.off(E.Events.BUFFER_CREATED, this.onBufferCreated, this), h.off(E.Events.BUFFER_FLUSHED, this.onBufferFlushed, this), h.off(E.Events.LEVELS_UPDATED, this.onLevelsUpdated, this), h.off(E.Events.FRAG_BUFFERED, this.onFragBuffered, this);
          }, _.onHandlerDestroying = function() {
            this._unregisterListeners(), this.onMediaDetaching();
          }, _.startLoad = function(h) {
            if (this.levels) {
              var C = this.lastCurrentTime, f = this.hls;
              if (this.stopLoad(), this.setInterval(L), this.level = -1, this.fragLoadError = 0, !this.startFragRequested) {
                var P = f.startLevel;
                P === -1 && (f.config.testBandwidth && this.levels.length > 1 ? (P = 0, this.bitrateTest = !0) : P = f.nextAutoLevel), this.level = f.nextLoadLevel = P, this.loadedmetadata = !1;
              }
              C > 0 && h === -1 && (this.log("Override startPosition with lastCurrentTime @" + C.toFixed(3)), h = C), this.state = y.State.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = h, this.tick();
            } else
              this._forceStartLoad = !0, this.state = y.State.STOPPED;
          }, _.stopLoad = function() {
            this._forceStartLoad = !1, x.prototype.stopLoad.call(this);
          }, _.doTick = function() {
            switch (this.state) {
              case y.State.IDLE:
                this.doTickIdle();
                break;
              case y.State.WAITING_LEVEL: {
                var h, C = this.levels, f = this.level, P = C == null || (h = C[f]) === null || h === void 0 ? void 0 : h.details;
                if (P && (!P.live || this.levelLastLoaded === this.level)) {
                  if (this.waitForCdnTuneIn(P))
                    break;
                  this.state = y.State.IDLE;
                  break;
                }
                break;
              }
              case y.State.FRAG_LOADING_WAITING_RETRY:
                {
                  var F, R = self.performance.now(), U = this.retryDate;
                  (!U || R >= U || (F = this.media) !== null && F !== void 0 && F.seeking) && (this.log("retryDate reached, switch back to IDLE state"), this.resetStartWhenNotLoaded(this.level), this.state = y.State.IDLE);
                }
                break;
            }
            this.onTickEnd();
          }, _.onTickEnd = function() {
            x.prototype.onTickEnd.call(this), this.checkBuffer(), this.checkFragmentChanged();
          }, _.doTickIdle = function() {
            var h = this.hls, C = this.levelLastLoaded, f = this.levels, P = this.media, F = h.config, R = h.nextLoadLevel;
            if (!(C === null || !P && (this.startFragRequested || !F.startFragPrefetch)) && !(this.altAudio && this.audioOnly) && !(!f || !f[R])) {
              var U = f[R], K = this.getMainFwdBufferInfo();
              if (K !== null) {
                var V = this.getLevelDetails();
                if (V && this._streamEnded(K, V)) {
                  var W = {};
                  this.altAudio && (W.type = "video"), this.hls.trigger(E.Events.BUFFER_EOS, W), this.state = y.State.ENDED;
                  return;
                }
                this.level = h.nextLoadLevel = R;
                var G = U.details;
                if (!G || this.state === y.State.WAITING_LEVEL || G.live && this.levelLastLoaded !== R) {
                  this.level = R, this.state = y.State.WAITING_LEVEL;
                  return;
                }
                var H = K.len, $ = this.getMaxBufferLength(U.maxBitrate);
                if (!(H >= $)) {
                  this.backtrackFragment && this.backtrackFragment.start > K.end && (this.backtrackFragment = null);
                  var Y = this.backtrackFragment ? this.backtrackFragment.start : K.end, z = this.getNextFragment(Y, G);
                  if (this.couldBacktrack && !this.fragPrevious && z && z.sn !== "initSegment" && this.fragmentTracker.getState(z) !== I.FragmentState.OK) {
                    var X, Q = ((X = this.backtrackFragment) != null ? X : z).sn, q = Q - G.startSN, Z = G.fragments[q - 1];
                    Z && z.cc === Z.cc && (z = Z, this.fragmentTracker.removeFragment(Z));
                  } else
                    this.backtrackFragment && K.len && (this.backtrackFragment = null);
                  if (z && this.fragmentTracker.getState(z) === I.FragmentState.OK && this.nextLoadPosition > Y) {
                    var J = this.audioOnly && !this.altAudio ? A.ElementaryStreamTypes.AUDIO : A.ElementaryStreamTypes.VIDEO, te = (J === A.ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
                    te && this.afterBufferFlushed(te, J, T.PlaylistLevelType.MAIN), z = this.getNextFragment(this.nextLoadPosition, G);
                  }
                  !z || (z.initSegment && !z.initSegment.data && !this.bitrateTest && (z = z.initSegment), this.loadFragment(z, G, Y));
                }
              }
            }
          }, _.loadFragment = function(h, C, f) {
            var P, F = this.fragmentTracker.getState(h);
            this.fragCurrent = h, F === I.FragmentState.NOT_LOADED ? h.sn === "initSegment" ? this._loadInitSegment(h, C) : this.bitrateTest ? (this.log("Fragment " + h.sn + " of level " + h.level + " is being downloaded to test bitrate and will not be buffered"), this._loadBitrateTestFrag(h, C)) : (this.startFragRequested = !0, x.prototype.loadFragment.call(this, h, C, f)) : F === I.FragmentState.APPENDING ? this.reduceMaxBufferLength(h.duration) && this.fragmentTracker.removeFragment(h) : ((P = this.media) === null || P === void 0 ? void 0 : P.buffered.length) === 0 && this.fragmentTracker.removeAllFragments();
          }, _.getAppendedFrag = function(h) {
            var C = this.fragmentTracker.getAppendedFrag(h, T.PlaylistLevelType.MAIN);
            return C && "fragment" in C ? C.fragment : C;
          }, _.getBufferedFrag = function(h) {
            return this.fragmentTracker.getBufferedFrag(h, T.PlaylistLevelType.MAIN);
          }, _.followingBufferedFrag = function(h) {
            return h ? this.getBufferedFrag(h.end + 0.5) : null;
          }, _.immediateLevelSwitch = function() {
            this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
          }, _.nextLevelSwitch = function() {
            var h = this.levels, C = this.media;
            if (C != null && C.readyState) {
              var f, P = this.getAppendedFrag(C.currentTime);
              if (P && P.start > 1 && this.flushMainBuffer(0, P.start - 1), !C.paused && h) {
                var F = this.hls.nextLoadLevel, R = h[F], U = this.fragLastKbps;
                U && this.fragCurrent ? f = this.fragCurrent.duration * R.maxBitrate / (1e3 * U) + 1 : f = 0;
              } else
                f = 0;
              var K = this.getBufferedFrag(C.currentTime + f);
              if (K) {
                var V = this.followingBufferedFrag(K);
                if (V) {
                  this.abortCurrentFrag();
                  var W = V.maxStartPTS ? V.maxStartPTS : V.start, G = V.duration, H = Math.max(K.end, W + Math.min(Math.max(G - this.config.maxFragLookUpTolerance, G * 0.5), G * 0.75));
                  this.flushMainBuffer(H, Number.POSITIVE_INFINITY);
                }
              }
            }
          }, _.abortCurrentFrag = function() {
            var h = this.fragCurrent;
            switch (this.fragCurrent = null, this.backtrackFragment = null, h && h.abortRequests(), this.state) {
              case y.State.KEY_LOADING:
              case y.State.FRAG_LOADING:
              case y.State.FRAG_LOADING_WAITING_RETRY:
              case y.State.PARSING:
              case y.State.PARSED:
                this.state = y.State.IDLE;
                break;
            }
            this.nextLoadPosition = this.getLoadPosition();
          }, _.flushMainBuffer = function(h, C) {
            x.prototype.flushMainBuffer.call(this, h, C, this.altAudio ? "video" : null);
          }, _.onMediaAttached = function(h, C) {
            x.prototype.onMediaAttached.call(this, h, C);
            var f = C.media;
            this.onvplaying = this.onMediaPlaying.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), f.addEventListener("playing", this.onvplaying), f.addEventListener("seeked", this.onvseeked), this.gapController = new u.default(this.config, f, this.fragmentTracker, this.hls);
          }, _.onMediaDetaching = function() {
            var h = this.media;
            h && this.onvplaying && this.onvseeked && (h.removeEventListener("playing", this.onvplaying), h.removeEventListener("seeked", this.onvseeked), this.onvplaying = this.onvseeked = null, this.videoBuffer = null), this.fragPlaying = null, this.gapController && (this.gapController.destroy(), this.gapController = null), x.prototype.onMediaDetaching.call(this);
          }, _.onMediaPlaying = function() {
            this.tick();
          }, _.onMediaSeeked = function() {
            var h = this.media, C = h ? h.currentTime : null;
            (0, b.isFiniteNumber)(C) && this.log("Media seeked to " + C.toFixed(3)), this.tick();
          }, _.onManifestLoading = function() {
            this.log("Trigger BUFFER_RESET"), this.hls.trigger(E.Events.BUFFER_RESET, void 0), this.fragmentTracker.removeAllFragments(), this.couldBacktrack = !1, this.startPosition = this.lastCurrentTime = 0, this.fragPlaying = null, this.backtrackFragment = null;
          }, _.onManifestParsed = function(h, C) {
            var f = !1, P = !1, F;
            C.levels.forEach(function(R) {
              F = R.audioCodec, F && (F.indexOf("mp4a.40.2") !== -1 && (f = !0), F.indexOf("mp4a.40.5") !== -1 && (P = !0));
            }), this.audioCodecSwitch = f && P && !(0, N.changeTypeSupported)(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = C.levels, this.startFragRequested = !1;
          }, _.onLevelLoading = function(h, C) {
            var f = this.levels;
            if (!(!f || this.state !== y.State.IDLE)) {
              var P = f[C.level];
              (!P.details || P.details.live && this.levelLastLoaded !== C.level || this.waitForCdnTuneIn(P.details)) && (this.state = y.State.WAITING_LEVEL);
            }
          }, _.onLevelLoaded = function(h, C) {
            var f, P = this.levels, F = C.level, R = C.details, U = R.totalduration;
            if (!P) {
              this.warn("Levels were reset while loading level " + F);
              return;
            }
            this.log("Level " + F + " loaded [" + R.startSN + "," + R.endSN + "], cc [" + R.startCC + ", " + R.endCC + "] duration:" + U);
            var K = this.fragCurrent;
            K && (this.state === y.State.FRAG_LOADING || this.state === y.State.FRAG_LOADING_WAITING_RETRY) && K.level !== C.level && K.loader && (this.state = y.State.IDLE, this.backtrackFragment = null, K.abortRequests());
            var V = P[F], W = 0;
            if (R.live || (f = V.details) !== null && f !== void 0 && f.live) {
              if (R.fragments[0] || (R.deltaUpdateFailed = !0), R.deltaUpdateFailed)
                return;
              W = this.alignPlaylists(R, V.details);
            }
            if (V.details = R, this.levelLastLoaded = F, this.hls.trigger(E.Events.LEVEL_UPDATED, {
              details: R,
              level: F
            }), this.state === y.State.WAITING_LEVEL) {
              if (this.waitForCdnTuneIn(R))
                return;
              this.state = y.State.IDLE;
            }
            this.startFragRequested ? R.live && this.synchronizeToLiveEdge(R) : this.setStartPosition(R, W), this.tick();
          }, _._handleFragmentLoadProgress = function(h) {
            var C, f = h.frag, P = h.part, F = h.payload, R = this.levels;
            if (!R) {
              this.warn("Levels were reset while fragment load was in progress. Fragment " + f.sn + " of level " + f.level + " will not be buffered");
              return;
            }
            var U = R[f.level], K = U.details;
            if (!K) {
              this.warn("Dropping fragment " + f.sn + " of level " + f.level + " after level details were reset");
              return;
            }
            var V = U.videoCodec, W = K.PTSKnown || !K.live, G = (C = f.initSegment) === null || C === void 0 ? void 0 : C.data, H = this._getAudioCodec(U), $ = this.transmuxer = this.transmuxer || new w.default(this.hls, T.PlaylistLevelType.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), Y = P ? P.index : -1, z = Y !== -1, X = new O.ChunkMetadata(f.level, f.sn, f.stats.chunkCount, F.byteLength, Y, z), Q = this.initPTS[f.cc];
            $.push(F, G, H, V, f, P, K.totalduration, W, X, Q);
          }, _.onAudioTrackSwitching = function(h, C) {
            var f = this.altAudio, P = !!C.url, F = C.id;
            if (!P) {
              if (this.mediaBuffer !== this.media) {
                this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
                var R = this.fragCurrent;
                R && (this.log("Switching to main audio track, cancel main fragment load"), R.abortRequests()), this.resetTransmuxer(), this.resetLoadingState();
              } else
                this.audioOnly && this.resetTransmuxer();
              var U = this.hls;
              f && U.trigger(E.Events.BUFFER_FLUSHING, {
                startOffset: 0,
                endOffset: Number.POSITIVE_INFINITY,
                type: "audio"
              }), U.trigger(E.Events.AUDIO_TRACK_SWITCHED, {
                id: F
              });
            }
          }, _.onAudioTrackSwitched = function(h, C) {
            var f = C.id, P = !!this.hls.audioTracks[f].url;
            if (P) {
              var F = this.videoBuffer;
              F && this.mediaBuffer !== F && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = F);
            }
            this.altAudio = P, this.tick();
          }, _.onBufferCreated = function(h, C) {
            var f = C.tracks, P, F, R = !1;
            for (var U in f) {
              var K = f[U];
              if (K.id === "main") {
                if (F = U, P = K, U === "video") {
                  var V = f[U];
                  V && (this.videoBuffer = V.buffer);
                }
              } else
                R = !0;
            }
            R && P ? (this.log("Alternate track found, use " + F + ".buffered to schedule main fragment loading"), this.mediaBuffer = P.buffer) : this.mediaBuffer = this.media;
          }, _.onFragBuffered = function(h, C) {
            var f = C.frag, P = C.part;
            if (!(f && f.type !== T.PlaylistLevelType.MAIN)) {
              if (this.fragContextChanged(f)) {
                this.warn("Fragment " + f.sn + (P ? " p: " + P.index : "") + " of level " + f.level + " finished buffering, but was aborted. state: " + this.state), this.state === y.State.PARSED && (this.state = y.State.IDLE);
                return;
              }
              var F = P ? P.stats : f.stats;
              this.fragLastKbps = Math.round(8 * F.total / (F.buffering.end - F.loading.first)), f.sn !== "initSegment" && (this.fragPrevious = f), this.fragBufferedComplete(f, P);
            }
          }, _.onError = function(h, C) {
            if (C.type === M.ErrorTypes.KEY_SYSTEM_ERROR) {
              this.onFragmentOrKeyLoadError(T.PlaylistLevelType.MAIN, C);
              return;
            }
            switch (C.details) {
              case M.ErrorDetails.FRAG_LOAD_ERROR:
              case M.ErrorDetails.FRAG_LOAD_TIMEOUT:
              case M.ErrorDetails.FRAG_PARSING_ERROR:
              case M.ErrorDetails.KEY_LOAD_ERROR:
              case M.ErrorDetails.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError(T.PlaylistLevelType.MAIN, C);
                break;
              case M.ErrorDetails.LEVEL_LOAD_ERROR:
              case M.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                this.state !== y.State.ERROR && (C.fatal ? (this.warn("" + C.details), this.state = y.State.ERROR) : !C.levelRetry && this.state === y.State.WAITING_LEVEL && (this.state = y.State.IDLE));
                break;
              case M.ErrorDetails.BUFFER_FULL_ERROR:
                if (C.parent === "main" && (this.state === y.State.PARSING || this.state === y.State.PARSED)) {
                  var f = !0, P = this.getFwdBufferInfo(this.media, T.PlaylistLevelType.MAIN);
                  P && P.len > 0.5 && (f = !this.reduceMaxBufferLength(P.len)), f && (this.warn("buffer full error also media.currentTime is not buffered, flush main"), this.immediateLevelSwitch()), this.resetLoadingState();
                }
                break;
            }
          }, _.checkBuffer = function() {
            var h = this.media, C = this.gapController;
            if (!(!h || !C || !h.readyState)) {
              if (this.loadedmetadata || !B.BufferHelper.getBuffered(h).length) {
                var f = this.state !== y.State.IDLE ? this.fragCurrent : null;
                C.poll(this.lastCurrentTime, f);
              }
              this.lastCurrentTime = h.currentTime;
            }
          }, _.onFragLoadEmergencyAborted = function() {
            this.state = y.State.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tickImmediate();
          }, _.onBufferFlushed = function(h, C) {
            var f = C.type;
            if (f !== A.ElementaryStreamTypes.AUDIO || this.audioOnly && !this.altAudio) {
              var P = (f === A.ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
              this.afterBufferFlushed(P, f, T.PlaylistLevelType.MAIN);
            }
          }, _.onLevelsUpdated = function(h, C) {
            this.levels = C.levels;
          }, _.swapAudioCodec = function() {
            this.audioCodecSwap = !this.audioCodecSwap;
          }, _.seekToStartPos = function() {
            var h = this.media;
            if (!!h) {
              var C = h.currentTime, f = this.startPosition;
              if (f >= 0 && C < f) {
                if (h.seeking) {
                  this.log("could not seek to " + f + ", already seeking at " + C);
                  return;
                }
                var P = B.BufferHelper.getBuffered(h), F = P.length ? P.start(0) : 0, R = F - f;
                R > 0 && (R < this.config.maxBufferHole || R < this.config.maxFragLookUpTolerance) && (this.log("adjusting start position by " + R + " to match buffer start"), f += R, this.startPosition = f), this.log("seek to target start position " + f + " from current time " + C), h.currentTime = f;
              }
            }
          }, _._getAudioCodec = function(h) {
            var C = this.config.defaultAudioCodec || h.audioCodec;
            return this.audioCodecSwap && C && (this.log("Swapping audio codec"), C.indexOf("mp4a.40.5") !== -1 ? C = "mp4a.40.2" : C = "mp4a.40.5"), C;
          }, _._loadBitrateTestFrag = function(h, C) {
            var f = this;
            h.bitrateTest = !0, this._doFragLoad(h, C).then(function(P) {
              var F = f.hls;
              if (!(!P || f.fragContextChanged(h))) {
                f.fragLoadError = 0, f.state = y.State.IDLE, f.startFragRequested = !1, f.bitrateTest = !1;
                var R = h.stats;
                R.parsing.start = R.parsing.end = R.buffering.start = R.buffering.end = self.performance.now(), F.trigger(E.Events.FRAG_LOADED, P), h.bitrateTest = !1;
              }
            });
          }, _._handleTransmuxComplete = function(h) {
            var C, f = "main", P = this.hls, F = h.remuxResult, R = h.chunkMeta, U = this.getCurrentContext(R);
            if (!U) {
              this.warn("The loading context changed while buffering fragment " + R.sn + " of level " + R.level + ". This chunk will not be buffered."), this.resetStartWhenNotLoaded(R.level);
              return;
            }
            var K = U.frag, V = U.part, W = U.level, G = F.video, H = F.text, $ = F.id3, Y = F.initSegment, z = W.details, X = this.altAudio ? void 0 : F.audio;
            if (!this.fragContextChanged(K)) {
              if (this.state = y.State.PARSING, Y) {
                Y.tracks && (this._bufferInitSegment(W, Y.tracks, K, R), P.trigger(E.Events.FRAG_PARSING_INIT_SEGMENT, {
                  frag: K,
                  id: f,
                  tracks: Y.tracks
                }));
                var Q = Y.initPTS, q = Y.timescale;
                (0, b.isFiniteNumber)(Q) && (this.initPTS[K.cc] = Q, P.trigger(E.Events.INIT_PTS_FOUND, {
                  frag: K,
                  id: f,
                  initPTS: Q,
                  timescale: q
                }));
              }
              if (G && F.independent !== !1) {
                if (z) {
                  var Z = G.startPTS, J = G.endPTS, te = G.startDTS, ne = G.endDTS;
                  if (V)
                    V.elementaryStreams[G.type] = {
                      startPTS: Z,
                      endPTS: J,
                      startDTS: te,
                      endDTS: ne
                    };
                  else if (G.firstKeyFrame && G.independent && R.id === 1 && (this.couldBacktrack = !0), G.dropped && G.independent) {
                    var re = this.getMainFwdBufferInfo(), ee = (re ? re.end : this.getLoadPosition()) + this.config.maxBufferHole, le = G.firstKeyFramePTS ? G.firstKeyFramePTS : Z;
                    if (ee < le - this.config.maxBufferHole) {
                      this.backtrack(K);
                      return;
                    }
                    K.setElementaryStreamInfo(G.type, K.start, J, K.start, ne, !0);
                  }
                  K.setElementaryStreamInfo(G.type, Z, J, te, ne), this.backtrackFragment && (this.backtrackFragment = K), this.bufferFragmentData(G, K, V, R);
                }
              } else if (F.independent === !1) {
                this.backtrack(K);
                return;
              }
              if (X) {
                var pe = X.startPTS, ie = X.endPTS, ce = X.startDTS, se = X.endDTS;
                V && (V.elementaryStreams[A.ElementaryStreamTypes.AUDIO] = {
                  startPTS: pe,
                  endPTS: ie,
                  startDTS: ce,
                  endDTS: se
                }), K.setElementaryStreamInfo(A.ElementaryStreamTypes.AUDIO, pe, ie, ce, se), this.bufferFragmentData(X, K, V, R);
              }
              if (z && $ !== null && $ !== void 0 && (C = $.samples) !== null && C !== void 0 && C.length) {
                var he = {
                  id: f,
                  frag: K,
                  details: z,
                  samples: $.samples
                };
                P.trigger(E.Events.FRAG_PARSING_METADATA, he);
              }
              if (z && H) {
                var ae = {
                  id: f,
                  frag: K,
                  details: z,
                  samples: H.samples
                };
                P.trigger(E.Events.FRAG_PARSING_USERDATA, ae);
              }
            }
          }, _._bufferInitSegment = function(h, C, f, P) {
            var F = this;
            if (this.state === y.State.PARSING) {
              this.audioOnly = !!C.audio && !C.video, this.altAudio && !this.audioOnly && delete C.audio;
              var R = C.audio, U = C.video, K = C.audiovideo;
              if (R) {
                var V = h.audioCodec, W = navigator.userAgent.toLowerCase();
                this.audioCodecSwitch && (V && (V.indexOf("mp4a.40.5") !== -1 ? V = "mp4a.40.2" : V = "mp4a.40.5"), R.metadata.channelCount !== 1 && W.indexOf("firefox") === -1 && (V = "mp4a.40.5")), W.indexOf("android") !== -1 && R.container !== "audio/mpeg" && (V = "mp4a.40.2", this.log("Android: force audio codec to " + V)), h.audioCodec && h.audioCodec !== V && this.log('Swapping manifest audio codec "' + h.audioCodec + '" for "' + V + '"'), R.levelCodec = V, R.id = "main", this.log("Init audio buffer, container:" + R.container + ", codecs[selected/level/parsed]=[" + (V || "") + "/" + (h.audioCodec || "") + "/" + R.codec + "]");
              }
              U && (U.levelCodec = h.videoCodec, U.id = "main", this.log("Init video buffer, container:" + U.container + ", codecs[level/parsed]=[" + (h.videoCodec || "") + "/" + U.codec + "]")), K && this.log("Init audiovideo buffer, container:" + K.container + ", codecs[level/parsed]=[" + (h.attrs.CODECS || "") + "/" + K.codec + "]"), this.hls.trigger(E.Events.BUFFER_CODECS, C), Object.keys(C).forEach(function(G) {
                var H = C[G], $ = H.initSegment;
                $ != null && $.byteLength && F.hls.trigger(E.Events.BUFFER_APPENDING, {
                  type: G,
                  data: $,
                  frag: f,
                  part: null,
                  chunkMeta: P,
                  parent: f.type
                });
              }), this.tick();
            }
          }, _.getMainFwdBufferInfo = function() {
            return this.getFwdBufferInfo(this.mediaBuffer ? this.mediaBuffer : this.media, T.PlaylistLevelType.MAIN);
          }, _.backtrack = function(h) {
            this.couldBacktrack = !0, this.backtrackFragment = h, this.resetTransmuxer(), this.flushBufferGap(h), this.fragmentTracker.removeFragment(h), this.fragPrevious = null, this.nextLoadPosition = h.start, this.state = y.State.IDLE;
          }, _.checkFragmentChanged = function() {
            var h = this.media, C = null;
            if (h && h.readyState > 1 && h.seeking === !1) {
              var f = h.currentTime;
              if (B.BufferHelper.isBuffered(h, f) ? C = this.getAppendedFrag(f) : B.BufferHelper.isBuffered(h, f + 0.1) && (C = this.getAppendedFrag(f + 0.1)), C) {
                this.backtrackFragment = null;
                var P = this.fragPlaying, F = C.level;
                (!P || C.sn !== P.sn || P.level !== F || C.urlId !== P.urlId) && (this.fragPlaying = C, this.hls.trigger(E.Events.FRAG_CHANGED, {
                  frag: C
                }), (!P || P.level !== F) && this.hls.trigger(E.Events.LEVEL_SWITCHED, {
                  level: F
                }));
              }
            }
          }, c(k, [{
            key: "nextLevel",
            get: function() {
              var h = this.nextBufferedFrag;
              return h ? h.level : -1;
            }
          }, {
            key: "currentFrag",
            get: function() {
              var h = this.media;
              return h ? this.fragPlaying || this.getAppendedFrag(h.currentTime) : null;
            }
          }, {
            key: "currentProgramDateTime",
            get: function() {
              var h = this.media;
              if (h) {
                var C = h.currentTime, f = this.currentFrag;
                if (f && (0, b.isFiniteNumber)(C) && (0, b.isFiniteNumber)(f.programDateTime)) {
                  var P = f.programDateTime + (C - f.start) * 1e3;
                  return new Date(P);
                }
              }
              return null;
            }
          }, {
            key: "currentLevel",
            get: function() {
              var h = this.currentFrag;
              return h ? h.level : -1;
            }
          }, {
            key: "nextBufferedFrag",
            get: function() {
              var h = this.currentFrag;
              return h ? this.followingBufferedFrag(h) : null;
            }
          }, {
            key: "forceStartLoad",
            get: function() {
              return this._forceStartLoad;
            }
          }]), k;
        }(y.default);
      },
      "./src/controller/subtitle-stream-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          SubtitleStreamController: () => m
        });
        var b = a("./src/events.ts"), y = a("./src/utils/buffer-helper.ts"), N = a("./src/controller/fragment-finders.ts"), E = a("./src/utils/discontinuities.ts"), B = a("./src/controller/level-helper.ts"), I = a("./src/controller/fragment-tracker.ts"), T = a("./src/controller/base-stream-controller.ts"), A = a("./src/types/loader.ts"), w = a("./src/types/level.ts");
        function O(L, p) {
          for (var x = 0; x < p.length; x++) {
            var k = p[x];
            k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(L, M(k.key), k);
          }
        }
        function u(L, p, x) {
          return p && O(L.prototype, p), x && O(L, x), Object.defineProperty(L, "prototype", { writable: !1 }), L;
        }
        function M(L) {
          var p = d(L, "string");
          return typeof p == "symbol" ? p : String(p);
        }
        function d(L, p) {
          if (typeof L != "object" || L === null)
            return L;
          var x = L[Symbol.toPrimitive];
          if (x !== void 0) {
            var k = x.call(L, p || "default");
            if (typeof k != "object")
              return k;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (p === "string" ? String : Number)(L);
        }
        function c(L, p) {
          L.prototype = Object.create(p.prototype), L.prototype.constructor = L, v(L, p);
        }
        function v(L, p) {
          return v = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(k, _) {
            return k.__proto__ = _, k;
          }, v(L, p);
        }
        var g = 500, m = /* @__PURE__ */ function(L) {
          c(p, L);
          function p(k, _, S) {
            var h;
            return h = L.call(this, k, _, S, "[subtitle-stream-controller]") || this, h.levels = [], h.currentTrackId = -1, h.tracksBuffered = [], h.mainDetails = null, h._registerListeners(), h;
          }
          var x = p.prototype;
          return x.onHandlerDestroying = function() {
            this._unregisterListeners(), this.mainDetails = null;
          }, x._registerListeners = function() {
            var _ = this.hls;
            _.on(b.Events.MEDIA_ATTACHED, this.onMediaAttached, this), _.on(b.Events.MEDIA_DETACHING, this.onMediaDetaching, this), _.on(b.Events.MANIFEST_LOADING, this.onManifestLoading, this), _.on(b.Events.LEVEL_LOADED, this.onLevelLoaded, this), _.on(b.Events.ERROR, this.onError, this), _.on(b.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), _.on(b.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), _.on(b.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), _.on(b.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), _.on(b.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), _.on(b.Events.FRAG_BUFFERED, this.onFragBuffered, this);
          }, x._unregisterListeners = function() {
            var _ = this.hls;
            _.off(b.Events.MEDIA_ATTACHED, this.onMediaAttached, this), _.off(b.Events.MEDIA_DETACHING, this.onMediaDetaching, this), _.off(b.Events.MANIFEST_LOADING, this.onManifestLoading, this), _.off(b.Events.LEVEL_LOADED, this.onLevelLoaded, this), _.off(b.Events.ERROR, this.onError, this), _.off(b.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), _.off(b.Events.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), _.off(b.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), _.off(b.Events.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), _.off(b.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), _.off(b.Events.FRAG_BUFFERED, this.onFragBuffered, this);
          }, x.startLoad = function(_) {
            this.stopLoad(), this.state = T.State.IDLE, this.setInterval(g), this.nextLoadPosition = this.startPosition = this.lastCurrentTime = _, this.tick();
          }, x.onManifestLoading = function() {
            this.mainDetails = null, this.fragmentTracker.removeAllFragments();
          }, x.onLevelLoaded = function(_, S) {
            this.mainDetails = S.details;
          }, x.onSubtitleFragProcessed = function(_, S) {
            var h = S.frag, C = S.success;
            if (this.fragPrevious = h, this.state = T.State.IDLE, !!C) {
              var f = this.tracksBuffered[this.currentTrackId];
              if (!!f) {
                for (var P, F = h.start, R = 0; R < f.length; R++)
                  if (F >= f[R].start && F <= f[R].end) {
                    P = f[R];
                    break;
                  }
                var U = h.start + h.duration;
                P ? P.end = U : (P = {
                  start: F,
                  end: U
                }, f.push(P)), this.fragmentTracker.fragBuffered(h);
              }
            }
          }, x.onBufferFlushing = function(_, S) {
            var h = S.startOffset, C = S.endOffset;
            if (h === 0 && C !== Number.POSITIVE_INFINITY) {
              var f = this.currentTrackId, P = this.levels;
              if (!P.length || !P[f] || !P[f].details)
                return;
              var F = P[f].details, R = F.targetduration, U = C - R;
              if (U <= 0)
                return;
              S.endOffsetSubtitles = Math.max(0, U), this.tracksBuffered.forEach(function(K) {
                for (var V = 0; V < K.length; ) {
                  if (K[V].end <= U) {
                    K.shift();
                    continue;
                  } else if (K[V].start < U)
                    K[V].start = U;
                  else
                    break;
                  V++;
                }
              }), this.fragmentTracker.removeFragmentsInRange(h, U, A.PlaylistLevelType.SUBTITLE);
            }
          }, x.onFragBuffered = function(_, S) {
            if (!this.loadedmetadata && S.frag.type === A.PlaylistLevelType.MAIN) {
              var h;
              (h = this.media) !== null && h !== void 0 && h.buffered.length && (this.loadedmetadata = !0);
            }
          }, x.onError = function(_, S) {
            var h = S.frag;
            !h || h.type !== A.PlaylistLevelType.SUBTITLE || (this.fragCurrent && this.fragCurrent.abortRequests(), this.state = T.State.IDLE);
          }, x.onSubtitleTracksUpdated = function(_, S) {
            var h = this, C = S.subtitleTracks;
            this.tracksBuffered = [], this.levels = C.map(function(f) {
              return new w.Level(f);
            }), this.fragmentTracker.removeAllFragments(), this.fragPrevious = null, this.levels.forEach(function(f) {
              h.tracksBuffered[f.id] = [];
            }), this.mediaBuffer = null;
          }, x.onSubtitleTrackSwitch = function(_, S) {
            if (this.currentTrackId = S.id, !this.levels.length || this.currentTrackId === -1) {
              this.clearInterval();
              return;
            }
            var h = this.levels[this.currentTrackId];
            h != null && h.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, h && this.setInterval(g);
          }, x.onSubtitleTrackLoaded = function(_, S) {
            var h, C = S.details, f = S.id, P = this.currentTrackId, F = this.levels;
            if (!!F.length) {
              var R = F[P];
              if (!(f >= F.length || f !== P || !R)) {
                this.mediaBuffer = this.mediaBufferTimeRanges;
                var U = 0;
                if (C.live || (h = R.details) !== null && h !== void 0 && h.live) {
                  var K = this.mainDetails;
                  if (C.deltaUpdateFailed || !K)
                    return;
                  var V = K.fragments[0];
                  R.details ? (U = this.alignPlaylists(C, R.details), U === 0 && V && (U = V.start, (0, B.addSliding)(C, U))) : C.hasProgramDateTime && K.hasProgramDateTime ? ((0, E.alignMediaPlaylistByPDT)(C, K), U = C.fragments[0].start) : V && (U = V.start, (0, B.addSliding)(C, U));
                }
                if (R.details = C, this.levelLastLoaded = f, !this.startFragRequested && (this.mainDetails || !C.live) && this.setStartPosition(R.details, U), this.tick(), C.live && !this.fragCurrent && this.media && this.state === T.State.IDLE) {
                  var W = (0, N.findFragmentByPTS)(null, C.fragments, this.media.currentTime, 0);
                  W || (this.warn("Subtitle playlist not aligned with playback"), R.details = void 0);
                }
              }
            }
          }, x._handleFragmentLoadComplete = function(_) {
            var S = this, h = _.frag, C = _.payload, f = h.decryptdata, P = this.hls;
            if (!this.fragContextChanged(h) && C && C.byteLength > 0 && f && f.key && f.iv && f.method === "AES-128") {
              var F = performance.now();
              this.decrypter.decrypt(new Uint8Array(C), f.key.buffer, f.iv.buffer).then(function(R) {
                var U = performance.now();
                P.trigger(b.Events.FRAG_DECRYPTED, {
                  frag: h,
                  payload: R,
                  stats: {
                    tstart: F,
                    tdecrypt: U
                  }
                });
              }).catch(function(R) {
                S.warn(R.name + ": " + R.message), S.state = T.State.IDLE;
              });
            }
          }, x.doTick = function() {
            if (!this.media) {
              this.state = T.State.IDLE;
              return;
            }
            if (this.state === T.State.IDLE) {
              var _ = this.currentTrackId, S = this.levels;
              if (!S.length || !S[_] || !S[_].details)
                return;
              var h = S[_].details, C = h.targetduration, f = this.config, P = this.getLoadPosition(), F = y.BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], P - C, f.maxBufferHole), R = F.end, U = F.len, K = this.getFwdBufferInfo(this.media, A.PlaylistLevelType.MAIN), V = this.getMaxBufferLength(K == null ? void 0 : K.len) + C;
              if (U > V)
                return;
              console.assert(h, "Subtitle track details are defined on idle subtitle stream controller tick");
              var W = h.fragments, G = W.length, H = h.edge, $ = null, Y = this.fragPrevious;
              if (R < H) {
                var z = f.maxFragLookUpTolerance;
                $ = (0, N.findFragmentByPTS)(Y, W, Math.max(W[0].start, R), z), !$ && Y && Y.start < W[0].start && ($ = W[0]);
              } else
                $ = W[G - 1];
              if (!$)
                return;
              $ = this.mapToInitFragWhenRequired($), this.fragmentTracker.getState($) === I.FragmentState.NOT_LOADED && this.loadFragment($, h, R);
            }
          }, x.getMaxBufferLength = function(_) {
            var S = L.prototype.getMaxBufferLength.call(this);
            return _ ? Math.max(S, _) : S;
          }, x.loadFragment = function(_, S, h) {
            this.fragCurrent = _, _.sn === "initSegment" ? this._loadInitSegment(_, S) : (this.startFragRequested = !0, L.prototype.loadFragment.call(this, _, S, h));
          }, u(p, [{
            key: "mediaBufferTimeRanges",
            get: function() {
              return new D(this.tracksBuffered[this.currentTrackId] || []);
            }
          }]), p;
        }(T.default), D = function(p) {
          this.buffered = void 0;
          var x = function(_, S, h) {
            if (S = S >>> 0, S > h - 1)
              throw new DOMException("Failed to execute '" + _ + "' on 'TimeRanges': The index provided (" + S + ") is greater than the maximum bound (" + h + ")");
            return p[S][_];
          };
          this.buffered = {
            get length() {
              return p.length;
            },
            end: function(_) {
              return x("end", _, p.length);
            },
            start: function(_) {
              return x("start", _, p.length);
            }
          };
        };
      },
      "./src/controller/subtitle-track-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => d
        });
        var b = a("./src/events.ts"), y = a("./src/utils/texttrack-utils.ts"), N = a("./src/controller/base-playlist-controller.ts"), E = a("./src/types/loader.ts");
        function B(c, v) {
          for (var g = 0; g < v.length; g++) {
            var m = v[g];
            m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(c, T(m.key), m);
          }
        }
        function I(c, v, g) {
          return v && B(c.prototype, v), g && B(c, g), Object.defineProperty(c, "prototype", { writable: !1 }), c;
        }
        function T(c) {
          var v = A(c, "string");
          return typeof v == "symbol" ? v : String(v);
        }
        function A(c, v) {
          if (typeof c != "object" || c === null)
            return c;
          var g = c[Symbol.toPrimitive];
          if (g !== void 0) {
            var m = g.call(c, v || "default");
            if (typeof m != "object")
              return m;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (v === "string" ? String : Number)(c);
        }
        function w(c, v) {
          c.prototype = Object.create(v.prototype), c.prototype.constructor = c, O(c, v);
        }
        function O(c, v) {
          return O = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(m, D) {
            return m.__proto__ = D, m;
          }, O(c, v);
        }
        var u = /* @__PURE__ */ function(c) {
          w(v, c);
          function v(m) {
            var D;
            return D = c.call(this, m, "[subtitle-track-controller]") || this, D.media = null, D.tracks = [], D.groupId = null, D.tracksInGroup = [], D.trackId = -1, D.selectDefaultTrack = !0, D.queuedDefaultTrack = -1, D.trackChangeListener = function() {
              return D.onTextTracksChanged();
            }, D.asyncPollTrackChange = function() {
              return D.pollTrackChange(0);
            }, D.useTextTrackPolling = !1, D.subtitlePollingInterval = -1, D._subtitleDisplay = !0, D.registerListeners(), D;
          }
          var g = v.prototype;
          return g.destroy = function() {
            this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.trackChangeListener = this.asyncPollTrackChange = null, c.prototype.destroy.call(this);
          }, g.registerListeners = function() {
            var D = this.hls;
            D.on(b.Events.MEDIA_ATTACHED, this.onMediaAttached, this), D.on(b.Events.MEDIA_DETACHING, this.onMediaDetaching, this), D.on(b.Events.MANIFEST_LOADING, this.onManifestLoading, this), D.on(b.Events.MANIFEST_PARSED, this.onManifestParsed, this), D.on(b.Events.LEVEL_LOADING, this.onLevelLoading, this), D.on(b.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), D.on(b.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), D.on(b.Events.ERROR, this.onError, this);
          }, g.unregisterListeners = function() {
            var D = this.hls;
            D.off(b.Events.MEDIA_ATTACHED, this.onMediaAttached, this), D.off(b.Events.MEDIA_DETACHING, this.onMediaDetaching, this), D.off(b.Events.MANIFEST_LOADING, this.onManifestLoading, this), D.off(b.Events.MANIFEST_PARSED, this.onManifestParsed, this), D.off(b.Events.LEVEL_LOADING, this.onLevelLoading, this), D.off(b.Events.LEVEL_SWITCHING, this.onLevelSwitching, this), D.off(b.Events.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), D.off(b.Events.ERROR, this.onError, this);
          }, g.onMediaAttached = function(D, L) {
            this.media = L.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
          }, g.pollTrackChange = function(D) {
            self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.trackChangeListener, D);
          }, g.onMediaDetaching = function() {
            if (!!this.media) {
              self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || this.media.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId);
              var D = M(this.media.textTracks);
              D.forEach(function(L) {
                (0, y.clearCurrentCues)(L);
              }), this.subtitleTrack = -1, this.media = null;
            }
          }, g.onManifestLoading = function() {
            this.tracks = [], this.groupId = null, this.tracksInGroup = [], this.trackId = -1, this.selectDefaultTrack = !0;
          }, g.onManifestParsed = function(D, L) {
            this.tracks = L.subtitleTracks;
          }, g.onSubtitleTrackLoaded = function(D, L) {
            var p = L.id, x = L.details, k = this.trackId, _ = this.tracksInGroup[k];
            if (!_) {
              this.warn("Invalid subtitle track id " + p);
              return;
            }
            var S = _.details;
            _.details = L.details, this.log("subtitle track " + p + " loaded [" + x.startSN + "-" + x.endSN + "]"), p === this.trackId && (this.retryCount = 0, this.playlistLoaded(p, L, S));
          }, g.onLevelLoading = function(D, L) {
            this.switchLevel(L.level);
          }, g.onLevelSwitching = function(D, L) {
            this.switchLevel(L.level);
          }, g.switchLevel = function(D) {
            var L = this.hls.levels[D];
            if (!!(L != null && L.textGroupIds)) {
              var p = L.textGroupIds[L.urlId];
              if (this.groupId !== p) {
                var x = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0, k = this.tracks.filter(function(h) {
                  return !p || h.groupId === p;
                });
                this.tracksInGroup = k;
                var _ = this.findTrackId(x == null ? void 0 : x.name) || this.findTrackId();
                this.groupId = p;
                var S = {
                  subtitleTracks: k
                };
                this.log("Updating subtitle tracks, " + k.length + ' track(s) found in "' + p + '" group-id'), this.hls.trigger(b.Events.SUBTITLE_TRACKS_UPDATED, S), _ !== -1 && this.setSubtitleTrack(_, x);
              }
            }
          }, g.findTrackId = function(D) {
            for (var L = this.tracksInGroup, p = 0; p < L.length; p++) {
              var x = L[p];
              if ((!this.selectDefaultTrack || x.default) && (!D || D === x.name))
                return x.id;
            }
            return -1;
          }, g.onError = function(D, L) {
            c.prototype.onError.call(this, D, L), !(L.fatal || !L.context) && L.context.type === E.PlaylistContextType.SUBTITLE_TRACK && L.context.id === this.trackId && L.context.groupId === this.groupId && this.retryLoadingOrFail(L);
          }, g.loadPlaylist = function(D) {
            c.prototype.loadPlaylist.call(this);
            var L = this.tracksInGroup[this.trackId];
            if (this.shouldLoadTrack(L)) {
              var p = L.id, x = L.groupId, k = L.url;
              if (D)
                try {
                  k = D.addDirectives(k);
                } catch (_) {
                  this.warn("Could not construct new URL with HLS Delivery Directives: " + _);
                }
              this.log("Loading subtitle playlist for id " + p), this.hls.trigger(b.Events.SUBTITLE_TRACK_LOADING, {
                url: k,
                id: p,
                groupId: x,
                deliveryDirectives: D || null
              });
            }
          }, g.toggleTrackModes = function(D) {
            var L = this, p = this.media, x = this.trackId;
            if (!!p) {
              var k = M(p.textTracks), _ = k.filter(function(C) {
                return C.groupId === L.groupId;
              });
              if (D === -1)
                [].slice.call(k).forEach(function(C) {
                  C.mode = "disabled";
                });
              else {
                var S = _[x];
                S && (S.mode = "disabled");
              }
              var h = _[D];
              h && (h.mode = this.subtitleDisplay ? "showing" : "hidden");
            }
          }, g.setSubtitleTrack = function(D, L) {
            var p, x = this.tracksInGroup;
            if (!this.media) {
              this.queuedDefaultTrack = D;
              return;
            }
            if (this.trackId !== D && this.toggleTrackModes(D), !(this.trackId === D && (D === -1 || (p = x[D]) !== null && p !== void 0 && p.details) || D < -1 || D >= x.length)) {
              this.clearTimer();
              var k = x[D];
              if (this.log("Switching to subtitle track " + D), this.trackId = D, k) {
                var _ = k.id, S = k.groupId, h = S === void 0 ? "" : S, C = k.name, f = k.type, P = k.url;
                this.hls.trigger(b.Events.SUBTITLE_TRACK_SWITCH, {
                  id: _,
                  groupId: h,
                  name: C,
                  type: f,
                  url: P
                });
                var F = this.switchParams(k.url, L == null ? void 0 : L.details);
                this.loadPlaylist(F);
              } else
                this.hls.trigger(b.Events.SUBTITLE_TRACK_SWITCH, {
                  id: D
                });
            }
          }, g.onTextTracksChanged = function() {
            if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !(!this.media || !this.hls.config.renderTextTracksNatively)) {
              for (var D = -1, L = M(this.media.textTracks), p = 0; p < L.length; p++)
                if (L[p].mode === "hidden")
                  D = p;
                else if (L[p].mode === "showing") {
                  D = p;
                  break;
                }
              this.subtitleTrack !== D && (this.subtitleTrack = D);
            }
          }, I(v, [{
            key: "subtitleDisplay",
            get: function() {
              return this._subtitleDisplay;
            },
            set: function(D) {
              this._subtitleDisplay = D, this.trackId > -1 && this.toggleTrackModes(this.trackId);
            }
          }, {
            key: "subtitleTracks",
            get: function() {
              return this.tracksInGroup;
            }
          }, {
            key: "subtitleTrack",
            get: function() {
              return this.trackId;
            },
            set: function(D) {
              this.selectDefaultTrack = !1;
              var L = this.tracksInGroup ? this.tracksInGroup[this.trackId] : void 0;
              this.setSubtitleTrack(D, L);
            }
          }]), v;
        }(N.default);
        function M(c) {
          for (var v = [], g = 0; g < c.length; g++) {
            var m = c[g];
            (m.kind === "subtitles" || m.kind === "captions") && m.label && v.push(c[g]);
          }
          return v;
        }
        const d = u;
      },
      "./src/controller/timeline-controller.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          TimelineController: () => u
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/events.ts"), N = a("./src/utils/cea-608-parser.ts"), E = a("./src/utils/output-filter.ts"), B = a("./src/utils/webvtt-parser.ts"), I = a("./src/utils/texttrack-utils.ts"), T = a("./src/utils/imsc1-ttml-parser.ts"), A = a("./src/utils/mp4-tools.ts"), w = a("./src/types/loader.ts"), O = a("./src/utils/logger.ts"), u = /* @__PURE__ */ function() {
          function v(m) {
            if (this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.timescale = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = c(), this.captionsProperties = void 0, this.hls = m, this.config = m.config, this.Cues = m.config.cueHandler, this.captionsProperties = {
              textTrack1: {
                label: this.config.captionsTextTrack1Label,
                languageCode: this.config.captionsTextTrack1LanguageCode
              },
              textTrack2: {
                label: this.config.captionsTextTrack2Label,
                languageCode: this.config.captionsTextTrack2LanguageCode
              },
              textTrack3: {
                label: this.config.captionsTextTrack3Label,
                languageCode: this.config.captionsTextTrack3LanguageCode
              },
              textTrack4: {
                label: this.config.captionsTextTrack4Label,
                languageCode: this.config.captionsTextTrack4LanguageCode
              }
            }, this.config.enableCEA708Captions) {
              var D = new E.default(this, "textTrack1"), L = new E.default(this, "textTrack2"), p = new E.default(this, "textTrack3"), x = new E.default(this, "textTrack4");
              this.cea608Parser1 = new N.default(1, D, L), this.cea608Parser2 = new N.default(3, p, x);
            }
            m.on(y.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), m.on(y.Events.MEDIA_DETACHING, this.onMediaDetaching, this), m.on(y.Events.MANIFEST_LOADING, this.onManifestLoading, this), m.on(y.Events.MANIFEST_LOADED, this.onManifestLoaded, this), m.on(y.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), m.on(y.Events.FRAG_LOADING, this.onFragLoading, this), m.on(y.Events.FRAG_LOADED, this.onFragLoaded, this), m.on(y.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), m.on(y.Events.FRAG_DECRYPTED, this.onFragDecrypted, this), m.on(y.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), m.on(y.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), m.on(y.Events.BUFFER_FLUSHING, this.onBufferFlushing, this);
          }
          var g = v.prototype;
          return g.destroy = function() {
            var D = this.hls;
            D.off(y.Events.MEDIA_ATTACHING, this.onMediaAttaching, this), D.off(y.Events.MEDIA_DETACHING, this.onMediaDetaching, this), D.off(y.Events.MANIFEST_LOADING, this.onManifestLoading, this), D.off(y.Events.MANIFEST_LOADED, this.onManifestLoaded, this), D.off(y.Events.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), D.off(y.Events.FRAG_LOADING, this.onFragLoading, this), D.off(y.Events.FRAG_LOADED, this.onFragLoaded, this), D.off(y.Events.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), D.off(y.Events.FRAG_DECRYPTED, this.onFragDecrypted, this), D.off(y.Events.INIT_PTS_FOUND, this.onInitPtsFound, this), D.off(y.Events.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), D.off(y.Events.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = this.cea608Parser1 = this.cea608Parser2 = null;
          }, g.addCues = function(D, L, p, x, k) {
            for (var _ = !1, S = k.length; S--; ) {
              var h = k[S], C = d(h[0], h[1], L, p);
              if (C >= 0 && (h[0] = Math.min(h[0], L), h[1] = Math.max(h[1], p), _ = !0, C / (p - L) > 0.5))
                return;
            }
            if (_ || k.push([L, p]), this.config.renderTextTracksNatively) {
              var f = this.captionsTracks[D];
              this.Cues.newCue(f, L, p, x);
            } else {
              var P = this.Cues.newCue(null, L, p, x);
              this.hls.trigger(y.Events.CUES_PARSED, {
                type: "captions",
                cues: P,
                track: D
              });
            }
          }, g.onInitPtsFound = function(D, L) {
            var p = this, x = L.frag, k = L.id, _ = L.initPTS, S = L.timescale, h = this.unparsedVttFrags;
            k === "main" && (this.initPTS[x.cc] = _, this.timescale[x.cc] = S), h.length && (this.unparsedVttFrags = [], h.forEach(function(C) {
              p.onFragLoaded(y.Events.FRAG_LOADED, C);
            }));
          }, g.getExistingTrack = function(D) {
            var L = this.media;
            if (L)
              for (var p = 0; p < L.textTracks.length; p++) {
                var x = L.textTracks[p];
                if (x[D])
                  return x;
              }
            return null;
          }, g.createCaptionsTrack = function(D) {
            this.config.renderTextTracksNatively ? this.createNativeTrack(D) : this.createNonNativeTrack(D);
          }, g.createNativeTrack = function(D) {
            if (!this.captionsTracks[D]) {
              var L = this.captionsProperties, p = this.captionsTracks, x = this.media, k = L[D], _ = k.label, S = k.languageCode, h = this.getExistingTrack(D);
              if (h)
                p[D] = h, (0, I.clearCurrentCues)(p[D]), (0, I.sendAddTrackEvent)(p[D], x);
              else {
                var C = this.createTextTrack("captions", _, S);
                C && (C[D] = !0, p[D] = C);
              }
            }
          }, g.createNonNativeTrack = function(D) {
            if (!this.nonNativeCaptionsTracks[D]) {
              var L = this.captionsProperties[D];
              if (!!L) {
                var p = L.label, x = {
                  _id: D,
                  label: p,
                  kind: "captions",
                  default: L.media ? !!L.media.default : !1,
                  closedCaptions: L.media
                };
                this.nonNativeCaptionsTracks[D] = x, this.hls.trigger(y.Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                  tracks: [x]
                });
              }
            }
          }, g.createTextTrack = function(D, L, p) {
            var x = this.media;
            if (!!x)
              return x.addTextTrack(D, L, p);
          }, g.onMediaAttaching = function(D, L) {
            this.media = L.media, this._cleanTracks();
          }, g.onMediaDetaching = function() {
            var D = this.captionsTracks;
            Object.keys(D).forEach(function(L) {
              (0, I.clearCurrentCues)(D[L]), delete D[L];
            }), this.nonNativeCaptionsTracks = {};
          }, g.onManifestLoading = function() {
            this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = c(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = this.unparsedVttFrags || [], this.initPTS = [], this.timescale = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
          }, g._cleanTracks = function() {
            var D = this.media;
            if (!!D) {
              var L = D.textTracks;
              if (L)
                for (var p = 0; p < L.length; p++)
                  (0, I.clearCurrentCues)(L[p]);
            }
          }, g.onSubtitleTracksUpdated = function(D, L) {
            var p = this;
            this.textTracks = [];
            var x = L.subtitleTracks || [], k = x.some(function(C) {
              return C.textCodec === T.IMSC1_CODEC;
            });
            if (this.config.enableWebVTT || k && this.config.enableIMSC1) {
              var _ = this.tracks && x && this.tracks.length === x.length;
              if (this.tracks = x || [], this.config.renderTextTracksNatively) {
                var S = this.media ? this.media.textTracks : [];
                this.tracks.forEach(function(C, f) {
                  var P;
                  if (f < S.length) {
                    for (var F = null, R = 0; R < S.length; R++)
                      if (M(S[R], C)) {
                        F = S[R];
                        break;
                      }
                    F && (P = F);
                  }
                  if (P)
                    (0, I.clearCurrentCues)(P);
                  else {
                    var U = p._captionsOrSubtitlesFromCharacteristics(C);
                    P = p.createTextTrack(U, C.name, C.lang), P && (P.mode = "disabled");
                  }
                  P && (P.groupId = C.groupId, p.textTracks.push(P));
                });
              } else if (!_ && this.tracks && this.tracks.length) {
                var h = this.tracks.map(function(C) {
                  return {
                    label: C.name,
                    kind: C.type.toLowerCase(),
                    default: C.default,
                    subtitleTrack: C
                  };
                });
                this.hls.trigger(y.Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                  tracks: h
                });
              }
            }
          }, g._captionsOrSubtitlesFromCharacteristics = function(D) {
            var L;
            if ((L = D.attrs) !== null && L !== void 0 && L.CHARACTERISTICS) {
              var p = /transcribes-spoken-dialog/gi.test(D.attrs.CHARACTERISTICS), x = /describes-music-and-sound/gi.test(D.attrs.CHARACTERISTICS);
              if (p && x)
                return "captions";
            }
            return "subtitles";
          }, g.onManifestLoaded = function(D, L) {
            var p = this;
            this.config.enableCEA708Captions && L.captions && L.captions.forEach(function(x) {
              var k = /(?:CC|SERVICE)([1-4])/.exec(x.instreamId);
              if (!!k) {
                var _ = "textTrack" + k[1], S = p.captionsProperties[_];
                !S || (S.label = x.name, x.lang && (S.languageCode = x.lang), S.media = x);
              }
            });
          }, g.closedCaptionsForLevel = function(D) {
            var L = this.hls.levels[D.level];
            return L == null ? void 0 : L.attrs["CLOSED-CAPTIONS"];
          }, g.onFragLoading = function(D, L) {
            var p = this.cea608Parser1, x = this.cea608Parser2, k = this.lastSn, _ = this.lastPartIndex;
            if (!(!this.enabled || !(p && x)) && L.frag.type === w.PlaylistLevelType.MAIN) {
              var S, h, C = L.frag.sn, f = (S = L == null || (h = L.part) === null || h === void 0 ? void 0 : h.index) != null ? S : -1;
              C === k + 1 || C === k && f === _ + 1 || (p.reset(), x.reset()), this.lastSn = C, this.lastPartIndex = f;
            }
          }, g.onFragLoaded = function(D, L) {
            var p = L.frag, x = L.payload, k = this.initPTS, _ = this.unparsedVttFrags;
            if (p.type === w.PlaylistLevelType.SUBTITLE)
              if (x.byteLength) {
                if (!(0, b.isFiniteNumber)(k[p.cc])) {
                  _.push(L), k.length && this.hls.trigger(y.Events.SUBTITLE_FRAG_PROCESSED, {
                    success: !1,
                    frag: p,
                    error: new Error("Missing initial subtitle PTS")
                  });
                  return;
                }
                var S = p.decryptdata, h = "stats" in L;
                if (S == null || !S.encrypted || h) {
                  var C = this.tracks[p.level], f = this.vttCCs;
                  f[p.cc] || (f[p.cc] = {
                    start: p.start,
                    prevCC: this.prevCC,
                    new: !0
                  }, this.prevCC = p.cc), C && C.textCodec === T.IMSC1_CODEC ? this._parseIMSC1(p, x) : this._parseVTTs(p, x, f);
                }
              } else
                this.hls.trigger(y.Events.SUBTITLE_FRAG_PROCESSED, {
                  success: !1,
                  frag: p,
                  error: new Error("Empty subtitle payload")
                });
          }, g._parseIMSC1 = function(D, L) {
            var p = this, x = this.hls;
            (0, T.parseIMSC1)(L, this.initPTS[D.cc], this.timescale[D.cc], function(k) {
              p._appendCues(k, D.level), x.trigger(y.Events.SUBTITLE_FRAG_PROCESSED, {
                success: !0,
                frag: D
              });
            }, function(k) {
              O.logger.log("Failed to parse IMSC1: " + k), x.trigger(y.Events.SUBTITLE_FRAG_PROCESSED, {
                success: !1,
                frag: D,
                error: k
              });
            });
          }, g._parseVTTs = function(D, L, p) {
            var x, k = this, _ = this.hls, S = (x = D.initSegment) !== null && x !== void 0 && x.data ? (0, A.appendUint8Array)(D.initSegment.data, new Uint8Array(L)) : L;
            (0, B.parseWebVTT)(S, this.initPTS[D.cc], this.timescale[D.cc], p, D.cc, D.start, function(h) {
              k._appendCues(h, D.level), _.trigger(y.Events.SUBTITLE_FRAG_PROCESSED, {
                success: !0,
                frag: D
              });
            }, function(h) {
              k._fallbackToIMSC1(D, L), O.logger.log("Failed to parse VTT cue: " + h), _.trigger(y.Events.SUBTITLE_FRAG_PROCESSED, {
                success: !1,
                frag: D,
                error: h
              });
            });
          }, g._fallbackToIMSC1 = function(D, L) {
            var p = this, x = this.tracks[D.level];
            x.textCodec || (0, T.parseIMSC1)(L, this.initPTS[D.cc], this.timescale[D.cc], function() {
              x.textCodec = T.IMSC1_CODEC, p._parseIMSC1(D, L);
            }, function() {
              x.textCodec = "wvtt";
            });
          }, g._appendCues = function(D, L) {
            var p = this.hls;
            if (this.config.renderTextTracksNatively) {
              var x = this.textTracks[L];
              if (!x || x.mode === "disabled")
                return;
              D.forEach(function(S) {
                return (0, I.addCueToTrack)(x, S);
              });
            } else {
              var k = this.tracks[L];
              if (!k)
                return;
              var _ = k.default ? "default" : "subtitles" + L;
              p.trigger(y.Events.CUES_PARSED, {
                type: "subtitles",
                cues: D,
                track: _
              });
            }
          }, g.onFragDecrypted = function(D, L) {
            var p = L.frag;
            if (p.type === w.PlaylistLevelType.SUBTITLE) {
              if (!(0, b.isFiniteNumber)(this.initPTS[p.cc])) {
                this.unparsedVttFrags.push(L);
                return;
              }
              this.onFragLoaded(y.Events.FRAG_LOADED, L);
            }
          }, g.onSubtitleTracksCleared = function() {
            this.tracks = [], this.captionsTracks = {};
          }, g.onFragParsingUserdata = function(D, L) {
            var p = this.cea608Parser1, x = this.cea608Parser2;
            if (!(!this.enabled || !(p && x))) {
              var k = L.frag, _ = L.samples;
              if (!(k.type === w.PlaylistLevelType.MAIN && this.closedCaptionsForLevel(k) === "NONE"))
                for (var S = 0; S < _.length; S++) {
                  var h = _[S].bytes;
                  if (h) {
                    var C = this.extractCea608Data(h);
                    p.addData(_[S].pts, C[0]), x.addData(_[S].pts, C[1]);
                  }
                }
            }
          }, g.onBufferFlushing = function(D, L) {
            var p = L.startOffset, x = L.endOffset, k = L.endOffsetSubtitles, _ = L.type, S = this.media;
            if (!(!S || S.currentTime < x)) {
              if (!_ || _ === "video") {
                var h = this.captionsTracks;
                Object.keys(h).forEach(function(f) {
                  return (0, I.removeCuesInRange)(h[f], p, x);
                });
              }
              if (this.config.renderTextTracksNatively && p === 0 && k !== void 0) {
                var C = this.textTracks;
                Object.keys(C).forEach(function(f) {
                  return (0, I.removeCuesInRange)(C[f], p, k);
                });
              }
            }
          }, g.extractCea608Data = function(D) {
            for (var L = [[], []], p = D[0] & 31, x = 2, k = 0; k < p; k++) {
              var _ = D[x++], S = 127 & D[x++], h = 127 & D[x++];
              if (!(S === 0 && h === 0)) {
                var C = (4 & _) !== 0;
                if (C) {
                  var f = 3 & _;
                  (f === 0 || f === 1) && (L[f].push(S), L[f].push(h));
                }
              }
            }
            return L;
          }, v;
        }();
        function M(v, g) {
          return v && v.label === g.name && !(v.textTrack1 || v.textTrack2);
        }
        function d(v, g, m, D) {
          return Math.min(g, D) - Math.max(v, m);
        }
        function c() {
          return {
            ccOffset: 0,
            presentationOffset: 0,
            0: {
              start: 0,
              prevCC: -1,
              new: !0
            }
          };
        }
      },
      "./src/crypt/aes-crypto.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => b
        });
        var b = /* @__PURE__ */ function() {
          function y(E, B) {
            this.subtle = void 0, this.aesIV = void 0, this.subtle = E, this.aesIV = B;
          }
          var N = y.prototype;
          return N.decrypt = function(B, I) {
            return this.subtle.decrypt({
              name: "AES-CBC",
              iv: this.aesIV
            }, I, B);
          }, y;
        }();
      },
      "./src/crypt/aes-decryptor.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => N,
          removePadding: () => y
        });
        var b = a("./src/utils/typed-array.ts");
        function y(E) {
          var B = E.byteLength, I = B && new DataView(E.buffer).getUint8(B - 1);
          return I ? (0, b.sliceUint8)(E, 0, B - I) : E;
        }
        var N = /* @__PURE__ */ function() {
          function E() {
            this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
          }
          var B = E.prototype;
          return B.uint8ArrayToUint32Array_ = function(T) {
            for (var A = new DataView(T), w = new Uint32Array(4), O = 0; O < 4; O++)
              w[O] = A.getUint32(O * 4);
            return w;
          }, B.initTable = function() {
            var T = this.sBox, A = this.invSBox, w = this.subMix, O = w[0], u = w[1], M = w[2], d = w[3], c = this.invSubMix, v = c[0], g = c[1], m = c[2], D = c[3], L = new Uint32Array(256), p = 0, x = 0, k = 0;
            for (k = 0; k < 256; k++)
              k < 128 ? L[k] = k << 1 : L[k] = k << 1 ^ 283;
            for (k = 0; k < 256; k++) {
              var _ = x ^ x << 1 ^ x << 2 ^ x << 3 ^ x << 4;
              _ = _ >>> 8 ^ _ & 255 ^ 99, T[p] = _, A[_] = p;
              var S = L[p], h = L[S], C = L[h], f = L[_] * 257 ^ _ * 16843008;
              O[p] = f << 24 | f >>> 8, u[p] = f << 16 | f >>> 16, M[p] = f << 8 | f >>> 24, d[p] = f, f = C * 16843009 ^ h * 65537 ^ S * 257 ^ p * 16843008, v[_] = f << 24 | f >>> 8, g[_] = f << 16 | f >>> 16, m[_] = f << 8 | f >>> 24, D[_] = f, p ? (p = S ^ L[L[L[C ^ S]]], x ^= L[L[x]]) : p = x = 1;
            }
          }, B.expandKey = function(T) {
            for (var A = this.uint8ArrayToUint32Array_(T), w = !0, O = 0; O < A.length && w; )
              w = A[O] === this.key[O], O++;
            if (!w) {
              this.key = A;
              var u = this.keySize = A.length;
              if (u !== 4 && u !== 6 && u !== 8)
                throw new Error("Invalid aes key size=" + u);
              var M = this.ksRows = (u + 6 + 1) * 4, d, c, v = this.keySchedule = new Uint32Array(M), g = this.invKeySchedule = new Uint32Array(M), m = this.sBox, D = this.rcon, L = this.invSubMix, p = L[0], x = L[1], k = L[2], _ = L[3], S, h;
              for (d = 0; d < M; d++) {
                if (d < u) {
                  S = v[d] = A[d];
                  continue;
                }
                h = S, d % u === 0 ? (h = h << 8 | h >>> 24, h = m[h >>> 24] << 24 | m[h >>> 16 & 255] << 16 | m[h >>> 8 & 255] << 8 | m[h & 255], h ^= D[d / u | 0] << 24) : u > 6 && d % u === 4 && (h = m[h >>> 24] << 24 | m[h >>> 16 & 255] << 16 | m[h >>> 8 & 255] << 8 | m[h & 255]), v[d] = S = (v[d - u] ^ h) >>> 0;
              }
              for (c = 0; c < M; c++)
                d = M - c, c & 3 ? h = v[d] : h = v[d - 4], c < 4 || d <= 4 ? g[c] = h : g[c] = p[m[h >>> 24]] ^ x[m[h >>> 16 & 255]] ^ k[m[h >>> 8 & 255]] ^ _[m[h & 255]], g[c] = g[c] >>> 0;
            }
          }, B.networkToHostOrderSwap = function(T) {
            return T << 24 | (T & 65280) << 8 | (T & 16711680) >> 8 | T >>> 24;
          }, B.decrypt = function(T, A, w) {
            for (var O = this.keySize + 6, u = this.invKeySchedule, M = this.invSBox, d = this.invSubMix, c = d[0], v = d[1], g = d[2], m = d[3], D = this.uint8ArrayToUint32Array_(w), L = D[0], p = D[1], x = D[2], k = D[3], _ = new Int32Array(T), S = new Int32Array(_.length), h, C, f, P, F, R, U, K, V, W, G, H, $, Y, z = this.networkToHostOrderSwap; A < _.length; ) {
              for (V = z(_[A]), W = z(_[A + 1]), G = z(_[A + 2]), H = z(_[A + 3]), F = V ^ u[0], R = H ^ u[1], U = G ^ u[2], K = W ^ u[3], $ = 4, Y = 1; Y < O; Y++)
                h = c[F >>> 24] ^ v[R >> 16 & 255] ^ g[U >> 8 & 255] ^ m[K & 255] ^ u[$], C = c[R >>> 24] ^ v[U >> 16 & 255] ^ g[K >> 8 & 255] ^ m[F & 255] ^ u[$ + 1], f = c[U >>> 24] ^ v[K >> 16 & 255] ^ g[F >> 8 & 255] ^ m[R & 255] ^ u[$ + 2], P = c[K >>> 24] ^ v[F >> 16 & 255] ^ g[R >> 8 & 255] ^ m[U & 255] ^ u[$ + 3], F = h, R = C, U = f, K = P, $ = $ + 4;
              h = M[F >>> 24] << 24 ^ M[R >> 16 & 255] << 16 ^ M[U >> 8 & 255] << 8 ^ M[K & 255] ^ u[$], C = M[R >>> 24] << 24 ^ M[U >> 16 & 255] << 16 ^ M[K >> 8 & 255] << 8 ^ M[F & 255] ^ u[$ + 1], f = M[U >>> 24] << 24 ^ M[K >> 16 & 255] << 16 ^ M[F >> 8 & 255] << 8 ^ M[R & 255] ^ u[$ + 2], P = M[K >>> 24] << 24 ^ M[F >> 16 & 255] << 16 ^ M[R >> 8 & 255] << 8 ^ M[U & 255] ^ u[$ + 3], S[A] = z(h ^ L), S[A + 1] = z(P ^ p), S[A + 2] = z(f ^ x), S[A + 3] = z(C ^ k), L = V, p = W, x = G, k = H, A = A + 4;
            }
            return S.buffer;
          }, E;
        }();
      },
      "./src/crypt/decrypter.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => A
        });
        var b = a("./src/crypt/aes-crypto.ts"), y = a("./src/crypt/fast-aes-key.ts"), N = a("./src/crypt/aes-decryptor.ts"), E = a("./src/utils/logger.ts"), B = a("./src/utils/mp4-tools.ts"), I = a("./src/utils/typed-array.ts"), T = 16, A = /* @__PURE__ */ function() {
          function w(u, M) {
            var d = M === void 0 ? {} : M, c = d.removePKCS7Padding, v = c === void 0 ? !0 : c;
            if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.useSoftware = u.enableSoftwareAES, this.removePKCS7Padding = v, v)
              try {
                var g = self.crypto;
                g && (this.subtle = g.subtle || g.webkitSubtle);
              } catch {
              }
            this.subtle === null && (this.useSoftware = !0);
          }
          var O = w.prototype;
          return O.destroy = function() {
            this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
          }, O.isSync = function() {
            return this.useSoftware;
          }, O.flush = function() {
            var M = this.currentResult, d = this.remainderData;
            if (!M || d)
              return this.reset(), null;
            var c = new Uint8Array(M);
            return this.reset(), this.removePKCS7Padding ? (0, N.removePadding)(c) : c;
          }, O.reset = function() {
            this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
          }, O.decrypt = function(M, d, c) {
            var v = this;
            return this.useSoftware ? new Promise(function(g, m) {
              v.softwareDecrypt(new Uint8Array(M), d, c);
              var D = v.flush();
              D ? g(D.buffer) : m(new Error("[softwareDecrypt] Failed to decrypt data"));
            }) : this.webCryptoDecrypt(new Uint8Array(M), d, c);
          }, O.softwareDecrypt = function(M, d, c) {
            var v = this.currentIV, g = this.currentResult, m = this.remainderData;
            this.logOnce("JS AES decrypt"), m && (M = (0, B.appendUint8Array)(m, M), this.remainderData = null);
            var D = this.getValidChunk(M);
            if (!D.length)
              return null;
            v && (c = v);
            var L = this.softwareDecrypter;
            L || (L = this.softwareDecrypter = new N.default()), L.expandKey(d);
            var p = g;
            return this.currentResult = L.decrypt(D.buffer, 0, c), this.currentIV = (0, I.sliceUint8)(D, -16).buffer, p || null;
          }, O.webCryptoDecrypt = function(M, d, c) {
            var v = this, g = this.subtle;
            return (this.key !== d || !this.fastAesKey) && (this.key = d, this.fastAesKey = new y.default(g, d)), this.fastAesKey.expandKey().then(function(m) {
              if (!g)
                return Promise.reject(new Error("web crypto not initialized"));
              v.logOnce("WebCrypto AES decrypt");
              var D = new b.default(g, new Uint8Array(c));
              return D.decrypt(M.buffer, m);
            }).catch(function(m) {
              return E.logger.warn("[decrypter]: WebCrypto Error, disable WebCrypto API, " + m.name + ": " + m.message), v.onWebCryptoError(M, d, c);
            });
          }, O.onWebCryptoError = function(M, d, c) {
            this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(M, d, c);
            var v = this.flush();
            if (v)
              return v.buffer;
            throw new Error("WebCrypto and softwareDecrypt: failed to decrypt data");
          }, O.getValidChunk = function(M) {
            var d = M, c = M.length - M.length % T;
            return c !== M.length && (d = (0, I.sliceUint8)(M, 0, c), this.remainderData = (0, I.sliceUint8)(M, c)), d;
          }, O.logOnce = function(M) {
            !this.logEnabled || (E.logger.log("[decrypter]: " + M), this.logEnabled = !1);
          }, w;
        }();
      },
      "./src/crypt/fast-aes-key.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => b
        });
        var b = /* @__PURE__ */ function() {
          function y(E, B) {
            this.subtle = void 0, this.key = void 0, this.subtle = E, this.key = B;
          }
          var N = y.prototype;
          return N.expandKey = function() {
            return this.subtle.importKey("raw", this.key, {
              name: "AES-CBC"
            }, !1, ["encrypt", "decrypt"]);
          }, y;
        }();
      },
      "./src/demux/aacdemuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => A
        });
        var b = a("./src/demux/base-audio-demuxer.ts"), y = a("./src/demux/adts.ts"), N = a("./src/utils/logger.ts"), E = a("./src/demux/id3.ts");
        function B(w, O) {
          w.prototype = Object.create(O.prototype), w.prototype.constructor = w, I(w, O);
        }
        function I(w, O) {
          return I = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(M, d) {
            return M.__proto__ = d, M;
          }, I(w, O);
        }
        var T = /* @__PURE__ */ function(w) {
          B(O, w);
          function O(M, d) {
            var c;
            return c = w.call(this) || this, c.observer = void 0, c.config = void 0, c.observer = M, c.config = d, c;
          }
          var u = O.prototype;
          return u.resetInitSegment = function(d, c, v, g) {
            w.prototype.resetInitSegment.call(this, d, c, v, g), this._audioTrack = {
              container: "audio/adts",
              type: "audio",
              id: 2,
              pid: -1,
              sequenceNumber: 0,
              segmentCodec: "aac",
              samples: [],
              manifestCodec: c,
              duration: g,
              inputTimeScale: 9e4,
              dropped: 0
            };
          }, O.probe = function(d) {
            if (!d)
              return !1;
            for (var c = E.getID3Data(d, 0) || [], v = c.length, g = d.length; v < g; v++)
              if (y.probe(d, v))
                return N.logger.log("ADTS sync word found !"), !0;
            return !1;
          }, u.canParse = function(d, c) {
            return y.canParse(d, c);
          }, u.appendFrame = function(d, c, v) {
            y.initTrackConfig(d, this.observer, c, v, d.manifestCodec);
            var g = y.appendFrame(d, c, v, this.basePTS, this.frameIndex);
            if (g && g.missing === 0)
              return g;
          }, O;
        }(b.default);
        const A = T;
      },
      "./src/demux/adts.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          appendFrame: () => v,
          canGetFrameLength: () => A,
          canParse: () => O,
          getAudioConfig: () => E,
          getFrameDuration: () => d,
          getFullFrameLength: () => T,
          getHeaderLength: () => I,
          initTrackConfig: () => M,
          isHeader: () => w,
          isHeaderPattern: () => B,
          parseFrameHeader: () => c,
          probe: () => u
        });
        var b = a("./src/utils/logger.ts"), y = a("./src/errors.ts"), N = a("./src/events.ts");
        function E(g, m, D, L) {
          var p, x, k, _, S = navigator.userAgent.toLowerCase(), h = L, C = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
          p = ((m[D + 2] & 192) >>> 6) + 1;
          var f = (m[D + 2] & 60) >>> 2;
          if (f > C.length - 1) {
            g.trigger(N.Events.ERROR, {
              type: y.ErrorTypes.MEDIA_ERROR,
              details: y.ErrorDetails.FRAG_PARSING_ERROR,
              fatal: !0,
              reason: "invalid ADTS sampling index:" + f
            });
            return;
          }
          return k = (m[D + 2] & 1) << 2, k |= (m[D + 3] & 192) >>> 6, b.logger.log("manifest codec:" + L + ", ADTS type:" + p + ", samplingIndex:" + f), /firefox/i.test(S) ? f >= 6 ? (p = 5, _ = new Array(4), x = f - 3) : (p = 2, _ = new Array(2), x = f) : S.indexOf("android") !== -1 ? (p = 2, _ = new Array(2), x = f) : (p = 5, _ = new Array(4), L && (L.indexOf("mp4a.40.29") !== -1 || L.indexOf("mp4a.40.5") !== -1) || !L && f >= 6 ? x = f - 3 : ((L && L.indexOf("mp4a.40.2") !== -1 && (f >= 6 && k === 1 || /vivaldi/i.test(S)) || !L && k === 1) && (p = 2, _ = new Array(2)), x = f)), _[0] = p << 3, _[0] |= (f & 14) >> 1, _[1] |= (f & 1) << 7, _[1] |= k << 3, p === 5 && (_[1] |= (x & 14) >> 1, _[2] = (x & 1) << 7, _[2] |= 8, _[3] = 0), {
            config: _,
            samplerate: C[f],
            channelCount: k,
            codec: "mp4a.40." + p,
            manifestCodec: h
          };
        }
        function B(g, m) {
          return g[m] === 255 && (g[m + 1] & 246) === 240;
        }
        function I(g, m) {
          return g[m + 1] & 1 ? 7 : 9;
        }
        function T(g, m) {
          return (g[m + 3] & 3) << 11 | g[m + 4] << 3 | (g[m + 5] & 224) >>> 5;
        }
        function A(g, m) {
          return m + 5 < g.length;
        }
        function w(g, m) {
          return m + 1 < g.length && B(g, m);
        }
        function O(g, m) {
          return A(g, m) && B(g, m) && T(g, m) <= g.length - m;
        }
        function u(g, m) {
          if (w(g, m)) {
            var D = I(g, m);
            if (m + D >= g.length)
              return !1;
            var L = T(g, m);
            if (L <= D)
              return !1;
            var p = m + L;
            return p === g.length || w(g, p);
          }
          return !1;
        }
        function M(g, m, D, L, p) {
          if (!g.samplerate) {
            var x = E(m, D, L, p);
            if (!x)
              return;
            g.config = x.config, g.samplerate = x.samplerate, g.channelCount = x.channelCount, g.codec = x.codec, g.manifestCodec = x.manifestCodec, b.logger.log("parsed codec:" + g.codec + ", rate:" + x.samplerate + ", channels:" + x.channelCount);
          }
        }
        function d(g) {
          return 9216e4 / g;
        }
        function c(g, m) {
          var D = I(g, m);
          if (m + D <= g.length) {
            var L = T(g, m) - D;
            if (L > 0)
              return {
                headerLength: D,
                frameLength: L
              };
          }
        }
        function v(g, m, D, L, p) {
          var x = d(g.samplerate), k = L + p * x, _ = c(m, D), S;
          if (_) {
            var h = _.frameLength, C = _.headerLength, f = C + h, P = Math.max(0, D + f - m.length);
            P ? (S = new Uint8Array(f - C), S.set(m.subarray(D + C, m.length), 0)) : S = m.subarray(D + C, D + f);
            var F = {
              unit: S,
              pts: k
            };
            return P || g.samples.push(F), {
              sample: F,
              length: f,
              missing: P
            };
          }
          var R = m.length - D;
          S = new Uint8Array(R), S.set(m.subarray(D, m.length), 0);
          var U = {
            unit: S,
            pts: k
          };
          return {
            sample: U,
            length: R,
            missing: -1
          };
        }
      },
      "./src/demux/base-audio-demuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => w,
          initPTSFn: () => A
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/demux/id3.ts"), N = a("./src/types/demuxer.ts"), E = a("./src/demux/dummy-demuxed-track.ts"), B = a("./src/utils/mp4-tools.ts"), I = a("./src/utils/typed-array.ts"), T = /* @__PURE__ */ function() {
          function O() {
            this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
          }
          var u = O.prototype;
          return u.resetInitSegment = function(d, c, v, g) {
            this._id3Track = {
              type: "id3",
              id: 3,
              pid: -1,
              inputTimeScale: 9e4,
              sequenceNumber: 0,
              samples: [],
              dropped: 0
            };
          }, u.resetTimeStamp = function(d) {
            this.initPTS = d, this.resetContiguity();
          }, u.resetContiguity = function() {
            this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
          }, u.canParse = function(d, c) {
            return !1;
          }, u.appendFrame = function(d, c, v) {
          }, u.demux = function(d, c) {
            this.cachedData && (d = (0, B.appendUint8Array)(this.cachedData, d), this.cachedData = null);
            var v = y.getID3Data(d, 0), g = v ? v.length : 0, m, D = this._audioTrack, L = this._id3Track, p = v ? y.getTimeStamp(v) : void 0, x = d.length;
            for ((this.basePTS === null || this.frameIndex === 0 && (0, b.isFiniteNumber)(p)) && (this.basePTS = A(p, c, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), v && v.length > 0 && L.samples.push({
              pts: this.lastPTS,
              dts: this.lastPTS,
              data: v,
              type: N.MetadataSchema.audioId3,
              duration: Number.POSITIVE_INFINITY
            }); g < x; ) {
              if (this.canParse(d, g)) {
                var k = this.appendFrame(D, d, g);
                k ? (this.frameIndex++, this.lastPTS = k.sample.pts, g += k.length, m = g) : g = x;
              } else
                y.canParse(d, g) ? (v = y.getID3Data(d, g), L.samples.push({
                  pts: this.lastPTS,
                  dts: this.lastPTS,
                  data: v,
                  type: N.MetadataSchema.audioId3,
                  duration: Number.POSITIVE_INFINITY
                }), g += v.length, m = g) : g++;
              if (g === x && m !== x) {
                var _ = (0, I.sliceUint8)(d, m);
                this.cachedData ? this.cachedData = (0, B.appendUint8Array)(this.cachedData, _) : this.cachedData = _;
              }
            }
            return {
              audioTrack: D,
              videoTrack: (0, E.dummyTrack)(),
              id3Track: L,
              textTrack: (0, E.dummyTrack)()
            };
          }, u.demuxSampleAes = function(d, c, v) {
            return Promise.reject(new Error("[" + this + "] This demuxer does not support Sample-AES decryption"));
          }, u.flush = function(d) {
            var c = this.cachedData;
            return c && (this.cachedData = null, this.demux(c, 0)), {
              audioTrack: this._audioTrack,
              videoTrack: (0, E.dummyTrack)(),
              id3Track: this._id3Track,
              textTrack: (0, E.dummyTrack)()
            };
          }, u.destroy = function() {
          }, O;
        }(), A = function(u, M, d) {
          return (0, b.isFiniteNumber)(u) ? u * 90 : M * 9e4 + (d || 0);
        };
        const w = T;
      },
      "./src/demux/chunk-cache.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => b
        });
        var b = /* @__PURE__ */ function() {
          function N() {
            this.chunks = [], this.dataLength = 0;
          }
          var E = N.prototype;
          return E.push = function(I) {
            this.chunks.push(I), this.dataLength += I.length;
          }, E.flush = function() {
            var I = this.chunks, T = this.dataLength, A;
            if (I.length)
              I.length === 1 ? A = I[0] : A = y(I, T);
            else
              return new Uint8Array(0);
            return this.reset(), A;
          }, E.reset = function() {
            this.chunks.length = 0, this.dataLength = 0;
          }, N;
        }();
        function y(N, E) {
          for (var B = new Uint8Array(E), I = 0, T = 0; T < N.length; T++) {
            var A = N[T];
            B.set(A, I), I += A.length;
          }
          return B;
        }
      },
      "./src/demux/dummy-demuxed-track.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          dummyTrack: () => b
        });
        function b(y, N) {
          return y === void 0 && (y = ""), N === void 0 && (N = 9e4), {
            type: y,
            id: -1,
            pid: -1,
            inputTimeScale: N,
            sequenceNumber: -1,
            samples: [],
            dropped: 0
          };
        }
      },
      "./src/demux/exp-golomb.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => N
        });
        var b = a("./src/utils/logger.ts"), y = /* @__PURE__ */ function() {
          function E(I) {
            this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = I, this.bytesAvailable = I.byteLength, this.word = 0, this.bitsAvailable = 0;
          }
          var B = E.prototype;
          return B.loadWord = function() {
            var T = this.data, A = this.bytesAvailable, w = T.byteLength - A, O = new Uint8Array(4), u = Math.min(4, A);
            if (u === 0)
              throw new Error("no bytes available");
            O.set(T.subarray(w, w + u)), this.word = new DataView(O.buffer).getUint32(0), this.bitsAvailable = u * 8, this.bytesAvailable -= u;
          }, B.skipBits = function(T) {
            var A;
            T = Math.min(T, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > T ? (this.word <<= T, this.bitsAvailable -= T) : (T -= this.bitsAvailable, A = T >> 3, T -= A << 3, this.bytesAvailable -= A, this.loadWord(), this.word <<= T, this.bitsAvailable -= T);
          }, B.readBits = function(T) {
            var A = Math.min(this.bitsAvailable, T), w = this.word >>> 32 - A;
            if (T > 32 && b.logger.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= A, this.bitsAvailable > 0)
              this.word <<= A;
            else if (this.bytesAvailable > 0)
              this.loadWord();
            else
              throw new Error("no bits available");
            return A = T - A, A > 0 && this.bitsAvailable ? w << A | this.readBits(A) : w;
          }, B.skipLZ = function() {
            var T;
            for (T = 0; T < this.bitsAvailable; ++T)
              if ((this.word & 2147483648 >>> T) !== 0)
                return this.word <<= T, this.bitsAvailable -= T, T;
            return this.loadWord(), T + this.skipLZ();
          }, B.skipUEG = function() {
            this.skipBits(1 + this.skipLZ());
          }, B.skipEG = function() {
            this.skipBits(1 + this.skipLZ());
          }, B.readUEG = function() {
            var T = this.skipLZ();
            return this.readBits(T + 1) - 1;
          }, B.readEG = function() {
            var T = this.readUEG();
            return 1 & T ? 1 + T >>> 1 : -1 * (T >>> 1);
          }, B.readBoolean = function() {
            return this.readBits(1) === 1;
          }, B.readUByte = function() {
            return this.readBits(8);
          }, B.readUShort = function() {
            return this.readBits(16);
          }, B.readUInt = function() {
            return this.readBits(32);
          }, B.skipScalingList = function(T) {
            for (var A = 8, w = 8, O, u = 0; u < T; u++)
              w !== 0 && (O = this.readEG(), w = (A + O + 256) % 256), A = w === 0 ? A : w;
          }, B.readSPS = function() {
            var T = 0, A = 0, w = 0, O = 0, u, M, d, c = this.readUByte.bind(this), v = this.readBits.bind(this), g = this.readUEG.bind(this), m = this.readBoolean.bind(this), D = this.skipBits.bind(this), L = this.skipEG.bind(this), p = this.skipUEG.bind(this), x = this.skipScalingList.bind(this);
            c();
            var k = c();
            if (v(5), D(3), c(), p(), k === 100 || k === 110 || k === 122 || k === 244 || k === 44 || k === 83 || k === 86 || k === 118 || k === 128) {
              var _ = g();
              if (_ === 3 && D(1), p(), p(), D(1), m())
                for (M = _ !== 3 ? 8 : 12, d = 0; d < M; d++)
                  m() && (d < 6 ? x(16) : x(64));
            }
            p();
            var S = g();
            if (S === 0)
              g();
            else if (S === 1)
              for (D(1), L(), L(), u = g(), d = 0; d < u; d++)
                L();
            p(), D(1);
            var h = g(), C = g(), f = v(1);
            f === 0 && D(1), D(1), m() && (T = g(), A = g(), w = g(), O = g());
            var P = [1, 1];
            if (m() && m()) {
              var F = c();
              switch (F) {
                case 1:
                  P = [1, 1];
                  break;
                case 2:
                  P = [12, 11];
                  break;
                case 3:
                  P = [10, 11];
                  break;
                case 4:
                  P = [16, 11];
                  break;
                case 5:
                  P = [40, 33];
                  break;
                case 6:
                  P = [24, 11];
                  break;
                case 7:
                  P = [20, 11];
                  break;
                case 8:
                  P = [32, 11];
                  break;
                case 9:
                  P = [80, 33];
                  break;
                case 10:
                  P = [18, 11];
                  break;
                case 11:
                  P = [15, 11];
                  break;
                case 12:
                  P = [64, 33];
                  break;
                case 13:
                  P = [160, 99];
                  break;
                case 14:
                  P = [4, 3];
                  break;
                case 15:
                  P = [3, 2];
                  break;
                case 16:
                  P = [2, 1];
                  break;
                case 255: {
                  P = [c() << 8 | c(), c() << 8 | c()];
                  break;
                }
              }
            }
            return {
              width: Math.ceil((h + 1) * 16 - T * 2 - A * 2),
              height: (2 - f) * (C + 1) * 16 - (f ? 2 : 4) * (w + O),
              pixelRatio: P
            };
          }, B.readSliceType = function() {
            return this.readUByte(), this.readUEG(), this.readUEG();
          }, E;
        }();
        const N = y;
      },
      "./src/demux/id3.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          canParse: () => B,
          decodeFrame: () => O,
          getID3Data: () => N,
          getID3Frames: () => w,
          getTimeStamp: () => I,
          isFooter: () => y,
          isHeader: () => b,
          isTimeStampFrame: () => T,
          testables: () => g,
          utf8ArrayToStr: () => v
        });
        var b = function(p, x) {
          return x + 10 <= p.length && p[x] === 73 && p[x + 1] === 68 && p[x + 2] === 51 && p[x + 3] < 255 && p[x + 4] < 255 && p[x + 6] < 128 && p[x + 7] < 128 && p[x + 8] < 128 && p[x + 9] < 128;
        }, y = function(p, x) {
          return x + 10 <= p.length && p[x] === 51 && p[x + 1] === 68 && p[x + 2] === 73 && p[x + 3] < 255 && p[x + 4] < 255 && p[x + 6] < 128 && p[x + 7] < 128 && p[x + 8] < 128 && p[x + 9] < 128;
        }, N = function(p, x) {
          for (var k = x, _ = 0; b(p, x); ) {
            _ += 10;
            var S = E(p, x + 6);
            _ += S, y(p, x + 10) && (_ += 10), x += _;
          }
          if (_ > 0)
            return p.subarray(k, k + _);
        }, E = function(p, x) {
          var k = 0;
          return k = (p[x] & 127) << 21, k |= (p[x + 1] & 127) << 14, k |= (p[x + 2] & 127) << 7, k |= p[x + 3] & 127, k;
        }, B = function(p, x) {
          return b(p, x) && E(p, x + 6) + 10 <= p.length - x;
        }, I = function(p) {
          for (var x = w(p), k = 0; k < x.length; k++) {
            var _ = x[k];
            if (T(_))
              return c(_);
          }
        }, T = function(p) {
          return p && p.key === "PRIV" && p.info === "com.apple.streaming.transportStreamTimestamp";
        }, A = function(p) {
          var x = String.fromCharCode(p[0], p[1], p[2], p[3]), k = E(p, 4), _ = 10;
          return {
            type: x,
            size: k,
            data: p.subarray(_, _ + k)
          };
        }, w = function(p) {
          for (var x = 0, k = []; b(p, x); ) {
            var _ = E(p, x + 6);
            x += 10;
            for (var S = x + _; x + 8 < S; ) {
              var h = A(p.subarray(x)), C = O(h);
              C && k.push(C), x += h.size + 10;
            }
            y(p, x) && (x += 10);
          }
          return k;
        }, O = function(p) {
          return p.type === "PRIV" ? u(p) : p.type[0] === "W" ? d(p) : M(p);
        }, u = function(p) {
          if (!(p.size < 2)) {
            var x = v(p.data, !0), k = new Uint8Array(p.data.subarray(x.length + 1));
            return {
              key: p.type,
              info: x,
              data: k.buffer
            };
          }
        }, M = function(p) {
          if (!(p.size < 2)) {
            if (p.type === "TXXX") {
              var x = 1, k = v(p.data.subarray(x), !0);
              x += k.length + 1;
              var _ = v(p.data.subarray(x));
              return {
                key: p.type,
                info: k,
                data: _
              };
            }
            var S = v(p.data.subarray(1));
            return {
              key: p.type,
              data: S
            };
          }
        }, d = function(p) {
          if (p.type === "WXXX") {
            if (p.size < 2)
              return;
            var x = 1, k = v(p.data.subarray(x), !0);
            x += k.length + 1;
            var _ = v(p.data.subarray(x));
            return {
              key: p.type,
              info: k,
              data: _
            };
          }
          var S = v(p.data);
          return {
            key: p.type,
            data: S
          };
        }, c = function(p) {
          if (p.data.byteLength === 8) {
            var x = new Uint8Array(p.data), k = x[3] & 1, _ = (x[4] << 23) + (x[5] << 15) + (x[6] << 7) + x[7];
            return _ /= 45, k && (_ += 4772185884e-2), Math.round(_);
          }
        }, v = function(p, x) {
          x === void 0 && (x = !1);
          var k = D();
          if (k) {
            var _ = k.decode(p);
            if (x) {
              var S = _.indexOf("\0");
              return S !== -1 ? _.substring(0, S) : _;
            }
            return _.replace(/\0/g, "");
          }
          for (var h = p.length, C, f, P, F = "", R = 0; R < h; ) {
            if (C = p[R++], C === 0 && x)
              return F;
            if (C === 0 || C === 3)
              continue;
            switch (C >> 4) {
              case 0:
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
              case 6:
              case 7:
                F += String.fromCharCode(C);
                break;
              case 12:
              case 13:
                f = p[R++], F += String.fromCharCode((C & 31) << 6 | f & 63);
                break;
              case 14:
                f = p[R++], P = p[R++], F += String.fromCharCode((C & 15) << 12 | (f & 63) << 6 | (P & 63) << 0);
                break;
            }
          }
          return F;
        }, g = {
          decodeTextFrame: M
        }, m;
        function D() {
          return !m && typeof self.TextDecoder < "u" && (m = new self.TextDecoder("utf-8")), m;
        }
      },
      "./src/demux/mp3demuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => A
        });
        var b = a("./src/demux/base-audio-demuxer.ts"), y = a("./src/demux/id3.ts"), N = a("./src/utils/logger.ts"), E = a("./src/demux/mpegaudio.ts");
        function B(w, O) {
          w.prototype = Object.create(O.prototype), w.prototype.constructor = w, I(w, O);
        }
        function I(w, O) {
          return I = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(M, d) {
            return M.__proto__ = d, M;
          }, I(w, O);
        }
        var T = /* @__PURE__ */ function(w) {
          B(O, w);
          function O() {
            return w.apply(this, arguments) || this;
          }
          var u = O.prototype;
          return u.resetInitSegment = function(d, c, v, g) {
            w.prototype.resetInitSegment.call(this, d, c, v, g), this._audioTrack = {
              container: "audio/mpeg",
              type: "audio",
              id: 2,
              pid: -1,
              sequenceNumber: 0,
              segmentCodec: "mp3",
              samples: [],
              manifestCodec: c,
              duration: g,
              inputTimeScale: 9e4,
              dropped: 0
            };
          }, O.probe = function(d) {
            if (!d)
              return !1;
            for (var c = y.getID3Data(d, 0) || [], v = c.length, g = d.length; v < g; v++)
              if (E.probe(d, v))
                return N.logger.log("MPEG Audio sync word found !"), !0;
            return !1;
          }, u.canParse = function(d, c) {
            return E.canParse(d, c);
          }, u.appendFrame = function(d, c, v) {
            if (this.basePTS !== null)
              return E.appendFrame(d, c, v, this.basePTS, this.frameIndex);
          }, O;
        }(b.default);
        const A = T;
      },
      "./src/demux/mp4demuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => T
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/types/demuxer.ts"), N = a("./src/utils/mp4-tools.ts"), E = a("./src/demux/dummy-demuxed-track.ts"), B = /\/emsg[-/]ID3/i, I = /* @__PURE__ */ function() {
          function A(O, u) {
            this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = u;
          }
          var w = A.prototype;
          return w.resetTimeStamp = function() {
          }, w.resetInitSegment = function(u, M, d, c) {
            var v = this.videoTrack = (0, E.dummyTrack)("video", 1), g = this.audioTrack = (0, E.dummyTrack)("audio", 1), m = this.txtTrack = (0, E.dummyTrack)("text", 1);
            if (this.id3Track = (0, E.dummyTrack)("id3", 1), this.timeOffset = 0, !(!u || !u.byteLength)) {
              var D = (0, N.parseInitSegment)(u);
              if (D.video) {
                var L = D.video, p = L.id, x = L.timescale, k = L.codec;
                v.id = p, v.timescale = m.timescale = x, v.codec = k;
              }
              if (D.audio) {
                var _ = D.audio, S = _.id, h = _.timescale, C = _.codec;
                g.id = S, g.timescale = h, g.codec = C;
              }
              m.id = N.RemuxerTrackIdConfig.text, v.sampleDuration = 0, v.duration = g.duration = c;
            }
          }, w.resetContiguity = function() {
          }, A.probe = function(u) {
            return u = u.length > 16384 ? u.subarray(0, 16384) : u, (0, N.findBox)(u, ["moof"]).length > 0;
          }, w.demux = function(u, M) {
            this.timeOffset = M;
            var d = u, c = this.videoTrack, v = this.txtTrack;
            if (this.config.progressive) {
              this.remainderData && (d = (0, N.appendUint8Array)(this.remainderData, u));
              var g = (0, N.segmentValidRange)(d);
              this.remainderData = g.remainder, c.samples = g.valid || new Uint8Array();
            } else
              c.samples = d;
            var m = this.extractID3Track(c, M);
            return v.samples = (0, N.parseSamples)(M, c), {
              videoTrack: c,
              audioTrack: this.audioTrack,
              id3Track: m,
              textTrack: this.txtTrack
            };
          }, w.flush = function() {
            var u = this.timeOffset, M = this.videoTrack, d = this.txtTrack;
            M.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
            var c = this.extractID3Track(M, this.timeOffset);
            return d.samples = (0, N.parseSamples)(u, M), {
              videoTrack: M,
              audioTrack: (0, E.dummyTrack)(),
              id3Track: c,
              textTrack: (0, E.dummyTrack)()
            };
          }, w.extractID3Track = function(u, M) {
            var d = this.id3Track;
            if (u.samples.length) {
              var c = (0, N.findBox)(u.samples, ["emsg"]);
              c && c.forEach(function(v) {
                var g = (0, N.parseEmsg)(v);
                if (B.test(g.schemeIdUri)) {
                  var m = (0, b.isFiniteNumber)(g.presentationTime) ? g.presentationTime / g.timeScale : M + g.presentationTimeDelta / g.timeScale, D = g.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : g.eventDuration / g.timeScale;
                  D <= 1e-3 && (D = Number.POSITIVE_INFINITY);
                  var L = g.payload;
                  d.samples.push({
                    data: L,
                    len: L.byteLength,
                    dts: m,
                    pts: m,
                    type: y.MetadataSchema.emsg,
                    duration: D
                  });
                }
              });
            }
            return d;
          }, w.demuxSampleAes = function(u, M, d) {
            return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
          }, w.destroy = function() {
          }, A;
        }();
        const T = I;
      },
      "./src/demux/mpegaudio.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          appendFrame: () => I,
          canParse: () => O,
          isHeader: () => w,
          isHeaderPattern: () => A,
          parseHeader: () => T,
          probe: () => u
        });
        var b = null, y = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], N = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], E = [
          [
            0,
            72,
            144,
            12
          ],
          [
            0,
            0,
            0,
            0
          ],
          [
            0,
            72,
            144,
            12
          ],
          [
            0,
            144,
            144,
            12
          ]
        ], B = [
          0,
          1,
          1,
          4
        ];
        function I(M, d, c, v, g) {
          if (!(c + 24 > d.length)) {
            var m = T(d, c);
            if (m && c + m.frameLength <= d.length) {
              var D = m.samplesPerFrame * 9e4 / m.sampleRate, L = v + g * D, p = {
                unit: d.subarray(c, c + m.frameLength),
                pts: L,
                dts: L
              };
              return M.config = [], M.channelCount = m.channelCount, M.samplerate = m.sampleRate, M.samples.push(p), {
                sample: p,
                length: m.frameLength,
                missing: 0
              };
            }
          }
        }
        function T(M, d) {
          var c = M[d + 1] >> 3 & 3, v = M[d + 1] >> 1 & 3, g = M[d + 2] >> 4 & 15, m = M[d + 2] >> 2 & 3;
          if (c !== 1 && g !== 0 && g !== 15 && m !== 3) {
            var D = M[d + 2] >> 1 & 1, L = M[d + 3] >> 6, p = c === 3 ? 3 - v : v === 3 ? 3 : 4, x = y[p * 14 + g - 1] * 1e3, k = c === 3 ? 0 : c === 2 ? 1 : 2, _ = N[k * 3 + m], S = L === 3 ? 1 : 2, h = E[c][v], C = B[v], f = h * 8 * C, P = Math.floor(h * x / _ + D) * C;
            if (b === null) {
              var F = navigator.userAgent || "", R = F.match(/Chrome\/(\d+)/i);
              b = R ? parseInt(R[1]) : 0;
            }
            var U = !!b && b <= 87;
            return U && v === 2 && x >= 224e3 && L === 0 && (M[d + 3] = M[d + 3] | 128), {
              sampleRate: _,
              channelCount: S,
              frameLength: P,
              samplesPerFrame: f
            };
          }
        }
        function A(M, d) {
          return M[d] === 255 && (M[d + 1] & 224) === 224 && (M[d + 1] & 6) !== 0;
        }
        function w(M, d) {
          return d + 1 < M.length && A(M, d);
        }
        function O(M, d) {
          var c = 4;
          return A(M, d) && c <= M.length - d;
        }
        function u(M, d) {
          if (d + 1 < M.length && A(M, d)) {
            var c = 4, v = T(M, d), g = c;
            v != null && v.frameLength && (g = v.frameLength);
            var m = d + g;
            return m === M.length || w(M, m);
          }
          return !1;
        }
      },
      "./src/demux/sample-aes.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => E
        });
        var b = a("./src/crypt/decrypter.ts"), y = a("./src/utils/mp4-tools.ts"), N = /* @__PURE__ */ function() {
          function B(T, A, w) {
            this.keyData = void 0, this.decrypter = void 0, this.keyData = w, this.decrypter = new b.default(A, {
              removePKCS7Padding: !1
            });
          }
          var I = B.prototype;
          return I.decryptBuffer = function(A) {
            return this.decrypter.decrypt(A, this.keyData.key.buffer, this.keyData.iv.buffer);
          }, I.decryptAacSample = function(A, w, O) {
            var u = this, M = A[w].unit;
            if (!(M.length <= 16)) {
              var d = M.subarray(16, M.length - M.length % 16), c = d.buffer.slice(d.byteOffset, d.byteOffset + d.length);
              this.decryptBuffer(c).then(function(v) {
                var g = new Uint8Array(v);
                M.set(g, 16), u.decrypter.isSync() || u.decryptAacSamples(A, w + 1, O);
              });
            }
          }, I.decryptAacSamples = function(A, w, O) {
            for (; ; w++) {
              if (w >= A.length) {
                O();
                return;
              }
              if (!(A[w].unit.length < 32) && (this.decryptAacSample(A, w, O), !this.decrypter.isSync()))
                return;
            }
          }, I.getAvcEncryptedData = function(A) {
            for (var w = Math.floor((A.length - 48) / 160) * 16 + 16, O = new Int8Array(w), u = 0, M = 32; M < A.length - 16; M += 160, u += 16)
              O.set(A.subarray(M, M + 16), u);
            return O;
          }, I.getAvcDecryptedUnit = function(A, w) {
            for (var O = new Uint8Array(w), u = 0, M = 32; M < A.length - 16; M += 160, u += 16)
              A.set(O.subarray(u, u + 16), M);
            return A;
          }, I.decryptAvcSample = function(A, w, O, u, M) {
            var d = this, c = (0, y.discardEPB)(M.data), v = this.getAvcEncryptedData(c);
            this.decryptBuffer(v.buffer).then(function(g) {
              M.data = d.getAvcDecryptedUnit(c, g), d.decrypter.isSync() || d.decryptAvcSamples(A, w, O + 1, u);
            });
          }, I.decryptAvcSamples = function(A, w, O, u) {
            if (A instanceof Uint8Array)
              throw new Error("Cannot decrypt samples of type Uint8Array");
            for (; ; w++, O = 0) {
              if (w >= A.length) {
                u();
                return;
              }
              for (var M = A[w].units; !(O >= M.length); O++) {
                var d = M[O];
                if (!(d.data.length <= 48 || d.type !== 1 && d.type !== 5) && (this.decryptAvcSample(A, w, O, u, d), !this.decrypter.isSync()))
                  return;
              }
            }
          }, B;
        }();
        const E = N;
      },
      "./src/demux/transmuxer-interface.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => w
        });
        var b = a("./src/demux/webworkify-webpack.js"), y = a("./src/events.ts"), N = a("./src/demux/transmuxer.ts"), E = a("./src/utils/logger.ts"), B = a("./src/errors.ts"), I = a("./src/utils/mediasource-helper.ts"), T = a("./node_modules/eventemitter3/index.js"), A = (0, I.getMediaSource)() || {
          isTypeSupported: function() {
            return !1;
          }
        }, w = /* @__PURE__ */ function() {
          function O(M, d, c, v) {
            var g = this;
            this.hls = void 0, this.id = void 0, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.worker = void 0, this.onwmsg = void 0, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0;
            var m = M.config;
            this.hls = M, this.id = d, this.useWorker = !!m.enableWorker, this.onTransmuxComplete = c, this.onFlush = v;
            var D = function(_, S) {
              S = S || {}, S.frag = g.frag, S.id = g.id, g.hls.trigger(_, S);
            };
            this.observer = new T.EventEmitter(), this.observer.on(y.Events.FRAG_DECRYPTED, D), this.observer.on(y.Events.ERROR, D);
            var L = {
              mp4: A.isTypeSupported("video/mp4"),
              mpeg: A.isTypeSupported("audio/mpeg"),
              mp3: A.isTypeSupported('audio/mp4; codecs="mp3"')
            }, p = navigator.vendor;
            if (this.useWorker && typeof Worker < "u") {
              E.logger.log("demuxing in webworker");
              var x;
              try {
                x = this.worker = (0, b.default)("./src/demux/transmuxer-worker.ts"), this.onwmsg = this.onWorkerMessage.bind(this), x.addEventListener("message", this.onwmsg), x.onerror = function(k) {
                  g.useWorker = !1, E.logger.warn("Exception in webworker, fallback to inline"), g.hls.trigger(y.Events.ERROR, {
                    type: B.ErrorTypes.OTHER_ERROR,
                    details: B.ErrorDetails.INTERNAL_EXCEPTION,
                    fatal: !1,
                    event: "demuxerWorker",
                    error: new Error(k.message + "  (" + k.filename + ":" + k.lineno + ")")
                  });
                }, x.postMessage({
                  cmd: "init",
                  typeSupported: L,
                  vendor: p,
                  id: d,
                  config: JSON.stringify(m)
                });
              } catch (k) {
                E.logger.warn("Error in worker:", k), E.logger.error("Error while initializing DemuxerWorker, fallback to inline"), x && self.URL.revokeObjectURL(x.objectURL), this.transmuxer = new N.default(this.observer, L, m, p, d), this.worker = null;
              }
            } else
              this.transmuxer = new N.default(this.observer, L, m, p, d);
          }
          var u = O.prototype;
          return u.destroy = function() {
            var d = this.worker;
            if (d)
              d.removeEventListener("message", this.onwmsg), d.terminate(), this.worker = null, this.onwmsg = void 0;
            else {
              var c = this.transmuxer;
              c && (c.destroy(), this.transmuxer = null);
            }
            var v = this.observer;
            v && v.removeAllListeners(), this.frag = null, this.observer = null, this.hls = null;
          }, u.push = function(d, c, v, g, m, D, L, p, x, k) {
            var _, S, h = this;
            x.transmuxing.start = self.performance.now();
            var C = this.transmuxer, f = this.worker, P = D ? D.start : m.start, F = m.decryptdata, R = this.frag, U = !(R && m.cc === R.cc), K = !(R && x.level === R.level), V = R ? x.sn - R.sn : -1, W = this.part ? x.part - this.part.index : -1, G = V === 0 && x.id > 1 && x.id === (R == null ? void 0 : R.stats.chunkCount), H = !K && (V === 1 || V === 0 && (W === 1 || G && W <= 0)), $ = self.performance.now();
            (K || V || m.stats.parsing.start === 0) && (m.stats.parsing.start = $), D && (W || !H) && (D.stats.parsing.start = $);
            var Y = !(R && ((_ = m.initSegment) === null || _ === void 0 ? void 0 : _.url) === ((S = R.initSegment) === null || S === void 0 ? void 0 : S.url)), z = new N.TransmuxState(U, H, p, K, P, Y);
            if (!H || U || Y) {
              E.logger.log("[transmuxer-interface, " + m.type + "]: Starting new transmux session for sn: " + x.sn + " p: " + x.part + " level: " + x.level + " id: " + x.id + `
        discontinuity: ` + U + `
        trackSwitch: ` + K + `
        contiguous: ` + H + `
        accurateTimeOffset: ` + p + `
        timeOffset: ` + P + `
        initSegmentChange: ` + Y);
              var X = new N.TransmuxConfig(v, g, c, L, k);
              this.configureTransmuxer(X);
            }
            if (this.frag = m, this.part = D, f)
              f.postMessage({
                cmd: "demux",
                data: d,
                decryptdata: F,
                chunkMeta: x,
                state: z
              }, d instanceof ArrayBuffer ? [d] : []);
            else if (C) {
              var Q = C.push(d, F, x, z);
              (0, N.isPromise)(Q) ? (C.async = !0, Q.then(function(q) {
                h.handleTransmuxComplete(q);
              }).catch(function(q) {
                h.transmuxerError(q, x, "transmuxer-interface push error");
              })) : (C.async = !1, this.handleTransmuxComplete(Q));
            }
          }, u.flush = function(d) {
            var c = this;
            d.transmuxing.start = self.performance.now();
            var v = this.transmuxer, g = this.worker;
            if (g)
              g.postMessage({
                cmd: "flush",
                chunkMeta: d
              });
            else if (v) {
              var m = v.flush(d), D = (0, N.isPromise)(m);
              D || v.async ? ((0, N.isPromise)(m) || (m = Promise.resolve(m)), m.then(function(L) {
                c.handleFlushResult(L, d);
              }).catch(function(L) {
                c.transmuxerError(L, d, "transmuxer-interface flush error");
              })) : this.handleFlushResult(m, d);
            }
          }, u.transmuxerError = function(d, c, v) {
            !this.hls || this.hls.trigger(y.Events.ERROR, {
              type: B.ErrorTypes.MEDIA_ERROR,
              details: B.ErrorDetails.FRAG_PARSING_ERROR,
              chunkMeta: c,
              fatal: !1,
              error: d,
              err: d,
              reason: v
            });
          }, u.handleFlushResult = function(d, c) {
            var v = this;
            d.forEach(function(g) {
              v.handleTransmuxComplete(g);
            }), this.onFlush(c);
          }, u.onWorkerMessage = function(d) {
            var c = d.data, v = this.hls;
            switch (c.event) {
              case "init": {
                self.URL.revokeObjectURL(this.worker.objectURL);
                break;
              }
              case "transmuxComplete": {
                this.handleTransmuxComplete(c.data);
                break;
              }
              case "flush": {
                this.onFlush(c.data);
                break;
              }
              case "workerLog":
                E.logger[c.data.logType] && E.logger[c.data.logType](c.data.message);
                break;
              default: {
                c.data = c.data || {}, c.data.frag = this.frag, c.data.id = this.id, v.trigger(c.event, c.data);
                break;
              }
            }
          }, u.configureTransmuxer = function(d) {
            var c = this.worker, v = this.transmuxer;
            c ? c.postMessage({
              cmd: "configure",
              config: d
            }) : v && v.configure(d);
          }, u.handleTransmuxComplete = function(d) {
            d.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(d);
          }, O;
        }();
      },
      "./src/demux/transmuxer-worker.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => I
        });
        var b = a("./src/demux/transmuxer.ts"), y = a("./src/events.ts"), N = a("./src/utils/logger.ts"), E = a("./node_modules/eventemitter3/index.js"), B = a("./src/errors.ts");
        function I(u) {
          var M = new E.EventEmitter(), d = function(g, m) {
            u.postMessage({
              event: g,
              data: m
            });
          };
          M.on(y.Events.FRAG_DECRYPTED, d), M.on(y.Events.ERROR, d);
          var c = function() {
            var g = function(L) {
              var p = function(k) {
                d("workerLog", {
                  logType: L,
                  message: k
                });
              };
              N.logger[L] = p;
            };
            for (var m in N.logger)
              g(m);
          };
          u.addEventListener("message", function(v) {
            var g = v.data;
            switch (g.cmd) {
              case "init": {
                var m = JSON.parse(g.config);
                u.transmuxer = new b.default(M, g.typeSupported, m, g.vendor, g.id), (0, N.enableLogs)(m.debug, g.id), c(), d("init", null);
                break;
              }
              case "configure": {
                u.transmuxer.configure(g.config);
                break;
              }
              case "demux": {
                var D = u.transmuxer.push(g.data, g.decryptdata, g.chunkMeta, g.state);
                (0, b.isPromise)(D) ? (u.transmuxer.async = !0, D.then(function(k) {
                  T(u, k);
                }).catch(function(k) {
                  d(y.Events.ERROR, {
                    type: B.ErrorTypes.MEDIA_ERROR,
                    details: B.ErrorDetails.FRAG_PARSING_ERROR,
                    chunkMeta: g.chunkMeta,
                    fatal: !1,
                    error: k,
                    err: k,
                    reason: "transmuxer-worker push error"
                  });
                })) : (u.transmuxer.async = !1, T(u, D));
                break;
              }
              case "flush": {
                var L = g.chunkMeta, p = u.transmuxer.flush(L), x = (0, b.isPromise)(p);
                x || u.transmuxer.async ? ((0, b.isPromise)(p) || (p = Promise.resolve(p)), p.then(function(k) {
                  w(u, k, L);
                }).catch(function(k) {
                  d(y.Events.ERROR, {
                    type: B.ErrorTypes.MEDIA_ERROR,
                    details: B.ErrorDetails.FRAG_PARSING_ERROR,
                    chunkMeta: g.chunkMeta,
                    fatal: !1,
                    error: k,
                    err: k,
                    reason: "transmuxer-worker flush error"
                  });
                })) : w(u, p, L);
                break;
              }
            }
          });
        }
        function T(u, M) {
          if (O(M.remuxResult))
            return !1;
          var d = [], c = M.remuxResult, v = c.audio, g = c.video;
          return v && A(d, v), g && A(d, g), u.postMessage({
            event: "transmuxComplete",
            data: M
          }, d), !0;
        }
        function A(u, M) {
          M.data1 && u.push(M.data1.buffer), M.data2 && u.push(M.data2.buffer);
        }
        function w(u, M, d) {
          var c = M.reduce(function(v, g) {
            return T(u, g) || v;
          }, !1);
          c || u.postMessage({
            event: "transmuxComplete",
            data: M[0]
          }), u.postMessage({
            event: "flush",
            data: d
          });
        }
        function O(u) {
          return !u.audio && !u.video && !u.text && !u.id3 && !u.initSegment;
        }
      },
      "./src/demux/transmuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          TransmuxConfig: () => m,
          TransmuxState: () => D,
          default: () => d,
          isPromise: () => g
        });
        var b = a("./src/events.ts"), y = a("./src/errors.ts"), N = a("./src/crypt/decrypter.ts"), E = a("./src/demux/aacdemuxer.ts"), B = a("./src/demux/mp4demuxer.ts"), I = a("./src/demux/tsdemuxer.ts"), T = a("./src/demux/mp3demuxer.ts"), A = a("./src/remux/mp4-remuxer.ts"), w = a("./src/remux/passthrough-remuxer.ts"), O = a("./src/utils/logger.ts"), u;
        try {
          u = self.performance.now.bind(self.performance);
        } catch {
          O.logger.debug("Unable to use Performance API on this environment"), u = self.Date.now;
        }
        var M = [{
          demux: B.default,
          remux: w.default
        }, {
          demux: I.default,
          remux: A.default
        }, {
          demux: E.default,
          remux: A.default
        }, {
          demux: T.default,
          remux: A.default
        }], d = /* @__PURE__ */ function() {
          function L(x, k, _, S, h) {
            this.async = !1, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.vendor = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = x, this.typeSupported = k, this.config = _, this.vendor = S, this.id = h;
          }
          var p = L.prototype;
          return p.configure = function(k) {
            this.transmuxConfig = k, this.decrypter && this.decrypter.reset();
          }, p.push = function(k, _, S, h) {
            var C = this, f = S.transmuxing;
            f.executeStart = u();
            var P = new Uint8Array(k), F = this.currentTransmuxState, R = this.transmuxConfig;
            h && (this.currentTransmuxState = h);
            var U = h || F, K = U.contiguous, V = U.discontinuity, W = U.trackSwitch, G = U.accurateTimeOffset, H = U.timeOffset, $ = U.initSegmentChange, Y = R.audioCodec, z = R.videoCodec, X = R.defaultInitPts, Q = R.duration, q = R.initSegmentData, Z = c(P, _);
            if (Z && Z.method === "AES-128") {
              var J = this.getDecrypter();
              if (J.isSync()) {
                var te = J.softwareDecrypt(P, Z.key.buffer, Z.iv.buffer), ne = S.part > -1;
                if (ne && (te = J.flush()), !te)
                  return f.executeEnd = u(), v(S);
                P = new Uint8Array(te);
              } else
                return this.decryptionPromise = J.webCryptoDecrypt(P, Z.key.buffer, Z.iv.buffer).then(function(pe) {
                  var ie = C.push(pe, null, S);
                  return C.decryptionPromise = null, ie;
                }), this.decryptionPromise;
            }
            var re = this.needsProbing(V, W);
            re && this.configureTransmuxer(P), (V || W || $ || re) && this.resetInitSegment(q, Y, z, Q, _), (V || $ || re) && this.resetInitialTimestamp(X), K || this.resetContiguity();
            var ee = this.transmux(P, Z, H, G, S), le = this.currentTransmuxState;
            return le.contiguous = !0, le.discontinuity = !1, le.trackSwitch = !1, f.executeEnd = u(), ee;
          }, p.flush = function(k) {
            var _ = this, S = k.transmuxing;
            S.executeStart = u();
            var h = this.decrypter, C = this.currentTransmuxState, f = this.decryptionPromise;
            if (f)
              return f.then(function() {
                return _.flush(k);
              });
            var P = [], F = C.timeOffset;
            if (h) {
              var R = h.flush();
              R && P.push(this.push(R, null, k));
            }
            var U = this.demuxer, K = this.remuxer;
            if (!U || !K)
              return this.observer.emit(b.Events.ERROR, b.Events.ERROR, {
                type: y.ErrorTypes.MEDIA_ERROR,
                details: y.ErrorDetails.FRAG_PARSING_ERROR,
                fatal: !0,
                reason: "no demux matching with content found"
              }), S.executeEnd = u(), [v(k)];
            var V = U.flush(F);
            return g(V) ? V.then(function(W) {
              return _.flushRemux(P, W, k), P;
            }) : (this.flushRemux(P, V, k), P);
          }, p.flushRemux = function(k, _, S) {
            var h = _.audioTrack, C = _.videoTrack, f = _.id3Track, P = _.textTrack, F = this.currentTransmuxState, R = F.accurateTimeOffset, U = F.timeOffset;
            O.logger.log("[transmuxer.ts]: Flushed fragment " + S.sn + (S.part > -1 ? " p: " + S.part : "") + " of level " + S.level);
            var K = this.remuxer.remux(h, C, f, P, U, R, !0, this.id);
            k.push({
              remuxResult: K,
              chunkMeta: S
            }), S.transmuxing.executeEnd = u();
          }, p.resetInitialTimestamp = function(k) {
            var _ = this.demuxer, S = this.remuxer;
            !_ || !S || (_.resetTimeStamp(k), S.resetTimeStamp(k));
          }, p.resetContiguity = function() {
            var k = this.demuxer, _ = this.remuxer;
            !k || !_ || (k.resetContiguity(), _.resetNextTimestamp());
          }, p.resetInitSegment = function(k, _, S, h, C) {
            var f = this.demuxer, P = this.remuxer;
            !f || !P || (f.resetInitSegment(k, _, S, h), P.resetInitSegment(k, _, S, C));
          }, p.destroy = function() {
            this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
          }, p.transmux = function(k, _, S, h, C) {
            var f;
            return _ && _.method === "SAMPLE-AES" ? f = this.transmuxSampleAes(k, _, S, h, C) : f = this.transmuxUnencrypted(k, S, h, C), f;
          }, p.transmuxUnencrypted = function(k, _, S, h) {
            var C = this.demuxer.demux(k, _, !1, !this.config.progressive), f = C.audioTrack, P = C.videoTrack, F = C.id3Track, R = C.textTrack, U = this.remuxer.remux(f, P, F, R, _, S, !1, this.id);
            return {
              remuxResult: U,
              chunkMeta: h
            };
          }, p.transmuxSampleAes = function(k, _, S, h, C) {
            var f = this;
            return this.demuxer.demuxSampleAes(k, _, S).then(function(P) {
              var F = f.remuxer.remux(P.audioTrack, P.videoTrack, P.id3Track, P.textTrack, S, h, !1, f.id);
              return {
                remuxResult: F,
                chunkMeta: C
              };
            });
          }, p.configureTransmuxer = function(k) {
            for (var _ = this.config, S = this.observer, h = this.typeSupported, C = this.vendor, f, P = 0, F = M.length; P < F; P++)
              if (M[P].demux.probe(k)) {
                f = M[P];
                break;
              }
            f || (O.logger.warn("Failed to find demuxer by probing frag, treating as mp4 passthrough"), f = {
              demux: B.default,
              remux: w.default
            });
            var R = this.demuxer, U = this.remuxer, K = f.remux, V = f.demux;
            (!U || !(U instanceof K)) && (this.remuxer = new K(S, _, h, C)), (!R || !(R instanceof V)) && (this.demuxer = new V(S, _, h), this.probe = V.probe);
          }, p.needsProbing = function(k, _) {
            return !this.demuxer || !this.remuxer || k || _;
          }, p.getDecrypter = function() {
            var k = this.decrypter;
            return k || (k = this.decrypter = new N.default(this.config)), k;
          }, L;
        }();
        function c(L, p) {
          var x = null;
          return L.byteLength > 0 && p != null && p.key != null && p.iv !== null && p.method != null && (x = p), x;
        }
        var v = function(p) {
          return {
            remuxResult: {},
            chunkMeta: p
          };
        };
        function g(L) {
          return "then" in L && L.then instanceof Function;
        }
        var m = function(p, x, k, _, S) {
          this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = p, this.videoCodec = x, this.initSegmentData = k, this.duration = _, this.defaultInitPts = S;
        }, D = function(p, x, k, _, S, h) {
          this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = p, this.contiguous = x, this.accurateTimeOffset = k, this.trackSwitch = _, this.timeOffset = S, this.initSegmentChange = h;
        };
      },
      "./src/demux/tsdemuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => L
        });
        var b = a("./src/demux/adts.ts"), y = a("./src/demux/mpegaudio.ts"), N = a("./src/demux/exp-golomb.ts"), E = a("./src/demux/sample-aes.ts"), B = a("./src/events.ts"), I = a("./src/utils/mp4-tools.ts"), T = a("./src/utils/logger.ts"), A = a("./src/errors.ts"), w = a("./src/types/demuxer.ts");
        function O() {
          return O = Object.assign ? Object.assign.bind() : function(p) {
            for (var x = 1; x < arguments.length; x++) {
              var k = arguments[x];
              for (var _ in k)
                Object.prototype.hasOwnProperty.call(k, _) && (p[_] = k[_]);
            }
            return p;
          }, O.apply(this, arguments);
        }
        var u = 188, M = /* @__PURE__ */ function() {
          function p(k, _, S) {
            this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._duration = 0, this._pmtId = -1, this._avcTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.avcSample = null, this.remainderData = null, this.observer = k, this.config = _, this.typeSupported = S;
          }
          p.probe = function(_) {
            var S = p.syncOffset(_);
            return S > 0 && T.logger.warn("MPEG2-TS detected but first sync word found @ offset " + S), S !== -1;
          }, p.syncOffset = function(_) {
            for (var S = _.length, h = Math.min(u * 5, _.length - u) + 1, C = 0; C < h; ) {
              for (var f = !1, P = C; P < S && _[P] === 71; P += u)
                if (!f && c(_, P) === 0 && (f = !0), f && P + u > h)
                  return C;
              C++;
            }
            return -1;
          }, p.createTrack = function(_, S) {
            return {
              container: _ === "video" || _ === "audio" ? "video/mp2t" : void 0,
              type: _,
              id: I.RemuxerTrackIdConfig[_],
              pid: -1,
              inputTimeScale: 9e4,
              sequenceNumber: 0,
              samples: [],
              dropped: 0,
              duration: _ === "audio" ? S : void 0
            };
          };
          var x = p.prototype;
          return x.resetInitSegment = function(_, S, h, C) {
            this.pmtParsed = !1, this._pmtId = -1, this._avcTrack = p.createTrack("video"), this._audioTrack = p.createTrack("audio", C), this._id3Track = p.createTrack("id3"), this._txtTrack = p.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.aacOverFlow = null, this.avcSample = null, this.remainderData = null, this.audioCodec = S, this.videoCodec = h, this._duration = C;
          }, x.resetTimeStamp = function() {
          }, x.resetContiguity = function() {
            var _ = this._audioTrack, S = this._avcTrack, h = this._id3Track;
            _ && (_.pesData = null), S && (S.pesData = null), h && (h.pesData = null), this.aacOverFlow = null, this.avcSample = null, this.remainderData = null;
          }, x.demux = function(_, S, h, C) {
            h === void 0 && (h = !1), C === void 0 && (C = !1), h || (this.sampleAes = null);
            var f, P = this._avcTrack, F = this._audioTrack, R = this._id3Track, U = this._txtTrack, K = P.pid, V = P.pesData, W = F.pid, G = R.pid, H = F.pesData, $ = R.pesData, Y = null, z = this.pmtParsed, X = this._pmtId, Q = _.length;
            if (this.remainderData && (_ = (0, I.appendUint8Array)(this.remainderData, _), Q = _.length, this.remainderData = null), Q < u && !C)
              return this.remainderData = _, {
                audioTrack: F,
                videoTrack: P,
                id3Track: R,
                textTrack: U
              };
            var q = Math.max(0, p.syncOffset(_));
            Q -= (Q - q) % u, Q < _.byteLength && !C && (this.remainderData = new Uint8Array(_.buffer, Q, _.buffer.byteLength - Q));
            for (var Z = 0, J = q; J < Q; J += u)
              if (_[J] === 71) {
                var te = !!(_[J + 1] & 64), ne = c(_, J), re = (_[J + 3] & 48) >> 4, ee = void 0;
                if (re > 1) {
                  if (ee = J + 5 + _[J + 4], ee === J + u)
                    continue;
                } else
                  ee = J + 4;
                switch (ne) {
                  case K:
                    te && (V && (f = m(V)) && this.parseAVCPES(P, U, f, !1), V = {
                      data: [],
                      size: 0
                    }), V && (V.data.push(_.subarray(ee, J + u)), V.size += J + u - ee);
                    break;
                  case W:
                    if (te) {
                      if (H && (f = m(H)))
                        switch (F.segmentCodec) {
                          case "aac":
                            this.parseAACPES(F, f);
                            break;
                          case "mp3":
                            this.parseMPEGPES(F, f);
                            break;
                        }
                      H = {
                        data: [],
                        size: 0
                      };
                    }
                    H && (H.data.push(_.subarray(ee, J + u)), H.size += J + u - ee);
                    break;
                  case G:
                    te && ($ && (f = m($)) && this.parseID3PES(R, f), $ = {
                      data: [],
                      size: 0
                    }), $ && ($.data.push(_.subarray(ee, J + u)), $.size += J + u - ee);
                    break;
                  case 0:
                    te && (ee += _[ee] + 1), X = this._pmtId = v(_, ee);
                    break;
                  case X: {
                    te && (ee += _[ee] + 1);
                    var le = g(_, ee, this.typeSupported, h);
                    K = le.avc, K > 0 && (P.pid = K), W = le.audio, W > 0 && (F.pid = W, F.segmentCodec = le.segmentCodec), G = le.id3, G > 0 && (R.pid = G), Y !== null && !z && (T.logger.warn("MPEG-TS PMT found at " + J + " after unknown PID '" + Y + "'. Backtracking to sync byte @" + q + " to parse all TS packets."), Y = null, J = q - 188), z = this.pmtParsed = !0;
                    break;
                  }
                  case 17:
                  case 8191:
                    break;
                  default:
                    Y = ne;
                    break;
                }
              } else
                Z++;
            Z > 0 && this.observer.emit(B.Events.ERROR, B.Events.ERROR, {
              type: A.ErrorTypes.MEDIA_ERROR,
              details: A.ErrorDetails.FRAG_PARSING_ERROR,
              fatal: !1,
              reason: "Found " + Z + " TS packet/s that do not start with 0x47"
            }), P.pesData = V, F.pesData = H, R.pesData = $;
            var pe = {
              audioTrack: F,
              videoTrack: P,
              id3Track: R,
              textTrack: U
            };
            return C && this.extractRemainingSamples(pe), pe;
          }, x.flush = function() {
            var _ = this.remainderData;
            this.remainderData = null;
            var S;
            return _ ? S = this.demux(_, -1, !1, !0) : S = {
              videoTrack: this._avcTrack,
              audioTrack: this._audioTrack,
              id3Track: this._id3Track,
              textTrack: this._txtTrack
            }, this.extractRemainingSamples(S), this.sampleAes ? this.decrypt(S, this.sampleAes) : S;
          }, x.extractRemainingSamples = function(_) {
            var S = _.audioTrack, h = _.videoTrack, C = _.id3Track, f = _.textTrack, P = h.pesData, F = S.pesData, R = C.pesData, U;
            if (P && (U = m(P)) ? (this.parseAVCPES(h, f, U, !0), h.pesData = null) : h.pesData = P, F && (U = m(F))) {
              switch (S.segmentCodec) {
                case "aac":
                  this.parseAACPES(S, U);
                  break;
                case "mp3":
                  this.parseMPEGPES(S, U);
                  break;
              }
              S.pesData = null;
            } else
              F != null && F.size && T.logger.log("last AAC PES packet truncated,might overlap between fragments"), S.pesData = F;
            R && (U = m(R)) ? (this.parseID3PES(C, U), C.pesData = null) : C.pesData = R;
          }, x.demuxSampleAes = function(_, S, h) {
            var C = this.demux(_, h, !0, !this.config.progressive), f = this.sampleAes = new E.default(this.observer, this.config, S);
            return this.decrypt(C, f);
          }, x.decrypt = function(_, S) {
            return new Promise(function(h) {
              var C = _.audioTrack, f = _.videoTrack;
              C.samples && C.segmentCodec === "aac" ? S.decryptAacSamples(C.samples, 0, function() {
                f.samples ? S.decryptAvcSamples(f.samples, 0, 0, function() {
                  h(_);
                }) : h(_);
              }) : f.samples && S.decryptAvcSamples(f.samples, 0, 0, function() {
                h(_);
              });
            });
          }, x.destroy = function() {
            this._duration = 0;
          }, x.parseAVCPES = function(_, S, h, C) {
            var f = this, P = this.parseAVCNALu(_, h.data), F = this.avcSample, R, U = !1;
            h.data = null, F && P.length && !_.audFound && (D(F, _), F = this.avcSample = d(!1, h.pts, h.dts, "")), P.forEach(function(K) {
              switch (K.type) {
                case 1: {
                  R = !0, F || (F = f.avcSample = d(!0, h.pts, h.dts, "")), F.frame = !0;
                  var V = K.data;
                  if (U && V.length > 4) {
                    var W = new N.default(V).readSliceType();
                    (W === 2 || W === 4 || W === 7 || W === 9) && (F.key = !0);
                  }
                  break;
                }
                case 5:
                  R = !0, F || (F = f.avcSample = d(!0, h.pts, h.dts, "")), F.key = !0, F.frame = !0;
                  break;
                case 6: {
                  R = !0, (0, I.parseSEIMessageFromNALu)(K.data, 1, h.pts, S.samples);
                  break;
                }
                case 7:
                  if (R = !0, U = !0, !_.sps) {
                    var G = new N.default(K.data), H = G.readSPS();
                    _.width = H.width, _.height = H.height, _.pixelRatio = H.pixelRatio, _.sps = [K.data], _.duration = f._duration;
                    for (var $ = K.data.subarray(1, 4), Y = "avc1.", z = 0; z < 3; z++) {
                      var X = $[z].toString(16);
                      X.length < 2 && (X = "0" + X), Y += X;
                    }
                    _.codec = Y;
                  }
                  break;
                case 8:
                  R = !0, _.pps || (_.pps = [K.data]);
                  break;
                case 9:
                  R = !1, _.audFound = !0, F && D(F, _), F = f.avcSample = d(!1, h.pts, h.dts, "");
                  break;
                case 12:
                  R = !0;
                  break;
                default:
                  R = !1, F && (F.debug += "unknown NAL " + K.type + " ");
                  break;
              }
              if (F && R) {
                var Q = F.units;
                Q.push(K);
              }
            }), C && F && (D(F, _), this.avcSample = null);
          }, x.getLastNalUnit = function(_) {
            var S, h = this.avcSample, C;
            if ((!h || h.units.length === 0) && (h = _[_.length - 1]), (S = h) !== null && S !== void 0 && S.units) {
              var f = h.units;
              C = f[f.length - 1];
            }
            return C;
          }, x.parseAVCNALu = function(_, S) {
            var h = S.byteLength, C = _.naluState || 0, f = C, P = [], F = 0, R, U, K, V = -1, W = 0;
            for (C === -1 && (V = 0, W = S[0] & 31, C = 0, F = 1); F < h; ) {
              if (R = S[F++], !C) {
                C = R ? 0 : 1;
                continue;
              }
              if (C === 1) {
                C = R ? 0 : 2;
                continue;
              }
              if (!R)
                C = 3;
              else if (R === 1) {
                if (V >= 0) {
                  var G = {
                    data: S.subarray(V, F - C - 1),
                    type: W
                  };
                  P.push(G);
                } else {
                  var H = this.getLastNalUnit(_.samples);
                  if (H && (f && F <= 4 - f && H.state && (H.data = H.data.subarray(0, H.data.byteLength - f)), U = F - C - 1, U > 0)) {
                    var $ = new Uint8Array(H.data.byteLength + U);
                    $.set(H.data, 0), $.set(S.subarray(0, U), H.data.byteLength), H.data = $, H.state = 0;
                  }
                }
                F < h ? (K = S[F] & 31, V = F, W = K, C = 0) : C = -1;
              } else
                C = 0;
            }
            if (V >= 0 && C >= 0) {
              var Y = {
                data: S.subarray(V, h),
                type: W,
                state: C
              };
              P.push(Y);
            }
            if (P.length === 0) {
              var z = this.getLastNalUnit(_.samples);
              if (z) {
                var X = new Uint8Array(z.data.byteLength + S.byteLength);
                X.set(z.data, 0), X.set(S, z.data.byteLength), z.data = X;
              }
            }
            return _.naluState = C, P;
          }, x.parseAACPES = function(_, S) {
            var h = 0, C = this.aacOverFlow, f = S.data;
            if (C) {
              this.aacOverFlow = null;
              var P = C.missing, F = C.sample.unit.byteLength;
              if (P === -1) {
                var R = new Uint8Array(F + f.byteLength);
                R.set(C.sample.unit, 0), R.set(f, F), f = R;
              } else {
                var U = F - P;
                C.sample.unit.set(f.subarray(0, P), U), _.samples.push(C.sample), h = C.missing;
              }
            }
            var K, V;
            for (K = h, V = f.length; K < V - 1 && !b.isHeader(f, K); K++)
              ;
            if (K !== h) {
              var W, G;
              if (K < V - 1 ? (W = "AAC PES did not start with ADTS header,offset:" + K, G = !1) : (W = "no ADTS header found in AAC PES", G = !0), T.logger.warn("parsing error:" + W), this.observer.emit(B.Events.ERROR, B.Events.ERROR, {
                type: A.ErrorTypes.MEDIA_ERROR,
                details: A.ErrorDetails.FRAG_PARSING_ERROR,
                fatal: G,
                reason: W
              }), G)
                return;
            }
            b.initTrackConfig(_, this.observer, f, K, this.audioCodec);
            var H;
            if (S.pts !== void 0)
              H = S.pts;
            else if (C) {
              var $ = b.getFrameDuration(_.samplerate);
              H = C.sample.pts + $;
            } else {
              T.logger.warn("[tsdemuxer]: AAC PES unknown PTS");
              return;
            }
            for (var Y = 0, z; K < V; )
              if (z = b.appendFrame(_, f, K, H, Y), K += z.length, z.missing) {
                this.aacOverFlow = z;
                break;
              } else
                for (Y++; K < V - 1 && !b.isHeader(f, K); K++)
                  ;
          }, x.parseMPEGPES = function(_, S) {
            var h = S.data, C = h.length, f = 0, P = 0, F = S.pts;
            if (F === void 0) {
              T.logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
              return;
            }
            for (; P < C; )
              if (y.isHeader(h, P)) {
                var R = y.appendFrame(_, h, P, F, f);
                if (R)
                  P += R.length, f++;
                else
                  break;
              } else
                P++;
          }, x.parseID3PES = function(_, S) {
            if (S.pts === void 0) {
              T.logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
              return;
            }
            var h = O({}, S, {
              type: this._avcTrack ? w.MetadataSchema.emsg : w.MetadataSchema.audioId3,
              duration: Number.POSITIVE_INFINITY
            });
            _.samples.push(h);
          }, p;
        }();
        function d(p, x, k, _) {
          return {
            key: p,
            frame: !1,
            pts: x,
            dts: k,
            units: [],
            debug: _,
            length: 0
          };
        }
        function c(p, x) {
          return ((p[x + 1] & 31) << 8) + p[x + 2];
        }
        function v(p, x) {
          return (p[x + 10] & 31) << 8 | p[x + 11];
        }
        function g(p, x, k, _) {
          var S = {
            audio: -1,
            avc: -1,
            id3: -1,
            segmentCodec: "aac"
          }, h = (p[x + 1] & 15) << 8 | p[x + 2], C = x + 3 + h - 4, f = (p[x + 10] & 15) << 8 | p[x + 11];
          for (x += 12 + f; x < C; ) {
            var P = c(p, x);
            switch (p[x]) {
              case 207:
                if (!_) {
                  T.logger.log("ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");
                  break;
                }
              case 15:
                S.audio === -1 && (S.audio = P);
                break;
              case 21:
                S.id3 === -1 && (S.id3 = P);
                break;
              case 219:
                if (!_) {
                  T.logger.log("H.264 with AES-128-CBC slice encryption found in unencrypted stream");
                  break;
                }
              case 27:
                S.avc === -1 && (S.avc = P);
                break;
              case 3:
              case 4:
                k.mpeg !== !0 && k.mp3 !== !0 ? T.logger.log("MPEG audio found, not supported in this browser") : S.audio === -1 && (S.audio = P, S.segmentCodec = "mp3");
                break;
              case 36:
                T.logger.warn("Unsupported HEVC stream type found");
                break;
            }
            x += ((p[x + 3] & 15) << 8 | p[x + 4]) + 5;
          }
          return S;
        }
        function m(p) {
          var x = 0, k, _, S, h, C, f = p.data;
          if (!p || p.size === 0)
            return null;
          for (; f[0].length < 19 && f.length > 1; ) {
            var P = new Uint8Array(f[0].length + f[1].length);
            P.set(f[0]), P.set(f[1], f[0].length), f[0] = P, f.splice(1, 1);
          }
          k = f[0];
          var F = (k[0] << 16) + (k[1] << 8) + k[2];
          if (F === 1) {
            if (_ = (k[4] << 8) + k[5], _ && _ > p.size - 6)
              return null;
            var R = k[7];
            R & 192 && (h = (k[9] & 14) * 536870912 + (k[10] & 255) * 4194304 + (k[11] & 254) * 16384 + (k[12] & 255) * 128 + (k[13] & 254) / 2, R & 64 ? (C = (k[14] & 14) * 536870912 + (k[15] & 255) * 4194304 + (k[16] & 254) * 16384 + (k[17] & 255) * 128 + (k[18] & 254) / 2, h - C > 54e5 && (T.logger.warn(Math.round((h - C) / 9e4) + "s delta between PTS and DTS, align them"), h = C)) : C = h), S = k[8];
            var U = S + 9;
            if (p.size <= U)
              return null;
            p.size -= U;
            for (var K = new Uint8Array(p.size), V = 0, W = f.length; V < W; V++) {
              k = f[V];
              var G = k.byteLength;
              if (U)
                if (U > G) {
                  U -= G;
                  continue;
                } else
                  k = k.subarray(U), G -= U, U = 0;
              K.set(k, x), x += G;
            }
            return _ && (_ -= S + 3), {
              data: K,
              pts: h,
              dts: C,
              len: _
            };
          }
          return null;
        }
        function D(p, x) {
          if (p.units.length && p.frame) {
            if (p.pts === void 0) {
              var k = x.samples, _ = k.length;
              if (_) {
                var S = k[_ - 1];
                p.pts = S.pts, p.dts = S.dts;
              } else {
                x.dropped++;
                return;
              }
            }
            x.samples.push(p);
          }
          p.debug.length && T.logger.log(p.pts + "/" + p.dts + ":" + p.debug);
        }
        const L = M;
      },
      "./src/demux/webworkify-webpack.js": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => u
        });
        var b = function() {
          var d = ENTRY_MODULE, c = {}, v = function m(D) {
            var L = c[D];
            if (L !== void 0)
              return L.exports;
            var p = c[D] = {
              exports: {}
            };
            return d[D].call(p.exports, p, p.exports, m), p.exports;
          };
          v.m = d, function() {
            v.n = function(m) {
              var D = m && m.__esModule ? function() {
                return m.default;
              } : function() {
                return m;
              };
              return v.d(D, {
                a: D
              }), D;
            };
          }(), function() {
            v.d = function(m, D) {
              for (var L in D)
                v.o(D, L) && !v.o(m, L) && Object.defineProperty(m, L, {
                  enumerable: !0,
                  get: D[L]
                });
            };
          }(), function() {
            v.o = function(m, D) {
              return Object.prototype.hasOwnProperty.call(m, D);
            };
          }(), function() {
            v.r = function(m) {
              typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(m, Symbol.toStringTag, {
                value: "Module"
              }), Object.defineProperty(m, "__esModule", {
                value: !0
              });
            };
          }();
          var g = v(ENTRY_MODULE);
          return g.default || g;
        }, y = b.toString().split("ENTRY_MODULE"), N = "[\\.|\\-|\\+|\\w|/|@]+", E = "\\(\\s*(/\\*.*?\\*/)?\\s*.*?(" + N + ").*?\\)";
        function B(M) {
          return (M + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
        }
        function I(M) {
          return !isNaN(1 * M);
        }
        function T(M, d, c) {
          var v = {};
          v[c] = [];
          var g = d.toString().replace(/^"[^"]+"/, "function"), m = g.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/) || g.match(/^\(\w+,\s*\w+,\s*(\w+)\)\s?\=\s?\>/);
          if (!m)
            return v;
          for (var D = m[1], L = new RegExp("(\\\\n|\\W)" + B(D) + E, "g"), p; p = L.exec(g); )
            p[3] !== "dll-reference" && v[c].push(p[3]);
          for (L = new RegExp("\\(" + B(D) + '\\("(dll-reference\\s(' + N + '))"\\)\\)' + E, "g"); p = L.exec(g); )
            M[p[2]] || (v[c].push(p[1]), M[p[2]] = a(p[1]).m), v[p[2]] = v[p[2]] || [], v[p[2]].push(p[4]);
          for (var x = Object.keys(v), k = 0; k < x.length; k++)
            for (var _ = 0; _ < v[x[k]].length; _++)
              I(v[x[k]][_]) && (v[x[k]][_] = 1 * v[x[k]][_]);
          return v;
        }
        function A(M) {
          var d = Object.keys(M);
          return d.reduce(function(c, v) {
            return c || M[v].length > 0;
          }, !1);
        }
        function w(M, d) {
          for (var c = {
            main: [d]
          }, v = {
            main: []
          }, g = {
            main: {}
          }; A(c); )
            for (var m = Object.keys(c), D = 0; D < m.length; D++) {
              var L = m[D], p = c[L], x = p.pop();
              if (g[L] = g[L] || {}, !(g[L][x] || !M[L][x])) {
                g[L][x] = !0, v[L] = v[L] || [], v[L].push(x);
                for (var k = T(M, M[L][x], L), _ = Object.keys(k), S = 0; S < _.length; S++)
                  c[_[S]] = c[_[S]] || [], c[_[S]] = c[_[S]].concat(k[_[S]]);
              }
            }
          return v;
        }
        function O(M, d, c, v) {
          var g = M[v].map(function(m) {
            return '"' + m + '": ' + d[v][m].toString().replace(/^"[^"]+"/, "function");
          }).join(",");
          return y[0] + "{" + g + "}" + y[1] + '"' + c + '"' + y[2];
        }
        function u(M, d) {
          d = d || {};
          var c = {
            main: a.m
          }, v = d.all ? {
            main: Object.keys(c.main)
          } : w(c, M), g = "";
          Object.keys(v).filter(function(x) {
            return x !== "main";
          }).forEach(function(x) {
            for (var k = 0; v[x][k]; )
              k++;
            v[x].push(k), c[x][k] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", g = g + ("var " + x + " = (" + O(v, c, k, modules) + `)();
`);
          }), g = g + ("new ((" + O(v, c, M, "main") + ")())(self);");
          var m = new window.Blob([g], {
            type: "text/javascript"
          }), D = window.URL || window.webkitURL || window.mozURL || window.msURL, L = D.createObjectURL(m), p = new window.Worker(L);
          return p.objectURL = L, p;
        }
      },
      "./src/errors.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          ErrorDetails: () => y,
          ErrorTypes: () => b
        });
        var b;
        (function(N) {
          N.NETWORK_ERROR = "networkError", N.MEDIA_ERROR = "mediaError", N.KEY_SYSTEM_ERROR = "keySystemError", N.MUX_ERROR = "muxError", N.OTHER_ERROR = "otherError";
        })(b || (b = {}));
        var y;
        (function(N) {
          N.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", N.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", N.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", N.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", N.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", N.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", N.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", N.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", N.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", N.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", N.MANIFEST_LOAD_ERROR = "manifestLoadError", N.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", N.MANIFEST_PARSING_ERROR = "manifestParsingError", N.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", N.LEVEL_EMPTY_ERROR = "levelEmptyError", N.LEVEL_LOAD_ERROR = "levelLoadError", N.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", N.LEVEL_SWITCH_ERROR = "levelSwitchError", N.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", N.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", N.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", N.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", N.FRAG_LOAD_ERROR = "fragLoadError", N.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", N.FRAG_DECRYPT_ERROR = "fragDecryptError", N.FRAG_PARSING_ERROR = "fragParsingError", N.REMUX_ALLOC_ERROR = "remuxAllocError", N.KEY_LOAD_ERROR = "keyLoadError", N.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", N.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", N.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", N.BUFFER_APPEND_ERROR = "bufferAppendError", N.BUFFER_APPENDING_ERROR = "bufferAppendingError", N.BUFFER_STALLED_ERROR = "bufferStalledError", N.BUFFER_FULL_ERROR = "bufferFullError", N.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", N.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", N.INTERNAL_EXCEPTION = "internalException", N.INTERNAL_ABORTED = "aborted", N.UNKNOWN = "unknown";
        })(y || (y = {}));
      },
      "./src/events.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          Events: () => b
        });
        var b;
        (function(y) {
          y.MEDIA_ATTACHING = "hlsMediaAttaching", y.MEDIA_ATTACHED = "hlsMediaAttached", y.MEDIA_DETACHING = "hlsMediaDetaching", y.MEDIA_DETACHED = "hlsMediaDetached", y.BUFFER_RESET = "hlsBufferReset", y.BUFFER_CODECS = "hlsBufferCodecs", y.BUFFER_CREATED = "hlsBufferCreated", y.BUFFER_APPENDING = "hlsBufferAppending", y.BUFFER_APPENDED = "hlsBufferAppended", y.BUFFER_EOS = "hlsBufferEos", y.BUFFER_FLUSHING = "hlsBufferFlushing", y.BUFFER_FLUSHED = "hlsBufferFlushed", y.MANIFEST_LOADING = "hlsManifestLoading", y.MANIFEST_LOADED = "hlsManifestLoaded", y.MANIFEST_PARSED = "hlsManifestParsed", y.LEVEL_SWITCHING = "hlsLevelSwitching", y.LEVEL_SWITCHED = "hlsLevelSwitched", y.LEVEL_LOADING = "hlsLevelLoading", y.LEVEL_LOADED = "hlsLevelLoaded", y.LEVEL_UPDATED = "hlsLevelUpdated", y.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", y.LEVELS_UPDATED = "hlsLevelsUpdated", y.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", y.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", y.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", y.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", y.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", y.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", y.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", y.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", y.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", y.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", y.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", y.CUES_PARSED = "hlsCuesParsed", y.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", y.INIT_PTS_FOUND = "hlsInitPtsFound", y.FRAG_LOADING = "hlsFragLoading", y.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", y.FRAG_LOADED = "hlsFragLoaded", y.FRAG_DECRYPTED = "hlsFragDecrypted", y.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", y.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", y.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", y.FRAG_PARSED = "hlsFragParsed", y.FRAG_BUFFERED = "hlsFragBuffered", y.FRAG_CHANGED = "hlsFragChanged", y.FPS_DROP = "hlsFpsDrop", y.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", y.ERROR = "hlsError", y.DESTROYING = "hlsDestroying", y.KEY_LOADING = "hlsKeyLoading", y.KEY_LOADED = "hlsKeyLoaded", y.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", y.BACK_BUFFER_REACHED = "hlsBackBufferReached";
        })(b || (b = {}));
      },
      "./src/hls.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => p
        });
        var b = a("./node_modules/url-toolkit/src/url-toolkit.js"), y = a("./src/loader/playlist-loader.ts"), N = a("./src/controller/id3-track-controller.ts"), E = a("./src/controller/latency-controller.ts"), B = a("./src/controller/level-controller.ts"), I = a("./src/controller/fragment-tracker.ts"), T = a("./src/loader/key-loader.ts"), A = a("./src/controller/stream-controller.ts"), w = a("./src/is-supported.ts"), O = a("./src/utils/logger.ts"), u = a("./src/config.ts"), M = a("./node_modules/eventemitter3/index.js"), d = a("./src/events.ts"), c = a("./src/errors.ts"), v = a("./src/types/level.ts");
        function g(x, k) {
          for (var _ = 0; _ < k.length; _++) {
            var S = k[_];
            S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(x, D(S.key), S);
          }
        }
        function m(x, k, _) {
          return k && g(x.prototype, k), _ && g(x, _), Object.defineProperty(x, "prototype", { writable: !1 }), x;
        }
        function D(x) {
          var k = L(x, "string");
          return typeof k == "symbol" ? k : String(k);
        }
        function L(x, k) {
          if (typeof x != "object" || x === null)
            return x;
          var _ = x[Symbol.toPrimitive];
          if (_ !== void 0) {
            var S = _.call(x, k || "default");
            if (typeof S != "object")
              return S;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (k === "string" ? String : Number)(x);
        }
        var p = /* @__PURE__ */ function() {
          x.isSupported = function() {
            return (0, w.isSupported)();
          };
          function x(_) {
            _ === void 0 && (_ = {}), this.config = void 0, this.userConfig = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this._emitter = new M.EventEmitter(), this._autoLevelCapping = void 0, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this.url = null;
            var S = this.config = (0, u.mergeConfig)(x.DefaultConfig, _);
            this.userConfig = _, (0, O.enableLogs)(S.debug, "Hls instance"), this._autoLevelCapping = -1, S.progressive && (0, u.enableStreamingMode)(S);
            var h = S.abrController, C = S.bufferController, f = S.capLevelController, P = S.fpsController, F = this.abrController = new h(this), R = this.bufferController = new C(this), U = this.capLevelController = new f(this), K = new P(this), V = new y.default(this), W = new N.default(this), G = this.levelController = new B.default(this), H = new I.FragmentTracker(this), $ = new T.default(this.config), Y = this.streamController = new A.default(this, H, $);
            U.setStreamController(Y), K.setStreamController(Y);
            var z = [V, G, Y];
            this.networkControllers = z;
            var X = [F, R, U, K, W, H];
            this.audioTrackController = this.createController(S.audioTrackController, z);
            var Q = S.audioStreamController;
            Q && z.push(new Q(this, H, $)), this.subtitleTrackController = this.createController(S.subtitleTrackController, z);
            var q = S.subtitleStreamController;
            q && z.push(new q(this, H, $)), this.createController(S.timelineController, X), $.emeController = this.emeController = this.createController(S.emeController, X), this.cmcdController = this.createController(S.cmcdController, X), this.latencyController = this.createController(E.default, X), this.coreComponents = X;
          }
          var k = x.prototype;
          return k.createController = function(S, h) {
            if (S) {
              var C = new S(this);
              return h && h.push(C), C;
            }
            return null;
          }, k.on = function(S, h, C) {
            C === void 0 && (C = this), this._emitter.on(S, h, C);
          }, k.once = function(S, h, C) {
            C === void 0 && (C = this), this._emitter.once(S, h, C);
          }, k.removeAllListeners = function(S) {
            this._emitter.removeAllListeners(S);
          }, k.off = function(S, h, C, f) {
            C === void 0 && (C = this), this._emitter.off(S, h, C, f);
          }, k.listeners = function(S) {
            return this._emitter.listeners(S);
          }, k.emit = function(S, h, C) {
            return this._emitter.emit(S, h, C);
          }, k.trigger = function(S, h) {
            if (this.config.debug)
              return this.emit(S, S, h);
            try {
              return this.emit(S, S, h);
            } catch (C) {
              O.logger.error("An internal error happened while handling event " + S + '. Error message: "' + C.message + '". Here is a stacktrace:', C), this.trigger(d.Events.ERROR, {
                type: c.ErrorTypes.OTHER_ERROR,
                details: c.ErrorDetails.INTERNAL_EXCEPTION,
                fatal: !1,
                event: S,
                error: C
              });
            }
            return !1;
          }, k.listenerCount = function(S) {
            return this._emitter.listenerCount(S);
          }, k.destroy = function() {
            O.logger.log("destroy"), this.trigger(d.Events.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this.url = null, this.networkControllers.forEach(function(S) {
              return S.destroy();
            }), this.networkControllers.length = 0, this.coreComponents.forEach(function(S) {
              return S.destroy();
            }), this.coreComponents.length = 0;
          }, k.attachMedia = function(S) {
            O.logger.log("attachMedia"), this._media = S, this.trigger(d.Events.MEDIA_ATTACHING, {
              media: S
            });
          }, k.detachMedia = function() {
            O.logger.log("detachMedia"), this.trigger(d.Events.MEDIA_DETACHING, void 0), this._media = null;
          }, k.loadSource = function(S) {
            this.stopLoad();
            var h = this.media, C = this.url, f = this.url = b.buildAbsoluteURL(self.location.href, S, {
              alwaysNormalize: !0
            });
            O.logger.log("loadSource:" + f), h && C && C !== f && this.bufferController.hasSourceTypes() && (this.detachMedia(), this.attachMedia(h)), this.trigger(d.Events.MANIFEST_LOADING, {
              url: S
            });
          }, k.startLoad = function(S) {
            S === void 0 && (S = -1), O.logger.log("startLoad(" + S + ")"), this.networkControllers.forEach(function(h) {
              h.startLoad(S);
            });
          }, k.stopLoad = function() {
            O.logger.log("stopLoad"), this.networkControllers.forEach(function(S) {
              S.stopLoad();
            });
          }, k.swapAudioCodec = function() {
            O.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
          }, k.recoverMediaError = function() {
            O.logger.log("recoverMediaError");
            var S = this._media;
            this.detachMedia(), S && this.attachMedia(S);
          }, k.removeLevel = function(S, h) {
            h === void 0 && (h = 0), this.levelController.removeLevel(S, h);
          }, m(x, [{
            key: "levels",
            get: function() {
              var S = this.levelController.levels;
              return S || [];
            }
          }, {
            key: "currentLevel",
            get: function() {
              return this.streamController.currentLevel;
            },
            set: function(S) {
              O.logger.log("set currentLevel:" + S), this.loadLevel = S, this.abrController.clearTimer(), this.streamController.immediateLevelSwitch();
            }
          }, {
            key: "nextLevel",
            get: function() {
              return this.streamController.nextLevel;
            },
            set: function(S) {
              O.logger.log("set nextLevel:" + S), this.levelController.manualLevel = S, this.streamController.nextLevelSwitch();
            }
          }, {
            key: "loadLevel",
            get: function() {
              return this.levelController.level;
            },
            set: function(S) {
              O.logger.log("set loadLevel:" + S), this.levelController.manualLevel = S;
            }
          }, {
            key: "nextLoadLevel",
            get: function() {
              return this.levelController.nextLoadLevel;
            },
            set: function(S) {
              this.levelController.nextLoadLevel = S;
            }
          }, {
            key: "firstLevel",
            get: function() {
              return Math.max(this.levelController.firstLevel, this.minAutoLevel);
            },
            set: function(S) {
              O.logger.log("set firstLevel:" + S), this.levelController.firstLevel = S;
            }
          }, {
            key: "startLevel",
            get: function() {
              return this.levelController.startLevel;
            },
            set: function(S) {
              O.logger.log("set startLevel:" + S), S !== -1 && (S = Math.max(S, this.minAutoLevel)), this.levelController.startLevel = S;
            }
          }, {
            key: "capLevelToPlayerSize",
            get: function() {
              return this.config.capLevelToPlayerSize;
            },
            set: function(S) {
              var h = !!S;
              h !== this.config.capLevelToPlayerSize && (h ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = h);
            }
          }, {
            key: "autoLevelCapping",
            get: function() {
              return this._autoLevelCapping;
            },
            set: function(S) {
              this._autoLevelCapping !== S && (O.logger.log("set autoLevelCapping:" + S), this._autoLevelCapping = S);
            }
          }, {
            key: "bandwidthEstimate",
            get: function() {
              var S = this.abrController.bwEstimator;
              return S ? S.getEstimate() : NaN;
            }
          }, {
            key: "maxHdcpLevel",
            get: function() {
              return this._maxHdcpLevel;
            },
            set: function(S) {
              v.HdcpLevels.indexOf(S) > -1 && (this._maxHdcpLevel = S);
            }
          }, {
            key: "autoLevelEnabled",
            get: function() {
              return this.levelController.manualLevel === -1;
            }
          }, {
            key: "manualLevel",
            get: function() {
              return this.levelController.manualLevel;
            }
          }, {
            key: "minAutoLevel",
            get: function() {
              var S = this.levels, h = this.config.minAutoBitrate;
              if (!S)
                return 0;
              for (var C = S.length, f = 0; f < C; f++)
                if (S[f].maxBitrate >= h)
                  return f;
              return 0;
            }
          }, {
            key: "maxAutoLevel",
            get: function() {
              var S = this.levels, h = this.autoLevelCapping, C = this.maxHdcpLevel, f;
              if (h === -1 && S && S.length ? f = S.length - 1 : f = h, C)
                for (var P = f; P--; ) {
                  var F = S[P].attrs["HDCP-LEVEL"];
                  if (F && F <= C)
                    return P;
                }
              return f;
            }
          }, {
            key: "nextAutoLevel",
            get: function() {
              return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
            },
            set: function(S) {
              this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, S);
            }
          }, {
            key: "playingDate",
            get: function() {
              return this.streamController.currentProgramDateTime;
            }
          }, {
            key: "mainForwardBufferInfo",
            get: function() {
              return this.streamController.getMainFwdBufferInfo();
            }
          }, {
            key: "audioTracks",
            get: function() {
              var S = this.audioTrackController;
              return S ? S.audioTracks : [];
            }
          }, {
            key: "audioTrack",
            get: function() {
              var S = this.audioTrackController;
              return S ? S.audioTrack : -1;
            },
            set: function(S) {
              var h = this.audioTrackController;
              h && (h.audioTrack = S);
            }
          }, {
            key: "subtitleTracks",
            get: function() {
              var S = this.subtitleTrackController;
              return S ? S.subtitleTracks : [];
            }
          }, {
            key: "subtitleTrack",
            get: function() {
              var S = this.subtitleTrackController;
              return S ? S.subtitleTrack : -1;
            },
            set: function(S) {
              var h = this.subtitleTrackController;
              h && (h.subtitleTrack = S);
            }
          }, {
            key: "media",
            get: function() {
              return this._media;
            }
          }, {
            key: "subtitleDisplay",
            get: function() {
              var S = this.subtitleTrackController;
              return S ? S.subtitleDisplay : !1;
            },
            set: function(S) {
              var h = this.subtitleTrackController;
              h && (h.subtitleDisplay = S);
            }
          }, {
            key: "lowLatencyMode",
            get: function() {
              return this.config.lowLatencyMode;
            },
            set: function(S) {
              this.config.lowLatencyMode = S;
            }
          }, {
            key: "liveSyncPosition",
            get: function() {
              return this.latencyController.liveSyncPosition;
            }
          }, {
            key: "latency",
            get: function() {
              return this.latencyController.latency;
            }
          }, {
            key: "maxLatency",
            get: function() {
              return this.latencyController.maxLatency;
            }
          }, {
            key: "targetLatency",
            get: function() {
              return this.latencyController.targetLatency;
            }
          }, {
            key: "drift",
            get: function() {
              return this.latencyController.drift;
            }
          }, {
            key: "forceStartLoad",
            get: function() {
              return this.streamController.forceStartLoad;
            }
          }], [{
            key: "version",
            get: function() {
              return "1.3.5";
            }
          }, {
            key: "Events",
            get: function() {
              return d.Events;
            }
          }, {
            key: "ErrorTypes",
            get: function() {
              return c.ErrorTypes;
            }
          }, {
            key: "ErrorDetails",
            get: function() {
              return c.ErrorDetails;
            }
          }, {
            key: "DefaultConfig",
            get: function() {
              return x.defaultConfig ? x.defaultConfig : u.hlsDefaultConfig;
            },
            set: function(S) {
              x.defaultConfig = S;
            }
          }]), x;
        }();
        p.defaultConfig = void 0;
      },
      "./src/is-supported.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          changeTypeSupported: () => E,
          isSupported: () => N
        });
        var b = a("./src/utils/mediasource-helper.ts");
        function y() {
          return self.SourceBuffer || self.WebKitSourceBuffer;
        }
        function N() {
          var B = (0, b.getMediaSource)();
          if (!B)
            return !1;
          var I = y(), T = B && typeof B.isTypeSupported == "function" && B.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), A = !I || I.prototype && typeof I.prototype.appendBuffer == "function" && typeof I.prototype.remove == "function";
          return !!T && !!A;
        }
        function E() {
          var B, I = y();
          return typeof (I == null || (B = I.prototype) === null || B === void 0 ? void 0 : B.changeType) == "function";
        }
      },
      "./src/loader/date-range.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          DateRange: () => O,
          DateRangeAttribute: () => w
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/utils/attr-list.ts"), N = a("./src/utils/logger.ts");
        function E() {
          return E = Object.assign ? Object.assign.bind() : function(u) {
            for (var M = 1; M < arguments.length; M++) {
              var d = arguments[M];
              for (var c in d)
                Object.prototype.hasOwnProperty.call(d, c) && (u[c] = d[c]);
            }
            return u;
          }, E.apply(this, arguments);
        }
        function B(u, M) {
          for (var d = 0; d < M.length; d++) {
            var c = M[d];
            c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(u, T(c.key), c);
          }
        }
        function I(u, M, d) {
          return M && B(u.prototype, M), d && B(u, d), Object.defineProperty(u, "prototype", { writable: !1 }), u;
        }
        function T(u) {
          var M = A(u, "string");
          return typeof M == "symbol" ? M : String(M);
        }
        function A(u, M) {
          if (typeof u != "object" || u === null)
            return u;
          var d = u[Symbol.toPrimitive];
          if (d !== void 0) {
            var c = d.call(u, M || "default");
            if (typeof c != "object")
              return c;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (M === "string" ? String : Number)(u);
        }
        var w;
        (function(u) {
          u.ID = "ID", u.CLASS = "CLASS", u.START_DATE = "START-DATE", u.DURATION = "DURATION", u.END_DATE = "END-DATE", u.END_ON_NEXT = "END-ON-NEXT", u.PLANNED_DURATION = "PLANNED-DURATION", u.SCTE35_OUT = "SCTE35-OUT", u.SCTE35_IN = "SCTE35-IN";
        })(w || (w = {}));
        var O = /* @__PURE__ */ function() {
          function u(M, d) {
            if (this.attr = void 0, this._startDate = void 0, this._endDate = void 0, this._badValueForSameId = void 0, d) {
              var c = d.attr;
              for (var v in c)
                if (Object.prototype.hasOwnProperty.call(M, v) && M[v] !== c[v]) {
                  N.logger.warn('DATERANGE tag attribute: "' + v + '" does not match for tags with ID: "' + M.ID + '"'), this._badValueForSameId = v;
                  break;
                }
              M = E(new y.AttrList({}), c, M);
            }
            if (this.attr = M, this._startDate = new Date(M[w.START_DATE]), w.END_DATE in this.attr) {
              var g = new Date(this.attr[w.END_DATE]);
              (0, b.isFiniteNumber)(g.getTime()) && (this._endDate = g);
            }
          }
          return I(u, [{
            key: "id",
            get: function() {
              return this.attr.ID;
            }
          }, {
            key: "class",
            get: function() {
              return this.attr.CLASS;
            }
          }, {
            key: "startDate",
            get: function() {
              return this._startDate;
            }
          }, {
            key: "endDate",
            get: function() {
              if (this._endDate)
                return this._endDate;
              var d = this.duration;
              return d !== null ? new Date(this._startDate.getTime() + d * 1e3) : null;
            }
          }, {
            key: "duration",
            get: function() {
              if (w.DURATION in this.attr) {
                var d = this.attr.decimalFloatingPoint(w.DURATION);
                if ((0, b.isFiniteNumber)(d))
                  return d;
              } else if (this._endDate)
                return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
              return null;
            }
          }, {
            key: "plannedDuration",
            get: function() {
              return w.PLANNED_DURATION in this.attr ? this.attr.decimalFloatingPoint(w.PLANNED_DURATION) : null;
            }
          }, {
            key: "endOnNext",
            get: function() {
              return this.attr.bool(w.END_ON_NEXT);
            }
          }, {
            key: "isValid",
            get: function() {
              return !!this.id && !this._badValueForSameId && (0, b.isFiniteNumber)(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class);
            }
          }]), u;
        }();
      },
      "./src/loader/fragment-loader.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          LoadError: () => d,
          default: () => u
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/errors.ts");
        function N(c, v) {
          c.prototype = Object.create(v.prototype), c.prototype.constructor = c, A(c, v);
        }
        function E(c) {
          var v = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
          return E = function(m) {
            if (m === null || !T(m))
              return m;
            if (typeof m != "function")
              throw new TypeError("Super expression must either be null or a function");
            if (typeof v < "u") {
              if (v.has(m))
                return v.get(m);
              v.set(m, D);
            }
            function D() {
              return B(m, arguments, w(this).constructor);
            }
            return D.prototype = Object.create(m.prototype, { constructor: { value: D, enumerable: !1, writable: !0, configurable: !0 } }), A(D, m);
          }, E(c);
        }
        function B(c, v, g) {
          return I() ? B = Reflect.construct.bind() : B = function(D, L, p) {
            var x = [null];
            x.push.apply(x, L);
            var k = Function.bind.apply(D, x), _ = new k();
            return p && A(_, p.prototype), _;
          }, B.apply(null, arguments);
        }
        function I() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return !1;
          if (typeof Proxy == "function")
            return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }
        function T(c) {
          return Function.toString.call(c).indexOf("[native code]") !== -1;
        }
        function A(c, v) {
          return A = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(m, D) {
            return m.__proto__ = D, m;
          }, A(c, v);
        }
        function w(c) {
          return w = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(g) {
            return g.__proto__ || Object.getPrototypeOf(g);
          }, w(c);
        }
        var O = Math.pow(2, 17), u = /* @__PURE__ */ function() {
          function c(g) {
            this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = g;
          }
          var v = c.prototype;
          return v.destroy = function() {
            this.loader && (this.loader.destroy(), this.loader = null);
          }, v.abort = function() {
            this.loader && this.loader.abort();
          }, v.load = function(m, D) {
            var L = this, p = m.url;
            if (!p)
              return Promise.reject(new d({
                type: y.ErrorTypes.NETWORK_ERROR,
                details: y.ErrorDetails.FRAG_LOAD_ERROR,
                fatal: !1,
                frag: m,
                networkDetails: null
              }, "Fragment does not have a " + (p ? "part list" : "url")));
            this.abort();
            var x = this.config, k = x.fLoader, _ = x.loader;
            return new Promise(function(S, h) {
              L.loader && L.loader.destroy();
              var C = L.loader = m.loader = k ? new k(x) : new _(x), f = M(m), P = {
                timeout: x.fragLoadingTimeOut,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: x.fragLoadingMaxRetryTimeout,
                highWaterMark: m.sn === "initSegment" ? 1 / 0 : O
              };
              m.stats = C.stats, C.load(f, P, {
                onSuccess: function(R, U, K, V) {
                  L.resetLoader(m, C);
                  var W = R.data;
                  K.resetIV && m.decryptdata && (m.decryptdata.iv = new Uint8Array(W.slice(0, 16)), W = W.slice(16)), S({
                    frag: m,
                    part: null,
                    payload: W,
                    networkDetails: V
                  });
                },
                onError: function(R, U, K) {
                  L.resetLoader(m, C), h(new d({
                    type: y.ErrorTypes.NETWORK_ERROR,
                    details: y.ErrorDetails.FRAG_LOAD_ERROR,
                    fatal: !1,
                    frag: m,
                    response: R,
                    networkDetails: K
                  }));
                },
                onAbort: function(R, U, K) {
                  L.resetLoader(m, C), h(new d({
                    type: y.ErrorTypes.NETWORK_ERROR,
                    details: y.ErrorDetails.INTERNAL_ABORTED,
                    fatal: !1,
                    frag: m,
                    networkDetails: K
                  }));
                },
                onTimeout: function(R, U, K) {
                  L.resetLoader(m, C), h(new d({
                    type: y.ErrorTypes.NETWORK_ERROR,
                    details: y.ErrorDetails.FRAG_LOAD_TIMEOUT,
                    fatal: !1,
                    frag: m,
                    networkDetails: K
                  }));
                },
                onProgress: function(R, U, K, V) {
                  D && D({
                    frag: m,
                    part: null,
                    payload: K,
                    networkDetails: V
                  });
                }
              });
            });
          }, v.loadPart = function(m, D, L) {
            var p = this;
            this.abort();
            var x = this.config, k = x.fLoader, _ = x.loader;
            return new Promise(function(S, h) {
              p.loader && p.loader.destroy();
              var C = p.loader = m.loader = k ? new k(x) : new _(x), f = M(m, D), P = {
                timeout: x.fragLoadingTimeOut,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: x.fragLoadingMaxRetryTimeout,
                highWaterMark: O
              };
              D.stats = C.stats, C.load(f, P, {
                onSuccess: function(R, U, K, V) {
                  p.resetLoader(m, C), p.updateStatsFromPart(m, D);
                  var W = {
                    frag: m,
                    part: D,
                    payload: R.data,
                    networkDetails: V
                  };
                  L(W), S(W);
                },
                onError: function(R, U, K) {
                  p.resetLoader(m, C), h(new d({
                    type: y.ErrorTypes.NETWORK_ERROR,
                    details: y.ErrorDetails.FRAG_LOAD_ERROR,
                    fatal: !1,
                    frag: m,
                    part: D,
                    response: R,
                    networkDetails: K
                  }));
                },
                onAbort: function(R, U, K) {
                  m.stats.aborted = D.stats.aborted, p.resetLoader(m, C), h(new d({
                    type: y.ErrorTypes.NETWORK_ERROR,
                    details: y.ErrorDetails.INTERNAL_ABORTED,
                    fatal: !1,
                    frag: m,
                    part: D,
                    networkDetails: K
                  }));
                },
                onTimeout: function(R, U, K) {
                  p.resetLoader(m, C), h(new d({
                    type: y.ErrorTypes.NETWORK_ERROR,
                    details: y.ErrorDetails.FRAG_LOAD_TIMEOUT,
                    fatal: !1,
                    frag: m,
                    part: D,
                    networkDetails: K
                  }));
                }
              });
            });
          }, v.updateStatsFromPart = function(m, D) {
            var L = m.stats, p = D.stats, x = p.total;
            if (L.loaded += p.loaded, x) {
              var k = Math.round(m.duration / D.duration), _ = Math.min(Math.round(L.loaded / x), k), S = k - _, h = S * Math.round(L.loaded / _);
              L.total = L.loaded + h;
            } else
              L.total = Math.max(L.loaded, L.total);
            var C = L.loading, f = p.loading;
            C.start ? C.first += f.first - f.start : (C.start = f.start, C.first = f.first), C.end = f.end;
          }, v.resetLoader = function(m, D) {
            m.loader = null, this.loader === D && (self.clearTimeout(this.partLoadTimeout), this.loader = null), D.destroy();
          }, c;
        }();
        function M(c, v) {
          v === void 0 && (v = null);
          var g = v || c, m = {
            frag: c,
            part: v,
            responseType: "arraybuffer",
            url: g.url,
            headers: {},
            rangeStart: 0,
            rangeEnd: 0
          }, D = g.byteRangeStartOffset, L = g.byteRangeEndOffset;
          if ((0, b.isFiniteNumber)(D) && (0, b.isFiniteNumber)(L)) {
            var p, x = D, k = L;
            if (c.sn === "initSegment" && ((p = c.decryptdata) === null || p === void 0 ? void 0 : p.method) === "AES-128") {
              var _ = L - D;
              _ % 16 && (k = L + (16 - _ % 16)), D !== 0 && (m.resetIV = !0, x = D - 16);
            }
            m.rangeStart = x, m.rangeEnd = k;
          }
          return m;
        }
        var d = /* @__PURE__ */ function(c) {
          N(v, c);
          function v(g) {
            for (var m, D = arguments.length, L = new Array(D > 1 ? D - 1 : 0), p = 1; p < D; p++)
              L[p - 1] = arguments[p];
            return m = c.call.apply(c, [this].concat(L)) || this, m.data = void 0, m.data = g, m;
          }
          return v;
        }(/* @__PURE__ */ E(Error));
      },
      "./src/loader/fragment.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          BaseSegment: () => u,
          ElementaryStreamTypes: () => O,
          Fragment: () => M,
          Part: () => d
        });
        var b = a("./src/polyfills/number.ts"), y = a("./node_modules/url-toolkit/src/url-toolkit.js"), N = a("./src/loader/load-stats.ts");
        function E(c, v) {
          c.prototype = Object.create(v.prototype), c.prototype.constructor = c, B(c, v);
        }
        function B(c, v) {
          return B = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(m, D) {
            return m.__proto__ = D, m;
          }, B(c, v);
        }
        function I(c, v) {
          for (var g = 0; g < v.length; g++) {
            var m = v[g];
            m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(c, A(m.key), m);
          }
        }
        function T(c, v, g) {
          return v && I(c.prototype, v), g && I(c, g), Object.defineProperty(c, "prototype", { writable: !1 }), c;
        }
        function A(c) {
          var v = w(c, "string");
          return typeof v == "symbol" ? v : String(v);
        }
        function w(c, v) {
          if (typeof c != "object" || c === null)
            return c;
          var g = c[Symbol.toPrimitive];
          if (g !== void 0) {
            var m = g.call(c, v || "default");
            if (typeof m != "object")
              return m;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (v === "string" ? String : Number)(c);
        }
        var O;
        (function(c) {
          c.AUDIO = "audio", c.VIDEO = "video", c.AUDIOVIDEO = "audiovideo";
        })(O || (O = {}));
        var u = /* @__PURE__ */ function() {
          function c(g) {
            var m;
            this._byteRange = null, this._url = null, this.baseurl = void 0, this.relurl = void 0, this.elementaryStreams = (m = {}, m[O.AUDIO] = null, m[O.VIDEO] = null, m[O.AUDIOVIDEO] = null, m), this.baseurl = g;
          }
          var v = c.prototype;
          return v.setByteRange = function(m, D) {
            var L = m.split("@", 2), p = [];
            L.length === 1 ? p[0] = D ? D.byteRangeEndOffset : 0 : p[0] = parseInt(L[1]), p[1] = parseInt(L[0]) + p[0], this._byteRange = p;
          }, T(c, [{
            key: "byteRange",
            get: function() {
              return this._byteRange ? this._byteRange : [];
            }
          }, {
            key: "byteRangeStartOffset",
            get: function() {
              return this.byteRange[0];
            }
          }, {
            key: "byteRangeEndOffset",
            get: function() {
              return this.byteRange[1];
            }
          }, {
            key: "url",
            get: function() {
              return !this._url && this.baseurl && this.relurl && (this._url = (0, y.buildAbsoluteURL)(this.baseurl, this.relurl, {
                alwaysNormalize: !0
              })), this._url || "";
            },
            set: function(m) {
              this._url = m;
            }
          }]), c;
        }(), M = /* @__PURE__ */ function(c) {
          E(v, c);
          function v(m, D) {
            var L;
            return L = c.call(this, D) || this, L._decryptdata = null, L.rawProgramDateTime = null, L.programDateTime = null, L.tagList = [], L.duration = 0, L.sn = 0, L.levelkeys = void 0, L.type = void 0, L.loader = null, L.keyLoader = null, L.level = -1, L.cc = 0, L.startPTS = void 0, L.endPTS = void 0, L.appendedPTS = void 0, L.startDTS = void 0, L.endDTS = void 0, L.start = 0, L.deltaPTS = void 0, L.maxStartPTS = void 0, L.minEndPTS = void 0, L.stats = new N.LoadStats(), L.urlId = 0, L.data = void 0, L.bitrateTest = !1, L.title = null, L.initSegment = null, L.endList = void 0, L.type = m, L;
          }
          var g = v.prototype;
          return g.setKeyFormat = function(D) {
            if (this.levelkeys) {
              var L = this.levelkeys[D];
              L && !this._decryptdata && (this._decryptdata = L.getDecryptData(this.sn));
            }
          }, g.abortRequests = function() {
            var D, L;
            (D = this.loader) === null || D === void 0 || D.abort(), (L = this.keyLoader) === null || L === void 0 || L.abort();
          }, g.setElementaryStreamInfo = function(D, L, p, x, k, _) {
            _ === void 0 && (_ = !1);
            var S = this.elementaryStreams, h = S[D];
            if (!h) {
              S[D] = {
                startPTS: L,
                endPTS: p,
                startDTS: x,
                endDTS: k,
                partial: _
              };
              return;
            }
            h.startPTS = Math.min(h.startPTS, L), h.endPTS = Math.max(h.endPTS, p), h.startDTS = Math.min(h.startDTS, x), h.endDTS = Math.max(h.endDTS, k);
          }, g.clearElementaryStreamInfo = function() {
            var D = this.elementaryStreams;
            D[O.AUDIO] = null, D[O.VIDEO] = null, D[O.AUDIOVIDEO] = null;
          }, T(v, [{
            key: "decryptdata",
            get: function() {
              var D = this.levelkeys;
              if (!D && !this._decryptdata)
                return null;
              if (!this._decryptdata && this.levelkeys && !this.levelkeys.NONE) {
                var L = this.levelkeys.identity;
                if (L)
                  this._decryptdata = L.getDecryptData(this.sn);
                else {
                  var p = Object.keys(this.levelkeys);
                  if (p.length === 1)
                    return this._decryptdata = this.levelkeys[p[0]].getDecryptData(this.sn);
                }
              }
              return this._decryptdata;
            }
          }, {
            key: "end",
            get: function() {
              return this.start + this.duration;
            }
          }, {
            key: "endProgramDateTime",
            get: function() {
              if (this.programDateTime === null || !(0, b.isFiniteNumber)(this.programDateTime))
                return null;
              var D = (0, b.isFiniteNumber)(this.duration) ? this.duration : 0;
              return this.programDateTime + D * 1e3;
            }
          }, {
            key: "encrypted",
            get: function() {
              var D;
              if ((D = this._decryptdata) !== null && D !== void 0 && D.encrypted)
                return !0;
              if (this.levelkeys) {
                var L = Object.keys(this.levelkeys), p = L.length;
                if (p > 1 || p === 1 && this.levelkeys[L[0]].encrypted)
                  return !0;
              }
              return !1;
            }
          }]), v;
        }(u), d = /* @__PURE__ */ function(c) {
          E(v, c);
          function v(g, m, D, L, p) {
            var x;
            x = c.call(this, D) || this, x.fragOffset = 0, x.duration = 0, x.gap = !1, x.independent = !1, x.relurl = void 0, x.fragment = void 0, x.index = void 0, x.stats = new N.LoadStats(), x.duration = g.decimalFloatingPoint("DURATION"), x.gap = g.bool("GAP"), x.independent = g.bool("INDEPENDENT"), x.relurl = g.enumeratedString("URI"), x.fragment = m, x.index = L;
            var k = g.enumeratedString("BYTERANGE");
            return k && x.setByteRange(k, p), p && (x.fragOffset = p.fragOffset + p.duration), x;
          }
          return T(v, [{
            key: "start",
            get: function() {
              return this.fragment.start + this.fragOffset;
            }
          }, {
            key: "end",
            get: function() {
              return this.start + this.duration;
            }
          }, {
            key: "loaded",
            get: function() {
              var m = this.elementaryStreams;
              return !!(m.audio || m.video || m.audiovideo);
            }
          }]), v;
        }(u);
      },
      "./src/loader/key-loader.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => N
        });
        var b = a("./src/errors.ts"), y = a("./src/loader/fragment-loader.ts"), N = /* @__PURE__ */ function() {
          function E(I) {
            this.config = void 0, this.keyUriToKeyInfo = {}, this.emeController = null, this.config = I;
          }
          var B = E.prototype;
          return B.abort = function() {
            for (var T in this.keyUriToKeyInfo) {
              var A = this.keyUriToKeyInfo[T].loader;
              A && A.abort();
            }
          }, B.detach = function() {
            for (var T in this.keyUriToKeyInfo) {
              var A = this.keyUriToKeyInfo[T];
              (A.mediaKeySessionContext || A.decryptdata.isCommonEncryption) && delete this.keyUriToKeyInfo[T];
            }
          }, B.destroy = function() {
            this.detach();
            for (var T in this.keyUriToKeyInfo) {
              var A = this.keyUriToKeyInfo[T].loader;
              A && A.destroy();
            }
            this.keyUriToKeyInfo = {};
          }, B.createKeyLoadError = function(T, A, w, O) {
            return A === void 0 && (A = b.ErrorDetails.KEY_LOAD_ERROR), new y.LoadError({
              type: b.ErrorTypes.NETWORK_ERROR,
              details: A,
              fatal: !1,
              frag: T,
              networkDetails: w
            });
          }, B.loadClear = function(T, A) {
            var w = this;
            if (this.emeController && this.config.emeEnabled)
              for (var O = T.sn, u = T.cc, M = function(g) {
                var m = A[g];
                if (u <= m.cc && (O === "initSegment" || O < m.sn))
                  return w.emeController.selectKeySystemFormat(m).then(function(D) {
                    m.setKeyFormat(D);
                  }), "break";
              }, d = 0; d < A.length; d++) {
                var c = M(d);
                if (c === "break")
                  break;
              }
          }, B.load = function(T) {
            var A = this;
            return !T.decryptdata && T.encrypted && this.emeController ? this.emeController.selectKeySystemFormat(T).then(function(w) {
              return A.loadInternal(T, w);
            }) : this.loadInternal(T);
          }, B.loadInternal = function(T, A) {
            var w, O;
            A && T.setKeyFormat(A);
            var u = T.decryptdata;
            if (!u) {
              var M = A ? "Expected frag.decryptdata to be defined after setting format " + A : "Missing decryption data on fragment in onKeyLoading";
              return Promise.reject(this.createKeyLoadError(T, b.ErrorDetails.KEY_LOAD_ERROR, null, M));
            }
            var d = u.uri;
            if (!d)
              return Promise.reject(this.createKeyLoadError(T, b.ErrorDetails.KEY_LOAD_ERROR, null, 'Invalid key URI: "' + d + '"'));
            var c = this.keyUriToKeyInfo[d];
            if ((w = c) !== null && w !== void 0 && w.decryptdata.key)
              return u.key = c.decryptdata.key, Promise.resolve({
                frag: T,
                keyInfo: c
              });
            if ((O = c) !== null && O !== void 0 && O.keyLoadPromise) {
              var v;
              switch ((v = c.mediaKeySessionContext) === null || v === void 0 ? void 0 : v.keyStatus) {
                case void 0:
                case "status-pending":
                case "usable":
                case "usable-in-future":
                  return c.keyLoadPromise.then(function(g) {
                    return u.key = g.keyInfo.decryptdata.key, {
                      frag: T,
                      keyInfo: c
                    };
                  });
              }
            }
            switch (c = this.keyUriToKeyInfo[d] = {
              decryptdata: u,
              keyLoadPromise: null,
              loader: null,
              mediaKeySessionContext: null
            }, u.method) {
              case "ISO-23001-7":
              case "SAMPLE-AES":
              case "SAMPLE-AES-CENC":
              case "SAMPLE-AES-CTR":
                return u.keyFormat === "identity" ? this.loadKeyHTTP(c, T) : this.loadKeyEME(c, T);
              case "AES-128":
                return this.loadKeyHTTP(c, T);
              default:
                return Promise.reject(this.createKeyLoadError(T, b.ErrorDetails.KEY_LOAD_ERROR, null, 'Key supplied with unsupported METHOD: "' + u.method + '"'));
            }
          }, B.loadKeyEME = function(T, A) {
            var w = {
              frag: A,
              keyInfo: T
            };
            if (this.emeController && this.config.emeEnabled) {
              var O = this.emeController.loadKey(w);
              if (O)
                return (T.keyLoadPromise = O.then(function(u) {
                  return T.mediaKeySessionContext = u, w;
                })).catch(function(u) {
                  throw T.keyLoadPromise = null, u;
                });
            }
            return Promise.resolve(w);
          }, B.loadKeyHTTP = function(T, A) {
            var w = this, O = this.config, u = O.loader, M = new u(O);
            return A.keyLoader = T.loader = M, T.keyLoadPromise = new Promise(function(d, c) {
              var v = {
                keyInfo: T,
                frag: A,
                responseType: "arraybuffer",
                url: T.decryptdata.uri
              }, g = {
                timeout: O.fragLoadingTimeOut,
                maxRetry: 0,
                retryDelay: O.fragLoadingRetryDelay,
                maxRetryDelay: O.fragLoadingMaxRetryTimeout,
                highWaterMark: 0
              }, m = {
                onSuccess: function(L, p, x, k) {
                  var _ = x.frag, S = x.keyInfo, h = x.url;
                  if (!_.decryptdata || S !== w.keyUriToKeyInfo[h])
                    return c(w.createKeyLoadError(_, b.ErrorDetails.KEY_LOAD_ERROR, k, "after key load, decryptdata unset or changed"));
                  S.decryptdata.key = _.decryptdata.key = new Uint8Array(L.data), _.keyLoader = null, S.loader = null, d({
                    frag: _,
                    keyInfo: S
                  });
                },
                onError: function(L, p, x) {
                  w.resetLoader(p), c(w.createKeyLoadError(A, b.ErrorDetails.KEY_LOAD_ERROR, x));
                },
                onTimeout: function(L, p, x) {
                  w.resetLoader(p), c(w.createKeyLoadError(A, b.ErrorDetails.KEY_LOAD_TIMEOUT, x));
                },
                onAbort: function(L, p, x) {
                  w.resetLoader(p), c(w.createKeyLoadError(A, b.ErrorDetails.INTERNAL_ABORTED, x));
                }
              };
              M.load(v, g, m);
            });
          }, B.resetLoader = function(T) {
            var A = T.frag, w = T.keyInfo, O = T.url, u = w.loader;
            A.keyLoader === u && (A.keyLoader = null, w.loader = null), delete this.keyUriToKeyInfo[O], u && u.destroy();
          }, E;
        }();
      },
      "./src/loader/level-details.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          LevelDetails: () => T
        });
        var b = a("./src/polyfills/number.ts");
        function y(A, w) {
          for (var O = 0; O < w.length; O++) {
            var u = w[O];
            u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(A, E(u.key), u);
          }
        }
        function N(A, w, O) {
          return w && y(A.prototype, w), O && y(A, O), Object.defineProperty(A, "prototype", { writable: !1 }), A;
        }
        function E(A) {
          var w = B(A, "string");
          return typeof w == "symbol" ? w : String(w);
        }
        function B(A, w) {
          if (typeof A != "object" || A === null)
            return A;
          var O = A[Symbol.toPrimitive];
          if (O !== void 0) {
            var u = O.call(A, w || "default");
            if (typeof u != "object")
              return u;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (w === "string" ? String : Number)(A);
        }
        var I = 10, T = /* @__PURE__ */ function() {
          function A(O) {
            this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.live = !0, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.availabilityDelay = void 0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = O;
          }
          var w = A.prototype;
          return w.reloaded = function(u) {
            if (!u) {
              this.advanced = !0, this.updated = !0;
              return;
            }
            var M = this.lastPartSn - u.lastPartSn, d = this.lastPartIndex - u.lastPartIndex;
            this.updated = this.endSN !== u.endSN || !!d || !!M, this.advanced = this.endSN > u.endSN || M > 0 || M === 0 && d > 0, this.updated || this.advanced ? this.misses = Math.floor(u.misses * 0.6) : this.misses = u.misses + 1, this.availabilityDelay = u.availabilityDelay;
          }, N(A, [{
            key: "hasProgramDateTime",
            get: function() {
              return this.fragments.length ? (0, b.isFiniteNumber)(this.fragments[this.fragments.length - 1].programDateTime) : !1;
            }
          }, {
            key: "levelTargetDuration",
            get: function() {
              return this.averagetargetduration || this.targetduration || I;
            }
          }, {
            key: "drift",
            get: function() {
              var u = this.driftEndTime - this.driftStartTime;
              if (u > 0) {
                var M = this.driftEnd - this.driftStart;
                return M * 1e3 / u;
              }
              return 1;
            }
          }, {
            key: "edge",
            get: function() {
              return this.partEnd || this.fragmentEnd;
            }
          }, {
            key: "partEnd",
            get: function() {
              var u;
              return (u = this.partList) !== null && u !== void 0 && u.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
            }
          }, {
            key: "fragmentEnd",
            get: function() {
              var u;
              return (u = this.fragments) !== null && u !== void 0 && u.length ? this.fragments[this.fragments.length - 1].end : 0;
            }
          }, {
            key: "age",
            get: function() {
              return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
            }
          }, {
            key: "lastPartIndex",
            get: function() {
              var u;
              return (u = this.partList) !== null && u !== void 0 && u.length ? this.partList[this.partList.length - 1].index : -1;
            }
          }, {
            key: "lastPartSn",
            get: function() {
              var u;
              return (u = this.partList) !== null && u !== void 0 && u.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
            }
          }]), A;
        }();
      },
      "./src/loader/level-key.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          LevelKey: () => T
        });
        var b = a("./src/utils/keysystem-util.ts"), y = a("./src/utils/mediakeys-helper.ts"), N = a("./src/utils/mp4-tools.ts"), E = a("./src/utils/logger.ts"), B = a("./src/utils/numeric-encoding-utils.ts"), I = {}, T = /* @__PURE__ */ function() {
          w.clearKeyUriToKeyIdMap = function() {
            I = {};
          };
          function w(u, M, d, c, v) {
            c === void 0 && (c = [1]), v === void 0 && (v = null), this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = u, this.uri = M, this.keyFormat = d, this.keyFormatVersions = c, this.iv = v, this.encrypted = u ? u !== "NONE" : !1, this.isCommonEncryption = this.encrypted && u !== "AES-128";
          }
          var O = w.prototype;
          return O.isSupported = function() {
            if (this.method) {
              if (this.method === "AES-128" || this.method === "NONE")
                return !0;
              switch (this.keyFormat) {
                case "identity":
                  return this.method === "SAMPLE-AES";
                case y.KeySystemFormats.FAIRPLAY:
                case y.KeySystemFormats.WIDEVINE:
                case y.KeySystemFormats.PLAYREADY:
                case y.KeySystemFormats.CLEARKEY:
                  return ["ISO-23001-7", "SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
              }
            }
            return !1;
          }, O.getDecryptData = function(M) {
            if (!this.encrypted || !this.uri)
              return null;
            if (this.method === "AES-128" && this.uri && !this.iv) {
              typeof M != "number" && (this.method === "AES-128" && !this.iv && E.logger.warn('missing IV for initialization segment with method="' + this.method + '" - compliance issue'), M = 0);
              var d = A(M), c = new w(this.method, this.uri, "identity", this.keyFormatVersions, d);
              return c;
            }
            var v = (0, b.convertDataUriToArrayBytes)(this.uri);
            if (v)
              switch (this.keyFormat) {
                case y.KeySystemFormats.WIDEVINE:
                  this.pssh = v, v.length >= 22 && (this.keyId = v.subarray(v.length - 22, v.length - 6));
                  break;
                case y.KeySystemFormats.PLAYREADY: {
                  var g = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
                  this.pssh = (0, N.mp4pssh)(g, null, v);
                  var m = new Uint16Array(v.buffer, v.byteOffset, v.byteLength / 2), D = String.fromCharCode.apply(null, Array.from(m)), L = D.substring(D.indexOf("<"), D.length), p = new DOMParser(), x = p.parseFromString(L, "text/xml"), k = x.getElementsByTagName("KID")[0];
                  if (k) {
                    var _ = k.childNodes[0] ? k.childNodes[0].nodeValue : k.getAttribute("VALUE");
                    if (_) {
                      var S = (0, B.base64Decode)(_).subarray(0, 16);
                      (0, b.changeEndianness)(S), this.keyId = S;
                    }
                  }
                  break;
                }
                default: {
                  var h = v.subarray(0, 16);
                  if (h.length !== 16) {
                    var C = new Uint8Array(16);
                    C.set(h, 16 - h.length), h = C;
                  }
                  this.keyId = h;
                  break;
                }
              }
            if (!this.keyId || this.keyId.byteLength !== 16) {
              var f = I[this.uri];
              if (!f) {
                var P = Object.keys(I).length % Number.MAX_SAFE_INTEGER;
                f = new Uint8Array(16);
                var F = new DataView(f.buffer, 12, 4);
                F.setUint32(0, P), I[this.uri] = f;
              }
              this.keyId = f;
            }
            return this;
          }, w;
        }();
        function A(w) {
          for (var O = new Uint8Array(16), u = 12; u < 16; u++)
            O[u] = w >> 8 * (15 - u) & 255;
          return O;
        }
      },
      "./src/loader/load-stats.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          LoadStats: () => b
        });
        var b = function() {
          this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
            start: 0,
            first: 0,
            end: 0
          }, this.parsing = {
            start: 0,
            end: 0
          }, this.buffering = {
            start: 0,
            first: 0,
            end: 0
          };
        };
      },
      "./src/loader/m3u8-parser.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => v
        });
        var b = a("./src/polyfills/number.ts"), y = a("./node_modules/url-toolkit/src/url-toolkit.js"), N = a("./src/loader/date-range.ts"), E = a("./src/loader/fragment.ts"), B = a("./src/loader/level-details.ts"), I = a("./src/loader/level-key.ts"), T = a("./src/utils/attr-list.ts"), A = a("./src/utils/logger.ts"), w = a("./src/utils/codecs.ts");
        function O() {
          return O = Object.assign ? Object.assign.bind() : function(_) {
            for (var S = 1; S < arguments.length; S++) {
              var h = arguments[S];
              for (var C in h)
                Object.prototype.hasOwnProperty.call(h, C) && (_[C] = h[C]);
            }
            return _;
          }, O.apply(this, arguments);
        }
        var u = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-SESSION-DATA:([^\r\n]*)[\r\n]+|#EXT-X-SESSION-KEY:([^\n\r]*)[\r\n]+/g, M = /#EXT-X-MEDIA:(.*)/g, d = new RegExp([
          /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
          /(?!#) *(\S[\S ]*)/.source,
          /#EXT-X-BYTERANGE:*(.+)/.source,
          /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
          /#.*/.source
        ].join("|"), "g"), c = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|")), v = /* @__PURE__ */ function() {
          function _() {
          }
          return _.findGroup = function(h, C) {
            for (var f = 0; f < h.length; f++) {
              var P = h[f];
              if (P.id === C)
                return P;
            }
          }, _.convertAVC1ToAVCOTI = function(h) {
            var C = h.split(".");
            if (C.length > 2) {
              var f = C.shift() + ".";
              return f += parseInt(C.shift()).toString(16), f += ("000" + parseInt(C.shift()).toString(16)).slice(-4), f;
            }
            return h;
          }, _.resolve = function(h, C) {
            return (0, y.buildAbsoluteURL)(C, h, {
              alwaysNormalize: !0
            });
          }, _.parseMasterPlaylist = function(h, C) {
            var f = [], P = [], F = {}, R = [], U = !1;
            u.lastIndex = 0;
            for (var K; (K = u.exec(h)) != null; )
              if (K[1]) {
                var V, W = new T.AttrList(K[1]), G = {
                  attrs: W,
                  bitrate: W.decimalInteger("AVERAGE-BANDWIDTH") || W.decimalInteger("BANDWIDTH"),
                  name: W.NAME,
                  url: _.resolve(K[2], C)
                }, H = W.decimalResolution("RESOLUTION");
                H && (G.width = H.width, G.height = H.height), m((W.CODECS || "").split(/[ ,]+/).filter(function(Q) {
                  return Q;
                }), G), G.videoCodec && G.videoCodec.indexOf("avc1") !== -1 && (G.videoCodec = _.convertAVC1ToAVCOTI(G.videoCodec)), (V = G.unknownCodecs) !== null && V !== void 0 && V.length || P.push(G), f.push(G);
              } else if (K[3]) {
                var $ = new T.AttrList(K[3]);
                $["DATA-ID"] && (U = !0, F[$["DATA-ID"]] = $);
              } else if (K[4]) {
                var Y = K[4], z = g(Y, C);
                z.encrypted && z.isSupported() ? R.push(z) : A.logger.warn('[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "' + Y + '"');
              }
            var X = P.length > 0 && P.length < f.length;
            return {
              levels: X ? P : f,
              sessionData: U ? F : null,
              sessionKeys: R.length ? R : null
            };
          }, _.parseMasterPlaylistMedia = function(h, C, f, P) {
            P === void 0 && (P = []);
            var F, R = [], U = 0;
            for (M.lastIndex = 0; (F = M.exec(h)) !== null; ) {
              var K = new T.AttrList(F[1]);
              if (K.TYPE === f) {
                var V = {
                  attrs: K,
                  bitrate: 0,
                  id: U++,
                  groupId: K["GROUP-ID"],
                  instreamId: K["INSTREAM-ID"],
                  name: K.NAME || K.LANGUAGE || "",
                  type: f,
                  default: K.bool("DEFAULT"),
                  autoselect: K.bool("AUTOSELECT"),
                  forced: K.bool("FORCED"),
                  lang: K.LANGUAGE,
                  url: K.URI ? _.resolve(K.URI, C) : ""
                };
                if (P.length) {
                  var W = _.findGroup(P, V.groupId) || P[0];
                  D(V, W, "audioCodec"), D(V, W, "textCodec");
                }
                R.push(V);
              }
            }
            return R;
          }, _.parseLevelPlaylist = function(h, C, f, P, F) {
            var R = new B.LevelDetails(C), U = R.fragments, K = null, V = 0, W = 0, G = 0, H = 0, $ = null, Y = new E.Fragment(P, C), z, X, Q, q = -1, Z = !1;
            for (d.lastIndex = 0, R.m3u8 = h; (z = d.exec(h)) !== null; ) {
              Z && (Z = !1, Y = new E.Fragment(P, C), Y.start = G, Y.sn = V, Y.cc = H, Y.level = f, K && (Y.initSegment = K, Y.rawProgramDateTime = K.rawProgramDateTime, K.rawProgramDateTime = null));
              var J = z[1];
              if (J) {
                Y.duration = parseFloat(J);
                var te = (" " + z[2]).slice(1);
                Y.title = te || null, Y.tagList.push(te ? ["INF", J, te] : ["INF", J]);
              } else if (z[3])
                (0, b.isFiniteNumber)(Y.duration) && (Y.start = G, Q && k(Y, Q, R), Y.sn = V, Y.level = f, Y.cc = H, Y.urlId = F, U.push(Y), Y.relurl = (" " + z[3]).slice(1), p(Y, $), $ = Y, G += Y.duration, V++, W = 0, Z = !0);
              else if (z[4]) {
                var ne = (" " + z[4]).slice(1);
                $ ? Y.setByteRange(ne, $) : Y.setByteRange(ne);
              } else if (z[5])
                Y.rawProgramDateTime = (" " + z[5]).slice(1), Y.tagList.push(["PROGRAM-DATE-TIME", Y.rawProgramDateTime]), q === -1 && (q = U.length);
              else {
                if (z = z[0].match(c), !z) {
                  A.logger.warn("No matches on slow regex match for level playlist!");
                  continue;
                }
                for (X = 1; X < z.length && !(typeof z[X] < "u"); X++)
                  ;
                var re = (" " + z[X]).slice(1), ee = (" " + z[X + 1]).slice(1), le = z[X + 2] ? (" " + z[X + 2]).slice(1) : "";
                switch (re) {
                  case "PLAYLIST-TYPE":
                    R.type = ee.toUpperCase();
                    break;
                  case "MEDIA-SEQUENCE":
                    V = R.startSN = parseInt(ee);
                    break;
                  case "SKIP": {
                    var pe = new T.AttrList(ee), ie = pe.decimalInteger("SKIPPED-SEGMENTS");
                    if ((0, b.isFiniteNumber)(ie)) {
                      R.skippedSegments = ie;
                      for (var ce = ie; ce--; )
                        U.unshift(null);
                      V += ie;
                    }
                    var se = pe.enumeratedString("RECENTLY-REMOVED-DATERANGES");
                    se && (R.recentlyRemovedDateranges = se.split("	"));
                    break;
                  }
                  case "TARGETDURATION":
                    R.targetduration = parseFloat(ee);
                    break;
                  case "VERSION":
                    R.version = parseInt(ee);
                    break;
                  case "EXTM3U":
                    break;
                  case "ENDLIST":
                    R.live = !1;
                    break;
                  case "#":
                    (ee || le) && Y.tagList.push(le ? [ee, le] : [ee]);
                    break;
                  case "DISCONTINUITY":
                    H++, Y.tagList.push(["DIS"]);
                    break;
                  case "GAP":
                    Y.tagList.push([re]);
                    break;
                  case "BITRATE":
                    Y.tagList.push([re, ee]);
                    break;
                  case "DATERANGE": {
                    var he = new T.AttrList(ee), ae = new N.DateRange(he, R.dateRanges[he.ID]);
                    ae.isValid || R.skippedSegments ? R.dateRanges[ae.id] = ae : A.logger.warn('Ignoring invalid DATERANGE tag: "' + ee + '"'), Y.tagList.push(["EXT-X-DATERANGE", ee]);
                    break;
                  }
                  case "DISCONTINUITY-SEQUENCE":
                    H = parseInt(ee);
                    break;
                  case "KEY": {
                    var Ee = g(ee, C);
                    if (Ee.isSupported()) {
                      if (Ee.method === "NONE") {
                        Q = void 0;
                        break;
                      }
                      Q || (Q = {}), Q[Ee.keyFormat] && (Q = O({}, Q)), Q[Ee.keyFormat] = Ee;
                    } else
                      A.logger.warn('[Keys] Ignoring invalid EXT-X-KEY tag: "' + ee + '"');
                    break;
                  }
                  case "START": {
                    var ue = new T.AttrList(ee), Le = ue.decimalFloatingPoint("TIME-OFFSET");
                    (0, b.isFiniteNumber)(Le) && (R.startTimeOffset = Le);
                    break;
                  }
                  case "MAP": {
                    var Ae = new T.AttrList(ee);
                    if (Y.duration) {
                      var Re = new E.Fragment(P, C);
                      x(Re, Ae, f, Q), K = Re, Y.initSegment = K, K.rawProgramDateTime && !Y.rawProgramDateTime && (Y.rawProgramDateTime = K.rawProgramDateTime);
                    } else
                      x(Y, Ae, f, Q), K = Y, Z = !0;
                    break;
                  }
                  case "SERVER-CONTROL": {
                    var Ke = new T.AttrList(ee);
                    R.canBlockReload = Ke.bool("CAN-BLOCK-RELOAD"), R.canSkipUntil = Ke.optionalFloat("CAN-SKIP-UNTIL", 0), R.canSkipDateRanges = R.canSkipUntil > 0 && Ke.bool("CAN-SKIP-DATERANGES"), R.partHoldBack = Ke.optionalFloat("PART-HOLD-BACK", 0), R.holdBack = Ke.optionalFloat("HOLD-BACK", 0);
                    break;
                  }
                  case "PART-INF": {
                    var Nt = new T.AttrList(ee);
                    R.partTarget = Nt.decimalFloatingPoint("PART-TARGET");
                    break;
                  }
                  case "PART": {
                    var nt = R.partList;
                    nt || (nt = R.partList = []);
                    var Wt = W > 0 ? nt[nt.length - 1] : void 0, bt = W++, gt = new E.Part(new T.AttrList(ee), Y, C, bt, Wt);
                    nt.push(gt), Y.duration += gt.duration;
                    break;
                  }
                  case "PRELOAD-HINT": {
                    var pt = new T.AttrList(ee);
                    R.preloadHint = pt;
                    break;
                  }
                  case "RENDITION-REPORT": {
                    var tt = new T.AttrList(ee);
                    R.renditionReports = R.renditionReports || [], R.renditionReports.push(tt);
                    break;
                  }
                  default:
                    A.logger.warn("line parsed but not handled: " + z);
                    break;
                }
              }
            }
            $ && !$.relurl ? (U.pop(), G -= $.duration, R.partList && (R.fragmentHint = $)) : R.partList && (p(Y, $), Y.cc = H, R.fragmentHint = Y, Q && k(Y, Q, R));
            var Xe = U.length, yt = U[0], At = U[Xe - 1];
            if (G += R.skippedSegments * R.targetduration, G > 0 && Xe && At) {
              R.averagetargetduration = G / Xe;
              var Ve = At.sn;
              R.endSN = Ve !== "initSegment" ? Ve : 0, R.live || (At.endList = !0), yt && (R.startCC = yt.cc);
            } else
              R.endSN = 0, R.startCC = 0;
            return R.fragmentHint && (G += R.fragmentHint.duration), R.totalduration = G, R.endCC = H, q > 0 && L(U, q), R;
          }, _;
        }();
        function g(_, S) {
          var h, C, f = new T.AttrList(_), P = (h = f.enumeratedString("METHOD")) != null ? h : "", F = f.URI, R = f.hexadecimalInteger("IV"), U = f.enumeratedString("KEYFORMATVERSIONS"), K = (C = f.enumeratedString("KEYFORMAT")) != null ? C : "identity";
          F && f.IV && !R && A.logger.error("Invalid IV: " + f.IV);
          var V = F ? v.resolve(F, S) : "", W = (U || "1").split("/").map(Number).filter(Number.isFinite);
          return new I.LevelKey(P, V, K, W, R);
        }
        function m(_, S) {
          ["video", "audio", "text"].forEach(function(h) {
            var C = _.filter(function(P) {
              return (0, w.isCodecType)(P, h);
            });
            if (C.length) {
              var f = C.filter(function(P) {
                return P.lastIndexOf("avc1", 0) === 0 || P.lastIndexOf("mp4a", 0) === 0;
              });
              S[h + "Codec"] = f.length > 0 ? f[0] : C[0], _ = _.filter(function(P) {
                return C.indexOf(P) === -1;
              });
            }
          }), S.unknownCodecs = _;
        }
        function D(_, S, h) {
          var C = S[h];
          C && (_[h] = C);
        }
        function L(_, S) {
          for (var h = _[S], C = S; C--; ) {
            var f = _[C];
            if (!f)
              return;
            f.programDateTime = h.programDateTime - f.duration * 1e3, h = f;
          }
        }
        function p(_, S) {
          _.rawProgramDateTime ? _.programDateTime = Date.parse(_.rawProgramDateTime) : S != null && S.programDateTime && (_.programDateTime = S.endProgramDateTime), (0, b.isFiniteNumber)(_.programDateTime) || (_.programDateTime = null, _.rawProgramDateTime = null);
        }
        function x(_, S, h, C) {
          _.relurl = S.URI, S.BYTERANGE && _.setByteRange(S.BYTERANGE), _.level = h, _.sn = "initSegment", C && (_.levelkeys = C), _.initSegment = null;
        }
        function k(_, S, h) {
          _.levelkeys = S;
          var C = h.encryptedFragments;
          (!C.length || C[C.length - 1].levelkeys !== S) && Object.keys(S).some(function(f) {
            return S[f].isCommonEncryption;
          }) && C.push(_);
        }
      },
      "./src/loader/playlist-loader.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => u
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/events.ts"), N = a("./src/errors.ts"), E = a("./src/utils/logger.ts"), B = a("./src/loader/m3u8-parser.ts"), I = a("./src/types/loader.ts"), T = a("./src/utils/attr-list.ts");
        function A(M) {
          var d = M.type;
          switch (d) {
            case I.PlaylistContextType.AUDIO_TRACK:
              return I.PlaylistLevelType.AUDIO;
            case I.PlaylistContextType.SUBTITLE_TRACK:
              return I.PlaylistLevelType.SUBTITLE;
            default:
              return I.PlaylistLevelType.MAIN;
          }
        }
        function w(M, d) {
          var c = M.url;
          return (c === void 0 || c.indexOf("data:") === 0) && (c = d.url), c;
        }
        var O = /* @__PURE__ */ function() {
          function M(c) {
            this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.hls = c, this.registerListeners();
          }
          var d = M.prototype;
          return d.startLoad = function(v) {
          }, d.stopLoad = function() {
            this.destroyInternalLoaders();
          }, d.registerListeners = function() {
            var v = this.hls;
            v.on(y.Events.MANIFEST_LOADING, this.onManifestLoading, this), v.on(y.Events.LEVEL_LOADING, this.onLevelLoading, this), v.on(y.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), v.on(y.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
          }, d.unregisterListeners = function() {
            var v = this.hls;
            v.off(y.Events.MANIFEST_LOADING, this.onManifestLoading, this), v.off(y.Events.LEVEL_LOADING, this.onLevelLoading, this), v.off(y.Events.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), v.off(y.Events.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
          }, d.createInternalLoader = function(v) {
            var g = this.hls.config, m = g.pLoader, D = g.loader, L = m || D, p = new L(g);
            return v.loader = p, this.loaders[v.type] = p, p;
          }, d.getInternalLoader = function(v) {
            return this.loaders[v.type];
          }, d.resetInternalLoader = function(v) {
            this.loaders[v] && delete this.loaders[v];
          }, d.destroyInternalLoaders = function() {
            for (var v in this.loaders) {
              var g = this.loaders[v];
              g && g.destroy(), this.resetInternalLoader(v);
            }
          }, d.destroy = function() {
            this.unregisterListeners(), this.destroyInternalLoaders();
          }, d.onManifestLoading = function(v, g) {
            var m = g.url;
            this.load({
              id: null,
              groupId: null,
              level: 0,
              responseType: "text",
              type: I.PlaylistContextType.MANIFEST,
              url: m,
              deliveryDirectives: null
            });
          }, d.onLevelLoading = function(v, g) {
            var m = g.id, D = g.level, L = g.url, p = g.deliveryDirectives;
            this.load({
              id: m,
              groupId: null,
              level: D,
              responseType: "text",
              type: I.PlaylistContextType.LEVEL,
              url: L,
              deliveryDirectives: p
            });
          }, d.onAudioTrackLoading = function(v, g) {
            var m = g.id, D = g.groupId, L = g.url, p = g.deliveryDirectives;
            this.load({
              id: m,
              groupId: D,
              level: null,
              responseType: "text",
              type: I.PlaylistContextType.AUDIO_TRACK,
              url: L,
              deliveryDirectives: p
            });
          }, d.onSubtitleTrackLoading = function(v, g) {
            var m = g.id, D = g.groupId, L = g.url, p = g.deliveryDirectives;
            this.load({
              id: m,
              groupId: D,
              level: null,
              responseType: "text",
              type: I.PlaylistContextType.SUBTITLE_TRACK,
              url: L,
              deliveryDirectives: p
            });
          }, d.load = function(v) {
            var g, m = this.hls.config, D = this.getInternalLoader(v);
            if (D) {
              var L = D.context;
              if (L && L.url === v.url) {
                E.logger.trace("[playlist-loader]: playlist request ongoing");
                return;
              }
              E.logger.log("[playlist-loader]: aborting previous loader for type: " + v.type), D.abort();
            }
            var p, x, k, _;
            switch (v.type) {
              case I.PlaylistContextType.MANIFEST:
                p = m.manifestLoadingMaxRetry, x = m.manifestLoadingTimeOut, k = m.manifestLoadingRetryDelay, _ = m.manifestLoadingMaxRetryTimeout;
                break;
              case I.PlaylistContextType.LEVEL:
              case I.PlaylistContextType.AUDIO_TRACK:
              case I.PlaylistContextType.SUBTITLE_TRACK:
                p = 0, x = m.levelLoadingTimeOut;
                break;
              default:
                p = m.levelLoadingMaxRetry, x = m.levelLoadingTimeOut, k = m.levelLoadingRetryDelay, _ = m.levelLoadingMaxRetryTimeout;
                break;
            }
            if (D = this.createInternalLoader(v), (g = v.deliveryDirectives) !== null && g !== void 0 && g.part) {
              var S;
              if (v.type === I.PlaylistContextType.LEVEL && v.level !== null ? S = this.hls.levels[v.level].details : v.type === I.PlaylistContextType.AUDIO_TRACK && v.id !== null ? S = this.hls.audioTracks[v.id].details : v.type === I.PlaylistContextType.SUBTITLE_TRACK && v.id !== null && (S = this.hls.subtitleTracks[v.id].details), S) {
                var h = S.partTarget, C = S.targetduration;
                h && C && (x = Math.min(Math.max(h * 3, C * 0.8) * 1e3, x));
              }
            }
            var f = {
              timeout: x,
              maxRetry: p,
              retryDelay: k,
              maxRetryDelay: _,
              highWaterMark: 0
            }, P = {
              onSuccess: this.loadsuccess.bind(this),
              onError: this.loaderror.bind(this),
              onTimeout: this.loadtimeout.bind(this)
            };
            D.load(v, f, P);
          }, d.loadsuccess = function(v, g, m, D) {
            D === void 0 && (D = null), this.resetInternalLoader(m.type);
            var L = v.data;
            if (L.indexOf("#EXTM3U") !== 0) {
              this.handleManifestParsingError(v, m, "no EXTM3U delimiter", D);
              return;
            }
            g.parsing.start = performance.now(), L.indexOf("#EXTINF:") > 0 || L.indexOf("#EXT-X-TARGETDURATION:") > 0 ? this.handleTrackOrLevelPlaylist(v, g, m, D) : this.handleMasterPlaylist(v, g, m, D);
          }, d.loaderror = function(v, g, m) {
            m === void 0 && (m = null), this.handleNetworkError(g, m, !1, v);
          }, d.loadtimeout = function(v, g, m) {
            m === void 0 && (m = null), this.handleNetworkError(g, m, !0);
          }, d.handleMasterPlaylist = function(v, g, m, D) {
            var L = this.hls, p = v.data, x = w(v, m), k = B.default.parseMasterPlaylist(p, x), _ = k.levels, S = k.sessionData, h = k.sessionKeys;
            if (!_.length) {
              this.handleManifestParsingError(v, m, "no level found in manifest", D);
              return;
            }
            var C = _.map(function(K) {
              return {
                id: K.attrs.AUDIO,
                audioCodec: K.audioCodec
              };
            }), f = _.map(function(K) {
              return {
                id: K.attrs.SUBTITLES,
                textCodec: K.textCodec
              };
            }), P = B.default.parseMasterPlaylistMedia(p, x, "AUDIO", C), F = B.default.parseMasterPlaylistMedia(p, x, "SUBTITLES", f), R = B.default.parseMasterPlaylistMedia(p, x, "CLOSED-CAPTIONS");
            if (P.length) {
              var U = P.some(function(K) {
                return !K.url;
              });
              !U && _[0].audioCodec && !_[0].attrs.AUDIO && (E.logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), P.unshift({
                type: "main",
                name: "main",
                default: !1,
                autoselect: !1,
                forced: !1,
                id: -1,
                attrs: new T.AttrList({}),
                bitrate: 0,
                url: ""
              }));
            }
            L.trigger(y.Events.MANIFEST_LOADED, {
              levels: _,
              audioTracks: P,
              subtitles: F,
              captions: R,
              url: x,
              stats: g,
              networkDetails: D,
              sessionData: S,
              sessionKeys: h
            });
          }, d.handleTrackOrLevelPlaylist = function(v, g, m, D) {
            var L = this.hls, p = m.id, x = m.level, k = m.type, _ = w(v, m), S = (0, b.isFiniteNumber)(p) ? p : 0, h = (0, b.isFiniteNumber)(x) ? x : S, C = A(m), f = B.default.parseLevelPlaylist(v.data, _, h, C, S);
            if (!f.fragments.length) {
              L.trigger(y.Events.ERROR, {
                type: N.ErrorTypes.NETWORK_ERROR,
                details: N.ErrorDetails.LEVEL_EMPTY_ERROR,
                fatal: !1,
                url: _,
                reason: "no fragments found in level",
                level: typeof m.level == "number" ? m.level : void 0
              });
              return;
            }
            if (k === I.PlaylistContextType.MANIFEST) {
              var P = {
                attrs: new T.AttrList({}),
                bitrate: 0,
                details: f,
                name: "",
                url: _
              };
              L.trigger(y.Events.MANIFEST_LOADED, {
                levels: [P],
                audioTracks: [],
                url: _,
                stats: g,
                networkDetails: D,
                sessionData: null,
                sessionKeys: null
              });
            }
            g.parsing.end = performance.now(), m.levelDetails = f, this.handlePlaylistLoaded(v, g, m, D);
          }, d.handleManifestParsingError = function(v, g, m, D) {
            this.hls.trigger(y.Events.ERROR, {
              type: N.ErrorTypes.NETWORK_ERROR,
              details: N.ErrorDetails.MANIFEST_PARSING_ERROR,
              fatal: g.type === I.PlaylistContextType.MANIFEST,
              url: v.url,
              reason: m,
              response: v,
              context: g,
              networkDetails: D
            });
          }, d.handleNetworkError = function(v, g, m, D) {
            m === void 0 && (m = !1), E.logger.warn("[playlist-loader]: A network " + (m ? "timeout" : "error") + " occurred while loading " + v.type + " level: " + v.level + " id: " + v.id + ' group-id: "' + v.groupId + '"');
            var L = N.ErrorDetails.UNKNOWN, p = !1, x = this.getInternalLoader(v);
            switch (v.type) {
              case I.PlaylistContextType.MANIFEST:
                L = m ? N.ErrorDetails.MANIFEST_LOAD_TIMEOUT : N.ErrorDetails.MANIFEST_LOAD_ERROR, p = !0;
                break;
              case I.PlaylistContextType.LEVEL:
                L = m ? N.ErrorDetails.LEVEL_LOAD_TIMEOUT : N.ErrorDetails.LEVEL_LOAD_ERROR, p = !1;
                break;
              case I.PlaylistContextType.AUDIO_TRACK:
                L = m ? N.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : N.ErrorDetails.AUDIO_TRACK_LOAD_ERROR, p = !1;
                break;
              case I.PlaylistContextType.SUBTITLE_TRACK:
                L = m ? N.ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : N.ErrorDetails.SUBTITLE_LOAD_ERROR, p = !1;
                break;
            }
            x && this.resetInternalLoader(v.type);
            var k = {
              type: N.ErrorTypes.NETWORK_ERROR,
              details: L,
              fatal: p,
              url: v.url,
              loader: x,
              context: v,
              networkDetails: g
            };
            D && (k.response = D), this.hls.trigger(y.Events.ERROR, k);
          }, d.handlePlaylistLoaded = function(v, g, m, D) {
            var L = m.type, p = m.level, x = m.id, k = m.groupId, _ = m.loader, S = m.levelDetails, h = m.deliveryDirectives;
            if (!(S != null && S.targetduration)) {
              this.handleManifestParsingError(v, m, "invalid target duration", D);
              return;
            }
            if (!!_)
              switch (S.live && (_.getCacheAge && (S.ageHeader = _.getCacheAge() || 0), (!_.getCacheAge || isNaN(S.ageHeader)) && (S.ageHeader = 0)), L) {
                case I.PlaylistContextType.MANIFEST:
                case I.PlaylistContextType.LEVEL:
                  this.hls.trigger(y.Events.LEVEL_LOADED, {
                    details: S,
                    level: p || 0,
                    id: x || 0,
                    stats: g,
                    networkDetails: D,
                    deliveryDirectives: h
                  });
                  break;
                case I.PlaylistContextType.AUDIO_TRACK:
                  this.hls.trigger(y.Events.AUDIO_TRACK_LOADED, {
                    details: S,
                    id: x || 0,
                    groupId: k || "",
                    stats: g,
                    networkDetails: D,
                    deliveryDirectives: h
                  });
                  break;
                case I.PlaylistContextType.SUBTITLE_TRACK:
                  this.hls.trigger(y.Events.SUBTITLE_TRACK_LOADED, {
                    details: S,
                    id: x || 0,
                    groupId: k || "",
                    stats: g,
                    networkDetails: D,
                    deliveryDirectives: h
                  });
                  break;
              }
          }, M;
        }();
        const u = O;
      },
      "./src/polyfills/number.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          MAX_SAFE_INTEGER: () => y,
          isFiniteNumber: () => b
        });
        var b = Number.isFinite || function(N) {
          return typeof N == "number" && isFinite(N);
        }, y = Number.MAX_SAFE_INTEGER || 9007199254740991;
      },
      "./src/remux/aac-helper.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => y
        });
        var b = /* @__PURE__ */ function() {
          function N() {
          }
          return N.getSilentFrame = function(B, I) {
            switch (B) {
              case "mp4a.40.2":
                if (I === 1)
                  return new Uint8Array([0, 200, 0, 128, 35, 128]);
                if (I === 2)
                  return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
                if (I === 3)
                  return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
                if (I === 4)
                  return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
                if (I === 5)
                  return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
                if (I === 6)
                  return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
                break;
              default:
                if (I === 1)
                  return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                if (I === 2)
                  return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                if (I === 3)
                  return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                break;
            }
          }, N;
        }();
        const y = b;
      },
      "./src/remux/mp4-generator.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => N
        });
        var b = Math.pow(2, 32) - 1, y = /* @__PURE__ */ function() {
          function E() {
          }
          return E.init = function() {
            E.types = {
              avc1: [],
              avcC: [],
              btrt: [],
              dinf: [],
              dref: [],
              esds: [],
              ftyp: [],
              hdlr: [],
              mdat: [],
              mdhd: [],
              mdia: [],
              mfhd: [],
              minf: [],
              moof: [],
              moov: [],
              mp4a: [],
              ".mp3": [],
              mvex: [],
              mvhd: [],
              pasp: [],
              sdtp: [],
              stbl: [],
              stco: [],
              stsc: [],
              stsd: [],
              stsz: [],
              stts: [],
              tfdt: [],
              tfhd: [],
              traf: [],
              trak: [],
              trun: [],
              trex: [],
              tkhd: [],
              vmhd: [],
              smhd: []
            };
            var I;
            for (I in E.types)
              E.types.hasOwnProperty(I) && (E.types[I] = [I.charCodeAt(0), I.charCodeAt(1), I.charCodeAt(2), I.charCodeAt(3)]);
            var T = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              118,
              105,
              100,
              101,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              86,
              105,
              100,
              101,
              111,
              72,
              97,
              110,
              100,
              108,
              101,
              114,
              0
            ]), A = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              115,
              111,
              117,
              110,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              83,
              111,
              117,
              110,
              100,
              72,
              97,
              110,
              100,
              108,
              101,
              114,
              0
            ]);
            E.HDLR_TYPES = {
              video: T,
              audio: A
            };
            var w = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              12,
              117,
              114,
              108,
              32,
              0,
              0,
              0,
              1
            ]), O = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]);
            E.STTS = E.STSC = E.STCO = O, E.STSZ = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]), E.VMHD = new Uint8Array([
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]), E.SMHD = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0
            ]), E.STSD = new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1
            ]);
            var u = new Uint8Array([105, 115, 111, 109]), M = new Uint8Array([97, 118, 99, 49]), d = new Uint8Array([0, 0, 0, 1]);
            E.FTYP = E.box(E.types.ftyp, u, d, u, M), E.DINF = E.box(E.types.dinf, E.box(E.types.dref, w));
          }, E.box = function(I) {
            for (var T = 8, A = arguments.length, w = new Array(A > 1 ? A - 1 : 0), O = 1; O < A; O++)
              w[O - 1] = arguments[O];
            for (var u = w.length, M = u; u--; )
              T += w[u].byteLength;
            var d = new Uint8Array(T);
            for (d[0] = T >> 24 & 255, d[1] = T >> 16 & 255, d[2] = T >> 8 & 255, d[3] = T & 255, d.set(I, 4), u = 0, T = 8; u < M; u++)
              d.set(w[u], T), T += w[u].byteLength;
            return d;
          }, E.hdlr = function(I) {
            return E.box(E.types.hdlr, E.HDLR_TYPES[I]);
          }, E.mdat = function(I) {
            return E.box(E.types.mdat, I);
          }, E.mdhd = function(I, T) {
            T *= I;
            var A = Math.floor(T / (b + 1)), w = Math.floor(T % (b + 1));
            return E.box(E.types.mdhd, new Uint8Array([
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              2,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              3,
              I >> 24 & 255,
              I >> 16 & 255,
              I >> 8 & 255,
              I & 255,
              A >> 24,
              A >> 16 & 255,
              A >> 8 & 255,
              A & 255,
              w >> 24,
              w >> 16 & 255,
              w >> 8 & 255,
              w & 255,
              85,
              196,
              0,
              0
            ]));
          }, E.mdia = function(I) {
            return E.box(E.types.mdia, E.mdhd(I.timescale, I.duration), E.hdlr(I.type), E.minf(I));
          }, E.mfhd = function(I) {
            return E.box(E.types.mfhd, new Uint8Array([
              0,
              0,
              0,
              0,
              I >> 24,
              I >> 16 & 255,
              I >> 8 & 255,
              I & 255
            ]));
          }, E.minf = function(I) {
            return I.type === "audio" ? E.box(E.types.minf, E.box(E.types.smhd, E.SMHD), E.DINF, E.stbl(I)) : E.box(E.types.minf, E.box(E.types.vmhd, E.VMHD), E.DINF, E.stbl(I));
          }, E.moof = function(I, T, A) {
            return E.box(E.types.moof, E.mfhd(I), E.traf(A, T));
          }, E.moov = function(I) {
            for (var T = I.length, A = []; T--; )
              A[T] = E.trak(I[T]);
            return E.box.apply(null, [E.types.moov, E.mvhd(I[0].timescale, I[0].duration)].concat(A).concat(E.mvex(I)));
          }, E.mvex = function(I) {
            for (var T = I.length, A = []; T--; )
              A[T] = E.trex(I[T]);
            return E.box.apply(null, [E.types.mvex].concat(A));
          }, E.mvhd = function(I, T) {
            T *= I;
            var A = Math.floor(T / (b + 1)), w = Math.floor(T % (b + 1)), O = new Uint8Array([
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              2,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              3,
              I >> 24 & 255,
              I >> 16 & 255,
              I >> 8 & 255,
              I & 255,
              A >> 24,
              A >> 16 & 255,
              A >> 8 & 255,
              A & 255,
              w >> 24,
              w >> 16 & 255,
              w >> 8 & 255,
              w & 255,
              0,
              1,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              64,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              255,
              255,
              255,
              255
            ]);
            return E.box(E.types.mvhd, O);
          }, E.sdtp = function(I) {
            var T = I.samples || [], A = new Uint8Array(4 + T.length), w, O;
            for (w = 0; w < T.length; w++)
              O = T[w].flags, A[w + 4] = O.dependsOn << 4 | O.isDependedOn << 2 | O.hasRedundancy;
            return E.box(E.types.sdtp, A);
          }, E.stbl = function(I) {
            return E.box(E.types.stbl, E.stsd(I), E.box(E.types.stts, E.STTS), E.box(E.types.stsc, E.STSC), E.box(E.types.stsz, E.STSZ), E.box(E.types.stco, E.STCO));
          }, E.avc1 = function(I) {
            var T = [], A = [], w, O, u;
            for (w = 0; w < I.sps.length; w++)
              O = I.sps[w], u = O.byteLength, T.push(u >>> 8 & 255), T.push(u & 255), T = T.concat(Array.prototype.slice.call(O));
            for (w = 0; w < I.pps.length; w++)
              O = I.pps[w], u = O.byteLength, A.push(u >>> 8 & 255), A.push(u & 255), A = A.concat(Array.prototype.slice.call(O));
            var M = E.box(E.types.avcC, new Uint8Array([
              1,
              T[3],
              T[4],
              T[5],
              255,
              224 | I.sps.length
            ].concat(T).concat([
              I.pps.length
            ]).concat(A))), d = I.width, c = I.height, v = I.pixelRatio[0], g = I.pixelRatio[1];
            return E.box(
              E.types.avc1,
              new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                d >> 8 & 255,
                d & 255,
                c >> 8 & 255,
                c & 255,
                0,
                72,
                0,
                0,
                0,
                72,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                18,
                100,
                97,
                105,
                108,
                121,
                109,
                111,
                116,
                105,
                111,
                110,
                47,
                104,
                108,
                115,
                46,
                106,
                115,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                24,
                17,
                17
              ]),
              M,
              E.box(E.types.btrt, new Uint8Array([
                0,
                28,
                156,
                128,
                0,
                45,
                198,
                192,
                0,
                45,
                198,
                192
              ])),
              E.box(E.types.pasp, new Uint8Array([
                v >> 24,
                v >> 16 & 255,
                v >> 8 & 255,
                v & 255,
                g >> 24,
                g >> 16 & 255,
                g >> 8 & 255,
                g & 255
              ]))
            );
          }, E.esds = function(I) {
            var T = I.config.length;
            return new Uint8Array([
              0,
              0,
              0,
              0,
              3,
              23 + T,
              0,
              1,
              0,
              4,
              15 + T,
              64,
              21,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              5
            ].concat([T]).concat(I.config).concat([6, 1, 2]));
          }, E.mp4a = function(I) {
            var T = I.samplerate;
            return E.box(E.types.mp4a, new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              I.channelCount,
              0,
              16,
              0,
              0,
              0,
              0,
              T >> 8 & 255,
              T & 255,
              0,
              0
            ]), E.box(E.types.esds, E.esds(I)));
          }, E.mp3 = function(I) {
            var T = I.samplerate;
            return E.box(E.types[".mp3"], new Uint8Array([
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              I.channelCount,
              0,
              16,
              0,
              0,
              0,
              0,
              T >> 8 & 255,
              T & 255,
              0,
              0
            ]));
          }, E.stsd = function(I) {
            return I.type === "audio" ? I.segmentCodec === "mp3" && I.codec === "mp3" ? E.box(E.types.stsd, E.STSD, E.mp3(I)) : E.box(E.types.stsd, E.STSD, E.mp4a(I)) : E.box(E.types.stsd, E.STSD, E.avc1(I));
          }, E.tkhd = function(I) {
            var T = I.id, A = I.duration * I.timescale, w = I.width, O = I.height, u = Math.floor(A / (b + 1)), M = Math.floor(A % (b + 1));
            return E.box(E.types.tkhd, new Uint8Array([
              1,
              0,
              0,
              7,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              2,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              3,
              T >> 24 & 255,
              T >> 16 & 255,
              T >> 8 & 255,
              T & 255,
              0,
              0,
              0,
              0,
              u >> 24,
              u >> 16 & 255,
              u >> 8 & 255,
              u & 255,
              M >> 24,
              M >> 16 & 255,
              M >> 8 & 255,
              M & 255,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              64,
              0,
              0,
              0,
              w >> 8 & 255,
              w & 255,
              0,
              0,
              O >> 8 & 255,
              O & 255,
              0,
              0
            ]));
          }, E.traf = function(I, T) {
            var A = E.sdtp(I), w = I.id, O = Math.floor(T / (b + 1)), u = Math.floor(T % (b + 1));
            return E.box(
              E.types.traf,
              E.box(E.types.tfhd, new Uint8Array([
                0,
                0,
                0,
                0,
                w >> 24,
                w >> 16 & 255,
                w >> 8 & 255,
                w & 255
              ])),
              E.box(E.types.tfdt, new Uint8Array([
                1,
                0,
                0,
                0,
                O >> 24,
                O >> 16 & 255,
                O >> 8 & 255,
                O & 255,
                u >> 24,
                u >> 16 & 255,
                u >> 8 & 255,
                u & 255
              ])),
              E.trun(I, A.length + 16 + 20 + 8 + 16 + 8 + 8),
              A
            );
          }, E.trak = function(I) {
            return I.duration = I.duration || 4294967295, E.box(E.types.trak, E.tkhd(I), E.mdia(I));
          }, E.trex = function(I) {
            var T = I.id;
            return E.box(E.types.trex, new Uint8Array([
              0,
              0,
              0,
              0,
              T >> 24,
              T >> 16 & 255,
              T >> 8 & 255,
              T & 255,
              0,
              0,
              0,
              1,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              1,
              0,
              1
            ]));
          }, E.trun = function(I, T) {
            var A = I.samples || [], w = A.length, O = 12 + 16 * w, u = new Uint8Array(O), M, d, c, v, g, m;
            for (T += 8 + O, u.set([
              I.type === "video" ? 1 : 0,
              0,
              15,
              1,
              w >>> 24 & 255,
              w >>> 16 & 255,
              w >>> 8 & 255,
              w & 255,
              T >>> 24 & 255,
              T >>> 16 & 255,
              T >>> 8 & 255,
              T & 255
            ], 0), M = 0; M < w; M++)
              d = A[M], c = d.duration, v = d.size, g = d.flags, m = d.cts, u.set([
                c >>> 24 & 255,
                c >>> 16 & 255,
                c >>> 8 & 255,
                c & 255,
                v >>> 24 & 255,
                v >>> 16 & 255,
                v >>> 8 & 255,
                v & 255,
                g.isLeading << 2 | g.dependsOn,
                g.isDependedOn << 6 | g.hasRedundancy << 4 | g.paddingValue << 1 | g.isNonSync,
                g.degradPrio & 240 << 8,
                g.degradPrio & 15,
                m >>> 24 & 255,
                m >>> 16 & 255,
                m >>> 8 & 255,
                m & 255
              ], 12 + 16 * M);
            return E.box(E.types.trun, u);
          }, E.initSegment = function(I) {
            E.types || E.init();
            var T = E.moov(I), A = new Uint8Array(E.FTYP.byteLength + T.byteLength);
            return A.set(E.FTYP), A.set(T, E.FTYP.byteLength), A;
          }, E;
        }();
        y.types = void 0, y.HDLR_TYPES = void 0, y.STTS = void 0, y.STSC = void 0, y.STCO = void 0, y.STSZ = void 0, y.VMHD = void 0, y.SMHD = void 0, y.STSD = void 0, y.FTYP = void 0, y.DINF = void 0;
        const N = y;
      },
      "./src/remux/mp4-remuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => v,
          flushTextTrackMetadataCueSamples: () => D,
          flushTextTrackUserdataCueSamples: () => L,
          normalizePts: () => g
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/remux/aac-helper.ts"), N = a("./src/remux/mp4-generator.ts"), E = a("./src/events.ts"), B = a("./src/errors.ts"), I = a("./src/utils/logger.ts"), T = a("./src/types/loader.ts"), A = a("./src/utils/timescale-conversion.ts");
        function w() {
          return w = Object.assign ? Object.assign.bind() : function(k) {
            for (var _ = 1; _ < arguments.length; _++) {
              var S = arguments[_];
              for (var h in S)
                Object.prototype.hasOwnProperty.call(S, h) && (k[h] = S[h]);
            }
            return k;
          }, w.apply(this, arguments);
        }
        var O = 10 * 1e3, u = 1024, M = 1152, d = null, c = null, v = /* @__PURE__ */ function() {
          function k(S, h, C, f) {
            if (this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = void 0, this._initDTS = void 0, this.nextAvcDts = null, this.nextAudioPts = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.observer = S, this.config = h, this.typeSupported = C, this.ISGenerated = !1, d === null) {
              var P = navigator.userAgent || "", F = P.match(/Chrome\/(\d+)/i);
              d = F ? parseInt(F[1]) : 0;
            }
            if (c === null) {
              var R = navigator.userAgent.match(/Safari\/(\d+)/i);
              c = R ? parseInt(R[1]) : 0;
            }
          }
          var _ = k.prototype;
          return _.destroy = function() {
          }, _.resetTimeStamp = function(h) {
            I.logger.log("[mp4-remuxer]: initPTS & initDTS reset"), this._initPTS = this._initDTS = h;
          }, _.resetNextTimestamp = function() {
            I.logger.log("[mp4-remuxer]: reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
          }, _.resetInitSegment = function() {
            I.logger.log("[mp4-remuxer]: ISGenerated flag reset"), this.ISGenerated = !1;
          }, _.getVideoStartPts = function(h) {
            var C = !1, f = h.reduce(function(P, F) {
              var R = F.pts - P;
              return R < -4294967296 ? (C = !0, g(P, F.pts)) : R > 0 ? P : F.pts;
            }, h[0].pts);
            return C && I.logger.debug("PTS rollover detected"), f;
          }, _.remux = function(h, C, f, P, F, R, U, K) {
            var V, W, G, H, $, Y, z = F, X = F, Q = h.pid > -1, q = C.pid > -1, Z = C.samples.length, J = h.samples.length > 0, te = U && Z > 0 || Z > 1, ne = (!Q || J) && (!q || te) || this.ISGenerated || U;
            if (ne) {
              this.ISGenerated || (G = this.generateIS(h, C, F));
              var re = this.isVideoContiguous, ee = -1, le;
              if (te && (ee = m(C.samples), !re && this.config.forceKeyFrameOnDiscontinuity))
                if (Y = !0, ee > 0) {
                  I.logger.warn("[mp4-remuxer]: Dropped " + ee + " out of " + Z + " video samples due to a missing keyframe");
                  var pe = this.getVideoStartPts(C.samples);
                  C.samples = C.samples.slice(ee), C.dropped += ee, X += (C.samples[0].pts - pe) / C.inputTimeScale, le = X;
                } else
                  ee === -1 && (I.logger.warn("[mp4-remuxer]: No keyframe found out of " + Z + " video samples"), Y = !1);
              if (this.ISGenerated) {
                if (J && te) {
                  var ie = this.getVideoStartPts(C.samples), ce = g(h.samples[0].pts, ie) - ie, se = ce / C.inputTimeScale;
                  z += Math.max(0, se), X += Math.max(0, -se);
                }
                if (J) {
                  if (h.samplerate || (I.logger.warn("[mp4-remuxer]: regenerate InitSegment as audio detected"), G = this.generateIS(h, C, F)), W = this.remuxAudio(h, z, this.isAudioContiguous, R, q || te || K === T.PlaylistLevelType.AUDIO ? X : void 0), te) {
                    var he = W ? W.endPTS - W.startPTS : 0;
                    C.inputTimeScale || (I.logger.warn("[mp4-remuxer]: regenerate InitSegment as video detected"), G = this.generateIS(h, C, F)), V = this.remuxVideo(C, X, re, he);
                  }
                } else
                  te && (V = this.remuxVideo(C, X, re, 0));
                V && (V.firstKeyFrame = ee, V.independent = ee !== -1, V.firstKeyFramePTS = le);
              }
            }
            return this.ISGenerated && (f.samples.length && ($ = D(f, F, this._initPTS, this._initDTS)), P.samples.length && (H = L(P, F, this._initPTS))), {
              audio: W,
              video: V,
              initSegment: G,
              independent: Y,
              text: H,
              id3: $
            };
          }, _.generateIS = function(h, C, f) {
            var P = h.samples, F = C.samples, R = this.typeSupported, U = {}, K = !(0, b.isFiniteNumber)(this._initPTS), V = "audio/mp4", W, G, H;
            if (K && (W = G = 1 / 0), h.config && P.length) {
              switch (h.timescale = h.samplerate, h.segmentCodec) {
                case "mp3":
                  R.mpeg ? (V = "audio/mpeg", h.codec = "") : R.mp3 && (h.codec = "mp3");
                  break;
              }
              U.audio = {
                id: "audio",
                container: V,
                codec: h.codec,
                initSegment: h.segmentCodec === "mp3" && R.mpeg ? new Uint8Array(0) : N.default.initSegment([h]),
                metadata: {
                  channelCount: h.channelCount
                }
              }, K && (H = h.inputTimeScale, W = G = P[0].pts - Math.round(H * f));
            }
            if (C.sps && C.pps && F.length && (C.timescale = C.inputTimeScale, U.video = {
              id: "main",
              container: "video/mp4",
              codec: C.codec,
              initSegment: N.default.initSegment([C]),
              metadata: {
                width: C.width,
                height: C.height
              }
            }, K)) {
              H = C.inputTimeScale;
              var $ = this.getVideoStartPts(F), Y = Math.round(H * f);
              G = Math.min(G, g(F[0].dts, $) - Y), W = Math.min(W, $ - Y);
            }
            if (Object.keys(U).length)
              return this.ISGenerated = !0, K && (this._initPTS = W, this._initDTS = G), {
                tracks: U,
                initPTS: W,
                timescale: H
              };
          }, _.remuxVideo = function(h, C, f, P) {
            var F = h.inputTimeScale, R = h.samples, U = [], K = R.length, V = this._initPTS, W = this.nextAvcDts, G = 8, H = this.videoSampleDuration, $, Y, z = Number.POSITIVE_INFINITY, X = Number.NEGATIVE_INFINITY, Q = !1;
            if (!f || W === null) {
              var q = C * F, Z = R[0].pts - g(R[0].dts, R[0].pts);
              W = q - Z;
            }
            for (var J = 0; J < K; J++) {
              var te = R[J];
              te.pts = g(te.pts - V, W), te.dts = g(te.dts - V, W), te.dts < R[J > 0 ? J - 1 : J].dts && (Q = !0);
            }
            Q && R.sort(function(Kn, Ta) {
              var ku = Kn.dts - Ta.dts, Fu = Kn.pts - Ta.pts;
              return ku || Fu;
            }), $ = R[0].dts, Y = R[R.length - 1].dts;
            var ne = Y - $, re = ne ? Math.round(ne / (K - 1)) : H || h.inputTimeScale / 30;
            if (f) {
              var ee = $ - W, le = ee > re, pe = ee < -1;
              if ((le || pe) && (le ? I.logger.warn("AVC: " + (0, A.toMsFromMpegTsClock)(ee, !0) + " ms (" + ee + "dts) hole between fragments detected, filling it") : I.logger.warn("AVC: " + (0, A.toMsFromMpegTsClock)(-ee, !0) + " ms (" + ee + "dts) overlapping between fragments detected"), !pe || W > R[0].pts)) {
                $ = W;
                var ie = R[0].pts - ee;
                R[0].dts = $, R[0].pts = ie, I.logger.log("Video: First PTS/DTS adjusted: " + (0, A.toMsFromMpegTsClock)(ie, !0) + "/" + (0, A.toMsFromMpegTsClock)($, !0) + ", delta: " + (0, A.toMsFromMpegTsClock)(ee, !0) + " ms");
              }
            }
            $ = Math.max(0, $);
            for (var ce = 0, se = 0, he = 0; he < K; he++) {
              for (var ae = R[he], Ee = ae.units, ue = Ee.length, Le = 0, Ae = 0; Ae < ue; Ae++)
                Le += Ee[Ae].data.length;
              se += Le, ce += ue, ae.length = Le, ae.dts = Math.max(ae.dts, $), z = Math.min(ae.pts, z), X = Math.max(ae.pts, X);
            }
            Y = R[K - 1].dts;
            var Re = se + 4 * ce + 8, Ke;
            try {
              Ke = new Uint8Array(Re);
            } catch {
              this.observer.emit(E.Events.ERROR, E.Events.ERROR, {
                type: B.ErrorTypes.MUX_ERROR,
                details: B.ErrorDetails.REMUX_ALLOC_ERROR,
                fatal: !1,
                bytes: Re,
                reason: "fail allocating video mdat " + Re
              });
              return;
            }
            var Nt = new DataView(Ke.buffer);
            Nt.setUint32(0, Re), Ke.set(N.default.types.mdat, 4);
            for (var nt = !1, Wt = Number.POSITIVE_INFINITY, bt = Number.POSITIVE_INFINITY, gt = Number.NEGATIVE_INFINITY, pt = Number.NEGATIVE_INFINITY, tt = 0; tt < K; tt++) {
              for (var Xe = R[tt], yt = Xe.units, At = 0, Ve = 0, Bt = yt.length; Ve < Bt; Ve++) {
                var Lt = yt[Ve], Li = Lt.data, rr = Lt.data.byteLength;
                Nt.setUint32(G, rr), G += 4, Ke.set(Li, G), G += rr, At += 4 + rr;
              }
              var Er = void 0;
              if (tt < K - 1)
                H = R[tt + 1].dts - Xe.dts, Er = R[tt + 1].pts - Xe.pts;
              else {
                var pa = this.config, wi = tt > 0 ? Xe.dts - R[tt - 1].dts : re;
                if (Er = tt > 0 ? Xe.pts - R[tt - 1].pts : re, pa.stretchShortVideoTrack && this.nextAudioPts !== null) {
                  var Du = Math.floor(pa.maxBufferHole * F), Bn = (P ? z + P * F : this.nextAudioPts) - Xe.pts;
                  Bn > Du ? (H = Bn - wi, H < 0 ? H = wi : nt = !0, I.logger.log("[mp4-remuxer]: It is approximately " + Bn / 90 + " ms to the next segment; using duration " + H / 90 + " ms for the last video frame.")) : H = wi;
                } else
                  H = wi;
              }
              var Iu = Math.round(Xe.pts - Xe.dts);
              Wt = Math.min(Wt, H), gt = Math.max(gt, H), bt = Math.min(bt, Er), pt = Math.max(pt, Er), U.push(new p(Xe.key, H, At, Iu));
            }
            if (U.length) {
              if (d) {
                if (d < 70) {
                  var ya = U[0].flags;
                  ya.dependsOn = 2, ya.isNonSync = 0;
                }
              } else if (c && pt - bt < gt - Wt && re / gt < 0.025 && U[0].cts === 0) {
                I.logger.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
                for (var Un = $, wt = 0, Ea = U.length; wt < Ea; wt++) {
                  var _a = Un + U[wt].duration, Ou = Un + U[wt].cts;
                  if (wt < Ea - 1) {
                    var Cu = _a + U[wt + 1].cts;
                    U[wt].duration = Cu - Ou;
                  } else
                    U[wt].duration = wt ? U[wt - 1].duration : re;
                  U[wt].cts = 0, Un = _a;
                }
              }
            }
            console.assert(H !== null, "mp4SampleDuration must be computed"), H = nt || !H ? re : H, this.nextAvcDts = W = Y + H, this.videoSampleDuration = H, this.isVideoContiguous = !0;
            var Pu = N.default.moof(h.sequenceNumber++, $, w({}, h, {
              samples: U
            })), Ru = "video", Mu = {
              data1: Pu,
              data2: Ke,
              startPTS: z / F,
              endPTS: (X + H) / F,
              startDTS: $ / F,
              endDTS: W / F,
              type: Ru,
              hasAudio: !1,
              hasVideo: !0,
              nb: U.length,
              dropped: h.dropped
            };
            return h.samples = [], h.dropped = 0, console.assert(Ke.length, "MDAT length must not be zero"), Mu;
          }, _.remuxAudio = function(h, C, f, P, F) {
            var R = h.inputTimeScale, U = h.samplerate ? h.samplerate : R, K = R / U, V = h.segmentCodec === "aac" ? u : M, W = V * K, G = this._initPTS, H = h.segmentCodec === "mp3" && this.typeSupported.mpeg, $ = [], Y = F !== void 0, z = h.samples, X = H ? 0 : 8, Q = this.nextAudioPts || -1, q = C * R;
            if (this.isAudioContiguous = f = f || z.length && Q > 0 && (P && Math.abs(q - Q) < 9e3 || Math.abs(g(z[0].pts - G, q) - Q) < 20 * W), z.forEach(function(Lt) {
              Lt.pts = g(Lt.pts - G, q);
            }), !f || Q < 0) {
              if (z = z.filter(function(Lt) {
                return Lt.pts >= 0;
              }), !z.length)
                return;
              F === 0 ? Q = 0 : P && !Y ? Q = Math.max(0, q) : Q = z[0].pts;
            }
            if (h.segmentCodec === "aac")
              for (var Z = this.config.maxAudioFramesDrift, J = 0, te = Q; J < z.length; J++) {
                var ne = z[J], re = ne.pts, ee = re - te, le = Math.abs(1e3 * ee / R);
                if (ee <= -Z * W && Y)
                  J === 0 && (I.logger.warn("Audio frame @ " + (re / R).toFixed(3) + "s overlaps nextAudioPts by " + Math.round(1e3 * ee / R) + " ms."), this.nextAudioPts = Q = te = re);
                else if (ee >= Z * W && le < O && Y) {
                  var pe = Math.round(ee / W);
                  te = re - pe * W, te < 0 && (pe--, te += W), J === 0 && (this.nextAudioPts = Q = te), I.logger.warn("[mp4-remuxer]: Injecting " + pe + " audio frame @ " + (te / R).toFixed(3) + "s due to " + Math.round(1e3 * ee / R) + " ms gap.");
                  for (var ie = 0; ie < pe; ie++) {
                    var ce = Math.max(te, 0), se = y.default.getSilentFrame(h.manifestCodec || h.codec, h.channelCount);
                    se || (I.logger.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead."), se = ne.unit.subarray()), z.splice(J, 0, {
                      unit: se,
                      pts: ce
                    }), te += W, J++;
                  }
                }
                ne.pts = te, te += W;
              }
            for (var he = null, ae = null, Ee, ue = 0, Le = z.length; Le--; )
              ue += z[Le].unit.byteLength;
            for (var Ae = 0, Re = z.length; Ae < Re; Ae++) {
              var Ke = z[Ae], Nt = Ke.unit, nt = Ke.pts;
              if (ae !== null) {
                var Wt = $[Ae - 1];
                Wt.duration = Math.round((nt - ae) / K);
              } else if (f && h.segmentCodec === "aac" && (nt = Q), he = nt, ue > 0) {
                ue += X;
                try {
                  Ee = new Uint8Array(ue);
                } catch {
                  this.observer.emit(E.Events.ERROR, E.Events.ERROR, {
                    type: B.ErrorTypes.MUX_ERROR,
                    details: B.ErrorDetails.REMUX_ALLOC_ERROR,
                    fatal: !1,
                    bytes: ue,
                    reason: "fail allocating audio mdat " + ue
                  });
                  return;
                }
                if (!H) {
                  var bt = new DataView(Ee.buffer);
                  bt.setUint32(0, ue), Ee.set(N.default.types.mdat, 4);
                }
              } else
                return;
              Ee.set(Nt, X);
              var gt = Nt.byteLength;
              X += gt, $.push(new p(!0, V, gt, 0)), ae = nt;
            }
            var pt = $.length;
            if (!!pt) {
              var tt = $[$.length - 1];
              this.nextAudioPts = Q = ae + K * tt.duration;
              var Xe = H ? new Uint8Array(0) : N.default.moof(h.sequenceNumber++, he / K, w({}, h, {
                samples: $
              }));
              h.samples = [];
              var yt = he / R, At = Q / R, Ve = "audio", Bt = {
                data1: Xe,
                data2: Ee,
                startPTS: yt,
                endPTS: At,
                startDTS: yt,
                endDTS: At,
                type: Ve,
                hasAudio: !0,
                hasVideo: !1,
                nb: pt
              };
              return this.isAudioContiguous = !0, console.assert(Ee.length, "MDAT length must not be zero"), Bt;
            }
          }, _.remuxEmptyAudio = function(h, C, f, P) {
            var F = h.inputTimeScale, R = h.samplerate ? h.samplerate : F, U = F / R, K = this.nextAudioPts, V = (K !== null ? K : P.startDTS * F) + this._initDTS, W = P.endDTS * F + this._initDTS, G = U * u, H = Math.ceil((W - V) / G), $ = y.default.getSilentFrame(h.manifestCodec || h.codec, h.channelCount);
            if (I.logger.warn("[mp4-remuxer]: remux empty Audio"), !$) {
              I.logger.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
              return;
            }
            for (var Y = [], z = 0; z < H; z++) {
              var X = V + z * G;
              Y.push({
                unit: $,
                pts: X,
                dts: X
              });
            }
            return h.samples = Y, this.remuxAudio(h, C, f, !1);
          }, k;
        }();
        function g(k, _) {
          var S;
          if (_ === null)
            return k;
          for (_ < k ? S = -8589934592 : S = 8589934592; Math.abs(k - _) > 4294967296; )
            k += S;
          return k;
        }
        function m(k) {
          for (var _ = 0; _ < k.length; _++)
            if (k[_].key)
              return _;
          return -1;
        }
        function D(k, _, S, h) {
          var C = k.samples.length;
          if (!!C) {
            for (var f = k.inputTimeScale, P = 0; P < C; P++) {
              var F = k.samples[P];
              F.pts = g(F.pts - S, _ * f) / f, F.dts = g(F.dts - h, _ * f) / f;
            }
            var R = k.samples;
            return k.samples = [], {
              samples: R
            };
          }
        }
        function L(k, _, S) {
          var h = k.samples.length;
          if (!!h) {
            for (var C = k.inputTimeScale, f = 0; f < h; f++) {
              var P = k.samples[f];
              P.pts = g(P.pts - S, _ * C) / C;
            }
            k.samples.sort(function(R, U) {
              return R.pts - U.pts;
            });
            var F = k.samples;
            return k.samples = [], {
              samples: F
            };
          }
        }
        var p = function(_, S, h, C) {
          this.size = void 0, this.duration = void 0, this.cts = void 0, this.flags = void 0, this.duration = S, this.size = h, this.cts = C, this.flags = new x(_);
        }, x = function(_) {
          this.isLeading = 0, this.isDependedOn = 0, this.hasRedundancy = 0, this.degradPrio = 0, this.dependsOn = 1, this.isNonSync = 1, this.dependsOn = _ ? 2 : 1, this.isNonSync = _ ? 0 : 1;
        };
      },
      "./src/remux/passthrough-remuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => A
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/remux/mp4-remuxer.ts"), N = a("./src/utils/mp4-tools.ts"), E = a("./src/loader/fragment.ts"), B = a("./src/utils/logger.ts"), I = /* @__PURE__ */ function() {
          function w() {
            this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = void 0, this.initTracks = void 0, this.lastEndTime = null;
          }
          var O = w.prototype;
          return O.destroy = function() {
          }, O.resetTimeStamp = function(M) {
            this.initPTS = M, this.lastEndTime = null;
          }, O.resetNextTimestamp = function() {
            this.lastEndTime = null;
          }, O.resetInitSegment = function(M, d, c, v) {
            this.audioCodec = d, this.videoCodec = c, this.generateInitSegment((0, N.patchEncyptionData)(M, v)), this.emitInitSegment = !0;
          }, O.generateInitSegment = function(M) {
            var d = this.audioCodec, c = this.videoCodec;
            if (!M || !M.byteLength) {
              this.initTracks = void 0, this.initData = void 0;
              return;
            }
            var v = this.initData = (0, N.parseInitSegment)(M);
            d || (d = T(v.audio, E.ElementaryStreamTypes.AUDIO)), c || (c = T(v.video, E.ElementaryStreamTypes.VIDEO));
            var g = {};
            v.audio && v.video ? g.audiovideo = {
              container: "video/mp4",
              codec: d + "," + c,
              initSegment: M,
              id: "main"
            } : v.audio ? g.audio = {
              container: "audio/mp4",
              codec: d,
              initSegment: M,
              id: "audio"
            } : v.video ? g.video = {
              container: "video/mp4",
              codec: c,
              initSegment: M,
              id: "main"
            } : B.logger.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes."), this.initTracks = g;
          }, O.remux = function(M, d, c, v, g) {
            var m, D = this.initPTS, L = this.lastEndTime, p = {
              audio: void 0,
              video: void 0,
              text: v,
              id3: c,
              initSegment: void 0
            };
            (0, b.isFiniteNumber)(L) || (L = this.lastEndTime = g || 0);
            var x = d.samples;
            if (!x || !x.length)
              return p;
            var k = {
              initPTS: void 0,
              timescale: 1
            }, _ = this.initData;
            if ((!_ || !_.length) && (this.generateInitSegment(x), _ = this.initData), !_ || !_.length)
              return B.logger.warn("[passthrough-remuxer.ts]: Failed to generate initSegment."), p;
            this.emitInitSegment && (k.tracks = this.initTracks, this.emitInitSegment = !1);
            var S = (0, N.getStartDTS)(_, x);
            (0, b.isFiniteNumber)(D) || (this.initPTS = k.initPTS = D = S - g);
            var h = (0, N.getDuration)(x, _), C = M ? S - D : L, f = C + h;
            (0, N.offsetStartDTS)(_, x, D), h > 0 ? this.lastEndTime = f : (B.logger.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
            var P = !!_.audio, F = !!_.video, R = "";
            P && (R += "audio"), F && (R += "video");
            var U = {
              data1: x,
              startPTS: C,
              startDTS: C,
              endPTS: f,
              endDTS: f,
              type: R,
              hasAudio: P,
              hasVideo: F,
              nb: 1,
              dropped: 0
            };
            p.audio = U.type === "audio" ? U : void 0, p.video = U.type !== "audio" ? U : void 0, p.initSegment = k;
            var K = (m = this.initPTS) != null ? m : 0;
            return p.id3 = (0, y.flushTextTrackMetadataCueSamples)(c, g, K, K), v.samples.length && (p.text = (0, y.flushTextTrackUserdataCueSamples)(v, g, K)), p;
          }, w;
        }();
        function T(w, O) {
          var u = w == null ? void 0 : w.codec;
          return u && u.length > 4 ? u : u === "hvc1" || u === "hev1" ? "hvc1.1.c.L120.90" : u === "av01" ? "av01.0.04M.08" : u === "avc1" || O === E.ElementaryStreamTypes.VIDEO ? "avc1.42e01e" : "mp4a.40.5";
        }
        const A = I;
      },
      "./src/task-loop.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => b
        });
        var b = /* @__PURE__ */ function() {
          function y() {
            this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
          }
          var N = y.prototype;
          return N.destroy = function() {
            this.onHandlerDestroying(), this.onHandlerDestroyed();
          }, N.onHandlerDestroying = function() {
            this.clearNextTick(), this.clearInterval();
          }, N.onHandlerDestroyed = function() {
          }, N.hasInterval = function() {
            return !!this._tickInterval;
          }, N.hasNextTick = function() {
            return !!this._tickTimer;
          }, N.setInterval = function(B) {
            return this._tickInterval ? !1 : (this._tickInterval = self.setInterval(this._boundTick, B), !0);
          }, N.clearInterval = function() {
            return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
          }, N.clearNextTick = function() {
            return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
          }, N.tick = function() {
            this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
          }, N.tickImmediate = function() {
            this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
          }, N.doTick = function() {
          }, y;
        }();
      },
      "./src/types/cmcd.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          CMCDObjectType: () => y,
          CMCDStreamType: () => E,
          CMCDStreamingFormat: () => N,
          CMCDVersion: () => b
        });
        var b = 1, y;
        (function(B) {
          B.MANIFEST = "m", B.AUDIO = "a", B.VIDEO = "v", B.MUXED = "av", B.INIT = "i", B.CAPTION = "c", B.TIMED_TEXT = "tt", B.KEY = "k", B.OTHER = "o";
        })(y || (y = {}));
        var N;
        (function(B) {
          B.DASH = "d", B.HLS = "h", B.SMOOTH = "s", B.OTHER = "o";
        })(N || (N = {}));
        var E;
        (function(B) {
          B.VOD = "v", B.LIVE = "l";
        })(E || (E = {}));
      },
      "./src/types/demuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          MetadataSchema: () => b
        });
        var b;
        (function(y) {
          y.audioId3 = "org.id3", y.dateRange = "com.apple.quicktime.HLS", y.emsg = "https://aomedia.org/emsg/ID3";
        })(b || (b = {}));
      },
      "./src/types/level.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          HdcpLevels: () => B,
          HlsSkip: () => I,
          HlsUrlParameters: () => A,
          Level: () => w,
          getSkipValue: () => T
        });
        function b(O, u) {
          for (var M = 0; M < u.length; M++) {
            var d = u[M];
            d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(O, N(d.key), d);
          }
        }
        function y(O, u, M) {
          return u && b(O.prototype, u), M && b(O, M), Object.defineProperty(O, "prototype", { writable: !1 }), O;
        }
        function N(O) {
          var u = E(O, "string");
          return typeof u == "symbol" ? u : String(u);
        }
        function E(O, u) {
          if (typeof O != "object" || O === null)
            return O;
          var M = O[Symbol.toPrimitive];
          if (M !== void 0) {
            var d = M.call(O, u || "default");
            if (typeof d != "object")
              return d;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (u === "string" ? String : Number)(O);
        }
        var B = ["NONE", "TYPE-0", "TYPE-1", "TYPE-2", null], I;
        (function(O) {
          O.No = "", O.Yes = "YES", O.v2 = "v2";
        })(I || (I = {}));
        function T(O, u) {
          var M = O.canSkipUntil, d = O.canSkipDateRanges, c = O.endSN, v = u !== void 0 ? u - c : 0;
          return M && v < M ? d ? I.v2 : I.Yes : I.No;
        }
        var A = /* @__PURE__ */ function() {
          function O(M, d, c) {
            this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = M, this.part = d, this.skip = c;
          }
          var u = O.prototype;
          return u.addDirectives = function(d) {
            var c = new self.URL(d);
            return this.msn !== void 0 && c.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && c.searchParams.set("_HLS_part", this.part.toString()), this.skip && c.searchParams.set("_HLS_skip", this.skip), c.href;
          }, O;
        }(), w = /* @__PURE__ */ function() {
          function O(u) {
            this.attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.videoCodec = void 0, this.width = void 0, this.unknownCodecs = void 0, this.audioGroupIds = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.textGroupIds = void 0, this.url = void 0, this._urlId = 0, this.url = [u.url], this.attrs = u.attrs, this.bitrate = u.bitrate, u.details && (this.details = u.details), this.id = u.id || 0, this.name = u.name, this.width = u.width || 0, this.height = u.height || 0, this.audioCodec = u.audioCodec, this.videoCodec = u.videoCodec, this.unknownCodecs = u.unknownCodecs, this.codecSet = [u.videoCodec, u.audioCodec].filter(function(M) {
              return M;
            }).join(",").replace(/\.[^.,]+/g, "");
          }
          return y(O, [{
            key: "maxBitrate",
            get: function() {
              return Math.max(this.realBitrate, this.bitrate);
            }
          }, {
            key: "uri",
            get: function() {
              return this.url[this._urlId] || "";
            }
          }, {
            key: "urlId",
            get: function() {
              return this._urlId;
            },
            set: function(M) {
              var d = M % this.url.length;
              this._urlId !== d && (this.details = void 0, this._urlId = d);
            }
          }]), O;
        }();
      },
      "./src/types/loader.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          PlaylistContextType: () => b,
          PlaylistLevelType: () => y
        });
        var b;
        (function(N) {
          N.MANIFEST = "manifest", N.LEVEL = "level", N.AUDIO_TRACK = "audioTrack", N.SUBTITLE_TRACK = "subtitleTrack";
        })(b || (b = {}));
        var y;
        (function(N) {
          N.MAIN = "main", N.AUDIO = "audio", N.SUBTITLE = "subtitle";
        })(y || (y = {}));
      },
      "./src/types/transmuxer.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          ChunkMetadata: () => b
        });
        var b = function(E, B, I, T, A, w) {
          T === void 0 && (T = 0), A === void 0 && (A = -1), w === void 0 && (w = !1), this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = y(), this.buffering = {
            audio: y(),
            video: y(),
            audiovideo: y()
          }, this.level = E, this.sn = B, this.id = I, this.size = T, this.part = A, this.partial = w;
        };
        function y() {
          return {
            start: 0,
            executeStart: 0,
            executeEnd: 0,
            end: 0
          };
        }
      },
      "./src/utils/attr-list.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          AttrList: () => N
        });
        var b = /^(\d+)x(\d+)$/, y = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g, N = /* @__PURE__ */ function() {
          function E(I) {
            typeof I == "string" && (I = E.parseAttrList(I));
            for (var T in I)
              I.hasOwnProperty(T) && (this[T] = I[T]);
          }
          var B = E.prototype;
          return B.decimalInteger = function(T) {
            var A = parseInt(this[T], 10);
            return A > Number.MAX_SAFE_INTEGER ? 1 / 0 : A;
          }, B.hexadecimalInteger = function(T) {
            if (this[T]) {
              var A = (this[T] || "0x").slice(2);
              A = (A.length & 1 ? "0" : "") + A;
              for (var w = new Uint8Array(A.length / 2), O = 0; O < A.length / 2; O++)
                w[O] = parseInt(A.slice(O * 2, O * 2 + 2), 16);
              return w;
            } else
              return null;
          }, B.hexadecimalIntegerAsNumber = function(T) {
            var A = parseInt(this[T], 16);
            return A > Number.MAX_SAFE_INTEGER ? 1 / 0 : A;
          }, B.decimalFloatingPoint = function(T) {
            return parseFloat(this[T]);
          }, B.optionalFloat = function(T, A) {
            var w = this[T];
            return w ? parseFloat(w) : A;
          }, B.enumeratedString = function(T) {
            return this[T];
          }, B.bool = function(T) {
            return this[T] === "YES";
          }, B.decimalResolution = function(T) {
            var A = b.exec(this[T]);
            if (A !== null)
              return {
                width: parseInt(A[1], 10),
                height: parseInt(A[2], 10)
              };
          }, E.parseAttrList = function(T) {
            var A, w = {}, O = '"';
            for (y.lastIndex = 0; (A = y.exec(T)) !== null; ) {
              var u = A[2];
              u.indexOf(O) === 0 && u.lastIndexOf(O) === u.length - 1 && (u = u.slice(1, -1)), w[A[1]] = u;
            }
            return w;
          }, E;
        }();
      },
      "./src/utils/binary-search.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => y
        });
        var b = {
          search: function(E, B) {
            for (var I = 0, T = E.length - 1, A = null, w = null; I <= T; ) {
              A = (I + T) / 2 | 0, w = E[A];
              var O = B(w);
              if (O > 0)
                I = A + 1;
              else if (O < 0)
                T = A - 1;
              else
                return w;
            }
            return null;
          }
        };
        const y = b;
      },
      "./src/utils/buffer-helper.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          BufferHelper: () => N
        });
        var b = a("./src/utils/logger.ts"), y = {
          length: 0,
          start: function() {
            return 0;
          },
          end: function() {
            return 0;
          }
        }, N = /* @__PURE__ */ function() {
          function E() {
          }
          return E.isBuffered = function(I, T) {
            try {
              if (I) {
                for (var A = E.getBuffered(I), w = 0; w < A.length; w++)
                  if (T >= A.start(w) && T <= A.end(w))
                    return !0;
              }
            } catch {
            }
            return !1;
          }, E.bufferInfo = function(I, T, A) {
            try {
              if (I) {
                var w = E.getBuffered(I), O = [], u;
                for (u = 0; u < w.length; u++)
                  O.push({
                    start: w.start(u),
                    end: w.end(u)
                  });
                return this.bufferedInfo(O, T, A);
              }
            } catch {
            }
            return {
              len: 0,
              start: T,
              end: T,
              nextStart: void 0
            };
          }, E.bufferedInfo = function(I, T, A) {
            T = Math.max(0, T), I.sort(function(p, x) {
              var k = p.start - x.start;
              return k || x.end - p.end;
            });
            var w = [];
            if (A)
              for (var O = 0; O < I.length; O++) {
                var u = w.length;
                if (u) {
                  var M = w[u - 1].end;
                  I[O].start - M < A ? I[O].end > M && (w[u - 1].end = I[O].end) : w.push(I[O]);
                } else
                  w.push(I[O]);
              }
            else
              w = I;
            for (var d = 0, c, v = T, g = T, m = 0; m < w.length; m++) {
              var D = w[m].start, L = w[m].end;
              if (T + A >= D && T < L)
                v = D, g = L, d = g - T;
              else if (T + A < D) {
                c = D;
                break;
              }
            }
            return {
              len: d,
              start: v || 0,
              end: g || 0,
              nextStart: c
            };
          }, E.getBuffered = function(I) {
            try {
              return I.buffered;
            } catch (T) {
              return b.logger.log("failed to get media.buffered", T), y;
            }
          }, E;
        }();
      },
      "./src/utils/cea-608-parser.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          CaptionScreen: () => m,
          Row: () => g,
          default: () => _
        });
        var b = a("./src/utils/logger.ts"), y = {
          42: 225,
          92: 233,
          94: 237,
          95: 243,
          96: 250,
          123: 231,
          124: 247,
          125: 209,
          126: 241,
          127: 9608,
          128: 174,
          129: 176,
          130: 189,
          131: 191,
          132: 8482,
          133: 162,
          134: 163,
          135: 9834,
          136: 224,
          137: 32,
          138: 232,
          139: 226,
          140: 234,
          141: 238,
          142: 244,
          143: 251,
          144: 193,
          145: 201,
          146: 211,
          147: 218,
          148: 220,
          149: 252,
          150: 8216,
          151: 161,
          152: 42,
          153: 8217,
          154: 9473,
          155: 169,
          156: 8480,
          157: 8226,
          158: 8220,
          159: 8221,
          160: 192,
          161: 194,
          162: 199,
          163: 200,
          164: 202,
          165: 203,
          166: 235,
          167: 206,
          168: 207,
          169: 239,
          170: 212,
          171: 217,
          172: 249,
          173: 219,
          174: 171,
          175: 187,
          176: 195,
          177: 227,
          178: 205,
          179: 204,
          180: 236,
          181: 210,
          182: 242,
          183: 213,
          184: 245,
          185: 123,
          186: 125,
          187: 92,
          188: 94,
          189: 95,
          190: 124,
          191: 8764,
          192: 196,
          193: 228,
          194: 214,
          195: 246,
          196: 223,
          197: 165,
          198: 164,
          199: 9475,
          200: 197,
          201: 229,
          202: 216,
          203: 248,
          204: 9487,
          205: 9491,
          206: 9495,
          207: 9499
        }, N = function(h) {
          var C = h;
          return y.hasOwnProperty(h) && (C = y[h]), String.fromCharCode(C);
        }, E = 15, B = 100, I = {
          17: 1,
          18: 3,
          21: 5,
          22: 7,
          23: 9,
          16: 11,
          19: 12,
          20: 14
        }, T = {
          17: 2,
          18: 4,
          21: 6,
          22: 8,
          23: 10,
          19: 13,
          20: 15
        }, A = {
          25: 1,
          26: 3,
          29: 5,
          30: 7,
          31: 9,
          24: 11,
          27: 12,
          28: 14
        }, w = {
          25: 2,
          26: 4,
          29: 6,
          30: 8,
          31: 10,
          27: 13,
          28: 15
        }, O = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"], u;
        (function(S) {
          S[S.ERROR = 0] = "ERROR", S[S.TEXT = 1] = "TEXT", S[S.WARNING = 2] = "WARNING", S[S.INFO = 2] = "INFO", S[S.DEBUG = 3] = "DEBUG", S[S.DATA = 3] = "DATA";
        })(u || (u = {}));
        var M = /* @__PURE__ */ function() {
          function S() {
            this.time = null, this.verboseLevel = u.ERROR;
          }
          var h = S.prototype;
          return h.log = function(f, P) {
            if (this.verboseLevel >= f) {
              var F = typeof P == "function" ? P() : P;
              b.logger.log(this.time + " [" + f + "] " + F);
            }
          }, S;
        }(), d = function(h) {
          for (var C = [], f = 0; f < h.length; f++)
            C.push(h[f].toString(16));
          return C;
        }, c = /* @__PURE__ */ function() {
          function S(C, f, P, F, R) {
            this.foreground = void 0, this.underline = void 0, this.italics = void 0, this.background = void 0, this.flash = void 0, this.foreground = C || "white", this.underline = f || !1, this.italics = P || !1, this.background = F || "black", this.flash = R || !1;
          }
          var h = S.prototype;
          return h.reset = function() {
            this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
          }, h.setStyles = function(f) {
            for (var P = ["foreground", "underline", "italics", "background", "flash"], F = 0; F < P.length; F++) {
              var R = P[F];
              f.hasOwnProperty(R) && (this[R] = f[R]);
            }
          }, h.isDefault = function() {
            return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
          }, h.equals = function(f) {
            return this.foreground === f.foreground && this.underline === f.underline && this.italics === f.italics && this.background === f.background && this.flash === f.flash;
          }, h.copy = function(f) {
            this.foreground = f.foreground, this.underline = f.underline, this.italics = f.italics, this.background = f.background, this.flash = f.flash;
          }, h.toString = function() {
            return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
          }, S;
        }(), v = /* @__PURE__ */ function() {
          function S(C, f, P, F, R, U) {
            this.uchar = void 0, this.penState = void 0, this.uchar = C || " ", this.penState = new c(f, P, F, R, U);
          }
          var h = S.prototype;
          return h.reset = function() {
            this.uchar = " ", this.penState.reset();
          }, h.setChar = function(f, P) {
            this.uchar = f, this.penState.copy(P);
          }, h.setPenState = function(f) {
            this.penState.copy(f);
          }, h.equals = function(f) {
            return this.uchar === f.uchar && this.penState.equals(f.penState);
          }, h.copy = function(f) {
            this.uchar = f.uchar, this.penState.copy(f.penState);
          }, h.isEmpty = function() {
            return this.uchar === " " && this.penState.isDefault();
          }, S;
        }(), g = /* @__PURE__ */ function() {
          function S(C) {
            this.chars = void 0, this.pos = void 0, this.currPenState = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chars = [];
            for (var f = 0; f < B; f++)
              this.chars.push(new v());
            this.logger = C, this.pos = 0, this.currPenState = new c();
          }
          var h = S.prototype;
          return h.equals = function(f) {
            for (var P = !0, F = 0; F < B; F++)
              if (!this.chars[F].equals(f.chars[F])) {
                P = !1;
                break;
              }
            return P;
          }, h.copy = function(f) {
            for (var P = 0; P < B; P++)
              this.chars[P].copy(f.chars[P]);
          }, h.isEmpty = function() {
            for (var f = !0, P = 0; P < B; P++)
              if (!this.chars[P].isEmpty()) {
                f = !1;
                break;
              }
            return f;
          }, h.setCursor = function(f) {
            this.pos !== f && (this.pos = f), this.pos < 0 ? (this.logger.log(u.DEBUG, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > B && (this.logger.log(u.DEBUG, "Too large cursor position " + this.pos), this.pos = B);
          }, h.moveCursor = function(f) {
            var P = this.pos + f;
            if (f > 1)
              for (var F = this.pos + 1; F < P + 1; F++)
                this.chars[F].setPenState(this.currPenState);
            this.setCursor(P);
          }, h.backSpace = function() {
            this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
          }, h.insertChar = function(f) {
            var P = this;
            f >= 144 && this.backSpace();
            var F = N(f);
            if (this.pos >= B) {
              this.logger.log(u.ERROR, function() {
                return "Cannot insert " + f.toString(16) + " (" + F + ") at position " + P.pos + ". Skipping it!";
              });
              return;
            }
            this.chars[this.pos].setChar(F, this.currPenState), this.moveCursor(1);
          }, h.clearFromPos = function(f) {
            var P;
            for (P = f; P < B; P++)
              this.chars[P].reset();
          }, h.clear = function() {
            this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
          }, h.clearToEndOfRow = function() {
            this.clearFromPos(this.pos);
          }, h.getTextString = function() {
            for (var f = [], P = !0, F = 0; F < B; F++) {
              var R = this.chars[F].uchar;
              R !== " " && (P = !1), f.push(R);
            }
            return P ? "" : f.join("");
          }, h.setPenStyles = function(f) {
            this.currPenState.setStyles(f);
            var P = this.chars[this.pos];
            P.setPenState(this.currPenState);
          }, S;
        }(), m = /* @__PURE__ */ function() {
          function S(C) {
            this.rows = void 0, this.currRow = void 0, this.nrRollUpRows = void 0, this.lastOutputScreen = void 0, this.logger = void 0, this.rows = [];
            for (var f = 0; f < E; f++)
              this.rows.push(new g(C));
            this.logger = C, this.currRow = E - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.reset();
          }
          var h = S.prototype;
          return h.reset = function() {
            for (var f = 0; f < E; f++)
              this.rows[f].clear();
            this.currRow = E - 1;
          }, h.equals = function(f) {
            for (var P = !0, F = 0; F < E; F++)
              if (!this.rows[F].equals(f.rows[F])) {
                P = !1;
                break;
              }
            return P;
          }, h.copy = function(f) {
            for (var P = 0; P < E; P++)
              this.rows[P].copy(f.rows[P]);
          }, h.isEmpty = function() {
            for (var f = !0, P = 0; P < E; P++)
              if (!this.rows[P].isEmpty()) {
                f = !1;
                break;
              }
            return f;
          }, h.backSpace = function() {
            var f = this.rows[this.currRow];
            f.backSpace();
          }, h.clearToEndOfRow = function() {
            var f = this.rows[this.currRow];
            f.clearToEndOfRow();
          }, h.insertChar = function(f) {
            var P = this.rows[this.currRow];
            P.insertChar(f);
          }, h.setPen = function(f) {
            var P = this.rows[this.currRow];
            P.setPenStyles(f);
          }, h.moveCursor = function(f) {
            var P = this.rows[this.currRow];
            P.moveCursor(f);
          }, h.setCursor = function(f) {
            this.logger.log(u.INFO, "setCursor: " + f);
            var P = this.rows[this.currRow];
            P.setCursor(f);
          }, h.setPAC = function(f) {
            this.logger.log(u.INFO, function() {
              return "pacData = " + JSON.stringify(f);
            });
            var P = f.row - 1;
            if (this.nrRollUpRows && P < this.nrRollUpRows - 1 && (P = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== P) {
              for (var F = 0; F < E; F++)
                this.rows[F].clear();
              var R = this.currRow + 1 - this.nrRollUpRows, U = this.lastOutputScreen;
              if (U) {
                var K = U.rows[R].cueStartTime, V = this.logger.time;
                if (K && V !== null && K < V)
                  for (var W = 0; W < this.nrRollUpRows; W++)
                    this.rows[P - this.nrRollUpRows + W + 1].copy(U.rows[R + W]);
              }
            }
            this.currRow = P;
            var G = this.rows[this.currRow];
            if (f.indent !== null) {
              var H = f.indent, $ = Math.max(H - 1, 0);
              G.setCursor(f.indent), f.color = G.chars[$].penState.foreground;
            }
            var Y = {
              foreground: f.color,
              underline: f.underline,
              italics: f.italics,
              background: "black",
              flash: !1
            };
            this.setPen(Y);
          }, h.setBkgData = function(f) {
            this.logger.log(u.INFO, function() {
              return "bkgData = " + JSON.stringify(f);
            }), this.backSpace(), this.setPen(f), this.insertChar(32);
          }, h.setRollUpRows = function(f) {
            this.nrRollUpRows = f;
          }, h.rollUp = function() {
            var f = this;
            if (this.nrRollUpRows === null) {
              this.logger.log(u.DEBUG, "roll_up but nrRollUpRows not set yet");
              return;
            }
            this.logger.log(u.TEXT, function() {
              return f.getDisplayText();
            });
            var P = this.currRow + 1 - this.nrRollUpRows, F = this.rows.splice(P, 1)[0];
            F.clear(), this.rows.splice(this.currRow, 0, F), this.logger.log(u.INFO, "Rolling up");
          }, h.getDisplayText = function(f) {
            f = f || !1;
            for (var P = [], F = "", R = -1, U = 0; U < E; U++) {
              var K = this.rows[U].getTextString();
              K && (R = U + 1, f ? P.push("Row " + R + ": '" + K + "'") : P.push(K.trim()));
            }
            return P.length > 0 && (f ? F = "[" + P.join(" | ") + "]" : F = P.join(`
`)), F;
          }, h.getTextAndFormat = function() {
            return this.rows;
          }, S;
        }(), D = /* @__PURE__ */ function() {
          function S(C, f, P) {
            this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = C, this.outputFilter = f, this.mode = null, this.verbose = 0, this.displayedMemory = new m(P), this.nonDisplayedMemory = new m(P), this.lastOutputScreen = new m(P), this.currRollUpRow = this.displayedMemory.rows[E - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = P;
          }
          var h = S.prototype;
          return h.reset = function() {
            this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[E - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
          }, h.getHandler = function() {
            return this.outputFilter;
          }, h.setHandler = function(f) {
            this.outputFilter = f;
          }, h.setPAC = function(f) {
            this.writeScreen.setPAC(f);
          }, h.setBkgData = function(f) {
            this.writeScreen.setBkgData(f);
          }, h.setMode = function(f) {
            f !== this.mode && (this.mode = f, this.logger.log(u.INFO, function() {
              return "MODE=" + f;
            }), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = f);
          }, h.insertChars = function(f) {
            for (var P = this, F = 0; F < f.length; F++)
              this.writeScreen.insertChar(f[F]);
            var R = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
            this.logger.log(u.INFO, function() {
              return R + ": " + P.writeScreen.getDisplayText(!0);
            }), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(u.TEXT, function() {
              return "DISPLAYED: " + P.displayedMemory.getDisplayText(!0);
            }), this.outputDataUpdate());
          }, h.ccRCL = function() {
            this.logger.log(u.INFO, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
          }, h.ccBS = function() {
            this.logger.log(u.INFO, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
          }, h.ccAOF = function() {
          }, h.ccAON = function() {
          }, h.ccDER = function() {
            this.logger.log(u.INFO, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
          }, h.ccRU = function(f) {
            this.logger.log(u.INFO, "RU(" + f + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(f);
          }, h.ccFON = function() {
            this.logger.log(u.INFO, "FON - Flash On"), this.writeScreen.setPen({
              flash: !0
            });
          }, h.ccRDC = function() {
            this.logger.log(u.INFO, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
          }, h.ccTR = function() {
            this.logger.log(u.INFO, "TR"), this.setMode("MODE_TEXT");
          }, h.ccRTD = function() {
            this.logger.log(u.INFO, "RTD"), this.setMode("MODE_TEXT");
          }, h.ccEDM = function() {
            this.logger.log(u.INFO, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
          }, h.ccCR = function() {
            this.logger.log(u.INFO, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
          }, h.ccENM = function() {
            this.logger.log(u.INFO, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
          }, h.ccEOC = function() {
            var f = this;
            if (this.logger.log(u.INFO, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
              var P = this.displayedMemory;
              this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = P, this.writeScreen = this.nonDisplayedMemory, this.logger.log(u.TEXT, function() {
                return "DISP: " + f.displayedMemory.getDisplayText();
              });
            }
            this.outputDataUpdate(!0);
          }, h.ccTO = function(f) {
            this.logger.log(u.INFO, "TO(" + f + ") - Tab Offset"), this.writeScreen.moveCursor(f);
          }, h.ccMIDROW = function(f) {
            var P = {
              flash: !1
            };
            if (P.underline = f % 2 === 1, P.italics = f >= 46, P.italics)
              P.foreground = "white";
            else {
              var F = Math.floor(f / 2) - 16, R = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
              P.foreground = R[F];
            }
            this.logger.log(u.INFO, "MIDROW: " + JSON.stringify(P)), this.writeScreen.setPen(P);
          }, h.outputDataUpdate = function(f) {
            f === void 0 && (f = !1);
            var P = this.logger.time;
            P !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = P : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, P, this.lastOutputScreen), f && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : P), this.lastOutputScreen.copy(this.displayedMemory));
          }, h.cueSplitAtTime = function(f) {
            this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, f, this.displayedMemory), this.cueStartTime = f));
          }, S;
        }(), L = /* @__PURE__ */ function() {
          function S(C, f, P) {
            this.channels = void 0, this.currentChannel = 0, this.cmdHistory = void 0, this.logger = void 0;
            var F = new M();
            this.channels = [null, new D(C, f, F), new D(C + 1, P, F)], this.cmdHistory = k(), this.logger = F;
          }
          var h = S.prototype;
          return h.getHandler = function(f) {
            return this.channels[f].getHandler();
          }, h.setHandler = function(f, P) {
            this.channels[f].setHandler(P);
          }, h.addData = function(f, P) {
            var F, R, U, K = !1;
            this.logger.time = f;
            for (var V = 0; V < P.length; V += 2)
              if (R = P[V] & 127, U = P[V + 1] & 127, !(R === 0 && U === 0)) {
                if (this.logger.log(u.DATA, "[" + d([P[V], P[V + 1]]) + "] -> (" + d([R, U]) + ")"), F = this.parseCmd(R, U), F || (F = this.parseMidrow(R, U)), F || (F = this.parsePAC(R, U)), F || (F = this.parseBackgroundAttributes(R, U)), !F && (K = this.parseChars(R, U), K)) {
                  var W = this.currentChannel;
                  if (W && W > 0) {
                    var G = this.channels[W];
                    G.insertChars(K);
                  } else
                    this.logger.log(u.WARNING, "No channel found yet. TEXT-MODE?");
                }
                !F && !K && this.logger.log(u.WARNING, "Couldn't parse cleaned data " + d([R, U]) + " orig: " + d([P[V], P[V + 1]]));
              }
          }, h.parseCmd = function(f, P) {
            var F = this.cmdHistory, R = (f === 20 || f === 28 || f === 21 || f === 29) && P >= 32 && P <= 47, U = (f === 23 || f === 31) && P >= 33 && P <= 35;
            if (!(R || U))
              return !1;
            if (x(f, P, F))
              return p(null, null, F), this.logger.log(u.DEBUG, "Repeated command (" + d([f, P]) + ") is dropped"), !0;
            var K = f === 20 || f === 21 || f === 23 ? 1 : 2, V = this.channels[K];
            return f === 20 || f === 21 || f === 28 || f === 29 ? P === 32 ? V.ccRCL() : P === 33 ? V.ccBS() : P === 34 ? V.ccAOF() : P === 35 ? V.ccAON() : P === 36 ? V.ccDER() : P === 37 ? V.ccRU(2) : P === 38 ? V.ccRU(3) : P === 39 ? V.ccRU(4) : P === 40 ? V.ccFON() : P === 41 ? V.ccRDC() : P === 42 ? V.ccTR() : P === 43 ? V.ccRTD() : P === 44 ? V.ccEDM() : P === 45 ? V.ccCR() : P === 46 ? V.ccENM() : P === 47 && V.ccEOC() : V.ccTO(P - 32), p(f, P, F), this.currentChannel = K, !0;
          }, h.parseMidrow = function(f, P) {
            var F = 0;
            if ((f === 17 || f === 25) && P >= 32 && P <= 47) {
              if (f === 17 ? F = 1 : F = 2, F !== this.currentChannel)
                return this.logger.log(u.ERROR, "Mismatch channel in midrow parsing"), !1;
              var R = this.channels[F];
              return R ? (R.ccMIDROW(P), this.logger.log(u.DEBUG, "MIDROW (" + d([f, P]) + ")"), !0) : !1;
            }
            return !1;
          }, h.parsePAC = function(f, P) {
            var F, R = this.cmdHistory, U = (f >= 17 && f <= 23 || f >= 25 && f <= 31) && P >= 64 && P <= 127, K = (f === 16 || f === 24) && P >= 64 && P <= 95;
            if (!(U || K))
              return !1;
            if (x(f, P, R))
              return p(null, null, R), !0;
            var V = f <= 23 ? 1 : 2;
            P >= 64 && P <= 95 ? F = V === 1 ? I[f] : A[f] : F = V === 1 ? T[f] : w[f];
            var W = this.channels[V];
            return W ? (W.setPAC(this.interpretPAC(F, P)), p(f, P, R), this.currentChannel = V, !0) : !1;
          }, h.interpretPAC = function(f, P) {
            var F, R = {
              color: null,
              italics: !1,
              indent: null,
              underline: !1,
              row: f
            };
            return P > 95 ? F = P - 96 : F = P - 64, R.underline = (F & 1) === 1, F <= 13 ? R.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(F / 2)] : F <= 15 ? (R.italics = !0, R.color = "white") : R.indent = Math.floor((F - 16) / 2) * 4, R;
          }, h.parseChars = function(f, P) {
            var F, R = null, U = null;
            if (f >= 25 ? (F = 2, U = f - 8) : (F = 1, U = f), U >= 17 && U <= 19) {
              var K;
              U === 17 ? K = P + 80 : U === 18 ? K = P + 112 : K = P + 144, this.logger.log(u.INFO, "Special char '" + N(K) + "' in channel " + F), R = [K];
            } else
              f >= 32 && f <= 127 && (R = P === 0 ? [f] : [f, P]);
            if (R) {
              var V = d(R);
              this.logger.log(u.DEBUG, "Char codes =  " + V.join(",")), p(f, P, this.cmdHistory);
            }
            return R;
          }, h.parseBackgroundAttributes = function(f, P) {
            var F = (f === 16 || f === 24) && P >= 32 && P <= 47, R = (f === 23 || f === 31) && P >= 45 && P <= 47;
            if (!(F || R))
              return !1;
            var U, K = {};
            f === 16 || f === 24 ? (U = Math.floor((P - 32) / 2), K.background = O[U], P % 2 === 1 && (K.background = K.background + "_semi")) : P === 45 ? K.background = "transparent" : (K.foreground = "black", P === 47 && (K.underline = !0));
            var V = f <= 23 ? 1 : 2, W = this.channels[V];
            return W.setBkgData(K), p(f, P, this.cmdHistory), !0;
          }, h.reset = function() {
            for (var f = 0; f < Object.keys(this.channels).length; f++) {
              var P = this.channels[f];
              P && P.reset();
            }
            this.cmdHistory = k();
          }, h.cueSplitAtTime = function(f) {
            for (var P = 0; P < this.channels.length; P++) {
              var F = this.channels[P];
              F && F.cueSplitAtTime(f);
            }
          }, S;
        }();
        function p(S, h, C) {
          C.a = S, C.b = h;
        }
        function x(S, h, C) {
          return C.a === S && C.b === h;
        }
        function k() {
          return {
            a: null,
            b: null
          };
        }
        const _ = L;
      },
      "./src/utils/codecs.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          isCodecSupportedInMp4: () => N,
          isCodecType: () => y
        });
        var b = {
          audio: {
            a3ds: !0,
            "ac-3": !0,
            "ac-4": !0,
            alac: !0,
            alaw: !0,
            dra1: !0,
            "dts+": !0,
            "dts-": !0,
            dtsc: !0,
            dtse: !0,
            dtsh: !0,
            "ec-3": !0,
            enca: !0,
            g719: !0,
            g726: !0,
            m4ae: !0,
            mha1: !0,
            mha2: !0,
            mhm1: !0,
            mhm2: !0,
            mlpa: !0,
            mp4a: !0,
            "raw ": !0,
            Opus: !0,
            opus: !0,
            samr: !0,
            sawb: !0,
            sawp: !0,
            sevc: !0,
            sqcp: !0,
            ssmv: !0,
            twos: !0,
            ulaw: !0
          },
          video: {
            avc1: !0,
            avc2: !0,
            avc3: !0,
            avc4: !0,
            avcp: !0,
            av01: !0,
            drac: !0,
            dva1: !0,
            dvav: !0,
            dvh1: !0,
            dvhe: !0,
            encv: !0,
            hev1: !0,
            hvc1: !0,
            mjp2: !0,
            mp4v: !0,
            mvc1: !0,
            mvc2: !0,
            mvc3: !0,
            mvc4: !0,
            resv: !0,
            rv60: !0,
            s263: !0,
            svc1: !0,
            svc2: !0,
            "vc-1": !0,
            vp08: !0,
            vp09: !0
          },
          text: {
            stpp: !0,
            wvtt: !0
          }
        };
        function y(E, B) {
          var I = b[B];
          return !!I && I[E.slice(0, 4)] === !0;
        }
        function N(E, B) {
          return MediaSource.isTypeSupported((B || "video") + '/mp4;codecs="' + E + '"');
        }
      },
      "./src/utils/cues.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => I
        });
        var b = a("./src/utils/vttparser.ts"), y = a("./src/utils/webvtt-parser.ts"), N = a("./src/utils/texttrack-utils.ts"), E = /\s/, B = {
          newCue: function(A, w, O, u) {
            for (var M = [], d, c, v, g, m, D = self.VTTCue || self.TextTrackCue, L = 0; L < u.rows.length; L++)
              if (d = u.rows[L], v = !0, g = 0, m = "", !d.isEmpty()) {
                for (var p = 0; p < d.chars.length; p++)
                  E.test(d.chars[p].uchar) && v ? g++ : (m += d.chars[p].uchar, v = !1);
                d.cueStartTime = w, w === O && (O += 1e-4), g >= 16 ? g-- : g++;
                var x = (0, b.fixLineBreaks)(m.trim()), k = (0, y.generateCueId)(w, O, x);
                (!A || !A.cues || !A.cues.getCueById(k)) && (c = new D(w, O, x), c.id = k, c.line = L + 1, c.align = "left", c.position = 10 + Math.min(80, Math.floor(g * 8 / 32) * 10), M.push(c));
              }
            return A && M.length && (M.sort(function(_, S) {
              return _.line === "auto" || S.line === "auto" ? 0 : _.line > 8 && S.line > 8 ? S.line - _.line : _.line - S.line;
            }), M.forEach(function(_) {
              return (0, N.addCueToTrack)(A, _);
            })), M;
          }
        };
        const I = B;
      },
      "./src/utils/discontinuities.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          adjustSlidingStart: () => A,
          alignMediaPlaylistByPDT: () => M,
          alignPDT: () => u,
          alignStream: () => w,
          findDiscontinuousReferenceFrag: () => I,
          findFirstFragWithCC: () => E,
          shouldAlignOnDiscontinuities: () => B
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/utils/logger.ts"), N = a("./src/controller/level-helper.ts");
        function E(d, c) {
          for (var v = null, g = 0, m = d.length; g < m; g++) {
            var D = d[g];
            if (D && D.cc === c) {
              v = D;
              break;
            }
          }
          return v;
        }
        function B(d, c, v) {
          return !!(c.details && (v.endCC > v.startCC || d && d.cc < v.startCC));
        }
        function I(d, c, v) {
          var g = d.fragments, m = c.fragments;
          if (!m.length || !g.length) {
            y.logger.log("No fragments to align");
            return;
          }
          var D = E(g, m[0].cc);
          if (!D || D && !D.startPTS) {
            y.logger.log("No frag in previous level to align on");
            return;
          }
          return D;
        }
        function T(d, c) {
          if (d) {
            var v = d.start + c;
            d.start = d.startPTS = v, d.endPTS = v + d.duration;
          }
        }
        function A(d, c) {
          for (var v = c.fragments, g = 0, m = v.length; g < m; g++)
            T(v[g], d);
          c.fragmentHint && T(c.fragmentHint, d), c.alignedSliding = !0;
        }
        function w(d, c, v) {
          !c || (O(d, v, c), !v.alignedSliding && c.details && u(v, c.details), !v.alignedSliding && c.details && !v.skippedSegments && (0, N.adjustSliding)(c.details, v));
        }
        function O(d, c, v) {
          if (B(d, v, c)) {
            var g = I(v.details, c);
            g && (0, b.isFiniteNumber)(g.start) && (y.logger.log("Adjusting PTS using last level due to CC increase within current level " + c.url), A(g.start, c));
          }
        }
        function u(d, c) {
          if (!(!c.fragments.length || !d.hasProgramDateTime || !c.hasProgramDateTime)) {
            var v = c.fragments[0].programDateTime, g = d.fragments[0].programDateTime, m = (g - v) / 1e3 + c.fragments[0].start;
            m && (0, b.isFiniteNumber)(m) && (y.logger.log("Adjusting PTS using programDateTime delta " + (g - v) + "ms, sliding:" + m.toFixed(3) + " " + d.url + " "), A(m, d));
          }
        }
        function M(d, c) {
          if (!(!d.hasProgramDateTime || !c.hasProgramDateTime)) {
            var v = d.fragments, g = c.fragments;
            if (!(!v.length || !g.length)) {
              var m = Math.round(g.length / 2) - 1, D = g[m], L = E(v, D.cc) || v[Math.round(v.length / 2) - 1], p = D.programDateTime, x = L.programDateTime;
              if (!(p === null || x === null)) {
                var k = (x - p) / 1e3 - (L.start - D.start);
                A(k, d);
              }
            }
          }
        }
      },
      "./src/utils/ewma-bandwidth-estimator.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => N
        });
        var b = a("./src/utils/ewma.ts"), y = /* @__PURE__ */ function() {
          function E(I, T, A) {
            this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultEstimate_ = A, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new b.default(I), this.fast_ = new b.default(T);
          }
          var B = E.prototype;
          return B.update = function(T, A) {
            var w = this.slow_, O = this.fast_;
            this.slow_.halfLife !== T && (this.slow_ = new b.default(T, w.getEstimate(), w.getTotalWeight())), this.fast_.halfLife !== A && (this.fast_ = new b.default(A, O.getEstimate(), O.getTotalWeight()));
          }, B.sample = function(T, A) {
            T = Math.max(T, this.minDelayMs_);
            var w = 8 * A, O = T / 1e3, u = w / O;
            this.fast_.sample(O, u), this.slow_.sample(O, u);
          }, B.canEstimate = function() {
            var T = this.fast_;
            return T && T.getTotalWeight() >= this.minWeight_;
          }, B.getEstimate = function() {
            return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
          }, B.destroy = function() {
          }, E;
        }();
        const N = y;
      },
      "./src/utils/ewma.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => y
        });
        var b = /* @__PURE__ */ function() {
          function N(B, I, T) {
            I === void 0 && (I = 0), T === void 0 && (T = 0), this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = B, this.alpha_ = B ? Math.exp(Math.log(0.5) / B) : 0, this.estimate_ = I, this.totalWeight_ = T;
          }
          var E = N.prototype;
          return E.sample = function(I, T) {
            var A = Math.pow(this.alpha_, I);
            this.estimate_ = T * (1 - A) + A * this.estimate_, this.totalWeight_ += I;
          }, E.getTotalWeight = function() {
            return this.totalWeight_;
          }, E.getEstimate = function() {
            if (this.alpha_) {
              var I = 1 - Math.pow(this.alpha_, this.totalWeight_);
              if (I)
                return this.estimate_ / I;
            }
            return this.estimate_;
          }, N;
        }();
        const y = b;
      },
      "./src/utils/fetch-loader.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => m,
          fetchSupported: () => M
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/loader/load-stats.ts"), N = a("./src/demux/chunk-cache.ts");
        function E(D, L) {
          D.prototype = Object.create(L.prototype), D.prototype.constructor = D, w(D, L);
        }
        function B(D) {
          var L = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
          return B = function(x) {
            if (x === null || !A(x))
              return x;
            if (typeof x != "function")
              throw new TypeError("Super expression must either be null or a function");
            if (typeof L < "u") {
              if (L.has(x))
                return L.get(x);
              L.set(x, k);
            }
            function k() {
              return I(x, arguments, O(this).constructor);
            }
            return k.prototype = Object.create(x.prototype, { constructor: { value: k, enumerable: !1, writable: !0, configurable: !0 } }), w(k, x);
          }, B(D);
        }
        function I(D, L, p) {
          return T() ? I = Reflect.construct.bind() : I = function(k, _, S) {
            var h = [null];
            h.push.apply(h, _);
            var C = Function.bind.apply(k, h), f = new C();
            return S && w(f, S.prototype), f;
          }, I.apply(null, arguments);
        }
        function T() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
            return !1;
          if (typeof Proxy == "function")
            return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
            })), !0;
          } catch {
            return !1;
          }
        }
        function A(D) {
          return Function.toString.call(D).indexOf("[native code]") !== -1;
        }
        function w(D, L) {
          return w = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(x, k) {
            return x.__proto__ = k, x;
          }, w(D, L);
        }
        function O(D) {
          return O = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(p) {
            return p.__proto__ || Object.getPrototypeOf(p);
          }, O(D);
        }
        function u() {
          return u = Object.assign ? Object.assign.bind() : function(D) {
            for (var L = 1; L < arguments.length; L++) {
              var p = arguments[L];
              for (var x in p)
                Object.prototype.hasOwnProperty.call(p, x) && (D[x] = p[x]);
            }
            return D;
          }, u.apply(this, arguments);
        }
        function M() {
          if (self.fetch && self.AbortController && self.ReadableStream && self.Request)
            try {
              return new self.ReadableStream({}), !0;
            } catch {
            }
          return !1;
        }
        var d = /* @__PURE__ */ function() {
          function D(p) {
            this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = void 0, this.response = void 0, this.controller = void 0, this.context = void 0, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = p.fetchSetup || v, this.controller = new self.AbortController(), this.stats = new y.LoadStats();
          }
          var L = D.prototype;
          return L.destroy = function() {
            this.loader = this.callbacks = null, this.abortInternal();
          }, L.abortInternal = function() {
            var x = this.response;
            (!x || !x.ok) && (this.stats.aborted = !0, this.controller.abort());
          }, L.abort = function() {
            var x;
            this.abortInternal(), (x = this.callbacks) !== null && x !== void 0 && x.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
          }, L.load = function(x, k, _) {
            var S = this, h = this.stats;
            if (h.loading.start)
              throw new Error("Loader can only be used once.");
            h.loading.start = self.performance.now();
            var C = c(x, this.controller.signal), f = _.onProgress, P = x.responseType === "arraybuffer", F = P ? "byteLength" : "length";
            this.context = x, this.config = k, this.callbacks = _, this.request = this.fetchSetup(x, C), self.clearTimeout(this.requestTimeout), this.requestTimeout = self.setTimeout(function() {
              S.abortInternal(), _.onTimeout(h, x, S.response);
            }, k.timeout), self.fetch(this.request).then(function(R) {
              if (S.response = S.loader = R, !R.ok) {
                var U = R.status, K = R.statusText;
                throw new g(K || "fetch, bad network response", U, R);
              }
              return h.loading.first = Math.max(self.performance.now(), h.loading.start), h.total = parseInt(R.headers.get("Content-Length") || "0"), f && (0, b.isFiniteNumber)(k.highWaterMark) ? S.loadProgressively(R, h, x, k.highWaterMark, f) : P ? R.arrayBuffer() : R.text();
            }).then(function(R) {
              var U = S.response;
              self.clearTimeout(S.requestTimeout), h.loading.end = Math.max(self.performance.now(), h.loading.first);
              var K = R[F];
              K && (h.loaded = h.total = K);
              var V = {
                url: U.url,
                data: R
              };
              f && !(0, b.isFiniteNumber)(k.highWaterMark) && f(h, x, R, U), _.onSuccess(V, h, x, U);
            }).catch(function(R) {
              if (self.clearTimeout(S.requestTimeout), !h.aborted) {
                var U = R && R.code || 0, K = R ? R.message : null;
                _.onError({
                  code: U,
                  text: K
                }, x, R ? R.details : null);
              }
            });
          }, L.getCacheAge = function() {
            var x = null;
            if (this.response) {
              var k = this.response.headers.get("age");
              x = k ? parseFloat(k) : null;
            }
            return x;
          }, L.loadProgressively = function(x, k, _, S, h) {
            S === void 0 && (S = 0);
            var C = new N.default(), f = x.body.getReader(), P = function F() {
              return f.read().then(function(R) {
                if (R.done)
                  return C.dataLength && h(k, _, C.flush(), x), Promise.resolve(new ArrayBuffer(0));
                var U = R.value, K = U.length;
                return k.loaded += K, K < S || C.dataLength ? (C.push(U), C.dataLength >= S && h(k, _, C.flush(), x)) : h(k, _, U, x), F();
              }).catch(function() {
                return Promise.reject();
              });
            };
            return P();
          }, D;
        }();
        function c(D, L) {
          var p = {
            method: "GET",
            mode: "cors",
            credentials: "same-origin",
            signal: L,
            headers: new self.Headers(u({}, D.headers))
          };
          return D.rangeEnd && p.headers.set("Range", "bytes=" + D.rangeStart + "-" + String(D.rangeEnd - 1)), p;
        }
        function v(D, L) {
          return new self.Request(D.url, L);
        }
        var g = /* @__PURE__ */ function(D) {
          E(L, D);
          function L(p, x, k) {
            var _;
            return _ = D.call(this, p) || this, _.code = void 0, _.details = void 0, _.code = x, _.details = k, _;
          }
          return L;
        }(/* @__PURE__ */ B(Error));
        const m = d;
      },
      "./src/utils/hex.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => y
        });
        var b = {
          hexDump: function(E) {
            for (var B = "", I = 0; I < E.length; I++) {
              var T = E[I].toString(16);
              T.length < 2 && (T = "0" + T), B += T;
            }
            return B;
          }
        };
        const y = b;
      },
      "./src/utils/imsc1-ttml-parser.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          IMSC1_CODEC: () => A,
          parseIMSC1: () => M
        });
        var b = a("./src/utils/mp4-tools.ts"), y = a("./src/utils/vttparser.ts"), N = a("./src/utils/vttcue.ts"), E = a("./src/demux/id3.ts"), B = a("./src/utils/timescale-conversion.ts"), I = a("./src/utils/webvtt-parser.ts");
        function T() {
          return T = Object.assign ? Object.assign.bind() : function(_) {
            for (var S = 1; S < arguments.length; S++) {
              var h = arguments[S];
              for (var C in h)
                Object.prototype.hasOwnProperty.call(h, C) && (_[C] = h[C]);
            }
            return _;
          }, T.apply(this, arguments);
        }
        var A = "stpp.ttml.im1t", w = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, O = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, u = {
          left: "start",
          center: "center",
          right: "end",
          start: "start",
          end: "end"
        };
        function M(_, S, h, C, f) {
          var P = (0, b.findBox)(new Uint8Array(_), ["mdat"]);
          if (P.length === 0) {
            f(new Error("Could not parse IMSC1 mdat"));
            return;
          }
          var F = P.map(function(U) {
            return (0, E.utf8ArrayToStr)(U);
          }), R = (0, B.toTimescaleFromScale)(S, 1, h);
          try {
            F.forEach(function(U) {
              return C(d(U, R));
            });
          } catch (U) {
            f(U);
          }
        }
        function d(_, S) {
          var h = new DOMParser(), C = h.parseFromString(_, "text/xml"), f = C.getElementsByTagName("tt")[0];
          if (!f)
            throw new Error("Invalid ttml");
          var P = {
            frameRate: 30,
            subFrameRate: 1,
            frameRateMultiplier: 0,
            tickRate: 0
          }, F = Object.keys(P).reduce(function(W, G) {
            return W[G] = f.getAttribute("ttp:" + G) || P[G], W;
          }, {}), R = f.getAttribute("xml:space") !== "preserve", U = v(c(f, "styling", "style")), K = v(c(f, "layout", "region")), V = c(f, "body", "[begin]");
          return [].map.call(V, function(W) {
            var G = g(W, R);
            if (!G || !W.hasAttribute("begin"))
              return null;
            var H = p(W.getAttribute("begin"), F), $ = p(W.getAttribute("dur"), F), Y = p(W.getAttribute("end"), F);
            if (H === null)
              throw L(W);
            if (Y === null) {
              if ($ === null)
                throw L(W);
              Y = H + $;
            }
            var z = new N.default(H - S, Y - S, G);
            z.id = (0, I.generateCueId)(z.startTime, z.endTime, z.text);
            var X = K[W.getAttribute("region")], Q = U[W.getAttribute("style")], q = m(X, Q, U), Z = q.textAlign;
            if (Z) {
              var J = u[Z];
              J && (z.lineAlign = J), z.align = Z;
            }
            return T(z, q), z;
          }).filter(function(W) {
            return W !== null;
          });
        }
        function c(_, S, h) {
          var C = _.getElementsByTagName(S)[0];
          return C ? [].slice.call(C.querySelectorAll(h)) : [];
        }
        function v(_) {
          return _.reduce(function(S, h) {
            var C = h.getAttribute("xml:id");
            return C && (S[C] = h), S;
          }, {});
        }
        function g(_, S) {
          return [].slice.call(_.childNodes).reduce(function(h, C, f) {
            var P;
            return C.nodeName === "br" && f ? h + `
` : (P = C.childNodes) !== null && P !== void 0 && P.length ? g(C, S) : S ? h + C.textContent.trim().replace(/\s+/g, " ") : h + C.textContent;
          }, "");
        }
        function m(_, S, h) {
          var C = "http://www.w3.org/ns/ttml#styling", f = null, P = [
            "displayAlign",
            "textAlign",
            "color",
            "backgroundColor",
            "fontSize",
            "fontFamily"
          ], F = _ != null && _.hasAttribute("style") ? _.getAttribute("style") : null;
          return F && h.hasOwnProperty(F) && (f = h[F]), P.reduce(function(R, U) {
            var K = D(S, C, U) || D(_, C, U) || D(f, C, U);
            return K && (R[U] = K), R;
          }, {});
        }
        function D(_, S, h) {
          return _ && _.hasAttributeNS(S, h) ? _.getAttributeNS(S, h) : null;
        }
        function L(_) {
          return new Error("Could not parse ttml timestamp " + _);
        }
        function p(_, S) {
          if (!_)
            return null;
          var h = (0, y.parseTimeStamp)(_);
          return h === null && (w.test(_) ? h = x(_, S) : O.test(_) && (h = k(_, S))), h;
        }
        function x(_, S) {
          var h = w.exec(_), C = (h[4] | 0) + (h[5] | 0) / S.subFrameRate;
          return (h[1] | 0) * 3600 + (h[2] | 0) * 60 + (h[3] | 0) + C / S.frameRate;
        }
        function k(_, S) {
          var h = O.exec(_), C = Number(h[1]), f = h[2];
          switch (f) {
            case "h":
              return C * 3600;
            case "m":
              return C * 60;
            case "ms":
              return C * 1e3;
            case "f":
              return C / S.frameRate;
            case "t":
              return C / S.tickRate;
          }
          return C;
        }
      },
      "./src/utils/keysystem-util.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          changeEndianness: () => N,
          convertDataUriToArrayBytes: () => E,
          strToUtf8array: () => B
        });
        var b = a("./src/utils/numeric-encoding-utils.ts");
        function y(I) {
          var T = B(I).subarray(0, 16), A = new Uint8Array(16);
          return A.set(T, 16 - T.length), A;
        }
        function N(I) {
          var T = function(w, O, u) {
            var M = w[O];
            w[O] = w[u], w[u] = M;
          };
          T(I, 0, 3), T(I, 1, 2), T(I, 4, 5), T(I, 6, 7);
        }
        function E(I) {
          var T = I.split(":"), A = null;
          if (T[0] === "data" && T.length === 2) {
            var w = T[1].split(";"), O = w[w.length - 1].split(",");
            if (O.length === 2) {
              var u = O[0] === "base64", M = O[1];
              u ? (w.splice(-1, 1), A = (0, b.base64Decode)(M)) : A = y(M);
            }
          }
          return A;
        }
        function B(I) {
          return Uint8Array.from(unescape(encodeURIComponent(I)), function(T) {
            return T.charCodeAt(0);
          });
        }
      },
      "./src/utils/logger.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          enableLogs: () => I,
          logger: () => T
        });
        var b = function() {
        }, y = {
          trace: b,
          debug: b,
          log: b,
          warn: b,
          info: b,
          error: b
        }, N = y;
        function E(A) {
          var w = self.console[A];
          return w ? w.bind(self.console, "[" + A + "] >") : b;
        }
        function B(A) {
          for (var w = arguments.length, O = new Array(w > 1 ? w - 1 : 0), u = 1; u < w; u++)
            O[u - 1] = arguments[u];
          O.forEach(function(M) {
            N[M] = A[M] ? A[M].bind(A) : E(M);
          });
        }
        function I(A, w) {
          if (self.console && A === !0 || typeof A == "object") {
            B(
              A,
              "debug",
              "log",
              "info",
              "warn",
              "error"
            );
            try {
              N.log('Debug logs enabled for "' + w + '"');
            } catch {
              N = y;
            }
          } else
            N = y;
        }
        var T = N;
      },
      "./src/utils/mediakeys-helper.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          KeySystemFormats: () => y,
          KeySystemIds: () => E,
          KeySystems: () => b,
          getKeySystemsForConfig: () => T,
          getSupportedMediaKeySystemConfigurations: () => w,
          keySystemDomainToKeySystemFormat: () => I,
          keySystemFormatToKeySystemDomain: () => N,
          keySystemIdToKeySystemDomain: () => B,
          requestMediaKeySystemAccess: () => A
        });
        var b;
        (function(u) {
          u.CLEARKEY = "org.w3.clearkey", u.FAIRPLAY = "com.apple.fps", u.PLAYREADY = "com.microsoft.playready", u.WIDEVINE = "com.widevine.alpha";
        })(b || (b = {}));
        var y;
        (function(u) {
          u.CLEARKEY = "org.w3.clearkey", u.FAIRPLAY = "com.apple.streamingkeydelivery", u.PLAYREADY = "com.microsoft.playready", u.WIDEVINE = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed";
        })(y || (y = {}));
        function N(u) {
          switch (u) {
            case y.FAIRPLAY:
              return b.FAIRPLAY;
            case y.PLAYREADY:
              return b.PLAYREADY;
            case y.WIDEVINE:
              return b.WIDEVINE;
            case y.CLEARKEY:
              return b.CLEARKEY;
          }
        }
        var E;
        (function(u) {
          u.WIDEVINE = "edef8ba979d64acea3c827dcd51d21ed";
        })(E || (E = {}));
        function B(u) {
          if (u === E.WIDEVINE)
            return b.WIDEVINE;
        }
        function I(u) {
          switch (u) {
            case b.FAIRPLAY:
              return y.FAIRPLAY;
            case b.PLAYREADY:
              return y.PLAYREADY;
            case b.WIDEVINE:
              return y.WIDEVINE;
            case b.CLEARKEY:
              return y.CLEARKEY;
          }
        }
        function T(u) {
          var M = u.drmSystems, d = u.widevineLicenseUrl, c = M ? [b.FAIRPLAY, b.WIDEVINE, b.PLAYREADY, b.CLEARKEY].filter(function(v) {
            return !!M[v];
          }) : [];
          return !c[b.WIDEVINE] && d && c.push(b.WIDEVINE), c;
        }
        var A = function() {
          return typeof self < "u" && self.navigator && self.navigator.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
        }();
        function w(u, M, d, c) {
          var v;
          switch (u) {
            case b.FAIRPLAY:
              v = ["cenc", "sinf"];
              break;
            case b.WIDEVINE:
            case b.PLAYREADY:
              v = ["cenc"];
              break;
            case b.CLEARKEY:
              v = ["cenc", "keyids"];
              break;
            default:
              throw new Error("Unknown key-system: " + u);
          }
          return O(v, M, d, c);
        }
        function O(u, M, d, c) {
          var v = {
            initDataTypes: u,
            persistentState: c.persistentState || "not-allowed",
            distinctiveIdentifier: c.distinctiveIdentifier || "not-allowed",
            sessionTypes: c.sessionTypes || [c.sessionType || "temporary"],
            audioCapabilities: M.map(function(g) {
              return {
                contentType: 'audio/mp4; codecs="' + g + '"',
                robustness: c.audioRobustness || "",
                encryptionScheme: c.audioEncryptionScheme || null
              };
            }),
            videoCapabilities: d.map(function(g) {
              return {
                contentType: 'video/mp4; codecs="' + g + '"',
                robustness: c.videoRobustness || "",
                encryptionScheme: c.videoEncryptionScheme || null
              };
            })
          };
          return [v];
        }
      },
      "./src/utils/mediasource-helper.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          getMediaSource: () => b
        });
        function b() {
          return self.MediaSource || self.WebKitMediaSource;
        }
      },
      "./src/utils/mp4-tools.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          RemuxerTrackIdConfig: () => A,
          appendUint8Array: () => S,
          bin2str: () => w,
          computeRawDurationFromSamples: () => x,
          discardEPB: () => F,
          findBox: () => c,
          getDuration: () => p,
          getStartDTS: () => L,
          mp4Box: () => U,
          mp4pssh: () => K,
          offsetStartDTS: () => k,
          parseEmsg: () => R,
          parseInitSegment: () => g,
          parsePssh: () => V,
          parseSEIMessageFromNALu: () => P,
          parseSamples: () => h,
          parseSegmentIndex: () => v,
          parseSinf: () => D,
          patchEncyptionData: () => m,
          readSint32: () => M,
          readUint16: () => O,
          readUint32: () => u,
          segmentValidRange: () => _,
          writeUint32: () => d
        });
        var b = a("./src/loader/fragment.ts"), y = a("./src/utils/typed-array.ts"), N = a("./src/demux/id3.ts"), E = a("./src/utils/logger.ts"), B = a("./src/utils/hex.ts"), I = Math.pow(2, 32) - 1, T = [].push, A = {
          video: 1,
          audio: 2,
          id3: 3,
          text: 4
        };
        function w(W) {
          return String.fromCharCode.apply(null, W);
        }
        function O(W, G) {
          var H = W[G] << 8 | W[G + 1];
          return H < 0 ? 65536 + H : H;
        }
        function u(W, G) {
          var H = M(W, G);
          return H < 0 ? 4294967296 + H : H;
        }
        function M(W, G) {
          return W[G] << 24 | W[G + 1] << 16 | W[G + 2] << 8 | W[G + 3];
        }
        function d(W, G, H) {
          W[G] = H >> 24, W[G + 1] = H >> 16 & 255, W[G + 2] = H >> 8 & 255, W[G + 3] = H & 255;
        }
        function c(W, G) {
          var H = [];
          if (!G.length)
            return H;
          for (var $ = W.byteLength, Y = 0; Y < $; ) {
            var z = u(W, Y), X = w(W.subarray(Y + 4, Y + 8)), Q = z > 1 ? Y + z : $;
            if (X === G[0])
              if (G.length === 1)
                H.push(W.subarray(Y + 8, Q));
              else {
                var q = c(W.subarray(Y + 8, Q), G.slice(1));
                q.length && T.apply(H, q);
              }
            Y = Q;
          }
          return H;
        }
        function v(W) {
          var G = [], H = W[0], $ = 8, Y = u(W, $);
          $ += 4;
          var z = 0, X = 0;
          H === 0 ? $ += 8 : $ += 16, $ += 2;
          var Q = W.length + X, q = O(W, $);
          $ += 2;
          for (var Z = 0; Z < q; Z++) {
            var J = $, te = u(W, J);
            J += 4;
            var ne = te & 2147483647, re = (te & 2147483648) >>> 31;
            if (re === 1)
              return console.warn("SIDX has hierarchical references (not supported)"), null;
            var ee = u(W, J);
            J += 4, G.push({
              referenceSize: ne,
              subsegmentDuration: ee,
              info: {
                duration: ee / Y,
                start: Q,
                end: Q + ne - 1
              }
            }), Q += ne, J += 4, $ = J;
          }
          return {
            earliestPresentationTime: z,
            timescale: Y,
            version: H,
            referencesCount: q,
            references: G
          };
        }
        function g(W) {
          for (var G = [], H = c(W, ["moov", "trak"]), $ = 0; $ < H.length; $++) {
            var Y = H[$], z = c(Y, ["tkhd"])[0];
            if (z) {
              var X = z[0], Q = X === 0 ? 12 : 20, q = u(z, Q), Z = c(Y, ["mdia", "mdhd"])[0];
              if (Z) {
                X = Z[0], Q = X === 0 ? 12 : 20;
                var J = u(Z, Q), te = c(Y, ["mdia", "hdlr"])[0];
                if (te) {
                  var ne = w(te.subarray(8, 12)), re = {
                    soun: b.ElementaryStreamTypes.AUDIO,
                    vide: b.ElementaryStreamTypes.VIDEO
                  }[ne];
                  if (re) {
                    var ee = c(Y, ["mdia", "minf", "stbl", "stsd"])[0], le = void 0;
                    ee && (le = w(ee.subarray(12, 16))), G[q] = {
                      timescale: J,
                      type: re
                    }, G[re] = {
                      timescale: J,
                      id: q,
                      codec: le
                    };
                  }
                }
              }
            }
          }
          var pe = c(W, ["moov", "mvex", "trex"]);
          return pe.forEach(function(ie) {
            var ce = u(ie, 4), se = G[ce];
            se && (se.default = {
              duration: u(ie, 12),
              flags: u(ie, 20)
            });
          }), G;
        }
        function m(W, G) {
          if (!W || !G)
            return W;
          var H = G.keyId;
          if (H && G.isCommonEncryption) {
            var $ = c(W, ["moov", "trak"]);
            $.forEach(function(Y) {
              var z = c(Y, ["mdia", "minf", "stbl", "stsd"])[0], X = z.subarray(8), Q = c(X, ["enca"]), q = Q.length > 0;
              q || (Q = c(X, ["encv"])), Q.forEach(function(Z) {
                var J = q ? Z.subarray(28) : Z.subarray(78), te = c(J, ["sinf"]);
                te.forEach(function(ne) {
                  var re = D(ne);
                  if (re) {
                    var ee = re.subarray(8, 24);
                    ee.some(function(le) {
                      return le !== 0;
                    }) || (E.logger.log("[eme] Patching keyId in 'enc" + (q ? "a" : "v") + ">sinf>>tenc' box: " + B.default.hexDump(ee) + " -> " + B.default.hexDump(H)), re.set(H, 8));
                  }
                });
              });
            });
          }
          return W;
        }
        function D(W) {
          var G = c(W, ["schm"])[0];
          if (G) {
            var H = w(G.subarray(4, 8));
            if (H === "cbcs" || H === "cenc")
              return c(W, ["schi", "tenc"])[0];
          }
          return E.logger.error("[eme] missing 'schm' box"), null;
        }
        function L(W, G) {
          return c(G, ["moof", "traf"]).reduce(function(H, $) {
            var Y = c($, ["tfdt"])[0], z = Y[0], X = c($, ["tfhd"]).reduce(function(Q, q) {
              var Z = u(q, 4), J = W[Z];
              if (J) {
                var te = u(Y, 4);
                z === 1 && (te *= Math.pow(2, 32), te += u(Y, 8));
                var ne = J.timescale || 9e4, re = te / ne;
                if (isFinite(re) && (Q === null || re < Q))
                  return re;
              }
              return Q;
            }, null);
            return X !== null && isFinite(X) && (H === null || X < H) ? X : H;
          }, null) || 0;
        }
        function p(W, G) {
          for (var H = 0, $ = 0, Y = 0, z = c(W, ["moof", "traf"]), X = 0; X < z.length; X++) {
            var Q = z[X], q = c(Q, ["tfhd"])[0], Z = u(q, 4), J = G[Z];
            if (!!J) {
              var te = J.default, ne = u(q, 0) | (te == null ? void 0 : te.flags), re = te == null ? void 0 : te.duration;
              ne & 8 && (ne & 2 ? re = u(q, 12) : re = u(q, 8));
              for (var ee = J.timescale || 9e4, le = c(Q, ["trun"]), pe = 0; pe < le.length; pe++) {
                if (H = x(le[pe]), !H && re) {
                  var ie = u(le[pe], 4);
                  H = re * ie;
                }
                J.type === b.ElementaryStreamTypes.VIDEO ? $ += H / ee : J.type === b.ElementaryStreamTypes.AUDIO && (Y += H / ee);
              }
            }
          }
          if ($ === 0 && Y === 0) {
            for (var ce = 0, se = c(W, ["sidx"]), he = 0; he < se.length; he++) {
              var ae = v(se[he]);
              ae != null && ae.references && (ce += ae.references.reduce(function(Ee, ue) {
                return Ee + ue.info.duration || 0;
              }, 0));
            }
            return ce;
          }
          return $ || Y;
        }
        function x(W) {
          var G = u(W, 0), H = 8;
          G & 1 && (H += 4), G & 4 && (H += 4);
          for (var $ = 0, Y = u(W, 4), z = 0; z < Y; z++) {
            if (G & 256) {
              var X = u(W, H);
              $ += X, H += 4;
            }
            G & 512 && (H += 4), G & 1024 && (H += 4), G & 2048 && (H += 4);
          }
          return $;
        }
        function k(W, G, H) {
          c(G, ["moof", "traf"]).forEach(function($) {
            c($, ["tfhd"]).forEach(function(Y) {
              var z = u(Y, 4), X = W[z];
              if (!!X) {
                var Q = X.timescale || 9e4;
                c($, ["tfdt"]).forEach(function(q) {
                  var Z = q[0], J = u(q, 4);
                  if (Z === 0)
                    J -= H * Q, J = Math.max(J, 0), d(q, 4, J);
                  else {
                    J *= Math.pow(2, 32), J += u(q, 8), J -= H * Q, J = Math.max(J, 0);
                    var te = Math.floor(J / (I + 1)), ne = Math.floor(J % (I + 1));
                    d(q, 4, te), d(q, 8, ne);
                  }
                });
              }
            });
          });
        }
        function _(W) {
          var G = {
            valid: null,
            remainder: null
          }, H = c(W, ["moof"]);
          if (H) {
            if (H.length < 2)
              return G.remainder = W, G;
          } else
            return G;
          var $ = H[H.length - 1];
          return G.valid = (0, y.sliceUint8)(W, 0, $.byteOffset - 8), G.remainder = (0, y.sliceUint8)(W, $.byteOffset - 8), G;
        }
        function S(W, G) {
          var H = new Uint8Array(W.length + G.length);
          return H.set(W), H.set(G, W.length), H;
        }
        function h(W, G) {
          var H = [], $ = G.samples, Y = G.timescale, z = G.id, X = !1, Q = c($, ["moof"]);
          return Q.map(function(q) {
            var Z = q.byteOffset - 8, J = c(q, ["traf"]);
            J.map(function(te) {
              var ne = c(te, ["tfdt"]).map(function(re) {
                var ee = re[0], le = u(re, 4);
                return ee === 1 && (le *= Math.pow(2, 32), le += u(re, 8)), le / Y;
              })[0];
              return ne !== void 0 && (W = ne), c(te, ["tfhd"]).map(function(re) {
                var ee = u(re, 4), le = u(re, 0) & 16777215, pe = (le & 1) !== 0, ie = (le & 2) !== 0, ce = (le & 8) !== 0, se = 0, he = (le & 16) !== 0, ae = 0, Ee = (le & 32) !== 0, ue = 8;
                ee === z && (pe && (ue += 8), ie && (ue += 4), ce && (se = u(re, ue), ue += 4), he && (ae = u(re, ue), ue += 4), Ee && (ue += 4), G.type === "video" && (X = C(G.codec)), c(te, ["trun"]).map(function(Le) {
                  var Ae = Le[0], Re = u(Le, 0) & 16777215, Ke = (Re & 1) !== 0, Nt = 0, nt = (Re & 4) !== 0, Wt = (Re & 256) !== 0, bt = 0, gt = (Re & 512) !== 0, pt = 0, tt = (Re & 1024) !== 0, Xe = (Re & 2048) !== 0, yt = 0, At = u(Le, 4), Ve = 8;
                  Ke && (Nt = u(Le, Ve), Ve += 4), nt && (Ve += 4);
                  for (var Bt = Nt + Z, Lt = 0; Lt < At; Lt++) {
                    if (Wt ? (bt = u(Le, Ve), Ve += 4) : bt = se, gt ? (pt = u(Le, Ve), Ve += 4) : pt = ae, tt && (Ve += 4), Xe && (Ae === 0 ? yt = u(Le, Ve) : yt = M(Le, Ve), Ve += 4), G.type === b.ElementaryStreamTypes.VIDEO)
                      for (var Li = 0; Li < pt; ) {
                        var rr = u($, Bt);
                        if (Bt += 4, f(X, $[Bt])) {
                          var Er = $.subarray(Bt, Bt + rr);
                          P(Er, X ? 2 : 1, W + yt / Y, H);
                        }
                        Bt += rr, Li += rr + 4;
                      }
                    W += bt / Y;
                  }
                }));
              });
            });
          }), H;
        }
        function C(W) {
          if (!W)
            return !1;
          var G = W.indexOf("."), H = G < 0 ? W : W.substring(0, G);
          return H === "hvc1" || H === "hev1" || H === "dvh1" || H === "dvhe";
        }
        function f(W, G) {
          if (W) {
            var H = G >> 1 & 63;
            return H === 39 || H === 40;
          } else {
            var $ = G & 31;
            return $ === 6;
          }
        }
        function P(W, G, H, $) {
          var Y = F(W), z = 0;
          z += G;
          for (var X = 0, Q = 0, q = !1, Z = 0; z < Y.length; ) {
            X = 0;
            do {
              if (z >= Y.length)
                break;
              Z = Y[z++], X += Z;
            } while (Z === 255);
            Q = 0;
            do {
              if (z >= Y.length)
                break;
              Z = Y[z++], Q += Z;
            } while (Z === 255);
            var J = Y.length - z;
            if (!q && X === 4 && z < Y.length) {
              q = !0;
              var te = Y[z++];
              if (te === 181) {
                var ne = O(Y, z);
                if (z += 2, ne === 49) {
                  var re = u(Y, z);
                  if (z += 4, re === 1195456820) {
                    var ee = Y[z++];
                    if (ee === 3) {
                      var le = Y[z++], pe = 31 & le, ie = 64 & le, ce = ie ? 2 + pe * 3 : 0, se = new Uint8Array(ce);
                      if (ie) {
                        se[0] = le;
                        for (var he = 1; he < ce; he++)
                          se[he] = Y[z++];
                      }
                      $.push({
                        type: ee,
                        payloadType: X,
                        pts: H,
                        bytes: se
                      });
                    }
                  }
                }
              }
            } else if (X === 5 && Q < J) {
              if (q = !0, Q > 16) {
                for (var ae = [], Ee = 0; Ee < 16; Ee++) {
                  var ue = Y[z++].toString(16);
                  ae.push(ue.length == 1 ? "0" + ue : ue), (Ee === 3 || Ee === 5 || Ee === 7 || Ee === 9) && ae.push("-");
                }
                for (var Le = Q - 16, Ae = new Uint8Array(Le), Re = 0; Re < Le; Re++)
                  Ae[Re] = Y[z++];
                $.push({
                  payloadType: X,
                  pts: H,
                  uuid: ae.join(""),
                  userData: (0, N.utf8ArrayToStr)(Ae),
                  userDataBytes: Ae
                });
              }
            } else if (Q < J)
              z += Q;
            else if (Q > J)
              break;
          }
        }
        function F(W) {
          for (var G = W.byteLength, H = [], $ = 1; $ < G - 2; )
            W[$] === 0 && W[$ + 1] === 0 && W[$ + 2] === 3 ? (H.push($ + 2), $ += 2) : $++;
          if (H.length === 0)
            return W;
          var Y = G - H.length, z = new Uint8Array(Y), X = 0;
          for ($ = 0; $ < Y; X++, $++)
            X === H[0] && (X++, H.shift()), z[$] = W[X];
          return z;
        }
        function R(W) {
          var G = W[0], H = "", $ = "", Y = 0, z = 0, X = 0, Q = 0, q = 0, Z = 0;
          if (G === 0) {
            for (; w(W.subarray(Z, Z + 1)) !== "\0"; )
              H += w(W.subarray(Z, Z + 1)), Z += 1;
            for (H += w(W.subarray(Z, Z + 1)), Z += 1; w(W.subarray(Z, Z + 1)) !== "\0"; )
              $ += w(W.subarray(Z, Z + 1)), Z += 1;
            $ += w(W.subarray(Z, Z + 1)), Z += 1, Y = u(W, 12), z = u(W, 16), Q = u(W, 20), q = u(W, 24), Z = 28;
          } else if (G === 1) {
            Z += 4, Y = u(W, Z), Z += 4;
            var J = u(W, Z);
            Z += 4;
            var te = u(W, Z);
            for (Z += 4, X = Math.pow(2, 32) * J + te, Number.isSafeInteger(X) || (X = Number.MAX_SAFE_INTEGER, console.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), Q = u(W, Z), Z += 4, q = u(W, Z), Z += 4; w(W.subarray(Z, Z + 1)) !== "\0"; )
              H += w(W.subarray(Z, Z + 1)), Z += 1;
            for (H += w(W.subarray(Z, Z + 1)), Z += 1; w(W.subarray(Z, Z + 1)) !== "\0"; )
              $ += w(W.subarray(Z, Z + 1)), Z += 1;
            $ += w(W.subarray(Z, Z + 1)), Z += 1;
          }
          var ne = W.subarray(Z, W.byteLength);
          return {
            schemeIdUri: H,
            value: $,
            timeScale: Y,
            presentationTime: X,
            presentationTimeDelta: z,
            eventDuration: Q,
            id: q,
            payload: ne
          };
        }
        function U(W) {
          for (var G = arguments.length, H = new Array(G > 1 ? G - 1 : 0), $ = 1; $ < G; $++)
            H[$ - 1] = arguments[$];
          for (var Y = H.length, z = 8, X = Y; X--; )
            z += H[X].byteLength;
          var Q = new Uint8Array(z);
          for (Q[0] = z >> 24 & 255, Q[1] = z >> 16 & 255, Q[2] = z >> 8 & 255, Q[3] = z & 255, Q.set(W, 4), X = 0, z = 8; X < Y; X++)
            Q.set(H[X], z), z += H[X].byteLength;
          return Q;
        }
        function K(W, G, H) {
          if (W.byteLength !== 16)
            throw new RangeError("Invalid system id");
          var $, Y;
          if (G) {
            $ = 1, Y = new Uint8Array(G.length * 16);
            for (var z = 0; z < G.length; z++) {
              var X = G[z];
              if (X.byteLength !== 16)
                throw new RangeError("Invalid key");
              Y.set(X, z * 16);
            }
          } else
            $ = 0, Y = new Uint8Array();
          var Q;
          $ > 0 ? (Q = new Uint8Array(4), G.length > 0 && new DataView(Q.buffer).setUint32(0, G.length, !1)) : Q = new Uint8Array();
          var q = new Uint8Array(4);
          return H && H.byteLength > 0 && new DataView(q.buffer).setUint32(0, H.byteLength, !1), U(
            [112, 115, 115, 104],
            new Uint8Array([
              $,
              0,
              0,
              0
            ]),
            W,
            Q,
            Y,
            q,
            H || new Uint8Array()
          );
        }
        function V(W) {
          if (!(W instanceof ArrayBuffer) || W.byteLength < 32)
            return null;
          var G = {
            version: 0,
            systemId: "",
            kids: null,
            data: null
          }, H = new DataView(W), $ = H.getUint32(0);
          if (W.byteLength !== $ && $ > 44)
            return null;
          var Y = H.getUint32(4);
          if (Y !== 1886614376 || (G.version = H.getUint32(8) >>> 24, G.version > 1))
            return null;
          G.systemId = B.default.hexDump(new Uint8Array(W, 12, 16));
          var z = H.getUint32(28);
          if (G.version === 0) {
            if ($ - 32 < z)
              return null;
            G.data = new Uint8Array(W, 32, z);
          } else if (G.version === 1) {
            G.kids = [];
            for (var X = 0; X < z; X++)
              G.kids.push(new Uint8Array(W, 32 + X * 16, 16));
          }
          return G;
        }
      },
      "./src/utils/numeric-encoding-utils.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          base64Decode: () => I,
          base64DecodeToStr: () => N,
          base64Encode: () => E,
          base64ToBase64Url: () => b,
          base64UrlEncode: () => B,
          strToBase64Encode: () => y
        });
        function b(T) {
          return T.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        }
        function y(T) {
          return btoa(T);
        }
        function N(T) {
          return atob(T);
        }
        function E(T) {
          return btoa(String.fromCharCode.apply(String, T));
        }
        function B(T) {
          return b(E(T));
        }
        function I(T) {
          return Uint8Array.from(atob(T), function(A) {
            return A.charCodeAt(0);
          });
        }
      },
      "./src/utils/output-filter.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => b
        });
        var b = /* @__PURE__ */ function() {
          function y(E, B) {
            this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = E, this.trackName = B;
          }
          var N = y.prototype;
          return N.dispatchCue = function() {
            this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
          }, N.newCue = function(B, I, T) {
            (this.startTime === null || this.startTime > B) && (this.startTime = B), this.endTime = I, this.screen = T, this.timelineController.createCaptionsTrack(this.trackName);
          }, N.reset = function() {
            this.cueRanges = [], this.startTime = null;
          }, y;
        }();
      },
      "./src/utils/texttrack-utils.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          addCueToTrack: () => N,
          clearCurrentCues: () => E,
          getCuesInRange: () => T,
          removeCuesInRange: () => B,
          sendAddTrackEvent: () => y
        });
        var b = a("./src/utils/logger.ts");
        function y(A, w) {
          var O;
          try {
            O = new Event("addtrack");
          } catch {
            O = document.createEvent("Event"), O.initEvent("addtrack", !1, !1);
          }
          O.track = A, w.dispatchEvent(O);
        }
        function N(A, w) {
          var O = A.mode;
          if (O === "disabled" && (A.mode = "hidden"), A.cues && !A.cues.getCueById(w.id))
            try {
              if (A.addCue(w), !A.cues.getCueById(w.id))
                throw new Error("addCue is failed for: " + w);
            } catch (M) {
              b.logger.debug("[texttrack-utils]: " + M);
              var u = new self.TextTrackCue(w.startTime, w.endTime, w.text);
              u.id = w.id, A.addCue(u);
            }
          O === "disabled" && (A.mode = O);
        }
        function E(A) {
          var w = A.mode;
          if (w === "disabled" && (A.mode = "hidden"), A.cues)
            for (var O = A.cues.length; O--; )
              A.removeCue(A.cues[O]);
          w === "disabled" && (A.mode = w);
        }
        function B(A, w, O, u) {
          var M = A.mode;
          if (M === "disabled" && (A.mode = "hidden"), A.cues && A.cues.length > 0)
            for (var d = T(A.cues, w, O), c = 0; c < d.length; c++)
              (!u || u(d[c])) && A.removeCue(d[c]);
          M === "disabled" && (A.mode = M);
        }
        function I(A, w) {
          if (w < A[0].startTime)
            return 0;
          var O = A.length - 1;
          if (w > A[O].endTime)
            return -1;
          for (var u = 0, M = O; u <= M; ) {
            var d = Math.floor((M + u) / 2);
            if (w < A[d].startTime)
              M = d - 1;
            else if (w > A[d].startTime && u < O)
              u = d + 1;
            else
              return d;
          }
          return A[u].startTime - w < w - A[M].startTime ? u : M;
        }
        function T(A, w, O) {
          var u = [], M = I(A, w);
          if (M > -1)
            for (var d = M, c = A.length; d < c; d++) {
              var v = A[d];
              if (v.startTime >= w && v.endTime <= O)
                u.push(v);
              else if (v.startTime > O)
                return u;
            }
          return u;
        }
      },
      "./src/utils/time-ranges.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => y
        });
        var b = {
          toString: function(E) {
            for (var B = "", I = E.length, T = 0; T < I; T++)
              B += "[" + E.start(T).toFixed(3) + "-" + E.end(T).toFixed(3) + "]";
            return B;
          }
        };
        const y = b;
      },
      "./src/utils/timescale-conversion.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          toMpegTsClockFromTimescale: () => B,
          toMsFromMpegTsClock: () => E,
          toTimescaleFromBase: () => y,
          toTimescaleFromScale: () => N
        });
        var b = 9e4;
        function y(I, T, A, w) {
          A === void 0 && (A = 1), w === void 0 && (w = !1);
          var O = I * T * A;
          return w ? Math.round(O) : O;
        }
        function N(I, T, A, w) {
          return A === void 0 && (A = 1), w === void 0 && (w = !1), y(I, T, 1 / A, w);
        }
        function E(I, T) {
          return T === void 0 && (T = !1), y(I, 1e3, 1 / b, T);
        }
        function B(I, T) {
          return T === void 0 && (T = 1), y(I, b, 1 / T);
        }
      },
      "./src/utils/typed-array.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          sliceUint8: () => b
        });
        function b(y, N, E) {
          return Uint8Array.prototype.slice ? y.slice(N, E) : new Uint8Array(Array.prototype.slice.call(y, N, E));
        }
      },
      "./src/utils/vttcue.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => b
        });
        const b = function() {
          if (typeof self < "u" && self.VTTCue)
            return self.VTTCue;
          var y = ["", "lr", "rl"], N = ["start", "middle", "end", "left", "right"];
          function E(w, O) {
            if (typeof O != "string" || !Array.isArray(w))
              return !1;
            var u = O.toLowerCase();
            return ~w.indexOf(u) ? u : !1;
          }
          function B(w) {
            return E(y, w);
          }
          function I(w) {
            return E(N, w);
          }
          function T(w) {
            for (var O = arguments.length, u = new Array(O > 1 ? O - 1 : 0), M = 1; M < O; M++)
              u[M - 1] = arguments[M];
            for (var d = 1; d < arguments.length; d++) {
              var c = arguments[d];
              for (var v in c)
                w[v] = c[v];
            }
            return w;
          }
          function A(w, O, u) {
            var M = this, d = {
              enumerable: !0
            };
            M.hasBeenReset = !1;
            var c = "", v = !1, g = w, m = O, D = u, L = null, p = "", x = !0, k = "auto", _ = "start", S = 50, h = "middle", C = 50, f = "middle";
            Object.defineProperty(M, "id", T({}, d, {
              get: function() {
                return c;
              },
              set: function(F) {
                c = "" + F;
              }
            })), Object.defineProperty(M, "pauseOnExit", T({}, d, {
              get: function() {
                return v;
              },
              set: function(F) {
                v = !!F;
              }
            })), Object.defineProperty(M, "startTime", T({}, d, {
              get: function() {
                return g;
              },
              set: function(F) {
                if (typeof F != "number")
                  throw new TypeError("Start time must be set to a number.");
                g = F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "endTime", T({}, d, {
              get: function() {
                return m;
              },
              set: function(F) {
                if (typeof F != "number")
                  throw new TypeError("End time must be set to a number.");
                m = F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "text", T({}, d, {
              get: function() {
                return D;
              },
              set: function(F) {
                D = "" + F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "region", T({}, d, {
              get: function() {
                return L;
              },
              set: function(F) {
                L = F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "vertical", T({}, d, {
              get: function() {
                return p;
              },
              set: function(F) {
                var R = B(F);
                if (R === !1)
                  throw new SyntaxError("An invalid or illegal string was specified.");
                p = R, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "snapToLines", T({}, d, {
              get: function() {
                return x;
              },
              set: function(F) {
                x = !!F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "line", T({}, d, {
              get: function() {
                return k;
              },
              set: function(F) {
                if (typeof F != "number" && F !== "auto")
                  throw new SyntaxError("An invalid number or illegal string was specified.");
                k = F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "lineAlign", T({}, d, {
              get: function() {
                return _;
              },
              set: function(F) {
                var R = I(F);
                if (!R)
                  throw new SyntaxError("An invalid or illegal string was specified.");
                _ = R, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "position", T({}, d, {
              get: function() {
                return S;
              },
              set: function(F) {
                if (F < 0 || F > 100)
                  throw new Error("Position must be between 0 and 100.");
                S = F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "positionAlign", T({}, d, {
              get: function() {
                return h;
              },
              set: function(F) {
                var R = I(F);
                if (!R)
                  throw new SyntaxError("An invalid or illegal string was specified.");
                h = R, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "size", T({}, d, {
              get: function() {
                return C;
              },
              set: function(F) {
                if (F < 0 || F > 100)
                  throw new Error("Size must be between 0 and 100.");
                C = F, this.hasBeenReset = !0;
              }
            })), Object.defineProperty(M, "align", T({}, d, {
              get: function() {
                return f;
              },
              set: function(F) {
                var R = I(F);
                if (!R)
                  throw new SyntaxError("An invalid or illegal string was specified.");
                f = R, this.hasBeenReset = !0;
              }
            })), M.displayState = void 0;
          }
          return A.prototype.getCueAsHTML = function() {
            var w = self.WebVTT;
            return w.convertCueToDOMTree(self, this.text);
          }, A;
        }();
      },
      "./src/utils/vttparser.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          VTTParser: () => O,
          fixLineBreaks: () => w,
          parseTimeStamp: () => N
        });
        var b = a("./src/utils/vttcue.ts"), y = /* @__PURE__ */ function() {
          function u() {
          }
          var M = u.prototype;
          return M.decode = function(c, v) {
            if (!c)
              return "";
            if (typeof c != "string")
              throw new Error("Error - expected string data.");
            return decodeURIComponent(encodeURIComponent(c));
          }, u;
        }();
        function N(u) {
          function M(c, v, g, m) {
            return (c | 0) * 3600 + (v | 0) * 60 + (g | 0) + parseFloat(m || 0);
          }
          var d = u.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
          return d ? parseFloat(d[2]) > 59 ? M(d[2], d[3], 0, d[4]) : M(d[1], d[2], d[3], d[4]) : null;
        }
        var E = /* @__PURE__ */ function() {
          function u() {
            this.values = /* @__PURE__ */ Object.create(null);
          }
          var M = u.prototype;
          return M.set = function(c, v) {
            !this.get(c) && v !== "" && (this.values[c] = v);
          }, M.get = function(c, v, g) {
            return g ? this.has(c) ? this.values[c] : v[g] : this.has(c) ? this.values[c] : v;
          }, M.has = function(c) {
            return c in this.values;
          }, M.alt = function(c, v, g) {
            for (var m = 0; m < g.length; ++m)
              if (v === g[m]) {
                this.set(c, v);
                break;
              }
          }, M.integer = function(c, v) {
            /^-?\d+$/.test(v) && this.set(c, parseInt(v, 10));
          }, M.percent = function(c, v) {
            if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
              var g = parseFloat(v);
              if (g >= 0 && g <= 100)
                return this.set(c, g), !0;
            }
            return !1;
          }, u;
        }();
        function B(u, M, d, c) {
          var v = c ? u.split(c) : [u];
          for (var g in v)
            if (typeof v[g] == "string") {
              var m = v[g].split(d);
              if (m.length === 2) {
                var D = m[0], L = m[1];
                M(D, L);
              }
            }
        }
        var I = new b.default(0, 0, ""), T = I.align === "middle" ? "middle" : "center";
        function A(u, M, d) {
          var c = u;
          function v() {
            var D = N(u);
            if (D === null)
              throw new Error("Malformed timestamp: " + c);
            return u = u.replace(/^[^\sa-zA-Z-]+/, ""), D;
          }
          function g(D, L) {
            var p = new E();
            B(D, function(_, S) {
              var h;
              switch (_) {
                case "region":
                  for (var C = d.length - 1; C >= 0; C--)
                    if (d[C].id === S) {
                      p.set(_, d[C].region);
                      break;
                    }
                  break;
                case "vertical":
                  p.alt(_, S, ["rl", "lr"]);
                  break;
                case "line":
                  h = S.split(","), p.integer(_, h[0]), p.percent(_, h[0]) && p.set("snapToLines", !1), p.alt(_, h[0], ["auto"]), h.length === 2 && p.alt("lineAlign", h[1], ["start", T, "end"]);
                  break;
                case "position":
                  h = S.split(","), p.percent(_, h[0]), h.length === 2 && p.alt("positionAlign", h[1], ["start", T, "end", "line-left", "line-right", "auto"]);
                  break;
                case "size":
                  p.percent(_, S);
                  break;
                case "align":
                  p.alt(_, S, ["start", T, "end", "left", "right"]);
                  break;
              }
            }, /:/, /\s/), L.region = p.get("region", null), L.vertical = p.get("vertical", "");
            var x = p.get("line", "auto");
            x === "auto" && I.line === -1 && (x = -1), L.line = x, L.lineAlign = p.get("lineAlign", "start"), L.snapToLines = p.get("snapToLines", !0), L.size = p.get("size", 100), L.align = p.get("align", T);
            var k = p.get("position", "auto");
            k === "auto" && I.position === 50 && (k = L.align === "start" || L.align === "left" ? 0 : L.align === "end" || L.align === "right" ? 100 : 50), L.position = k;
          }
          function m() {
            u = u.replace(/^\s+/, "");
          }
          if (m(), M.startTime = v(), m(), u.slice(0, 3) !== "-->")
            throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + c);
          u = u.slice(3), m(), M.endTime = v(), m(), g(u, M);
        }
        function w(u) {
          return u.replace(/<br(?: \/)?>/gi, `
`);
        }
        var O = /* @__PURE__ */ function() {
          function u() {
            this.state = "INITIAL", this.buffer = "", this.decoder = new y(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
          }
          var M = u.prototype;
          return M.parse = function(c) {
            var v = this;
            c && (v.buffer += v.decoder.decode(c, {
              stream: !0
            }));
            function g() {
              var k = v.buffer, _ = 0;
              for (k = w(k); _ < k.length && k[_] !== "\r" && k[_] !== `
`; )
                ++_;
              var S = k.slice(0, _);
              return k[_] === "\r" && ++_, k[_] === `
` && ++_, v.buffer = k.slice(_), S;
            }
            function m(k) {
              B(k, function(_, S) {
              }, /:/);
            }
            try {
              var D = "";
              if (v.state === "INITIAL") {
                if (!/\r\n|\n/.test(v.buffer))
                  return this;
                D = g();
                var L = D.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                if (!L || !L[0])
                  throw new Error("Malformed WebVTT signature.");
                v.state = "HEADER";
              }
              for (var p = !1; v.buffer; ) {
                if (!/\r\n|\n/.test(v.buffer))
                  return this;
                switch (p ? p = !1 : D = g(), v.state) {
                  case "HEADER":
                    /:/.test(D) ? m(D) : D || (v.state = "ID");
                    continue;
                  case "NOTE":
                    D || (v.state = "ID");
                    continue;
                  case "ID":
                    if (/^NOTE($|[ \t])/.test(D)) {
                      v.state = "NOTE";
                      break;
                    }
                    if (!D)
                      continue;
                    if (v.cue = new b.default(0, 0, ""), v.state = "CUE", D.indexOf("-->") === -1) {
                      v.cue.id = D;
                      continue;
                    }
                  case "CUE":
                    if (!v.cue) {
                      v.state = "BADCUE";
                      continue;
                    }
                    try {
                      A(D, v.cue, v.regionList);
                    } catch {
                      v.cue = null, v.state = "BADCUE";
                      continue;
                    }
                    v.state = "CUETEXT";
                    continue;
                  case "CUETEXT":
                    {
                      var x = D.indexOf("-->") !== -1;
                      if (!D || x && (p = !0)) {
                        v.oncue && v.cue && v.oncue(v.cue), v.cue = null, v.state = "ID";
                        continue;
                      }
                      if (v.cue === null)
                        continue;
                      v.cue.text && (v.cue.text += `
`), v.cue.text += D;
                    }
                    continue;
                  case "BADCUE":
                    D || (v.state = "ID");
                }
              }
            } catch {
              v.state === "CUETEXT" && v.cue && v.oncue && v.oncue(v.cue), v.cue = null, v.state = v.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
            }
            return this;
          }, M.flush = function() {
            var c = this;
            try {
              if ((c.cue || c.state === "HEADER") && (c.buffer += `

`, c.parse()), c.state === "INITIAL" || c.state === "BADWEBVTT")
                throw new Error("Malformed WebVTT signature.");
            } catch (v) {
              c.onparsingerror && c.onparsingerror(v);
            }
            return c.onflush && c.onflush(), this;
          }, u;
        }();
      },
      "./src/utils/webvtt-parser.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          generateCueId: () => O,
          parseWebVTT: () => M
        });
        var b = a("./src/polyfills/number.ts"), y = a("./src/utils/vttparser.ts"), N = a("./src/demux/id3.ts"), E = a("./src/utils/timescale-conversion.ts"), B = a("./src/remux/mp4-remuxer.ts"), I = /\r\n|\n\r|\n|\r/g, T = function(c, v, g) {
          return g === void 0 && (g = 0), c.slice(g, g + v.length) === v;
        }, A = function(c) {
          var v = parseInt(c.slice(-3)), g = parseInt(c.slice(-6, -4)), m = parseInt(c.slice(-9, -7)), D = c.length > 9 ? parseInt(c.substring(0, c.indexOf(":"))) : 0;
          if (!(0, b.isFiniteNumber)(v) || !(0, b.isFiniteNumber)(g) || !(0, b.isFiniteNumber)(m) || !(0, b.isFiniteNumber)(D))
            throw Error("Malformed X-TIMESTAMP-MAP: Local:" + c);
          return v += 1e3 * g, v += 60 * 1e3 * m, v += 60 * 60 * 1e3 * D, v;
        }, w = function(c) {
          for (var v = 5381, g = c.length; g; )
            v = v * 33 ^ c.charCodeAt(--g);
          return (v >>> 0).toString();
        };
        function O(d, c, v) {
          return w(d.toString()) + w(c.toString()) + w(v);
        }
        var u = function(c, v, g) {
          var m = c[v], D = c[m.prevCC];
          if (!D || !D.new && m.new) {
            c.ccOffset = c.presentationOffset = m.start, m.new = !1;
            return;
          }
          for (; (L = D) !== null && L !== void 0 && L.new; ) {
            var L;
            c.ccOffset += m.start - D.start, m.new = !1, m = D, D = c[m.prevCC];
          }
          c.presentationOffset = g;
        };
        function M(d, c, v, g, m, D, L, p) {
          var x = new y.VTTParser(), k = (0, N.utf8ArrayToStr)(new Uint8Array(d)).trim().replace(I, `
`).split(`
`), _ = [], S = (0, E.toMpegTsClockFromTimescale)(c, v), h = "00:00.000", C = 0, f = 0, P, F = !0;
          x.oncue = function(R) {
            var U = g[m], K = g.ccOffset, V = (C - S) / 9e4;
            U != null && U.new && (f !== void 0 ? K = g.ccOffset = U.start : u(g, m, V)), V && (K = V - g.presentationOffset);
            var W = R.endTime - R.startTime, G = (0, B.normalizePts)((R.startTime + K - f) * 9e4, D * 9e4) / 9e4;
            R.startTime = Math.max(G, 0), R.endTime = Math.max(G + W, 0);
            var H = R.text.trim();
            R.text = decodeURIComponent(encodeURIComponent(H)), R.id || (R.id = O(R.startTime, R.endTime, H)), R.endTime > 0 && _.push(R);
          }, x.onparsingerror = function(R) {
            P = R;
          }, x.onflush = function() {
            if (P) {
              p(P);
              return;
            }
            L(_);
          }, k.forEach(function(R) {
            if (F)
              if (T(R, "X-TIMESTAMP-MAP=")) {
                F = !1, R.slice(16).split(",").forEach(function(U) {
                  T(U, "LOCAL:") ? h = U.slice(6) : T(U, "MPEGTS:") && (C = parseInt(U.slice(7)));
                });
                try {
                  f = A(h) / 1e3;
                } catch (U) {
                  P = U;
                }
                return;
              } else
                R === "" && (F = !1);
            x.parse(R + `
`);
          }), x.flush();
        }
      },
      "./src/utils/xhr-loader.ts": (o, l, a) => {
        a.r(l), a.d(l, {
          default: () => B
        });
        var b = a("./src/utils/logger.ts"), y = a("./src/loader/load-stats.ts"), N = /^age:\s*[\d.]+\s*$/m, E = /* @__PURE__ */ function() {
          function I(A) {
            this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = void 0, this.loader = null, this.stats = void 0, this.xhrSetup = A ? A.xhrSetup : null, this.stats = new y.LoadStats(), this.retryDelay = 0;
          }
          var T = I.prototype;
          return T.destroy = function() {
            this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null;
          }, T.abortInternal = function() {
            var w = this.loader;
            self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), w && (w.onreadystatechange = null, w.onprogress = null, w.readyState !== 4 && (this.stats.aborted = !0, w.abort()));
          }, T.abort = function() {
            var w;
            this.abortInternal(), (w = this.callbacks) !== null && w !== void 0 && w.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
          }, T.load = function(w, O, u) {
            if (this.stats.loading.start)
              throw new Error("Loader can only be used once.");
            this.stats.loading.start = self.performance.now(), this.context = w, this.config = O, this.callbacks = u, this.retryDelay = O.retryDelay, this.loadInternal();
          }, T.loadInternal = function() {
            var w = this.config, O = this.context;
            if (!!w) {
              var u = this.loader = new self.XMLHttpRequest(), M = this.stats;
              M.loading.first = 0, M.loaded = 0;
              var d = this.xhrSetup;
              try {
                if (d)
                  try {
                    d(u, O.url);
                  } catch {
                    u.open("GET", O.url, !0), d(u, O.url);
                  }
                u.readyState || u.open("GET", O.url, !0);
                var c = this.context.headers;
                if (c)
                  for (var v in c)
                    u.setRequestHeader(v, c[v]);
              } catch (g) {
                this.callbacks.onError({
                  code: u.status,
                  text: g.message
                }, O, u);
                return;
              }
              O.rangeEnd && u.setRequestHeader("Range", "bytes=" + O.rangeStart + "-" + (O.rangeEnd - 1)), u.onreadystatechange = this.readystatechange.bind(this), u.onprogress = this.loadprogress.bind(this), u.responseType = O.responseType, self.clearTimeout(this.requestTimeout), this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), w.timeout), u.send();
            }
          }, T.readystatechange = function() {
            var w = this.context, O = this.loader, u = this.stats;
            if (!(!w || !O)) {
              var M = O.readyState, d = this.config;
              if (!u.aborted && M >= 2)
                if (self.clearTimeout(this.requestTimeout), u.loading.first === 0 && (u.loading.first = Math.max(self.performance.now(), u.loading.start)), M === 4) {
                  O.onreadystatechange = null, O.onprogress = null;
                  var c = O.status, v = O.responseType === "arraybuffer";
                  if (c >= 200 && c < 300 && (v && O.response || O.responseText !== null)) {
                    u.loading.end = Math.max(self.performance.now(), u.loading.first);
                    var g, m;
                    if (v ? (g = O.response, m = g.byteLength) : (g = O.responseText, m = g.length), u.loaded = u.total = m, !this.callbacks)
                      return;
                    var D = this.callbacks.onProgress;
                    if (D && D(u, w, g, O), !this.callbacks)
                      return;
                    var L = {
                      url: O.responseURL,
                      data: g
                    };
                    this.callbacks.onSuccess(L, u, w, O);
                  } else
                    u.retry >= d.maxRetry || c >= 400 && c < 499 ? (b.logger.error(c + " while loading " + w.url), this.callbacks.onError({
                      code: c,
                      text: O.statusText
                    }, w, O)) : (b.logger.warn(c + " while loading " + w.url + ", retrying in " + this.retryDelay + "..."), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay), this.retryDelay = Math.min(2 * this.retryDelay, d.maxRetryDelay), u.retry++);
                } else
                  self.clearTimeout(this.requestTimeout), this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), d.timeout);
            }
          }, T.loadtimeout = function() {
            b.logger.warn("timeout while loading " + this.context.url);
            var w = this.callbacks;
            w && (this.abortInternal(), w.onTimeout(this.stats, this.context, this.loader));
          }, T.loadprogress = function(w) {
            var O = this.stats;
            O.loaded = w.loaded, w.lengthComputable && (O.total = w.total);
          }, T.getCacheAge = function() {
            var w = null;
            if (this.loader && N.test(this.loader.getAllResponseHeaders())) {
              var O = this.loader.getResponseHeader("age");
              w = O ? parseFloat(O) : null;
            }
            return w;
          }, I;
        }();
        const B = E;
      },
      "./node_modules/eventemitter3/index.js": (o) => {
        var l = Object.prototype.hasOwnProperty, a = "~";
        function b() {
        }
        Object.create && (b.prototype = /* @__PURE__ */ Object.create(null), new b().__proto__ || (a = !1));
        function y(I, T, A) {
          this.fn = I, this.context = T, this.once = A || !1;
        }
        function N(I, T, A, w, O) {
          if (typeof A != "function")
            throw new TypeError("The listener must be a function");
          var u = new y(A, w || I, O), M = a ? a + T : T;
          return I._events[M] ? I._events[M].fn ? I._events[M] = [I._events[M], u] : I._events[M].push(u) : (I._events[M] = u, I._eventsCount++), I;
        }
        function E(I, T) {
          --I._eventsCount === 0 ? I._events = new b() : delete I._events[T];
        }
        function B() {
          this._events = new b(), this._eventsCount = 0;
        }
        B.prototype.eventNames = function() {
          var T = [], A, w;
          if (this._eventsCount === 0)
            return T;
          for (w in A = this._events)
            l.call(A, w) && T.push(a ? w.slice(1) : w);
          return Object.getOwnPropertySymbols ? T.concat(Object.getOwnPropertySymbols(A)) : T;
        }, B.prototype.listeners = function(T) {
          var A = a ? a + T : T, w = this._events[A];
          if (!w)
            return [];
          if (w.fn)
            return [w.fn];
          for (var O = 0, u = w.length, M = new Array(u); O < u; O++)
            M[O] = w[O].fn;
          return M;
        }, B.prototype.listenerCount = function(T) {
          var A = a ? a + T : T, w = this._events[A];
          return w ? w.fn ? 1 : w.length : 0;
        }, B.prototype.emit = function(T, A, w, O, u, M) {
          var d = a ? a + T : T;
          if (!this._events[d])
            return !1;
          var c = this._events[d], v = arguments.length, g, m;
          if (c.fn) {
            switch (c.once && this.removeListener(T, c.fn, void 0, !0), v) {
              case 1:
                return c.fn.call(c.context), !0;
              case 2:
                return c.fn.call(c.context, A), !0;
              case 3:
                return c.fn.call(c.context, A, w), !0;
              case 4:
                return c.fn.call(c.context, A, w, O), !0;
              case 5:
                return c.fn.call(c.context, A, w, O, u), !0;
              case 6:
                return c.fn.call(c.context, A, w, O, u, M), !0;
            }
            for (m = 1, g = new Array(v - 1); m < v; m++)
              g[m - 1] = arguments[m];
            c.fn.apply(c.context, g);
          } else {
            var D = c.length, L;
            for (m = 0; m < D; m++)
              switch (c[m].once && this.removeListener(T, c[m].fn, void 0, !0), v) {
                case 1:
                  c[m].fn.call(c[m].context);
                  break;
                case 2:
                  c[m].fn.call(c[m].context, A);
                  break;
                case 3:
                  c[m].fn.call(c[m].context, A, w);
                  break;
                case 4:
                  c[m].fn.call(c[m].context, A, w, O);
                  break;
                default:
                  if (!g)
                    for (L = 1, g = new Array(v - 1); L < v; L++)
                      g[L - 1] = arguments[L];
                  c[m].fn.apply(c[m].context, g);
              }
          }
          return !0;
        }, B.prototype.on = function(T, A, w) {
          return N(this, T, A, w, !1);
        }, B.prototype.once = function(T, A, w) {
          return N(this, T, A, w, !0);
        }, B.prototype.removeListener = function(T, A, w, O) {
          var u = a ? a + T : T;
          if (!this._events[u])
            return this;
          if (!A)
            return E(this, u), this;
          var M = this._events[u];
          if (M.fn)
            M.fn === A && (!O || M.once) && (!w || M.context === w) && E(this, u);
          else {
            for (var d = 0, c = [], v = M.length; d < v; d++)
              (M[d].fn !== A || O && !M[d].once || w && M[d].context !== w) && c.push(M[d]);
            c.length ? this._events[u] = c.length === 1 ? c[0] : c : E(this, u);
          }
          return this;
        }, B.prototype.removeAllListeners = function(T) {
          var A;
          return T ? (A = a ? a + T : T, this._events[A] && E(this, A)) : (this._events = new b(), this._eventsCount = 0), this;
        }, B.prototype.off = B.prototype.removeListener, B.prototype.addListener = B.prototype.on, B.prefixed = a, B.EventEmitter = B, o.exports = B;
      },
      "./node_modules/url-toolkit/src/url-toolkit.js": function(o) {
        (function(l) {
          var a = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, b = /^(?=([^\/?#]*))\1([^]*)$/, y = /(?:\/|^)\.(?=\/)/g, N = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, E = {
            buildAbsoluteURL: function(B, I, T) {
              if (T = T || {}, B = B.trim(), I = I.trim(), !I) {
                if (!T.alwaysNormalize)
                  return B;
                var A = E.parseURL(B);
                if (!A)
                  throw new Error("Error trying to parse base URL.");
                return A.path = E.normalizePath(
                  A.path
                ), E.buildURLFromParts(A);
              }
              var w = E.parseURL(I);
              if (!w)
                throw new Error("Error trying to parse relative URL.");
              if (w.scheme)
                return T.alwaysNormalize ? (w.path = E.normalizePath(w.path), E.buildURLFromParts(w)) : I;
              var O = E.parseURL(B);
              if (!O)
                throw new Error("Error trying to parse base URL.");
              if (!O.netLoc && O.path && O.path[0] !== "/") {
                var u = b.exec(O.path);
                O.netLoc = u[1], O.path = u[2];
              }
              O.netLoc && !O.path && (O.path = "/");
              var M = {
                scheme: O.scheme,
                netLoc: w.netLoc,
                path: null,
                params: w.params,
                query: w.query,
                fragment: w.fragment
              };
              if (!w.netLoc && (M.netLoc = O.netLoc, w.path[0] !== "/"))
                if (!w.path)
                  M.path = O.path, w.params || (M.params = O.params, w.query || (M.query = O.query));
                else {
                  var d = O.path, c = d.substring(0, d.lastIndexOf("/") + 1) + w.path;
                  M.path = E.normalizePath(c);
                }
              return M.path === null && (M.path = T.alwaysNormalize ? E.normalizePath(w.path) : w.path), E.buildURLFromParts(M);
            },
            parseURL: function(B) {
              var I = a.exec(B);
              return I ? {
                scheme: I[1] || "",
                netLoc: I[2] || "",
                path: I[3] || "",
                params: I[4] || "",
                query: I[5] || "",
                fragment: I[6] || ""
              } : null;
            },
            normalizePath: function(B) {
              for (B = B.split("").reverse().join("").replace(y, ""); B.length !== (B = B.replace(N, "")).length; )
                ;
              return B.split("").reverse().join("");
            },
            buildURLFromParts: function(B) {
              return B.scheme + B.netLoc + B.path + B.params + B.query + B.fragment;
            }
          };
          o.exports = E;
        })();
      }
    }, i = {};
    function n(o) {
      var l = i[o];
      if (l !== void 0)
        return l.exports;
      var a = i[o] = {
        exports: {}
      };
      return t[o].call(a.exports, a, a.exports, n), a.exports;
    }
    n.m = t, n.n = (o) => {
      var l = o && o.__esModule ? () => o.default : () => o;
      return n.d(l, { a: l }), l;
    }, n.d = (o, l) => {
      for (var a in l)
        n.o(l, a) && !n.o(o, a) && Object.defineProperty(o, a, { enumerable: !0, get: l[a] });
    }, n.o = (o, l) => Object.prototype.hasOwnProperty.call(o, l), n.r = (o) => {
      typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
    };
    var s = n("./src/hls.ts");
    return s = s.default, s;
  })());
})(rl);
const Ba = /* @__PURE__ */ Qo(rl.exports);
class il extends Error {
  constructor(e) {
    super(e), this.name = "NotImplementedException";
  }
}
class Cf {
  constructor() {
    j(this, "_hls", null);
  }
  get isLoading() {
    return !0;
  }
  load(e, t, i = !0) {
    if (i && e.canPlayType("application/vnd.apple.mpegurl"))
      e.setAttribute("src", t), e.setAttribute("data-decoder-type", "Native");
    else if (Ba.isSupported())
      this._hls = new Ba({
        maxMaxBufferLength: 20,
        maxBufferHole: 0.5,
        backBufferLength: 10,
        lowLatencyMode: !0,
        enableWorker: !0
      }), this._hls.loadSource(t), this._hls.attachMedia(e), e.setAttribute("data-decoder-type", "HLS.js");
    else
      throw new Error("media not supported.");
    e.load();
  }
  unload(e) {
    this._hls && (this._hls.detachMedia(), this._hls.destroy(), this._hls = null), e.pause(), e.setAttribute("src", ""), e.load();
  }
  stopLoading() {
    throw new il();
  }
}
var Ht;
(function(r) {
  r[r.Debug = 0] = "Debug", r[r.Log = 1] = "Log", r[r.Info = 2] = "Info", r[r.Warn = 3] = "Warn", r[r.Error = 4] = "Error";
})(Ht || (Ht = {}));
class be {
  static get debug() {
    return this.logLevel <= Ht.Debug ? console.debug : this.emptyEvent;
  }
  static get log() {
    return this.logLevel <= Ht.Log ? console.log : this.emptyEvent;
  }
  static get info() {
    return this.logLevel <= Ht.Info ? console.info : this.emptyEvent;
  }
  static get warn() {
    return this.logLevel <= Ht.Warn ? console.warn : this.emptyEvent;
  }
  static get error() {
    return this.logLevel <= Ht.Error ? console.error : this.emptyEvent;
  }
  static setLogLevel(e) {
    this.logLevel = e;
  }
}
j(be, "logLevel", Ht.Debug), j(be, "emptyEvent", (...e) => {
});
class Pf {
  get isLoading() {
    return !0;
  }
  load(e, t, i = !0) {
    e.setAttribute("src", t), be.debug(e);
  }
  unload(e) {
    e.pause(), e.removeAttribute("src"), e.load();
  }
  stopLoading() {
    throw new il();
  }
}
var ar;
(function(r) {
  r.MP4 = "MP4", r.HLS = "HLS", r.MP3 = "MP3", r.AAC = "AAC", r.UNKNOWN = "UNKNOWN";
})(ar || (ar = {}));
var at;
(function(r) {
  r[r.Video = 0] = "Video", r[r.Audio = 1] = "Audio";
})(at || (at = {}));
var Ua;
(function(r) {
  r[r.None = 0] = "None", r[r.Loading = 1] = "Loading", r[r.CanPlay = 2] = "CanPlay", r[r.Completed = 3] = "Completed", r[r.Failed = 4] = "Failed", r[r.Disposed = 8] = "Disposed";
})(Ua || (Ua = {}));
class Ks {
  constructor(e = at.Video, t) {
    j(this, "onCanPlay", new ge());
    j(this, "onSeeked", new ge());
    j(this, "_media");
    j(this, "_url");
    j(this, "_containerType");
    j(this, "_mediaDelegate");
    j(this, "_seekStartTime", -1);
    j(this, "_willSeekAt", -1);
    j(this, "_nextTickEvent", []);
    j(this, "_played", !1);
    j(this, "_useNative", !0);
    j(this, "_hasControlPermission", !1);
    j(this, "_mediaType");
    j(this, "_isSeeking", !1);
    j(this, "_lastSeekDiffTime", 0);
    j(this, "_aspectOverride");
    j(this, "_muted", !0);
    j(this, "_uuid", ks());
    j(this, "_currentTime", 0);
    this._url = t, this._mediaType = e, this._media = Ks._createMedia(e), this._media.muted = this._muted, this._media.addEventListener("timeupdate", this._onTimesUpdate.bind(this)), this._media.addEventListener("loadedmetadata", () => {
      this._media.currentTime !== this._currentTime && (this.currentTime = this._currentTime);
    }), this._media.addEventListener("seeked", () => {
      this._isSeeking = !1, this._currentTime = this._media.currentTime;
    }), this._media.addEventListener("suspend", () => {
    }), this._media.addEventListener("waiting", () => {
    });
  }
  get hasControlPermission() {
    return this._hasControlPermission;
  }
  get mediaType() {
    return this._mediaType;
  }
  get isSeeking() {
    return this._media.seeking;
  }
  get lastSeekDiffTime() {
    return this._lastSeekDiffTime;
  }
  get isPlaying() {
    return !this._media.paused && !this._media.ended && this._media.currentTime > 0 && this._media.readyState > this._media.HAVE_CURRENT_DATA;
  }
  get isCanPlay() {
    return this._media.readyState >= 4 && !this._isSeeking;
  }
  get isReadable() {
    return this.isCanPlay && this._played;
  }
  get aspectOverride() {
    return this._aspectOverride;
  }
  set aspectOverride(e) {
    this._aspectOverride = e;
  }
  get muted() {
    return this._muted;
  }
  set muted(e) {
    this._muted = e, this._hasControlPermission && (this._media.muted = this._muted);
  }
  get volume() {
    return this._media.volume;
  }
  set volume(e) {
    this._media.volume = e;
  }
  get uuid() {
    return this._uuid;
  }
  get url() {
    return this._url;
  }
  get currentTime() {
    return this._currentTime;
  }
  set currentTime(e) {
    this._media.currentTime !== e && (this._isSeeking = !0), this._currentTime = e, this._media.fastSeek ? this._media.fastSeek(this._currentTime) : this._media.currentTime = this._currentTime;
  }
  get duration() {
    return this._media.duration || 0;
  }
  get el() {
    return this._media;
  }
  get aspect() {
    return this.aspectOverride !== void 0 ? this.aspectOverride : this._media && this._media instanceof HTMLVideoElement ? this._media.videoWidth / this._media.videoHeight : 1;
  }
  get frame() {
    return Math.floor(this._currentTime / (1 / 60));
  }
  static _createMedia(e) {
    const t = document.createElement(e === at.Video ? "video" : "audio");
    return t.muted = !0, t.crossOrigin = "Anonymous", t.setAttribute("controls", "false"), t.setAttribute("preload", "metadata"), t.loop = !1, t.setAttribute("playsinline", "true"), t.setAttribute("webkit-playsinline", "true"), t.playsinline = !0, t;
  }
  dispose() {
    this._media.src = "", this._media.load();
  }
  reload() {
    this.unload(), this.load(this._containerType, this._useNative);
  }
  load(e, t = !0) {
    this._containerType = e != null ? e : this.detectContentType(), this._useNative = t, this._containerType === ar.HLS && (this._mediaDelegate = new Cf()), this._containerType === ar.MP4 && (this._mediaDelegate = new Pf()), this._mediaDelegate && this._mediaDelegate.load(this._media, this._url, t);
  }
  detectContentType() {
    const e = this.url;
    return e.endsWith("m3u8") ? ar.HLS : e.endsWith("mp4") ? ar.MP4 : ar.UNKNOWN;
  }
  unload() {
    this._mediaDelegate && this._mediaDelegate.unload(this._media);
  }
  play() {
    !this._hasControlPermission && this._mediaType === at.Audio || this._media.play();
  }
  playAndSeek(e) {
    this._media.play(), this._willSeekAt = e, this._seekStartTime = Date.now();
  }
  stop() {
    this._media.pause(), this._media.currentTime = 0;
  }
  pause() {
    this._media.pause();
  }
  update(e) {
    this.isCanPlay && (this._currentTime = this._media.currentTime);
  }
  allowControl() {
    this._media && this._media.src && (this._hasControlPermission = !0, this._media.muted = this.muted);
  }
  _onTimesUpdate() {
    this._played = !0, this._currentTime = this._media.currentTime;
  }
}
var vi;
class fr {
  constructor() {
    j(this, "_syncTimer", 0);
    j(this, "_seekTime", -1);
    j(this, "_requestSync", !1);
    j(this, "_requestPlaying", !1);
    j(this, "_nextStreamId", -1);
    j(this, "_nextTransformId", -1);
    j(this, "_nextVideoTarget", null);
    j(this, "_currentTime", 0);
    j(this, "_allowControl", !1);
    ba(this, vi, 0);
    j(this, "_loop", !0);
    j(this, "_activeTransformId", -1);
    j(this, "_activeVideoTarget", null);
    j(this, "_activeStreamId", -1);
    j(this, "_streams", {});
    j(this, "_playing", !1);
    j(this, "_muted", !1);
    j(this, "_volume", 1);
  }
  get loop() {
    return this._loop;
  }
  set loop(e) {
    this._loop = e, this.streams.forEach((t) => {
      t.el.loop = e;
    });
  }
  get activeTransformId() {
    return this._activeTransformId;
  }
  get activeVideoTarget() {
    return this._activeVideoTarget;
  }
  get activeStreamId() {
    var e, t;
    return (t = (e = this._activeVideoTarget) == null ? void 0 : e.sourceId) != null ? t : -1;
  }
  get duration() {
    return this.streams.reduce((e, t) => Math.min(e, t.duration), Number.MAX_VALUE);
  }
  get streams() {
    return Object.keys(this._streams).map((e) => this._streams[e].stream);
  }
  get videoStreamMap() {
    return Object.keys(this._streams).filter((e) => this._streams[+e] && this._streams[+e].stream.mediaType === at.Video).map((e) => [+e, this._streams[+e].stream]);
  }
  get videoStreams() {
    return this.streams.filter((e) => e.mediaType === at.Video);
  }
  get audioStreams() {
    return this.streams.filter((e) => e.mediaType === at.Audio);
  }
  get playing() {
    return this._playing;
  }
  set playing(e) {
    this._playing !== e && (this._requestPlaying = !0, this.sync()), this._playing = e;
  }
  get activeStream() {
    var e, t;
    return this._activeVideoTarget && (t = (e = this._streams[this._activeStreamId]) == null ? void 0 : e.stream) != null ? t : null;
  }
  get isLoading() {
    return this.activeStream ? !this.activeStream.isCanPlay : !0;
  }
  get isPreLoading() {
    return !!this._nextVideoTarget;
  }
  get muted() {
    return this._muted;
  }
  set muted(e) {
    this._muted = e;
  }
  get volume() {
    return this._volume;
  }
  set volume(e) {
    this._volume = We(e, 0, 1);
  }
  static createStream(e, t) {
    const i = new Ks(e, t.url);
    return i.load(void 0, this.useNative), e === at.Video && t.aspect && (i.aspectOverride = Array.isArray(t.aspect) ? t.aspect[0] / t.aspect[1] : t.aspect), i;
  }
  dispose() {
    return Object.keys(this._streams).forEach((e) => {
      this._streams[+e].stream.unload(), delete this._streams[+e];
    });
  }
  clear() {
    Object.keys(this._streams).forEach((e) => this._streams[+e].willDestroy = !0), this._unloadStreams(), this._seekTime = -1, this._requestSync = !1, this._requestPlaying = !1, this._nextStreamId = -1, this._nextVideoTarget = null, this._activeVideoTarget = null;
  }
  hasStream(e) {
    return this._streams[e] && !this._streams[e].willDestroy;
  }
  getStream(e) {
    return this.hasStream(e) ? this._streams[e].stream : null;
  }
  addStream(e, t, i = !1, n = !0) {
    this._streams[e] || (this._allowControl && t.allowControl(), t.el.loop = this._loop, this._streams[e] = {
      stream: t,
      willDestroy: !1,
      unloadOnBlur: i,
      loadingTime: 0,
      active: n,
      synced: !1
    });
  }
  removeStream(e) {
    this._streams[e] && (this._streams[e].willDestroy = !0);
  }
  removeInactiveStream() {
    Object.keys(this._streams).forEach((e) => {
      this._streams[+e].active || (this._streams[+e].willDestroy = !0);
    });
  }
  changeActiveTrack(e, t = -1) {
    var n;
    const i = e.sourceId;
    if (!(this._nextVideoTarget === e && this._nextTransformId === t)) {
      if (!this._streams[i])
        throw new Error(`Stream ${i} is not loaded`);
      if (this._streams[i].active = !0, (n = this._streams[this._nextStreamId]) != null && n.unloadOnBlur && (this._streams[this._nextStreamId].willDestroy = !0), this._nextStreamId = -1, this._nextTransformId = -1, this._nextVideoTarget = null, this._activeStreamId === i) {
        this._activeVideoTarget = e, this._activeTransformId = t;
        return;
      }
      this._nextStreamId = i, this._nextTransformId = t, this._nextVideoTarget = e, be.debug("[StreamingManager] queue next", i), this._streams[this._activeStreamId] && this._streams[this._activeStreamId].unloadOnBlur && (this._streams[this._activeStreamId].willDestroy = !0);
    }
  }
  seek(e, t = !1) {
    this._currentTime = e, this.activeStream && (this.activeStream.currentTime = this._currentTime), Object.keys(this._streams).forEach((n) => {
      const s = this._streams[+n].stream;
      s !== this.activeStream && (s.currentTime = e);
    }), t ? (this._syncTimer > 0 && clearTimeout(this._syncTimer), this._syncTimer = window.setTimeout(() => {
      this.sync();
    }, 500)) : Object.keys(this._streams).map((s) => this._streams[+s].stream).forEach((s) => {
      s.currentTime = e;
    });
  }
  play() {
    this.playing = !0, be.debug("[StreamingManager] play");
  }
  pause() {
    this.playing = !1, be.debug("[StreamingManager] pause");
  }
  stop() {
    this.playing = !1, this.seek(0), be.debug("[StreamingManager] stop");
  }
  sync() {
    this._requestSync = !0;
  }
  allowControl() {
    const e = this.streams.every((t) => t.hasControlPermission);
    if (this._allowControl = !0, !e) {
      for (const t of this.streams)
        t.allowControl();
      this.sync();
    }
  }
  update(e, t) {
    this._requestSync && this._syncStreams(e) && (this._requestSync = !1);
    const i = this.activeStream, n = this.streams;
    for (const s of n)
      s.muted = this._muted, s.volume = this._volume, s.update(e), s.isCanPlay && s.isPlaying !== this.playing && (this.playing ? s.play() : s.pause());
    if (this._nextStreamId >= 0 && this._activeStreamId !== this._nextStreamId) {
      const s = this._streams[this._nextStreamId];
      s.synced || !this.activeStream ? (this._activeStreamId = this._nextStreamId, this._activeTransformId = this._nextTransformId, this._activeVideoTarget = this._nextVideoTarget, this._nextStreamId = -1, this._nextTransformId = -1, this._nextVideoTarget = null, s.loadingTime = 0, be.debug("[StreamingManager] changed!", this._activeStreamId, this._activeTransformId)) : (s.loadingTime += e, this.sync());
    }
    i && i.onCanPlay && this.duration > 0 && this.duration <= i.currentTime && (this._loop ? this.seek(0) : this.pause()), this._unloadStreams(), t.extraDebugMessages.s = Object.keys(this._streams).map((s) => {
      const o = this._streams[+s], l = o.stream.mediaType === at.Video ? "V" : "A";
      let a = "";
      return o.willDestroy ? a = "DE" : o.active ? o.synced ? o.stream.isPlaying ? a = "AP" : a = "AS" : a = "SK" : a = "PR", `${l}:${a}`;
    });
  }
  _syncStreams(e) {
    const t = Object.keys(this._streams), i = this._streams[this._activeStreamId];
    return i ? t.every((s) => {
      const o = this._streams[+s];
      if (!o.active)
        return !0;
      if (!o.stream.hasControlPermission || !o.stream.isCanPlay)
        return !1;
      if (this.playing !== o.stream.isPlaying && (this.playing ? o.stream.play() : o.stream.pause()), !o.stream.isSeeking) {
        const a = o.stream.currentTime - i.stream.currentTime;
        if (Math.abs(a) > (o.stream.mediaType === at.Video ? 3 / 30 : 10 / 30)) {
          const b = Math.max(0, a), y = Date.now();
          xa(this, vi) + 250 <= y && (this.playing ? o.stream.currentTime = i.stream.currentTime + b : o.stream.currentTime = i.stream.currentTime, Aa(this, vi, y));
        } else
          o.synced = !0;
      }
      const l = o.stream.currentTime - i.stream.currentTime;
      return Math.abs(l) <= (o.stream.mediaType === at.Video ? 3 / 30 : 10 / 30);
    }) : !1;
  }
  _unloadStreams() {
    const e = Object.keys(this._streams), t = this._streams[this._activeStreamId];
    return e.forEach((i) => {
      const n = this._streams[+i];
      n.willDestroy && n !== t && (n.stream.unload(), delete this._streams[+i]);
    });
  }
}
vi = new WeakMap(), j(fr, "useNative", !0);
class Ka {
  constructor(e, t, i) {
    j(this, "manager");
    j(this, "content");
    j(this, "currentGroup");
    j(this, "singleStreamTimerId", -1);
    j(this, "_currentGroupId", -1);
    j(this, "_currentVideoId", -1);
    be.debug(e, t, i), this.manager = e, t && this.updateContent(t), i !== void 0 && this.changeGroup(i);
  }
  get currentGroupId() {
    return this._currentGroupId;
  }
  get currentVideoId() {
    return this._currentVideoId;
  }
  get currentVideoIndex() {
    try {
      return this.getGroup().videoIds.indexOf(this.currentVideoId);
    } catch {
      return -1;
    }
  }
  get activeTransformId() {
    return this.manager.activeTransformId;
  }
  dispose() {
  }
  update(e) {
    var t, i;
    (i = (t = this.manager.activeStream) == null ? void 0 : t.currentTime) != null;
  }
  getGroup() {
    if (!this.currentGroup)
      throw new Error("Group is not loaded yet");
    return this.currentGroup;
  }
  updateContent(e) {
    this.content = e;
    for (const t of this.content.audioTracks) {
      const i = t.sourceId, n = this.content.getSource(i);
      if (!this.manager.hasStream(i)) {
        const s = fr.createStream(at.Audio, n);
        s.muted = !1, this.manager.addStream(i, s);
      }
    }
  }
  getContent() {
    if (!this.content)
      throw new Error("content is not loaded");
    return this.content;
  }
  changeGroup(e, t) {
    this._currentGroupId !== e && (this._currentGroupId !== -1 && this.removeGroup(this._currentGroupId, e), this.activateGroup(e)), this.currentGroup && (t !== void 0 ? this.selectVideoWithIndex(t) : this.selectVideoWithVideoId(this.currentGroup.data.defaultVideoId)), be.debug("[GroupManager] group changed", this);
  }
  selectVideoWithIndex(e) {
    let t;
    const i = this.getGroup().videoIds;
    this.getGroup().data.cyclic ? t = (e + Math.ceil(Math.abs(e) / i.length) * i.length) % i.length : t = We(e, 0, i.length - 1), this.selectVideoWithVideoId(i[t]);
  }
  selectVideoWithVideoId(e) {
    var n, s;
    const t = this.getContent().getVideoTrack(e), i = t.getRegionAt((s = (n = this.manager.activeStream) == null ? void 0 : n.currentTime) != null ? s : 0);
    !i || !i.tiled && !i.single || (be.debug("[GroupManager] select", e, "timer:", this.singleStreamTimerId), this.singleStreamTimerId > -1 && (be.debug("[timer] clear"), clearTimeout(this.singleStreamTimerId), this.singleStreamTimerId = -1), this._currentVideoId = e, i.tiled ? this.selectTiledTrack(t, i) : i.single && this.selectSingleTrack(t, i));
  }
  selectTiledTrack(e, t) {
    const i = t.tiled;
    if (!i)
      throw new Error("VideoTrack has no tiled video target");
    be.debug("[GroupManager] select tiled", i.sourceId), this.manager.changeActiveTrack(i, e.data.transformId), this.singleStreamTimerId > -1 && (clearTimeout(this.singleStreamTimerId), this.singleStreamTimerId = -1), t.single && (be.debug("[timer] single switch timer start"), this.manager.removeInactiveStream(), this.selectSingleTrack(e, t, !0), this.singleStreamTimerId = window.setTimeout(() => {
      var n, s;
      be.debug("[timer] request single switch"), this.singleStreamTimerId = -1, this.selectSingleTrack(e, t), this.manager.seek((s = (n = this.manager.activeStream) == null ? void 0 : n.currentTime) != null ? s : 0);
    }, 1e3));
  }
  selectSingleTrack(e, t, i = !1) {
    const n = t.single;
    if (!n)
      throw new Error("VideoTrack has no single video target");
    if (be.debug("[GroupManager] select single", n.sourceId), !this.manager.hasStream(n.sourceId)) {
      const s = this.getContent().getSource(n.sourceId), o = fr.createStream(at.Video, s);
      console.log("addStream"), this.manager.addStream(n.sourceId, o, !0, !i);
    }
    i || this.manager.changeActiveTrack(n, e.data.transformId);
  }
  activateGroup(e) {
    const t = this.getContent().getGroup(e);
    this._currentGroupId = e, this.currentGroup = t;
    const i = t.getSources("tiled");
    for (const { sourceId: n, source: s } of i)
      if (!this.manager.hasStream(n)) {
        be.debug("[GroupManager] add stream", n);
        const o = fr.createStream(at.Video, s);
        this.manager.addStream(n, o);
      }
    this.selectVideoWithVideoId(this.currentGroup.data.defaultVideoId);
  }
  removeGroup(e, t) {
    const i = this.getContent().getGroup(e), n = this.getContent().getGroup(t), s = i.getSourceIds("both"), o = n.getSourceIds("tiled"), l = s.filter((a) => o.indexOf(a) === -1);
    for (const a of l)
      this.manager.hasStream(a) && this.manager.removeStream(a);
  }
}
class Rf {
  constructor() {
    j(this, "player");
    j(this, "markers", []);
  }
  onSetup(e) {
    this.player = e;
  }
  dispose() {
  }
  onUpdate(e) {
    const t = e.data.markers || [];
    this.markers = t.filter((i) => i.event === Hu.None), be.debug(t);
  }
  onExposeStatus(e) {
    e.timeMarkers !== this.markers && (e.timeMarkers = this.markers);
  }
}
const Va = {
  [Kt.FreeView]: ln,
  [Kt.MultiSelect]: un
}, Es = () => ({
  isPlaying: !1,
  currentTime: 0,
  frameDuration: 1 / 30,
  seekingTime: 0,
  isLoading: !1,
  isStarted: !1,
  isFrameControl: !1,
  duration: 0,
  title: "",
  description: "",
  caption: "",
  captionColor: "white",
  captionOpacity: 1,
  captionBgColor: "black",
  captionSize: "1em",
  captionTextAlign: "center",
  captionJustify: "center",
  captionAlign: "end",
  captionOffsetX: "0",
  captionOffsetY: "0",
  captionWritingMode: "horizontal-tb",
  captionInlineSize: "auto",
  currentMode: Kt.FreeView,
  currentVideoId: -1,
  currentVideoIndex: -1,
  currentTransformId: -1,
  currentGroupId: -1,
  isMuted: !0,
  volume: 1,
  loadingTime: 0,
  timeMarkers: [],
  loop: !1
});
class Mf {
  constructor(e, t = {}) {
    j(this, "exposedStates", { ...Es() });
    j(this, "userAgent", new Zo());
    j(this, "lastSize", { width: 0, height: 0 });
    j(this, "_options");
    j(this, "_currentMode", null);
    j(this, "_renderer");
    j(this, "_debugElement", null);
    j(this, "_eventSystem");
    j(this, "_videoGroupManager");
    j(this, "_mainEventNode");
    j(this, "_currentTransformSetId", 0);
    j(this, "_isMuted", !1);
    j(this, "_volume", 1);
    j(this, "_nextPlayingState", "");
    j(this, "_muteToPlay", !1);
    j(this, "features", []);
    j(this, "_setFrameTimer", 0);
    j(this, "_onEndOfFrame", new ge());
    j(this, "_streamingManager", new fr());
    j(this, "_updateEveryTexture", !1);
    j(this, "_extraDebugMessages", {});
    j(this, "_el");
    j(this, "_translate", new Rt());
    j(this, "_scale", 1);
    j(this, "_eventController");
    j(this, "_content", null);
    var i, n;
    be.setLogLevel((i = t.logLevel) != null ? i : Ht.Error), this._el = e, this._options = Object.assign({
      enableInput: !0,
      inputHandlerElement: null,
      displayScale: 1,
      autoStart: !0,
      displayMode: Kt.FreeView,
      content: null
    }, t), this._applyEnvironment(), this._renderer = new Fs(this._el), this._renderer.draw(0), this._eventSystem = this._renderer.scene.addComponent(cr), this._eventSystem.el = (n = this._options.inputHandlerElement) != null ? n : this._el, this._eventSystem.camera = this._renderer.camera, this._mainEventNode = new on(this._renderer.context, this._renderer.scene, "EventSystem"), this._mainEventNode.color.set(1, 0, 1), this._mainEventNode.opacity = 0, this._mainEventNode.drawOrder = -1, this._mainEventNode.stencilWrite = !1, this._mainEventNode.stencilOp = {
      fail: Pe.KEEP,
      zFail: Pe.KEEP,
      zPass: Pe.REPLACE
    }, this._mainEventNode.stencilFunc = {
      func: Ze.ALWAYS,
      ref: 1,
      mask: 255
    }, this._eventController = this._mainEventNode.addComponent(Bs), this._setupInput(), Da.add(this, this.update), this._videoGroupManager = new Ka(this._streamingManager), this._options.content && this.loadContent(this._options.content), [Rf].forEach((s) => {
      const o = new s();
      this.features.push(o), o.onSetup(this);
    }), window.addEventListener("pointerdown", () => {
      this._streamingManager.allowControl();
    }), window.addEventListener("keydown", () => {
      this._streamingManager.allowControl();
    });
  }
  get streamingManager() {
    return this._streamingManager;
  }
  get updateEveryTexture() {
    return this._updateEveryTexture;
  }
  set updateEveryTexture(e) {
    this._updateEveryTexture = e;
  }
  get currentTime() {
    var e, t;
    return (t = (e = this._streamingManager.activeStream) == null ? void 0 : e.currentTime) != null ? t : 0;
  }
  get onEndOfFrame() {
    return this._onEndOfFrame;
  }
  get extraDebugMessages() {
    return this._extraDebugMessages;
  }
  get el() {
    return this._el;
  }
  get translate() {
    return this._translate;
  }
  get scale() {
    return this._scale;
  }
  set scale(e) {
    this._scale = e;
  }
  get eventController() {
    return this._eventController;
  }
  get tracker() {
    return Xt;
  }
  get currentGroupVideoIndex() {
    return this.getVideoGroupManager().currentVideoIndex;
  }
  get content() {
    var e, t;
    return (t = (e = this._content) == null ? void 0 : e.data) != null ? t : null;
  }
  get currentGroupId() {
    return this.getVideoGroupManager().currentGroupId;
  }
  get activeVideoTarget() {
    return this._streamingManager.activeVideoTarget;
  }
  get activeVideoSource() {
    return this.getContent().getSource(this._streamingManager.activeStreamId);
  }
  get activeVideoStream() {
    return this._streamingManager.activeStream;
  }
  get activeGroup() {
    return this.getVideoGroupManager().getGroup();
  }
  get availableModes() {
    var e, t, i;
    return ((e = this._content) == null ? void 0 : e.data.modes) && ((t = this._content) == null ? void 0 : t.data.modes) !== "*" ? (i = this._content) == null ? void 0 : i.data.modes : [Kt.FreeView, Kt.MultiSelect];
  }
  get isLoading() {
    return this._streamingManager.isLoading;
  }
  get isPlaying() {
    return this._streamingManager.playing;
  }
  get frameDuration() {
    var e;
    return 1 / (((e = this._content) == null ? void 0 : e.data.frameRate) || 30);
  }
  get currentTransforms() {
    try {
      return this.getTransformSet(this._currentTransformSetId);
    } catch {
      return null;
    }
  }
  get loop() {
    return this._streamingManager.loop;
  }
  set loop(e) {
    this._streamingManager.loop = e;
  }
  setLogLevel(e) {
    be.setLogLevel(e);
  }
  getContent() {
    if (!this._content)
      throw new Error("Content is not loaded yet");
    return this._content;
  }
  getVideoGroupManager() {
    if (!this._videoGroupManager)
      throw new Error("VideoGroupManager is not loaded yet");
    return this._videoGroupManager;
  }
  dispose() {
    var e, t, i, n;
    Da.remove(this, this.update), (e = this._currentMode) == null || e.dispose(), this._renderer.dispose(), (t = this.activeVideoStream) == null || t.dispose(), (i = this._streamingManager) == null || i.dispose(), (n = this._videoGroupManager) == null || n.dispose(), this.features.forEach((s) => s.dispose());
  }
  clear() {
    var e;
    (e = this._currentMode) == null || e.dispose(), this._currentMode = null, this._streamingManager.clear(), Object.assign(this.exposedStates, Es());
  }
  changeMode(e) {
    var t;
    if (this._currentMode && (this._currentMode.dispose(), this._currentMode = null), !(((t = this.content) == null ? void 0 : t.modes) && this.content.modes !== "*" && this.content.modes.indexOf(e) === -1)) {
      if (!Va[e])
        throw new Error("Unknown display mode");
      this._currentMode = new Va[e](this), this.setupMode();
    }
  }
  getMediaSource(e) {
    return this.getContent().getSource(e);
  }
  getVideoTrack(e) {
    return this.getContent().getVideoTrack(e);
  }
  getTransformSet(e) {
    return this.getContent().getTransform(e);
  }
  changeTransformSet(e) {
    var t, i;
    this._currentTransformSetId = We(e, 0, (i = (t = this.content) == null ? void 0 : t.transforms.length) != null ? i : 0);
  }
  loadContent(e) {
    var i;
    this.clear(), be.debug("load contents", e), this._content = new Of(e);
    const t = this.getContent();
    if (t.groupCount === 0)
      throw new Error("NO_VISUAL_GROUPS");
    if (t.data.playerOptions.backgroundColor) {
      const n = t.data.playerOptions.backgroundColor;
      this._renderer.clearColor.set(We(n[0], 0, 1), We(n[1], 0, 1), We(n[2], 0, 1), 1);
    } else
      this._renderer.clearColor.set(0, 0, 0, 1);
    this._videoGroupManager = new Ka(this._streamingManager, t), this.changeGroup(t.defaultGroupId), this.exposedStates.title = t.data.title, this.exposedStates.description = t.data.description, Array.isArray(t.data.modes) ? this.changeMode((i = t.data.modes[0]) != null ? i : Kt.MultiSelect) : this.changeMode(Kt.MultiSelect), this.features.forEach((n) => n.onUpdate(t)), t.onChange.add(() => {
      this.features.forEach((n) => n.onUpdate(t));
    }), this.loop = !!t.data.playerOptions.loop, this._eventController.isEnableTransform = !!t.data.playerOptions.userTransformable, this._eventController.isEnableStepFrame = !!t.data.playerOptions.userStepControl;
  }
  selectByVideoId(e) {
    this.getVideoGroupManager().selectVideoWithVideoId(e);
  }
  select(e, t) {
    const i = this.getVideoGroupManager();
    t !== void 0 ? i.changeGroup(t, e) : i.selectVideoWithIndex(e);
  }
  changeGroup(e) {
    var t, i;
    (i = (t = this._currentMode) == null ? void 0 : t.onChangeGroup) == null || i.call(t, this, this._renderer, e), this.getVideoGroupManager().changeGroup(e), this._eventController.horizontalOffsetAmount = this.getVideoGroupManager().getGroup().videoIds.length * 2;
  }
  selectPrev() {
    this.select(this.getVideoGroupManager().currentVideoIndex - 1);
  }
  selectNext() {
    this.select(this.getVideoGroupManager().currentVideoIndex + 1);
  }
  stepFrameForward(e = 1) {
    this.stepFrame(e);
  }
  stepFrameBackward(e = 1) {
    this.stepFrame(-e);
  }
  stepFrame(e) {
    this.seek(this.currentTime + this.frameDuration * e, !0);
  }
  playOrPause() {
    this.isPlaying ? this.pause() : this.play();
  }
  play() {
    if (this.isLoading) {
      this._nextPlayingState = "play";
      return;
    }
    if (this.exposedStates.isStarted = !0, this.isPlaying)
      return;
    const e = this._isMuted;
    this._muteToPlay && (this._streamingManager.muted = !0), this.seek(this.currentTime), this._streamingManager.play(), this._muteToPlay && setTimeout(() => {
      this._streamingManager.muted = e;
    }, 500);
  }
  pause() {
    if (this.isLoading) {
      this._nextPlayingState = "pause";
      return;
    }
    this._streamingManager.pause();
  }
  stop() {
    if (this.isLoading) {
      this._nextPlayingState = "stop";
      return;
    }
    this._streamingManager.stop();
  }
  seek(e, t = !1) {
    this._streamingManager.seek(e, t);
  }
  updateViewSize() {
    var e, t;
    this._renderer.resetView(), (e = this._currentMode) != null && e.updateViewSize && ((t = this._currentMode) == null || t.updateViewSize(this, this._renderer));
  }
  setMuted(e) {
    this._isMuted = e, this._streamingManager.muted = e;
  }
  setVolume(e) {
    this._volume = e, this._streamingManager.volume = e;
  }
  updateCaptions(e) {
    this.getContent().updateCaptions(e);
  }
  keydown(e) {
    var i;
    const t = !(e.shiftKey && e.metaKey && e.ctrlKey);
    this._eventController.isEnableStepFrame && ((e.key === "." || e.key === ir.ArrowRight && !t) && this.setFrameInput(1), (e.key === "," || e.key === ir.ArrowLeft && !t) && this.setFrameInput(-1), e.key === ir.ArrowRight && e.shiftKey && this.setFrameInput(1 / this.frameDuration), e.key === ir.ArrowLeft && e.shiftKey && this.setFrameInput(-1 / this.frameDuration)), e.key === ir.ArrowRight && (e.altKey || e.ctrlKey) && (be.debug("[key] Right"), this.selectNext()), e.key === ir.ArrowLeft && (e.altKey || e.ctrlKey) && (be.debug("[key] Left"), this.selectPrev()), (i = this.content) != null && i.playerOptions.userPlayable && (e.key === ir.Space || e.key === "l") && this.playOrPause();
  }
  updateTimeMarkers(e) {
    const t = this.getContent().data;
    t.markers = e.map((i) => ({ description: "", event: "None", ...i })), this.getContent().update(t);
  }
  showDebugger() {
    this._debugElement || this.setupDebugger();
  }
  update(e) {
    var n, s, o, l, a, b, y;
    const t = this._el.getBoundingClientRect();
    if ((this.lastSize.width !== t.width || this.lastSize.height !== t.height) && (this.updateViewSize(), this.lastSize.width = t.width, this.lastSize.height = t.height), this._nextPlayingState !== "" && !this.isLoading) {
      switch (this._nextPlayingState) {
        case "pause":
          this.pause();
          break;
        case "play":
          this.play();
          break;
        case "stop":
          this.stop();
          break;
      }
      this._nextPlayingState = "";
    }
    this._videoGroupManager.update(e), this._streamingManager.update(e, this);
    const i = this._streamingManager.activeStream;
    if (i && i.isCanPlay && ((n = this._currentMode) == null || n.update(this, this._renderer), (s = this._currentMode) != null && s.drawRequired && this._renderer.draw(e)), this.exposedStates.seekingTime = this.currentTime, this._applyStates(e), this._debugElement) {
      const N = (o = this.activeVideoStream) == null ? void 0 : o.el;
      this._debugElement.innerHTML = `${e}ms ${("" + Math.floor(1 / e)).padStart(3, "0")}fps<br/>
        time: ${(this.currentTime * 100 / 100).toFixed(3).padEnd(5, "0")}s state: ${this.isPlaying}<br>
        decoder: ${N ? N.getAttribute("data-decoder-type") === "Native" ? "Native" : "HLS.js" : ""}<br/>
        source: ${(a = (l = this.activeVideoStream) == null ? void 0 : l.el) == null ? void 0 : a.videoWidth}x${(y = (b = this.activeVideoStream) == null ? void 0 : b.el) == null ? void 0 : y.videoHeight}<br/>
        ${Object.keys(this._extraDebugMessages).map((E) => `${E}: ${this._extraDebugMessages[E]}`).join(", ")}
        `;
    }
    this._onEndOfFrame.emit(this);
  }
  setupMode() {
    !this._currentMode || this._currentMode.onSetup(this, this._renderer);
  }
  _applyEnvironment() {
    const e = this.userAgent.getDevice(), t = this.userAgent.getOS(), i = this.userAgent.getBrowser();
    be.debug("Device", e, e.model, e.type, e.vendor), be.debug("Browser", i, i.name, i.version), be.debug("OS", t, t.name, t.version), fr.useNative = !0, e.model === "iPhone" || e.model === "iPad" || t.name === "Mac OS" && "ontouchstart" in window ? this._muteToPlay = !0 : (t.name === "Android" || i.name === "Chrome" || i.name === "Edge" || i.name === "Firefox") && (fr.useNative = !1);
  }
  _setupInput() {
    this.scale;
    let e = !1;
    const t = this.translate.clone(), i = new Rt();
    let n = !1, s = !1, o = !1;
    this._eventController.onStartAction.add(this, (l) => {
      if (e = !0, this.scale, t.copy(this.translate), this._eventSystem.camera) {
        const a = this._eventSystem.camera.viewPointToRay(cr.getViewPortPosition(cr.getElementBounds(this._el), this._eventSystem.inputHandler.eventPosition));
        i.x = t.x - a.origin.x, i.y = t.y - a.origin.y;
      }
    }), this._eventController.onEndAction.add(this, () => {
      !e || (e = !1, this.exposedStates.isFrameControl = !1, n && (this.play(), n = !1), s && Xt.sendEvent(zi.DragCamera, ji.PlayerControls, Yi.ViewEvent, 1), o && Xt.sendEvent(zi.DragFrame, ji.PlayerControls, Yi.ViewEvent, 1), s = !1, o = !1);
    }), this._eventController.onOffsetHorizontal.add(this, (l) => {
      l > 0 ? (be.debug("prev"), this.selectPrev()) : (be.debug("next"), this.selectNext()), s = !0;
    }), this._eventController.onOffsetVertical.add(this, (l) => {
      var a;
      !((a = this.content) != null && a.playerOptions.userStepControl) || (this.isPlaying && (this.pause(), n = !0), this.exposedStates.isFrameControl = !0, this.stepFrame(l), o = !0);
    }), this._eventController.onPauseOrPlay.add(this, () => {
      var l;
      !((l = this.content) != null && l.playerOptions.userPlayable) || (this.playOrPause(), Xt.sendEvent(zi.Toggle, ji.PlayerGlobal, Yi.ViewEvent, 1));
    }), this._eventSystem.onKeyDownEvent.add((l) => {
      this.keydown(l);
    });
  }
  setFrameInput(e) {
    this.pause(), this.stepFrame(e), this.exposedStates.isFrameControl = !0, clearTimeout(this._setFrameTimer), this._setFrameTimer = window.setTimeout(() => {
      this.exposedStates.isFrameControl = !1;
    }, 2e3);
  }
  setupDebugger() {
    var i;
    const e = "BulletLightPlayer-Debugger";
    document.getElementById(e) && ((i = document.getElementById(e)) == null || i.remove());
    const t = document.createElement("div");
    t.style.position = "fixed", t.style.top = "0px", t.style.left = "0px", t.style.width = "140px", t.style.height = "60px", t.style.color = "white", t.style.backgroundColor = "black", t.style.fontFamily = "sans-serif", t.style.fontSize = "10px", t.innerHTML = "", t.id = e, document.body.append(t), this._debugElement = t;
  }
  _applyStates(e) {
    this.exposedStates.currentTime !== this.currentTime && (this.exposedStates.currentTime = this.currentTime), this.exposedStates.isPlaying = this.isPlaying, this.exposedStates.frameDuration = this.frameDuration, this._streamingManager.isPreLoading ? this.exposedStates.loadingTime += e : this.exposedStates.loadingTime !== 0 && (this.exposedStates.loadingTime = 0);
    const t = this.isLoading || this._streamingManager.isPreLoading && this.exposedStates.loadingTime > 4;
    this.exposedStates.isLoading !== t && (this.exposedStates.isLoading = t), this.activeVideoStream && (this.exposedStates.duration = this._streamingManager.duration), this.exposedStates.currentVideoIndex = this.currentGroupVideoIndex, this.exposedStates.currentVideoId = this.getVideoGroupManager().currentVideoId, this.exposedStates.currentTransformId = this._currentTransformSetId, this.exposedStates.currentGroupId = this.currentGroupId, this._applyCaptions(), this.exposedStates.isMuted = this._isMuted, this.exposedStates.volume = this._volume, this.exposedStates.loop = this.loop, this.features.forEach((i) => i.onExposeStatus(this.exposedStates));
  }
  _applyCaptions() {
    var e, t, i, n, s, o;
    if (this.content && this.content.closedCaptions && this.content.closedCaptions[0]) {
      const l = this.getContent().data.closedCaptions[0], a = { color: "white", opacity: 1, bgColor: "black", fontSize: "1em", inlineSize: "auto", writingMode: "horizontal", textAlign: "center", align: "center", verticalAlign: "bottom", offsetX: "0", offsetY: "0", ...l.options }, b = { left: "start", center: "center", right: "end" }, y = { top: "start", middle: "center", bottom: "end" }, N = { vertical: "vertical-rl", horizontal: "horizontal-tb" };
      let E = !1;
      for (let B = 0; B < l.captions.length; B++) {
        const I = l.captions[B].time, T = l.captions[B].time + ((e = l.captions[B].duration) != null ? e : 1);
        if (this.currentTime < I)
          break;
        if (I <= this.currentTime && this.currentTime < T) {
          if (this.exposedStates.caption !== l.captions[B].label) {
            this.exposedStates.caption = l.captions[B].label;
            const A = { ...a, ...l.captions[B].options };
            this.exposedStates.captionSize = A.fontSize, this.exposedStates.captionColor = A.color, this.exposedStates.captionBgColor = A.bgColor, this.exposedStates.captionOpacity = A.opacity, this.exposedStates.captionInlineSize = A.inlineSize, this.exposedStates.captionWritingMode = (i = (t = N[A.writingMode]) != null ? t : A.writingMode) != null ? i : "horizontal-tb", this.exposedStates.captionTextAlign = (n = A.textAlign) != null ? n : "center", this.exposedStates.captionJustify = (s = b[A.align]) != null ? s : "center", this.exposedStates.captionAlign = (o = y[A.verticalAlign]) != null ? o : "end", this.exposedStates.captionOffsetX = A.offsetX, this.exposedStates.captionOffsetY = A.offsetY;
          }
          E = !0;
          break;
        }
      }
      E || this.exposedStates.caption !== "" && (this.exposedStates.caption = "");
    }
  }
}
var nl = { exports: {} }, Vs = { exports: {} }, sl = function(e, t) {
  return function() {
    for (var n = new Array(arguments.length), s = 0; s < n.length; s++)
      n[s] = arguments[s];
    return e.apply(t, n);
  };
}, kf = sl, Ws = Object.prototype.toString, Gs = function(r) {
  return function(e) {
    var t = Ws.call(e);
    return r[t] || (r[t] = t.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function yr(r) {
  return r = r.toLowerCase(), function(t) {
    return Gs(t) === r;
  };
}
function Hs(r) {
  return Array.isArray(r);
}
function cn(r) {
  return typeof r > "u";
}
function Ff(r) {
  return r !== null && !cn(r) && r.constructor !== null && !cn(r.constructor) && typeof r.constructor.isBuffer == "function" && r.constructor.isBuffer(r);
}
var al = yr("ArrayBuffer");
function Nf(r) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(r) : e = r && r.buffer && al(r.buffer), e;
}
function Bf(r) {
  return typeof r == "string";
}
function Uf(r) {
  return typeof r == "number";
}
function ol(r) {
  return r !== null && typeof r == "object";
}
function Xi(r) {
  if (Gs(r) !== "object")
    return !1;
  var e = Object.getPrototypeOf(r);
  return e === null || e === Object.prototype;
}
var Kf = yr("Date"), Vf = yr("File"), Wf = yr("Blob"), Gf = yr("FileList");
function $s(r) {
  return Ws.call(r) === "[object Function]";
}
function Hf(r) {
  return ol(r) && $s(r.pipe);
}
function $f(r) {
  var e = "[object FormData]";
  return r && (typeof FormData == "function" && r instanceof FormData || Ws.call(r) === e || $s(r.toString) && r.toString() === e);
}
var jf = yr("URLSearchParams");
function Yf(r) {
  return r.trim ? r.trim() : r.replace(/^\s+|\s+$/g, "");
}
function zf() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function js(r, e) {
  if (!(r === null || typeof r > "u"))
    if (typeof r != "object" && (r = [r]), Hs(r))
      for (var t = 0, i = r.length; t < i; t++)
        e.call(null, r[t], t, r);
    else
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && e.call(null, r[n], n, r);
}
function _s() {
  var r = {};
  function e(n, s) {
    Xi(r[s]) && Xi(n) ? r[s] = _s(r[s], n) : Xi(n) ? r[s] = _s({}, n) : Hs(n) ? r[s] = n.slice() : r[s] = n;
  }
  for (var t = 0, i = arguments.length; t < i; t++)
    js(arguments[t], e);
  return r;
}
function Xf(r, e, t) {
  return js(e, function(n, s) {
    t && typeof n == "function" ? r[s] = kf(n, t) : r[s] = n;
  }), r;
}
function Qf(r) {
  return r.charCodeAt(0) === 65279 && (r = r.slice(1)), r;
}
function Zf(r, e, t, i) {
  r.prototype = Object.create(e.prototype, i), r.prototype.constructor = r, t && Object.assign(r.prototype, t);
}
function Jf(r, e, t) {
  var i, n, s, o = {};
  e = e || {};
  do {
    for (i = Object.getOwnPropertyNames(r), n = i.length; n-- > 0; )
      s = i[n], o[s] || (e[s] = r[s], o[s] = !0);
    r = Object.getPrototypeOf(r);
  } while (r && (!t || t(r, e)) && r !== Object.prototype);
  return e;
}
function qf(r, e, t) {
  r = String(r), (t === void 0 || t > r.length) && (t = r.length), t -= e.length;
  var i = r.indexOf(e, t);
  return i !== -1 && i === t;
}
function eh(r) {
  if (!r)
    return null;
  var e = r.length;
  if (cn(e))
    return null;
  for (var t = new Array(e); e-- > 0; )
    t[e] = r[e];
  return t;
}
var th = function(r) {
  return function(e) {
    return r && e instanceof r;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), et = {
  isArray: Hs,
  isArrayBuffer: al,
  isBuffer: Ff,
  isFormData: $f,
  isArrayBufferView: Nf,
  isString: Bf,
  isNumber: Uf,
  isObject: ol,
  isPlainObject: Xi,
  isUndefined: cn,
  isDate: Kf,
  isFile: Vf,
  isBlob: Wf,
  isFunction: $s,
  isStream: Hf,
  isURLSearchParams: jf,
  isStandardBrowserEnv: zf,
  forEach: js,
  merge: _s,
  extend: Xf,
  trim: Yf,
  stripBOM: Qf,
  inherits: Zf,
  toFlatObject: Jf,
  kindOf: Gs,
  kindOfTest: yr,
  endsWith: qf,
  toArray: eh,
  isTypedArray: th,
  isFileList: Gf
}, Sr = et;
function Wa(r) {
  return encodeURIComponent(r).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var ll = function(e, t, i) {
  if (!t)
    return e;
  var n;
  if (i)
    n = i(t);
  else if (Sr.isURLSearchParams(t))
    n = t.toString();
  else {
    var s = [];
    Sr.forEach(t, function(a, b) {
      a === null || typeof a > "u" || (Sr.isArray(a) ? b = b + "[]" : a = [a], Sr.forEach(a, function(N) {
        Sr.isDate(N) ? N = N.toISOString() : Sr.isObject(N) && (N = JSON.stringify(N)), s.push(Wa(b) + "=" + Wa(N));
      }));
    }), n = s.join("&");
  }
  if (n) {
    var o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + n;
  }
  return e;
}, rh = et;
function _n() {
  this.handlers = [];
}
_n.prototype.use = function(e, t, i) {
  return this.handlers.push({
    fulfilled: e,
    rejected: t,
    synchronous: i ? i.synchronous : !1,
    runWhen: i ? i.runWhen : null
  }), this.handlers.length - 1;
};
_n.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
_n.prototype.forEach = function(e) {
  rh.forEach(this.handlers, function(i) {
    i !== null && e(i);
  });
};
var ih = _n, nh = et, sh = function(e, t) {
  nh.forEach(e, function(n, s) {
    s !== t && s.toUpperCase() === t.toUpperCase() && (e[t] = n, delete e[s]);
  });
}, ul = et;
function Mr(r, e, t, i, n) {
  Error.call(this), this.message = r, this.name = "AxiosError", e && (this.code = e), t && (this.config = t), i && (this.request = i), n && (this.response = n);
}
ul.inherits(Mr, Error, {
  toJSON: function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var cl = Mr.prototype, fl = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
].forEach(function(r) {
  fl[r] = { value: r };
});
Object.defineProperties(Mr, fl);
Object.defineProperty(cl, "isAxiosError", { value: !0 });
Mr.from = function(r, e, t, i, n, s) {
  var o = Object.create(cl);
  return ul.toFlatObject(r, o, function(a) {
    return a !== Error.prototype;
  }), Mr.call(o, r.message, e, t, i, n), o.name = r.name, s && Object.assign(o, s), o;
};
var Kr = Mr, hl = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Dt = et;
function ah(r, e) {
  e = e || new FormData();
  var t = [];
  function i(s) {
    return s === null ? "" : Dt.isDate(s) ? s.toISOString() : Dt.isArrayBuffer(s) || Dt.isTypedArray(s) ? typeof Blob == "function" ? new Blob([s]) : Buffer.from(s) : s;
  }
  function n(s, o) {
    if (Dt.isPlainObject(s) || Dt.isArray(s)) {
      if (t.indexOf(s) !== -1)
        throw Error("Circular reference detected in " + o);
      t.push(s), Dt.forEach(s, function(a, b) {
        if (!Dt.isUndefined(a)) {
          var y = o ? o + "." + b : b, N;
          if (a && !o && typeof a == "object") {
            if (Dt.endsWith(b, "{}"))
              a = JSON.stringify(a);
            else if (Dt.endsWith(b, "[]") && (N = Dt.toArray(a))) {
              N.forEach(function(E) {
                !Dt.isUndefined(E) && e.append(y, i(E));
              });
              return;
            }
          }
          n(a, y);
        }
      }), t.pop();
    } else
      e.append(o, i(s));
  }
  return n(r), e;
}
var dl = ah, jn, Ga;
function oh() {
  if (Ga)
    return jn;
  Ga = 1;
  var r = Kr;
  return jn = function(t, i, n) {
    var s = n.config.validateStatus;
    !n.status || !s || s(n.status) ? t(n) : i(new r(
      "Request failed with status code " + n.status,
      [r.ERR_BAD_REQUEST, r.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
      n.config,
      n.request,
      n
    ));
  }, jn;
}
var Yn, Ha;
function lh() {
  if (Ha)
    return Yn;
  Ha = 1;
  var r = et;
  return Yn = r.isStandardBrowserEnv() ? function() {
    return {
      write: function(i, n, s, o, l, a) {
        var b = [];
        b.push(i + "=" + encodeURIComponent(n)), r.isNumber(s) && b.push("expires=" + new Date(s).toGMTString()), r.isString(o) && b.push("path=" + o), r.isString(l) && b.push("domain=" + l), a === !0 && b.push("secure"), document.cookie = b.join("; ");
      },
      read: function(i) {
        var n = document.cookie.match(new RegExp("(^|;\\s*)(" + i + ")=([^;]*)"));
        return n ? decodeURIComponent(n[3]) : null;
      },
      remove: function(i) {
        this.write(i, "", Date.now() - 864e5);
      }
    };
  }() : function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }(), Yn;
}
var uh = function(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}, ch = function(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}, fh = uh, hh = ch, vl = function(e, t) {
  return e && !fh(t) ? hh(e, t) : t;
}, zn, $a;
function dh() {
  if ($a)
    return zn;
  $a = 1;
  var r = et, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return zn = function(i) {
    var n = {}, s, o, l;
    return i && r.forEach(i.split(`
`), function(b) {
      if (l = b.indexOf(":"), s = r.trim(b.substr(0, l)).toLowerCase(), o = r.trim(b.substr(l + 1)), s) {
        if (n[s] && e.indexOf(s) >= 0)
          return;
        s === "set-cookie" ? n[s] = (n[s] ? n[s] : []).concat([o]) : n[s] = n[s] ? n[s] + ", " + o : o;
      }
    }), n;
  }, zn;
}
var Xn, ja;
function vh() {
  if (ja)
    return Xn;
  ja = 1;
  var r = et;
  return Xn = r.isStandardBrowserEnv() ? function() {
    var t = /(msie|trident)/i.test(navigator.userAgent), i = document.createElement("a"), n;
    function s(o) {
      var l = o;
      return t && (i.setAttribute("href", l), l = i.href), i.setAttribute("href", l), {
        href: i.href,
        protocol: i.protocol ? i.protocol.replace(/:$/, "") : "",
        host: i.host,
        search: i.search ? i.search.replace(/^\?/, "") : "",
        hash: i.hash ? i.hash.replace(/^#/, "") : "",
        hostname: i.hostname,
        port: i.port,
        pathname: i.pathname.charAt(0) === "/" ? i.pathname : "/" + i.pathname
      };
    }
    return n = s(window.location.href), function(l) {
      var a = r.isString(l) ? s(l) : l;
      return a.protocol === n.protocol && a.host === n.host;
    };
  }() : function() {
    return function() {
      return !0;
    };
  }(), Xn;
}
var Qn, Ya;
function Tn() {
  if (Ya)
    return Qn;
  Ya = 1;
  var r = Kr, e = et;
  function t(i) {
    r.call(this, i == null ? "canceled" : i, r.ERR_CANCELED), this.name = "CanceledError";
  }
  return e.inherits(t, r, {
    __CANCEL__: !0
  }), Qn = t, Qn;
}
var Zn, za;
function mh() {
  return za || (za = 1, Zn = function(e) {
    var t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return t && t[1] || "";
  }), Zn;
}
var Jn, Xa;
function Qa() {
  if (Xa)
    return Jn;
  Xa = 1;
  var r = et, e = oh(), t = lh(), i = ll, n = vl, s = dh(), o = vh(), l = hl, a = Kr, b = Tn(), y = mh();
  return Jn = function(E) {
    return new Promise(function(I, T) {
      var A = E.data, w = E.headers, O = E.responseType, u;
      function M() {
        E.cancelToken && E.cancelToken.unsubscribe(u), E.signal && E.signal.removeEventListener("abort", u);
      }
      r.isFormData(A) && r.isStandardBrowserEnv() && delete w["Content-Type"];
      var d = new XMLHttpRequest();
      if (E.auth) {
        var c = E.auth.username || "", v = E.auth.password ? unescape(encodeURIComponent(E.auth.password)) : "";
        w.Authorization = "Basic " + btoa(c + ":" + v);
      }
      var g = n(E.baseURL, E.url);
      d.open(E.method.toUpperCase(), i(g, E.params, E.paramsSerializer), !0), d.timeout = E.timeout;
      function m() {
        if (!!d) {
          var p = "getAllResponseHeaders" in d ? s(d.getAllResponseHeaders()) : null, x = !O || O === "text" || O === "json" ? d.responseText : d.response, k = {
            data: x,
            status: d.status,
            statusText: d.statusText,
            headers: p,
            config: E,
            request: d
          };
          e(function(S) {
            I(S), M();
          }, function(S) {
            T(S), M();
          }, k), d = null;
        }
      }
      if ("onloadend" in d ? d.onloadend = m : d.onreadystatechange = function() {
        !d || d.readyState !== 4 || d.status === 0 && !(d.responseURL && d.responseURL.indexOf("file:") === 0) || setTimeout(m);
      }, d.onabort = function() {
        !d || (T(new a("Request aborted", a.ECONNABORTED, E, d)), d = null);
      }, d.onerror = function() {
        T(new a("Network Error", a.ERR_NETWORK, E, d, d)), d = null;
      }, d.ontimeout = function() {
        var x = E.timeout ? "timeout of " + E.timeout + "ms exceeded" : "timeout exceeded", k = E.transitional || l;
        E.timeoutErrorMessage && (x = E.timeoutErrorMessage), T(new a(
          x,
          k.clarifyTimeoutError ? a.ETIMEDOUT : a.ECONNABORTED,
          E,
          d
        )), d = null;
      }, r.isStandardBrowserEnv()) {
        var D = (E.withCredentials || o(g)) && E.xsrfCookieName ? t.read(E.xsrfCookieName) : void 0;
        D && (w[E.xsrfHeaderName] = D);
      }
      "setRequestHeader" in d && r.forEach(w, function(x, k) {
        typeof A > "u" && k.toLowerCase() === "content-type" ? delete w[k] : d.setRequestHeader(k, x);
      }), r.isUndefined(E.withCredentials) || (d.withCredentials = !!E.withCredentials), O && O !== "json" && (d.responseType = E.responseType), typeof E.onDownloadProgress == "function" && d.addEventListener("progress", E.onDownloadProgress), typeof E.onUploadProgress == "function" && d.upload && d.upload.addEventListener("progress", E.onUploadProgress), (E.cancelToken || E.signal) && (u = function(p) {
        !d || (T(!p || p && p.type ? new b() : p), d.abort(), d = null);
      }, E.cancelToken && E.cancelToken.subscribe(u), E.signal && (E.signal.aborted ? u() : E.signal.addEventListener("abort", u))), A || (A = null);
      var L = y(g);
      if (L && ["http", "https", "file"].indexOf(L) === -1) {
        T(new a("Unsupported protocol " + L + ":", a.ERR_BAD_REQUEST, E));
        return;
      }
      d.send(A);
    });
  }, Jn;
}
var qn, Za;
function gh() {
  return Za || (Za = 1, qn = null), qn;
}
var Ye = et, Ja = sh, qa = Kr, ph = hl, yh = dl, Eh = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function eo(r, e) {
  !Ye.isUndefined(r) && Ye.isUndefined(r["Content-Type"]) && (r["Content-Type"] = e);
}
function _h() {
  var r;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (r = Qa()), r;
}
function Th(r, e, t) {
  if (Ye.isString(r))
    try {
      return (e || JSON.parse)(r), Ye.trim(r);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (t || JSON.stringify)(r);
}
var Sn = {
  transitional: ph,
  adapter: _h(),
  transformRequest: [function(e, t) {
    if (Ja(t, "Accept"), Ja(t, "Content-Type"), Ye.isFormData(e) || Ye.isArrayBuffer(e) || Ye.isBuffer(e) || Ye.isStream(e) || Ye.isFile(e) || Ye.isBlob(e))
      return e;
    if (Ye.isArrayBufferView(e))
      return e.buffer;
    if (Ye.isURLSearchParams(e))
      return eo(t, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
    var i = Ye.isObject(e), n = t && t["Content-Type"], s;
    if ((s = Ye.isFileList(e)) || i && n === "multipart/form-data") {
      var o = this.env && this.env.FormData;
      return yh(s ? { "files[]": e } : e, o && new o());
    } else if (i || n === "application/json")
      return eo(t, "application/json"), Th(e);
    return e;
  }],
  transformResponse: [function(e) {
    var t = this.transitional || Sn.transitional, i = t && t.silentJSONParsing, n = t && t.forcedJSONParsing, s = !i && this.responseType === "json";
    if (s || n && Ye.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (o) {
        if (s)
          throw o.name === "SyntaxError" ? qa.from(o, qa.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    return e;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: gh()
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
Ye.forEach(["delete", "get", "head"], function(e) {
  Sn.headers[e] = {};
});
Ye.forEach(["post", "put", "patch"], function(e) {
  Sn.headers[e] = Ye.merge(Eh);
});
var Ys = Sn, Sh = et, xh = Ys, bh = function(e, t, i) {
  var n = this || xh;
  return Sh.forEach(i, function(o) {
    e = o.call(n, e, t);
  }), e;
}, es, to;
function ml() {
  return to || (to = 1, es = function(e) {
    return !!(e && e.__CANCEL__);
  }), es;
}
var ro = et, ts = bh, Ah = ml(), Lh = Ys, wh = Tn();
function rs(r) {
  if (r.cancelToken && r.cancelToken.throwIfRequested(), r.signal && r.signal.aborted)
    throw new wh();
}
var Dh = function(e) {
  rs(e), e.headers = e.headers || {}, e.data = ts.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = ro.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), ro.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(n) {
      delete e.headers[n];
    }
  );
  var t = e.adapter || Lh.adapter;
  return t(e).then(function(n) {
    return rs(e), n.data = ts.call(
      e,
      n.data,
      n.headers,
      e.transformResponse
    ), n;
  }, function(n) {
    return Ah(n) || (rs(e), n && n.response && (n.response.data = ts.call(
      e,
      n.response.data,
      n.response.headers,
      e.transformResponse
    ))), Promise.reject(n);
  });
}, ht = et, gl = function(e, t) {
  t = t || {};
  var i = {};
  function n(y, N) {
    return ht.isPlainObject(y) && ht.isPlainObject(N) ? ht.merge(y, N) : ht.isPlainObject(N) ? ht.merge({}, N) : ht.isArray(N) ? N.slice() : N;
  }
  function s(y) {
    if (ht.isUndefined(t[y])) {
      if (!ht.isUndefined(e[y]))
        return n(void 0, e[y]);
    } else
      return n(e[y], t[y]);
  }
  function o(y) {
    if (!ht.isUndefined(t[y]))
      return n(void 0, t[y]);
  }
  function l(y) {
    if (ht.isUndefined(t[y])) {
      if (!ht.isUndefined(e[y]))
        return n(void 0, e[y]);
    } else
      return n(void 0, t[y]);
  }
  function a(y) {
    if (y in t)
      return n(e[y], t[y]);
    if (y in e)
      return n(void 0, e[y]);
  }
  var b = {
    url: o,
    method: o,
    data: o,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: a
  };
  return ht.forEach(Object.keys(e).concat(Object.keys(t)), function(N) {
    var E = b[N] || s, B = E(N);
    ht.isUndefined(B) && E !== a || (i[N] = B);
  }), i;
}, is, io;
function pl() {
  return io || (io = 1, is = {
    version: "0.27.2"
  }), is;
}
var Ih = pl().version, zt = Kr, zs = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(r, e) {
  zs[r] = function(i) {
    return typeof i === r || "a" + (e < 1 ? "n " : " ") + r;
  };
});
var no = {};
zs.transitional = function(e, t, i) {
  function n(s, o) {
    return "[Axios v" + Ih + "] Transitional option '" + s + "'" + o + (i ? ". " + i : "");
  }
  return function(s, o, l) {
    if (e === !1)
      throw new zt(
        n(o, " has been removed" + (t ? " in " + t : "")),
        zt.ERR_DEPRECATED
      );
    return t && !no[o] && (no[o] = !0, console.warn(
      n(
        o,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(s, o, l) : !0;
  };
};
function Oh(r, e, t) {
  if (typeof r != "object")
    throw new zt("options must be an object", zt.ERR_BAD_OPTION_VALUE);
  for (var i = Object.keys(r), n = i.length; n-- > 0; ) {
    var s = i[n], o = e[s];
    if (o) {
      var l = r[s], a = l === void 0 || o(l, s, r);
      if (a !== !0)
        throw new zt("option " + s + " must be " + a, zt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new zt("Unknown option " + s, zt.ERR_BAD_OPTION);
  }
}
var Ch = {
  assertOptions: Oh,
  validators: zs
}, yl = et, Ph = ll, so = ih, ao = Dh, xn = gl, Rh = vl, El = Ch, xr = El.validators;
function kr(r) {
  this.defaults = r, this.interceptors = {
    request: new so(),
    response: new so()
  };
}
kr.prototype.request = function(e, t) {
  typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = xn(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var i = t.transitional;
  i !== void 0 && El.assertOptions(i, {
    silentJSONParsing: xr.transitional(xr.boolean),
    forcedJSONParsing: xr.transitional(xr.boolean),
    clarifyTimeoutError: xr.transitional(xr.boolean)
  }, !1);
  var n = [], s = !0;
  this.interceptors.request.forEach(function(B) {
    typeof B.runWhen == "function" && B.runWhen(t) === !1 || (s = s && B.synchronous, n.unshift(B.fulfilled, B.rejected));
  });
  var o = [];
  this.interceptors.response.forEach(function(B) {
    o.push(B.fulfilled, B.rejected);
  });
  var l;
  if (!s) {
    var a = [ao, void 0];
    for (Array.prototype.unshift.apply(a, n), a = a.concat(o), l = Promise.resolve(t); a.length; )
      l = l.then(a.shift(), a.shift());
    return l;
  }
  for (var b = t; n.length; ) {
    var y = n.shift(), N = n.shift();
    try {
      b = y(b);
    } catch (E) {
      N(E);
      break;
    }
  }
  try {
    l = ao(b);
  } catch (E) {
    return Promise.reject(E);
  }
  for (; o.length; )
    l = l.then(o.shift(), o.shift());
  return l;
};
kr.prototype.getUri = function(e) {
  e = xn(this.defaults, e);
  var t = Rh(e.baseURL, e.url);
  return Ph(t, e.params, e.paramsSerializer);
};
yl.forEach(["delete", "get", "head", "options"], function(e) {
  kr.prototype[e] = function(t, i) {
    return this.request(xn(i || {}, {
      method: e,
      url: t,
      data: (i || {}).data
    }));
  };
});
yl.forEach(["post", "put", "patch"], function(e) {
  function t(i) {
    return function(s, o, l) {
      return this.request(xn(l || {}, {
        method: e,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: o
      }));
    };
  }
  kr.prototype[e] = t(), kr.prototype[e + "Form"] = t(!0);
});
var Mh = kr, ns, oo;
function kh() {
  if (oo)
    return ns;
  oo = 1;
  var r = Tn();
  function e(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    var i;
    this.promise = new Promise(function(o) {
      i = o;
    });
    var n = this;
    this.promise.then(function(s) {
      if (!!n._listeners) {
        var o, l = n._listeners.length;
        for (o = 0; o < l; o++)
          n._listeners[o](s);
        n._listeners = null;
      }
    }), this.promise.then = function(s) {
      var o, l = new Promise(function(a) {
        n.subscribe(a), o = a;
      }).then(s);
      return l.cancel = function() {
        n.unsubscribe(o);
      }, l;
    }, t(function(o) {
      n.reason || (n.reason = new r(o), i(n.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(i) {
    if (this.reason) {
      i(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(i) : this._listeners = [i];
  }, e.prototype.unsubscribe = function(i) {
    if (!!this._listeners) {
      var n = this._listeners.indexOf(i);
      n !== -1 && this._listeners.splice(n, 1);
    }
  }, e.source = function() {
    var i, n = new e(function(o) {
      i = o;
    });
    return {
      token: n,
      cancel: i
    };
  }, ns = e, ns;
}
var ss, lo;
function Fh() {
  return lo || (lo = 1, ss = function(e) {
    return function(i) {
      return e.apply(null, i);
    };
  }), ss;
}
var as, uo;
function Nh() {
  if (uo)
    return as;
  uo = 1;
  var r = et;
  return as = function(t) {
    return r.isObject(t) && t.isAxiosError === !0;
  }, as;
}
var co = et, Bh = sl, Qi = Mh, Uh = gl, Kh = Ys;
function _l(r) {
  var e = new Qi(r), t = Bh(Qi.prototype.request, e);
  return co.extend(t, Qi.prototype, e), co.extend(t, e), t.create = function(n) {
    return _l(Uh(r, n));
  }, t;
}
var ct = _l(Kh);
ct.Axios = Qi;
ct.CanceledError = Tn();
ct.CancelToken = kh();
ct.isCancel = ml();
ct.VERSION = pl().version;
ct.toFormData = dl;
ct.AxiosError = Kr;
ct.Cancel = ct.CanceledError;
ct.all = function(e) {
  return Promise.all(e);
};
ct.spread = Fh();
ct.isAxiosError = Nh();
Vs.exports = ct;
Vs.exports.default = ct;
(function(r) {
  r.exports = Vs.exports;
})(nl);
const Vh = /* @__PURE__ */ Qo(nl.exports), Xs = Symbol.for("yaml.alias"), Ts = Symbol.for("yaml.document"), Jt = Symbol.for("yaml.map"), Tl = Symbol.for("yaml.pair"), Yt = Symbol.for("yaml.scalar"), Vr = Symbol.for("yaml.seq"), xt = Symbol.for("yaml.node.type"), Wr = (r) => !!r && typeof r == "object" && r[xt] === Xs, bn = (r) => !!r && typeof r == "object" && r[xt] === Ts, pi = (r) => !!r && typeof r == "object" && r[xt] === Jt, Be = (r) => !!r && typeof r == "object" && r[xt] === Tl, Oe = (r) => !!r && typeof r == "object" && r[xt] === Yt, yi = (r) => !!r && typeof r == "object" && r[xt] === Vr;
function Ne(r) {
  if (r && typeof r == "object")
    switch (r[xt]) {
      case Jt:
      case Vr:
        return !0;
    }
  return !1;
}
function je(r) {
  if (r && typeof r == "object")
    switch (r[xt]) {
      case Xs:
      case Jt:
      case Yt:
      case Vr:
        return !0;
    }
  return !1;
}
const Wh = (r) => (Oe(r) || Ne(r)) && !!r.anchor, nr = Symbol("break visit"), Gh = Symbol("skip children"), ri = Symbol("remove node");
function vr(r, e) {
  const t = Hh(e);
  bn(r) ? Dr(null, r.contents, t, Object.freeze([r])) === ri && (r.contents = null) : Dr(null, r, t, Object.freeze([]));
}
vr.BREAK = nr;
vr.SKIP = Gh;
vr.REMOVE = ri;
function Dr(r, e, t, i) {
  const n = $h(r, e, t, i);
  if (je(n) || Be(n))
    return jh(r, i, n), Dr(r, n, t, i);
  if (typeof n != "symbol") {
    if (Ne(e)) {
      i = Object.freeze(i.concat(e));
      for (let s = 0; s < e.items.length; ++s) {
        const o = Dr(s, e.items[s], t, i);
        if (typeof o == "number")
          s = o - 1;
        else {
          if (o === nr)
            return nr;
          o === ri && (e.items.splice(s, 1), s -= 1);
        }
      }
    } else if (Be(e)) {
      i = Object.freeze(i.concat(e));
      const s = Dr("key", e.key, t, i);
      if (s === nr)
        return nr;
      s === ri && (e.key = null);
      const o = Dr("value", e.value, t, i);
      if (o === nr)
        return nr;
      o === ri && (e.value = null);
    }
  }
  return n;
}
function Hh(r) {
  return typeof r == "object" && (r.Collection || r.Node || r.Value) ? Object.assign({
    Alias: r.Node,
    Map: r.Node,
    Scalar: r.Node,
    Seq: r.Node
  }, r.Value && {
    Map: r.Value,
    Scalar: r.Value,
    Seq: r.Value
  }, r.Collection && {
    Map: r.Collection,
    Seq: r.Collection
  }, r) : r;
}
function $h(r, e, t, i) {
  var n, s, o, l, a;
  if (typeof t == "function")
    return t(r, e, i);
  if (pi(e))
    return (n = t.Map) == null ? void 0 : n.call(t, r, e, i);
  if (yi(e))
    return (s = t.Seq) == null ? void 0 : s.call(t, r, e, i);
  if (Be(e))
    return (o = t.Pair) == null ? void 0 : o.call(t, r, e, i);
  if (Oe(e))
    return (l = t.Scalar) == null ? void 0 : l.call(t, r, e, i);
  if (Wr(e))
    return (a = t.Alias) == null ? void 0 : a.call(t, r, e, i);
}
function jh(r, e, t) {
  const i = e[e.length - 1];
  if (Ne(i))
    i.items[r] = t;
  else if (Be(i))
    r === "key" ? i.key = t : i.value = t;
  else if (bn(i))
    i.contents = t;
  else {
    const n = Wr(i) ? "alias" : "scalar";
    throw new Error(`Cannot replace node with ${n} parent`);
  }
}
const Yh = {
  "!": "%21",
  ",": "%2C",
  "[": "%5B",
  "]": "%5D",
  "{": "%7B",
  "}": "%7D"
}, zh = (r) => r.replace(/[!,[\]{}]/g, (e) => Yh[e]);
class st {
  constructor(e, t) {
    this.docStart = null, this.docEnd = !1, this.yaml = Object.assign({}, st.defaultYaml, e), this.tags = Object.assign({}, st.defaultTags, t);
  }
  clone() {
    const e = new st(this.yaml, this.tags);
    return e.docStart = this.docStart, e;
  }
  atDocument() {
    const e = new st(this.yaml, this.tags);
    switch (this.yaml.version) {
      case "1.1":
        this.atNextDocument = !0;
        break;
      case "1.2":
        this.atNextDocument = !1, this.yaml = {
          explicit: st.defaultYaml.explicit,
          version: "1.2"
        }, this.tags = Object.assign({}, st.defaultTags);
        break;
    }
    return e;
  }
  add(e, t) {
    this.atNextDocument && (this.yaml = { explicit: st.defaultYaml.explicit, version: "1.1" }, this.tags = Object.assign({}, st.defaultTags), this.atNextDocument = !1);
    const i = e.trim().split(/[ \t]+/), n = i.shift();
    switch (n) {
      case "%TAG": {
        if (i.length !== 2 && (t(0, "%TAG directive should contain exactly two parts"), i.length < 2))
          return !1;
        const [s, o] = i;
        return this.tags[s] = o, !0;
      }
      case "%YAML": {
        if (this.yaml.explicit = !0, i.length !== 1)
          return t(0, "%YAML directive should contain exactly one part"), !1;
        const [s] = i;
        if (s === "1.1" || s === "1.2")
          return this.yaml.version = s, !0;
        {
          const o = /^\d+\.\d+$/.test(s);
          return t(6, `Unsupported YAML version ${s}`, o), !1;
        }
      }
      default:
        return t(0, `Unknown directive ${n}`, !0), !1;
    }
  }
  tagName(e, t) {
    if (e === "!")
      return "!";
    if (e[0] !== "!")
      return t(`Not a valid tag: ${e}`), null;
    if (e[1] === "<") {
      const o = e.slice(2, -1);
      return o === "!" || o === "!!" ? (t(`Verbatim tags aren't resolved, so ${e} is invalid.`), null) : (e[e.length - 1] !== ">" && t("Verbatim tags must end with a >"), o);
    }
    const [, i, n] = e.match(/^(.*!)([^!]*)$/s);
    n || t(`The ${e} tag has no suffix`);
    const s = this.tags[i];
    if (s)
      try {
        return s + decodeURIComponent(n);
      } catch (o) {
        return t(String(o)), null;
      }
    return i === "!" ? e : (t(`Could not resolve tag: ${e}`), null);
  }
  tagString(e) {
    for (const [t, i] of Object.entries(this.tags))
      if (e.startsWith(i))
        return t + zh(e.substring(i.length));
    return e[0] === "!" ? e : `!<${e}>`;
  }
  toString(e) {
    const t = this.yaml.explicit ? [`%YAML ${this.yaml.version || "1.2"}`] : [], i = Object.entries(this.tags);
    let n;
    if (e && i.length > 0 && je(e.contents)) {
      const s = {};
      vr(e.contents, (o, l) => {
        je(l) && l.tag && (s[l.tag] = !0);
      }), n = Object.keys(s);
    } else
      n = [];
    for (const [s, o] of i)
      s === "!!" && o === "tag:yaml.org,2002:" || (!e || n.some((l) => l.startsWith(o))) && t.push(`%TAG ${s} ${o}`);
    return t.join(`
`);
  }
}
st.defaultYaml = { explicit: !1, version: "1.2" };
st.defaultTags = { "!!": "tag:yaml.org,2002:" };
function Sl(r) {
  if (/[\x00-\x19\s,[\]{}]/.test(r)) {
    const t = `Anchor must not contain whitespace or control characters: ${JSON.stringify(r)}`;
    throw new Error(t);
  }
  return !0;
}
function xl(r) {
  const e = /* @__PURE__ */ new Set();
  return vr(r, {
    Value(t, i) {
      i.anchor && e.add(i.anchor);
    }
  }), e;
}
function bl(r, e) {
  for (let t = 1; ; ++t) {
    const i = `${r}${t}`;
    if (!e.has(i))
      return i;
  }
}
function Xh(r, e) {
  const t = [], i = /* @__PURE__ */ new Map();
  let n = null;
  return {
    onAnchor: (s) => {
      t.push(s), n || (n = xl(r));
      const o = bl(e, n);
      return n.add(o), o;
    },
    setAnchors: () => {
      for (const s of t) {
        const o = i.get(s);
        if (typeof o == "object" && o.anchor && (Oe(o.node) || Ne(o.node)))
          o.node.anchor = o.anchor;
        else {
          const l = new Error("Failed to resolve repeated object (this should not happen)");
          throw l.source = s, l;
        }
      }
    },
    sourceObjects: i
  };
}
function Ir(r, e, t, i) {
  if (i && typeof i == "object")
    if (Array.isArray(i))
      for (let n = 0, s = i.length; n < s; ++n) {
        const o = i[n], l = Ir(r, i, String(n), o);
        l === void 0 ? delete i[n] : l !== o && (i[n] = l);
      }
    else if (i instanceof Map)
      for (const n of Array.from(i.keys())) {
        const s = i.get(n), o = Ir(r, i, n, s);
        o === void 0 ? i.delete(n) : o !== s && i.set(n, o);
      }
    else if (i instanceof Set)
      for (const n of Array.from(i)) {
        const s = Ir(r, i, n, n);
        s === void 0 ? i.delete(n) : s !== n && (i.delete(n), i.add(s));
      }
    else
      for (const [n, s] of Object.entries(i)) {
        const o = Ir(r, i, n, s);
        o === void 0 ? delete i[n] : o !== s && (i[n] = o);
      }
  return r.call(e, t, i);
}
function St(r, e, t) {
  if (Array.isArray(r))
    return r.map((i, n) => St(i, String(n), t));
  if (r && typeof r.toJSON == "function") {
    if (!t || !Wh(r))
      return r.toJSON(e, t);
    const i = { aliasCount: 0, count: 1, res: void 0 };
    t.anchors.set(r, i), t.onCreate = (s) => {
      i.res = s, delete t.onCreate;
    };
    const n = r.toJSON(e, t);
    return t.onCreate && t.onCreate(n), n;
  }
  return typeof r == "bigint" && !(t != null && t.keep) ? Number(r) : r;
}
class Qs {
  constructor(e) {
    Object.defineProperty(this, xt, { value: e });
  }
  clone() {
    const e = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
    return this.range && (e.range = this.range.slice()), e;
  }
  toJS(e, { mapAsMap: t, maxAliasCount: i, onAnchor: n, reviver: s } = {}) {
    if (!bn(e))
      throw new TypeError("A document argument is required");
    const o = {
      anchors: /* @__PURE__ */ new Map(),
      doc: e,
      keep: !0,
      mapAsMap: t === !0,
      mapKeyWarned: !1,
      maxAliasCount: typeof i == "number" ? i : 100
    }, l = St(this, "", o);
    if (typeof n == "function")
      for (const { count: a, res: b } of o.anchors.values())
        n(b, a);
    return typeof s == "function" ? Ir(s, { "": l }, "", l) : l;
  }
}
class Zs extends Qs {
  constructor(e) {
    super(Xs), this.source = e, Object.defineProperty(this, "tag", {
      set() {
        throw new Error("Alias nodes cannot have tags");
      }
    });
  }
  resolve(e) {
    let t;
    return vr(e, {
      Node: (i, n) => {
        if (n === this)
          return vr.BREAK;
        n.anchor === this.source && (t = n);
      }
    }), t;
  }
  toJSON(e, t) {
    if (!t)
      return { source: this.source };
    const { anchors: i, doc: n, maxAliasCount: s } = t, o = this.resolve(n);
    if (!o) {
      const a = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
      throw new ReferenceError(a);
    }
    let l = i.get(o);
    if (l || (St(o, null, t), l = i.get(o)), !l || l.res === void 0) {
      const a = "This should not happen: Alias anchor was not resolved?";
      throw new ReferenceError(a);
    }
    if (s >= 0 && (l.count += 1, l.aliasCount === 0 && (l.aliasCount = Zi(n, o, i)), l.count * l.aliasCount > s)) {
      const a = "Excessive alias count indicates a resource exhaustion attack";
      throw new ReferenceError(a);
    }
    return l.res;
  }
  toString(e, t, i) {
    const n = `*${this.source}`;
    if (e) {
      if (Sl(this.source), e.options.verifyAliasOrder && !e.anchors.has(this.source)) {
        const s = `Unresolved alias (the anchor must be set before the alias): ${this.source}`;
        throw new Error(s);
      }
      if (e.implicitKey)
        return `${n} `;
    }
    return n;
  }
}
function Zi(r, e, t) {
  if (Wr(e)) {
    const i = e.resolve(r), n = t && i && t.get(i);
    return n ? n.count * n.aliasCount : 0;
  } else if (Ne(e)) {
    let i = 0;
    for (const n of e.items) {
      const s = Zi(r, n, t);
      s > i && (i = s);
    }
    return i;
  } else if (Be(e)) {
    const i = Zi(r, e.key, t), n = Zi(r, e.value, t);
    return Math.max(i, n);
  }
  return 1;
}
const Al = (r) => !r || typeof r != "function" && typeof r != "object";
class ye extends Qs {
  constructor(e) {
    super(Yt), this.value = e;
  }
  toJSON(e, t) {
    return t != null && t.keep ? this.value : St(this.value, e, t);
  }
  toString() {
    return String(this.value);
  }
}
ye.BLOCK_FOLDED = "BLOCK_FOLDED";
ye.BLOCK_LITERAL = "BLOCK_LITERAL";
ye.PLAIN = "PLAIN";
ye.QUOTE_DOUBLE = "QUOTE_DOUBLE";
ye.QUOTE_SINGLE = "QUOTE_SINGLE";
const Qh = "tag:yaml.org,2002:";
function Zh(r, e, t) {
  var i;
  if (e) {
    const n = t.filter((o) => o.tag === e), s = (i = n.find((o) => !o.format)) != null ? i : n[0];
    if (!s)
      throw new Error(`Tag ${e} not found`);
    return s;
  }
  return t.find((n) => {
    var s;
    return ((s = n.identify) == null ? void 0 : s.call(n, r)) && !n.format;
  });
}
function li(r, e, t) {
  var N, E, B;
  if (bn(r) && (r = r.contents), je(r))
    return r;
  if (Be(r)) {
    const I = (E = (N = t.schema[Jt]).createNode) == null ? void 0 : E.call(N, t.schema, null, t);
    return I.items.push(r), I;
  }
  (r instanceof String || r instanceof Number || r instanceof Boolean || typeof BigInt < "u" && r instanceof BigInt) && (r = r.valueOf());
  const { aliasDuplicateObjects: i, onAnchor: n, onTagObj: s, schema: o, sourceObjects: l } = t;
  let a;
  if (i && r && typeof r == "object") {
    if (a = l.get(r), a)
      return a.anchor || (a.anchor = n(r)), new Zs(a.anchor);
    a = { anchor: null, node: null }, l.set(r, a);
  }
  e != null && e.startsWith("!!") && (e = Qh + e.slice(2));
  let b = Zh(r, e, o.tags);
  if (!b) {
    if (r && typeof r.toJSON == "function" && (r = r.toJSON()), !r || typeof r != "object") {
      const I = new ye(r);
      return a && (a.node = I), I;
    }
    b = r instanceof Map ? o[Jt] : Symbol.iterator in Object(r) ? o[Vr] : o[Jt];
  }
  s && (s(b), delete t.onTagObj);
  const y = b != null && b.createNode ? b.createNode(t.schema, r, t) : typeof ((B = b == null ? void 0 : b.nodeClass) == null ? void 0 : B.from) == "function" ? b.nodeClass.from(t.schema, r, t) : new ye(r);
  return e ? y.tag = e : b.default || (y.tag = b.tag), a && (a.node = y), y;
}
function fn(r, e, t) {
  let i = t;
  for (let n = e.length - 1; n >= 0; --n) {
    const s = e[n];
    if (typeof s == "number" && Number.isInteger(s) && s >= 0) {
      const o = [];
      o[s] = i, i = o;
    } else
      i = /* @__PURE__ */ new Map([[s, i]]);
  }
  return li(i, void 0, {
    aliasDuplicateObjects: !1,
    keepUndefined: !1,
    onAnchor: () => {
      throw new Error("This should not happen, please report a bug.");
    },
    schema: r,
    sourceObjects: /* @__PURE__ */ new Map()
  });
}
const Qr = (r) => r == null || typeof r == "object" && !!r[Symbol.iterator]().next().done;
class An extends Qs {
  constructor(e, t) {
    super(e), Object.defineProperty(this, "schema", {
      value: t,
      configurable: !0,
      enumerable: !1,
      writable: !0
    });
  }
  clone(e) {
    const t = Object.create(Object.getPrototypeOf(this), Object.getOwnPropertyDescriptors(this));
    return e && (t.schema = e), t.items = t.items.map((i) => je(i) || Be(i) ? i.clone(e) : i), this.range && (t.range = this.range.slice()), t;
  }
  addIn(e, t) {
    if (Qr(e))
      this.add(t);
    else {
      const [i, ...n] = e, s = this.get(i, !0);
      if (Ne(s))
        s.addIn(n, t);
      else if (s === void 0 && this.schema)
        this.set(i, fn(this.schema, n, t));
      else
        throw new Error(`Expected YAML collection at ${i}. Remaining path: ${n}`);
    }
  }
  deleteIn(e) {
    const [t, ...i] = e;
    if (i.length === 0)
      return this.delete(t);
    const n = this.get(t, !0);
    if (Ne(n))
      return n.deleteIn(i);
    throw new Error(`Expected YAML collection at ${t}. Remaining path: ${i}`);
  }
  getIn(e, t) {
    const [i, ...n] = e, s = this.get(i, !0);
    return n.length === 0 ? !t && Oe(s) ? s.value : s : Ne(s) ? s.getIn(n, t) : void 0;
  }
  hasAllNullValues(e) {
    return this.items.every((t) => {
      if (!Be(t))
        return !1;
      const i = t.value;
      return i == null || e && Oe(i) && i.value == null && !i.commentBefore && !i.comment && !i.tag;
    });
  }
  hasIn(e) {
    const [t, ...i] = e;
    if (i.length === 0)
      return this.has(t);
    const n = this.get(t, !0);
    return Ne(n) ? n.hasIn(i) : !1;
  }
  setIn(e, t) {
    const [i, ...n] = e;
    if (n.length === 0)
      this.set(i, t);
    else {
      const s = this.get(i, !0);
      if (Ne(s))
        s.setIn(n, t);
      else if (s === void 0 && this.schema)
        this.set(i, fn(this.schema, n, t));
      else
        throw new Error(`Expected YAML collection at ${i}. Remaining path: ${n}`);
    }
  }
}
An.maxFlowStringSingleLineLength = 60;
const Jh = (r) => r.replace(/^(?!$)(?: $)?/gm, "#");
function $t(r, e) {
  return /^\n+$/.test(r) ? r.substring(1) : e ? r.replace(/^(?! *$)/gm, e) : r;
}
const Qt = (r, e, t) => r.endsWith(`
`) ? $t(t, e) : t.includes(`
`) ? `
` + $t(t, e) : (r.endsWith(" ") ? "" : " ") + t, Ll = "flow", Ss = "block", Ji = "quoted";
function Ln(r, e, t = "flow", { indentAtStart: i, lineWidth: n = 80, minContentWidth: s = 20, onFold: o, onOverflow: l } = {}) {
  if (!n || n < 0)
    return r;
  const a = Math.max(1 + s, 1 + n - e.length);
  if (r.length <= a)
    return r;
  const b = [], y = {};
  let N = n - e.length;
  typeof i == "number" && (i > n - Math.max(2, s) ? b.push(0) : N = n - i);
  let E, B, I = !1, T = -1, A = -1, w = -1;
  t === Ss && (T = fo(r, T), T !== -1 && (N = T + a));
  for (let u; u = r[T += 1]; ) {
    if (t === Ji && u === "\\") {
      switch (A = T, r[T + 1]) {
        case "x":
          T += 3;
          break;
        case "u":
          T += 5;
          break;
        case "U":
          T += 9;
          break;
        default:
          T += 1;
      }
      w = T;
    }
    if (u === `
`)
      t === Ss && (T = fo(r, T)), N = T + a, E = void 0;
    else {
      if (u === " " && B && B !== " " && B !== `
` && B !== "	") {
        const M = r[T + 1];
        M && M !== " " && M !== `
` && M !== "	" && (E = T);
      }
      if (T >= N)
        if (E)
          b.push(E), N = E + a, E = void 0;
        else if (t === Ji) {
          for (; B === " " || B === "	"; )
            B = u, u = r[T += 1], I = !0;
          const M = T > w + 1 ? T - 2 : A - 1;
          if (y[M])
            return r;
          b.push(M), y[M] = !0, N = M + a, E = void 0;
        } else
          I = !0;
    }
    B = u;
  }
  if (I && l && l(), b.length === 0)
    return r;
  o && o();
  let O = r.slice(0, b[0]);
  for (let u = 0; u < b.length; ++u) {
    const M = b[u], d = b[u + 1] || r.length;
    M === 0 ? O = `
${e}${r.slice(0, d)}` : (t === Ji && y[M] && (O += `${r[M]}\\`), O += `
${e}${r.slice(M + 1, d)}`);
  }
  return O;
}
function fo(r, e) {
  let t = r[e + 1];
  for (; t === " " || t === "	"; ) {
    do
      t = r[e += 1];
    while (t && t !== `
`);
    t = r[e + 1];
  }
  return e;
}
const wn = (r, e) => ({
  indentAtStart: e ? r.indent.length : r.indentAtStart,
  lineWidth: r.options.lineWidth,
  minContentWidth: r.options.minContentWidth
}), Dn = (r) => /^(%|---|\.\.\.)/m.test(r);
function qh(r, e, t) {
  if (!e || e < 0)
    return !1;
  const i = e - t, n = r.length;
  if (n <= i)
    return !1;
  for (let s = 0, o = 0; s < n; ++s)
    if (r[s] === `
`) {
      if (s - o > i)
        return !0;
      if (o = s + 1, n - o <= i)
        return !1;
    }
  return !0;
}
function ii(r, e) {
  const t = JSON.stringify(r);
  if (e.options.doubleQuotedAsJSON)
    return t;
  const { implicitKey: i } = e, n = e.options.doubleQuotedMinMultiLineLength, s = e.indent || (Dn(r) ? "  " : "");
  let o = "", l = 0;
  for (let a = 0, b = t[a]; b; b = t[++a])
    if (b === " " && t[a + 1] === "\\" && t[a + 2] === "n" && (o += t.slice(l, a) + "\\ ", a += 1, l = a, b = "\\"), b === "\\")
      switch (t[a + 1]) {
        case "u":
          {
            o += t.slice(l, a);
            const y = t.substr(a + 2, 4);
            switch (y) {
              case "0000":
                o += "\\0";
                break;
              case "0007":
                o += "\\a";
                break;
              case "000b":
                o += "\\v";
                break;
              case "001b":
                o += "\\e";
                break;
              case "0085":
                o += "\\N";
                break;
              case "00a0":
                o += "\\_";
                break;
              case "2028":
                o += "\\L";
                break;
              case "2029":
                o += "\\P";
                break;
              default:
                y.substr(0, 2) === "00" ? o += "\\x" + y.substr(2) : o += t.substr(a, 6);
            }
            a += 5, l = a + 1;
          }
          break;
        case "n":
          if (i || t[a + 2] === '"' || t.length < n)
            a += 1;
          else {
            for (o += t.slice(l, a) + `

`; t[a + 2] === "\\" && t[a + 3] === "n" && t[a + 4] !== '"'; )
              o += `
`, a += 2;
            o += s, t[a + 2] === " " && (o += "\\"), a += 1, l = a + 1;
          }
          break;
        default:
          a += 1;
      }
  return o = l ? o + t.slice(l) : t, i ? o : Ln(o, s, Ji, wn(e, !1));
}
function xs(r, e) {
  if (e.options.singleQuote === !1 || e.implicitKey && r.includes(`
`) || /[ \t]\n|\n[ \t]/.test(r))
    return ii(r, e);
  const t = e.indent || (Dn(r) ? "  " : ""), i = "'" + r.replace(/'/g, "''").replace(/\n+/g, `$&
${t}`) + "'";
  return e.implicitKey ? i : Ln(i, t, Ll, wn(e, !1));
}
function Or(r, e) {
  const { singleQuote: t } = e.options;
  let i;
  if (t === !1)
    i = ii;
  else {
    const n = r.includes('"'), s = r.includes("'");
    n && !s ? i = xs : s && !n ? i = ii : i = t ? xs : ii;
  }
  return i(r, e);
}
let bs;
try {
  bs = new RegExp(`(^|(?<!
))
+(?!
|$)`, "g");
} catch {
  bs = /\n+(?!\n|$)/g;
}
function qi({ comment: r, type: e, value: t }, i, n, s) {
  const { blockQuote: o, commentString: l, lineWidth: a } = i.options;
  if (!o || /\n[\t ]+$/.test(t) || /^\s*$/.test(t))
    return Or(t, i);
  const b = i.indent || (i.forceBlockIndent || Dn(t) ? "  " : ""), y = o === "literal" ? !0 : o === "folded" || e === ye.BLOCK_FOLDED ? !1 : e === ye.BLOCK_LITERAL ? !0 : !qh(t, a, b.length);
  if (!t)
    return y ? `|
` : `>
`;
  let N, E;
  for (E = t.length; E > 0; --E) {
    const c = t[E - 1];
    if (c !== `
` && c !== "	" && c !== " ")
      break;
  }
  let B = t.substring(E);
  const I = B.indexOf(`
`);
  I === -1 ? N = "-" : t === B || I !== B.length - 1 ? (N = "+", s && s()) : N = "", B && (t = t.slice(0, -B.length), B[B.length - 1] === `
` && (B = B.slice(0, -1)), B = B.replace(bs, `$&${b}`));
  let T = !1, A, w = -1;
  for (A = 0; A < t.length; ++A) {
    const c = t[A];
    if (c === " ")
      T = !0;
    else if (c === `
`)
      w = A;
    else
      break;
  }
  let O = t.substring(0, w < A ? w + 1 : A);
  O && (t = t.substring(O.length), O = O.replace(/\n+/g, `$&${b}`));
  let M = (y ? "|" : ">") + (T ? b ? "2" : "1" : "") + N;
  if (r && (M += " " + l(r.replace(/ ?[\r\n]+/g, " ")), n && n()), y)
    return t = t.replace(/\n+/g, `$&${b}`), `${M}
${b}${O}${t}${B}`;
  t = t.replace(/\n+/g, `
$&`).replace(/(?:^|\n)([\t ].*)(?:([\n\t ]*)\n(?![\n\t ]))?/g, "$1$2").replace(/\n+/g, `$&${b}`);
  const d = Ln(`${O}${t}${B}`, b, Ss, wn(i, !0));
  return `${M}
${b}${d}`;
}
function ed(r, e, t, i) {
  const { type: n, value: s } = r, { actualString: o, implicitKey: l, indent: a, indentStep: b, inFlow: y } = e;
  if (l && s.includes(`
`) || y && /[[\]{},]/.test(s))
    return Or(s, e);
  if (!s || /^[\n\t ,[\]{}#&*!|>'"%@`]|^[?-]$|^[?-][ \t]|[\n:][ \t]|[ \t]\n|[\n\t ]#|[\n\t :]$/.test(s))
    return l || y || !s.includes(`
`) ? Or(s, e) : qi(r, e, t, i);
  if (!l && !y && n !== ye.PLAIN && s.includes(`
`))
    return qi(r, e, t, i);
  if (Dn(s)) {
    if (a === "")
      return e.forceBlockIndent = !0, qi(r, e, t, i);
    if (l && a === b)
      return Or(s, e);
  }
  const N = s.replace(/\n+/g, `$&
${a}`);
  if (o) {
    const E = (T) => {
      var A;
      return T.default && T.tag !== "tag:yaml.org,2002:str" && ((A = T.test) == null ? void 0 : A.test(N));
    }, { compat: B, tags: I } = e.doc.schema;
    if (I.some(E) || (B == null ? void 0 : B.some(E)))
      return Or(s, e);
  }
  return l ? N : Ln(N, a, Ll, wn(e, !1));
}
function Js(r, e, t, i) {
  const { implicitKey: n, inFlow: s } = e, o = typeof r.value == "string" ? r : Object.assign({}, r, { value: String(r.value) });
  let { type: l } = r;
  l !== ye.QUOTE_DOUBLE && /[\x00-\x08\x0b-\x1f\x7f-\x9f\u{D800}-\u{DFFF}]/u.test(o.value) && (l = ye.QUOTE_DOUBLE);
  const a = (y) => {
    switch (y) {
      case ye.BLOCK_FOLDED:
      case ye.BLOCK_LITERAL:
        return n || s ? Or(o.value, e) : qi(o, e, t, i);
      case ye.QUOTE_DOUBLE:
        return ii(o.value, e);
      case ye.QUOTE_SINGLE:
        return xs(o.value, e);
      case ye.PLAIN:
        return ed(o, e, t, i);
      default:
        return null;
    }
  };
  let b = a(l);
  if (b === null) {
    const { defaultKeyType: y, defaultStringType: N } = e.options, E = n && y || N;
    if (b = a(E), b === null)
      throw new Error(`Unsupported default string type ${E}`);
  }
  return b;
}
function wl(r, e) {
  const t = Object.assign({
    blockQuote: !0,
    commentString: Jh,
    defaultKeyType: null,
    defaultStringType: "PLAIN",
    directives: null,
    doubleQuotedAsJSON: !1,
    doubleQuotedMinMultiLineLength: 40,
    falseStr: "false",
    flowCollectionPadding: !0,
    indentSeq: !0,
    lineWidth: 80,
    minContentWidth: 20,
    nullStr: "null",
    simpleKeys: !1,
    singleQuote: null,
    trueStr: "true",
    verifyAliasOrder: !0
  }, r.schema.toStringOptions, e);
  let i;
  switch (t.collectionStyle) {
    case "block":
      i = !1;
      break;
    case "flow":
      i = !0;
      break;
    default:
      i = null;
  }
  return {
    anchors: /* @__PURE__ */ new Set(),
    doc: r,
    flowCollectionPadding: t.flowCollectionPadding ? " " : "",
    indent: "",
    indentStep: typeof t.indent == "number" ? " ".repeat(t.indent) : "  ",
    inFlow: i,
    options: t
  };
}
function td(r, e) {
  var n, s, o, l;
  if (e.tag) {
    const a = r.filter((b) => b.tag === e.tag);
    if (a.length > 0)
      return (n = a.find((b) => b.format === e.format)) != null ? n : a[0];
  }
  let t, i;
  if (Oe(e)) {
    i = e.value;
    const a = r.filter((b) => {
      var y;
      return (y = b.identify) == null ? void 0 : y.call(b, i);
    });
    t = (s = a.find((b) => b.format === e.format)) != null ? s : a.find((b) => !b.format);
  } else
    i = e, t = r.find((a) => a.nodeClass && i instanceof a.nodeClass);
  if (!t) {
    const a = (l = (o = i == null ? void 0 : i.constructor) == null ? void 0 : o.name) != null ? l : typeof i;
    throw new Error(`Tag not resolved for ${a} value`);
  }
  return t;
}
function rd(r, e, { anchors: t, doc: i }) {
  if (!i.directives)
    return "";
  const n = [], s = (Oe(r) || Ne(r)) && r.anchor;
  s && Sl(s) && (t.add(s), n.push(`&${s}`));
  const o = r.tag ? r.tag : e.default ? null : e.tag;
  return o && n.push(i.directives.tagString(o)), n.join(" ");
}
function Fr(r, e, t, i) {
  var a, b;
  if (Be(r))
    return r.toString(e, t, i);
  if (Wr(r)) {
    if (e.doc.directives)
      return r.toString(e);
    if ((a = e.resolvedAliases) != null && a.has(r))
      throw new TypeError("Cannot stringify circular structure without alias nodes");
    e.resolvedAliases ? e.resolvedAliases.add(r) : e.resolvedAliases = /* @__PURE__ */ new Set([r]), r = r.resolve(e.doc);
  }
  let n;
  const s = je(r) ? r : e.doc.createNode(r, { onTagObj: (y) => n = y });
  n || (n = td(e.doc.schema.tags, s));
  const o = rd(s, n, e);
  o.length > 0 && (e.indentAtStart = ((b = e.indentAtStart) != null ? b : 0) + o.length + 1);
  const l = typeof n.stringify == "function" ? n.stringify(s, e, t, i) : Oe(s) ? Js(s, e, t, i) : s.toString(e, t, i);
  return o ? Oe(s) || l[0] === "{" || l[0] === "[" ? `${o} ${l}` : `${o}
${e.indent}${l}` : l;
}
function id({ key: r, value: e }, t, i, n) {
  var v, g;
  const { allNullValues: s, doc: o, indent: l, indentStep: a, options: { commentString: b, indentSeq: y, simpleKeys: N } } = t;
  let E = je(r) && r.comment || null;
  if (N) {
    if (E)
      throw new Error("With simple keys, key nodes cannot have comments");
    if (Ne(r)) {
      const m = "With simple keys, collection cannot be used as a key value";
      throw new Error(m);
    }
  }
  let B = !N && (!r || E && e == null && !t.inFlow || Ne(r) || (Oe(r) ? r.type === ye.BLOCK_FOLDED || r.type === ye.BLOCK_LITERAL : typeof r == "object"));
  t = Object.assign({}, t, {
    allNullValues: !1,
    implicitKey: !B && (N || !s),
    indent: l + a
  });
  let I = !1, T = !1, A = Fr(r, t, () => I = !0, () => T = !0);
  if (!B && !t.inFlow && A.length > 1024) {
    if (N)
      throw new Error("With simple keys, single line scalar must not span more than 1024 characters");
    B = !0;
  }
  if (t.inFlow) {
    if (s || e == null)
      return I && i && i(), A === "" ? "?" : B ? `? ${A}` : A;
  } else if (s && !N || e == null && B)
    return A = `? ${A}`, E && !I ? A += Qt(A, t.indent, b(E)) : T && n && n(), A;
  I && (E = null), B ? (E && (A += Qt(A, t.indent, b(E))), A = `? ${A}
${l}:`) : (A = `${A}:`, E && (A += Qt(A, t.indent, b(E))));
  let w, O, u;
  je(e) ? (w = !!e.spaceBefore, O = e.commentBefore, u = e.comment) : (w = !1, O = null, u = null, e && typeof e == "object" && (e = o.createNode(e))), t.implicitKey = !1, !B && !E && Oe(e) && (t.indentAtStart = A.length + 1), T = !1, !y && a.length >= 2 && !t.inFlow && !B && yi(e) && !e.flow && !e.tag && !e.anchor && (t.indent = t.indent.substring(2));
  let M = !1;
  const d = Fr(e, t, () => M = !0, () => T = !0);
  let c = " ";
  if (E || w || O) {
    if (c = w ? `
` : "", O) {
      const m = b(O);
      c += `
${$t(m, t.indent)}`;
    }
    d === "" && !t.inFlow ? c === `
` && (c = `

`) : c += `
${t.indent}`;
  } else if (!B && Ne(e)) {
    const m = d[0], D = d.indexOf(`
`), L = D !== -1, p = (g = (v = t.inFlow) != null ? v : e.flow) != null ? g : e.items.length === 0;
    if (L || !p) {
      let x = !1;
      if (L && (m === "&" || m === "!")) {
        let k = d.indexOf(" ");
        m === "&" && k !== -1 && k < D && d[k + 1] === "!" && (k = d.indexOf(" ", k + 1)), (k === -1 || D < k) && (x = !0);
      }
      x || (c = `
${t.indent}`);
    }
  } else
    (d === "" || d[0] === `
`) && (c = "");
  return A += c + d, t.inFlow ? M && i && i() : u && !M ? A += Qt(A, t.indent, b(u)) : T && n && n(), A;
}
function Dl(r, e) {
  (r === "debug" || r === "warn") && (typeof process < "u" && process.emitWarning ? process.emitWarning(e) : console.warn(e));
}
const ho = "<<";
function Il(r, e, { key: t, value: i }) {
  if ((r == null ? void 0 : r.doc.schema.merge) && nd(t))
    if (i = Wr(i) ? i.resolve(r.doc) : i, yi(i))
      for (const n of i.items)
        os(r, e, n);
    else if (Array.isArray(i))
      for (const n of i)
        os(r, e, n);
    else
      os(r, e, i);
  else {
    const n = St(t, "", r);
    if (e instanceof Map)
      e.set(n, St(i, n, r));
    else if (e instanceof Set)
      e.add(n);
    else {
      const s = sd(t, n, r), o = St(i, s, r);
      s in e ? Object.defineProperty(e, s, {
        value: o,
        writable: !0,
        enumerable: !0,
        configurable: !0
      }) : e[s] = o;
    }
  }
  return e;
}
const nd = (r) => r === ho || Oe(r) && r.value === ho && (!r.type || r.type === ye.PLAIN);
function os(r, e, t) {
  const i = r && Wr(t) ? t.resolve(r.doc) : t;
  if (!pi(i))
    throw new Error("Merge sources must be maps or map aliases");
  const n = i.toJSON(null, r, Map);
  for (const [s, o] of n)
    e instanceof Map ? e.has(s) || e.set(s, o) : e instanceof Set ? e.add(s) : Object.prototype.hasOwnProperty.call(e, s) || Object.defineProperty(e, s, {
      value: o,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  return e;
}
function sd(r, e, t) {
  if (e === null)
    return "";
  if (typeof e != "object")
    return String(e);
  if (je(r) && (t == null ? void 0 : t.doc)) {
    const i = wl(t.doc, {});
    i.anchors = /* @__PURE__ */ new Set();
    for (const s of t.anchors.keys())
      i.anchors.add(s.anchor);
    i.inFlow = !0, i.inStringifyKey = !0;
    const n = r.toString(i);
    if (!t.mapKeyWarned) {
      let s = JSON.stringify(n);
      s.length > 40 && (s = s.substring(0, 36) + '..."'), Dl(t.doc.options.logLevel, `Keys with collection values will be stringified due to JS Object restrictions: ${s}. Set mapAsMap: true to use object keys.`), t.mapKeyWarned = !0;
    }
    return n;
  }
  return JSON.stringify(e);
}
function qs(r, e, t) {
  const i = li(r, void 0, t), n = li(e, void 0, t);
  return new lt(i, n);
}
class lt {
  constructor(e, t = null) {
    Object.defineProperty(this, xt, { value: Tl }), this.key = e, this.value = t;
  }
  clone(e) {
    let { key: t, value: i } = this;
    return je(t) && (t = t.clone(e)), je(i) && (i = i.clone(e)), new lt(t, i);
  }
  toJSON(e, t) {
    const i = t != null && t.mapAsMap ? /* @__PURE__ */ new Map() : {};
    return Il(t, i, this);
  }
  toString(e, t, i) {
    return e != null && e.doc ? id(this, e, t, i) : JSON.stringify(this);
  }
}
function Ol(r, e, t) {
  var s;
  return (((s = e.inFlow) != null ? s : r.flow) ? od : ad)(r, e, t);
}
function ad({ comment: r, items: e }, t, { blockItemPrefix: i, flowChars: n, itemIndent: s, onChompKeep: o, onComment: l }) {
  const { indent: a, options: { commentString: b } } = t, y = Object.assign({}, t, { indent: s, type: null });
  let N = !1;
  const E = [];
  for (let I = 0; I < e.length; ++I) {
    const T = e[I];
    let A = null;
    if (je(T))
      !N && T.spaceBefore && E.push(""), hn(t, E, T.commentBefore, N), T.comment && (A = T.comment);
    else if (Be(T)) {
      const O = je(T.key) ? T.key : null;
      O && (!N && O.spaceBefore && E.push(""), hn(t, E, O.commentBefore, N));
    }
    N = !1;
    let w = Fr(T, y, () => A = null, () => N = !0);
    A && (w += Qt(w, s, b(A))), N && A && (N = !1), E.push(i + w);
  }
  let B;
  if (E.length === 0)
    B = n.start + n.end;
  else {
    B = E[0];
    for (let I = 1; I < E.length; ++I) {
      const T = E[I];
      B += T ? `
${a}${T}` : `
`;
    }
  }
  return r ? (B += `
` + $t(b(r), a), l && l()) : N && o && o(), B;
}
function od({ comment: r, items: e }, t, { flowChars: i, itemIndent: n, onComment: s }) {
  const { indent: o, indentStep: l, flowCollectionPadding: a, options: { commentString: b } } = t;
  n += l;
  const y = Object.assign({}, t, {
    indent: n,
    inFlow: !0,
    type: null
  });
  let N = !1, E = 0;
  const B = [];
  for (let w = 0; w < e.length; ++w) {
    const O = e[w];
    let u = null;
    if (je(O))
      O.spaceBefore && B.push(""), hn(t, B, O.commentBefore, !1), O.comment && (u = O.comment);
    else if (Be(O)) {
      const d = je(O.key) ? O.key : null;
      d && (d.spaceBefore && B.push(""), hn(t, B, d.commentBefore, !1), d.comment && (N = !0));
      const c = je(O.value) ? O.value : null;
      c ? (c.comment && (u = c.comment), c.commentBefore && (N = !0)) : O.value == null && (d == null ? void 0 : d.comment) && (u = d.comment);
    }
    u && (N = !0);
    let M = Fr(O, y, () => u = null);
    w < e.length - 1 && (M += ","), u && (M += Qt(M, n, b(u))), !N && (B.length > E || M.includes(`
`)) && (N = !0), B.push(M), E = B.length;
  }
  let I;
  const { start: T, end: A } = i;
  if (B.length === 0)
    I = T + A;
  else if (N || (N = B.reduce((O, u) => O + u.length + 2, 2) > An.maxFlowStringSingleLineLength), N) {
    I = T;
    for (const w of B)
      I += w ? `
${l}${o}${w}` : `
`;
    I += `
${o}${A}`;
  } else
    I = `${T}${a}${B.join(" ")}${a}${A}`;
  return r && (I += Qt(I, o, b(r)), s && s()), I;
}
function hn({ indent: r, options: { commentString: e } }, t, i, n) {
  if (i && n && (i = i.replace(/^\n+/, "")), i) {
    const s = $t(e(i), r);
    t.push(s.trimStart());
  }
}
function ur(r, e) {
  const t = Oe(e) ? e.value : e;
  for (const i of r)
    if (Be(i) && (i.key === e || i.key === t || Oe(i.key) && i.key.value === t))
      return i;
}
class Tt extends An {
  static get tagName() {
    return "tag:yaml.org,2002:map";
  }
  constructor(e) {
    super(Jt, e), this.items = [];
  }
  static from(e, t, i) {
    const { keepUndefined: n, replacer: s } = i, o = new this(e), l = (a, b) => {
      if (typeof s == "function")
        b = s.call(t, a, b);
      else if (Array.isArray(s) && !s.includes(a))
        return;
      (b !== void 0 || n) && o.items.push(qs(a, b, i));
    };
    if (t instanceof Map)
      for (const [a, b] of t)
        l(a, b);
    else if (t && typeof t == "object")
      for (const a of Object.keys(t))
        l(a, t[a]);
    return typeof e.sortMapEntries == "function" && o.items.sort(e.sortMapEntries), o;
  }
  add(e, t) {
    var o;
    let i;
    Be(e) ? i = e : !e || typeof e != "object" || !("key" in e) ? i = new lt(e, e == null ? void 0 : e.value) : i = new lt(e.key, e.value);
    const n = ur(this.items, i.key), s = (o = this.schema) == null ? void 0 : o.sortMapEntries;
    if (n) {
      if (!t)
        throw new Error(`Key ${i.key} already set`);
      Oe(n.value) && Al(i.value) ? n.value.value = i.value : n.value = i.value;
    } else if (s) {
      const l = this.items.findIndex((a) => s(i, a) < 0);
      l === -1 ? this.items.push(i) : this.items.splice(l, 0, i);
    } else
      this.items.push(i);
  }
  delete(e) {
    const t = ur(this.items, e);
    return t ? this.items.splice(this.items.indexOf(t), 1).length > 0 : !1;
  }
  get(e, t) {
    var s;
    const i = ur(this.items, e), n = i == null ? void 0 : i.value;
    return (s = !t && Oe(n) ? n.value : n) != null ? s : void 0;
  }
  has(e) {
    return !!ur(this.items, e);
  }
  set(e, t) {
    this.add(new lt(e, t), !0);
  }
  toJSON(e, t, i) {
    const n = i ? new i() : t != null && t.mapAsMap ? /* @__PURE__ */ new Map() : {};
    t != null && t.onCreate && t.onCreate(n);
    for (const s of this.items)
      Il(t, n, s);
    return n;
  }
  toString(e, t, i) {
    if (!e)
      return JSON.stringify(this);
    for (const n of this.items)
      if (!Be(n))
        throw new Error(`Map items must all be pairs; found ${JSON.stringify(n)} instead`);
    return !e.allNullValues && this.hasAllNullValues(!1) && (e = Object.assign({}, e, { allNullValues: !0 })), Ol(this, e, {
      blockItemPrefix: "",
      flowChars: { start: "{", end: "}" },
      itemIndent: e.indent || "",
      onChompKeep: i,
      onComment: t
    });
  }
}
const Gr = {
  collection: "map",
  default: !0,
  nodeClass: Tt,
  tag: "tag:yaml.org,2002:map",
  resolve(r, e) {
    return pi(r) || e("Expected a mapping for this tag"), r;
  },
  createNode: (r, e, t) => Tt.from(r, e, t)
};
class mr extends An {
  static get tagName() {
    return "tag:yaml.org,2002:seq";
  }
  constructor(e) {
    super(Vr, e), this.items = [];
  }
  add(e) {
    this.items.push(e);
  }
  delete(e) {
    const t = ki(e);
    return typeof t != "number" ? !1 : this.items.splice(t, 1).length > 0;
  }
  get(e, t) {
    const i = ki(e);
    if (typeof i != "number")
      return;
    const n = this.items[i];
    return !t && Oe(n) ? n.value : n;
  }
  has(e) {
    const t = ki(e);
    return typeof t == "number" && t < this.items.length;
  }
  set(e, t) {
    const i = ki(e);
    if (typeof i != "number")
      throw new Error(`Expected a valid index, not ${e}.`);
    const n = this.items[i];
    Oe(n) && Al(t) ? n.value = t : this.items[i] = t;
  }
  toJSON(e, t) {
    const i = [];
    t != null && t.onCreate && t.onCreate(i);
    let n = 0;
    for (const s of this.items)
      i.push(St(s, String(n++), t));
    return i;
  }
  toString(e, t, i) {
    return e ? Ol(this, e, {
      blockItemPrefix: "- ",
      flowChars: { start: "[", end: "]" },
      itemIndent: (e.indent || "") + "  ",
      onChompKeep: i,
      onComment: t
    }) : JSON.stringify(this);
  }
  static from(e, t, i) {
    const { replacer: n } = i, s = new this(e);
    if (t && Symbol.iterator in Object(t)) {
      let o = 0;
      for (let l of t) {
        if (typeof n == "function") {
          const a = t instanceof Set ? l : String(o++);
          l = n.call(t, a, l);
        }
        s.items.push(li(l, void 0, i));
      }
    }
    return s;
  }
}
function ki(r) {
  let e = Oe(r) ? r.value : r;
  return e && typeof e == "string" && (e = Number(e)), typeof e == "number" && Number.isInteger(e) && e >= 0 ? e : null;
}
const Hr = {
  collection: "seq",
  default: !0,
  nodeClass: mr,
  tag: "tag:yaml.org,2002:seq",
  resolve(r, e) {
    return yi(r) || e("Expected a sequence for this tag"), r;
  },
  createNode: (r, e, t) => mr.from(r, e, t)
}, In = {
  identify: (r) => typeof r == "string",
  default: !0,
  tag: "tag:yaml.org,2002:str",
  resolve: (r) => r,
  stringify(r, e, t, i) {
    return e = Object.assign({ actualString: !0 }, e), Js(r, e, t, i);
  }
}, On = {
  identify: (r) => r == null,
  createNode: () => new ye(null),
  default: !0,
  tag: "tag:yaml.org,2002:null",
  test: /^(?:~|[Nn]ull|NULL)?$/,
  resolve: () => new ye(null),
  stringify: ({ source: r }, e) => typeof r == "string" && On.test.test(r) ? r : e.options.nullStr
}, ea = {
  identify: (r) => typeof r == "boolean",
  default: !0,
  tag: "tag:yaml.org,2002:bool",
  test: /^(?:[Tt]rue|TRUE|[Ff]alse|FALSE)$/,
  resolve: (r) => new ye(r[0] === "t" || r[0] === "T"),
  stringify({ source: r, value: e }, t) {
    if (r && ea.test.test(r)) {
      const i = r[0] === "t" || r[0] === "T";
      if (e === i)
        return r;
    }
    return e ? t.options.trueStr : t.options.falseStr;
  }
};
function Ft({ format: r, minFractionDigits: e, tag: t, value: i }) {
  if (typeof i == "bigint")
    return String(i);
  const n = typeof i == "number" ? i : Number(i);
  if (!isFinite(n))
    return isNaN(n) ? ".nan" : n < 0 ? "-.inf" : ".inf";
  let s = JSON.stringify(i);
  if (!r && e && (!t || t === "tag:yaml.org,2002:float") && /^\d/.test(s)) {
    let o = s.indexOf(".");
    o < 0 && (o = s.length, s += ".");
    let l = e - (s.length - o - 1);
    for (; l-- > 0; )
      s += "0";
  }
  return s;
}
const Cl = {
  identify: (r) => typeof r == "number",
  default: !0,
  tag: "tag:yaml.org,2002:float",
  test: /^(?:[-+]?\.(?:inf|Inf|INF|nan|NaN|NAN))$/,
  resolve: (r) => r.slice(-3).toLowerCase() === "nan" ? NaN : r[0] === "-" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY,
  stringify: Ft
}, Pl = {
  identify: (r) => typeof r == "number",
  default: !0,
  tag: "tag:yaml.org,2002:float",
  format: "EXP",
  test: /^[-+]?(?:\.[0-9]+|[0-9]+(?:\.[0-9]*)?)[eE][-+]?[0-9]+$/,
  resolve: (r) => parseFloat(r),
  stringify(r) {
    const e = Number(r.value);
    return isFinite(e) ? e.toExponential() : Ft(r);
  }
}, Rl = {
  identify: (r) => typeof r == "number",
  default: !0,
  tag: "tag:yaml.org,2002:float",
  test: /^[-+]?(?:\.[0-9]+|[0-9]+\.[0-9]*)$/,
  resolve(r) {
    const e = new ye(parseFloat(r)), t = r.indexOf(".");
    return t !== -1 && r[r.length - 1] === "0" && (e.minFractionDigits = r.length - t - 1), e;
  },
  stringify: Ft
}, Cn = (r) => typeof r == "bigint" || Number.isInteger(r), ta = (r, e, t, { intAsBigInt: i }) => i ? BigInt(r) : parseInt(r.substring(e), t);
function Ml(r, e, t) {
  const { value: i } = r;
  return Cn(i) && i >= 0 ? t + i.toString(e) : Ft(r);
}
const kl = {
  identify: (r) => Cn(r) && r >= 0,
  default: !0,
  tag: "tag:yaml.org,2002:int",
  format: "OCT",
  test: /^0o[0-7]+$/,
  resolve: (r, e, t) => ta(r, 2, 8, t),
  stringify: (r) => Ml(r, 8, "0o")
}, Fl = {
  identify: Cn,
  default: !0,
  tag: "tag:yaml.org,2002:int",
  test: /^[-+]?[0-9]+$/,
  resolve: (r, e, t) => ta(r, 0, 10, t),
  stringify: Ft
}, Nl = {
  identify: (r) => Cn(r) && r >= 0,
  default: !0,
  tag: "tag:yaml.org,2002:int",
  format: "HEX",
  test: /^0x[0-9a-fA-F]+$/,
  resolve: (r, e, t) => ta(r, 2, 16, t),
  stringify: (r) => Ml(r, 16, "0x")
}, ld = [
  Gr,
  Hr,
  In,
  On,
  ea,
  kl,
  Fl,
  Nl,
  Cl,
  Pl,
  Rl
];
function vo(r) {
  return typeof r == "bigint" || Number.isInteger(r);
}
const Fi = ({ value: r }) => JSON.stringify(r), ud = [
  {
    identify: (r) => typeof r == "string",
    default: !0,
    tag: "tag:yaml.org,2002:str",
    resolve: (r) => r,
    stringify: Fi
  },
  {
    identify: (r) => r == null,
    createNode: () => new ye(null),
    default: !0,
    tag: "tag:yaml.org,2002:null",
    test: /^null$/,
    resolve: () => null,
    stringify: Fi
  },
  {
    identify: (r) => typeof r == "boolean",
    default: !0,
    tag: "tag:yaml.org,2002:bool",
    test: /^true|false$/,
    resolve: (r) => r === "true",
    stringify: Fi
  },
  {
    identify: vo,
    default: !0,
    tag: "tag:yaml.org,2002:int",
    test: /^-?(?:0|[1-9][0-9]*)$/,
    resolve: (r, e, { intAsBigInt: t }) => t ? BigInt(r) : parseInt(r, 10),
    stringify: ({ value: r }) => vo(r) ? r.toString() : JSON.stringify(r)
  },
  {
    identify: (r) => typeof r == "number",
    default: !0,
    tag: "tag:yaml.org,2002:float",
    test: /^-?(?:0|[1-9][0-9]*)(?:\.[0-9]*)?(?:[eE][-+]?[0-9]+)?$/,
    resolve: (r) => parseFloat(r),
    stringify: Fi
  }
], cd = {
  default: !0,
  tag: "",
  test: /^/,
  resolve(r, e) {
    return e(`Unresolved plain scalar ${JSON.stringify(r)}`), r;
  }
}, fd = [Gr, Hr].concat(ud, cd), ra = {
  identify: (r) => r instanceof Uint8Array,
  default: !1,
  tag: "tag:yaml.org,2002:binary",
  resolve(r, e) {
    if (typeof Buffer == "function")
      return Buffer.from(r, "base64");
    if (typeof atob == "function") {
      const t = atob(r.replace(/[\n\r]/g, "")), i = new Uint8Array(t.length);
      for (let n = 0; n < t.length; ++n)
        i[n] = t.charCodeAt(n);
      return i;
    } else
      return e("This environment does not support reading binary tags; either Buffer or atob is required"), r;
  },
  stringify({ comment: r, type: e, value: t }, i, n, s) {
    const o = t;
    let l;
    if (typeof Buffer == "function")
      l = o instanceof Buffer ? o.toString("base64") : Buffer.from(o.buffer).toString("base64");
    else if (typeof btoa == "function") {
      let a = "";
      for (let b = 0; b < o.length; ++b)
        a += String.fromCharCode(o[b]);
      l = btoa(a);
    } else
      throw new Error("This environment does not support writing binary tags; either Buffer or btoa is required");
    if (e || (e = ye.BLOCK_LITERAL), e !== ye.QUOTE_DOUBLE) {
      const a = Math.max(i.options.lineWidth - i.indent.length, i.options.minContentWidth), b = Math.ceil(l.length / a), y = new Array(b);
      for (let N = 0, E = 0; N < b; ++N, E += a)
        y[N] = l.substr(E, a);
      l = y.join(e === ye.BLOCK_LITERAL ? `
` : " ");
    }
    return Js({ comment: r, type: e, value: l }, i, n, s);
  }
};
function Bl(r, e) {
  var t;
  if (yi(r))
    for (let i = 0; i < r.items.length; ++i) {
      let n = r.items[i];
      if (!Be(n)) {
        if (pi(n)) {
          n.items.length > 1 && e("Each pair must have its own sequence indicator");
          const s = n.items[0] || new lt(new ye(null));
          if (n.commentBefore && (s.key.commentBefore = s.key.commentBefore ? `${n.commentBefore}
${s.key.commentBefore}` : n.commentBefore), n.comment) {
            const o = (t = s.value) != null ? t : s.key;
            o.comment = o.comment ? `${n.comment}
${o.comment}` : n.comment;
          }
          n = s;
        }
        r.items[i] = Be(n) ? n : new lt(n);
      }
    }
  else
    e("Expected a sequence for this tag");
  return r;
}
function Ul(r, e, t) {
  const { replacer: i } = t, n = new mr(r);
  n.tag = "tag:yaml.org,2002:pairs";
  let s = 0;
  if (e && Symbol.iterator in Object(e))
    for (let o of e) {
      typeof i == "function" && (o = i.call(e, String(s++), o));
      let l, a;
      if (Array.isArray(o))
        if (o.length === 2)
          l = o[0], a = o[1];
        else
          throw new TypeError(`Expected [key, value] tuple: ${o}`);
      else if (o && o instanceof Object) {
        const b = Object.keys(o);
        if (b.length === 1)
          l = b[0], a = o[l];
        else
          throw new TypeError(`Expected tuple with one key, not ${b.length} keys`);
      } else
        l = o;
      n.items.push(qs(l, a, t));
    }
  return n;
}
const ia = {
  collection: "seq",
  default: !1,
  tag: "tag:yaml.org,2002:pairs",
  resolve: Bl,
  createNode: Ul
};
class Cr extends mr {
  constructor() {
    super(), this.add = Tt.prototype.add.bind(this), this.delete = Tt.prototype.delete.bind(this), this.get = Tt.prototype.get.bind(this), this.has = Tt.prototype.has.bind(this), this.set = Tt.prototype.set.bind(this), this.tag = Cr.tag;
  }
  toJSON(e, t) {
    if (!t)
      return super.toJSON(e);
    const i = /* @__PURE__ */ new Map();
    t != null && t.onCreate && t.onCreate(i);
    for (const n of this.items) {
      let s, o;
      if (Be(n) ? (s = St(n.key, "", t), o = St(n.value, s, t)) : s = St(n, "", t), i.has(s))
        throw new Error("Ordered maps must not include duplicate keys");
      i.set(s, o);
    }
    return i;
  }
  static from(e, t, i) {
    const n = Ul(e, t, i), s = new this();
    return s.items = n.items, s;
  }
}
Cr.tag = "tag:yaml.org,2002:omap";
const na = {
  collection: "seq",
  identify: (r) => r instanceof Map,
  nodeClass: Cr,
  default: !1,
  tag: "tag:yaml.org,2002:omap",
  resolve(r, e) {
    const t = Bl(r, e), i = [];
    for (const { key: n } of t.items)
      Oe(n) && (i.includes(n.value) ? e(`Ordered maps must not include duplicate keys: ${n.value}`) : i.push(n.value));
    return Object.assign(new Cr(), t);
  },
  createNode: (r, e, t) => Cr.from(r, e, t)
};
function Kl({ value: r, source: e }, t) {
  return e && (r ? Vl : Wl).test.test(e) ? e : r ? t.options.trueStr : t.options.falseStr;
}
const Vl = {
  identify: (r) => r === !0,
  default: !0,
  tag: "tag:yaml.org,2002:bool",
  test: /^(?:Y|y|[Yy]es|YES|[Tt]rue|TRUE|[Oo]n|ON)$/,
  resolve: () => new ye(!0),
  stringify: Kl
}, Wl = {
  identify: (r) => r === !1,
  default: !0,
  tag: "tag:yaml.org,2002:bool",
  test: /^(?:N|n|[Nn]o|NO|[Ff]alse|FALSE|[Oo]ff|OFF)$/i,
  resolve: () => new ye(!1),
  stringify: Kl
}, hd = {
  identify: (r) => typeof r == "number",
  default: !0,
  tag: "tag:yaml.org,2002:float",
  test: /^[-+]?\.(?:inf|Inf|INF|nan|NaN|NAN)$/,
  resolve: (r) => r.slice(-3).toLowerCase() === "nan" ? NaN : r[0] === "-" ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY,
  stringify: Ft
}, dd = {
  identify: (r) => typeof r == "number",
  default: !0,
  tag: "tag:yaml.org,2002:float",
  format: "EXP",
  test: /^[-+]?(?:[0-9][0-9_]*)?(?:\.[0-9_]*)?[eE][-+]?[0-9]+$/,
  resolve: (r) => parseFloat(r.replace(/_/g, "")),
  stringify(r) {
    const e = Number(r.value);
    return isFinite(e) ? e.toExponential() : Ft(r);
  }
}, vd = {
  identify: (r) => typeof r == "number",
  default: !0,
  tag: "tag:yaml.org,2002:float",
  test: /^[-+]?(?:[0-9][0-9_]*)?\.[0-9_]*$/,
  resolve(r) {
    const e = new ye(parseFloat(r.replace(/_/g, ""))), t = r.indexOf(".");
    if (t !== -1) {
      const i = r.substring(t + 1).replace(/_/g, "");
      i[i.length - 1] === "0" && (e.minFractionDigits = i.length);
    }
    return e;
  },
  stringify: Ft
}, Ei = (r) => typeof r == "bigint" || Number.isInteger(r);
function Pn(r, e, t, { intAsBigInt: i }) {
  const n = r[0];
  if ((n === "-" || n === "+") && (e += 1), r = r.substring(e).replace(/_/g, ""), i) {
    switch (t) {
      case 2:
        r = `0b${r}`;
        break;
      case 8:
        r = `0o${r}`;
        break;
      case 16:
        r = `0x${r}`;
        break;
    }
    const o = BigInt(r);
    return n === "-" ? BigInt(-1) * o : o;
  }
  const s = parseInt(r, t);
  return n === "-" ? -1 * s : s;
}
function sa(r, e, t) {
  const { value: i } = r;
  if (Ei(i)) {
    const n = i.toString(e);
    return i < 0 ? "-" + t + n.substr(1) : t + n;
  }
  return Ft(r);
}
const md = {
  identify: Ei,
  default: !0,
  tag: "tag:yaml.org,2002:int",
  format: "BIN",
  test: /^[-+]?0b[0-1_]+$/,
  resolve: (r, e, t) => Pn(r, 2, 2, t),
  stringify: (r) => sa(r, 2, "0b")
}, gd = {
  identify: Ei,
  default: !0,
  tag: "tag:yaml.org,2002:int",
  format: "OCT",
  test: /^[-+]?0[0-7_]+$/,
  resolve: (r, e, t) => Pn(r, 1, 8, t),
  stringify: (r) => sa(r, 8, "0")
}, pd = {
  identify: Ei,
  default: !0,
  tag: "tag:yaml.org,2002:int",
  test: /^[-+]?[0-9][0-9_]*$/,
  resolve: (r, e, t) => Pn(r, 0, 10, t),
  stringify: Ft
}, yd = {
  identify: Ei,
  default: !0,
  tag: "tag:yaml.org,2002:int",
  format: "HEX",
  test: /^[-+]?0x[0-9a-fA-F_]+$/,
  resolve: (r, e, t) => Pn(r, 2, 16, t),
  stringify: (r) => sa(r, 16, "0x")
};
class Pr extends Tt {
  constructor(e) {
    super(e), this.tag = Pr.tag;
  }
  add(e) {
    let t;
    Be(e) ? t = e : e && typeof e == "object" && "key" in e && "value" in e && e.value === null ? t = new lt(e.key, null) : t = new lt(e, null), ur(this.items, t.key) || this.items.push(t);
  }
  get(e, t) {
    const i = ur(this.items, e);
    return !t && Be(i) ? Oe(i.key) ? i.key.value : i.key : i;
  }
  set(e, t) {
    if (typeof t != "boolean")
      throw new Error(`Expected boolean value for set(key, value) in a YAML set, not ${typeof t}`);
    const i = ur(this.items, e);
    i && !t ? this.items.splice(this.items.indexOf(i), 1) : !i && t && this.items.push(new lt(e));
  }
  toJSON(e, t) {
    return super.toJSON(e, t, Set);
  }
  toString(e, t, i) {
    if (!e)
      return JSON.stringify(this);
    if (this.hasAllNullValues(!0))
      return super.toString(Object.assign({}, e, { allNullValues: !0 }), t, i);
    throw new Error("Set items must all have null values");
  }
  static from(e, t, i) {
    const { replacer: n } = i, s = new this(e);
    if (t && Symbol.iterator in Object(t))
      for (let o of t)
        typeof n == "function" && (o = n.call(t, o, o)), s.items.push(qs(o, null, i));
    return s;
  }
}
Pr.tag = "tag:yaml.org,2002:set";
const aa = {
  collection: "map",
  identify: (r) => r instanceof Set,
  nodeClass: Pr,
  default: !1,
  tag: "tag:yaml.org,2002:set",
  createNode: (r, e, t) => Pr.from(r, e, t),
  resolve(r, e) {
    if (pi(r)) {
      if (r.hasAllNullValues(!0))
        return Object.assign(new Pr(), r);
      e("Set items must all have null values");
    } else
      e("Expected a mapping for this tag");
    return r;
  }
};
function oa(r, e) {
  const t = r[0], i = t === "-" || t === "+" ? r.substring(1) : r, n = (o) => e ? BigInt(o) : Number(o), s = i.replace(/_/g, "").split(":").reduce((o, l) => o * n(60) + n(l), n(0));
  return t === "-" ? n(-1) * s : s;
}
function Gl(r) {
  let { value: e } = r, t = (o) => o;
  if (typeof e == "bigint")
    t = (o) => BigInt(o);
  else if (isNaN(e) || !isFinite(e))
    return Ft(r);
  let i = "";
  e < 0 && (i = "-", e *= t(-1));
  const n = t(60), s = [e % n];
  return e < 60 ? s.unshift(0) : (e = (e - s[0]) / n, s.unshift(e % n), e >= 60 && (e = (e - s[0]) / n, s.unshift(e))), i + s.map((o) => String(o).padStart(2, "0")).join(":").replace(/000000\d*$/, "");
}
const Hl = {
  identify: (r) => typeof r == "bigint" || Number.isInteger(r),
  default: !0,
  tag: "tag:yaml.org,2002:int",
  format: "TIME",
  test: /^[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+$/,
  resolve: (r, e, { intAsBigInt: t }) => oa(r, t),
  stringify: Gl
}, $l = {
  identify: (r) => typeof r == "number",
  default: !0,
  tag: "tag:yaml.org,2002:float",
  format: "TIME",
  test: /^[-+]?[0-9][0-9_]*(?::[0-5]?[0-9])+\.[0-9_]*$/,
  resolve: (r) => oa(r, !1),
  stringify: Gl
}, Rn = {
  identify: (r) => r instanceof Date,
  default: !0,
  tag: "tag:yaml.org,2002:timestamp",
  test: RegExp("^([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})(?:(?:t|T|[ \\t]+)([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}(\\.[0-9]+)?)(?:[ \\t]*(Z|[-+][012]?[0-9](?::[0-9]{2})?))?)?$"),
  resolve(r) {
    const e = r.match(Rn.test);
    if (!e)
      throw new Error("!!timestamp expects a date, starting with yyyy-mm-dd");
    const [, t, i, n, s, o, l] = e.map(Number), a = e[7] ? Number((e[7] + "00").substr(1, 3)) : 0;
    let b = Date.UTC(t, i - 1, n, s || 0, o || 0, l || 0, a);
    const y = e[8];
    if (y && y !== "Z") {
      let N = oa(y, !1);
      Math.abs(N) < 30 && (N *= 60), b -= 6e4 * N;
    }
    return new Date(b);
  },
  stringify: ({ value: r }) => r.toISOString().replace(/((T00:00)?:00)?\.000Z$/, "")
}, mo = [
  Gr,
  Hr,
  In,
  On,
  Vl,
  Wl,
  md,
  gd,
  pd,
  yd,
  hd,
  dd,
  vd,
  ra,
  na,
  ia,
  aa,
  Hl,
  $l,
  Rn
], go = /* @__PURE__ */ new Map([
  ["core", ld],
  ["failsafe", [Gr, Hr, In]],
  ["json", fd],
  ["yaml11", mo],
  ["yaml-1.1", mo]
]), po = {
  binary: ra,
  bool: ea,
  float: Rl,
  floatExp: Pl,
  floatNaN: Cl,
  floatTime: $l,
  int: Fl,
  intHex: Nl,
  intOct: kl,
  intTime: Hl,
  map: Gr,
  null: On,
  omap: na,
  pairs: ia,
  seq: Hr,
  set: aa,
  timestamp: Rn
}, Ed = {
  "tag:yaml.org,2002:binary": ra,
  "tag:yaml.org,2002:omap": na,
  "tag:yaml.org,2002:pairs": ia,
  "tag:yaml.org,2002:set": aa,
  "tag:yaml.org,2002:timestamp": Rn
};
function ls(r, e) {
  let t = go.get(e);
  if (!t)
    if (Array.isArray(r))
      t = [];
    else {
      const i = Array.from(go.keys()).filter((n) => n !== "yaml11").map((n) => JSON.stringify(n)).join(", ");
      throw new Error(`Unknown schema "${e}"; use one of ${i} or define customTags array`);
    }
  if (Array.isArray(r))
    for (const i of r)
      t = t.concat(i);
  else
    typeof r == "function" && (t = r(t.slice()));
  return t.map((i) => {
    if (typeof i != "string")
      return i;
    const n = po[i];
    if (n)
      return n;
    const s = Object.keys(po).map((o) => JSON.stringify(o)).join(", ");
    throw new Error(`Unknown custom tag "${i}"; use one of ${s}`);
  });
}
const _d = (r, e) => r.key < e.key ? -1 : r.key > e.key ? 1 : 0;
class la {
  constructor({ compat: e, customTags: t, merge: i, resolveKnownTags: n, schema: s, sortMapEntries: o, toStringDefaults: l }) {
    this.compat = Array.isArray(e) ? ls(e, "compat") : e ? ls(null, e) : null, this.merge = !!i, this.name = typeof s == "string" && s || "core", this.knownTags = n ? Ed : {}, this.tags = ls(t, this.name), this.toStringOptions = l != null ? l : null, Object.defineProperty(this, Jt, { value: Gr }), Object.defineProperty(this, Yt, { value: In }), Object.defineProperty(this, Vr, { value: Hr }), this.sortMapEntries = typeof o == "function" ? o : o === !0 ? _d : null;
  }
  clone() {
    const e = Object.create(la.prototype, Object.getOwnPropertyDescriptors(this));
    return e.tags = this.tags.slice(), e;
  }
}
function Td(r, e) {
  var a;
  const t = [];
  let i = e.directives === !0;
  if (e.directives !== !1 && r.directives) {
    const b = r.directives.toString(r);
    b ? (t.push(b), i = !0) : r.directives.docStart && (i = !0);
  }
  i && t.push("---");
  const n = wl(r, e), { commentString: s } = n.options;
  if (r.commentBefore) {
    t.length !== 1 && t.unshift("");
    const b = s(r.commentBefore);
    t.unshift($t(b, ""));
  }
  let o = !1, l = null;
  if (r.contents) {
    if (je(r.contents)) {
      if (r.contents.spaceBefore && i && t.push(""), r.contents.commentBefore) {
        const N = s(r.contents.commentBefore);
        t.push($t(N, ""));
      }
      n.forceBlockIndent = !!r.comment, l = r.contents.comment;
    }
    const b = l ? void 0 : () => o = !0;
    let y = Fr(r.contents, n, () => l = null, b);
    l && (y += Qt(y, "", s(l))), (y[0] === "|" || y[0] === ">") && t[t.length - 1] === "---" ? t[t.length - 1] = `--- ${y}` : t.push(y);
  } else
    t.push(Fr(r.contents, n));
  if ((a = r.directives) != null && a.docEnd)
    if (r.comment) {
      const b = s(r.comment);
      b.includes(`
`) ? (t.push("..."), t.push($t(b, ""))) : t.push(`... ${b}`);
    } else
      t.push("...");
  else {
    let b = r.comment;
    b && o && (b = b.replace(/^\n+/, "")), b && ((!o || l) && t[t.length - 1] !== "" && t.push(""), t.push($t(s(b), "")));
  }
  return t.join(`
`) + `
`;
}
class Mn {
  constructor(e, t, i) {
    this.commentBefore = null, this.comment = null, this.errors = [], this.warnings = [], Object.defineProperty(this, xt, { value: Ts });
    let n = null;
    typeof t == "function" || Array.isArray(t) ? n = t : i === void 0 && t && (i = t, t = void 0);
    const s = Object.assign({
      intAsBigInt: !1,
      keepSourceTokens: !1,
      logLevel: "warn",
      prettyErrors: !0,
      strict: !0,
      uniqueKeys: !0,
      version: "1.2"
    }, i);
    this.options = s;
    let { version: o } = s;
    i != null && i._directives ? (this.directives = i._directives.atDocument(), this.directives.yaml.explicit && (o = this.directives.yaml.version)) : this.directives = new st({ version: o }), this.setSchema(o, i), this.contents = e === void 0 ? null : this.createNode(e, n, i);
  }
  clone() {
    const e = Object.create(Mn.prototype, {
      [xt]: { value: Ts }
    });
    return e.commentBefore = this.commentBefore, e.comment = this.comment, e.errors = this.errors.slice(), e.warnings = this.warnings.slice(), e.options = Object.assign({}, this.options), this.directives && (e.directives = this.directives.clone()), e.schema = this.schema.clone(), e.contents = je(this.contents) ? this.contents.clone(e.schema) : this.contents, this.range && (e.range = this.range.slice()), e;
  }
  add(e) {
    br(this.contents) && this.contents.add(e);
  }
  addIn(e, t) {
    br(this.contents) && this.contents.addIn(e, t);
  }
  createAlias(e, t) {
    if (!e.anchor) {
      const i = xl(this);
      e.anchor = !t || i.has(t) ? bl(t || "a", i) : t;
    }
    return new Zs(e.anchor);
  }
  createNode(e, t, i) {
    let n;
    if (typeof t == "function")
      e = t.call({ "": e }, "", e), n = t;
    else if (Array.isArray(t)) {
      const A = (O) => typeof O == "number" || O instanceof String || O instanceof Number, w = t.filter(A).map(String);
      w.length > 0 && (t = t.concat(w)), n = t;
    } else
      i === void 0 && t && (i = t, t = void 0);
    const { aliasDuplicateObjects: s, anchorPrefix: o, flow: l, keepUndefined: a, onTagObj: b, tag: y } = i != null ? i : {}, { onAnchor: N, setAnchors: E, sourceObjects: B } = Xh(
      this,
      o || "a"
    ), I = {
      aliasDuplicateObjects: s != null ? s : !0,
      keepUndefined: a != null ? a : !1,
      onAnchor: N,
      onTagObj: b,
      replacer: n,
      schema: this.schema,
      sourceObjects: B
    }, T = li(e, y, I);
    return l && Ne(T) && (T.flow = !0), E(), T;
  }
  createPair(e, t, i = {}) {
    const n = this.createNode(e, null, i), s = this.createNode(t, null, i);
    return new lt(n, s);
  }
  delete(e) {
    return br(this.contents) ? this.contents.delete(e) : !1;
  }
  deleteIn(e) {
    return Qr(e) ? this.contents == null ? !1 : (this.contents = null, !0) : br(this.contents) ? this.contents.deleteIn(e) : !1;
  }
  get(e, t) {
    return Ne(this.contents) ? this.contents.get(e, t) : void 0;
  }
  getIn(e, t) {
    return Qr(e) ? !t && Oe(this.contents) ? this.contents.value : this.contents : Ne(this.contents) ? this.contents.getIn(e, t) : void 0;
  }
  has(e) {
    return Ne(this.contents) ? this.contents.has(e) : !1;
  }
  hasIn(e) {
    return Qr(e) ? this.contents !== void 0 : Ne(this.contents) ? this.contents.hasIn(e) : !1;
  }
  set(e, t) {
    this.contents == null ? this.contents = fn(this.schema, [e], t) : br(this.contents) && this.contents.set(e, t);
  }
  setIn(e, t) {
    Qr(e) ? this.contents = t : this.contents == null ? this.contents = fn(this.schema, Array.from(e), t) : br(this.contents) && this.contents.setIn(e, t);
  }
  setSchema(e, t = {}) {
    typeof e == "number" && (e = String(e));
    let i;
    switch (e) {
      case "1.1":
        this.directives ? this.directives.yaml.version = "1.1" : this.directives = new st({ version: "1.1" }), i = { merge: !0, resolveKnownTags: !1, schema: "yaml-1.1" };
        break;
      case "1.2":
      case "next":
        this.directives ? this.directives.yaml.version = e : this.directives = new st({ version: e }), i = { merge: !1, resolveKnownTags: !0, schema: "core" };
        break;
      case null:
        this.directives && delete this.directives, i = null;
        break;
      default: {
        const n = JSON.stringify(e);
        throw new Error(`Expected '1.1', '1.2' or null as first argument, but found: ${n}`);
      }
    }
    if (t.schema instanceof Object)
      this.schema = t.schema;
    else if (i)
      this.schema = new la(Object.assign(i, t));
    else
      throw new Error("With a null YAML version, the { schema: Schema } option is required");
  }
  toJS({ json: e, jsonArg: t, mapAsMap: i, maxAliasCount: n, onAnchor: s, reviver: o } = {}) {
    const l = {
      anchors: /* @__PURE__ */ new Map(),
      doc: this,
      keep: !e,
      mapAsMap: i === !0,
      mapKeyWarned: !1,
      maxAliasCount: typeof n == "number" ? n : 100
    }, a = St(this.contents, t != null ? t : "", l);
    if (typeof s == "function")
      for (const { count: b, res: y } of l.anchors.values())
        s(y, b);
    return typeof o == "function" ? Ir(o, { "": a }, "", a) : a;
  }
  toJSON(e, t) {
    return this.toJS({ json: !0, jsonArg: e, mapAsMap: !1, onAnchor: t });
  }
  toString(e = {}) {
    if (this.errors.length > 0)
      throw new Error("Document with errors cannot be stringified");
    if ("indent" in e && (!Number.isInteger(e.indent) || Number(e.indent) <= 0)) {
      const t = JSON.stringify(e.indent);
      throw new Error(`"indent" option must be a positive integer, not ${t}`);
    }
    return Td(this, e);
  }
}
function br(r) {
  if (Ne(r))
    return !0;
  throw new Error("Expected a YAML collection as document contents");
}
class jl extends Error {
  constructor(e, t, i, n) {
    super(), this.name = e, this.code = i, this.message = n, this.pos = t;
  }
}
class Zr extends jl {
  constructor(e, t, i) {
    super("YAMLParseError", e, t, i);
  }
}
class Sd extends jl {
  constructor(e, t, i) {
    super("YAMLWarning", e, t, i);
  }
}
const yo = (r, e) => (t) => {
  if (t.pos[0] === -1)
    return;
  t.linePos = t.pos.map((l) => e.linePos(l));
  const { line: i, col: n } = t.linePos[0];
  t.message += ` at line ${i}, column ${n}`;
  let s = n - 1, o = r.substring(e.lineStarts[i - 1], e.lineStarts[i]).replace(/[\n\r]+$/, "");
  if (s >= 60 && o.length > 80) {
    const l = Math.min(s - 39, o.length - 79);
    o = "\u2026" + o.substring(l), s -= l - 1;
  }
  if (o.length > 80 && (o = o.substring(0, 79) + "\u2026"), i > 1 && /^ *$/.test(o.substring(0, s))) {
    let l = r.substring(e.lineStarts[i - 2], e.lineStarts[i - 1]);
    l.length > 80 && (l = l.substring(0, 79) + `\u2026
`), o = l + o;
  }
  if (/[^ ]/.test(o)) {
    let l = 1;
    const a = t.linePos[1];
    a && a.line === i && a.col > n && (l = Math.max(1, Math.min(a.col - n, 80 - s)));
    const b = " ".repeat(s) + "^".repeat(l);
    t.message += `:

${o}
${b}
`;
  }
};
function Nr(r, { flow: e, indicator: t, next: i, offset: n, onError: s, startOnNewline: o }) {
  let l = !1, a = o, b = o, y = "", N = "", E = !1, B = !1, I = !1, T = null, A = null, w = null, O = null, u = null;
  for (const c of r)
    switch (I && (c.type !== "space" && c.type !== "newline" && c.type !== "comma" && s(c.offset, "MISSING_CHAR", "Tags and anchors must be separated from the next token by white space"), I = !1), c.type) {
      case "space":
        !e && a && t !== "doc-start" && c.source[0] === "	" && s(c, "TAB_AS_INDENT", "Tabs are not allowed as indentation"), b = !0;
        break;
      case "comment": {
        b || s(c, "MISSING_CHAR", "Comments must be separated from other tokens by white space characters");
        const v = c.source.substring(1) || " ";
        y ? y += N + v : y = v, N = "", a = !1;
        break;
      }
      case "newline":
        a ? y ? y += c.source : l = !0 : N += c.source, a = !0, E = !0, (T || A) && (B = !0), b = !0;
        break;
      case "anchor":
        T && s(c, "MULTIPLE_ANCHORS", "A node can have at most one anchor"), c.source.endsWith(":") && s(c.offset + c.source.length - 1, "BAD_ALIAS", "Anchor ending in : is ambiguous", !0), T = c, u === null && (u = c.offset), a = !1, b = !1, I = !0;
        break;
      case "tag": {
        A && s(c, "MULTIPLE_TAGS", "A node can have at most one tag"), A = c, u === null && (u = c.offset), a = !1, b = !1, I = !0;
        break;
      }
      case t:
        (T || A) && s(c, "BAD_PROP_ORDER", `Anchors and tags must be after the ${c.source} indicator`), O && s(c, "UNEXPECTED_TOKEN", `Unexpected ${c.source} in ${e != null ? e : "collection"}`), O = c, a = !1, b = !1;
        break;
      case "comma":
        if (e) {
          w && s(c, "UNEXPECTED_TOKEN", `Unexpected , in ${e}`), w = c, a = !1, b = !1;
          break;
        }
      default:
        s(c, "UNEXPECTED_TOKEN", `Unexpected ${c.type} token`), a = !1, b = !1;
    }
  const M = r[r.length - 1], d = M ? M.offset + M.source.length : n;
  return I && i && i.type !== "space" && i.type !== "newline" && i.type !== "comma" && (i.type !== "scalar" || i.source !== "") && s(i.offset, "MISSING_CHAR", "Tags and anchors must be separated from the next token by white space"), {
    comma: w,
    found: O,
    spaceBefore: l,
    comment: y,
    hasNewline: E,
    hasNewlineAfterProp: B,
    anchor: T,
    tag: A,
    end: d,
    start: u != null ? u : d
  };
}
function ui(r) {
  if (!r)
    return null;
  switch (r.type) {
    case "alias":
    case "scalar":
    case "double-quoted-scalar":
    case "single-quoted-scalar":
      if (r.source.includes(`
`))
        return !0;
      if (r.end) {
        for (const e of r.end)
          if (e.type === "newline")
            return !0;
      }
      return !1;
    case "flow-collection":
      for (const e of r.items) {
        for (const t of e.start)
          if (t.type === "newline")
            return !0;
        if (e.sep) {
          for (const t of e.sep)
            if (t.type === "newline")
              return !0;
        }
        if (ui(e.key) || ui(e.value))
          return !0;
      }
      return !1;
    default:
      return !0;
  }
}
function As(r, e, t) {
  if ((e == null ? void 0 : e.type) === "flow-collection") {
    const i = e.end[0];
    i.indent === r && (i.source === "]" || i.source === "}") && ui(e) && t(i, "BAD_INDENT", "Flow end indicator should be more indented than parent", !0);
  }
}
function Yl(r, e, t) {
  const { uniqueKeys: i } = r.options;
  if (i === !1)
    return !1;
  const n = typeof i == "function" ? i : (s, o) => s === o || Oe(s) && Oe(o) && s.value === o.value && !(s.value === "<<" && r.schema.merge);
  return e.some((s) => n(s.key, t));
}
const Eo = "All mapping items must start at the same column";
function xd({ composeNode: r, composeEmptyNode: e }, t, i, n, s) {
  var y, N;
  const o = (y = s == null ? void 0 : s.nodeClass) != null ? y : Tt, l = new o(t.schema);
  t.atRoot && (t.atRoot = !1);
  let a = i.offset, b = null;
  for (const E of i.items) {
    const { start: B, key: I, sep: T, value: A } = E, w = Nr(B, {
      indicator: "explicit-key-ind",
      next: I != null ? I : T == null ? void 0 : T[0],
      offset: a,
      onError: n,
      startOnNewline: !0
    }), O = !w.found;
    if (O) {
      if (I && (I.type === "block-seq" ? n(a, "BLOCK_AS_IMPLICIT_KEY", "A block sequence may not be used as an implicit map key") : "indent" in I && I.indent !== i.indent && n(a, "BAD_INDENT", Eo)), !w.anchor && !w.tag && !T) {
        b = w.end, w.comment && (l.comment ? l.comment += `
` + w.comment : l.comment = w.comment);
        continue;
      }
      (w.hasNewlineAfterProp || ui(I)) && n(I != null ? I : B[B.length - 1], "MULTILINE_IMPLICIT_KEY", "Implicit keys need to be on a single line");
    } else
      ((N = w.found) == null ? void 0 : N.indent) !== i.indent && n(a, "BAD_INDENT", Eo);
    const u = w.end, M = I ? r(t, I, w, n) : e(t, u, B, null, w, n);
    t.schema.compat && As(i.indent, I, n), Yl(t, l.items, M) && n(u, "DUPLICATE_KEY", "Map keys must be unique");
    const d = Nr(T != null ? T : [], {
      indicator: "map-value-ind",
      next: A,
      offset: M.range[2],
      onError: n,
      startOnNewline: !I || I.type === "block-scalar"
    });
    if (a = d.end, d.found) {
      O && ((A == null ? void 0 : A.type) === "block-map" && !d.hasNewline && n(a, "BLOCK_AS_IMPLICIT_KEY", "Nested mappings are not allowed in compact mappings"), t.options.strict && w.start < d.found.offset - 1024 && n(M.range, "KEY_OVER_1024_CHARS", "The : indicator must be at most 1024 chars after the start of an implicit block mapping key"));
      const c = A ? r(t, A, d, n) : e(t, a, T, null, d, n);
      t.schema.compat && As(i.indent, A, n), a = c.range[2];
      const v = new lt(M, c);
      t.options.keepSourceTokens && (v.srcToken = E), l.items.push(v);
    } else {
      O && n(M.range, "MISSING_CHAR", "Implicit map keys need to be followed by map values"), d.comment && (M.comment ? M.comment += `
` + d.comment : M.comment = d.comment);
      const c = new lt(M);
      t.options.keepSourceTokens && (c.srcToken = E), l.items.push(c);
    }
  }
  return b && b < a && n(b, "IMPOSSIBLE", "Map comment with trailing content"), l.range = [i.offset, a, b != null ? b : a], l;
}
function bd({ composeNode: r, composeEmptyNode: e }, t, i, n, s) {
  var y;
  const o = (y = s == null ? void 0 : s.nodeClass) != null ? y : mr, l = new o(t.schema);
  t.atRoot && (t.atRoot = !1);
  let a = i.offset, b = null;
  for (const { start: N, value: E } of i.items) {
    const B = Nr(N, {
      indicator: "seq-item-ind",
      next: E,
      offset: a,
      onError: n,
      startOnNewline: !0
    });
    if (!B.found)
      if (B.anchor || B.tag || E)
        E && E.type === "block-seq" ? n(B.end, "BAD_INDENT", "All sequence items must start at the same column") : n(a, "MISSING_CHAR", "Sequence item without - indicator");
      else {
        b = B.end, B.comment && (l.comment = B.comment);
        continue;
      }
    const I = E ? r(t, E, B, n) : e(t, B.end, N, null, B, n);
    t.schema.compat && As(i.indent, E, n), a = I.range[2], l.items.push(I);
  }
  return l.range = [i.offset, a, b != null ? b : a], l;
}
function _i(r, e, t, i) {
  let n = "";
  if (r) {
    let s = !1, o = "";
    for (const l of r) {
      const { source: a, type: b } = l;
      switch (b) {
        case "space":
          s = !0;
          break;
        case "comment": {
          t && !s && i(l, "MISSING_CHAR", "Comments must be separated from other tokens by white space characters");
          const y = a.substring(1) || " ";
          n ? n += o + y : n = y, o = "";
          break;
        }
        case "newline":
          n && (o += a), s = !0;
          break;
        default:
          i(l, "UNEXPECTED_TOKEN", `Unexpected ${b} at node end`);
      }
      e += a.length;
    }
  }
  return { comment: n, offset: e };
}
const us = "Block collections are not allowed within flow collections", cs = (r) => r && (r.type === "block-map" || r.type === "block-seq");
function Ad({ composeNode: r, composeEmptyNode: e }, t, i, n, s) {
  var A, w;
  const o = i.start.source === "{", l = o ? "flow map" : "flow sequence", a = (A = s == null ? void 0 : s.nodeClass) != null ? A : o ? Tt : mr, b = new a(t.schema);
  b.flow = !0;
  const y = t.atRoot;
  y && (t.atRoot = !1);
  let N = i.offset + i.start.source.length;
  for (let O = 0; O < i.items.length; ++O) {
    const u = i.items[O], { start: M, key: d, sep: c, value: v } = u, g = Nr(M, {
      flow: l,
      indicator: "explicit-key-ind",
      next: d != null ? d : c == null ? void 0 : c[0],
      offset: N,
      onError: n,
      startOnNewline: !1
    });
    if (!g.found) {
      if (!g.anchor && !g.tag && !c && !v) {
        O === 0 && g.comma ? n(g.comma, "UNEXPECTED_TOKEN", `Unexpected , in ${l}`) : O < i.items.length - 1 && n(g.start, "UNEXPECTED_TOKEN", `Unexpected empty item in ${l}`), g.comment && (b.comment ? b.comment += `
` + g.comment : b.comment = g.comment), N = g.end;
        continue;
      }
      !o && t.options.strict && ui(d) && n(
        d,
        "MULTILINE_IMPLICIT_KEY",
        "Implicit keys of flow sequence pairs need to be on a single line"
      );
    }
    if (O === 0)
      g.comma && n(g.comma, "UNEXPECTED_TOKEN", `Unexpected , in ${l}`);
    else if (g.comma || n(g.start, "MISSING_CHAR", `Missing , between ${l} items`), g.comment) {
      let m = "";
      e:
        for (const D of M)
          switch (D.type) {
            case "comma":
            case "space":
              break;
            case "comment":
              m = D.source.substring(1);
              break e;
            default:
              break e;
          }
      if (m) {
        let D = b.items[b.items.length - 1];
        Be(D) && (D = (w = D.value) != null ? w : D.key), D.comment ? D.comment += `
` + m : D.comment = m, g.comment = g.comment.substring(m.length + 1);
      }
    }
    if (!o && !c && !g.found) {
      const m = v ? r(t, v, g, n) : e(t, g.end, c, null, g, n);
      b.items.push(m), N = m.range[2], cs(v) && n(m.range, "BLOCK_IN_FLOW", us);
    } else {
      const m = g.end, D = d ? r(t, d, g, n) : e(t, m, M, null, g, n);
      cs(d) && n(D.range, "BLOCK_IN_FLOW", us);
      const L = Nr(c != null ? c : [], {
        flow: l,
        indicator: "map-value-ind",
        next: v,
        offset: D.range[2],
        onError: n,
        startOnNewline: !1
      });
      if (L.found) {
        if (!o && !g.found && t.options.strict) {
          if (c)
            for (const k of c) {
              if (k === L.found)
                break;
              if (k.type === "newline") {
                n(k, "MULTILINE_IMPLICIT_KEY", "Implicit keys of flow sequence pairs need to be on a single line");
                break;
              }
            }
          g.start < L.found.offset - 1024 && n(L.found, "KEY_OVER_1024_CHARS", "The : indicator must be at most 1024 chars after the start of an implicit flow sequence key");
        }
      } else
        v && ("source" in v && v.source && v.source[0] === ":" ? n(v, "MISSING_CHAR", `Missing space after : in ${l}`) : n(L.start, "MISSING_CHAR", `Missing , or : between ${l} items`));
      const p = v ? r(t, v, L, n) : L.found ? e(t, L.end, c, null, L, n) : null;
      p ? cs(v) && n(p.range, "BLOCK_IN_FLOW", us) : L.comment && (D.comment ? D.comment += `
` + L.comment : D.comment = L.comment);
      const x = new lt(D, p);
      if (t.options.keepSourceTokens && (x.srcToken = u), o) {
        const k = b;
        Yl(t, k.items, D) && n(m, "DUPLICATE_KEY", "Map keys must be unique"), k.items.push(x);
      } else {
        const k = new Tt(t.schema);
        k.flow = !0, k.items.push(x), b.items.push(k);
      }
      N = p ? p.range[2] : L.end;
    }
  }
  const E = o ? "}" : "]", [B, ...I] = i.end;
  let T = N;
  if (B && B.source === E)
    T = B.offset + B.source.length;
  else {
    const O = l[0].toUpperCase() + l.substring(1), u = y ? `${O} must end with a ${E}` : `${O} in block collection must be sufficiently indented and end with a ${E}`;
    n(N, y ? "MISSING_CHAR" : "BAD_INDENT", u), B && B.source.length !== 1 && I.unshift(B);
  }
  if (I.length > 0) {
    const O = _i(I, T, t.options.strict, n);
    O.comment && (b.comment ? b.comment += `
` + O.comment : b.comment = O.comment), b.range = [i.offset, T, O.offset];
  } else
    b.range = [i.offset, T, T];
  return b;
}
function fs(r, e, t, i, n, s) {
  const o = t.type === "block-map" ? xd(r, e, t, i, s) : t.type === "block-seq" ? bd(r, e, t, i, s) : Ad(r, e, t, i, s), l = o.constructor;
  return n === "!" || n === l.tagName ? (o.tag = l.tagName, o) : (n && (o.tag = n), o);
}
function Ld(r, e, t, i, n) {
  var N, E;
  const s = i ? e.directives.tagName(i.source, (B) => n(i, "TAG_RESOLVE_FAILED", B)) : null, o = t.type === "block-map" ? "map" : t.type === "block-seq" ? "seq" : t.start.source === "{" ? "map" : "seq";
  if (!i || !s || s === "!" || s === Tt.tagName && o === "map" || s === mr.tagName && o === "seq" || !o)
    return fs(r, e, t, n, s);
  let l = e.schema.tags.find((B) => B.tag === s && B.collection === o);
  if (!l) {
    const B = e.schema.knownTags[s];
    if (B && B.collection === o)
      e.schema.tags.push(Object.assign({}, B, { default: !1 })), l = B;
    else
      return B != null && B.collection ? n(i, "BAD_COLLECTION_TYPE", `${B.tag} used for ${o} collection, but expects ${B.collection}`, !0) : n(i, "TAG_RESOLVE_FAILED", `Unresolved tag: ${s}`, !0), fs(r, e, t, n, s);
  }
  const a = fs(r, e, t, n, s, l), b = (E = (N = l.resolve) == null ? void 0 : N.call(l, a, (B) => n(i, "TAG_RESOLVE_FAILED", B), e.options)) != null ? E : a, y = je(b) ? b : new ye(b);
  return y.range = a.range, y.tag = s, l != null && l.format && (y.format = l.format), y;
}
function wd(r, e, t) {
  const i = r.offset, n = Dd(r, e, t);
  if (!n)
    return { value: "", type: null, comment: "", range: [i, i, i] };
  const s = n.mode === ">" ? ye.BLOCK_FOLDED : ye.BLOCK_LITERAL, o = r.source ? Id(r.source) : [];
  let l = o.length;
  for (let T = o.length - 1; T >= 0; --T) {
    const A = o[T][1];
    if (A === "" || A === "\r")
      l = T;
    else
      break;
  }
  if (l === 0) {
    const T = n.chomp === "+" && o.length > 0 ? `
`.repeat(Math.max(1, o.length - 1)) : "";
    let A = i + n.length;
    return r.source && (A += r.source.length), { value: T, type: s, comment: n.comment, range: [i, A, A] };
  }
  let a = r.indent + n.indent, b = r.offset + n.length, y = 0;
  for (let T = 0; T < l; ++T) {
    const [A, w] = o[T];
    if (w === "" || w === "\r")
      n.indent === 0 && A.length > a && (a = A.length);
    else {
      if (A.length < a) {
        const O = "Block scalars with more-indented leading empty lines must use an explicit indentation indicator";
        t(b + A.length, "MISSING_CHAR", O);
      }
      n.indent === 0 && (a = A.length), y = T;
      break;
    }
    b += A.length + w.length + 1;
  }
  for (let T = o.length - 1; T >= l; --T)
    o[T][0].length > a && (l = T + 1);
  let N = "", E = "", B = !1;
  for (let T = 0; T < y; ++T)
    N += o[T][0].slice(a) + `
`;
  for (let T = y; T < l; ++T) {
    let [A, w] = o[T];
    b += A.length + w.length + 1;
    const O = w[w.length - 1] === "\r";
    if (O && (w = w.slice(0, -1)), w && A.length < a) {
      const M = `Block scalar lines must not be less indented than their ${n.indent ? "explicit indentation indicator" : "first line"}`;
      t(b - w.length - (O ? 2 : 1), "BAD_INDENT", M), A = "";
    }
    s === ye.BLOCK_LITERAL ? (N += E + A.slice(a) + w, E = `
`) : A.length > a || w[0] === "	" ? (E === " " ? E = `
` : !B && E === `
` && (E = `

`), N += E + A.slice(a) + w, E = `
`, B = !0) : w === "" ? E === `
` ? N += `
` : E = `
` : (N += E + w, E = " ", B = !1);
  }
  switch (n.chomp) {
    case "-":
      break;
    case "+":
      for (let T = l; T < o.length; ++T)
        N += `
` + o[T][0].slice(a);
      N[N.length - 1] !== `
` && (N += `
`);
      break;
    default:
      N += `
`;
  }
  const I = i + n.length + r.source.length;
  return { value: N, type: s, comment: n.comment, range: [i, I, I] };
}
function Dd({ offset: r, props: e }, t, i) {
  if (e[0].type !== "block-scalar-header")
    return i(e[0], "IMPOSSIBLE", "Block scalar header not found"), null;
  const { source: n } = e[0], s = n[0];
  let o = 0, l = "", a = -1;
  for (let E = 1; E < n.length; ++E) {
    const B = n[E];
    if (!l && (B === "-" || B === "+"))
      l = B;
    else {
      const I = Number(B);
      !o && I ? o = I : a === -1 && (a = r + E);
    }
  }
  a !== -1 && i(a, "UNEXPECTED_TOKEN", `Block scalar header includes extra characters: ${n}`);
  let b = !1, y = "", N = n.length;
  for (let E = 1; E < e.length; ++E) {
    const B = e[E];
    switch (B.type) {
      case "space":
        b = !0;
      case "newline":
        N += B.source.length;
        break;
      case "comment":
        t && !b && i(B, "MISSING_CHAR", "Comments must be separated from other tokens by white space characters"), N += B.source.length, y = B.source.substring(1);
        break;
      case "error":
        i(B, "UNEXPECTED_TOKEN", B.message), N += B.source.length;
        break;
      default: {
        const I = `Unexpected token in block scalar header: ${B.type}`;
        i(B, "UNEXPECTED_TOKEN", I);
        const T = B.source;
        T && typeof T == "string" && (N += T.length);
      }
    }
  }
  return { mode: s, indent: o, chomp: l, comment: y, length: N };
}
function Id(r) {
  const e = r.split(/\n( *)/), t = e[0], i = t.match(/^( *)/), s = [i != null && i[1] ? [i[1], t.slice(i[1].length)] : ["", t]];
  for (let o = 1; o < e.length; o += 2)
    s.push([e[o], e[o + 1]]);
  return s;
}
function Od(r, e, t) {
  const { offset: i, type: n, source: s, end: o } = r;
  let l, a;
  const b = (E, B, I) => t(i + E, B, I);
  switch (n) {
    case "scalar":
      l = ye.PLAIN, a = Cd(s, b);
      break;
    case "single-quoted-scalar":
      l = ye.QUOTE_SINGLE, a = Pd(s, b);
      break;
    case "double-quoted-scalar":
      l = ye.QUOTE_DOUBLE, a = Rd(s, b);
      break;
    default:
      return t(r, "UNEXPECTED_TOKEN", `Expected a flow scalar value, but found: ${n}`), {
        value: "",
        type: null,
        comment: "",
        range: [i, i + s.length, i + s.length]
      };
  }
  const y = i + s.length, N = _i(o, y, e, t);
  return {
    value: a,
    type: l,
    comment: N.comment,
    range: [i, y, N.offset]
  };
}
function Cd(r, e) {
  let t = "";
  switch (r[0]) {
    case "	":
      t = "a tab character";
      break;
    case ",":
      t = "flow indicator character ,";
      break;
    case "%":
      t = "directive indicator character %";
      break;
    case "|":
    case ">": {
      t = `block scalar indicator ${r[0]}`;
      break;
    }
    case "@":
    case "`": {
      t = `reserved character ${r[0]}`;
      break;
    }
  }
  return t && e(0, "BAD_SCALAR_START", `Plain value cannot start with ${t}`), zl(r);
}
function Pd(r, e) {
  return (r[r.length - 1] !== "'" || r.length === 1) && e(r.length, "MISSING_CHAR", "Missing closing 'quote"), zl(r.slice(1, -1)).replace(/''/g, "'");
}
function zl(r) {
  var a;
  let e, t;
  try {
    e = new RegExp(`(.*?)(?<![ 	])[ 	]*\r?
`, "sy"), t = new RegExp(`[ 	]*(.*?)(?:(?<![ 	])[ 	]*)?\r?
`, "sy");
  } catch {
    e = /(.*?)[ \t]*\r?\n/sy, t = /[ \t]*(.*?)[ \t]*\r?\n/sy;
  }
  let i = e.exec(r);
  if (!i)
    return r;
  let n = i[1], s = " ", o = e.lastIndex;
  for (t.lastIndex = o; i = t.exec(r); )
    i[1] === "" ? s === `
` ? n += s : s = `
` : (n += s + i[1], s = " "), o = t.lastIndex;
  const l = /[ \t]*(.*)/sy;
  return l.lastIndex = o, i = l.exec(r), n + s + ((a = i == null ? void 0 : i[1]) != null ? a : "");
}
function Rd(r, e) {
  let t = "";
  for (let i = 1; i < r.length - 1; ++i) {
    const n = r[i];
    if (!(n === "\r" && r[i + 1] === `
`))
      if (n === `
`) {
        const { fold: s, offset: o } = Md(r, i);
        t += s, i = o;
      } else if (n === "\\") {
        let s = r[++i];
        const o = kd[s];
        if (o)
          t += o;
        else if (s === `
`)
          for (s = r[i + 1]; s === " " || s === "	"; )
            s = r[++i + 1];
        else if (s === "\r" && r[i + 1] === `
`)
          for (s = r[++i + 1]; s === " " || s === "	"; )
            s = r[++i + 1];
        else if (s === "x" || s === "u" || s === "U") {
          const l = { x: 2, u: 4, U: 8 }[s];
          t += Fd(r, i + 1, l, e), i += l;
        } else {
          const l = r.substr(i - 1, 2);
          e(i - 1, "BAD_DQ_ESCAPE", `Invalid escape sequence ${l}`), t += l;
        }
      } else if (n === " " || n === "	") {
        const s = i;
        let o = r[i + 1];
        for (; o === " " || o === "	"; )
          o = r[++i + 1];
        o !== `
` && !(o === "\r" && r[i + 2] === `
`) && (t += i > s ? r.slice(s, i + 1) : n);
      } else
        t += n;
  }
  return (r[r.length - 1] !== '"' || r.length === 1) && e(r.length, "MISSING_CHAR", 'Missing closing "quote'), t;
}
function Md(r, e) {
  let t = "", i = r[e + 1];
  for (; (i === " " || i === "	" || i === `
` || i === "\r") && !(i === "\r" && r[e + 2] !== `
`); )
    i === `
` && (t += `
`), e += 1, i = r[e + 1];
  return t || (t = " "), { fold: t, offset: e };
}
const kd = {
  0: "\0",
  a: "\x07",
  b: "\b",
  e: "\x1B",
  f: "\f",
  n: `
`,
  r: "\r",
  t: "	",
  v: "\v",
  N: "\x85",
  _: "\xA0",
  L: "\u2028",
  P: "\u2029",
  " ": " ",
  '"': '"',
  "/": "/",
  "\\": "\\",
  "	": "	"
};
function Fd(r, e, t, i) {
  const n = r.substr(e, t), o = n.length === t && /^[0-9a-fA-F]+$/.test(n) ? parseInt(n, 16) : NaN;
  if (isNaN(o)) {
    const l = r.substr(e - 2, t + 2);
    return i(e - 2, "BAD_DQ_ESCAPE", `Invalid escape sequence ${l}`), l;
  }
  return String.fromCodePoint(o);
}
function Xl(r, e, t, i) {
  const { value: n, type: s, comment: o, range: l } = e.type === "block-scalar" ? wd(e, r.options.strict, i) : Od(e, r.options.strict, i), a = t ? r.directives.tagName(t.source, (N) => i(t, "TAG_RESOLVE_FAILED", N)) : null, b = t && a ? Nd(r.schema, n, a, t, i) : e.type === "scalar" ? Bd(r, n, e, i) : r.schema[Yt];
  let y;
  try {
    const N = b.resolve(n, (E) => i(t != null ? t : e, "TAG_RESOLVE_FAILED", E), r.options);
    y = Oe(N) ? N : new ye(N);
  } catch (N) {
    const E = N instanceof Error ? N.message : String(N);
    i(t != null ? t : e, "TAG_RESOLVE_FAILED", E), y = new ye(n);
  }
  return y.range = l, y.source = n, s && (y.type = s), a && (y.tag = a), b.format && (y.format = b.format), o && (y.comment = o), y;
}
function Nd(r, e, t, i, n) {
  var l;
  if (t === "!")
    return r[Yt];
  const s = [];
  for (const a of r.tags)
    if (!a.collection && a.tag === t)
      if (a.default && a.test)
        s.push(a);
      else
        return a;
  for (const a of s)
    if ((l = a.test) != null && l.test(e))
      return a;
  const o = r.knownTags[t];
  return o && !o.collection ? (r.tags.push(Object.assign({}, o, { default: !1, test: void 0 })), o) : (n(i, "TAG_RESOLVE_FAILED", `Unresolved tag: ${t}`, t !== "tag:yaml.org,2002:str"), r[Yt]);
}
function Bd({ directives: r, schema: e }, t, i, n) {
  var o;
  const s = e.tags.find((l) => {
    var a;
    return l.default && ((a = l.test) == null ? void 0 : a.test(t));
  }) || e[Yt];
  if (e.compat) {
    const l = (o = e.compat.find((a) => {
      var b;
      return a.default && ((b = a.test) == null ? void 0 : b.test(t));
    })) != null ? o : e[Yt];
    if (s.tag !== l.tag) {
      const a = r.tagString(s.tag), b = r.tagString(l.tag), y = `Value may be parsed as either ${a} or ${b}`;
      n(i, "TAG_RESOLVE_FAILED", y, !0);
    }
  }
  return s;
}
function Ud(r, e, t) {
  if (e) {
    t === null && (t = e.length);
    for (let i = t - 1; i >= 0; --i) {
      let n = e[i];
      switch (n.type) {
        case "space":
        case "comment":
        case "newline":
          r -= n.source.length;
          continue;
      }
      for (n = e[++i]; (n == null ? void 0 : n.type) === "space"; )
        r += n.source.length, n = e[++i];
      break;
    }
  }
  return r;
}
const Kd = { composeNode: Ql, composeEmptyNode: ua };
function Ql(r, e, t, i) {
  const { spaceBefore: n, comment: s, anchor: o, tag: l } = t;
  let a, b = !0;
  switch (e.type) {
    case "alias":
      a = Vd(r, e, i), (o || l) && i(e, "ALIAS_PROPS", "An alias node must not specify any properties");
      break;
    case "scalar":
    case "single-quoted-scalar":
    case "double-quoted-scalar":
    case "block-scalar":
      a = Xl(r, e, l, i), o && (a.anchor = o.source.substring(1));
      break;
    case "block-map":
    case "block-seq":
    case "flow-collection":
      a = Ld(Kd, r, e, l, i), o && (a.anchor = o.source.substring(1));
      break;
    default: {
      const y = e.type === "error" ? e.message : `Unsupported token (type: ${e.type})`;
      i(e, "UNEXPECTED_TOKEN", y), a = ua(r, e.offset, void 0, null, t, i), b = !1;
    }
  }
  return o && a.anchor === "" && i(o, "BAD_ALIAS", "Anchor cannot be an empty string"), n && (a.spaceBefore = !0), s && (e.type === "scalar" && e.source === "" ? a.comment = s : a.commentBefore = s), r.options.keepSourceTokens && b && (a.srcToken = e), a;
}
function ua(r, e, t, i, { spaceBefore: n, comment: s, anchor: o, tag: l, end: a }, b) {
  const y = {
    type: "scalar",
    offset: Ud(e, t, i),
    indent: -1,
    source: ""
  }, N = Xl(r, y, l, b);
  return o && (N.anchor = o.source.substring(1), N.anchor === "" && b(o, "BAD_ALIAS", "Anchor cannot be an empty string")), n && (N.spaceBefore = !0), s && (N.comment = s, N.range[2] = a), N;
}
function Vd({ options: r }, { offset: e, source: t, end: i }, n) {
  const s = new Zs(t.substring(1));
  s.source === "" && n(e, "BAD_ALIAS", "Alias cannot be an empty string"), s.source.endsWith(":") && n(e + t.length - 1, "BAD_ALIAS", "Alias ending in : is ambiguous", !0);
  const o = e + t.length, l = _i(i, o, r.strict, n);
  return s.range = [e, o, l.offset], l.comment && (s.comment = l.comment), s;
}
function Wd(r, e, { offset: t, start: i, value: n, end: s }, o) {
  const l = Object.assign({ _directives: e }, r), a = new Mn(void 0, l), b = {
    atRoot: !0,
    directives: a.directives,
    options: a.options,
    schema: a.schema
  }, y = Nr(i, {
    indicator: "doc-start",
    next: n != null ? n : s == null ? void 0 : s[0],
    offset: t,
    onError: o,
    startOnNewline: !0
  });
  y.found && (a.directives.docStart = !0, n && (n.type === "block-map" || n.type === "block-seq") && !y.hasNewline && o(y.end, "MISSING_CHAR", "Block collection cannot start on same line with directives-end marker")), a.contents = n ? Ql(b, n, y, o) : ua(b, y.end, i, null, y, o);
  const N = a.contents.range[2], E = _i(s, N, !1, o);
  return E.comment && (a.comment = E.comment), a.range = [t, N, E.offset], a;
}
function Yr(r) {
  if (typeof r == "number")
    return [r, r + 1];
  if (Array.isArray(r))
    return r.length === 2 ? r : [r[0], r[1]];
  const { offset: e, source: t } = r;
  return [e, e + (typeof t == "string" ? t.length : 1)];
}
function _o(r) {
  var n;
  let e = "", t = !1, i = !1;
  for (let s = 0; s < r.length; ++s) {
    const o = r[s];
    switch (o[0]) {
      case "#":
        e += (e === "" ? "" : i ? `

` : `
`) + (o.substring(1) || " "), t = !0, i = !1;
        break;
      case "%":
        ((n = r[s + 1]) == null ? void 0 : n[0]) !== "#" && (s += 1), t = !1;
        break;
      default:
        t || (i = !0), t = !1;
    }
  }
  return { comment: e, afterEmptyLine: i };
}
class Gd {
  constructor(e = {}) {
    this.doc = null, this.atDirectives = !1, this.prelude = [], this.errors = [], this.warnings = [], this.onError = (t, i, n, s) => {
      const o = Yr(t);
      s ? this.warnings.push(new Sd(o, i, n)) : this.errors.push(new Zr(o, i, n));
    }, this.directives = new st({ version: e.version || "1.2" }), this.options = e;
  }
  decorate(e, t) {
    const { comment: i, afterEmptyLine: n } = _o(this.prelude);
    if (i) {
      const s = e.contents;
      if (t)
        e.comment = e.comment ? `${e.comment}
${i}` : i;
      else if (n || e.directives.docStart || !s)
        e.commentBefore = i;
      else if (Ne(s) && !s.flow && s.items.length > 0) {
        let o = s.items[0];
        Be(o) && (o = o.key);
        const l = o.commentBefore;
        o.commentBefore = l ? `${i}
${l}` : i;
      } else {
        const o = s.commentBefore;
        s.commentBefore = o ? `${i}
${o}` : i;
      }
    }
    t ? (Array.prototype.push.apply(e.errors, this.errors), Array.prototype.push.apply(e.warnings, this.warnings)) : (e.errors = this.errors, e.warnings = this.warnings), this.prelude = [], this.errors = [], this.warnings = [];
  }
  streamInfo() {
    return {
      comment: _o(this.prelude).comment,
      directives: this.directives,
      errors: this.errors,
      warnings: this.warnings
    };
  }
  *compose(e, t = !1, i = -1) {
    for (const n of e)
      yield* this.next(n);
    yield* this.end(t, i);
  }
  *next(e) {
    switch (e.type) {
      case "directive":
        this.directives.add(e.source, (t, i, n) => {
          const s = Yr(e);
          s[0] += t, this.onError(s, "BAD_DIRECTIVE", i, n);
        }), this.prelude.push(e.source), this.atDirectives = !0;
        break;
      case "document": {
        const t = Wd(this.options, this.directives, e, this.onError);
        this.atDirectives && !t.directives.docStart && this.onError(e, "MISSING_CHAR", "Missing directives-end/doc-start indicator line"), this.decorate(t, !1), this.doc && (yield this.doc), this.doc = t, this.atDirectives = !1;
        break;
      }
      case "byte-order-mark":
      case "space":
        break;
      case "comment":
      case "newline":
        this.prelude.push(e.source);
        break;
      case "error": {
        const t = e.source ? `${e.message}: ${JSON.stringify(e.source)}` : e.message, i = new Zr(Yr(e), "UNEXPECTED_TOKEN", t);
        this.atDirectives || !this.doc ? this.errors.push(i) : this.doc.errors.push(i);
        break;
      }
      case "doc-end": {
        if (!this.doc) {
          const i = "Unexpected doc-end without preceding document";
          this.errors.push(new Zr(Yr(e), "UNEXPECTED_TOKEN", i));
          break;
        }
        this.doc.directives.docEnd = !0;
        const t = _i(e.end, e.offset + e.source.length, this.doc.options.strict, this.onError);
        if (this.decorate(this.doc, !0), t.comment) {
          const i = this.doc.comment;
          this.doc.comment = i ? `${i}
${t.comment}` : t.comment;
        }
        this.doc.range[2] = t.offset;
        break;
      }
      default:
        this.errors.push(new Zr(Yr(e), "UNEXPECTED_TOKEN", `Unsupported token ${e.type}`));
    }
  }
  *end(e = !1, t = -1) {
    if (this.doc)
      this.decorate(this.doc, !0), yield this.doc, this.doc = null;
    else if (e) {
      const i = Object.assign({ _directives: this.directives }, this.options), n = new Mn(void 0, i);
      this.atDirectives && this.onError(t, "MISSING_CHAR", "Missing directives-end indicator line"), n.range = [0, t, t], this.decorate(n, !1), yield n;
    }
  }
}
const Zl = "\uFEFF", Jl = "", ql = "", Ls = "";
function Hd(r) {
  switch (r) {
    case Zl:
      return "byte-order-mark";
    case Jl:
      return "doc-mode";
    case ql:
      return "flow-error-end";
    case Ls:
      return "scalar";
    case "---":
      return "doc-start";
    case "...":
      return "doc-end";
    case "":
    case `
`:
    case `\r
`:
      return "newline";
    case "-":
      return "seq-item-ind";
    case "?":
      return "explicit-key-ind";
    case ":":
      return "map-value-ind";
    case "{":
      return "flow-map-start";
    case "}":
      return "flow-map-end";
    case "[":
      return "flow-seq-start";
    case "]":
      return "flow-seq-end";
    case ",":
      return "comma";
  }
  switch (r[0]) {
    case " ":
    case "	":
      return "space";
    case "#":
      return "comment";
    case "%":
      return "directive-line";
    case "*":
      return "alias";
    case "&":
      return "anchor";
    case "!":
      return "tag";
    case "'":
      return "single-quoted-scalar";
    case '"':
      return "double-quoted-scalar";
    case "|":
    case ">":
      return "block-scalar-header";
  }
  return null;
}
function Et(r) {
  switch (r) {
    case void 0:
    case " ":
    case `
`:
    case "\r":
    case "	":
      return !0;
    default:
      return !1;
  }
}
const To = "0123456789ABCDEFabcdef".split(""), $d = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-#;/?:@&=+$_.!~*'()".split(""), hs = ",[]{}".split(""), jd = ` ,[]{}
\r	`.split(""), ds = (r) => !r || jd.includes(r);
class Yd {
  constructor() {
    this.atEnd = !1, this.blockScalarIndent = -1, this.blockScalarKeep = !1, this.buffer = "", this.flowKey = !1, this.flowLevel = 0, this.indentNext = 0, this.indentValue = 0, this.lineEndPos = null, this.next = null, this.pos = 0;
  }
  *lex(e, t = !1) {
    var n;
    e && (this.buffer = this.buffer ? this.buffer + e : e, this.lineEndPos = null), this.atEnd = !t;
    let i = (n = this.next) != null ? n : "stream";
    for (; i && (t || this.hasChars(1)); )
      i = yield* this.parseNext(i);
  }
  atLineEnd() {
    let e = this.pos, t = this.buffer[e];
    for (; t === " " || t === "	"; )
      t = this.buffer[++e];
    return !t || t === "#" || t === `
` ? !0 : t === "\r" ? this.buffer[e + 1] === `
` : !1;
  }
  charAt(e) {
    return this.buffer[this.pos + e];
  }
  continueScalar(e) {
    let t = this.buffer[e];
    if (this.indentNext > 0) {
      let i = 0;
      for (; t === " "; )
        t = this.buffer[++i + e];
      if (t === "\r") {
        const n = this.buffer[i + e + 1];
        if (n === `
` || !n && !this.atEnd)
          return e + i + 1;
      }
      return t === `
` || i >= this.indentNext || !t && !this.atEnd ? e + i : -1;
    }
    if (t === "-" || t === ".") {
      const i = this.buffer.substr(e, 3);
      if ((i === "---" || i === "...") && Et(this.buffer[e + 3]))
        return -1;
    }
    return e;
  }
  getLine() {
    let e = this.lineEndPos;
    return (typeof e != "number" || e !== -1 && e < this.pos) && (e = this.buffer.indexOf(`
`, this.pos), this.lineEndPos = e), e === -1 ? this.atEnd ? this.buffer.substring(this.pos) : null : (this.buffer[e - 1] === "\r" && (e -= 1), this.buffer.substring(this.pos, e));
  }
  hasChars(e) {
    return this.pos + e <= this.buffer.length;
  }
  setNext(e) {
    return this.buffer = this.buffer.substring(this.pos), this.pos = 0, this.lineEndPos = null, this.next = e, null;
  }
  peek(e) {
    return this.buffer.substr(this.pos, e);
  }
  *parseNext(e) {
    switch (e) {
      case "stream":
        return yield* this.parseStream();
      case "line-start":
        return yield* this.parseLineStart();
      case "block-start":
        return yield* this.parseBlockStart();
      case "doc":
        return yield* this.parseDocument();
      case "flow":
        return yield* this.parseFlowCollection();
      case "quoted-scalar":
        return yield* this.parseQuotedScalar();
      case "block-scalar":
        return yield* this.parseBlockScalar();
      case "plain-scalar":
        return yield* this.parsePlainScalar();
    }
  }
  *parseStream() {
    let e = this.getLine();
    if (e === null)
      return this.setNext("stream");
    if (e[0] === Zl && (yield* this.pushCount(1), e = e.substring(1)), e[0] === "%") {
      let t = e.length;
      const i = e.indexOf("#");
      if (i !== -1) {
        const s = e[i - 1];
        (s === " " || s === "	") && (t = i - 1);
      }
      for (; ; ) {
        const s = e[t - 1];
        if (s === " " || s === "	")
          t -= 1;
        else
          break;
      }
      const n = (yield* this.pushCount(t)) + (yield* this.pushSpaces(!0));
      return yield* this.pushCount(e.length - n), this.pushNewline(), "stream";
    }
    if (this.atLineEnd()) {
      const t = yield* this.pushSpaces(!0);
      return yield* this.pushCount(e.length - t), yield* this.pushNewline(), "stream";
    }
    return yield Jl, yield* this.parseLineStart();
  }
  *parseLineStart() {
    const e = this.charAt(0);
    if (!e && !this.atEnd)
      return this.setNext("line-start");
    if (e === "-" || e === ".") {
      if (!this.atEnd && !this.hasChars(4))
        return this.setNext("line-start");
      const t = this.peek(3);
      if (t === "---" && Et(this.charAt(3)))
        return yield* this.pushCount(3), this.indentValue = 0, this.indentNext = 0, "doc";
      if (t === "..." && Et(this.charAt(3)))
        return yield* this.pushCount(3), "stream";
    }
    return this.indentValue = yield* this.pushSpaces(!1), this.indentNext > this.indentValue && !Et(this.charAt(1)) && (this.indentNext = this.indentValue), yield* this.parseBlockStart();
  }
  *parseBlockStart() {
    const [e, t] = this.peek(2);
    if (!t && !this.atEnd)
      return this.setNext("block-start");
    if ((e === "-" || e === "?" || e === ":") && Et(t)) {
      const i = (yield* this.pushCount(1)) + (yield* this.pushSpaces(!0));
      return this.indentNext = this.indentValue + 1, this.indentValue += i, yield* this.parseBlockStart();
    }
    return "doc";
  }
  *parseDocument() {
    yield* this.pushSpaces(!0);
    const e = this.getLine();
    if (e === null)
      return this.setNext("doc");
    let t = yield* this.pushIndicators();
    switch (e[t]) {
      case "#":
        yield* this.pushCount(e.length - t);
      case void 0:
        return yield* this.pushNewline(), yield* this.parseLineStart();
      case "{":
      case "[":
        return yield* this.pushCount(1), this.flowKey = !1, this.flowLevel = 1, "flow";
      case "}":
      case "]":
        return yield* this.pushCount(1), "doc";
      case "*":
        return yield* this.pushUntil(ds), "doc";
      case '"':
      case "'":
        return yield* this.parseQuotedScalar();
      case "|":
      case ">":
        return t += yield* this.parseBlockScalarHeader(), t += yield* this.pushSpaces(!0), yield* this.pushCount(e.length - t), yield* this.pushNewline(), yield* this.parseBlockScalar();
      default:
        return yield* this.parsePlainScalar();
    }
  }
  *parseFlowCollection() {
    let e, t, i = -1;
    do
      e = yield* this.pushNewline(), e > 0 ? (t = yield* this.pushSpaces(!1), this.indentValue = i = t) : t = 0, t += yield* this.pushSpaces(!0);
    while (e + t > 0);
    const n = this.getLine();
    if (n === null)
      return this.setNext("flow");
    if ((i !== -1 && i < this.indentNext && n[0] !== "#" || i === 0 && (n.startsWith("---") || n.startsWith("...")) && Et(n[3])) && !(i === this.indentNext - 1 && this.flowLevel === 1 && (n[0] === "]" || n[0] === "}")))
      return this.flowLevel = 0, yield ql, yield* this.parseLineStart();
    let s = 0;
    for (; n[s] === ","; )
      s += yield* this.pushCount(1), s += yield* this.pushSpaces(!0), this.flowKey = !1;
    switch (s += yield* this.pushIndicators(), n[s]) {
      case void 0:
        return "flow";
      case "#":
        return yield* this.pushCount(n.length - s), "flow";
      case "{":
      case "[":
        return yield* this.pushCount(1), this.flowKey = !1, this.flowLevel += 1, "flow";
      case "}":
      case "]":
        return yield* this.pushCount(1), this.flowKey = !0, this.flowLevel -= 1, this.flowLevel ? "flow" : "doc";
      case "*":
        return yield* this.pushUntil(ds), "flow";
      case '"':
      case "'":
        return this.flowKey = !0, yield* this.parseQuotedScalar();
      case ":": {
        const o = this.charAt(1);
        if (this.flowKey || Et(o) || o === ",")
          return this.flowKey = !1, yield* this.pushCount(1), yield* this.pushSpaces(!0), "flow";
      }
      default:
        return this.flowKey = !1, yield* this.parsePlainScalar();
    }
  }
  *parseQuotedScalar() {
    const e = this.charAt(0);
    let t = this.buffer.indexOf(e, this.pos + 1);
    if (e === "'")
      for (; t !== -1 && this.buffer[t + 1] === "'"; )
        t = this.buffer.indexOf("'", t + 2);
    else
      for (; t !== -1; ) {
        let s = 0;
        for (; this.buffer[t - 1 - s] === "\\"; )
          s += 1;
        if (s % 2 === 0)
          break;
        t = this.buffer.indexOf('"', t + 1);
      }
    const i = this.buffer.substring(0, t);
    let n = i.indexOf(`
`, this.pos);
    if (n !== -1) {
      for (; n !== -1; ) {
        const s = this.continueScalar(n + 1);
        if (s === -1)
          break;
        n = i.indexOf(`
`, s);
      }
      n !== -1 && (t = n - (i[n - 1] === "\r" ? 2 : 1));
    }
    if (t === -1) {
      if (!this.atEnd)
        return this.setNext("quoted-scalar");
      t = this.buffer.length;
    }
    return yield* this.pushToIndex(t + 1, !1), this.flowLevel ? "flow" : "doc";
  }
  *parseBlockScalarHeader() {
    this.blockScalarIndent = -1, this.blockScalarKeep = !1;
    let e = this.pos;
    for (; ; ) {
      const t = this.buffer[++e];
      if (t === "+")
        this.blockScalarKeep = !0;
      else if (t > "0" && t <= "9")
        this.blockScalarIndent = Number(t) - 1;
      else if (t !== "-")
        break;
    }
    return yield* this.pushUntil((t) => Et(t) || t === "#");
  }
  *parseBlockScalar() {
    let e = this.pos - 1, t = 0, i;
    e:
      for (let n = this.pos; i = this.buffer[n]; ++n)
        switch (i) {
          case " ":
            t += 1;
            break;
          case `
`:
            e = n, t = 0;
            break;
          case "\r": {
            const s = this.buffer[n + 1];
            if (!s && !this.atEnd)
              return this.setNext("block-scalar");
            if (s === `
`)
              break;
          }
          default:
            break e;
        }
    if (!i && !this.atEnd)
      return this.setNext("block-scalar");
    if (t >= this.indentNext) {
      this.blockScalarIndent === -1 ? this.indentNext = t : this.indentNext += this.blockScalarIndent;
      do {
        const n = this.continueScalar(e + 1);
        if (n === -1)
          break;
        e = this.buffer.indexOf(`
`, n);
      } while (e !== -1);
      if (e === -1) {
        if (!this.atEnd)
          return this.setNext("block-scalar");
        e = this.buffer.length;
      }
    }
    if (!this.blockScalarKeep)
      do {
        let n = e - 1, s = this.buffer[n];
        s === "\r" && (s = this.buffer[--n]);
        const o = n;
        for (; s === " " || s === "	"; )
          s = this.buffer[--n];
        if (s === `
` && n >= this.pos && n + 1 + t > o)
          e = n;
        else
          break;
      } while (!0);
    return yield Ls, yield* this.pushToIndex(e + 1, !0), yield* this.parseLineStart();
  }
  *parsePlainScalar() {
    const e = this.flowLevel > 0;
    let t = this.pos - 1, i = this.pos - 1, n;
    for (; n = this.buffer[++i]; )
      if (n === ":") {
        const s = this.buffer[i + 1];
        if (Et(s) || e && s === ",")
          break;
        t = i;
      } else if (Et(n)) {
        let s = this.buffer[i + 1];
        if (n === "\r" && (s === `
` ? (i += 1, n = `
`, s = this.buffer[i + 1]) : t = i), s === "#" || e && hs.includes(s))
          break;
        if (n === `
`) {
          const o = this.continueScalar(i + 1);
          if (o === -1)
            break;
          i = Math.max(i, o - 2);
        }
      } else {
        if (e && hs.includes(n))
          break;
        t = i;
      }
    return !n && !this.atEnd ? this.setNext("plain-scalar") : (yield Ls, yield* this.pushToIndex(t + 1, !0), e ? "flow" : "doc");
  }
  *pushCount(e) {
    return e > 0 ? (yield this.buffer.substr(this.pos, e), this.pos += e, e) : 0;
  }
  *pushToIndex(e, t) {
    const i = this.buffer.slice(this.pos, e);
    return i ? (yield i, this.pos += i.length, i.length) : (t && (yield ""), 0);
  }
  *pushIndicators() {
    switch (this.charAt(0)) {
      case "!":
        return (yield* this.pushTag()) + (yield* this.pushSpaces(!0)) + (yield* this.pushIndicators());
      case "&":
        return (yield* this.pushUntil(ds)) + (yield* this.pushSpaces(!0)) + (yield* this.pushIndicators());
      case "-":
      case "?":
      case ":": {
        const e = this.flowLevel > 0, t = this.charAt(1);
        if (Et(t) || e && hs.includes(t))
          return e ? this.flowKey && (this.flowKey = !1) : this.indentNext = this.indentValue + 1, (yield* this.pushCount(1)) + (yield* this.pushSpaces(!0)) + (yield* this.pushIndicators());
      }
    }
    return 0;
  }
  *pushTag() {
    if (this.charAt(1) === "<") {
      let e = this.pos + 2, t = this.buffer[e];
      for (; !Et(t) && t !== ">"; )
        t = this.buffer[++e];
      return yield* this.pushToIndex(t === ">" ? e + 1 : e, !1);
    } else {
      let e = this.pos + 1, t = this.buffer[e];
      for (; t; )
        if ($d.includes(t))
          t = this.buffer[++e];
        else if (t === "%" && To.includes(this.buffer[e + 1]) && To.includes(this.buffer[e + 2]))
          t = this.buffer[e += 3];
        else
          break;
      return yield* this.pushToIndex(e, !1);
    }
  }
  *pushNewline() {
    const e = this.buffer[this.pos];
    return e === `
` ? yield* this.pushCount(1) : e === "\r" && this.charAt(1) === `
` ? yield* this.pushCount(2) : 0;
  }
  *pushSpaces(e) {
    let t = this.pos - 1, i;
    do
      i = this.buffer[++t];
    while (i === " " || e && i === "	");
    const n = t - this.pos;
    return n > 0 && (yield this.buffer.substr(this.pos, n), this.pos = t), n;
  }
  *pushUntil(e) {
    let t = this.pos, i = this.buffer[t];
    for (; !e(i); )
      i = this.buffer[++t];
    return yield* this.pushToIndex(t, !1);
  }
}
class zd {
  constructor() {
    this.lineStarts = [], this.addNewLine = (e) => this.lineStarts.push(e), this.linePos = (e) => {
      let t = 0, i = this.lineStarts.length;
      for (; t < i; ) {
        const s = t + i >> 1;
        this.lineStarts[s] < e ? t = s + 1 : i = s;
      }
      if (this.lineStarts[t] === e)
        return { line: t + 1, col: 1 };
      if (t === 0)
        return { line: 0, col: e };
      const n = this.lineStarts[t - 1];
      return { line: t, col: e - n + 1 };
    };
  }
}
function It(r, e) {
  for (let t = 0; t < r.length; ++t)
    if (r[t].type === e)
      return !0;
  return !1;
}
function So(r) {
  for (let e = 0; e < r.length; ++e)
    switch (r[e].type) {
      case "space":
      case "comment":
      case "newline":
        break;
      default:
        return e;
    }
  return -1;
}
function eu(r) {
  switch (r == null ? void 0 : r.type) {
    case "alias":
    case "scalar":
    case "single-quoted-scalar":
    case "double-quoted-scalar":
    case "flow-collection":
      return !0;
    default:
      return !1;
  }
}
function Ni(r) {
  var e;
  switch (r.type) {
    case "document":
      return r.start;
    case "block-map": {
      const t = r.items[r.items.length - 1];
      return (e = t.sep) != null ? e : t.start;
    }
    case "block-seq":
      return r.items[r.items.length - 1].start;
    default:
      return [];
  }
}
function Ar(r) {
  var t;
  if (r.length === 0)
    return [];
  let e = r.length;
  e:
    for (; --e >= 0; )
      switch (r[e].type) {
        case "doc-start":
        case "explicit-key-ind":
        case "map-value-ind":
        case "seq-item-ind":
        case "newline":
          break e;
      }
  for (; ((t = r[++e]) == null ? void 0 : t.type) === "space"; )
    ;
  return r.splice(e, r.length);
}
function xo(r) {
  if (r.start.type === "flow-seq-start")
    for (const e of r.items)
      e.sep && !e.value && !It(e.start, "explicit-key-ind") && !It(e.sep, "map-value-ind") && (e.key && (e.value = e.key), delete e.key, eu(e.value) ? e.value.end ? Array.prototype.push.apply(e.value.end, e.sep) : e.value.end = e.sep : Array.prototype.push.apply(e.start, e.sep), delete e.sep);
}
class Xd {
  constructor(e) {
    this.atNewLine = !0, this.atScalar = !1, this.indent = 0, this.offset = 0, this.onKeyLine = !1, this.stack = [], this.source = "", this.type = "", this.lexer = new Yd(), this.onNewLine = e;
  }
  *parse(e, t = !1) {
    this.onNewLine && this.offset === 0 && this.onNewLine(0);
    for (const i of this.lexer.lex(e, t))
      yield* this.next(i);
    t || (yield* this.end());
  }
  *next(e) {
    if (this.source = e, this.atScalar) {
      this.atScalar = !1, yield* this.step(), this.offset += e.length;
      return;
    }
    const t = Hd(e);
    if (t)
      if (t === "scalar")
        this.atNewLine = !1, this.atScalar = !0, this.type = "scalar";
      else {
        switch (this.type = t, yield* this.step(), t) {
          case "newline":
            this.atNewLine = !0, this.indent = 0, this.onNewLine && this.onNewLine(this.offset + e.length);
            break;
          case "space":
            this.atNewLine && e[0] === " " && (this.indent += e.length);
            break;
          case "explicit-key-ind":
          case "map-value-ind":
          case "seq-item-ind":
            this.atNewLine && (this.indent += e.length);
            break;
          case "doc-mode":
          case "flow-error-end":
            return;
          default:
            this.atNewLine = !1;
        }
        this.offset += e.length;
      }
    else {
      const i = `Not a YAML token: ${e}`;
      yield* this.pop({ type: "error", offset: this.offset, message: i, source: e }), this.offset += e.length;
    }
  }
  *end() {
    for (; this.stack.length > 0; )
      yield* this.pop();
  }
  get sourceToken() {
    return {
      type: this.type,
      offset: this.offset,
      indent: this.indent,
      source: this.source
    };
  }
  *step() {
    const e = this.peek(1);
    if (this.type === "doc-end" && (!e || e.type !== "doc-end")) {
      for (; this.stack.length > 0; )
        yield* this.pop();
      this.stack.push({
        type: "doc-end",
        offset: this.offset,
        source: this.source
      });
      return;
    }
    if (!e)
      return yield* this.stream();
    switch (e.type) {
      case "document":
        return yield* this.document(e);
      case "alias":
      case "scalar":
      case "single-quoted-scalar":
      case "double-quoted-scalar":
        return yield* this.scalar(e);
      case "block-scalar":
        return yield* this.blockScalar(e);
      case "block-map":
        return yield* this.blockMap(e);
      case "block-seq":
        return yield* this.blockSequence(e);
      case "flow-collection":
        return yield* this.flowCollection(e);
      case "doc-end":
        return yield* this.documentEnd(e);
    }
    yield* this.pop();
  }
  peek(e) {
    return this.stack[this.stack.length - e];
  }
  *pop(e) {
    const t = e != null ? e : this.stack.pop();
    if (t)
      if (this.stack.length === 0)
        yield t;
      else {
        const i = this.peek(1);
        switch (t.type === "block-scalar" ? t.indent = "indent" in i ? i.indent : 0 : t.type === "flow-collection" && i.type === "document" && (t.indent = 0), t.type === "flow-collection" && xo(t), i.type) {
          case "document":
            i.value = t;
            break;
          case "block-scalar":
            i.props.push(t);
            break;
          case "block-map": {
            const n = i.items[i.items.length - 1];
            if (n.value) {
              i.items.push({ start: [], key: t, sep: [] }), this.onKeyLine = !0;
              return;
            } else if (n.sep)
              n.value = t;
            else {
              Object.assign(n, { key: t, sep: [] }), this.onKeyLine = !It(n.start, "explicit-key-ind");
              return;
            }
            break;
          }
          case "block-seq": {
            const n = i.items[i.items.length - 1];
            n.value ? i.items.push({ start: [], value: t }) : n.value = t;
            break;
          }
          case "flow-collection": {
            const n = i.items[i.items.length - 1];
            !n || n.value ? i.items.push({ start: [], key: t, sep: [] }) : n.sep ? n.value = t : Object.assign(n, { key: t, sep: [] });
            return;
          }
          default:
            yield* this.pop(), yield* this.pop(t);
        }
        if ((i.type === "document" || i.type === "block-map" || i.type === "block-seq") && (t.type === "block-map" || t.type === "block-seq")) {
          const n = t.items[t.items.length - 1];
          n && !n.sep && !n.value && n.start.length > 0 && So(n.start) === -1 && (t.indent === 0 || n.start.every((s) => s.type !== "comment" || s.indent < t.indent)) && (i.type === "document" ? i.end = n.start : i.items.push({ start: n.start }), t.items.splice(-1, 1));
        }
      }
    else {
      const i = "Tried to pop an empty stack";
      yield { type: "error", offset: this.offset, source: "", message: i };
    }
  }
  *stream() {
    switch (this.type) {
      case "directive-line":
        yield { type: "directive", offset: this.offset, source: this.source };
        return;
      case "byte-order-mark":
      case "space":
      case "comment":
      case "newline":
        yield this.sourceToken;
        return;
      case "doc-mode":
      case "doc-start": {
        const e = {
          type: "document",
          offset: this.offset,
          start: []
        };
        this.type === "doc-start" && e.start.push(this.sourceToken), this.stack.push(e);
        return;
      }
    }
    yield {
      type: "error",
      offset: this.offset,
      message: `Unexpected ${this.type} token in YAML stream`,
      source: this.source
    };
  }
  *document(e) {
    if (e.value)
      return yield* this.lineEnd(e);
    switch (this.type) {
      case "doc-start": {
        So(e.start) !== -1 ? (yield* this.pop(), yield* this.step()) : e.start.push(this.sourceToken);
        return;
      }
      case "anchor":
      case "tag":
      case "space":
      case "comment":
      case "newline":
        e.start.push(this.sourceToken);
        return;
    }
    const t = this.startBlockValue(e);
    t ? this.stack.push(t) : yield {
      type: "error",
      offset: this.offset,
      message: `Unexpected ${this.type} token in YAML document`,
      source: this.source
    };
  }
  *scalar(e) {
    if (this.type === "map-value-ind") {
      const t = Ni(this.peek(2)), i = Ar(t);
      let n;
      e.end ? (n = e.end, n.push(this.sourceToken), delete e.end) : n = [this.sourceToken];
      const s = {
        type: "block-map",
        offset: e.offset,
        indent: e.indent,
        items: [{ start: i, key: e, sep: n }]
      };
      this.onKeyLine = !0, this.stack[this.stack.length - 1] = s;
    } else
      yield* this.lineEnd(e);
  }
  *blockScalar(e) {
    switch (this.type) {
      case "space":
      case "comment":
      case "newline":
        e.props.push(this.sourceToken);
        return;
      case "scalar":
        if (e.source = this.source, this.atNewLine = !0, this.indent = 0, this.onNewLine) {
          let t = this.source.indexOf(`
`) + 1;
          for (; t !== 0; )
            this.onNewLine(this.offset + t), t = this.source.indexOf(`
`, t) + 1;
        }
        yield* this.pop();
        break;
      default:
        yield* this.pop(), yield* this.step();
    }
  }
  *blockMap(e) {
    var i;
    const t = e.items[e.items.length - 1];
    switch (this.type) {
      case "newline":
        if (this.onKeyLine = !1, t.value) {
          const n = "end" in t.value ? t.value.end : void 0, s = Array.isArray(n) ? n[n.length - 1] : void 0;
          (s == null ? void 0 : s.type) === "comment" ? n == null || n.push(this.sourceToken) : e.items.push({ start: [this.sourceToken] });
        } else
          t.sep ? t.sep.push(this.sourceToken) : t.start.push(this.sourceToken);
        return;
      case "space":
      case "comment":
        if (t.value)
          e.items.push({ start: [this.sourceToken] });
        else if (t.sep)
          t.sep.push(this.sourceToken);
        else {
          if (this.atIndentedComment(t.start, e.indent)) {
            const n = e.items[e.items.length - 2], s = (i = n == null ? void 0 : n.value) == null ? void 0 : i.end;
            if (Array.isArray(s)) {
              Array.prototype.push.apply(s, t.start), s.push(this.sourceToken), e.items.pop();
              return;
            }
          }
          t.start.push(this.sourceToken);
        }
        return;
    }
    if (this.indent >= e.indent) {
      const n = !this.onKeyLine && this.indent === e.indent && t.sep;
      let s = [];
      if (n && t.sep && !t.value) {
        const o = [];
        for (let l = 0; l < t.sep.length; ++l) {
          const a = t.sep[l];
          switch (a.type) {
            case "newline":
              o.push(l);
              break;
            case "space":
              break;
            case "comment":
              a.indent > e.indent && (o.length = 0);
              break;
            default:
              o.length = 0;
          }
        }
        o.length >= 2 && (s = t.sep.splice(o[1]));
      }
      switch (this.type) {
        case "anchor":
        case "tag":
          n || t.value ? (s.push(this.sourceToken), e.items.push({ start: s }), this.onKeyLine = !0) : t.sep ? t.sep.push(this.sourceToken) : t.start.push(this.sourceToken);
          return;
        case "explicit-key-ind":
          !t.sep && !It(t.start, "explicit-key-ind") ? t.start.push(this.sourceToken) : n || t.value ? (s.push(this.sourceToken), e.items.push({ start: s })) : this.stack.push({
            type: "block-map",
            offset: this.offset,
            indent: this.indent,
            items: [{ start: [this.sourceToken] }]
          }), this.onKeyLine = !0;
          return;
        case "map-value-ind":
          if (It(t.start, "explicit-key-ind"))
            if (t.sep)
              if (t.value)
                e.items.push({ start: [], key: null, sep: [this.sourceToken] });
              else if (It(t.sep, "map-value-ind"))
                this.stack.push({
                  type: "block-map",
                  offset: this.offset,
                  indent: this.indent,
                  items: [{ start: s, key: null, sep: [this.sourceToken] }]
                });
              else if (eu(t.key) && !It(t.sep, "newline")) {
                const o = Ar(t.start), l = t.key, a = t.sep;
                a.push(this.sourceToken), delete t.key, delete t.sep, this.stack.push({
                  type: "block-map",
                  offset: this.offset,
                  indent: this.indent,
                  items: [{ start: o, key: l, sep: a }]
                });
              } else
                s.length > 0 ? t.sep = t.sep.concat(s, this.sourceToken) : t.sep.push(this.sourceToken);
            else if (It(t.start, "newline"))
              Object.assign(t, { key: null, sep: [this.sourceToken] });
            else {
              const o = Ar(t.start);
              this.stack.push({
                type: "block-map",
                offset: this.offset,
                indent: this.indent,
                items: [{ start: o, key: null, sep: [this.sourceToken] }]
              });
            }
          else
            t.sep ? t.value || n ? e.items.push({ start: s, key: null, sep: [this.sourceToken] }) : It(t.sep, "map-value-ind") ? this.stack.push({
              type: "block-map",
              offset: this.offset,
              indent: this.indent,
              items: [{ start: [], key: null, sep: [this.sourceToken] }]
            }) : t.sep.push(this.sourceToken) : Object.assign(t, { key: null, sep: [this.sourceToken] });
          this.onKeyLine = !0;
          return;
        case "alias":
        case "scalar":
        case "single-quoted-scalar":
        case "double-quoted-scalar": {
          const o = this.flowScalar(this.type);
          n || t.value ? (e.items.push({ start: s, key: o, sep: [] }), this.onKeyLine = !0) : t.sep ? this.stack.push(o) : (Object.assign(t, { key: o, sep: [] }), this.onKeyLine = !0);
          return;
        }
        default: {
          const o = this.startBlockValue(e);
          if (o) {
            n && o.type !== "block-seq" && It(t.start, "explicit-key-ind") && e.items.push({ start: s }), this.stack.push(o);
            return;
          }
        }
      }
    }
    yield* this.pop(), yield* this.step();
  }
  *blockSequence(e) {
    var i;
    const t = e.items[e.items.length - 1];
    switch (this.type) {
      case "newline":
        if (t.value) {
          const n = "end" in t.value ? t.value.end : void 0, s = Array.isArray(n) ? n[n.length - 1] : void 0;
          (s == null ? void 0 : s.type) === "comment" ? n == null || n.push(this.sourceToken) : e.items.push({ start: [this.sourceToken] });
        } else
          t.start.push(this.sourceToken);
        return;
      case "space":
      case "comment":
        if (t.value)
          e.items.push({ start: [this.sourceToken] });
        else {
          if (this.atIndentedComment(t.start, e.indent)) {
            const n = e.items[e.items.length - 2], s = (i = n == null ? void 0 : n.value) == null ? void 0 : i.end;
            if (Array.isArray(s)) {
              Array.prototype.push.apply(s, t.start), s.push(this.sourceToken), e.items.pop();
              return;
            }
          }
          t.start.push(this.sourceToken);
        }
        return;
      case "anchor":
      case "tag":
        if (t.value || this.indent <= e.indent)
          break;
        t.start.push(this.sourceToken);
        return;
      case "seq-item-ind":
        if (this.indent !== e.indent)
          break;
        t.value || It(t.start, "seq-item-ind") ? e.items.push({ start: [this.sourceToken] }) : t.start.push(this.sourceToken);
        return;
    }
    if (this.indent > e.indent) {
      const n = this.startBlockValue(e);
      if (n) {
        this.stack.push(n);
        return;
      }
    }
    yield* this.pop(), yield* this.step();
  }
  *flowCollection(e) {
    const t = e.items[e.items.length - 1];
    if (this.type === "flow-error-end") {
      let i;
      do
        yield* this.pop(), i = this.peek(1);
      while (i && i.type === "flow-collection");
    } else if (e.end.length === 0) {
      switch (this.type) {
        case "comma":
        case "explicit-key-ind":
          !t || t.sep ? e.items.push({ start: [this.sourceToken] }) : t.start.push(this.sourceToken);
          return;
        case "map-value-ind":
          !t || t.value ? e.items.push({ start: [], key: null, sep: [this.sourceToken] }) : t.sep ? t.sep.push(this.sourceToken) : Object.assign(t, { key: null, sep: [this.sourceToken] });
          return;
        case "space":
        case "comment":
        case "newline":
        case "anchor":
        case "tag":
          !t || t.value ? e.items.push({ start: [this.sourceToken] }) : t.sep ? t.sep.push(this.sourceToken) : t.start.push(this.sourceToken);
          return;
        case "alias":
        case "scalar":
        case "single-quoted-scalar":
        case "double-quoted-scalar": {
          const n = this.flowScalar(this.type);
          !t || t.value ? e.items.push({ start: [], key: n, sep: [] }) : t.sep ? this.stack.push(n) : Object.assign(t, { key: n, sep: [] });
          return;
        }
        case "flow-map-end":
        case "flow-seq-end":
          e.end.push(this.sourceToken);
          return;
      }
      const i = this.startBlockValue(e);
      i ? this.stack.push(i) : (yield* this.pop(), yield* this.step());
    } else {
      const i = this.peek(2);
      if (i.type === "block-map" && (this.type === "map-value-ind" && i.indent === e.indent || this.type === "newline" && !i.items[i.items.length - 1].sep))
        yield* this.pop(), yield* this.step();
      else if (this.type === "map-value-ind" && i.type !== "flow-collection") {
        const n = Ni(i), s = Ar(n);
        xo(e);
        const o = e.end.splice(1, e.end.length);
        o.push(this.sourceToken);
        const l = {
          type: "block-map",
          offset: e.offset,
          indent: e.indent,
          items: [{ start: s, key: e, sep: o }]
        };
        this.onKeyLine = !0, this.stack[this.stack.length - 1] = l;
      } else
        yield* this.lineEnd(e);
    }
  }
  flowScalar(e) {
    if (this.onNewLine) {
      let t = this.source.indexOf(`
`) + 1;
      for (; t !== 0; )
        this.onNewLine(this.offset + t), t = this.source.indexOf(`
`, t) + 1;
    }
    return {
      type: e,
      offset: this.offset,
      indent: this.indent,
      source: this.source
    };
  }
  startBlockValue(e) {
    switch (this.type) {
      case "alias":
      case "scalar":
      case "single-quoted-scalar":
      case "double-quoted-scalar":
        return this.flowScalar(this.type);
      case "block-scalar-header":
        return {
          type: "block-scalar",
          offset: this.offset,
          indent: this.indent,
          props: [this.sourceToken],
          source: ""
        };
      case "flow-map-start":
      case "flow-seq-start":
        return {
          type: "flow-collection",
          offset: this.offset,
          indent: this.indent,
          start: this.sourceToken,
          items: [],
          end: []
        };
      case "seq-item-ind":
        return {
          type: "block-seq",
          offset: this.offset,
          indent: this.indent,
          items: [{ start: [this.sourceToken] }]
        };
      case "explicit-key-ind": {
        this.onKeyLine = !0;
        const t = Ni(e), i = Ar(t);
        return i.push(this.sourceToken), {
          type: "block-map",
          offset: this.offset,
          indent: this.indent,
          items: [{ start: i }]
        };
      }
      case "map-value-ind": {
        this.onKeyLine = !0;
        const t = Ni(e), i = Ar(t);
        return {
          type: "block-map",
          offset: this.offset,
          indent: this.indent,
          items: [{ start: i, key: null, sep: [this.sourceToken] }]
        };
      }
    }
    return null;
  }
  atIndentedComment(e, t) {
    return this.type !== "comment" || this.indent <= t ? !1 : e.every((i) => i.type === "newline" || i.type === "space");
  }
  *documentEnd(e) {
    this.type !== "doc-mode" && (e.end ? e.end.push(this.sourceToken) : e.end = [this.sourceToken], this.type === "newline" && (yield* this.pop()));
  }
  *lineEnd(e) {
    switch (this.type) {
      case "comma":
      case "doc-start":
      case "doc-end":
      case "flow-seq-end":
      case "flow-map-end":
      case "map-value-ind":
        yield* this.pop(), yield* this.step();
        break;
      case "newline":
        this.onKeyLine = !1;
      case "space":
      case "comment":
      default:
        e.end ? e.end.push(this.sourceToken) : e.end = [this.sourceToken], this.type === "newline" && (yield* this.pop());
    }
  }
}
function Qd(r) {
  const e = r.prettyErrors !== !1;
  return { lineCounter: r.lineCounter || e && new zd() || null, prettyErrors: e };
}
function Zd(r, e = {}) {
  const { lineCounter: t, prettyErrors: i } = Qd(e), n = new Xd(t == null ? void 0 : t.addNewLine), s = new Gd(e);
  let o = null;
  for (const l of s.compose(n.parse(r), !0, r.length))
    if (!o)
      o = l;
    else if (o.options.logLevel !== "silent") {
      o.errors.push(new Zr(l.range.slice(0, 2), "MULTIPLE_DOCS", "Source contains multiple documents; please use YAML.parseAllDocuments()"));
      break;
    }
  return i && t && (o.errors.forEach(yo(r, t)), o.warnings.forEach(yo(r, t))), o;
}
function Jd(r, e, t) {
  let i;
  typeof e == "function" ? i = e : t === void 0 && e && typeof e == "object" && (t = e);
  const n = Zd(r, t);
  if (!n)
    return null;
  if (n.warnings.forEach((s) => Dl(n.options.logLevel, s)), n.errors.length > 0) {
    if (n.options.logLevel !== "silent")
      throw n.errors[0];
    n.errors = [];
  }
  return n.toJS(Object.assign({ reviver: i }, t));
}
function bo(r) {
  return r.url !== void 0;
}
class qd {
  static async loadContent(e, t = {}) {
    const i = await this.resolveUrl(e, t);
    return this.conformContent(i);
  }
  static async conformContent(e) {
    var t;
    if (e == null)
      throw new Error("ERROR__CONTENT_IS_FALSY");
    switch (e.version = (t = e.version) != null ? t : "1.0", e.version) {
      case "1.0":
      case "LightPlayer ContentFormat v1.1":
        return this.conformContentV1(e);
    }
    throw new Error("ERROR__UNDEFINED_VERSION");
  }
  static async conformContentV1(e) {
    var o, l, a, b, y, N, E, B, I, T, A, w;
    const t = await this.resolveTransforms(e.transforms), i = e.groups.map((O) => (O.reversed = !!O.reversed, O.reversed && (O.reversed = !1, O.videoIds = O.videoIds.reverse()), delete O.reversed, O)), n = e.sources.map((O) => {
      var u, M;
      return O.levels && (O.url = (M = (u = O.levels.find((d) => !!d)) == null ? void 0 : u.url) != null ? M : ""), delete O.levels, O;
    });
    e.videos.forEach((O) => {
      (O.single || O.tiled) && (O.regions = [{
        single: O.single,
        tiled: O.tiled,
        startTime: 0,
        duration: -1
      }]);
    });
    const s = {
      audios: e.audios,
      authorName: e.authorName,
      closedCaptions: (o = e.closedCaptions) != null ? o : [],
      contentType: (l = e.contentType) != null ? l : "",
      createdDate: (a = e.createdDate) != null ? a : "",
      description: (b = e.description) != null ? b : "",
      duration: (y = e.duration) != null ? y : "auto",
      frameRate: e.frameRate || 30,
      groups: i,
      markers: (N = e.markers) != null ? N : [],
      modes: !e.modes || e.modes === "*" ? Object.keys(Kt).map((O) => Kt[O]) : Array.isArray(e.modes) ? e.modes : [e.modes],
      offsetTime: e.offsetTime,
      playerOptions: Object.assign({
        globalScale: 1,
        frameScale: 1,
        userPlayable: !0,
        userStepControl: !0,
        userTransformable: !0,
        backgroundColor: [0, 0, 0]
      }, (E = e.playerOptions) != null ? E : {}),
      poster: (B = e.poster) != null ? B : "",
      profiles: (I = e.profiles) != null ? I : [],
      sources: n != null ? n : [],
      title: (T = e.title) != null ? T : "",
      transforms: t,
      version: e.version,
      videos: (A = e.videos) != null ? A : [],
      domainFilter: (w = e.domainFilter) != null ? w : void 0
    };
    return be.debug(s), s;
  }
  static async resolveTransforms(e) {
    if (!e)
      return [];
    const t = [];
    return typeof e == "string" ? t.push({
      name: "Default",
      transforms: {
        url: e
      }
    }) : e.forEach((i) => {
      t.push(i);
    }), await Promise.all(t.map(async (i) => {
      if (!bo(i.transforms))
        return {
          name: i.name,
          contentsView: this.getCalibrationContentsViewType(i.contents_view),
          transforms: i.transforms
        };
      const n = await this.resolveRefs(i.transforms, async (s) => {
        let o = [];
        switch (s.calibration_format) {
          case "2501 affine calibration ver1.0":
          case "2501 affine calibration ver1.1":
          case "MasterVisions affine calibration ver1.1":
            o = await this.resolveCalibrationYAMLV1(s);
            break;
          default:
            throw new Error("ERROR__UNDEFINED_VERSION");
        }
        return {
          transforms: o,
          contentsView: this.getCalibrationContentsViewType(s.contents_view)
        };
      });
      return {
        name: i.name,
        contentsView: n.contentsView,
        transforms: n.transforms
      };
    }));
  }
  static getCalibrationContentsViewType(e) {
    return ["bounding_area", "portrait", "landscape"].some((t) => t === e) ? e : "bounding_area";
  }
  static async resolveRefs(e, t) {
    if (!bo(e))
      return e;
    let i = e.type;
    if (!i)
      switch (e.url.substr(e.url.lastIndexOf(".") + 1)) {
        case "json":
          i = "json";
          break;
        case "yml":
        case "yaml":
          i = "yaml";
      }
    const n = e.url;
    let s = await this.resolveUrl(n, { responseType: "text" }), o;
    switch (i) {
      case "yaml":
        s.startsWith("%YAML:1.0") && (console.warn("YAML 1.0 is deprecated"), s = s.replace("%YAML:1.0", "%YAML 1.1")), o = Jd(s);
        break;
      case "json":
      default:
        o = JSON.parse(s);
    }
    return t ? await t(o) : o;
  }
  static async resolveCalibrationYAMLV1(e) {
    var n;
    const t = [];
    let i = 0;
    (n = e == null ? void 0 : e.videos) == null || n.sort((s, o) => s.id - o.id).forEach((s) => {
      i = Math.max(i, s.id), t[s.id] = {
        scale: [s.scale, s.scale],
        rotation: -s.rotation,
        offset: [s.shift[0], -s.shift[1]]
      };
    });
    for (let s = 0; s < i + 1; s++)
      t[s] || (t[s] = {
        scale: [1, 1],
        rotation: 0,
        offset: [0, 0]
      });
    return t;
  }
  static async resolveUrl(e, t = {}) {
    try {
      return (await Vh.get(e, { responseType: "json", ...t })).data;
    } catch (i) {
      return console.error(i), null;
    }
  }
}
async function ev(r) {
  return new Promise((e) => {
    setTimeout(() => {
      e();
    }, r * 1e3);
  });
}
class ca {
  static formatFrameTimeCode(e, t = !0, i = 1 / 30) {
    const { sign: n, hours: s, minutes: o, seconds: l, msec: a } = this.splitTimeComponents(e, t);
    return `${n}${s.toString().padStart(2, "0")}:${o.toString().padStart(2, "0")}:${l.toString().padStart(2, "0")}.${Math.trunc(a / 1e3 / i).toString().padStart(2, "0")}`;
  }
  static formatFullTimeCode(e, t = !0) {
    const { sign: i, hours: n, minutes: s, seconds: o, msec: l } = this.splitTimeComponents(e, t);
    return `${i}${n.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}:${o.toString().padStart(2, "0")}.${l.toString().padStart(3, "0")}`;
  }
  static formatShorTimeCode(e, t = !0) {
    const { sign: i, hours: n, minutes: s, seconds: o } = this.splitTimeComponents(e, t), l = [s, o];
    return e >= 60 * 60 && l.unshift(n), `${i === "-" ? i : ""}${l.map((a) => a.toString().padStart(2, "0")).join(":")}`;
  }
  static validateFullDisplayTime(e) {
    return e.match(/^[+-]?(\d{1,2}(:\d{1,2}(:\d{1,2})?)?)?(\.\d{1,4})?$/);
  }
  static parseFullDisplayTime(e) {
    let t = 1, i = 0, n = e;
    (n.charAt(0) === "+" || n.charAt(0) === "-") && (t = n.charAt(0) === "-" ? -1 : 1, n = n.substr(1));
    const [s, o] = n.split("."), l = s.split(":");
    for (o && (i += parseInt(o, 10) * Math.pow(1 / 10, o.length)); l.length; ) {
      const a = parseInt(l.shift(), 10);
      i += Math.pow(60, l.length) * a;
    }
    return t * i;
  }
  static splitTimeComponents(e, t = !0) {
    let i = "";
    t && (i = Math.sign(e) < 0 ? "-" : "+");
    const n = Math.abs(e), s = Math.trunc(n / 60 / 60) % 60, o = Math.trunc(n / 60) % 60, l = Math.trunc(n) % 60, a = Math.trunc((n - Math.floor(n)) * 1e3);
    return { sign: i, hours: s, minutes: o, seconds: l, msec: a };
  }
}
class tv {
  constructor(e) {
    j(this, "_events", []);
    j(this, "_throttleTime", 0);
    j(this, "_handler");
    j(this, "_timer", -1);
    j(this, "_val", null);
    this._throttleTime = e, this._handler = this.eventHandler.bind(this);
  }
  subscribe(e) {
    this._events.push(e);
  }
  unsubscribe(e) {
    for (let t = 0; t < this._events.length; t++)
      this._events[t] === e && (this._events.splice(t, 1), t--);
  }
  emit(e) {
    this._timer > -1 && window.clearTimeout(this._timer), this._val = e, this._timer = window.setTimeout(this._handler, this._throttleTime);
  }
  eventHandler() {
    for (let e = 0; e < this._events.length; e++)
      this._events[e](this._val);
    this._val = null, this._timer = -1;
  }
}
const tu = (r) => (gr("data-v-9e011a4b"), r = r(), pr(), r), rv = /* @__PURE__ */ tu(() => /* @__PURE__ */ me("path", {
  class: "st arc2",
  d: "M64,6C31.97,6,6,31.97,6,64c0,16.02,6.49,30.52,16.99,41.01"
}, null, -1)), iv = /* @__PURE__ */ tu(() => /* @__PURE__ */ me("path", {
  class: "st arc1",
  d: "M64,6C31.97,6,6,31.97,6,64c0,16.02,6.49,30.52,16.99,41.01"
}, null, -1)), nv = [
  rv,
  iv
], sv = /* @__PURE__ */ ut({
  __name: "LoadingIcon",
  props: {
    size: {
      type: [String, Number],
      default: 64
    }
  },
  setup(r) {
    const e = r;
    return (t, i) => (fe(), Se("div", {
      style: Pt({ width: e.size, height: e.size }),
      class: "loading-icon"
    }, [
      (fe(), Se("svg", {
        style: Pt({ width: e.size, height: e.size }),
        viewBox: "0 0 128 128"
      }, nv, 4))
    ], 4));
  }
});
const Ue = (r, e) => {
  const t = r.__vccOpts || r;
  for (const [i, n] of e)
    t[i] = n;
  return t;
}, av = /* @__PURE__ */ Ue(sv, [["__scopeId", "data-v-9e011a4b"]]), $r = Symbol(), Ti = Symbol(), Si = Symbol(), ru = Symbol(), iu = Symbol(), nu = Symbol();
function ov(r) {
  if (r.sheet)
    return r.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === r)
      return document.styleSheets[e];
}
function lv(r) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", r.key), r.nonce !== void 0 && e.setAttribute("nonce", r.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var uv = /* @__PURE__ */ function() {
  function r(t) {
    var i = this;
    this._insertTag = function(n) {
      var s;
      i.tags.length === 0 ? i.insertionPoint ? s = i.insertionPoint.nextSibling : i.prepend ? s = i.container.firstChild : s = i.before : s = i.tags[i.tags.length - 1].nextSibling, i.container.insertBefore(n, s), i.tags.push(n);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var e = r.prototype;
  return e.hydrate = function(i) {
    i.forEach(this._insertTag);
  }, e.insert = function(i) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(lv(this));
    var n = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var s = i.charCodeAt(0) === 64 && i.charCodeAt(1) === 105;
      s && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + i + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !s;
    }
    if (this.isSpeedy) {
      var o = ov(n);
      try {
        o.insertRule(i, o.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(i) && console.error('There was a problem inserting the following rule: "' + i + '"', l);
      }
    } else
      n.appendChild(document.createTextNode(i));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(i) {
      return i.parentNode && i.parentNode.removeChild(i);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, r;
}(), rt = "-ms-", dn = "-moz-", _e = "-webkit-", fa = "comm", ha = "rule", da = "decl", cv = "@import", su = "@keyframes", fv = Math.abs, kn = String.fromCharCode, hv = Object.assign;
function dv(r, e) {
  return Je(r, 0) ^ 45 ? (((e << 2 ^ Je(r, 0)) << 2 ^ Je(r, 1)) << 2 ^ Je(r, 2)) << 2 ^ Je(r, 3) : 0;
}
function au(r) {
  return r.trim();
}
function vv(r, e) {
  return (r = e.exec(r)) ? r[0] : r;
}
function Te(r, e, t) {
  return r.replace(e, t);
}
function ws(r, e) {
  return r.indexOf(e);
}
function Je(r, e) {
  return r.charCodeAt(e) | 0;
}
function ci(r, e, t) {
  return r.slice(e, t);
}
function Ut(r) {
  return r.length;
}
function va(r) {
  return r.length;
}
function Bi(r, e) {
  return e.push(r), r;
}
function mv(r, e) {
  return r.map(e).join("");
}
var Fn = 1, Br = 1, ou = 0, ft = 0, Ge = 0, jr = "";
function Nn(r, e, t, i, n, s, o) {
  return { value: r, root: e, parent: t, type: i, props: n, children: s, line: Fn, column: Br, length: o, return: "" };
}
function zr(r, e) {
  return hv(Nn("", null, null, "", null, null, 0), r, { length: -r.length }, e);
}
function gv() {
  return Ge;
}
function pv() {
  return Ge = ft > 0 ? Je(jr, --ft) : 0, Br--, Ge === 10 && (Br = 1, Fn--), Ge;
}
function mt() {
  return Ge = ft < ou ? Je(jr, ft++) : 0, Br++, Ge === 10 && (Br = 1, Fn++), Ge;
}
function Vt() {
  return Je(jr, ft);
}
function en() {
  return ft;
}
function xi(r, e) {
  return ci(jr, r, e);
}
function fi(r) {
  switch (r) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function lu(r) {
  return Fn = Br = 1, ou = Ut(jr = r), ft = 0, [];
}
function uu(r) {
  return jr = "", r;
}
function tn(r) {
  return au(xi(ft - 1, Ds(r === 91 ? r + 2 : r === 40 ? r + 1 : r)));
}
function yv(r) {
  for (; (Ge = Vt()) && Ge < 33; )
    mt();
  return fi(r) > 2 || fi(Ge) > 3 ? "" : " ";
}
function Ev(r, e) {
  for (; --e && mt() && !(Ge < 48 || Ge > 102 || Ge > 57 && Ge < 65 || Ge > 70 && Ge < 97); )
    ;
  return xi(r, en() + (e < 6 && Vt() == 32 && mt() == 32));
}
function Ds(r) {
  for (; mt(); )
    switch (Ge) {
      case r:
        return ft;
      case 34:
      case 39:
        r !== 34 && r !== 39 && Ds(Ge);
        break;
      case 40:
        r === 41 && Ds(r);
        break;
      case 92:
        mt();
        break;
    }
  return ft;
}
function _v(r, e) {
  for (; mt() && r + Ge !== 47 + 10; )
    if (r + Ge === 42 + 42 && Vt() === 47)
      break;
  return "/*" + xi(e, ft - 1) + "*" + kn(r === 47 ? r : mt());
}
function Tv(r) {
  for (; !fi(Vt()); )
    mt();
  return xi(r, ft);
}
function Sv(r) {
  return uu(rn("", null, null, null, [""], r = lu(r), 0, [0], r));
}
function rn(r, e, t, i, n, s, o, l, a) {
  for (var b = 0, y = 0, N = o, E = 0, B = 0, I = 0, T = 1, A = 1, w = 1, O = 0, u = "", M = n, d = s, c = i, v = u; A; )
    switch (I = O, O = mt()) {
      case 40:
        if (I != 108 && Je(v, N - 1) == 58) {
          ws(v += Te(tn(O), "&", "&\f"), "&\f") != -1 && (w = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        v += tn(O);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        v += yv(I);
        break;
      case 92:
        v += Ev(en() - 1, 7);
        continue;
      case 47:
        switch (Vt()) {
          case 42:
          case 47:
            Bi(xv(_v(mt(), en()), e, t), a);
            break;
          default:
            v += "/";
        }
        break;
      case 123 * T:
        l[b++] = Ut(v) * w;
      case 125 * T:
      case 59:
      case 0:
        switch (O) {
          case 0:
          case 125:
            A = 0;
          case 59 + y:
            B > 0 && Ut(v) - N && Bi(B > 32 ? Lo(v + ";", i, t, N - 1) : Lo(Te(v, " ", "") + ";", i, t, N - 2), a);
            break;
          case 59:
            v += ";";
          default:
            if (Bi(c = Ao(v, e, t, b, y, n, l, u, M = [], d = [], N), s), O === 123)
              if (y === 0)
                rn(v, e, c, c, M, s, N, l, d);
              else
                switch (E === 99 && Je(v, 3) === 110 ? 100 : E) {
                  case 100:
                  case 109:
                  case 115:
                    rn(r, c, c, i && Bi(Ao(r, c, c, 0, 0, n, l, u, n, M = [], N), d), n, d, N, l, i ? M : d);
                    break;
                  default:
                    rn(v, c, c, c, [""], d, 0, l, d);
                }
        }
        b = y = B = 0, T = w = 1, u = v = "", N = o;
        break;
      case 58:
        N = 1 + Ut(v), B = I;
      default:
        if (T < 1) {
          if (O == 123)
            --T;
          else if (O == 125 && T++ == 0 && pv() == 125)
            continue;
        }
        switch (v += kn(O), O * T) {
          case 38:
            w = y > 0 ? 1 : (v += "\f", -1);
            break;
          case 44:
            l[b++] = (Ut(v) - 1) * w, w = 1;
            break;
          case 64:
            Vt() === 45 && (v += tn(mt())), E = Vt(), y = N = Ut(u = v += Tv(en())), O++;
            break;
          case 45:
            I === 45 && Ut(v) == 2 && (T = 0);
        }
    }
  return s;
}
function Ao(r, e, t, i, n, s, o, l, a, b, y) {
  for (var N = n - 1, E = n === 0 ? s : [""], B = va(E), I = 0, T = 0, A = 0; I < i; ++I)
    for (var w = 0, O = ci(r, N + 1, N = fv(T = o[I])), u = r; w < B; ++w)
      (u = au(T > 0 ? E[w] + " " + O : Te(O, /&\f/g, E[w]))) && (a[A++] = u);
  return Nn(r, e, t, n === 0 ? ha : l, a, b, y);
}
function xv(r, e, t) {
  return Nn(r, e, t, fa, kn(gv()), ci(r, 2, -2), 0);
}
function Lo(r, e, t, i) {
  return Nn(r, e, t, da, ci(r, 0, i), ci(r, i + 1, -1), i);
}
function Rr(r, e) {
  for (var t = "", i = va(r), n = 0; n < i; n++)
    t += e(r[n], n, r, e) || "";
  return t;
}
function bv(r, e, t, i) {
  switch (r.type) {
    case cv:
    case da:
      return r.return = r.return || r.value;
    case fa:
      return "";
    case su:
      return r.return = r.value + "{" + Rr(r.children, i) + "}";
    case ha:
      r.value = r.props.join(",");
  }
  return Ut(t = Rr(r.children, i)) ? r.return = r.value + "{" + t + "}" : "";
}
function Av(r) {
  var e = va(r);
  return function(t, i, n, s) {
    for (var o = "", l = 0; l < e; l++)
      o += r[l](t, i, n, s) || "";
    return o;
  };
}
function Lv(r) {
  return function(e) {
    e.root || (e = e.return) && r(e);
  };
}
function wv(r) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return e[t] === void 0 && (e[t] = r(t)), e[t];
  };
}
var Dv = function(e, t, i) {
  for (var n = 0, s = 0; n = s, s = Vt(), n === 38 && s === 12 && (t[i] = 1), !fi(s); )
    mt();
  return xi(e, ft);
}, Iv = function(e, t) {
  var i = -1, n = 44;
  do
    switch (fi(n)) {
      case 0:
        n === 38 && Vt() === 12 && (t[i] = 1), e[i] += Dv(ft - 1, t, i);
        break;
      case 2:
        e[i] += tn(n);
        break;
      case 4:
        if (n === 44) {
          e[++i] = Vt() === 58 ? "&\f" : "", t[i] = e[i].length;
          break;
        }
      default:
        e[i] += kn(n);
    }
  while (n = mt());
  return e;
}, Ov = function(e, t) {
  return uu(Iv(lu(e), t));
}, wo = /* @__PURE__ */ new WeakMap(), Cv = function(e) {
  if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
    for (var t = e.value, i = e.parent, n = e.column === i.column && e.line === i.line; i.type !== "rule"; )
      if (i = i.parent, !i)
        return;
    if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !wo.get(i)) && !n) {
      wo.set(e, !0);
      for (var s = [], o = Ov(t, s), l = i.props, a = 0, b = 0; a < o.length; a++)
        for (var y = 0; y < l.length; y++, b++)
          e.props[b] = s[a] ? o[a].replace(/&\f/g, l[y]) : l[y] + " " + o[a];
    }
  }
}, Pv = function(e) {
  if (e.type === "decl") {
    var t = e.value;
    t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
  }
}, Rv = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Mv = function(e) {
  return e.type === "comm" && e.children.indexOf(Rv) > -1;
}, kv = function(e) {
  return function(t, i, n) {
    if (!(t.type !== "rule" || e.compat)) {
      var s = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (s) {
        for (var o = t.parent === n[0], l = o ? n[0].children : n, a = l.length - 1; a >= 0; a--) {
          var b = l[a];
          if (b.line < t.line)
            break;
          if (b.column < t.column) {
            if (Mv(b))
              return;
            break;
          }
        }
        s.forEach(function(y) {
          console.error('The pseudo class "' + y + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + y.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, cu = function(e) {
  return e.type.charCodeAt(1) === 105 && e.type.charCodeAt(0) === 64;
}, Fv = function(e, t) {
  for (var i = e - 1; i >= 0; i--)
    if (!cu(t[i]))
      return !0;
  return !1;
}, Do = function(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
}, Nv = function(e, t, i) {
  !cu(e) || (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Do(e)) : Fv(t, i) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Do(e)));
};
function fu(r, e) {
  switch (dv(r, e)) {
    case 5103:
      return _e + "print-" + r + r;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return _e + r + r;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return _e + r + dn + r + rt + r + r;
    case 6828:
    case 4268:
      return _e + r + rt + r + r;
    case 6165:
      return _e + r + rt + "flex-" + r + r;
    case 5187:
      return _e + r + Te(r, /(\w+).+(:[^]+)/, _e + "box-$1$2" + rt + "flex-$1$2") + r;
    case 5443:
      return _e + r + rt + "flex-item-" + Te(r, /flex-|-self/, "") + r;
    case 4675:
      return _e + r + rt + "flex-line-pack" + Te(r, /align-content|flex-|-self/, "") + r;
    case 5548:
      return _e + r + rt + Te(r, "shrink", "negative") + r;
    case 5292:
      return _e + r + rt + Te(r, "basis", "preferred-size") + r;
    case 6060:
      return _e + "box-" + Te(r, "-grow", "") + _e + r + rt + Te(r, "grow", "positive") + r;
    case 4554:
      return _e + Te(r, /([^-])(transform)/g, "$1" + _e + "$2") + r;
    case 6187:
      return Te(Te(Te(r, /(zoom-|grab)/, _e + "$1"), /(image-set)/, _e + "$1"), r, "") + r;
    case 5495:
    case 3959:
      return Te(r, /(image-set\([^]*)/, _e + "$1$`$1");
    case 4968:
      return Te(Te(r, /(.+:)(flex-)?(.*)/, _e + "box-pack:$3" + rt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + _e + r + r;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Te(r, /(.+)-inline(.+)/, _e + "$1$2") + r;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ut(r) - 1 - e > 6)
        switch (Je(r, e + 1)) {
          case 109:
            if (Je(r, e + 4) !== 45)
              break;
          case 102:
            return Te(r, /(.+:)(.+)-([^]+)/, "$1" + _e + "$2-$3$1" + dn + (Je(r, e + 3) == 108 ? "$3" : "$2-$3")) + r;
          case 115:
            return ~ws(r, "stretch") ? fu(Te(r, "stretch", "fill-available"), e) + r : r;
        }
      break;
    case 4949:
      if (Je(r, e + 1) !== 115)
        break;
    case 6444:
      switch (Je(r, Ut(r) - 3 - (~ws(r, "!important") && 10))) {
        case 107:
          return Te(r, ":", ":" + _e) + r;
        case 101:
          return Te(r, /(.+:)([^;!]+)(;|!.+)?/, "$1" + _e + (Je(r, 14) === 45 ? "inline-" : "") + "box$3$1" + _e + "$2$3$1" + rt + "$2box$3") + r;
      }
      break;
    case 5936:
      switch (Je(r, e + 11)) {
        case 114:
          return _e + r + rt + Te(r, /[svh]\w+-[tblr]{2}/, "tb") + r;
        case 108:
          return _e + r + rt + Te(r, /[svh]\w+-[tblr]{2}/, "tb-rl") + r;
        case 45:
          return _e + r + rt + Te(r, /[svh]\w+-[tblr]{2}/, "lr") + r;
      }
      return _e + r + rt + r + r;
  }
  return r;
}
var Bv = function(e, t, i, n) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case da:
        e.return = fu(e.value, e.length);
        break;
      case su:
        return Rr([zr(e, {
          value: Te(e.value, "@", "@" + _e)
        })], n);
      case ha:
        if (e.length)
          return mv(e.props, function(s) {
            switch (vv(s, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Rr([zr(e, {
                  props: [Te(s, /:(read-\w+)/, ":" + dn + "$1")]
                })], n);
              case "::placeholder":
                return Rr([zr(e, {
                  props: [Te(s, /:(plac\w+)/, ":" + _e + "input-$1")]
                }), zr(e, {
                  props: [Te(s, /:(plac\w+)/, ":" + dn + "$1")]
                }), zr(e, {
                  props: [Te(s, /:(plac\w+)/, rt + "input-$1")]
                })], n);
            }
            return "";
          });
    }
}, Uv = [Bv], Kv = function(e) {
  var t = e.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var i = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(i, function(T) {
      var A = T.getAttribute("data-emotion");
      A.indexOf(" ") !== -1 && (document.head.appendChild(T), T.setAttribute("data-s", ""));
    });
  }
  var n = e.stylisPlugins || Uv;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var s = {}, o, l = [];
  o = e.container || document.head, Array.prototype.forEach.call(
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(T) {
      for (var A = T.getAttribute("data-emotion").split(" "), w = 1; w < A.length; w++)
        s[A[w]] = !0;
      l.push(T);
    }
  );
  var a, b = [Cv, Pv];
  process.env.NODE_ENV !== "production" && b.push(kv({
    get compat() {
      return I.compat;
    }
  }), Nv);
  {
    var y, N = [bv, process.env.NODE_ENV !== "production" ? function(T) {
      T.root || (T.return ? y.insert(T.return) : T.value && T.type !== fa && y.insert(T.value + "{}"));
    } : Lv(function(T) {
      y.insert(T);
    })], E = Av(b.concat(n, N)), B = function(A) {
      return Rr(Sv(A), E);
    };
    a = function(A, w, O, u) {
      y = O, process.env.NODE_ENV !== "production" && w.map !== void 0 && (y = {
        insert: function(d) {
          O.insert(d + w.map);
        }
      }), B(A ? A + "{" + w.styles + "}" : w.styles), u && (I.inserted[w.name] = !0);
    };
  }
  var I = {
    key: t,
    sheet: new uv({
      key: t,
      container: o,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: s,
    registered: {},
    insert: a
  };
  return I.sheet.hydrate(l), I;
};
function Vv(r) {
  for (var e = 0, t, i = 0, n = r.length; n >= 4; ++i, n -= 4)
    t = r.charCodeAt(i) & 255 | (r.charCodeAt(++i) & 255) << 8 | (r.charCodeAt(++i) & 255) << 16 | (r.charCodeAt(++i) & 255) << 24, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= t >>> 24, e = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  switch (n) {
    case 3:
      e ^= (r.charCodeAt(i + 2) & 255) << 16;
    case 2:
      e ^= (r.charCodeAt(i + 1) & 255) << 8;
    case 1:
      e ^= r.charCodeAt(i) & 255, e = (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16);
  }
  return e ^= e >>> 13, e = (e & 65535) * 1540483477 + ((e >>> 16) * 59797 << 16), ((e ^ e >>> 15) >>> 0).toString(36);
}
var Wv = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Io = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Gv = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Hv = /[A-Z]|^ms/g, hu = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ma = function(e) {
  return e.charCodeAt(1) === 45;
}, Oo = function(e) {
  return e != null && typeof e != "boolean";
}, vs = /* @__PURE__ */ wv(function(r) {
  return ma(r) ? r : r.replace(Hv, "-$&").toLowerCase();
}), vn = function(e, t) {
  switch (e) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(hu, function(i, n, s) {
          return Ot = {
            name: n,
            styles: s,
            next: Ot
          }, n;
        });
  }
  return Wv[e] !== 1 && !ma(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var $v = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, jv = ["normal", "none", "initial", "inherit", "unset"], Yv = vn, zv = /^-ms-/, Xv = /-(.)/g, Co = {};
  vn = function(e, t) {
    if (e === "content" && (typeof t != "string" || jv.indexOf(t) === -1 && !$v.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var i = Yv(e, t);
    return i !== "" && !ma(e) && e.indexOf("-") !== -1 && Co[e] === void 0 && (Co[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(zv, "ms-").replace(Xv, function(n, s) {
      return s.toUpperCase();
    }) + "?")), i;
  };
}
var du = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function hi(r, e, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(du);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return Ot = {
          name: t.name,
          styles: t.styles,
          next: Ot
        }, t.name;
      if (t.styles !== void 0) {
        var i = t.next;
        if (i !== void 0)
          for (; i !== void 0; )
            Ot = {
              name: i.name,
              styles: i.styles,
              next: Ot
            }, i = i.next;
        var n = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (n += t.map), n;
      }
      return Qv(r, e, t);
    }
    case "function": {
      if (r !== void 0) {
        var s = Ot, o = t(r);
        return Ot = s, hi(r, e, o);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], a = t.replace(hu, function(y, N, E) {
          var B = "animation" + l.length;
          return l.push("const " + B + " = keyframes`" + E.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + B + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + a + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + a + "`"));
      }
      break;
  }
  if (e == null)
    return t;
  var b = e[t];
  return b !== void 0 ? b : t;
}
function Qv(r, e, t) {
  var i = "";
  if (Array.isArray(t))
    for (var n = 0; n < t.length; n++)
      i += hi(r, e, t[n]) + ";";
  else
    for (var s in t) {
      var o = t[s];
      if (typeof o != "object")
        e != null && e[o] !== void 0 ? i += s + "{" + e[o] + "}" : Oo(o) && (i += vs(s) + ":" + vn(s, o) + ";");
      else {
        if (s === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(du);
        if (Array.isArray(o) && typeof o[0] == "string" && (e == null || e[o[0]] === void 0))
          for (var l = 0; l < o.length; l++)
            Oo(o[l]) && (i += vs(s) + ":" + vn(s, o[l]) + ";");
        else {
          var a = hi(r, e, o);
          switch (s) {
            case "animation":
            case "animationName": {
              i += vs(s) + ":" + a + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && s === "undefined" && console.error(Gv), i += s + "{" + a + "}";
          }
        }
      }
    }
  return i;
}
var Po = /label:\s*([^\s;\n{]+)\s*(;|$)/g, vu;
process.env.NODE_ENV !== "production" && (vu = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Ot, ms = function(e, t, i) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, s = "";
  Ot = void 0;
  var o = e[0];
  o == null || o.raw === void 0 ? (n = !1, s += hi(i, t, o)) : (process.env.NODE_ENV !== "production" && o[0] === void 0 && console.error(Io), s += o[0]);
  for (var l = 1; l < e.length; l++)
    s += hi(i, t, e[l]), n && (process.env.NODE_ENV !== "production" && o[l] === void 0 && console.error(Io), s += o[l]);
  var a;
  process.env.NODE_ENV !== "production" && (s = s.replace(vu, function(E) {
    return a = E, "";
  })), Po.lastIndex = 0;
  for (var b = "", y; (y = Po.exec(s)) !== null; )
    b += "-" + y[1];
  var N = Vv(s) + b;
  return process.env.NODE_ENV !== "production" ? {
    name: N,
    styles: s,
    map: a,
    next: Ot,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: N,
    styles: s,
    next: Ot
  };
}, Zv = !0;
function mu(r, e, t) {
  var i = "";
  return t.split(" ").forEach(function(n) {
    r[n] !== void 0 ? e.push(r[n] + ";") : i += n + " ";
  }), i;
}
var Jv = function(e, t, i) {
  var n = e.key + "-" + t.name;
  (i === !1 || Zv === !1) && e.registered[n] === void 0 && (e.registered[n] = t.styles);
}, qv = function(e, t, i) {
  Jv(e, t, i);
  var n = e.key + "-" + t.name;
  if (e.inserted[t.name] === void 0) {
    var s = t;
    do
      e.insert(t === s ? "." + n : "", s, e.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function Ro(r, e) {
  if (r.inserted[e.name] === void 0)
    return r.insert("", e, r.sheet, !0);
}
function Mo(r, e, t) {
  var i = [], n = mu(r, i, t);
  return i.length < 2 ? t : n + e(i);
}
var em = function(e) {
  var t = Kv(e);
  t.sheet.speedy = function(l) {
    if (process.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = l;
  }, t.compat = !0;
  var i = function() {
    for (var a = arguments.length, b = new Array(a), y = 0; y < a; y++)
      b[y] = arguments[y];
    var N = ms(b, t.registered, void 0);
    return qv(t, N, !1), t.key + "-" + N.name;
  }, n = function() {
    for (var a = arguments.length, b = new Array(a), y = 0; y < a; y++)
      b[y] = arguments[y];
    var N = ms(b, t.registered), E = "animation-" + N.name;
    return Ro(t, {
      name: N.name,
      styles: "@keyframes " + E + "{" + N.styles + "}"
    }), E;
  }, s = function() {
    for (var a = arguments.length, b = new Array(a), y = 0; y < a; y++)
      b[y] = arguments[y];
    var N = ms(b, t.registered);
    Ro(t, N);
  }, o = function() {
    for (var a = arguments.length, b = new Array(a), y = 0; y < a; y++)
      b[y] = arguments[y];
    return Mo(t.registered, i, tm(b));
  };
  return {
    css: i,
    cx: o,
    injectGlobal: s,
    keyframes: n,
    hydrate: function(a) {
      a.forEach(function(b) {
        t.inserted[b] = !0;
      });
    },
    flush: function() {
      t.registered = {}, t.inserted = {}, t.sheet.flush();
    },
    sheet: t.sheet,
    cache: t,
    getRegisteredStyles: mu.bind(null, t.registered),
    merge: Mo.bind(null, t.registered, i)
  };
}, tm = function r(e) {
  for (var t = "", i = 0; i < e.length; i++) {
    var n = e[i];
    if (n != null) {
      var s = void 0;
      switch (typeof n) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(n))
            s = r(n);
          else {
            s = "";
            for (var o in n)
              n[o] && o && (s && (s += " "), s += o);
          }
          break;
        }
        default:
          s = n;
      }
      s && (t && (t += " "), t += s);
    }
  }
  return t;
}, rm = em({
  key: "css"
}), bi = rm.css;
const ko = /* @__PURE__ */ ut({
  __name: "Box",
  props: {
    as: {
      type: String,
      default: "div"
    },
    max: {
      type: String,
      default: ""
    },
    fullSize: {
      type: Boolean,
      default: !1
    },
    padding: {
      type: String,
      required: !1
    },
    bordered: {
      type: Boolean,
      default: !1
    },
    borderWidth: {
      type: String,
      required: !1
    },
    overflow: {
      type: String,
      required: !1
    }
  },
  setup(r) {
    const e = r, t = () => {
      var n;
      return bi`
    padding: ${(n = e.padding) != null ? n : "0"};
    border: ${e.bordered ? e.borderWidth : "none"};
    ${e.max ? `max-width: ${e.max}` : ""};
    ${e.fullSize ? "width: 100%" : ""};
    ${e.overflow ? `overflow: ${e.overflow}` : ""};
  `;
    };
    er(e, () => {
      i.value = { [t()]: !0 };
    }, { deep: !0 });
    const i = ke({
      [t()]: !0
    });
    return (n, s) => (fe(), Fe(yn(r.as), {
      class: Ct(i.value)
    }, {
      default: xe(() => [
        Ur(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), im = {}, nm = {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, sm = /* @__PURE__ */ me("path", {
  d: "M10.9167 9C10.4125 9 10 9.40089 10 9.89087V16.1269C10 16.6169 10.2933 17.3029 10.6508 17.6503L14.8583 21.7394C15.2158 22.0869 15.8025 22.0869 16.1508 21.7394L20.3583 17.6503C20.7067 17.3029 21 16.6169 21 16.1269V9.89087C21 9.40089 20.5875 9 20.0833 9H10.9167Z",
  fill: "inherit"
}, null, -1), am = [
  sm
];
function om(r, e) {
  return fe(), Se("svg", nm, am);
}
const lm = /* @__PURE__ */ Ue(im, [["render", om]]);
var gu = { exports: {} }, pu = {
  aliceblue: [240, 248, 255],
  antiquewhite: [250, 235, 215],
  aqua: [0, 255, 255],
  aquamarine: [127, 255, 212],
  azure: [240, 255, 255],
  beige: [245, 245, 220],
  bisque: [255, 228, 196],
  black: [0, 0, 0],
  blanchedalmond: [255, 235, 205],
  blue: [0, 0, 255],
  blueviolet: [138, 43, 226],
  brown: [165, 42, 42],
  burlywood: [222, 184, 135],
  cadetblue: [95, 158, 160],
  chartreuse: [127, 255, 0],
  chocolate: [210, 105, 30],
  coral: [255, 127, 80],
  cornflowerblue: [100, 149, 237],
  cornsilk: [255, 248, 220],
  crimson: [220, 20, 60],
  cyan: [0, 255, 255],
  darkblue: [0, 0, 139],
  darkcyan: [0, 139, 139],
  darkgoldenrod: [184, 134, 11],
  darkgray: [169, 169, 169],
  darkgreen: [0, 100, 0],
  darkgrey: [169, 169, 169],
  darkkhaki: [189, 183, 107],
  darkmagenta: [139, 0, 139],
  darkolivegreen: [85, 107, 47],
  darkorange: [255, 140, 0],
  darkorchid: [153, 50, 204],
  darkred: [139, 0, 0],
  darksalmon: [233, 150, 122],
  darkseagreen: [143, 188, 143],
  darkslateblue: [72, 61, 139],
  darkslategray: [47, 79, 79],
  darkslategrey: [47, 79, 79],
  darkturquoise: [0, 206, 209],
  darkviolet: [148, 0, 211],
  deeppink: [255, 20, 147],
  deepskyblue: [0, 191, 255],
  dimgray: [105, 105, 105],
  dimgrey: [105, 105, 105],
  dodgerblue: [30, 144, 255],
  firebrick: [178, 34, 34],
  floralwhite: [255, 250, 240],
  forestgreen: [34, 139, 34],
  fuchsia: [255, 0, 255],
  gainsboro: [220, 220, 220],
  ghostwhite: [248, 248, 255],
  gold: [255, 215, 0],
  goldenrod: [218, 165, 32],
  gray: [128, 128, 128],
  green: [0, 128, 0],
  greenyellow: [173, 255, 47],
  grey: [128, 128, 128],
  honeydew: [240, 255, 240],
  hotpink: [255, 105, 180],
  indianred: [205, 92, 92],
  indigo: [75, 0, 130],
  ivory: [255, 255, 240],
  khaki: [240, 230, 140],
  lavender: [230, 230, 250],
  lavenderblush: [255, 240, 245],
  lawngreen: [124, 252, 0],
  lemonchiffon: [255, 250, 205],
  lightblue: [173, 216, 230],
  lightcoral: [240, 128, 128],
  lightcyan: [224, 255, 255],
  lightgoldenrodyellow: [250, 250, 210],
  lightgray: [211, 211, 211],
  lightgreen: [144, 238, 144],
  lightgrey: [211, 211, 211],
  lightpink: [255, 182, 193],
  lightsalmon: [255, 160, 122],
  lightseagreen: [32, 178, 170],
  lightskyblue: [135, 206, 250],
  lightslategray: [119, 136, 153],
  lightslategrey: [119, 136, 153],
  lightsteelblue: [176, 196, 222],
  lightyellow: [255, 255, 224],
  lime: [0, 255, 0],
  limegreen: [50, 205, 50],
  linen: [250, 240, 230],
  magenta: [255, 0, 255],
  maroon: [128, 0, 0],
  mediumaquamarine: [102, 205, 170],
  mediumblue: [0, 0, 205],
  mediumorchid: [186, 85, 211],
  mediumpurple: [147, 112, 219],
  mediumseagreen: [60, 179, 113],
  mediumslateblue: [123, 104, 238],
  mediumspringgreen: [0, 250, 154],
  mediumturquoise: [72, 209, 204],
  mediumvioletred: [199, 21, 133],
  midnightblue: [25, 25, 112],
  mintcream: [245, 255, 250],
  mistyrose: [255, 228, 225],
  moccasin: [255, 228, 181],
  navajowhite: [255, 222, 173],
  navy: [0, 0, 128],
  oldlace: [253, 245, 230],
  olive: [128, 128, 0],
  olivedrab: [107, 142, 35],
  orange: [255, 165, 0],
  orangered: [255, 69, 0],
  orchid: [218, 112, 214],
  palegoldenrod: [238, 232, 170],
  palegreen: [152, 251, 152],
  paleturquoise: [175, 238, 238],
  palevioletred: [219, 112, 147],
  papayawhip: [255, 239, 213],
  peachpuff: [255, 218, 185],
  peru: [205, 133, 63],
  pink: [255, 192, 203],
  plum: [221, 160, 221],
  powderblue: [176, 224, 230],
  purple: [128, 0, 128],
  rebeccapurple: [102, 51, 153],
  red: [255, 0, 0],
  rosybrown: [188, 143, 143],
  royalblue: [65, 105, 225],
  saddlebrown: [139, 69, 19],
  salmon: [250, 128, 114],
  sandybrown: [244, 164, 96],
  seagreen: [46, 139, 87],
  seashell: [255, 245, 238],
  sienna: [160, 82, 45],
  silver: [192, 192, 192],
  skyblue: [135, 206, 235],
  slateblue: [106, 90, 205],
  slategray: [112, 128, 144],
  slategrey: [112, 128, 144],
  snow: [255, 250, 250],
  springgreen: [0, 255, 127],
  steelblue: [70, 130, 180],
  tan: [210, 180, 140],
  teal: [0, 128, 128],
  thistle: [216, 191, 216],
  tomato: [255, 99, 71],
  turquoise: [64, 224, 208],
  violet: [238, 130, 238],
  wheat: [245, 222, 179],
  white: [255, 255, 255],
  whitesmoke: [245, 245, 245],
  yellow: [255, 255, 0],
  yellowgreen: [154, 205, 50]
}, yu = { exports: {} }, um = function(e) {
  return !e || typeof e == "string" ? !1 : e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && e.constructor.name !== "String");
}, cm = um, fm = Array.prototype.concat, hm = Array.prototype.slice, Fo = yu.exports = function(e) {
  for (var t = [], i = 0, n = e.length; i < n; i++) {
    var s = e[i];
    cm(s) ? t = fm.call(t, hm.call(s)) : t.push(s);
  }
  return t;
};
Fo.wrap = function(r) {
  return function() {
    return r(Fo(arguments));
  };
};
var ni = pu, Ai = yu.exports, Eu = Object.hasOwnProperty, _u = /* @__PURE__ */ Object.create(null);
for (var gs in ni)
  Eu.call(ni, gs) && (_u[ni[gs]] = gs);
var vt = gu.exports = {
  to: {},
  get: {}
};
vt.get = function(r) {
  var e = r.substring(0, 3).toLowerCase(), t, i;
  switch (e) {
    case "hsl":
      t = vt.get.hsl(r), i = "hsl";
      break;
    case "hwb":
      t = vt.get.hwb(r), i = "hwb";
      break;
    default:
      t = vt.get.rgb(r), i = "rgb";
      break;
  }
  return t ? { model: i, value: t } : null;
};
vt.get.rgb = function(r) {
  if (!r)
    return null;
  var e = /^#([a-f0-9]{3,4})$/i, t = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, i = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, n = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, s = /^(\w+)$/, o = [0, 0, 0, 1], l, a, b;
  if (l = r.match(t)) {
    for (b = l[2], l = l[1], a = 0; a < 3; a++) {
      var y = a * 2;
      o[a] = parseInt(l.slice(y, y + 2), 16);
    }
    b && (o[3] = parseInt(b, 16) / 255);
  } else if (l = r.match(e)) {
    for (l = l[1], b = l[3], a = 0; a < 3; a++)
      o[a] = parseInt(l[a] + l[a], 16);
    b && (o[3] = parseInt(b + b, 16) / 255);
  } else if (l = r.match(i)) {
    for (a = 0; a < 3; a++)
      o[a] = parseInt(l[a + 1], 0);
    l[4] && (l[5] ? o[3] = parseFloat(l[4]) * 0.01 : o[3] = parseFloat(l[4]));
  } else if (l = r.match(n)) {
    for (a = 0; a < 3; a++)
      o[a] = Math.round(parseFloat(l[a + 1]) * 2.55);
    l[4] && (l[5] ? o[3] = parseFloat(l[4]) * 0.01 : o[3] = parseFloat(l[4]));
  } else
    return (l = r.match(s)) ? l[1] === "transparent" ? [0, 0, 0, 0] : Eu.call(ni, l[1]) ? (o = ni[l[1]], o[3] = 1, o) : null : null;
  for (a = 0; a < 3; a++)
    o[a] = qt(o[a], 0, 255);
  return o[3] = qt(o[3], 0, 1), o;
};
vt.get.hsl = function(r) {
  if (!r)
    return null;
  var e = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, t = r.match(e);
  if (t) {
    var i = parseFloat(t[4]), n = (parseFloat(t[1]) % 360 + 360) % 360, s = qt(parseFloat(t[2]), 0, 100), o = qt(parseFloat(t[3]), 0, 100), l = qt(isNaN(i) ? 1 : i, 0, 1);
    return [n, s, o, l];
  }
  return null;
};
vt.get.hwb = function(r) {
  if (!r)
    return null;
  var e = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/, t = r.match(e);
  if (t) {
    var i = parseFloat(t[4]), n = (parseFloat(t[1]) % 360 + 360) % 360, s = qt(parseFloat(t[2]), 0, 100), o = qt(parseFloat(t[3]), 0, 100), l = qt(isNaN(i) ? 1 : i, 0, 1);
    return [n, s, o, l];
  }
  return null;
};
vt.to.hex = function() {
  var r = Ai(arguments);
  return "#" + Ui(r[0]) + Ui(r[1]) + Ui(r[2]) + (r[3] < 1 ? Ui(Math.round(r[3] * 255)) : "");
};
vt.to.rgb = function() {
  var r = Ai(arguments);
  return r.length < 4 || r[3] === 1 ? "rgb(" + Math.round(r[0]) + ", " + Math.round(r[1]) + ", " + Math.round(r[2]) + ")" : "rgba(" + Math.round(r[0]) + ", " + Math.round(r[1]) + ", " + Math.round(r[2]) + ", " + r[3] + ")";
};
vt.to.rgb.percent = function() {
  var r = Ai(arguments), e = Math.round(r[0] / 255 * 100), t = Math.round(r[1] / 255 * 100), i = Math.round(r[2] / 255 * 100);
  return r.length < 4 || r[3] === 1 ? "rgb(" + e + "%, " + t + "%, " + i + "%)" : "rgba(" + e + "%, " + t + "%, " + i + "%, " + r[3] + ")";
};
vt.to.hsl = function() {
  var r = Ai(arguments);
  return r.length < 4 || r[3] === 1 ? "hsl(" + r[0] + ", " + r[1] + "%, " + r[2] + "%)" : "hsla(" + r[0] + ", " + r[1] + "%, " + r[2] + "%, " + r[3] + ")";
};
vt.to.hwb = function() {
  var r = Ai(arguments), e = "";
  return r.length >= 4 && r[3] !== 1 && (e = ", " + r[3]), "hwb(" + r[0] + ", " + r[1] + "%, " + r[2] + "%" + e + ")";
};
vt.to.keyword = function(r) {
  return _u[r.slice(0, 3)];
};
function qt(r, e, t) {
  return Math.min(Math.max(e, r), t);
}
function Ui(r) {
  var e = Math.round(r).toString(16).toUpperCase();
  return e.length < 2 ? "0" + e : e;
}
const di = pu, Tu = {};
for (const r of Object.keys(di))
  Tu[di[r]] = r;
const oe = {
  rgb: { channels: 3, labels: "rgb" },
  hsl: { channels: 3, labels: "hsl" },
  hsv: { channels: 3, labels: "hsv" },
  hwb: { channels: 3, labels: "hwb" },
  cmyk: { channels: 4, labels: "cmyk" },
  xyz: { channels: 3, labels: "xyz" },
  lab: { channels: 3, labels: "lab" },
  lch: { channels: 3, labels: "lch" },
  hex: { channels: 1, labels: ["hex"] },
  keyword: { channels: 1, labels: ["keyword"] },
  ansi16: { channels: 1, labels: ["ansi16"] },
  ansi256: { channels: 1, labels: ["ansi256"] },
  hcg: { channels: 3, labels: ["h", "c", "g"] },
  apple: { channels: 3, labels: ["r16", "g16", "b16"] },
  gray: { channels: 1, labels: ["gray"] }
};
var Su = oe;
for (const r of Object.keys(oe)) {
  if (!("channels" in oe[r]))
    throw new Error("missing channels property: " + r);
  if (!("labels" in oe[r]))
    throw new Error("missing channel labels property: " + r);
  if (oe[r].labels.length !== oe[r].channels)
    throw new Error("channel and label counts mismatch: " + r);
  const { channels: e, labels: t } = oe[r];
  delete oe[r].channels, delete oe[r].labels, Object.defineProperty(oe[r], "channels", { value: e }), Object.defineProperty(oe[r], "labels", { value: t });
}
oe.rgb.hsl = function(r) {
  const e = r[0] / 255, t = r[1] / 255, i = r[2] / 255, n = Math.min(e, t, i), s = Math.max(e, t, i), o = s - n;
  let l, a;
  s === n ? l = 0 : e === s ? l = (t - i) / o : t === s ? l = 2 + (i - e) / o : i === s && (l = 4 + (e - t) / o), l = Math.min(l * 60, 360), l < 0 && (l += 360);
  const b = (n + s) / 2;
  return s === n ? a = 0 : b <= 0.5 ? a = o / (s + n) : a = o / (2 - s - n), [l, a * 100, b * 100];
};
oe.rgb.hsv = function(r) {
  let e, t, i, n, s;
  const o = r[0] / 255, l = r[1] / 255, a = r[2] / 255, b = Math.max(o, l, a), y = b - Math.min(o, l, a), N = function(E) {
    return (b - E) / 6 / y + 1 / 2;
  };
  return y === 0 ? (n = 0, s = 0) : (s = y / b, e = N(o), t = N(l), i = N(a), o === b ? n = i - t : l === b ? n = 1 / 3 + e - i : a === b && (n = 2 / 3 + t - e), n < 0 ? n += 1 : n > 1 && (n -= 1)), [
    n * 360,
    s * 100,
    b * 100
  ];
};
oe.rgb.hwb = function(r) {
  const e = r[0], t = r[1];
  let i = r[2];
  const n = oe.rgb.hsl(r)[0], s = 1 / 255 * Math.min(e, Math.min(t, i));
  return i = 1 - 1 / 255 * Math.max(e, Math.max(t, i)), [n, s * 100, i * 100];
};
oe.rgb.cmyk = function(r) {
  const e = r[0] / 255, t = r[1] / 255, i = r[2] / 255, n = Math.min(1 - e, 1 - t, 1 - i), s = (1 - e - n) / (1 - n) || 0, o = (1 - t - n) / (1 - n) || 0, l = (1 - i - n) / (1 - n) || 0;
  return [s * 100, o * 100, l * 100, n * 100];
};
function dm(r, e) {
  return (r[0] - e[0]) ** 2 + (r[1] - e[1]) ** 2 + (r[2] - e[2]) ** 2;
}
oe.rgb.keyword = function(r) {
  const e = Tu[r];
  if (e)
    return e;
  let t = 1 / 0, i;
  for (const n of Object.keys(di)) {
    const s = di[n], o = dm(r, s);
    o < t && (t = o, i = n);
  }
  return i;
};
oe.keyword.rgb = function(r) {
  return di[r];
};
oe.rgb.xyz = function(r) {
  let e = r[0] / 255, t = r[1] / 255, i = r[2] / 255;
  e = e > 0.04045 ? ((e + 0.055) / 1.055) ** 2.4 : e / 12.92, t = t > 0.04045 ? ((t + 0.055) / 1.055) ** 2.4 : t / 12.92, i = i > 0.04045 ? ((i + 0.055) / 1.055) ** 2.4 : i / 12.92;
  const n = e * 0.4124 + t * 0.3576 + i * 0.1805, s = e * 0.2126 + t * 0.7152 + i * 0.0722, o = e * 0.0193 + t * 0.1192 + i * 0.9505;
  return [n * 100, s * 100, o * 100];
};
oe.rgb.lab = function(r) {
  const e = oe.rgb.xyz(r);
  let t = e[0], i = e[1], n = e[2];
  t /= 95.047, i /= 100, n /= 108.883, t = t > 8856e-6 ? t ** (1 / 3) : 7.787 * t + 16 / 116, i = i > 8856e-6 ? i ** (1 / 3) : 7.787 * i + 16 / 116, n = n > 8856e-6 ? n ** (1 / 3) : 7.787 * n + 16 / 116;
  const s = 116 * i - 16, o = 500 * (t - i), l = 200 * (i - n);
  return [s, o, l];
};
oe.hsl.rgb = function(r) {
  const e = r[0] / 360, t = r[1] / 100, i = r[2] / 100;
  let n, s, o;
  if (t === 0)
    return o = i * 255, [o, o, o];
  i < 0.5 ? n = i * (1 + t) : n = i + t - i * t;
  const l = 2 * i - n, a = [0, 0, 0];
  for (let b = 0; b < 3; b++)
    s = e + 1 / 3 * -(b - 1), s < 0 && s++, s > 1 && s--, 6 * s < 1 ? o = l + (n - l) * 6 * s : 2 * s < 1 ? o = n : 3 * s < 2 ? o = l + (n - l) * (2 / 3 - s) * 6 : o = l, a[b] = o * 255;
  return a;
};
oe.hsl.hsv = function(r) {
  const e = r[0];
  let t = r[1] / 100, i = r[2] / 100, n = t;
  const s = Math.max(i, 0.01);
  i *= 2, t *= i <= 1 ? i : 2 - i, n *= s <= 1 ? s : 2 - s;
  const o = (i + t) / 2, l = i === 0 ? 2 * n / (s + n) : 2 * t / (i + t);
  return [e, l * 100, o * 100];
};
oe.hsv.rgb = function(r) {
  const e = r[0] / 60, t = r[1] / 100;
  let i = r[2] / 100;
  const n = Math.floor(e) % 6, s = e - Math.floor(e), o = 255 * i * (1 - t), l = 255 * i * (1 - t * s), a = 255 * i * (1 - t * (1 - s));
  switch (i *= 255, n) {
    case 0:
      return [i, a, o];
    case 1:
      return [l, i, o];
    case 2:
      return [o, i, a];
    case 3:
      return [o, l, i];
    case 4:
      return [a, o, i];
    case 5:
      return [i, o, l];
  }
};
oe.hsv.hsl = function(r) {
  const e = r[0], t = r[1] / 100, i = r[2] / 100, n = Math.max(i, 0.01);
  let s, o;
  o = (2 - t) * i;
  const l = (2 - t) * n;
  return s = t * n, s /= l <= 1 ? l : 2 - l, s = s || 0, o /= 2, [e, s * 100, o * 100];
};
oe.hwb.rgb = function(r) {
  const e = r[0] / 360;
  let t = r[1] / 100, i = r[2] / 100;
  const n = t + i;
  let s;
  n > 1 && (t /= n, i /= n);
  const o = Math.floor(6 * e), l = 1 - i;
  s = 6 * e - o, (o & 1) !== 0 && (s = 1 - s);
  const a = t + s * (l - t);
  let b, y, N;
  switch (o) {
    default:
    case 6:
    case 0:
      b = l, y = a, N = t;
      break;
    case 1:
      b = a, y = l, N = t;
      break;
    case 2:
      b = t, y = l, N = a;
      break;
    case 3:
      b = t, y = a, N = l;
      break;
    case 4:
      b = a, y = t, N = l;
      break;
    case 5:
      b = l, y = t, N = a;
      break;
  }
  return [b * 255, y * 255, N * 255];
};
oe.cmyk.rgb = function(r) {
  const e = r[0] / 100, t = r[1] / 100, i = r[2] / 100, n = r[3] / 100, s = 1 - Math.min(1, e * (1 - n) + n), o = 1 - Math.min(1, t * (1 - n) + n), l = 1 - Math.min(1, i * (1 - n) + n);
  return [s * 255, o * 255, l * 255];
};
oe.xyz.rgb = function(r) {
  const e = r[0] / 100, t = r[1] / 100, i = r[2] / 100;
  let n, s, o;
  return n = e * 3.2406 + t * -1.5372 + i * -0.4986, s = e * -0.9689 + t * 1.8758 + i * 0.0415, o = e * 0.0557 + t * -0.204 + i * 1.057, n = n > 31308e-7 ? 1.055 * n ** (1 / 2.4) - 0.055 : n * 12.92, s = s > 31308e-7 ? 1.055 * s ** (1 / 2.4) - 0.055 : s * 12.92, o = o > 31308e-7 ? 1.055 * o ** (1 / 2.4) - 0.055 : o * 12.92, n = Math.min(Math.max(0, n), 1), s = Math.min(Math.max(0, s), 1), o = Math.min(Math.max(0, o), 1), [n * 255, s * 255, o * 255];
};
oe.xyz.lab = function(r) {
  let e = r[0], t = r[1], i = r[2];
  e /= 95.047, t /= 100, i /= 108.883, e = e > 8856e-6 ? e ** (1 / 3) : 7.787 * e + 16 / 116, t = t > 8856e-6 ? t ** (1 / 3) : 7.787 * t + 16 / 116, i = i > 8856e-6 ? i ** (1 / 3) : 7.787 * i + 16 / 116;
  const n = 116 * t - 16, s = 500 * (e - t), o = 200 * (t - i);
  return [n, s, o];
};
oe.lab.xyz = function(r) {
  const e = r[0], t = r[1], i = r[2];
  let n, s, o;
  s = (e + 16) / 116, n = t / 500 + s, o = s - i / 200;
  const l = s ** 3, a = n ** 3, b = o ** 3;
  return s = l > 8856e-6 ? l : (s - 16 / 116) / 7.787, n = a > 8856e-6 ? a : (n - 16 / 116) / 7.787, o = b > 8856e-6 ? b : (o - 16 / 116) / 7.787, n *= 95.047, s *= 100, o *= 108.883, [n, s, o];
};
oe.lab.lch = function(r) {
  const e = r[0], t = r[1], i = r[2];
  let n;
  n = Math.atan2(i, t) * 360 / 2 / Math.PI, n < 0 && (n += 360);
  const o = Math.sqrt(t * t + i * i);
  return [e, o, n];
};
oe.lch.lab = function(r) {
  const e = r[0], t = r[1], n = r[2] / 360 * 2 * Math.PI, s = t * Math.cos(n), o = t * Math.sin(n);
  return [e, s, o];
};
oe.rgb.ansi16 = function(r, e = null) {
  const [t, i, n] = r;
  let s = e === null ? oe.rgb.hsv(r)[2] : e;
  if (s = Math.round(s / 50), s === 0)
    return 30;
  let o = 30 + (Math.round(n / 255) << 2 | Math.round(i / 255) << 1 | Math.round(t / 255));
  return s === 2 && (o += 60), o;
};
oe.hsv.ansi16 = function(r) {
  return oe.rgb.ansi16(oe.hsv.rgb(r), r[2]);
};
oe.rgb.ansi256 = function(r) {
  const e = r[0], t = r[1], i = r[2];
  return e === t && t === i ? e < 8 ? 16 : e > 248 ? 231 : Math.round((e - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(t / 255 * 5) + Math.round(i / 255 * 5);
};
oe.ansi16.rgb = function(r) {
  let e = r % 10;
  if (e === 0 || e === 7)
    return r > 50 && (e += 3.5), e = e / 10.5 * 255, [e, e, e];
  const t = (~~(r > 50) + 1) * 0.5, i = (e & 1) * t * 255, n = (e >> 1 & 1) * t * 255, s = (e >> 2 & 1) * t * 255;
  return [i, n, s];
};
oe.ansi256.rgb = function(r) {
  if (r >= 232) {
    const s = (r - 232) * 10 + 8;
    return [s, s, s];
  }
  r -= 16;
  let e;
  const t = Math.floor(r / 36) / 5 * 255, i = Math.floor((e = r % 36) / 6) / 5 * 255, n = e % 6 / 5 * 255;
  return [t, i, n];
};
oe.rgb.hex = function(r) {
  const t = (((Math.round(r[0]) & 255) << 16) + ((Math.round(r[1]) & 255) << 8) + (Math.round(r[2]) & 255)).toString(16).toUpperCase();
  return "000000".substring(t.length) + t;
};
oe.hex.rgb = function(r) {
  const e = r.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
  if (!e)
    return [0, 0, 0];
  let t = e[0];
  e[0].length === 3 && (t = t.split("").map((l) => l + l).join(""));
  const i = parseInt(t, 16), n = i >> 16 & 255, s = i >> 8 & 255, o = i & 255;
  return [n, s, o];
};
oe.rgb.hcg = function(r) {
  const e = r[0] / 255, t = r[1] / 255, i = r[2] / 255, n = Math.max(Math.max(e, t), i), s = Math.min(Math.min(e, t), i), o = n - s;
  let l, a;
  return o < 1 ? l = s / (1 - o) : l = 0, o <= 0 ? a = 0 : n === e ? a = (t - i) / o % 6 : n === t ? a = 2 + (i - e) / o : a = 4 + (e - t) / o, a /= 6, a %= 1, [a * 360, o * 100, l * 100];
};
oe.hsl.hcg = function(r) {
  const e = r[1] / 100, t = r[2] / 100, i = t < 0.5 ? 2 * e * t : 2 * e * (1 - t);
  let n = 0;
  return i < 1 && (n = (t - 0.5 * i) / (1 - i)), [r[0], i * 100, n * 100];
};
oe.hsv.hcg = function(r) {
  const e = r[1] / 100, t = r[2] / 100, i = e * t;
  let n = 0;
  return i < 1 && (n = (t - i) / (1 - i)), [r[0], i * 100, n * 100];
};
oe.hcg.rgb = function(r) {
  const e = r[0] / 360, t = r[1] / 100, i = r[2] / 100;
  if (t === 0)
    return [i * 255, i * 255, i * 255];
  const n = [0, 0, 0], s = e % 1 * 6, o = s % 1, l = 1 - o;
  let a = 0;
  switch (Math.floor(s)) {
    case 0:
      n[0] = 1, n[1] = o, n[2] = 0;
      break;
    case 1:
      n[0] = l, n[1] = 1, n[2] = 0;
      break;
    case 2:
      n[0] = 0, n[1] = 1, n[2] = o;
      break;
    case 3:
      n[0] = 0, n[1] = l, n[2] = 1;
      break;
    case 4:
      n[0] = o, n[1] = 0, n[2] = 1;
      break;
    default:
      n[0] = 1, n[1] = 0, n[2] = l;
  }
  return a = (1 - t) * i, [
    (t * n[0] + a) * 255,
    (t * n[1] + a) * 255,
    (t * n[2] + a) * 255
  ];
};
oe.hcg.hsv = function(r) {
  const e = r[1] / 100, t = r[2] / 100, i = e + t * (1 - e);
  let n = 0;
  return i > 0 && (n = e / i), [r[0], n * 100, i * 100];
};
oe.hcg.hsl = function(r) {
  const e = r[1] / 100, i = r[2] / 100 * (1 - e) + 0.5 * e;
  let n = 0;
  return i > 0 && i < 0.5 ? n = e / (2 * i) : i >= 0.5 && i < 1 && (n = e / (2 * (1 - i))), [r[0], n * 100, i * 100];
};
oe.hcg.hwb = function(r) {
  const e = r[1] / 100, t = r[2] / 100, i = e + t * (1 - e);
  return [r[0], (i - e) * 100, (1 - i) * 100];
};
oe.hwb.hcg = function(r) {
  const e = r[1] / 100, i = 1 - r[2] / 100, n = i - e;
  let s = 0;
  return n < 1 && (s = (i - n) / (1 - n)), [r[0], n * 100, s * 100];
};
oe.apple.rgb = function(r) {
  return [r[0] / 65535 * 255, r[1] / 65535 * 255, r[2] / 65535 * 255];
};
oe.rgb.apple = function(r) {
  return [r[0] / 255 * 65535, r[1] / 255 * 65535, r[2] / 255 * 65535];
};
oe.gray.rgb = function(r) {
  return [r[0] / 100 * 255, r[0] / 100 * 255, r[0] / 100 * 255];
};
oe.gray.hsl = function(r) {
  return [0, 0, r[0]];
};
oe.gray.hsv = oe.gray.hsl;
oe.gray.hwb = function(r) {
  return [0, 100, r[0]];
};
oe.gray.cmyk = function(r) {
  return [0, 0, 0, r[0]];
};
oe.gray.lab = function(r) {
  return [r[0], 0, 0];
};
oe.gray.hex = function(r) {
  const e = Math.round(r[0] / 100 * 255) & 255, i = ((e << 16) + (e << 8) + e).toString(16).toUpperCase();
  return "000000".substring(i.length) + i;
};
oe.rgb.gray = function(r) {
  return [(r[0] + r[1] + r[2]) / 3 / 255 * 100];
};
const mn = Su;
function vm() {
  const r = {}, e = Object.keys(mn);
  for (let t = e.length, i = 0; i < t; i++)
    r[e[i]] = {
      distance: -1,
      parent: null
    };
  return r;
}
function mm(r) {
  const e = vm(), t = [r];
  for (e[r].distance = 0; t.length; ) {
    const i = t.pop(), n = Object.keys(mn[i]);
    for (let s = n.length, o = 0; o < s; o++) {
      const l = n[o], a = e[l];
      a.distance === -1 && (a.distance = e[i].distance + 1, a.parent = i, t.unshift(l));
    }
  }
  return e;
}
function gm(r, e) {
  return function(t) {
    return e(r(t));
  };
}
function pm(r, e) {
  const t = [e[r].parent, r];
  let i = mn[e[r].parent][r], n = e[r].parent;
  for (; e[n].parent; )
    t.unshift(e[n].parent), i = gm(mn[e[n].parent][n], i), n = e[n].parent;
  return i.conversion = t, i;
}
var ym = function(r) {
  const e = mm(r), t = {}, i = Object.keys(e);
  for (let n = i.length, s = 0; s < n; s++) {
    const o = i[s];
    e[o].parent !== null && (t[o] = pm(o, e));
  }
  return t;
};
const Is = Su, Em = ym, Lr = {}, _m = Object.keys(Is);
function Tm(r) {
  const e = function(...t) {
    const i = t[0];
    return i == null ? i : (i.length > 1 && (t = i), r(t));
  };
  return "conversion" in r && (e.conversion = r.conversion), e;
}
function Sm(r) {
  const e = function(...t) {
    const i = t[0];
    if (i == null)
      return i;
    i.length > 1 && (t = i);
    const n = r(t);
    if (typeof n == "object")
      for (let s = n.length, o = 0; o < s; o++)
        n[o] = Math.round(n[o]);
    return n;
  };
  return "conversion" in r && (e.conversion = r.conversion), e;
}
_m.forEach((r) => {
  Lr[r] = {}, Object.defineProperty(Lr[r], "channels", { value: Is[r].channels }), Object.defineProperty(Lr[r], "labels", { value: Is[r].labels });
  const e = Em(r);
  Object.keys(e).forEach((i) => {
    const n = e[i];
    Lr[r][i] = Sm(n), Lr[r][i].raw = Tm(n);
  });
});
var xm = Lr;
const wr = gu.exports, dt = xm, xu = [
  "keyword",
  "gray",
  "hex"
], Os = {};
for (const r of Object.keys(dt))
  Os[[...dt[r].labels].sort().join("")] = r;
const gn = {};
function ze(r, e) {
  if (!(this instanceof ze))
    return new ze(r, e);
  if (e && e in xu && (e = null), e && !(e in dt))
    throw new Error("Unknown model: " + e);
  let t, i;
  if (r == null)
    this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (r instanceof ze)
    this.model = r.model, this.color = [...r.color], this.valpha = r.valpha;
  else if (typeof r == "string") {
    const n = wr.get(r);
    if (n === null)
      throw new Error("Unable to parse color from string: " + r);
    this.model = n.model, i = dt[this.model].channels, this.color = n.value.slice(0, i), this.valpha = typeof n.value[i] == "number" ? n.value[i] : 1;
  } else if (r.length > 0) {
    this.model = e || "rgb", i = dt[this.model].channels;
    const n = Array.prototype.slice.call(r, 0, i);
    this.color = Cs(n, i), this.valpha = typeof r[i] == "number" ? r[i] : 1;
  } else if (typeof r == "number")
    this.model = "rgb", this.color = [
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255
    ], this.valpha = 1;
  else {
    this.valpha = 1;
    const n = Object.keys(r);
    "alpha" in r && (n.splice(n.indexOf("alpha"), 1), this.valpha = typeof r.alpha == "number" ? r.alpha : 0);
    const s = n.sort().join("");
    if (!(s in Os))
      throw new Error("Unable to parse color from object: " + JSON.stringify(r));
    this.model = Os[s];
    const { labels: o } = dt[this.model], l = [];
    for (t = 0; t < o.length; t++)
      l.push(r[o[t]]);
    this.color = Cs(l);
  }
  if (gn[this.model])
    for (i = dt[this.model].channels, t = 0; t < i; t++) {
      const n = gn[this.model][t];
      n && (this.color[t] = n(this.color[t]));
    }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
ze.prototype = {
  toString() {
    return this.string();
  },
  toJSON() {
    return this[this.model]();
  },
  string(r) {
    let e = this.model in wr.to ? this : this.rgb();
    e = e.round(typeof r == "number" ? r : 1);
    const t = e.valpha === 1 ? e.color : [...e.color, this.valpha];
    return wr.to[e.model](t);
  },
  percentString(r) {
    const e = this.rgb().round(typeof r == "number" ? r : 1), t = e.valpha === 1 ? e.color : [...e.color, this.valpha];
    return wr.to.rgb.percent(t);
  },
  array() {
    return this.valpha === 1 ? [...this.color] : [...this.color, this.valpha];
  },
  object() {
    const r = {}, { channels: e } = dt[this.model], { labels: t } = dt[this.model];
    for (let i = 0; i < e; i++)
      r[t[i]] = this.color[i];
    return this.valpha !== 1 && (r.alpha = this.valpha), r;
  },
  unitArray() {
    const r = this.rgb().color;
    return r[0] /= 255, r[1] /= 255, r[2] /= 255, this.valpha !== 1 && r.push(this.valpha), r;
  },
  unitObject() {
    const r = this.rgb().object();
    return r.r /= 255, r.g /= 255, r.b /= 255, this.valpha !== 1 && (r.alpha = this.valpha), r;
  },
  round(r) {
    return r = Math.max(r || 0, 0), new ze([...this.color.map(Am(r)), this.valpha], this.model);
  },
  alpha(r) {
    return r !== void 0 ? new ze([...this.color, Math.max(0, Math.min(1, r))], this.model) : this.valpha;
  },
  red: Me("rgb", 0, He(255)),
  green: Me("rgb", 1, He(255)),
  blue: Me("rgb", 2, He(255)),
  hue: Me(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, (r) => (r % 360 + 360) % 360),
  saturationl: Me("hsl", 1, He(100)),
  lightness: Me("hsl", 2, He(100)),
  saturationv: Me("hsv", 1, He(100)),
  value: Me("hsv", 2, He(100)),
  chroma: Me("hcg", 1, He(100)),
  gray: Me("hcg", 2, He(100)),
  white: Me("hwb", 1, He(100)),
  wblack: Me("hwb", 2, He(100)),
  cyan: Me("cmyk", 0, He(100)),
  magenta: Me("cmyk", 1, He(100)),
  yellow: Me("cmyk", 2, He(100)),
  black: Me("cmyk", 3, He(100)),
  x: Me("xyz", 0, He(95.047)),
  y: Me("xyz", 1, He(100)),
  z: Me("xyz", 2, He(108.833)),
  l: Me("lab", 0, He(100)),
  a: Me("lab", 1),
  b: Me("lab", 2),
  keyword(r) {
    return r !== void 0 ? new ze(r) : dt[this.model].keyword(this.color);
  },
  hex(r) {
    return r !== void 0 ? new ze(r) : wr.to.hex(this.rgb().round().color);
  },
  hexa(r) {
    if (r !== void 0)
      return new ze(r);
    const e = this.rgb().round().color;
    let t = Math.round(this.valpha * 255).toString(16).toUpperCase();
    return t.length === 1 && (t = "0" + t), wr.to.hex(e) + t;
  },
  rgbNumber() {
    const r = this.rgb().color;
    return (r[0] & 255) << 16 | (r[1] & 255) << 8 | r[2] & 255;
  },
  luminosity() {
    const r = this.rgb().color, e = [];
    for (const [t, i] of r.entries()) {
      const n = i / 255;
      e[t] = n <= 0.04045 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4;
    }
    return 0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2];
  },
  contrast(r) {
    const e = this.luminosity(), t = r.luminosity();
    return e > t ? (e + 0.05) / (t + 0.05) : (t + 0.05) / (e + 0.05);
  },
  level(r) {
    const e = this.contrast(r);
    return e >= 7 ? "AAA" : e >= 4.5 ? "AA" : "";
  },
  isDark() {
    const r = this.rgb().color;
    return (r[0] * 2126 + r[1] * 7152 + r[2] * 722) / 1e4 < 128;
  },
  isLight() {
    return !this.isDark();
  },
  negate() {
    const r = this.rgb();
    for (let e = 0; e < 3; e++)
      r.color[e] = 255 - r.color[e];
    return r;
  },
  lighten(r) {
    const e = this.hsl();
    return e.color[2] += e.color[2] * r, e;
  },
  darken(r) {
    const e = this.hsl();
    return e.color[2] -= e.color[2] * r, e;
  },
  saturate(r) {
    const e = this.hsl();
    return e.color[1] += e.color[1] * r, e;
  },
  desaturate(r) {
    const e = this.hsl();
    return e.color[1] -= e.color[1] * r, e;
  },
  whiten(r) {
    const e = this.hwb();
    return e.color[1] += e.color[1] * r, e;
  },
  blacken(r) {
    const e = this.hwb();
    return e.color[2] += e.color[2] * r, e;
  },
  grayscale() {
    const r = this.rgb().color, e = r[0] * 0.3 + r[1] * 0.59 + r[2] * 0.11;
    return ze.rgb(e, e, e);
  },
  fade(r) {
    return this.alpha(this.valpha - this.valpha * r);
  },
  opaquer(r) {
    return this.alpha(this.valpha + this.valpha * r);
  },
  rotate(r) {
    const e = this.hsl();
    let t = e.color[0];
    return t = (t + r) % 360, t = t < 0 ? 360 + t : t, e.color[0] = t, e;
  },
  mix(r, e) {
    if (!r || !r.rgb)
      throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof r);
    const t = r.rgb(), i = this.rgb(), n = e === void 0 ? 0.5 : e, s = 2 * n - 1, o = t.alpha() - i.alpha(), l = ((s * o === -1 ? s : (s + o) / (1 + s * o)) + 1) / 2, a = 1 - l;
    return ze.rgb(
      l * t.red() + a * i.red(),
      l * t.green() + a * i.green(),
      l * t.blue() + a * i.blue(),
      t.alpha() * n + i.alpha() * (1 - n)
    );
  }
};
for (const r of Object.keys(dt)) {
  if (xu.includes(r))
    continue;
  const { channels: e } = dt[r];
  ze.prototype[r] = function(...t) {
    return this.model === r ? new ze(this) : t.length > 0 ? new ze(t, r) : new ze([...Lm(dt[this.model][r].raw(this.color)), this.valpha], r);
  }, ze[r] = function(...t) {
    let i = t[0];
    return typeof i == "number" && (i = Cs(t, e)), new ze(i, r);
  };
}
function bm(r, e) {
  return Number(r.toFixed(e));
}
function Am(r) {
  return function(e) {
    return bm(e, r);
  };
}
function Me(r, e, t) {
  r = Array.isArray(r) ? r : [r];
  for (const i of r)
    (gn[i] || (gn[i] = []))[e] = t;
  return r = r[0], function(i) {
    let n;
    return i !== void 0 ? (t && (i = t(i)), n = this[r](), n.color[e] = i, n) : (n = this[r]().color[e], t && (n = t(n)), n);
  };
}
function He(r) {
  return function(e) {
    return Math.max(0, Math.min(r, e));
  };
}
function Lm(r) {
  return Array.isArray(r) ? r : [r];
}
function Cs(r, e) {
  for (let t = 0; t < e; t++)
    typeof r[t] != "number" && (r[t] = 0);
  return r;
}
var wm = ze;
const Dm = wm, Im = (r) => (gr("data-v-519cf9a9"), r = r(), pr(), r), Om = { class: "marker-bubble-group" }, Cm = { class: "marker-bubble-inner" }, Pm = { class: "label" }, Rm = { class: "sub" }, Mm = /* @__PURE__ */ Im(() => /* @__PURE__ */ me("svg", {
  class: "bubble-tail",
  fill: "none",
  height: "26",
  viewBox: "0 0 26 26",
  width: "26",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ me("path", {
    d: "M13 26L25.9904 0.5H0.00961876L13 26Z",
    fill: "#000"
  })
], -1)), km = /* @__PURE__ */ ut({
  __name: "MarkerBubble",
  props: {
    title: {
      type: String,
      default: ""
    },
    time: {
      type: String,
      default: ""
    }
  },
  setup(r) {
    return (e, t) => (fe(), Se("div", Om, [
      me("div", Cm, [
        me("h3", Pm, jt(r.title), 1),
        me("aside", Rm, jt(r.time), 1)
      ]),
      Mm
    ]));
  }
});
const Fm = /* @__PURE__ */ Ue(km, [["__scopeId", "data-v-519cf9a9"]]), bu = (r) => (gr("data-v-fba97bd0"), r = r(), pr(), r), Nm = { class: "timeline-wrapper" }, Bm = /* @__PURE__ */ bu(() => /* @__PURE__ */ me("div", { class: "time-bar-bg time-bar" }, null, -1)), Um = { class: "time-bar-indicator-group" }, Km = /* @__PURE__ */ bu(() => /* @__PURE__ */ me("div", { class: "time-bar-indicator" }, null, -1)), Vm = [
  Km
], Wm = { class: "markers" }, Gm = ["onPointerdown"], Hm = /* @__PURE__ */ ut({
  __name: "Timeline",
  setup(r) {
    const e = it($r), t = it(Ti), i = it(Si), n = ke(), s = ke(0), o = ke(!1), l = we(() => {
      var w, O;
      return (O = (w = e == null ? void 0 : e.value) == null ? void 0 : w.duration) != null ? O : 1;
    }), a = we(() => {
      var w, O;
      return (O = (w = e == null ? void 0 : e.value) == null ? void 0 : w.currentTime) != null ? O : 0;
    }), b = we(() => {
      var w, O;
      return (O = (w = e == null ? void 0 : e.value) == null ? void 0 : w.timeMarkers) != null ? O : [];
    }), y = we(() => {
      var w, O;
      return (O = (w = i == null ? void 0 : i.value) == null ? void 0 : w.playerOptions.userPlayable) != null ? O : !0;
    }), N = we(() => l.value === 0 ? 0 : (o.value ? s.value : a.value) / l.value);
    mi(async () => {
      const w = n.value;
      if (!w)
        throw new Error("Failed to refer timeline element.");
      let O = !0, u = !1, M = 0;
      const d = new Ns(w), c = new tv(50);
      c.subscribe((v) => {
        t == null || t.value().seek(v);
      }), d.onInputStart.add((v) => {
        var m, D;
        if (u || !y.value)
          return;
        u = !0, O = (D = (m = e == null ? void 0 : e.value) == null ? void 0 : m.isPlaying) != null ? D : !1;
        const g = B(v.main.x);
        t == null || t.value().seek(g), t == null || t.value().pause(), s.value = g, o.value = !0, v.originalEvent.preventDefault();
      }), d.onInputMove.add((v) => {
        if (!!y.value && v.isDown) {
          t == null || t.value().pause();
          const g = B(v.main.x);
          s.value = g, c.emit(g);
        }
      }), d.onInputEnd.add((v) => {
        if (!!y.value && (o.value = !1, v.isDown)) {
          const g = B(v.main.x);
          s.value = g, (e == null ? void 0 : e.value.currentTime) !== g && (t == null || t.value().seek(g)), t == null || t.value().tracker.sendEvent("SeekTime"), O ? (t == null || t.value().play(), clearTimeout(M), M = window.setTimeout(() => {
            u = !1;
          }, 100)) : u = !1;
        }
      });
    });
    function E(w, O) {
      const u = w.getBoundingClientRect();
      return We((O - u.x) / u.width, 0, 1);
    }
    function B(w) {
      return E(n.value, w) * l.value;
    }
    function I(w) {
      t == null || t.value().seek(w);
    }
    function T(w) {
      const O = Dm(w);
      return { "--stroke-color": O.lightness(O.lightness() * 0.5).desaturate(0.25).hex(), "--fill-color": w };
    }
    function A(w) {
      return ca.formatShorTimeCode(w || 0);
    }
    return (w, O) => (fe(), Se("section", Nm, [
      me("div", {
        ref_key: "timeline",
        ref: n,
        class: "timeline"
      }, [
        Bm,
        me("div", {
          style: Pt({ transform: `scaleX(${de(N)})` }),
          class: "time-bar-current time-bar"
        }, null, 4),
        me("div", Um, [
          me("div", {
            style: Pt({ transform: `translateX(${de(N) * 100}%)` }),
            class: "time-bar-indicator-position"
          }, Vm, 4)
        ])
      ], 512),
      me("div", Wm, [
        (fe(!0), Se(nn, null, Ps(de(b), (u) => (fe(), Se(nn, null, [
          me("div", {
            style: Pt({ left: `${u.time / de(l) * 100}%`, ...T(u.color || "white") }),
            class: "marker-item",
            onPointerdown: Uu((M) => I(u.time), ["stop"])
          }, [
            De(lm, {
              height: 32,
              width: 32
            })
          ], 44, Gm),
          De(Fm, {
            style: Pt({ left: `${u.time / de(l) * 100}%` }),
            time: A(u.time),
            title: u.label,
            class: "marker-bubble",
            onClick: (M) => I(u.time)
          }, null, 8, ["style", "time", "title", "onClick"])
        ], 64))), 256))
      ])
    ]));
  }
});
const $m = /* @__PURE__ */ Ue(Hm, [["__scopeId", "data-v-fba97bd0"]]), Ki = /* @__PURE__ */ ut({
  __name: "Cluster",
  props: {
    as: {
      type: String,
      default: "div"
    },
    justify: {
      type: String,
      default: "flex-start"
    },
    align: {
      type: String,
      default: "flex-start"
    },
    space: {
      type: String,
      default: ""
    },
    wrap: {
      type: String,
      default: "wrap"
    }
  },
  setup(r) {
    const e = r, t = () => {
      var n, s;
      return bi`
    label: cluster;
    justify-content: ${(n = e.justify) != null ? n : "flex-start"};
    align-items: ${(s = e.align) != null ? s : "center"};

    display: flex;
    flex-wrap: ${e.wrap};
    gap: ${e.space}
  `;
    };
    er(e, () => {
      i.value = { [t()]: !0 };
    }, { deep: !0 });
    const i = ke({
      [t()]: !0
    });
    return (n, s) => (fe(), Fe(yn(r.as), {
      class: Ct(i.value)
    }, {
      default: xe(() => [
        Ur(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), sr = /* @__PURE__ */ ut({
  __name: "SVGIcon",
  props: {
    as: {
      type: String,
      default: "span"
    },
    space: {
      type: String,
      default: "0"
    },
    size: {
      type: String,
      default: "1rem"
    },
    label: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "inherit"
    }
  },
  setup(r) {
    const e = r, t = () => bi`
    label: with-icon;

    display: inline-flex;
    align-items: baseline;

    & > .icon {
      margin-inline-end: ${e.space};
      width: ${e.size};
      height: ${e.size};
      fill: ${e.color};
    }
  `;
    er(e, () => {
      i.value = { [t()]: !0 };
    }, { deep: !0 });
    const i = ke({
      [t()]: !0
    });
    return (n, s) => (fe(), Se("div", {
      class: Ct(i.value)
    }, [
      Ur(n.$slots, "default")
    ], 2));
  }
}), jm = {}, Ym = {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, zm = /* @__PURE__ */ me("path", {
  d: "M27 16L9 26.3923L9 5.60767L27 16Z",
  fill: "inherit"
}, null, -1), Xm = [
  zm
];
function Qm(r, e) {
  return fe(), Se("svg", Ym, Xm);
}
const Zm = /* @__PURE__ */ Ue(jm, [["render", Qm]]), Jm = {}, qm = {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, e0 = /* @__PURE__ */ me("path", {
  d: "M8 5H13V27H8V5Z",
  fill: "inherit"
}, null, -1), t0 = /* @__PURE__ */ me("path", {
  d: "M19 5H24V27H19V5Z",
  fill: "inherit"
}, null, -1), r0 = [
  e0,
  t0
];
function i0(r, e) {
  return fe(), Se("svg", qm, r0);
}
const n0 = /* @__PURE__ */ Ue(Jm, [["render", i0]]), s0 = {}, a0 = {
  viewBox: "0 0 448 512",
  xmlns: "http://www.w3.org/2000/svg"
}, o0 = /* @__PURE__ */ me("path", {
  d: "M128 32H32C14.31 32 0 46.31 0 64v96c0 17.69 14.31 32 32 32s32-14.31 32-32V96h64c17.69 0 32-14.31 32-32S145.7 32 128 32zM416 32h-96c-17.69 0-32 14.31-32 32s14.31 32 32 32h64v64c0 17.69 14.31 32 32 32s32-14.31 32-32V64C448 46.31 433.7 32 416 32zM128 416H64v-64c0-17.69-14.31-32-32-32s-32 14.31-32 32v96c0 17.69 14.31 32 32 32h96c17.69 0 32-14.31 32-32S145.7 416 128 416zM416 320c-17.69 0-32 14.31-32 32v64h-64c-17.69 0-32 14.31-32 32s14.31 32 32 32h96c17.69 0 32-14.31 32-32v-96C448 334.3 433.7 320 416 320z",
  fill: "inherit"
}, null, -1), l0 = [
  o0
];
function u0(r, e) {
  return fe(), Se("svg", a0, l0);
}
const c0 = /* @__PURE__ */ Ue(s0, [["render", u0]]), f0 = {}, h0 = {
  viewBox: "0 0 640 512",
  xmlns: "http://www.w3.org/2000/svg"
}, d0 = /* @__PURE__ */ me("path", {
  d: "M412.6 181.9c-10.28-8.344-25.41-6.875-33.75 3.406c-8.406 10.25-6.906 25.37 3.375 33.78C393.5 228.4 400 241.8 400 256c0 14.19-6.5 27.62-17.81 36.87c-10.28 8.406-11.78 23.53-3.375 33.78c4.719 5.812 11.62 8.812 18.56 8.812c5.344 0 10.75-1.781 15.19-5.406C435.1 311.6 448 284.7 448 256S435.1 200.4 412.6 181.9zM301.2 34.84c-11.5-5.187-25.01-3.116-34.43 5.259L131.8 160H48c-26.51 0-48 21.49-48 47.1v95.1c0 26.51 21.49 47.1 48 47.1h83.84l134.9 119.9C272.7 477.2 280.3 480 288 480c4.438 0 8.959-.9313 13.16-2.837C312.7 472 320 460.6 320 448V64C320 51.41 312.7 39.1 301.2 34.84z",
  fill: "inherit"
}, null, -1), v0 = [
  d0
];
function m0(r, e) {
  return fe(), Se("svg", h0, v0);
}
const g0 = /* @__PURE__ */ Ue(f0, [["render", m0]]), p0 = {}, y0 = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}, E0 = /* @__PURE__ */ me("path", {
  d: "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32z",
  fill: "inherit"
}, null, -1), _0 = [
  E0
];
function T0(r, e) {
  return fe(), Se("svg", y0, _0);
}
const S0 = /* @__PURE__ */ Ue(p0, [["render", T0]]), x0 = {}, b0 = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}, A0 = /* @__PURE__ */ me("path", {
  d: "M215.1 272h-136c-12.94 0-24.63 7.797-29.56 19.75C45.47 303.7 48.22 317.5 57.37 326.6l30.06 30.06l-78.06 78.07c-12.5 12.5-12.5 32.75-.0012 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.26 .0013l78.06-78.07l30.06 30.06c6.125 6.125 14.31 9.367 22.63 9.367c4.125 0 8.279-.7891 12.25-2.43c11.97-4.953 19.75-16.62 19.75-29.56V296C239.1 282.7 229.3 272 215.1 272zM296 240h136c12.94 0 24.63-7.797 29.56-19.75c4.969-11.97 2.219-25.72-6.938-34.87l-30.06-30.06l78.06-78.07c12.5-12.5 12.5-32.76 .0002-45.26l-22.62-22.62c-12.5-12.5-32.76-12.5-45.26-.0003l-78.06 78.07l-30.06-30.06c-9.156-9.141-22.87-11.84-34.87-6.937c-11.97 4.953-19.75 16.62-19.75 29.56v135.1C272 229.3 282.7 240 296 240z",
  fill: "inherit"
}, null, -1), L0 = [
  A0
];
function w0(r, e) {
  return fe(), Se("svg", b0, L0);
}
const D0 = /* @__PURE__ */ Ue(x0, [["render", w0]]), I0 = {}, O0 = {
  viewBox: "0 0 640 512",
  xmlns: "http://www.w3.org/2000/svg"
}, C0 = /* @__PURE__ */ me("path", {
  d: "M301.2 34.85c-11.5-5.188-25.02-3.122-34.44 5.253L131.8 160H48c-26.51 0-48 21.49-48 47.1v95.1c0 26.51 21.49 47.1 48 47.1h83.84l134.9 119.9c5.984 5.312 13.58 8.094 21.26 8.094c4.438 0 8.972-.9375 13.17-2.844c11.5-5.156 18.82-16.56 18.82-29.16V64C319.1 51.41 312.7 40 301.2 34.85zM513.9 255.1l47.03-47.03c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L480 222.1L432.1 175c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l47.03 47.03l-47.03 47.03c-9.375 9.375-9.375 24.56 0 33.94c9.373 9.373 24.56 9.381 33.94 0L480 289.9l47.03 47.03c9.373 9.373 24.56 9.381 33.94 0c9.375-9.375 9.375-24.56 0-33.94L513.9 255.1z",
  fill: "inherit"
}, null, -1), P0 = [
  C0
];
function R0(r, e) {
  return fe(), Se("svg", O0, P0);
}
const M0 = /* @__PURE__ */ Ue(I0, [["render", R0]]), k0 = {}, F0 = {
  viewBox: "0 0 640 512",
  xmlns: "http://www.w3.org/2000/svg"
}, N0 = /* @__PURE__ */ me("path", {
  d: "M412.6 182c-10.28-8.334-25.41-6.867-33.75 3.402c-8.406 10.24-6.906 25.35 3.375 33.74C393.5 228.4 400 241.8 400 255.1c0 14.17-6.5 27.59-17.81 36.83c-10.28 8.396-11.78 23.5-3.375 33.74c4.719 5.806 11.62 8.802 18.56 8.802c5.344 0 10.75-1.779 15.19-5.399C435.1 311.5 448 284.6 448 255.1S435.1 200.4 412.6 182zM473.1 108.2c-10.22-8.334-25.34-6.898-33.78 3.34c-8.406 10.24-6.906 25.35 3.344 33.74C476.6 172.1 496 213.3 496 255.1s-19.44 82.1-53.31 110.7c-10.25 8.396-11.75 23.5-3.344 33.74c4.75 5.775 11.62 8.771 18.56 8.771c5.375 0 10.75-1.779 15.22-5.431C518.2 366.9 544 313 544 255.1S518.2 145 473.1 108.2zM534.4 33.4c-10.22-8.334-25.34-6.867-33.78 3.34c-8.406 10.24-6.906 25.35 3.344 33.74C559.9 116.3 592 183.9 592 255.1s-32.09 139.7-88.06 185.5c-10.25 8.396-11.75 23.5-3.344 33.74C505.3 481 512.2 484 519.2 484c5.375 0 10.75-1.779 15.22-5.431C601.5 423.6 640 342.5 640 255.1S601.5 88.34 534.4 33.4zM301.2 34.98c-11.5-5.181-25.01-3.076-34.43 5.29L131.8 160.1H48c-26.51 0-48 21.48-48 47.96v95.92c0 26.48 21.49 47.96 48 47.96h83.84l134.9 119.8C272.7 477 280.3 479.8 288 479.8c4.438 0 8.959-.9314 13.16-2.835C312.7 471.8 320 460.4 320 447.9V64.12C320 51.55 312.7 40.13 301.2 34.98z",
  fill: "inherit"
}, null, -1), B0 = [
  N0
];
function U0(r, e) {
  return fe(), Se("svg", F0, B0);
}
const K0 = /* @__PURE__ */ Ue(k0, [["render", U0]]), Au = (r) => (gr("data-v-70c87081"), r = r(), pr(), r), V0 = /* @__PURE__ */ Au(() => /* @__PURE__ */ me("div", { class: "bar-bg" }, null, -1)), W0 = /* @__PURE__ */ Au(() => /* @__PURE__ */ me("div", { class: "bar-indicator" }, null, -1)), G0 = [
  W0
], H0 = /* @__PURE__ */ ut({
  __name: "MicroSlider",
  props: {
    modelValue: {
      type: Number,
      default: ""
    },
    max: {
      type: String,
      default: "10rem"
    }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: e }) {
    const t = r, i = () => bi`
    ${t.max ? `max-width: ${t.max}` : ""};
    ${t.max ? `width: ${t.max}` : ""};
  `;
    er(t, () => {
      n.value = { [i()]: !0 };
    }, { deep: !0 });
    const n = ke({
      [i()]: !0
    }), s = ke();
    mi(() => {
      if (!s.value)
        return;
      const a = new Ns(s.value);
      a.onInputStart.add((b) => {
        const y = o(s.value, b.main.x);
        e("update:modelValue", y);
      }), a.onInputMove.add((b) => {
        if (b.isDown) {
          const y = o(s.value, b.main.x);
          e("update:modelValue", y);
        }
      }), a.onInputEnd.add((b) => {
        if (b.isDown) {
          const y = o(s.value, b.main.x);
          e("update:modelValue", y);
        }
      });
    });
    function o(a, b) {
      const y = a.getBoundingClientRect();
      return l((b - y.x) / y.width, 0, 1);
    }
    function l(a, b, y) {
      return a < b ? b : a > y ? y : a;
    }
    return (a, b) => (fe(), Se("div", {
      ref_key: "slider",
      ref: s,
      class: Ct([n.value, "slider"])
    }, [
      V0,
      me("div", {
        style: Pt({ transform: `scaleX(${r.modelValue})` }),
        class: "bar bar-current"
      }, null, 4),
      me("div", {
        style: Pt({ transform: `translateX(${r.modelValue * (100 - 5.5) - 5.5}px)` }),
        class: "bar-indicator-wrapper"
      }, G0, 4)
    ], 2));
  }
});
const $0 = /* @__PURE__ */ Ue(H0, [["__scopeId", "data-v-70c87081"]]);
const j0 = {}, Y0 = { class: "side-menu-wrapper" };
function z0(r, e) {
  return fe(), Se("div", Y0, [
    Ur(r.$slots, "default", {}, void 0, !0)
  ]);
}
const Lu = /* @__PURE__ */ Ue(j0, [["render", z0], ["__scopeId", "data-v-95b2a76c"]]), X0 = /* @__PURE__ */ ut({
  __name: "MenuListSelectItem",
  props: {
    isSelected: {
      type: Boolean,
      default: !1
    }
  },
  setup(r) {
    return (e, t) => (fe(), Se("div", {
      class: Ct([{ "is-selected": r.isSelected }, "menu-list-item"])
    }, [
      Ur(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
});
const wu = /* @__PURE__ */ Ue(X0, [["__scopeId", "data-v-16f676f0"]]), Q0 = /* @__PURE__ */ ut({
  __name: "InteractionArea",
  props: {
    as: {
      type: String,
      default: "div"
    },
    centered: {
      type: Boolean,
      default: !1
    },
    max: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(r, { emit: e }) {
    const t = r, i = ke(), n = ke(!1), s = ke(!1), o = () => bi`
    ${t.centered ? `
      display: flex;
      align-items: center;
      justify-items: center;
    ` : ""}
    ${t.max ? `
      width: max-content;
      height: max-content;
    ` : ""}
  `;
    er(t, () => {
      l.value = { [o()]: !0, "is-active": n.value };
    }, { deep: !0 });
    const l = ke({
      [o()]: !0,
      "is-active": n.value
    });
    mi(() => {
      const N = i.value;
      if (!N)
        throw new Error("Element is not defined");
      N.addEventListener("pointerdown", a), N.addEventListener("pointerup", b), N.addEventListener("pointermove", y);
    });
    function a() {
      s.value = !0, n.value = !0;
    }
    function b(N) {
      s.value && e("click", N), s.value = !1, n.value = !1;
    }
    function y() {
      s.value = !1, n.value = !1;
    }
    return (N, E) => (fe(), Fe(yn(r.as), {
      ref_key: "el",
      ref: i,
      class: Ct([l.value, "interaction-area"])
    }, {
      default: xe(() => [
        Ur(N.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
const or = /* @__PURE__ */ Ue(Q0, [["__scopeId", "data-v-ff495d6d"]]), Z0 = /* @__PURE__ */ ut({
  __name: "TransformMenu",
  setup(r) {
    const e = it(Ti), t = it($r), i = it(Si), n = we(() => {
      var o;
      return (o = t == null ? void 0 : t.value.currentTransformId) != null ? o : -1;
    });
    function s(o) {
      e == null || e.value().changeTransformSet(o), e == null || e.value().tracker.sendEvent("ChangeTransformSet");
    }
    return (o, l) => (fe(), Fe(Lu, null, {
      default: xe(() => {
        var a, b;
        return [
          de(i) ? (fe(!0), Se(nn, { key: 0 }, Ps((b = (a = de(i)) == null ? void 0 : a.transforms) != null ? b : [], (y, N) => (fe(), Se("ul", null, [
            De(or, {
              as: "li",
              onClick: (E) => s(N)
            }, {
              default: xe(() => [
                De(wu, {
                  "is-selected": N === de(n)
                }, {
                  default: xe(() => [
                    No(jt(y.name), 1)
                  ]),
                  _: 2
                }, 1032, ["is-selected"])
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))), 256)) : _t("", !0)
        ];
      }),
      _: 1
    }));
  }
}), J0 = /* @__PURE__ */ ut({
  __name: "GroupMenu",
  setup(r) {
    const e = it(Ti), t = it($r), i = it(Si), n = we(() => {
      var o;
      return (o = t == null ? void 0 : t.value.currentGroupId) != null ? o : -1;
    });
    function s(o) {
      e == null || e.value().changeGroup(o), e == null || e.value().tracker.sendEvent("ChangeGroup");
    }
    return (o, l) => (fe(), Fe(Lu, null, {
      default: xe(() => {
        var a;
        return [
          de(i) ? (fe(!0), Se(nn, { key: 0 }, Ps(((a = de(i)) == null ? void 0 : a.groups) || [], (b, y) => (fe(), Se("ul", null, [
            De(or, {
              as: "li",
              onClick: (N) => s(y)
            }, {
              default: xe(() => [
                De(wu, {
                  "is-selected": y === de(n)
                }, {
                  default: xe(() => [
                    No(jt(b.name), 1)
                  ]),
                  _: 2
                }, 1032, ["is-selected"])
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]))), 256)) : _t("", !0)
        ];
      }),
      _: 1
    }));
  }
}), q0 = {}, eg = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}, tg = /* @__PURE__ */ me("path", {
  d: "M224 0c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224zM64 160c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64H64V224h64V160H64z",
  fill: "inherit"
}, null, -1), rg = [
  tg
];
function ig(r, e) {
  return fe(), Se("svg", eg, rg);
}
const ng = /* @__PURE__ */ Ue(q0, [["render", ig]]), Xr = () => Boolean(
  document.fullscreenElement || document.webkitFullscreenElement || document.webkitCurrentFullScreenElement
);
function sg(r) {
  const e = () => {
    i.emit(Xr());
  }, t = (n) => {
    console.error("Fullscreen error captured:", n);
  }, i = new ge();
  return r.addEventListener("fullscreenchange", e), r.addEventListener("fullscreenerror", t), r.addEventListener("webkitfullscreenchange", e), r.addEventListener("webkitfullscreenerror", t), {
    toggle() {
      Xr() ? this.exit() : this.request();
    },
    request() {
      var s;
      if (Xr())
        return;
      ((s = r.requestFullscreen) != null ? s : r.webkitRequestFullscreen).call(r);
    },
    exit() {
      var s;
      if (!Xr())
        return;
      const n = (s = document.exitFullscreen) != null ? s : document.webkitExitFullscreen;
      n && n.call(document);
    },
    dispose() {
      r.removeEventListener("fullscreenchange", e), r.removeEventListener("fullscreenerror", t), r.removeEventListener("webkitfullscreenchange", e), r.removeEventListener("webkitfullscreenerror", t);
    },
    get isFullscreen() {
      return Xr();
    },
    onChange: i
  };
}
function ag() {
  return document.fullscreenEnabled || document.webkitFullscreenEnabled;
}
const og = (r) => (gr("data-v-28c9faa3"), r = r(), pr(), r), lg = /* @__PURE__ */ og(() => /* @__PURE__ */ me("div", { class: "total-time" }, "/", -1)), ug = { class: "total-time" }, cg = /* @__PURE__ */ ut({
  __name: "PlayerControls",
  setup(r) {
    const e = it($r), t = it(Ti), i = it(Si), n = it(ru), s = it(nu), o = it(iu), l = ke(!1), a = ke(1), b = {};
    mi(() => {
      var d;
      a.value = (d = e == null ? void 0 : e.value.volume) != null ? d : 0;
    });
    const y = we(() => (o == null ? void 0 : o.value.device.type) === "mobile" || (o == null ? void 0 : o.value.device.type) === "tablet"), N = we(() => ag()), E = we(() => {
      var d, c;
      return ((c = (d = i == null ? void 0 : i.value) == null ? void 0 : d.transforms.length) != null ? c : 0) > 1;
    }), B = we(() => {
      var d, c;
      return ((c = (d = i == null ? void 0 : i.value) == null ? void 0 : d.groups.length) != null ? c : 0) > 1;
    }), I = we(() => {
      var d, c;
      return (c = (d = i == null ? void 0 : i.value) == null ? void 0 : d.playerOptions.userPlayable) != null ? c : !0;
    });
    er(a, () => {
      t != null && t.value && t.value().setVolume(a.value);
    }), Ku((d) => {
      var c;
      (c = n == null ? void 0 : n.value) == null || c.onChange.add(b, () => {
        var v, g;
        l.value = (g = (v = n == null ? void 0 : n.value) == null ? void 0 : v.isFullscreen) != null ? g : !1;
      }), d(() => {
        var v;
        (v = n == null ? void 0 : n.value) == null || v.onChange.remove(this);
      });
    });
    function T(d) {
      return ca.formatShorTimeCode(d || 0);
    }
    function A() {
      t == null || t.value().playOrPause();
    }
    function w() {
      var d;
      (d = n == null ? void 0 : n.value) == null || d.toggle();
    }
    function O() {
      const d = !(e != null && e.value.isMuted);
      t == null || t.value().setMuted(!(e != null && e.value.isMuted)), t == null || t.value().tracker.sendEvent(d ? "Mute" : "UnMute");
    }
    function u() {
      s == null || s.value.toggle(Z0);
    }
    function M() {
      s == null || s.value.toggle(J0);
    }
    return (d, c) => (fe(), Fe(Ki, {
      align: "center",
      class: "navigations",
      justify: "space-between"
    }, {
      default: xe(() => [
        De(Ki, {
          align: "center",
          class: "left-nav",
          justify: "center",
          space: "1em"
        }, {
          default: xe(() => [
            de(I) ? (fe(), Fe(or, {
              key: 0,
              as: "div",
              centered: "",
              onClick: A
            }, {
              default: xe(() => {
                var v;
                return [
                  (v = de(e)) != null && v.isPlaying ? (fe(), Fe(sr, {
                    key: 1,
                    class: "clickable",
                    size: "max(1.5em, 1.5rem)"
                  }, {
                    default: xe(() => [
                      De(n0, { class: "icon" })
                    ]),
                    _: 1
                  })) : (fe(), Fe(sr, {
                    key: 0,
                    class: "clickable",
                    size: "max(1.5em, 1.5rem)"
                  }, {
                    default: xe(() => [
                      De(Zm, { class: "icon" })
                    ]),
                    _: 1
                  }))
                ];
              }),
              _: 1
            })) : _t("", !0),
            De(Ki, {
              class: "time",
              space: "0.55em"
            }, {
              default: xe(() => {
                var v, g;
                return [
                  me("time", null, jt(T((v = de(e)) == null ? void 0 : v.currentTime)), 1),
                  lg,
                  me("time", ug, jt(T((g = de(e)) == null ? void 0 : g.duration)), 1)
                ];
              }),
              _: 1
            })
          ]),
          _: 1
        }),
        De(Ki, {
          align: "center",
          class: "right-nav",
          space: "1em"
        }, {
          default: xe(() => [
            de(y) ? _t("", !0) : (fe(), Fe($0, {
              key: 0,
              modelValue: a.value,
              "onUpdate:modelValue": c[0] || (c[0] = (v) => a.value = v),
              max: "6em"
            }, null, 8, ["modelValue"])),
            De(or, {
              as: "div",
              centered: "",
              onClick: O
            }, {
              default: xe(() => [
                De(sr, {
                  class: "clickable",
                  size: "max(1.5em, 1.5rem)"
                }, {
                  default: xe(() => {
                    var v, g, m, D;
                    return [
                      ((v = de(e)) == null ? void 0 : v.isMuted) || ((g = de(e)) == null ? void 0 : g.volume) === 0 ? (fe(), Fe(M0, {
                        key: 0,
                        class: "icon"
                      })) : ((D = (m = de(e)) == null ? void 0 : m.volume) != null ? D : 0) < 0.75 ? (fe(), Fe(g0, {
                        key: 1,
                        class: "icon"
                      })) : (fe(), Fe(K0, {
                        key: 2,
                        class: "icon"
                      }))
                    ];
                  }),
                  _: 1
                })
              ]),
              _: 1
            }),
            de(E) ? (fe(), Fe(or, {
              key: 1,
              as: "span",
              centered: "",
              "data-menu": "",
              onClick: u
            }, {
              default: xe(() => [
                De(sr, {
                  class: "clickable",
                  size: "max(1.25em, 1.25rem)"
                }, {
                  default: xe(() => [
                    De(S0, { class: "icon" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : _t("", !0),
            de(B) ? (fe(), Fe(or, {
              key: 2,
              as: "span",
              centered: "",
              "data-menu": "",
              onClick: M
            }, {
              default: xe(() => [
                De(sr, {
                  class: "clickable",
                  size: "max(1.25em, 1.25rem)"
                }, {
                  default: xe(() => [
                    De(ng, { class: "icon" })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : _t("", !0),
            de(N) ? (fe(), Fe(or, {
              key: 3,
              as: "span",
              centered: "",
              onClick: w
            }, {
              default: xe(() => [
                De(sr, {
                  class: "clickable",
                  size: "max(1.25em, 1.25rem)"
                }, {
                  default: xe(() => [
                    l.value ? (fe(), Fe(D0, {
                      key: 1,
                      class: "icon"
                    })) : (fe(), Fe(c0, {
                      key: 0,
                      class: "icon"
                    }))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })) : _t("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
});
const fg = /* @__PURE__ */ Ue(cg, [["__scopeId", "data-v-28c9faa3"]]), hg = (r) => (gr("data-v-89af4ba3"), r = r(), pr(), r), dg = { class: "navigation" }, vg = /* @__PURE__ */ hg(() => /* @__PURE__ */ me("div", { class: "gradient" }, null, -1)), mg = /* @__PURE__ */ ut({
  __name: "Navigation",
  setup(r) {
    return (e, t) => (fe(), Se("nav", dg, [
      vg,
      De(ko, {
        "full-size": "",
        padding: "0 1em"
      }, {
        default: xe(() => [
          De($m)
        ]),
        _: 1
      }),
      De(ko, { padding: "0.15em 1em 0.5em 1em" }, {
        default: xe(() => [
          De(fg)
        ]),
        _: 1
      })
    ]));
  }
});
const gg = /* @__PURE__ */ Ue(mg, [["__scopeId", "data-v-89af4ba3"]]), pg = /* @__PURE__ */ ut({
  __name: "ClosedCaption",
  setup(r) {
    const e = it($r), t = we(() => {
      var s, o;
      return (o = (s = e == null ? void 0 : e.value) == null ? void 0 : s.caption) != null ? o : "";
    }), i = we(() => {
      var s, o, l, a, b, y, N, E, B, I, T, A, w, O, u, M, d, c;
      return {
        "font-size": (o = (s = e == null ? void 0 : e.value) == null ? void 0 : s.captionSize) != null ? o : "1em",
        opacity: (a = (l = e == null ? void 0 : e.value) == null ? void 0 : l.captionOpacity) != null ? a : 1,
        "background-color": (y = (b = e == null ? void 0 : e.value) == null ? void 0 : b.captionBgColor) != null ? y : "transparent",
        color: (E = (N = e == null ? void 0 : e.value) == null ? void 0 : N.captionColor) != null ? E : "white",
        "text-align": (I = (B = e == null ? void 0 : e.value) == null ? void 0 : B.captionTextAlign) != null ? I : "center",
        "writing-mode": (A = (T = e == null ? void 0 : e.value) == null ? void 0 : T.captionWritingMode) != null ? A : "horizontal-tb",
        "inline-size": (O = (w = e == null ? void 0 : e.value) == null ? void 0 : w.captionInlineSize) != null ? O : "auto",
        top: (M = (u = e == null ? void 0 : e.value) == null ? void 0 : u.captionOffsetY) != null ? M : "0",
        left: (c = (d = e == null ? void 0 : e.value) == null ? void 0 : d.captionOffsetX) != null ? c : "0"
      };
    }), n = we(() => {
      var s, o, l, a;
      return {
        "align-items": (o = (s = e == null ? void 0 : e.value) == null ? void 0 : s.captionAlign) != null ? o : "center",
        "justify-content": (a = (l = e == null ? void 0 : e.value) == null ? void 0 : l.captionJustify) != null ? a : "center"
      };
    });
    return (s, o) => (fe(), Se("div", {
      style: Pt(de(n)),
      class: "closed-caption"
    }, [
      de(t) ? (fe(), Se("div", {
        key: 0,
        style: Pt(de(i)),
        class: "text"
      }, jt(de(t)), 5)) : _t("", !0)
    ], 4));
  }
});
const yg = /* @__PURE__ */ Ue(pg, [["__scopeId", "data-v-4d730834"]]), Eg = (r) => (gr("data-v-c2307535"), r = r(), pr(), r), _g = /* @__PURE__ */ Eg(() => /* @__PURE__ */ me("svg", {
  class: "icon",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ me("path", { d: "M27 16L9 26.3923L9 5.60767L27 16Z" })
], -1)), Tg = { class: "header" }, Sg = { class: "title" }, xg = /* @__PURE__ */ ut({
  __name: "BulletLightPlayerComponent",
  props: {
    url: {
      type: String,
      default: ""
    },
    json: {
      type: Object,
      default: null
    },
    autoLoad: {
      type: Boolean,
      default: !0
    },
    autoStart: {
      type: Boolean,
      default: !1
    },
    controls: {
      type: Boolean,
      default: !0
    },
    posterOnly: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["playerCreated", "contentLoaded", "onStart", "onCameraChanged"],
  setup(r, { emit: e }) {
    const t = r, i = new Zo("user-agent").setUA(window.navigator.userAgent).getResult(), n = ke(null), s = ke(), o = ke(!1), l = we(() => {
      var F, R;
      return (R = (F = B.value) == null ? void 0 : F.isStarted) != null ? R : !1;
    }), a = we(() => o.value && B.value && B.value.isLoading), b = we(() => ca.formatFrameTimeCode(B.value.currentTime, !1)), y = we(() => {
      var F, R;
      return Array.isArray((F = n.value) == null ? void 0 : F.modes) ? (R = n.value) == null ? void 0 : R.modes.includes("MultiSelect") : !1;
    }), N = we(() => {
      var F;
      return (F = n.value) == null ? void 0 : F.poster;
    }), E = we(() => n.value), B = ke(Es());
    let I = null;
    const T = ke(), A = ke(null), w = ke(), O = Vu(null), u = ke({
      toggle: (F) => {
        O.value = O.value === F ? null : F;
      },
      close: () => {
        O.value = null;
      }
    });
    _r($r, B), _r(Ti, we(() => () => I)), _r(Si, we(() => n.value)), _r(ru, we(() => A.value)), _r(nu, u), _r(iu, we(() => i));
    const M = we(() => {
      var F, R;
      return (R = (F = n.value) == null ? void 0 : F.title) != null ? R : "";
    }), d = we(() => {
      var F;
      return (F = n.value) == null ? void 0 : F.playerOptions;
    }), c = ti.createRegion();
    let v = null;
    er(() => t.url, (F) => {
      F ? m(F) : I == null || I.clear();
    }), er(() => t.json, (F) => {
      F ? D(F) : I == null || I.clear();
    });
    function g() {
      I == null || I.clear(), n.value = null, o.value = !1;
    }
    async function m(F) {
      g();
      const R = await L(F);
      if (C(R))
        n.value = R;
      else
        return;
      t.autoLoad && (await p(), t.autoStart && await x());
    }
    async function D(F) {
      if (g(), C(F))
        n.value = F;
      else
        return;
      t.autoLoad && (await p(), t.autoStart && await x());
    }
    mi(async () => {
      var K;
      const F = s.value, R = T.value;
      if (!F || !R)
        throw new Error("Failed to initialize app");
      _(), I = new Mf(F), I.exposedStates = B.value, window.addEventListener("resize", k), window.addEventListener("pointerdown", S), T.value && (A.value = sg(T.value)), c.onKeyDown.add((V) => {
        I == null || I.keydown(V);
      }), e("playerCreated", I), t.url ? await m(t.url) : t.json && await D(t.json);
      const U = Wu();
      (K = U == null ? void 0 : U.proxy) == null || K.$forceUpdate(), v = new ResizeObserver(() => {
        k();
      }), v.observe(R);
    }), Gu(() => {
      var F;
      I == null || I.dispose(), window.addEventListener("resize", k), window.removeEventListener("pointerdown", S), (F = A.value) == null || F.dispose(), ti.disposeRegion(c), v == null || v.disconnect();
    });
    async function L(F) {
      const R = await qd.loadContent(F);
      return e("contentLoaded", R), R;
    }
    async function p() {
      if (!n.value) {
        console.warn("load() cannot be called: content is not loaded");
        return;
      }
      o.value = !0, I == null || I.loadContent(n.value);
    }
    async function x() {
      var F;
      if (!(!E.value || !I || l.value)) {
        for (o.value || await p(); await ev(1), !!(I != null && I.isLoading); )
          ;
        I == null || I.play(), I == null || I.seek(0), (F = n.value) != null && F.playerOptions.userPlayable || I == null || I.pause(), I.tracker.sendEvent("PlayerStart");
      }
    }
    function k() {
      !I || (_(), I == null || I.updateViewSize());
    }
    function _() {
      const F = s.value, R = T.value;
      if (F && R) {
        const U = R.getBoundingClientRect();
        F.width = U.width * 2, F.height = U.height * 2, F.style.width = "100%", F.style.height = "100%";
      }
    }
    function S(F) {
      var U, K;
      if (!w.value)
        return;
      let R = (U = F.target) != null ? U : null;
      for (; R; ) {
        if (R === w.value || R.hasAttribute("data-menu"))
          return;
        R = (K = R == null ? void 0 : R.parentElement) != null ? K : null;
      }
      O.value = null;
    }
    function h() {
      c.enable();
    }
    function C(F) {
      if (F != null && F.domainFilter) {
        const K = [
          "web.dev.pixyeye.com",
          "web.staging.pixyeye.com",
          "web.pixyeye.com",
          "localhost:8080"
        ].concat(
          F.domainFilter.domainWhiteList
        ).includes(f());
        return K || console.warn("blocked by domain filter"), K;
      } else
        return !0;
    }
    function f() {
      return P() ? new URL(document.referrer).host : window.location.host;
    }
    function P() {
      return window.location !== window.parent.location;
    }
    return (F, R) => {
      var U, K;
      return fe(), Se("div", {
        ref_key: "playerElement",
        ref: T,
        class: Ct([{ "is-not-playable": !de(l) && !de(E) }, "player"]),
        onPointerdown: h
      }, [
        me("section", {
          class: Ct([{ "is-short-size": de(y) }, "drawer"])
        }, [
          me("canvas", {
            ref_key: "canvas",
            ref: s,
            class: "gl-view"
          }, null, 512)
        ], 2),
        r.controls ? (fe(), Se("section", {
          key: 0,
          class: Ct([{ pinned: !((U = B.value) != null && U.isPlaying) }, "controls"])
        }, [
          De(gg)
        ], 2)) : _t("", !0),
        me("section", {
          class: Ct([{ "is-started": de(l), "is-loading": de(a) }, "overlays"]),
          onClick: x
        }, [
          Di(me("div", {
            style: Pt({ backgroundImage: de(N) ? `url(${de(N)})` : void 0 }),
            class: "poster"
          }, null, 4), [
            [Ii, !de(l)]
          ]),
          Di(De(sr, {
            as: "div",
            class: "start-icon",
            size: "4em"
          }, {
            default: xe(() => [
              _g
            ]),
            _: 1
          }, 512), [
            [Ii, de(E) && !de(l) && !r.posterOnly]
          ]),
          Di(me("header", Tg, [
            me("h2", Sg, jt(de(M)), 1)
          ], 512), [
            [Ii, !de(l) && !r.posterOnly]
          ]),
          De(La, { name: "fade" }, {
            default: xe(() => [
              de(l) && de(a) ? (fe(), Fe(av, {
                key: 0,
                size: "2em",
                class: "loading"
              })) : _t("", !0)
            ]),
            _: 1
          }),
          De(La, { name: "fade" }, {
            default: xe(() => {
              var V;
              return [
                Di(me("div", { class: "time-code" }, jt(de(b)), 513), [
                  [Ii, B.value.isFrameControl || !!((V = de(d)) != null && V.alwaysDisplayTimeCode)]
                ])
              ];
            }),
            _: 1
          }),
          de(l) ? (fe(), Fe(yg, {
            key: 0,
            class: Ct([{ pinned: !((K = B.value) != null && K.isPlaying) }, "closed-caption"])
          }, null, 8, ["class"])) : _t("", !0),
          de(O) ? (fe(), Se("div", {
            key: 1,
            ref_key: "sideMenu",
            ref: w,
            class: "side-menu"
          }, [
            (fe(), Fe(yn(de(O))))
          ], 512)) : _t("", !0)
        ], 2)
      ], 34);
    };
  }
});
const wg = /* @__PURE__ */ Ue(xg, [["__scopeId", "data-v-c2307535"]]);
export {
  wg as BulletLightPlayerComponent
};
